// === GENERATED BY scripts/generate_template.py — DO NOT EDIT MANUALLY ===
// Template: Django SaaS Platform
// Total files: 95

import type { FileTreeNode } from '../types/wizard';

export const djangoSaasDemoFileTree: FileTreeNode[] = [
    {
      name: '.claude',
      path: '.claude',
      type: 'directory',
      children: [
        {
          name: 'rules',
          path: '.claude/rules',
          type: 'directory',
          children: [
            {
              name: 'common',
              path: '.claude/rules/common',
              type: 'directory',
              children: [
                { name: 'coding-style.md', path: '.claude/rules/common/coding-style.md', type: 'file' },
                { name: 'git-workflow.md', path: '.claude/rules/common/git-workflow.md', type: 'file' },
                { name: 'security.md', path: '.claude/rules/common/security.md', type: 'file' },
                { name: 'testing.md', path: '.claude/rules/common/testing.md', type: 'file' },
              ],
            },
            {
              name: 'python',
              path: '.claude/rules/python',
              type: 'directory',
              children: [
                { name: 'coding-style.md', path: '.claude/rules/python/coding-style.md', type: 'file' },
                { name: 'testing.md', path: '.claude/rules/python/testing.md', type: 'file' },
              ],
            },
          ],
        },
        { name: 'settings.json', path: '.claude/settings.json', type: 'file' },
      ],
    },
    { name: '.editorconfig', path: '.editorconfig', type: 'file' },
    { name: '.gitattributes', path: '.gitattributes', type: 'file' },
    {
      name: '.github',
      path: '.github',
      type: 'directory',
      children: [
        { name: 'CODEOWNERS', path: '.github/CODEOWNERS', type: 'file' },
        {
          name: 'ISSUE_TEMPLATE',
          path: '.github/ISSUE_TEMPLATE',
          type: 'directory',
          children: [
            { name: 'ai_task.md', path: '.github/ISSUE_TEMPLATE/ai_task.md', type: 'file' },
            { name: 'bug_report.md', path: '.github/ISSUE_TEMPLATE/bug_report.md', type: 'file' },
            { name: 'feature_request.md', path: '.github/ISSUE_TEMPLATE/feature_request.md', type: 'file' },
          ],
        },
        { name: 'PULL_REQUEST_TEMPLATE.md', path: '.github/PULL_REQUEST_TEMPLATE.md', type: 'file' },
        {
          name: 'workflows',
          path: '.github/workflows',
          type: 'directory',
          children: [
            { name: 'ai-code-audit.yml', path: '.github/workflows/ai-code-audit.yml', type: 'file' },
            { name: 'ci.yml', path: '.github/workflows/ci.yml', type: 'file' },
            { name: 'deploy-production.yml', path: '.github/workflows/deploy-production.yml', type: 'file' },
            { name: 'deploy-staging.yml', path: '.github/workflows/deploy-staging.yml', type: 'file' },
          ],
        },
      ],
    },
    { name: '.gitignore', path: '.gitignore', type: 'file' },
    { name: '.mcp.json', path: '.mcp.json', type: 'file' },
    { name: 'CLAUDE.md', path: 'CLAUDE.md', type: 'file' },
    { name: 'README.md', path: 'README.md', type: 'file' },
    {
      name: 'docs',
      path: 'docs',
      type: 'directory',
      children: [
        { name: 'AI-USAGE-POLICY.md', path: 'docs/AI-USAGE-POLICY.md', type: 'file' },
        { name: 'ARCHITECTURE.md', path: 'docs/ARCHITECTURE.md', type: 'file' },
        { name: 'CONTRIBUTING.md', path: 'docs/CONTRIBUTING.md', type: 'file' },
        { name: 'ONBOARDING.md', path: 'docs/ONBOARDING.md', type: 'file' },
      ],
    },
    {
      name: 'git-hooks',
      path: 'git-hooks',
      type: 'directory',
      children: [
        { name: 'commit-msg', path: 'git-hooks/commit-msg', type: 'file' },
        { name: 'pre-commit', path: 'git-hooks/pre-commit', type: 'file' },
        { name: 'pre-push', path: 'git-hooks/pre-push', type: 'file' },
      ],
    },
    { name: 'install.sh', path: 'install.sh', type: 'file' },
    {
      name: 'mock-mcp-servers',
      path: 'mock-mcp-servers',
      type: 'directory',
      children: [
        { name: 'README.md', path: 'mock-mcp-servers/README.md', type: 'file' },
        { name: 'github-server.mjs', path: 'mock-mcp-servers/github-server.mjs', type: 'file' },
        { name: 'jira-server.mjs', path: 'mock-mcp-servers/jira-server.mjs', type: 'file' },
        { name: 'package.json', path: 'mock-mcp-servers/package.json', type: 'file' },
      ],
    },
    {
      name: 'playbook',
      path: 'playbook',
      type: 'directory',
      children: [
        { name: 'PLAYBOOK.md', path: 'playbook/PLAYBOOK.md', type: 'file' },
        {
          name: 'claude-overrides',
          path: 'playbook/claude-overrides',
          type: 'directory',
          children: [
            { name: '01-discovery.claude.md', path: 'playbook/claude-overrides/01-discovery.claude.md', type: 'file' },
            { name: '02-architecture.claude.md', path: 'playbook/claude-overrides/02-architecture.claude.md', type: 'file' },
            { name: '03-foundation.claude.md', path: 'playbook/claude-overrides/03-foundation.claude.md', type: 'file' },
            { name: '04-core-implementation.claude.md', path: 'playbook/claude-overrides/04-core-implementation.claude.md', type: 'file' },
            { name: '05-integration-hardening.claude.md', path: 'playbook/claude-overrides/05-integration-hardening.claude.md', type: 'file' },
            { name: '06-testing-quality.claude.md', path: 'playbook/claude-overrides/06-testing-quality.claude.md', type: 'file' },
            { name: '07-launch.claude.md', path: 'playbook/claude-overrides/07-launch.claude.md', type: 'file' },
          ],
        },
        { name: 'codeforge-phase.sh', path: 'playbook/codeforge-phase.sh', type: 'file' },
        { name: 'current-phase.json', path: 'playbook/current-phase.json', type: 'file' },
        {
          name: 'phases',
          path: 'playbook/phases',
          type: 'directory',
          children: [
            { name: '01-discovery.md', path: 'playbook/phases/01-discovery.md', type: 'file' },
            { name: '02-architecture.md', path: 'playbook/phases/02-architecture.md', type: 'file' },
            { name: '03-foundation.md', path: 'playbook/phases/03-foundation.md', type: 'file' },
            { name: '04-core-implementation.md', path: 'playbook/phases/04-core-implementation.md', type: 'file' },
            { name: '05-integration-hardening.md', path: 'playbook/phases/05-integration-hardening.md', type: 'file' },
            { name: '06-testing-quality.md', path: 'playbook/phases/06-testing-quality.md', type: 'file' },
            { name: '07-launch.md', path: 'playbook/phases/07-launch.md', type: 'file' },
          ],
        },
        {
          name: 'prompts',
          path: 'playbook/prompts',
          type: 'directory',
          children: [
            {
              name: '01',
              path: 'playbook/prompts/01',
              type: 'directory',
              children: [
                { name: 'gather-requirements.md', path: 'playbook/prompts/01/gather-requirements.md', type: 'file' },
                { name: 'nfr-checklist.md', path: 'playbook/prompts/01/nfr-checklist.md', type: 'file' },
                { name: 'user-stories.md', path: 'playbook/prompts/01/user-stories.md', type: 'file' },
              ],
            },
            {
              name: '02',
              path: 'playbook/prompts/02',
              type: 'directory',
              children: [
                { name: 'adr-generator.md', path: 'playbook/prompts/02/adr-generator.md', type: 'file' },
                { name: 'api-design.md', path: 'playbook/prompts/02/api-design.md', type: 'file' },
                { name: 'data-model-design.md', path: 'playbook/prompts/02/data-model-design.md', type: 'file' },
              ],
            },
            {
              name: '03',
              path: 'playbook/prompts/03',
              type: 'directory',
              children: [
                { name: 'ci-pipeline.md', path: 'playbook/prompts/03/ci-pipeline.md', type: 'file' },
                { name: 'iac-setup.md', path: 'playbook/prompts/03/iac-setup.md', type: 'file' },
                { name: 'project-scaffold.md', path: 'playbook/prompts/03/project-scaffold.md', type: 'file' },
              ],
            },
            {
              name: '04',
              path: 'playbook/prompts/04',
              type: 'directory',
              children: [
                { name: 'auth-implementation.md', path: 'playbook/prompts/04/auth-implementation.md', type: 'file' },
                { name: 'crud-generator.md', path: 'playbook/prompts/04/crud-generator.md', type: 'file' },
                { name: 'feature-implementation.md', path: 'playbook/prompts/04/feature-implementation.md', type: 'file' },
              ],
            },
            {
              name: '05',
              path: 'playbook/prompts/05',
              type: 'directory',
              children: [
                { name: 'integration-adapter.md', path: 'playbook/prompts/05/integration-adapter.md', type: 'file' },
                { name: 'observability-setup.md', path: 'playbook/prompts/05/observability-setup.md', type: 'file' },
                { name: 'security-hardening.md', path: 'playbook/prompts/05/security-hardening.md', type: 'file' },
              ],
            },
            {
              name: '06',
              path: 'playbook/prompts/06',
              type: 'directory',
              children: [
                { name: 'e2e-test-generator.md', path: 'playbook/prompts/06/e2e-test-generator.md', type: 'file' },
                { name: 'load-test.md', path: 'playbook/prompts/06/load-test.md', type: 'file' },
                { name: 'test-suite-generator.md', path: 'playbook/prompts/06/test-suite-generator.md', type: 'file' },
              ],
            },
            {
              name: '07',
              path: 'playbook/prompts/07',
              type: 'directory',
              children: [
                { name: 'go-live-checklist.md', path: 'playbook/prompts/07/go-live-checklist.md', type: 'file' },
                { name: 'monitoring-setup.md', path: 'playbook/prompts/07/monitoring-setup.md', type: 'file' },
                { name: 'runbook-generator.md', path: 'playbook/prompts/07/runbook-generator.md', type: 'file' },
              ],
            },
          ],
        },
      ],
    },
    {
      name: 'plugin',
      path: 'plugin',
      type: 'directory',
      children: [
        {
          name: 'codeforge-django-saas',
          path: 'plugin/codeforge-django-saas',
          type: 'directory',
          children: [
            {
              name: '.claude-plugin',
              path: 'plugin/codeforge-django-saas/.claude-plugin',
              type: 'directory',
              children: [
                { name: 'plugin.json', path: 'plugin/codeforge-django-saas/.claude-plugin/plugin.json', type: 'file' },
              ],
            },
            { name: 'README.md', path: 'plugin/codeforge-django-saas/README.md', type: 'file' },
            {
              name: 'agents',
              path: 'plugin/codeforge-django-saas/agents',
              type: 'directory',
              children: [
                { name: 'architect.md', path: 'plugin/codeforge-django-saas/agents/architect.md', type: 'file' },
                { name: 'build-error-resolver.md', path: 'plugin/codeforge-django-saas/agents/build-error-resolver.md', type: 'file' },
                { name: 'code-reviewer.md', path: 'plugin/codeforge-django-saas/agents/code-reviewer.md', type: 'file' },
                { name: 'planner.md', path: 'plugin/codeforge-django-saas/agents/planner.md', type: 'file' },
                { name: 'tdd-guide.md', path: 'plugin/codeforge-django-saas/agents/tdd-guide.md', type: 'file' },
              ],
            },
            {
              name: 'commands',
              path: 'plugin/codeforge-django-saas/commands',
              type: 'directory',
              children: [
                { name: 'build-fix.md', path: 'plugin/codeforge-django-saas/commands/build-fix.md', type: 'file' },
                { name: 'code-review.md', path: 'plugin/codeforge-django-saas/commands/code-review.md', type: 'file' },
                { name: 'phase.md', path: 'plugin/codeforge-django-saas/commands/phase.md', type: 'file' },
                { name: 'plan.md', path: 'plugin/codeforge-django-saas/commands/plan.md', type: 'file' },
                { name: 'tdd.md', path: 'plugin/codeforge-django-saas/commands/tdd.md', type: 'file' },
                { name: 'verify.md', path: 'plugin/codeforge-django-saas/commands/verify.md', type: 'file' },
              ],
            },
            {
              name: 'hooks',
              path: 'plugin/codeforge-django-saas/hooks',
              type: 'directory',
              children: [
                { name: 'hooks.json', path: 'plugin/codeforge-django-saas/hooks/hooks.json', type: 'file' },
              ],
            },
            {
              name: 'skills',
              path: 'plugin/codeforge-django-saas/skills',
              type: 'directory',
              children: [
                {
                  name: 'build-fix',
                  path: 'plugin/codeforge-django-saas/skills/build-fix',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-django-saas/skills/build-fix/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'code-review',
                  path: 'plugin/codeforge-django-saas/skills/code-review',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-django-saas/skills/code-review/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'phase',
                  path: 'plugin/codeforge-django-saas/skills/phase',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-django-saas/skills/phase/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'plan',
                  path: 'plugin/codeforge-django-saas/skills/plan',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-django-saas/skills/plan/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'tdd',
                  path: 'plugin/codeforge-django-saas/skills/tdd',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-django-saas/skills/tdd/SKILL.md', type: 'file' },
                  ],
                },
                {
                  name: 'verify',
                  path: 'plugin/codeforge-django-saas/skills/verify',
                  type: 'directory',
                  children: [
                    { name: 'SKILL.md', path: 'plugin/codeforge-django-saas/skills/verify/SKILL.md', type: 'file' },
                  ],
                },
              ],
            },
          ],
        },
        { name: 'marketplace.json.example', path: 'plugin/marketplace.json.example', type: 'file' },
      ],
    },
    { name: 'pyproject.toml', path: 'pyproject.toml', type: 'file' },
    { name: 'ruff.toml', path: 'ruff.toml', type: 'file' },
];

export const djangoSaasDemoFileContents: Record<string, string> = {
  '.claude/rules/common/coding-style.md': `# Coding Style Rules

## Python Naming Conventions

- **Files and modules**: \`snake_case\` — \`tenant_manager.py\`, \`billing_service.py\`
- **Functions and methods**: \`snake_case\` — \`get_tenant_by_slug()\`, \`sync_stripe_subscription()\`
- **Classes**: \`PascalCase\` — \`TenantAwareManager\`, \`SubscriptionPlan\`, \`BillingWebhookView\`
- **Constants**: \`SCREAMING_SNAKE_CASE\` — \`MAX_TENANTS_PER_PLAN\`, \`STRIPE_WEBHOOK_TOLERANCE\`
- **URL paths**: \`kebab-case\` — \`/api/v1/billing-plans/\`, \`/api/v1/tenant-settings/\`
- **Type variables**: \`PascalCase\` with \`T\` suffix — \`ModelT\`, \`SerializerT\`
- **Private members**: Single leading underscore — \`_calculate_usage()\`, \`_tenant_cache\`
- **Django settings**: \`SCREAMING_SNAKE_CASE\` — \`STRIPE_SECRET_KEY\`, \`TENANT_SUBDOMAIN_LENGTH\`

## Type Hints

Type hints are required on all public functions, methods, and class attributes:

\`\`\`python
from collections.abc import Sequence
from decimal import Decimal
from uuid import UUID

def get_active_subscriptions(
    tenant_id: UUID,
    *,
    include_trialing: bool = False,
) -> Sequence[Subscription]:
    ...
\`\`\`

- Use \`from __future__ import annotations\` at the top of every module
- Use modern union syntax: \`str | None\` not \`Optional[str]\`
- Use \`collections.abc\` types: \`Sequence\`, \`Mapping\`, \`Iterable\` over \`typing\` equivalents
- Use \`Self\` for fluent/builder return types
- Private/internal helpers should also have type hints but enforcement is relaxed

## File Structure

Every Python file follows this section order:

1. Module docstring
2. \`from __future__ import annotations\`
3. Standard library imports
4. Third-party imports
5. Django imports
6. Local app imports (relative)
7. Constants
8. Type aliases
9. Module-level logger
10. Classes and functions
11. Module-level code (kept to an absolute minimum)

## Import Ordering

Imports are organized into groups separated by a blank line, sorted alphabetically within each group. Enforced by \`ruff\` with isort rules:

\`\`\`python
"""Service layer for subscription billing."""

from __future__ import annotations

import logging
from datetime import datetime, timedelta
from decimal import Decimal
from typing import TYPE_CHECKING
from uuid import UUID

import stripe
from celery import shared_task
from django.conf import settings
from django.db import transaction
from django.utils import timezone
from rest_framework.exceptions import ValidationError

from core.models import BaseModel
from core.permissions import TenantPermission

from .models import Invoice, Subscription, UsageRecord
from .constants import GRACE_PERIOD_DAYS, MAX_RETRY_ATTEMPTS

if TYPE_CHECKING:
    from tenants.models import Tenant
\`\`\`

- Use \`TYPE_CHECKING\` blocks for imports only needed by type checkers to avoid circular imports
- Prefer relative imports within the same Django app: \`from .models import Subscription\`
- Use absolute imports across apps: \`from billing.services import create_subscription\`
- Never use wildcard imports (\`from module import *\`)

## File Length

- Maximum **300 lines** per file — if a file exceeds this, split it
- Split large modules into sub-packages: \`billing/services/__init__.py\`, \`billing/services/subscriptions.py\`, \`billing/services/invoicing.py\`
- Views, serializers, and models each get their own file or sub-package within a Django app

## Django App Structure

Each Django app is self-contained and follows this layout:

\`\`\`
billing/
  __init__.py
  admin.py              # Django admin configuration
  apps.py               # AppConfig
  constants.py          # App-specific constants
  exceptions.py         # App-specific exception classes
  managers.py           # Custom QuerySet and Manager classes
  models.py             # Django models (or models/ package if large)
  permissions.py        # DRF permission classes
  serializers.py        # DRF serializers (or serializers/ package)
  services.py           # Business logic layer (or services/ package)
  signals.py            # Signal handlers (use sparingly)
  tasks.py              # Celery task definitions
  types.py              # Strawberry GraphQL types
  urls.py               # URL routing
  views.py              # DRF viewsets and API views (or views/ package)
\`\`\`

## Class and Method Ordering

Within a Django model or class, follow this order:

1. Inner \`Meta\` class
2. Constants and class-level attributes
3. Fields (for Django models)
4. \`__str__\`, \`__repr__\`, and other dunder methods
5. \`clean()\`, \`save()\`, \`delete()\` (model lifecycle)
6. Properties (\`@property\`)
7. Public methods
8. Private methods (\`_prefixed\`)

\`\`\`python
class Subscription(TenantAwareModel):
    """Represents a tenant's subscription to a billing plan."""

    class Meta:
        ordering = ["-created_at"]
        indexes = [
            models.Index(fields=["tenant", "status"]),
        ]

    class Status(models.TextChoices):
        ACTIVE = "active", "Active"
        TRIALING = "trialing", "Trialing"
        PAST_DUE = "past_due", "Past Due"
        CANCELED = "canceled", "Canceled"

    tenant = models.ForeignKey("tenants.Tenant", on_delete=models.CASCADE)
    plan = models.ForeignKey("billing.Plan", on_delete=models.PROTECT)
    stripe_subscription_id = models.CharField(max_length=255, unique=True)
    status = models.CharField(max_length=20, choices=Status.choices)
    current_period_end = models.DateTimeField()

    def __str__(self) -> str:
        return f"{self.tenant.name} — {self.plan.name} ({self.status})"

    def clean(self) -> None:
        if self.status == self.Status.ACTIVE and not self.stripe_subscription_id:
            raise ValidationError("Active subscriptions require a Stripe ID.")

    @property
    def is_active(self) -> bool:
        return self.status in {self.Status.ACTIVE, self.Status.TRIALING}

    def cancel(self, *, at_period_end: bool = True) -> None:
        """Cancel this subscription via Stripe."""
        ...

    def _sync_from_stripe(self, stripe_sub: stripe.Subscription) -> None:
        ...
\`\`\`

## DRF Serializer Conventions

- Name serializers with the pattern \`{Model}Serializer\`, \`{Model}CreateSerializer\`, \`{Model}ListSerializer\`
- Use \`read_only_fields\` in \`Meta\` rather than per-field \`read_only=True\` where possible
- Validate tenant isolation in \`validate()\` or custom validators — never trust client-supplied tenant IDs

## Service Layer Pattern

Business logic lives in \`services.py\`, not in views or serializers:

\`\`\`python
# billing/services.py
def create_subscription(
    *,
    tenant: Tenant,
    plan: Plan,
    payment_method_id: str,
) -> Subscription:
    """Create a new Stripe subscription for a tenant."""
    with transaction.atomic():
        stripe_sub = stripe.Subscription.create(
            customer=tenant.stripe_customer_id,
            items=[{"price": plan.stripe_price_id}],
            default_payment_method=payment_method_id,
        )
        return Subscription.objects.create(
            tenant=tenant,
            plan=plan,
            stripe_subscription_id=stripe_sub.id,
            status=stripe_sub.status,
            current_period_end=datetime.fromtimestamp(
                stripe_sub.current_period_end, tz=timezone.utc
            ),
        )
\`\`\`

- Use keyword-only arguments (\`*\`) for service functions to enforce clarity at call sites
- Wrap multi-step operations in \`transaction.atomic()\`
- Raise domain-specific exceptions, not generic ones

## String Formatting

- Use f-strings for interpolation: \`f"Tenant {tenant.slug} exceeded quota"\`
- Use \`.format()\` only for log messages with lazy evaluation: \`logger.info("Processing %s", tenant_id)\`
- Never use \`%\` formatting outside of logger calls

## Docstrings

Use Google-style docstrings on all public classes, methods, and functions:

\`\`\`python
def sync_usage_records(
    tenant_id: UUID,
    *,
    period_start: datetime,
    period_end: datetime,
) -> int:
    """Sync usage records to Stripe for metered billing.

    Fetches unsynced usage records for the given period and reports
    them to Stripe's usage record API.

    Args:
        tenant_id: The tenant whose usage to sync.
        period_start: Start of the billing period.
        period_end: End of the billing period.

    Returns:
        Number of usage records successfully synced.

    Raises:
        BillingError: If the tenant has no active metered subscription.
        stripe.StripeError: If the Stripe API call fails.
    """
\`\`\`

## Error Handling

- Define app-specific exceptions in \`exceptions.py\`
- Catch specific exceptions — never bare \`except:\`
- Let unexpected exceptions propagate to Sentry
- Use \`raise ... from err\` to preserve exception chains

\`\`\`python
class BillingError(Exception):
    """Base exception for billing operations."""

class SubscriptionLimitExceeded(BillingError):
    """Tenant has exceeded their plan's subscription limit."""
\`\`\`

## Logging

- One logger per module: \`logger = logging.getLogger(__name__)\`
- Use structured key-value pairs for context: \`logger.info("subscription_created", extra={"tenant_id": str(tenant.id), "plan": plan.slug})\`
- Never log secrets, tokens, PII, or full Stripe API responses
- Use appropriate levels: \`DEBUG\` for development detail, \`INFO\` for business events, \`WARNING\` for recoverable issues, \`ERROR\` for failures requiring attention

## Linting and Formatting

All code is checked by \`ruff\` and \`mypy\` before merge:

\`\`\`bash
uv run ruff check src/ tests/        # Linting
uv run ruff format --check src/ tests/ # Format check
uv run mypy src/                       # Type checking
\`\`\`

Ruff is configured to enforce isort import ordering, pycodestyle, pyflakes, and additional rules. See \`pyproject.toml\` for the full rule set.`,

  '.claude/rules/common/git-workflow.md': `# Git Workflow Rules

## Branching Strategy: GitHub Flow

We use GitHub Flow with a single protected \`main\` branch. All work happens on short-lived feature branches merged via pull requests.

### Branch Naming

Format: \`type/TICKET-description\`

**Types:**
- \`feat/\` — New features (\`feat/SAAS-42-add-tenant-onboarding\`)
- \`fix/\` — Bug fixes (\`fix/SAAS-108-webhook-retry-logic\`)
- \`refactor/\` — Code restructuring (\`refactor/SAAS-55-billing-service-layer\`)
- \`chore/\` — Maintenance, deps, CI (\`chore/SAAS-200-upgrade-django-5-1\`)
- \`docs/\` — Documentation only (\`docs/SAAS-77-api-runbook\`)
- \`test/\` — Test additions or fixes (\`test/SAAS-90-billing-integration-tests\`)
- \`hotfix/\` — Urgent production fixes (\`hotfix/SAAS-999-stripe-webhook-crash\`)

**Rules:**
- Always include the GitHub Issue number (e.g., \`SAAS-42\`)
- Use lowercase kebab-case for the description portion
- Keep descriptions short but meaningful (3-5 words max)
- Branch from \`main\` — never from another feature branch unless explicitly coordinating

## Conventional Commits

Every commit message must follow the Conventional Commits specification.

### Format

\`\`\`
type(scope): short description

[optional body]

[optional footer(s)]
\`\`\`

### Types

| Type | When to Use |
|------|-------------|
| \`feat\` | New feature or user-facing capability |
| \`fix\` | Bug fix |
| \`refactor\` | Code change that neither fixes a bug nor adds a feature |
| \`test\` | Adding or updating tests |
| \`docs\` | Documentation changes |
| \`chore\` | Build, CI, dependency updates, tooling |
| \`perf\` | Performance improvement |
| \`ci\` | CI/CD pipeline changes |
| \`style\` | Formatting (ruff format), no logic change |

### Scopes

Use the Django app name or infrastructure component as scope:

- \`accounts\`, \`tenants\`, \`billing\`, \`api\`, \`core\`, \`notifications\`, \`tasks\`, \`utils\`
- \`config\`, \`ci\`, \`docker\`, \`terraform\`, \`deps\`

### Examples

\`\`\`
feat(tenants): add tenant onboarding wizard API endpoint

Implements POST /api/v1/tenants/onboard/ with org name, plan selection,
and initial admin user creation. Triggers welcome email via Celery task.

Closes SAAS-42
\`\`\`

\`\`\`
fix(billing): handle duplicate Stripe webhook events idempotently

Store processed event IDs in Redis with 48h TTL to prevent
double-processing of invoice.payment_succeeded events.

Fixes SAAS-108
\`\`\`

\`\`\`
refactor(core): extract tenant-aware queryset into TenantManager

Moves row-level security filtering from individual views into
core.managers.TenantManager for consistent tenant isolation.

Refs SAAS-55
\`\`\`

\`\`\`
chore(deps): upgrade celery to 5.4.0 and redis to 5.1.0
\`\`\`

### Commit Rules

- Write in imperative mood ("add feature" not "added feature")
- First line must be ≤72 characters
- Reference the GitHub Issue in the footer (\`Closes SAAS-XX\`, \`Fixes SAAS-XX\`, \`Refs SAAS-XX\`)
- One logical change per commit — do not mix refactoring with feature work
- Never commit secrets, \`.env\` files, or credentials (see \`.claude/rules/common/security.md\`)

### Breaking Changes

Mark breaking changes with \`!\` after the type/scope and include a \`BREAKING CHANGE:\` footer:

\`\`\`
feat(api)!: change tenant context header from X-Tenant to X-Tenant-ID

BREAKING CHANGE: All API clients must send X-Tenant-ID header instead
of X-Tenant. The old header is no longer recognized.

Closes SAAS-301
\`\`\`

## Pull Request Requirements

### Before Opening a PR

1. **Rebase on latest \`main\`**: \`git fetch origin && git rebase origin/main\`
2. **Run the full local check suite**:
   \`\`\`bash
   uv run ruff check src/ tests/
   uv run ruff format --check src/ tests/
   uv run mypy src/
   uv run pytest --cov=src --cov-fail-under=85
   \`\`\`
3. **Ensure migrations are consistent**: \`uv run python manage.py makemigrations --check --dry-run\`
4. **Verify no secrets are staged**: Check diff for API keys, tokens, connection strings

### PR Title

Must follow conventional commit format — this becomes the squash-merge commit message:

\`\`\`
feat(billing): implement usage-based metering for API calls (SAAS-150)
\`\`\`

### PR Description

Every PR must include:

- **What**: Summary of the change and why it's needed
- **How**: Brief technical approach (mention affected Django apps, new Celery tasks, Stripe API calls, migration changes)
- **Testing**: What tests were added or updated, how to verify manually
- **Issue link**: \`Closes #<issue-number>\` for automatic linking
- **Checklist** (copy into PR):

\`\`\`markdown
## Checklist
- [ ] Conventional commit messages used
- [ ] Type hints on all public functions
- [ ] Tests added/updated (coverage ≥85%)
- [ ] OpenAPI schema updated if API changed (\`drf-spectacular\`)
- [ ] Celery tasks are idempotent
- [ ] Tenant isolation verified (data access through TenantManager)
- [ ] No secrets or credentials in code
- [ ] Migrations included if models changed
- [ ] Documentation updated if behavior changed
\`\`\`

### Merge Requirements

All of these must pass before merging to \`main\`:

1. **At least 1 approval** from a code reviewer
2. **All CI checks green**: lint, type check, unit tests, integration tests, security scan
3. **No unresolved review comments**
4. **Branch is up to date** with \`main\`

### Sensitive Path Reviews

Changes to these paths require **additional scrutiny** and ideally review from a senior/lead:

- \`src/billing/**\` — Stripe integration, subscription logic, financial data
- \`src/accounts/**\` and \`src/core/auth/**\` — Authentication, authorization, RBAC
- \`config/production/**\` — Production Django settings
- \`.env*\` — Environment configuration (should never be committed)
- \`src/tenants/managers.py\`, \`src/core/managers.py\` — Tenant isolation logic
- \`.github/workflows/**\` — CI/CD pipeline definitions
- \`terraform/**\` — Infrastructure changes

These paths are enforced via \`CODEOWNERS\`.

### Merge Strategy

- **Squash and merge** for feature branches — keeps \`main\` history clean
- PR title becomes the commit message (must be conventional commit format)
- Delete the branch after merge

## AI-Generated Code

When Claude Code generates or substantially modifies code:

- The commit message should include \`🤖\` or \`[ai-assisted]\` in the body or footer
- Example:
  \`\`\`
  feat(notifications): add webhook retry with exponential backoff

  Implements retry logic for failed webhook deliveries with exponential
  backoff (max 5 attempts, max delay 5 minutes). Failed webhooks are
  logged to the audit trail.

  [ai-assisted]
  Closes SAAS-175
  \`\`\`
- Reviewers should pay particular attention to AI-generated code in sensitive paths

## Hotfix Process

For urgent production issues:

1. Branch from \`main\`: \`hotfix/SAAS-XXX-brief-description\`
2. Fix, test locally, open PR with \`hotfix\` label
3. Request expedited review (ping in Slack \`#engineering\`)
4. After merge to \`main\`, verify staging deployment, then promote to production
5. Create a follow-up issue for any shortcuts taken under pressure

## Common Mistakes to Avoid

- **Do not** force-push to \`main\` — it is a protected branch
- **Do not** merge without CI passing, even for "trivial" changes
- **Do not** create long-lived feature branches — break work into small PRs
- **Do not** commit migration conflicts — coordinate with the team in Slack
- **Do not** mix unrelated changes in a single PR (e.g., billing fix + UI refactor)
- **Do not** skip the tenant isolation checklist item for any data-access code`,

  '.claude/rules/common/security.md': `# Security Rules

## Multi-Tenant Data Isolation

- **All database queries for tenant-scoped data MUST use the tenant-aware manager** defined in \`src/core/managers.py\`. Never use \`.objects.all()\` on tenant-scoped models — use \`.for_tenant(tenant)\` or the \`TenantAwareQuerySet\`.
- Row-level security (RLS) policies are enforced at the PostgreSQL level. Never bypass RLS by using superuser connections in application code.
- Tenant context MUST be set in middleware (\`src/tenants/middleware.py\`) before any view executes. If tenant context is missing, the request must be rejected with \`403 Forbidden\`.
- Cross-tenant data access is a **critical security incident**. Every PR touching \`src/tenants/\`, \`src/core/managers.py\`, or any raw SQL must be reviewed by a lead engineer.
- Never include \`tenant_id\` in user-facing URLs or API responses unless explicitly required. Derive tenant from the authenticated user's session or JWT claims.
- Management commands that operate across tenants must require an explicit \`--all-tenants\` flag and log every tenant accessed.
- Test tenant isolation explicitly: every model with a \`tenant\` foreign key must have a test in \`tests/\` proving that Tenant A cannot read/write Tenant B's data.

## Authentication and Authorization

- Use Django's authentication framework with session-based auth for web and JWT (via \`djangorestframework-simplejwt\`) for API access.
- All API endpoints must enforce authentication. Unauthenticated endpoints require explicit documentation and security review.
- Role-based access control (RBAC) is defined in \`src/accounts/permissions.py\`. Use DRF permission classes — never check roles inside view logic with bare \`if\` statements.
- Enforce least privilege: default to denying access. Permissions are additive.
- Session tokens and JWTs must have reasonable expiry: sessions ≤ 24 hours, access tokens ≤ 15 minutes, refresh tokens ≤ 7 days.
- Implement account lockout after 5 failed login attempts within 15 minutes. Use \`django-axes\` or equivalent.
- All password resets, email changes, and role escalations must trigger an audit log entry via \`src/core/audit.py\`.

## GDPR Compliance

- Personal data fields must be annotated in model definitions with a \`# PII\` comment and tracked in \`docs/data-inventory.md\`.
- Implement right to deletion: \`src/accounts/services.py\` must provide a \`delete_user_data(user_id, tenant_id)\` function that anonymizes or deletes all PII across all apps. This must be covered by integration tests.
- Consent records (what the user agreed to, when, which version) must be stored in \`src/accounts/models.py\` (\`ConsentRecord\` model) and never silently overwritten.
- Data export: provide a \`export_user_data(user_id, tenant_id)\` function returning a JSON bundle of all user PII (GDPR Article 20 — data portability).
- Log retention: application logs must not contain PII. If PII appears in error context, it must be masked (email → \`u***@***.com\`, names → \`[REDACTED]\`).
- Data residency: tenant configuration must specify the data region. Queries and Celery tasks must respect the tenant's region setting. See \`src/tenants/models.py\` field \`data_region\`.
- Cookie consent must be obtained before setting non-essential cookies. Analytics and tracking scripts must respect consent state.
- Data Processing Agreements (DPAs) with sub-processors (Stripe, AWS, SendGrid) must be documented in \`docs/compliance/dpa-register.md\`.

## SOC 2 Controls

- **Audit logging is mandatory** for all state-changing operations on sensitive resources: user accounts, tenant settings, billing changes, permission changes, data exports, and data deletions. Use the structured audit logger in \`src/core/audit.py\`.
- Audit logs must be append-only and must not be deletable by application code. Store in a separate database table with restricted write access.
- All secrets (API keys, database credentials, Stripe keys) must be stored in environment variables or AWS Secrets Manager — never in code, config files, or version control. See \`config/\` settings and \`django-environ\` usage.
- Enforce HTTPS everywhere. Set \`SECURE_SSL_REDIRECT = True\`, \`SECURE_HSTS_SECONDS = 31536000\`, \`SESSION_COOKIE_SECURE = True\`, \`CSRF_COOKIE_SECURE = True\` in production settings (\`config/production.py\`).
- Dependency vulnerabilities must be scanned in CI using \`pip-audit\` or \`safety\`. Fail the build on high/critical CVEs.
- Access to production infrastructure requires MFA and is logged. No shared credentials.
- Quarterly access reviews: document who has access to production, admin panels, and Stripe dashboard in \`docs/compliance/access-reviews/\`.

## Stripe and PCI Compliance

- **Never handle raw credit card numbers, CVVs, or full card PANs in our application.** All payment data entry must use Stripe Elements or Stripe Checkout (client-side tokenization). This keeps us at PCI SAQ-A level.
- Stripe API keys: use \`STRIPE_SECRET_KEY\` (server-side only, never exposed to frontend) and \`STRIPE_PUBLISHABLE_KEY\` (frontend only). Store secret key in environment variables.
- Webhook signature verification is **mandatory**. Every Stripe webhook handler in \`src/billing/webhooks.py\` must call \`stripe.Webhook.construct_event()\` with the signing secret. Reject unverified payloads with \`400\`.
- Stripe webhook handlers must be **idempotent**. Use the \`event.id\` as an idempotency key and track processed events in \`src/billing/models.py\` (\`StripeEvent\` model) to prevent duplicate processing.
- Never log full Stripe event payloads in production — they may contain customer PII. Log only \`event.id\`, \`event.type\`, and processing status.
- Stripe customer IDs, subscription IDs, and payment intent IDs may be stored. Card fingerprints and last-4 digits may be stored for display. Full card numbers must **never** be stored.
- Test Stripe integration using Stripe test mode keys and \`stripe-mock\` in CI. Never use live keys in development or testing.
- Refunds, disputes, and subscription cancellations must create audit log entries.

## OWASP Top 10 Protections

### Injection (A03)
- Use Django ORM for all database queries. Raw SQL is allowed only in migrations and must be reviewed by a senior engineer.
- If raw SQL is unavoidable, use parameterized queries exclusively. Never use string formatting or f-strings to build SQL.
- Validate and sanitize all user input at the serializer layer (\`src/api/serializers/\`).

### Broken Authentication (A07)
- Enforce strong password policy: minimum 12 characters, check against breached password lists (\`django-pwned-passwords\` or similar).
- Rate-limit authentication endpoints: \`/api/auth/login/\`, \`/api/auth/token/\`, \`/api/auth/password-reset/\`.

### Sensitive Data Exposure (A02)
- Encrypt sensitive fields at rest using \`django-encrypted-model-fields\` or application-level encryption for fields like API tokens stored on behalf of tenants.
- Never return sensitive fields in API responses: passwords, secret keys, full tokens. Use serializer \`exclude\` or explicit \`fields\` lists.

### Broken Access Control (A01)
- Every DRF viewset must declare \`permission_classes\` explicitly. The default in \`config/base.py\` must be \`[IsAuthenticated]\`.
- Object-level permissions must verify tenant ownership. Use \`src/core/permissions.py\` \`IsTenantMember\` permission class.
- Admin endpoints (\`/admin/\`) must be restricted to staff users and protected by IP allowlist in production.

### Security Misconfiguration (A05)
- \`DEBUG = False\` in production. Enforced in \`config/production.py\` and verified in CI.
- Django security middleware must be enabled: \`SecurityMiddleware\`, \`XFrameOptionsMiddleware\`, \`ContentTypeNoSniff\`.
- \`ALLOWED_HOSTS\` must be explicitly set — never use \`['*']\` in production.

### Cross-Site Scripting (A03)
- Django templates auto-escape by default. Never use \`|safe\` or \`mark_safe()\` without security review.
- API responses are JSON — ensure \`Content-Type: application/json\` headers are set correctly by DRF.
- CSP headers should be configured via \`django-csp\` middleware.

### CSRF (A01)
- CSRF protection is enabled by default for session-authenticated views. Do not exempt views from CSRF without security review.
- API endpoints using JWT authentication are exempt from CSRF (stateless), but this must be configured correctly in DRF settings.

### SSRF Prevention
- Any feature that accepts URLs from users (webhooks, integrations, avatar uploads) must validate against an allowlist of schemes (\`https\` only) and block private/internal IP ranges.
- Use \`src/utils/url_validation.py\` for URL validation before making outbound HTTP requests.

## Secrets Management

- Required environment variables for production are documented in \`docs/deployment.md\` and validated at startup by Pydantic settings in \`config/settings.py\`.
- Rotate Stripe webhook signing secrets and API keys quarterly. Document rotation procedure in \`docs/runbooks/secret-rotation.md\`.
- Never commit \`.env\` files. The \`.gitignore\` must include \`.env*\`. CI uses GitHub Actions secrets.
- Database credentials must use IAM authentication in production (AWS RDS IAM auth) where possible.

## Security Review Requirements

- Changes to these paths require security-focused review from a lead or senior engineer:
  - \`src/billing/**\` — payment and subscription logic
  - \`src/accounts/**\` — authentication and authorization
  - \`src/tenants/**\` — tenant isolation and RLS
  - \`src/core/permissions.py\` — RBAC definitions
  - \`src/core/managers.py\` — tenant-aware query managers
  - \`src/core/audit.py\` — audit logging
  - \`config/production.py\` — production settings
  - \`config/settings.py\` — Pydantic settings validation
  - \`.env*\` — must never be committed; reject PRs that include these
  - Any file containing raw SQL
  - Any file importing \`subprocess\`, \`os.system\`, \`eval\`, or \`exec\`

## Celery Task Security

- Celery tasks must not accept tenant-scoped model instances as arguments — pass IDs and re-fetch within the task using the tenant-aware manager.
- Tasks processing billing or PII data must run on a dedicated queue (\`billing\`, \`pii\`) with restricted worker access.
- Task results containing PII must have a short TTL in Redis (≤ 1 hour) or must not be stored at all (\`ignore_result=True\`).
- Celery broker (Redis) must require authentication and use TLS in production.`,

  '.claude/rules/common/testing.md': `# Testing Standards

## Framework and Tools

- **Test runner**: pytest with pytest-django
- **Fixtures**: factory_boy (never use Django's built-in fixtures or raw \`Model.objects.create()\` in tests)
- **Async tests**: pytest-asyncio for async views and Celery task testing
- **Coverage**: pytest-cov with **85% minimum** threshold enforced in CI
- **API testing**: DRF's \`APIClient\` for REST endpoints, Strawberry's test client for GraphQL
- **Time control**: \`freezegun\` for time-dependent tests (billing cycles, trial expiry, token expiration)
- **Mocking**: \`unittest.mock\` (prefer \`mocker\` fixture from pytest-mock)

## Running Tests

\`\`\`bash
# Full suite
uv run pytest

# Specific app
uv run pytest tests/billing/

# With coverage report
uv run pytest --cov=src --cov-report=term-missing --cov-fail-under=85

# Only unit tests (exclude integration)
uv run pytest -m "not integration"

# Parallel execution
uv run pytest -n auto
\`\`\`

## Test Organization

Mirror the \`src/\` directory structure under \`tests/\`:

\`\`\`
tests/
  conftest.py              # Shared fixtures, tenant setup, API clients
  accounts/
    test_models.py
    test_services.py
    test_views.py
    test_serializers.py
    factories.py
  billing/
    test_models.py
    test_services.py
    test_stripe_webhooks.py
    test_subscription_lifecycle.py
    test_tasks.py
    factories.py
  tenants/
    test_models.py
    test_middleware.py
    test_isolation.py
    factories.py
  api/
    test_rest_endpoints.py
    test_graphql_queries.py
    test_graphql_mutations.py
    test_permissions.py
  core/
    test_managers.py
    test_permissions.py
  notifications/
    test_services.py
    test_tasks.py
    factories.py
\`\`\`

## Test Naming

- Files: \`test_<module>.py\`
- Classes: \`Test<Feature>\` (group related tests)
- Functions: \`test_<action>_<scenario>_<expected_result>\`

\`\`\`python
class TestSubscriptionCreation:
    def test_create_subscription_with_valid_plan_returns_active_status(self): ...
    def test_create_subscription_with_expired_trial_charges_immediately(self): ...
    def test_create_subscription_without_payment_method_raises_validation_error(self): ...
\`\`\`

## Factory Boy Patterns

Every app must have a \`factories.py\` file. Factories are the **only** way to create test data.

\`\`\`python
# tests/tenants/factories.py
import factory
from src.tenants.models import Tenant

class TenantFactory(factory.django.DjangoModelFactory):
    class Meta:
        model = Tenant

    name = factory.Sequence(lambda n: f"Tenant {n}")
    slug = factory.LazyAttribute(lambda o: o.name.lower().replace(" ", "-"))
    is_active = True
    plan = "professional"


# tests/accounts/factories.py
import factory
from src.accounts.models import User
from tests.tenants.factories import TenantFactory

class UserFactory(factory.django.DjangoModelFactory):
    class Meta:
        model = User

    email = factory.Sequence(lambda n: f"user{n}@example.com")
    tenant = factory.SubFactory(TenantFactory)
    role = "member"
    is_active = True

    @factory.post_generation
    def password(self, create, extracted, **kwargs):
        self.set_password(extracted or "testpass123!")
\`\`\`

## Shared Fixtures (conftest.py)

\`\`\`python
# tests/conftest.py
import pytest
from rest_framework.test import APIClient
from tests.tenants.factories import TenantFactory
from tests.accounts.factories import UserFactory


@pytest.fixture
def tenant(db):
    return TenantFactory()


@pytest.fixture
def user(db, tenant):
    return UserFactory(tenant=tenant)


@pytest.fixture
def admin_user(db, tenant):
    return UserFactory(tenant=tenant, role="admin")


@pytest.fixture
def api_client():
    return APIClient()


@pytest.fixture
def authenticated_client(api_client, user):
    api_client.force_authenticate(user=user)
    return api_client


@pytest.fixture
def tenant_aware_client(authenticated_client, tenant):
    """Client with tenant context header set."""
    authenticated_client.defaults["HTTP_X_TENANT_ID"] = str(tenant.id)
    return authenticated_client
\`\`\`

## Multi-Tenancy Testing

**Every test involving data access must verify tenant isolation.** This is a SOC 2 and security requirement.

\`\`\`python
class TestTenantIsolation:
    def test_queryset_excludes_other_tenant_data(self, tenant):
        own_project = ProjectFactory(tenant=tenant)
        other_project = ProjectFactory()  # different tenant

        qs = Project.tenant_objects.for_tenant(tenant)
        assert own_project in qs
        assert other_project not in qs

    def test_api_endpoint_returns_only_tenant_data(self, tenant_aware_client, tenant):
        own_item = ItemFactory(tenant=tenant)
        other_item = ItemFactory()  # different tenant

        response = tenant_aware_client.get("/api/v1/items/")
        item_ids = [i["id"] for i in response.data["results"]]

        assert str(own_item.id) in item_ids
        assert str(other_item.id) not in item_ids

    def test_cannot_access_other_tenant_resource_by_id(self, tenant_aware_client):
        other_item = ItemFactory()  # different tenant
        response = tenant_aware_client.get(f"/api/v1/items/{other_item.id}/")
        assert response.status_code == 404  # NOT 403 — don't leak existence
\`\`\`

## Billing and Stripe Testing

Never call real Stripe APIs in tests. Use \`unittest.mock\` to patch Stripe SDK calls.

\`\`\`python
import stripe
from unittest.mock import patch, MagicMock


class TestStripeWebhookHandling:
    @pytest.fixture
    def stripe_event_payload(self):
        """Return a realistic Stripe event payload."""
        return {
            "id": "evt_test_123",
            "type": "customer.subscription.updated",
            "data": {
                "object": {
                    "id": "sub_test_456",
                    "status": "active",
                    "current_period_end": 1700000000,
                }
            },
        }

    @patch("stripe.Webhook.construct_event")
    def test_webhook_processes_subscription_update(
        self, mock_construct, stripe_event_payload, api_client
    ):
        mock_construct.return_value = stripe.Event.construct_from(
            stripe_event_payload, stripe.api_key
        )
        response = api_client.post(
            "/api/v1/billing/webhooks/stripe/",
            data=stripe_event_payload,
            format="json",
            HTTP_STRIPE_SIGNATURE="test_sig",
        )
        assert response.status_code == 200

    def test_webhook_rejects_invalid_signature(self, api_client):
        with patch(
            "stripe.Webhook.construct_event",
            side_effect=stripe.error.SignatureVerificationError("bad sig", "sig"),
        ):
            response = api_client.post(
                "/api/v1/billing/webhooks/stripe/",
                data={},
                format="json",
                HTTP_STRIPE_SIGNATURE="invalid",
            )
            assert response.status_code == 400

    def test_webhook_is_idempotent(self, stripe_event_payload, api_client):
        """Processing the same event twice must not create duplicate state."""
        with patch("stripe.Webhook.construct_event") as mock_construct:
            mock_construct.return_value = stripe.Event.construct_from(
                stripe_event_payload, stripe.api_key
            )
            api_client.post(
                "/api/v1/billing/webhooks/stripe/",
                data=stripe_event_payload,
                format="json",
                HTTP_STRIPE_SIGNATURE="sig",
            )
            api_client.post(
                "/api/v1/billing/webhooks/stripe/",
                data=stripe_event_payload,
                format="json",
                HTTP_STRIPE_SIGNATURE="sig",
            )
        # Assert only one subscription record / state change exists
\`\`\`

## Celery Task Testing

Test tasks **synchronously** using \`CELERY_ALWAYS_EAGER=True\` or by calling the function directly. Always verify idempotency.

\`\`\`python
# settings/test.py
CELERY_TASK_ALWAYS_EAGER = True
CELERY_TASK_EAGER_PROPAGATES = True
\`\`\`

\`\`\`python
class TestBillingSyncTask:
    def test_sync_task_updates_subscription_status(self, tenant):
        subscription = SubscriptionFactory(tenant=tenant, status="trialing")
        with patch("src.billing.services.stripe_client") as mock_stripe:
            mock_stripe.Subscription.retrieve.return_value = MagicMock(status="active")
            sync_subscription_status(subscription.id)

        subscription.refresh_from_db()
        assert subscription.status == "active"

    def test_sync_task_is_idempotent(self, tenant):
        """Running the task twice produces the same result."""
        subscription = SubscriptionFactory(tenant=tenant)
        with patch("src.billing.services.stripe_client") as mock_stripe:
            mock_stripe.Subscription.retrieve.return_value = MagicMock(status="active")
            sync_subscription_status(subscription.id)
            sync_subscription_status(subscription.id)

        assert Subscription.objects.filter(id=subscription.id).count() == 1

    def test_task_handles_deleted_resource_gracefully(self):
        """Task must not crash if the DB record was deleted between enqueue and execution."""
        result = sync_subscription_status(uuid4())  # non-existent ID
        assert result is None  # or appropriate sentinel
\`\`\`

## API Testing Patterns

### REST (DRF)

\`\`\`python
class TestProjectEndpoints:
    def test_list_projects_returns_paginated_results(self, tenant_aware_client, tenant):
        ProjectFactory.create_batch(3, tenant=tenant)
        response = tenant_aware_client.get("/api/v1/projects/")
        assert response.status_code == 200
        assert response.data["count"] == 3

    def test_create_project_requires_authentication(self, api_client):
        response = api_client.post("/api/v1/projects/", data={"name": "Test"})
        assert response.status_code == 401

    def test_create_project_validates_required_fields(self, tenant_aware_client):
        response = tenant_aware_client.post("/api/v1/projects/", data={})
        assert response.status_code == 400
        assert "name" in response.data
\`\`\`

### GraphQL (Strawberry)

\`\`\`python
class TestGraphQLQueries:
    PROJECTS_QUERY = """
        query {
            projects {
                edges {
                    node {
                        id
                        name
                    }
                }
            }
        }
    """

    def test_projects_query_returns_tenant_scoped_data(self, tenant_aware_client, tenant):
        ProjectFactory(tenant=tenant, name="My Project")
        ProjectFactory()  # other tenant

        response = tenant_aware_client.post(
            "/api/graphql/",
            data={"query": self.PROJECTS_QUERY},
            content_type="application/json",
        )
        data = response.json()["data"]["projects"]["edges"]
        assert len(data) == 1
        assert data[0]["node"]["name"] == "My Project"
\`\`\`

## Test Markers

Use pytest markers to categorize tests:

\`\`\`python
# pyproject.toml
[tool.pytest.ini_options]
markers = [
    "unit: Fast, isolated unit tests",
    "integration: Tests requiring database or external service mocks",
    "e2e: End-to-end tests (run in CI staging only)",
    "slow: Tests taking >5 seconds",
    "billing: Billing and Stripe-related tests",
    "tenant_isolation: Multi-tenancy isolation verification tests",
]
\`\`\`

\`\`\`python
@pytest.mark.unit
def test_calculate_prorated_amount():
    assert calculate_prorated_amount(100_00, 15, 30) == 50_00

@pytest.mark.integration
@pytest.mark.billing
def test_subscription_upgrade_flow(tenant):
    ...

@pytest.mark.tenant_isolation
def test_row_level_security_prevents_cross_tenant_read(tenant):
    ...
\`\`\`

## GDPR and Data Privacy Tests

\`\`\`python
class TestGDPRCompliance:
    def test_user_deletion_removes_personal_data(self, user):
        """Right to deletion: PII must be purged or anonymized."""
        user_id = user.id
        delete_user_data(user)
        user.refresh_from_db()
        assert user.email != f"user{user_id}@example.com"
        assert user.is_active is False
        assert AuditLog.objects.filter(actor_id=user_id).exists()  # audit retained

    def test_data_export_includes_all_user_data(self, user):
        """Right to access: export must include all PII."""
        export = generate_user_data_export(user)
        assert "email" in export
        assert "profile" in export
        assert "billing_history" in export

    def test_consent_required_before_marketing_emails(self, user):
        user.marketing_consent = False
        user.save()
        assert not should_send_marketing_email(user)
\`\`\`

## Coverage Rules

- **Minimum overall**: 85%
- **Billing app**: 90% minimum (critical path)
- **Auth/accounts app**: 90% minimum (security-sensitive)
- **New code in PRs**: Must not decrease overall coverage
- Coverage is enforced in CI — builds fail below threshold

\`\`\`toml
# pyproject.toml
[tool.coverage.run]
source = ["src"]
omit = ["*/migrations/*", "*/management/commands/*", "config/*"]

[tool.coverage.report]
fail_under = 85
show_missing = true
exclude_lines = [
    "pragma: no cover",
    "if TYPE_CHECKING:",
    "raise NotImplementedError",
    "@overload",
]
\`\`\`

## What Not to Test

- Django's built-in functionality (ORM basics, admin rendering)
- Third-party library internals
- Migration files
- Type-only code (\`if TYPE_CHECKING\` blocks)

## What Must Always Be Tested

- Every API endpoint (happy path + error cases + permission checks)
- Tenant isolation on every queryset and endpoint
- Stripe webhook handlers (signature verification, idempotency, all event types)
- Celery task idempotency and failure handling
- Service layer business logic
- Permission and role-based access control
- Data validation (serializers, GraphQL input types)
- GDPR data deletion and export paths

## Pre-Push Checklist

Before pushing, run:

\`\`\`bash
uv run ruff check src/ tests/
uv run mypy src/
uv run pytest --cov=src --cov-fail-under=85 -x
\`\`\`

See also: \`.claude/rules/common/coding-style.md\` for naming conventions, \`.claude/rules/common/security.md\` for security testing requirements.`,

  '.claude/rules/python/coding-style.md': `# Python Coding Style

## Formatting and Linting

All Python code is formatted and linted with **ruff**. No other formatters or linters are used.

\`\`\`bash
# Check linting
uv run ruff check src/ tests/

# Auto-fix linting issues
uv run ruff check --fix src/ tests/

# Format code
uv run ruff format src/ tests/

# Check formatting without modifying
uv run ruff format --check src/ tests/
\`\`\`

Ruff is configured in \`pyproject.toml\`. Do not add inline \`# noqa\` comments without a justifying code comment explaining why the suppression is necessary.

## Type Hints

All public functions, methods, and class attributes must have type annotations. We use **mypy in strict mode**.

\`\`\`bash
uv run mypy src/
\`\`\`

### Rules

- All public function signatures must include parameter types and return types
- Use \`from __future__ import annotations\` at the top of every module
- Prefer \`str | None\` over \`Optional[str]\` (PEP 604 union syntax)
- Use \`collections.abc\` types (\`Sequence\`, \`Mapping\`, \`Iterable\`) over \`typing\` equivalents
- Use \`type\` keyword for simple type aliases (Python 3.12+): \`type TenantId = uuid.UUID\`
- Private/internal helper functions should still have type hints but mypy won't enforce strict coverage on \`_\`-prefixed functions
- Django model fields: use explicit type annotations where mypy-django-stubs need help
- Celery tasks: annotate parameters and return types; use \`@shared_task\` with typed signatures

\`\`\`python
from __future__ import annotations

from collections.abc import Sequence
from uuid import UUID

from django.db import models


def get_active_tenants(region: str | None = None) -> Sequence[Tenant]:
    """Return active tenants, optionally filtered by region."""
    qs = Tenant.objects.filter(is_active=True)
    if region:
        qs = qs.filter(region=region)
    return list(qs)
\`\`\`

### Common Patterns

\`\`\`python
# Use TypedDict for complex dict structures
from typing import TypedDict

class SubscriptionContext(TypedDict):
    tenant_id: UUID
    plan_id: str
    stripe_subscription_id: str
    is_trial: bool

# Use Protocol for duck-typed interfaces
from typing import Protocol

class BillingProvider(Protocol):
    def create_subscription(self, tenant_id: UUID, plan_id: str) -> str: ...
    def cancel_subscription(self, subscription_id: str) -> None: ...
\`\`\`

## Django Model Conventions

### Model Structure

Order model internals consistently:

1. Constants and class-level attributes (\`MAX_NAME_LENGTH\`, \`Status\` enum)
2. Database fields
3. \`Meta\` class
4. \`__str__\` method
5. \`__repr__\` method (if needed)
6. \`save()\` / \`delete()\` overrides
7. Properties
8. Instance methods
9. Class methods / static methods

\`\`\`python
from __future__ import annotations

import uuid

from django.db import models
from django.utils import timezone

from core.models import TenantAwareModel


class Subscription(TenantAwareModel):
    """Tracks a tenant's subscription to a billing plan."""

    class Status(models.TextChoices):
        ACTIVE = "active", "Active"
        PAST_DUE = "past_due", "Past Due"
        CANCELED = "canceled", "Canceled"
        TRIALING = "trialing", "Trialing"

    id = models.UUIDField(primary_key=True, default=uuid.uuid4, editable=False)
    plan = models.ForeignKey(
        "billing.Plan",
        on_delete=models.PROTECT,
        related_name="subscriptions",
    )
    status = models.CharField(
        max_length=20,
        choices=Status.choices,
        default=Status.TRIALING,
        db_index=True,
    )
    stripe_subscription_id = models.CharField(
        max_length=255,
        unique=True,
        blank=True,
    )
    current_period_end = models.DateTimeField()
    canceled_at = models.DateTimeField(null=True, blank=True)
    created_at = models.DateTimeField(auto_now_add=True)
    updated_at = models.DateTimeField(auto_now=True)

    class Meta:
        ordering = ["-created_at"]
        indexes = [
            models.Index(fields=["tenant", "status"]),
        ]

    def __str__(self) -> str:
        return f"{self.tenant} - {self.plan} ({self.status})"

    @property
    def is_active(self) -> bool:
        return self.status in (self.Status.ACTIVE, self.Status.TRIALING)

    def cancel(self, *, at_period_end: bool = True) -> None:
        """Cancel this subscription. Prefer calling billing.services.cancel_subscription()."""
        self.status = self.Status.CANCELED
        self.canceled_at = timezone.now()
        self.save(update_fields=["status", "canceled_at", "updated_at"])
\`\`\`

### Model Rules

- Always use \`UUIDField\` as primary key — never expose sequential IDs
- All models holding tenant data must inherit from \`core.models.TenantAwareModel\`
- Use \`TextChoices\` / \`IntegerChoices\` for enumerated fields, never raw strings
- Always set \`related_name\` on ForeignKey and ManyToManyField
- Use \`PROTECT\` for ForeignKey \`on_delete\` unless there is a documented reason for \`CASCADE\`
- Add \`db_index=True\` on fields used in filters and lookups
- Add composite indexes in \`Meta.indexes\` for common query patterns
- Use \`auto_now_add\` for \`created_at\`, \`auto_now\` for \`updated_at\`
- Never put business logic in \`save()\` — use the service layer
- Keep models under 150 lines; split large models into mixins if needed

### TenantAwareModel

All tenant-scoped data must use the tenant-aware manager. Direct \`objects\` queries that bypass tenant filtering are a security violation.

\`\`\`python
# CORRECT — uses tenant-aware manager
subscriptions = Subscription.objects.for_tenant(tenant).filter(status="active")

# WRONG — bypasses tenant isolation
subscriptions = Subscription.objects.filter(status="active")
\`\`\`

The only exception is management commands or Celery tasks that explicitly operate across tenants, which must be clearly documented and use \`Subscription.objects.all_tenants()\`.

## Django Serializer Patterns

### DRF Serializers

\`\`\`python
from __future__ import annotations

from rest_framework import serializers

from billing.models import Subscription


class SubscriptionSerializer(serializers.ModelSerializer):
    """Read serializer for subscription data."""

    plan_name = serializers.CharField(source="plan.name", read_only=True)
    is_active = serializers.BooleanField(read_only=True)

    class Meta:
        model = Subscription
        fields = [
            "id",
            "plan",
            "plan_name",
            "status",
            "is_active",
            "current_period_end",
            "created_at",
        ]
        read_only_fields = ["id", "status", "created_at"]


class SubscriptionCreateSerializer(serializers.Serializer):
    """Write serializer — decoupled from model to enforce service layer."""

    plan_id = serializers.UUIDField()
    payment_method_id = serializers.CharField(max_length=255)

    def validate_plan_id(self, value: str) -> str:
        from billing.models import Plan

        if not Plan.objects.filter(id=value, is_active=True).exists():
            raise serializers.ValidationError("Invalid or inactive plan.")
        return value
\`\`\`

### Serializer Rules

- Separate read serializers (\`ModelSerializer\`) from write serializers (\`Serializer\`)
- Write serializers should call service layer functions in the view, not in \`create()\` / \`update()\` — keep serializers as validation-only
- Always explicitly list \`fields\` — never use \`fields = "__all__"\`
- Mark computed/derived fields as \`read_only=True\`
- Never expose internal fields: \`stripe_subscription_id\`, \`stripe_customer_id\`, or any Stripe-internal identifiers in public API responses
- Use \`source=\` for renaming fields rather than \`SerializerMethodField\` when possible
- Validate at the serializer level for input shape; validate business rules in the service layer
- All serializers must be registered with drf-spectacular via \`@extend_schema\` on the view

## Service Layer

Business logic lives in service modules (\`<app>/services.py\`), not in views, serializers, or models.

\`\`\`python
# billing/services.py
from __future__ import annotations

from uuid import UUID

from billing.models import Plan, Subscription
from billing.stripe_client import stripe_client
from tenants.models import Tenant


def create_subscription(*, tenant: Tenant, plan_id: UUID, payment_method_id: str) -> Subscription:
    """Create a new Stripe subscription and local record.

    This function is the single entry point for subscription creation.
    It is idempotent — if the tenant already has an active subscription
    to this plan, it returns the existing one.
    """
    plan = Plan.objects.get(id=plan_id, is_active=True)

    existing = Subscription.objects.for_tenant(tenant).filter(
        plan=plan,
        status__in=[Subscription.Status.ACTIVE, Subscription.Status.TRIALING],
    ).first()
    if existing:
        return existing

    stripe_sub = stripe_client.create_subscription(
        customer_id=tenant.stripe_customer_id,
        price_id=plan.stripe_price_id,
        payment_method_id=payment_method_id,
    )

    return Subscription.objects.create(
        tenant=tenant,
        plan=plan,
        stripe_subscription_id=stripe_sub.id,
        status=Subscription.Status.TRIALING,
        current_period_end=stripe_sub.current_period_end,
    )
\`\`\`

### Service Layer Rules

- Use keyword-only arguments (\`*\`) for all service functions to prevent positional argument mistakes
- Service functions must be the only place that calls external APIs (Stripe, SES, etc.)
- Service functions must be independently testable — inject dependencies or use the module-level client
- Document idempotency guarantees in the docstring
- Raise domain-specific exceptions (defined in \`<app>/exceptions.py\`), not generic \`ValueError\`

## Celery Task Conventions

\`\`\`python
# tasks/billing_tasks.py
from __future__ import annotations

from uuid import UUID

from celery import shared_task


@shared_task(
    bind=True,
    max_retries=3,
    default_retry_delay=60,
    acks_late=True,
    reject_on_worker_lost=True,
)
def sync_subscription_status(self, *, subscription_id: UUID) -> None:
    """Sync subscription status from Stripe. Idempotent."""
    from billing.services import sync_subscription_from_stripe

    try:
        sync_subscription_from_stripe(subscription_id=subscription_id)
    except Exception as exc:
        self.retry(exc=exc)
\`\`\`

### Task Rules

- All tasks must be **idempotent** — safe to retry or run multiple times
- Use \`bind=True\` and configure \`max_retries\`, \`default_retry_delay\`, \`acks_late\`
- Import service functions inside the task body to avoid circular imports
- Use keyword arguments for task parameters — never positional
- Task parameters must be JSON-serializable (use \`str(uuid)\` if needed, not UUID objects)
- Never access \`request.user\` or Django request context inside a task
- Log task start, completion, and failure with structured logging

## Imports

Order imports as:

1. \`from __future__ import annotations\`
2. Standard library
3. Third-party packages
4. Django imports
5. Local app imports (relative for same app, absolute for cross-app)

Ruff enforces this via \`isort\` rules. Do not manually reorder — run \`uv run ruff check --fix\`.

\`\`\`python
from __future__ import annotations

import logging
from uuid import UUID

import stripe
from celery import shared_task
from django.conf import settings
from django.db import transaction

from core.exceptions import TenantAccessError
from billing.models import Subscription
\`\`\`

## Naming Conventions

| Element | Convention | Example |
|---|---|---|
| Files / modules | \`snake_case\` | \`billing_tasks.py\` |
| Functions | \`snake_case\` | \`create_subscription()\` |
| Classes | \`PascalCase\` | \`SubscriptionSerializer\` |
| Constants | \`SCREAMING_SNAKE_CASE\` | \`MAX_RETRY_ATTEMPTS\` |
| URL paths | \`kebab-case\` | \`/api/v1/billing/payment-methods/\` |
| Test functions | \`test_<what>_<condition>_<expected>\` | \`test_create_subscription_invalid_plan_raises_error\` |
| Factories | \`<Model>Factory\` | \`SubscriptionFactory\` |
| Fixtures | descriptive noun | \`active_tenant\`, \`stripe_mock\` |

## File Length

Maximum **300 lines** per file. If a file approaches this limit:

- Split models into separate files with a \`models/\` package and \`__init__.py\` re-exports
- Split views into separate viewset files
- Extract complex validation into \`validators.py\`
- Extract query logic into \`selectors.py\` or \`querysets.py\`

## Docstrings

Use Google-style docstrings on all public classes, functions, and modules.

\`\`\`python
def cancel_subscription(*, subscription_id: UUID, at_period_end: bool = True) -> Subscription:
    """Cancel a tenant's subscription.

    Communicates with Stripe to cancel the subscription and updates
    the local record. Idempotent — canceling an already-canceled
    subscription is a no-op.

    Args:
        subscription_id: The UUID of the local Subscription record.
        at_period_end: If True, cancel at the end of the current billing
            period. If False, cancel immediately.

    Returns:
        The updated Subscription instance.

    Raises:
        SubscriptionNotFoundError: If no subscription exists with this ID.
        StripeSyncError: If the Stripe API call fails after retries.
    """
\`\`\`

## Testing Patterns

See \`.claude/rules/testing/pytest-conventions.md\` for full testing rules. Key Python-specific points:

- Use \`factory_boy\` for all test data — never create models manually in tests
- Use \`pytest.mark.django_db\` for tests that touch the database
- Mock external services (Stripe, SES) at the service layer boundary
- Use \`freezegun\` or \`time_machine\` for time-dependent tests
- Parametrize tests for multiple input scenarios

\`\`\`python
import pytest
from billing.factories import SubscriptionFactory, TenantFactory


@pytest.mark.django_db
def test_cancel_subscription_sets_status_to_canceled(stripe_mock: None) -> None:
    tenant = TenantFactory()
    subscription = SubscriptionFactory(tenant=tenant, status="active")

    result = cancel_subscription(subscription_id=subscription.id)

    assert result.status == "canceled"
    assert result.canceled_at is not None
\`\`\``,

  '.claude/rules/python/testing.md': `# Python Testing Standards

## Test Framework Configuration

We use **pytest** with **pytest-django**, **pytest-asyncio**, **pytest-cov**, and **factory_boy**. All tests run via \`uv run pytest\`. Never use Django's \`TestCase\` unless specifically needed for transaction isolation — prefer \`pytest\` functions with fixtures.

### conftest.py Hierarchy

\`\`\`
tests/
  conftest.py              # Global fixtures: db access, tenant, user, API client
  accounts/
    conftest.py            # Account-specific fixtures
    test_models.py
    test_services.py
    test_views.py
  billing/
    conftest.py            # Billing/Stripe-specific fixtures
    test_webhook_handler.py
    test_subscription_service.py
  tenants/
    conftest.py            # Tenant isolation fixtures
    test_middleware.py
    test_row_level_security.py
\`\`\`

Each \`conftest.py\` should only contain fixtures relevant to its directory. Do not put all fixtures in the root conftest.

## pytest Markers

Always mark tests appropriately:

\`\`\`python
import pytest

@pytest.mark.django_db
def test_user_creation(tenant: Tenant) -> None:
    """Tests that touch the database require django_db marker."""
    ...

@pytest.mark.django_db(transaction=True)
def test_concurrent_subscription_update() -> None:
    """Use transaction=True only when testing transaction isolation."""
    ...

@pytest.mark.integration
def test_stripe_customer_sync() -> None:
    """Integration tests that hit external services or complex DB operations."""
    ...

@pytest.mark.slow
def test_monthly_report_generation() -> None:
    """Tests that take >2 seconds."""
    ...

@pytest.mark.asyncio
async def test_async_webhook_dispatch() -> None:
    """Async tests require the asyncio marker."""
    ...
\`\`\`

Register custom markers in \`pyproject.toml\`:

\`\`\`toml
[tool.pytest.ini_options]
markers = [
    "integration: Integration tests (may be slower)",
    "slow: Tests that take >2 seconds",
    "stripe: Tests involving Stripe API mocks",
    "celery: Tests involving Celery task execution",
]
\`\`\`

## factory_boy Factories

Every Django model must have a corresponding factory. Factories live in \`tests/<app>/factories.py\`.

### Factory Conventions

\`\`\`python
import factory
from factory.django import DjangoModelFactory

from src.tenants.models import Tenant
from src.accounts.models import User
from src.billing.models import Subscription, Plan


class TenantFactory(DjangoModelFactory):
    class Meta:
        model = Tenant

    name = factory.Sequence(lambda n: f"Tenant {n}")
    slug = factory.LazyAttribute(lambda obj: obj.name.lower().replace(" ", "-"))
    is_active = True
    settings = factory.LazyFunction(dict)


class UserFactory(DjangoModelFactory):
    class Meta:
        model = User

    email = factory.Sequence(lambda n: f"user{n}@example.com")
    tenant = factory.SubFactory(TenantFactory)
    first_name = factory.Faker("first_name")
    last_name = factory.Faker("last_name")
    role = "member"
    is_active = True

    class Params:
        admin = factory.Trait(role="admin", is_staff=True)
        owner = factory.Trait(role="owner")


class PlanFactory(DjangoModelFactory):
    class Meta:
        model = Plan

    name = factory.Iterator(["Starter", "Professional", "Enterprise"])
    stripe_price_id = factory.Sequence(lambda n: f"price_test_{n}")
    monthly_price_cents = 2999
    is_active = True


class SubscriptionFactory(DjangoModelFactory):
    class Meta:
        model = Subscription

    tenant = factory.SubFactory(TenantFactory)
    plan = factory.SubFactory(PlanFactory)
    stripe_subscription_id = factory.Sequence(lambda n: f"sub_test_{n}")
    status = "active"
\`\`\`

### Factory Rules

- Use \`factory.Sequence\` for unique fields — never hardcode values that must be unique
- Use \`factory.SubFactory\` for foreign keys — do not create related objects manually
- Use \`factory.Trait\` via \`Params\` for common object variants (admin user, canceled subscription)
- Use \`factory.LazyAttribute\` when a field depends on another field's value
- Never use \`factory.Faker\` for fields that are used in assertions — use deterministic values
- Factories must produce valid model instances without any additional arguments

## Core Fixtures

### Global Fixtures (root \`conftest.py\`)

\`\`\`python
import pytest
from rest_framework.test import APIClient

from tests.tenants.factories import TenantFactory
from tests.accounts.factories import UserFactory


@pytest.fixture
def tenant(db) -> Tenant:
    """A default active tenant for tests."""
    return TenantFactory()


@pytest.fixture
def user(tenant: Tenant) -> User:
    """A regular member user associated with the default tenant."""
    return UserFactory(tenant=tenant)


@pytest.fixture
def admin_user(tenant: Tenant) -> User:
    """An admin user associated with the default tenant."""
    return UserFactory(tenant=tenant, admin=True)


@pytest.fixture
def owner_user(tenant: Tenant) -> User:
    """A tenant owner user."""
    return UserFactory(tenant=tenant, owner=True)


@pytest.fixture
def api_client() -> APIClient:
    """Unauthenticated DRF API client."""
    return APIClient()


@pytest.fixture
def authenticated_client(api_client: APIClient, user: User) -> APIClient:
    """API client authenticated as a regular user."""
    api_client.force_authenticate(user=user)
    return api_client


@pytest.fixture
def admin_client(api_client: APIClient, admin_user: User) -> APIClient:
    """API client authenticated as an admin user."""
    api_client.force_authenticate(user=admin_user)
    return api_client


@pytest.fixture
def other_tenant(db) -> Tenant:
    """A second tenant for cross-tenant isolation tests."""
    return TenantFactory(name="Other Tenant")


@pytest.fixture
def other_tenant_user(other_tenant: Tenant) -> User:
    """A user belonging to a different tenant."""
    return UserFactory(tenant=other_tenant)
\`\`\`

### Tenant Context Fixture

Every test that accesses tenant-scoped data must set the tenant context:

\`\`\`python
from src.tenants.context import set_current_tenant


@pytest.fixture(autouse=False)
def tenant_context(tenant: Tenant):
    """Set the current tenant in thread-local context."""
    token = set_current_tenant(tenant)
    yield tenant
    clear_current_tenant(token)
\`\`\`

## Mocking Stripe

**Never call the real Stripe API in tests.** Use \`unittest.mock\` or \`pytest-mock\` to patch Stripe SDK calls.

### Stripe Fixture Patterns

\`\`\`python
import json
from unittest.mock import MagicMock, patch
from pathlib import Path

import pytest
import stripe


STRIPE_FIXTURES_DIR = Path(__file__).parent / "fixtures" / "stripe"


@pytest.fixture
def mock_stripe_customer() -> MagicMock:
    """Mock stripe.Customer with common operations."""
    with patch("stripe.Customer") as mock:
        mock.create.return_value = stripe.Customer.construct_from(
            {"id": "cus_test_123", "email": "user@example.com"},
            key="sk_test_fake",
        )
        mock.retrieve.return_value = stripe.Customer.construct_from(
            {"id": "cus_test_123", "email": "user@example.com"},
            key="sk_test_fake",
        )
        mock.modify.return_value = stripe.Customer.construct_from(
            {"id": "cus_test_123", "email": "updated@example.com"},
            key="sk_test_fake",
        )
        yield mock


@pytest.fixture
def mock_stripe_subscription() -> MagicMock:
    """Mock stripe.Subscription with lifecycle operations."""
    with patch("stripe.Subscription") as mock:
        mock.create.return_value = stripe.Subscription.construct_from(
            {
                "id": "sub_test_456",
                "customer": "cus_test_123",
                "status": "active",
                "current_period_end": 1700000000,
                "items": {"data": [{"id": "si_test_789", "price": {"id": "price_test_1"}}]},
            },
            key="sk_test_fake",
        )
        yield mock


@pytest.fixture
def stripe_webhook_payload() -> dict:
    """Load a Stripe webhook event fixture."""
    def _load(event_type: str) -> dict:
        fixture_file = STRIPE_FIXTURES_DIR / f"{event_type.replace('.', '_')}.json"
        return json.loads(fixture_file.read_text())
    return _load


@pytest.fixture
def mock_stripe_webhook_verification():
    """Bypass Stripe webhook signature verification in tests."""
    with patch("stripe.Webhook.construct_event") as mock:
        mock.side_effect = lambda payload, sig, secret: json.loads(payload)
        yield mock
\`\`\`

### Stripe Webhook Test Pattern

\`\`\`python
@pytest.mark.django_db
def test_invoice_paid_webhook(
    authenticated_client: APIClient,
    tenant: Tenant,
    mock_stripe_webhook_verification,
    stripe_webhook_payload,
) -> None:
    event = stripe_webhook_payload("invoice.paid")
    response = authenticated_client.post(
        "/api/v1/billing/webhooks/stripe/",
        data=json.dumps(event),
        content_type="application/json",
        HTTP_STRIPE_SIGNATURE="t=123,v1=fake_sig",
    )
    assert response.status_code == 200
    # Assert idempotency — calling again should not create duplicates
    response = authenticated_client.post(
        "/api/v1/billing/webhooks/stripe/",
        data=json.dumps(event),
        content_type="application/json",
        HTTP_STRIPE_SIGNATURE="t=123,v1=fake_sig",
    )
    assert response.status_code == 200
\`\`\`

Store Stripe webhook JSON fixtures in \`tests/billing/fixtures/stripe/\`. Copy real payloads from Stripe's test mode (with sensitive data scrubbed).

### Stripe Error Testing

Always test Stripe error paths:

\`\`\`python
def test_subscription_creation_handles_card_declined(
    mock_stripe_subscription: MagicMock,
    tenant: Tenant,
) -> None:
    mock_stripe_subscription.create.side_effect = stripe.error.CardError(
        message="Your card was declined.",
        param="number",
        code="card_declined",
    )
    with pytest.raises(PaymentFailedError):
        create_subscription(tenant=tenant, plan_id="price_test_1")
\`\`\`

## Mocking Celery Tasks

**Never execute real Celery workers in unit tests.** Use \`CELERY_ALWAYS_EAGER\` for simple cases or mock tasks explicitly.

### Celery Test Settings

In \`config/test.py\`:

\`\`\`python
CELERY_TASK_ALWAYS_EAGER = True
CELERY_TASK_EAGER_PROPAGATES = True
\`\`\`

### Explicit Task Mocking

For tests where you need to verify a task was dispatched without executing it:

\`\`\`python
from unittest.mock import patch


def test_tenant_creation_dispatches_welcome_email(
    admin_client: APIClient,
) -> None:
    with patch("src.tasks.notifications.send_welcome_email.delay") as mock_task:
        response = admin_client.post("/api/v1/tenants/", data={...})
        assert response.status_code == 201
        mock_task.assert_called_once_with(tenant_id=response.data["id"])


def test_billing_sync_task_is_idempotent(
    tenant: Tenant,
    mock_stripe_customer: MagicMock,
) -> None:
    """Celery tasks must be idempotent — running twice produces same result."""
    from src.tasks.billing import sync_stripe_customer

    sync_stripe_customer(tenant_id=tenant.id)
    sync_stripe_customer(tenant_id=tenant.id)

    tenant.refresh_from_db()
    assert tenant.stripe_customer_id == "cus_test_123"
\`\`\`

### Testing Task Retry Logic

\`\`\`python
from celery.exceptions import Retry


def test_webhook_dispatch_retries_on_timeout(
    tenant: Tenant,
) -> None:
    with patch("src.tasks.notifications.requests.post") as mock_post:
        mock_post.side_effect = requests.Timeout("Connection timed out")
        with pytest.raises(Retry):
            dispatch_webhook(tenant_id=tenant.id, event="subscription.created")
\`\`\`

## Test Database Configuration

### PostgreSQL for Tests

Tests must run against PostgreSQL (not SQLite) to validate row-level security and tenant isolation:

\`\`\`python
# config/test.py
DATABASES = {
    "default": {
        "ENGINE": "django.db.backends.postgresql",
        "NAME": "test_saas_platform",
        "USER": environ.get("DB_USER", "postgres"),
        "PASSWORD": environ.get("DB_PASSWORD", "postgres"),
        "HOST": environ.get("DB_HOST", "localhost"),
        "PORT": environ.get("DB_PORT", "5432"),
        "TEST": {
            "NAME": "test_saas_platform",
        },
    }
}
\`\`\`

### Tenant Isolation Tests

Every model with tenant-scoped data must have a cross-tenant isolation test:

\`\`\`python
@pytest.mark.django_db
def test_tenant_cannot_access_other_tenant_data(
    tenant_context,
    tenant: Tenant,
    other_tenant: Tenant,
) -> None:
    """Verify row-level security prevents cross-tenant data access."""
    from src.billing.models import Invoice

    # Create invoice for other tenant
    InvoiceFactory(tenant=other_tenant)

    # Current tenant context should not see it
    assert Invoice.objects.count() == 0


@pytest.mark.django_db
def test_api_returns_only_current_tenant_resources(
    authenticated_client: APIClient,
    tenant: Tenant,
    other_tenant: Tenant,
) -> None:
    ProjectFactory(tenant=tenant, name="My Project")
    ProjectFactory(tenant=other_tenant, name="Their Project")

    response = authenticated_client.get("/api/v1/projects/")
    names = [p["name"] for p in response.data["results"]]
    assert names == ["My Project"]
\`\`\`

## API Testing Patterns

### DRF ViewSet Tests

\`\`\`python
@pytest.mark.django_db
class TestProjectViewSet:
    def test_list_requires_authentication(self, api_client: APIClient) -> None:
        response = api_client.get("/api/v1/projects/")
        assert response.status_code == 401

    def test_list_returns_tenant_projects(
        self, authenticated_client: APIClient, tenant: Tenant
    ) -> None:
        ProjectFactory.create_batch(3, tenant=tenant)
        response = authenticated_client.get("/api/v1/projects/")
        assert response.status_code == 200
        assert len(response.data["results"]) == 3

    def test_create_validates_required_fields(
        self, authenticated_client: APIClient
    ) -> None:
        response = authenticated_client.post("/api/v1/projects/", data={})
        assert response.status_code == 400
        assert "name" in response.data

    def test_owner_can_delete(
        self, admin_client: APIClient, tenant: Tenant
    ) -> None:
        project = ProjectFactory(tenant=tenant)
        response = admin_client.delete(f"/api/v1/projects/{project.id}/")
        assert response.status_code == 204

    def test_member_cannot_delete(
        self, authenticated_client: APIClient, tenant: Tenant
    ) -> None:
        project = ProjectFactory(tenant=tenant)
        response = authenticated_client.delete(f"/api/v1/projects/{project.id}/")
        assert response.status_code == 403
\`\`\`

### GraphQL Tests (Strawberry)

\`\`\`python
@pytest.mark.django_db
def test_graphql_tenant_query(authenticated_client: APIClient, tenant: Tenant) -> None:
    query = """
        query {
            currentTenant {
                id
                name
                plan { name }
            }
        }
    """
    response = authenticated_client.post(
        "/graphql/",
        data={"query": query},
        content_type="application/json",
    )
    assert response.status_code == 200
    data = response.json()["data"]["currentTenant"]
    assert data["name"] == tenant.name
\`\`\`

## Service Layer Testing

Test business logic through the service layer, not through models directly:

\`\`\`python
@pytest.mark.django_db
def test_upgrade_subscription(
    tenant: Tenant,
    mock_stripe_subscription: MagicMock,
) -> None:
    current_plan = PlanFactory(name="Starter")
    new_plan = PlanFactory(name="Professional")
    SubscriptionFactory(tenant=tenant, plan=current_plan)

    result = upgrade_subscription(tenant=tenant, new_plan=new_plan)

    assert result.plan == new_plan
    assert result.status == "active"
    mock_stripe_subscription.modify.assert_called_once()


@pytest.mark.django_db
def test_cancel_subscription_schedules_end_of_period(
    tenant: Tenant,
    mock_stripe_subscription: MagicMock,
) -> None:
    subscription = SubscriptionFactory(tenant=tenant, status="active")

    cancel_subscription(tenant=tenant, immediate=False)

    subscription.refresh_from_db()
    assert subscription.status == "cancel_at_period_end"
\`\`\`

## Test Organization Rules

1. **One test file per module**: \`test_models.py\`, \`test_services.py\`, \`test_views.py\`, \`test_tasks.py\`
2. **Test file mirrors source**: \`src/billing/services.py\` → \`tests/billing/test_services.py\`
3. **Group related tests in classes**: Use classes for ViewSet tests, keep service tests as functions
4. **Test names describe behavior**: \`test_expired_subscription_blocks_api_access\` not \`test_subscription_3\`
5. **Arrange-Act-Assert**: Every test follows this structure with clear separation
6. **One assertion concept per test**: Multiple \`assert\` calls are fine if they verify the same behavior
7. **No test interdependence**: Tests must pass in any order — never rely on state from another test

## Coverage Requirements

- **Global minimum**: 85% line coverage
- **billing/ app**: 90% minimum (financial operations are critical)
- **auth/ and accounts/**: 90% minimum (security-sensitive)
- **tenants/**: 90% minimum (isolation is critical)
- **Exclude from coverage**: migrations, admin.py, manage.py, config files

\`\`\`toml
# pyproject.toml
[tool.coverage.run]
source = ["src"]
omit = [
    "*/migrations/*",
    "*/admin.py",
    "*/manage.py",
    "config/*",
    "*/apps.py",
]

[tool.coverage.report]
fail_under = 85
show_missing = true
skip_covered = true
\`\`\`

Run coverage: \`uv run pytest --cov=src --cov-report=term-missing --cov-fail-under=85\`

## Performance Testing Notes

- Use \`pytest-benchmark\` for performance-critical paths (tenant resolution middleware, billing calculations)
- Mark slow tests with \`@pytest.mark.slow\` and exclude from default runs: \`uv run pytest -m "not slow"\`
- Use \`django.test.utils.override_settings\` to test with different cache backends

## What Not to Do

- **Never** use \`django.test.TestCase\` for most tests — use \`pytest\` functions with \`@pytest.mark.django_db\`
- **Never** call real Stripe, AWS, or external APIs in unit tests
- **Never** use \`time.sleep()\` in tests — mock time-dependent behavior
- **Never** hardcode IDs or timestamps — use factories and \`freezegun\`
- **Never** share mutable state between tests via module-level variables
- **Never** test Django/DRF internals — test your business logic and API contracts
- **Never** skip writing tests for error paths — they are often where bugs hide`,

  '.claude/settings.json': `{
  "permissions": {
    "allow": [
      "Bash(uv run ruff check:*)",
      "Bash(uv run ruff format:*)",
      "Bash(uv run mypy:*)",
      "Bash(uv run pytest:*)",
      "Bash(uv run python manage.py check:*)",
      "Bash(uv run python manage.py makemigrations:*)",
      "Bash(uv run python manage.py migrate:*)",
      "Bash(uv run python manage.py showmigrations:*)",
      "Bash(uv run python manage.py shell:*)",
      "Bash(uv run python manage.py test:*)",
      "Bash(uv run python manage.py collectstatic:*)",
      "Bash(uv run python manage.py spectacular:*)",
      "Bash(uv run celery -A config inspect:*)",
      "Bash(uv pip list:*)",
      "Bash(uv pip show:*)",
      "Bash(uv lock:*)",
      "Bash(uv sync:*)",
      "Bash(cat:*)",
      "Bash(find:*)",
      "Bash(grep:*)",
      "Bash(head:*)",
      "Bash(tail:*)",
      "Bash(wc:*)",
      "Bash(ls:*)",
      "Bash(tree:*)",
      "Bash(diff:*)",
      "Bash(sort:*)",
      "Bash(echo:*)",
      "Bash(pwd)",
      "Bash(git status:*)",
      "Bash(git log:*)",
      "Bash(git diff:*)",
      "Bash(git branch:*)",
      "Bash(git show:*)",
      "Bash(git blame:*)",
      "Bash(git stash list:*)",
      "Bash(docker compose ps:*)",
      "Bash(docker compose logs:*)",
      "Read",
      "Write",
      "Edit",
      "MultiEdit",
      "Glob",
      "Grep",
      "TodoRead",
      "TodoWrite",
      "WebFetch",
      "mcp__github__get_issue",
      "mcp__github__list_issues",
      "mcp__github__get_pull_request",
      "mcp__github__list_pull_requests",
      "mcp__github__get_file_contents",
      "mcp__github__search_code",
      "mcp__github__search_issues",
      "mcp__slack__send_message",
      "mcp__slack__list_channels",
      "mcp__notion__search",
      "mcp__notion__get_page",
      "mcp__sentry__get_issue",
      "mcp__sentry__list_issues"
    ],
    "deny": [
      "Bash(rm -rf:*)",
      "Bash(uv run python manage.py flush:*)",
      "Bash(uv run python manage.py dbshell:*)",
      "Bash(uv run python manage.py dumpdata:*)",
      "Bash(uv run python manage.py loaddata:*)",
      "Bash(docker compose down:*)",
      "Bash(docker compose up:*)",
      "Bash(docker compose exec:*)",
      "Bash(celery -A config worker:*)",
      "Bash(celery -A config beat:*)",
      "Bash(git push:*)",
      "Bash(git merge:*)",
      "Bash(git rebase:*)",
      "Bash(git reset --hard:*)",
      "Bash(git checkout main:*)",
      "Bash(curl:*)",
      "Bash(wget:*)",
      "Bash(pip install:*)",
      "Bash(sudo:*)",
      "Bash(ssh:*)",
      "Bash(scp:*)",
      "Bash(aws:*)",
      "Bash(terraform:*)",
      "Bash(kubectl:*)",
      "Bash(stripe:*)",
      "mcp__github__create_pull_request",
      "mcp__github__merge_pull_request",
      "mcp__github__delete_branch",
      "mcp__github__create_release"
    ]
  },
  "env": {
    "DJANGO_SETTINGS_MODULE": "config.settings.development",
    "PYTHONPATH": "src",
    "PYTHONDONTWRITEBYTECODE": "1",
    "CELERY_TASK_ALWAYS_EAGER": "true",
    "STRIPE_TEST_MODE": "true"
  },
  "contextFiles": [
    "CLAUDE.md",
    "pyproject.toml",
    "docs/ARCHITECTURE.md"
  ]
}`,

  '.editorconfig': `root = true

[*]
charset = utf-8
end_of_line = lf
insert_final_newline = true
trim_trailing_whitespace = true
indent_style = space
indent_size = 4

[*.py]
indent_size = 4
max_line_length = 88

[*.pyi]
indent_size = 4
max_line_length = 88

[{*.yml,*.yaml}]
indent_size = 2

[*.html]
indent_size = 2

[*.css]
indent_size = 2

[*.js]
indent_size = 2

[*.json]
indent_size = 2

[*.graphql]
indent_size = 2

[*.toml]
indent_size = 4

[*.md]
trim_trailing_whitespace = false
indent_size = 2

[*.txt]
indent_size = 4

[*.cfg]
indent_size = 4

[*.ini]
indent_size = 4

[Makefile]
indent_style = tab

[Dockerfile*]
indent_size = 4

[docker-compose*.yml]
indent_size = 2

[*.tf]
indent_size = 2

[*.hcl]
indent_size = 2

[.github/**/*.yml]
indent_size = 2

[templates/**/*.html]
indent_size = 2

[*.env*]
indent_size = 4`,

  '.gitattributes': `# Auto detect text files and ensure LF line endings
* text=auto eol=lf

# Python source files
*.py text diff=python eol=lf
*.pyi text diff=python eol=lf
*.pyx text diff=python eol=lf

# Django templates
*.html text diff=html eol=lf
*.txt text eol=lf

# Configuration and data files
*.cfg text eol=lf
*.conf text eol=lf
*.ini text eol=lf
*.toml text eol=lf
*.yaml text diff=yaml eol=lf
*.yml text diff=yaml eol=lf
*.json text eol=lf
*.xml text eol=lf

# Markdown and documentation
*.md text diff=markdown eol=lf
*.rst text eol=lf

# Shell scripts
*.sh text eol=lf
*.bash text eol=lf

# Docker
Dockerfile text eol=lf
docker-compose*.yml text diff=yaml eol=lf
*.dockerignore text eol=lf

# Terraform
*.tf text eol=lf
*.tfvars text eol=lf

# Kubernetes manifests
*.k8s.yml text diff=yaml eol=lf
*.k8s.yaml text diff=yaml eol=lf

# GitHub Actions and templates
.github/**/*.yml text diff=yaml eol=lf
.github/**/*.md text diff=markdown eol=lf

# Claude configuration
CLAUDE.md text diff=markdown eol=lf
.claude/**/*.md text diff=markdown eol=lf
.claude/**/*.json text eol=lf

# Environment files (should not be committed, but enforce LF if they are)
.env* text eol=lf

# CSS and JavaScript (admin customizations, static assets)
*.css text diff=css eol=lf
*.js text eol=lf
*.ts text eol=lf

# SQL migrations
*.sql text eol=lf

# CSV and data fixtures
*.csv text eol=lf

# Requirements and lock files
requirements*.txt text eol=lf
uv.lock text eol=lf
pyproject.toml text eol=lf

# Binary files — do not diff or merge
*.png binary
*.jpg binary
*.jpeg binary
*.gif binary
*.ico binary
*.webp binary
*.woff binary
*.woff2 binary
*.ttf binary
*.eot binary
*.pdf binary
*.zip binary
*.gz binary
*.tar binary
*.sqlite3 binary

# Stripe webhook signing secrets and keys should never be committed
# but mark as binary to prevent accidental diff exposure
*.pem binary
*.key binary

# Generated / compiled Python
*.pyc binary
*.pyo binary
*.egg-info binary

# Export-ignore: exclude from git archive / release tarballs
.github/ export-ignore
.claude/ export-ignore
plugin/ export-ignore
playbook/ export-ignore
tests/ export-ignore
scripts/ export-ignore
docs/ export-ignore
.gitattributes export-ignore
.gitignore export-ignore
.pre-commit-config.yaml export-ignore
.ruff.toml export-ignore
mypy.ini export-ignore
Makefile export-ignore
docker-compose*.yml export-ignore
CLAUDE.md export-ignore

# Linguist overrides — ensure GitHub language detection is accurate
*.html linguist-language=HTML
templates/**/*.html linguist-language=HTML
*.py linguist-language=Python
*.tf linguist-detectable=false
docs/**/*.md linguist-documentation=true
tests/**/*.py linguist-detectable=false`,

  '.github/CODEOWNERS': `# CODEOWNERS — django-saas-platform
# https://docs.github.com/en/repositories/managing-your-repositorys-settings-and-features/customizing-your-repository/about-code-owners
#
# Each line is a file pattern followed by one or more owners.
# Order matters — later rules take precedence.

# ──────────────────────────────────────────────
# Default: require review from backend team
# ──────────────────────────────────────────────
*                                   @django-saas-platform/backend

# ──────────────────────────────────────────────
# Billing (Stripe integration, subscriptions, invoicing, usage metering)
# SOC 2 / GDPR sensitive — requires billing lead + platform lead approval
# ──────────────────────────────────────────────
src/billing/                        @django-saas-platform/billing-leads @django-saas-platform/platform-leads
tests/billing/                      @django-saas-platform/billing-leads @django-saas-platform/platform-leads

# ──────────────────────────────────────────────
# Authentication & authorization
# Security-sensitive — requires platform lead approval
# ──────────────────────────────────────────────
src/accounts/                       @django-saas-platform/platform-leads @django-saas-platform/security
tests/accounts/                     @django-saas-platform/platform-leads @django-saas-platform/security

# ──────────────────────────────────────────────
# Multi-tenancy (tenant isolation, row-level security, middleware)
# Data isolation is critical for SOC 2 compliance
# ──────────────────────────────────────────────
src/tenants/                        @django-saas-platform/platform-leads
src/core/                           @django-saas-platform/platform-leads
tests/tenants/                      @django-saas-platform/platform-leads
tests/core/                         @django-saas-platform/platform-leads

# ──────────────────────────────────────────────
# Production configuration & infrastructure
# Deployment-critical — requires platform lead approval
# ──────────────────────────────────────────────
config/production/                  @django-saas-platform/platform-leads @django-saas-platform/devops
config/staging/                     @django-saas-platform/platform-leads @django-saas-platform/devops

# ──────────────────────────────────────────────
# Django settings (all environments)
# ──────────────────────────────────────────────
config/                             @django-saas-platform/platform-leads

# ──────────────────────────────────────────────
# Celery tasks (billing sync, reports, webhooks)
# ──────────────────────────────────────────────
src/tasks/                          @django-saas-platform/backend @django-saas-platform/platform-leads

# ──────────────────────────────────────────────
# API layer (DRF viewsets, Strawberry GraphQL, serializers)
# ──────────────────────────────────────────────
src/api/                            @django-saas-platform/backend

# ──────────────────────────────────────────────
# CI/CD, GitHub Actions, deployment workflows
# ──────────────────────────────────────────────
.github/                            @django-saas-platform/platform-leads @django-saas-platform/devops
Dockerfile                          @django-saas-platform/devops @django-saas-platform/platform-leads
docker-compose*.yml                 @django-saas-platform/devops
terraform/                          @django-saas-platform/devops @django-saas-platform/platform-leads
k8s/                                @django-saas-platform/devops @django-saas-platform/platform-leads

# ──────────────────────────────────────────────
# Environment & secrets (should never contain actual secrets)
# ──────────────────────────────────────────────
.env*                               @django-saas-platform/platform-leads @django-saas-platform/security

# ──────────────────────────────────────────────
# Claude Code configuration & AI tooling
# ──────────────────────────────────────────────
CLAUDE.md                           @django-saas-platform/platform-leads
.claude/                            @django-saas-platform/platform-leads
plugin/                             @django-saas-platform/platform-leads

# ──────────────────────────────────────────────
# Dependency management
# Review new dependencies per project policy
# ──────────────────────────────────────────────
pyproject.toml                      @django-saas-platform/platform-leads @django-saas-platform/backend
uv.lock                             @django-saas-platform/platform-leads
requirements*.txt                   @django-saas-platform/platform-leads

# ──────────────────────────────────────────────
# Database migrations — require careful review
# ──────────────────────────────────────────────
**/migrations/                      @django-saas-platform/platform-leads @django-saas-platform/backend

# ──────────────────────────────────────────────
# Documentation
# ──────────────────────────────────────────────
docs/                               @django-saas-platform/backend
playbook/                           @django-saas-platform/platform-leads
scripts/                            @django-saas-platform/devops @django-saas-platform/backend`,

  '.github/ISSUE_TEMPLATE/ai_task.md': `---
name: AI Task (Claude Code)
about: Structured task for Claude Code to implement in the django-saas-platform
title: "[AI] "
labels: ai-task, claude-code
assignees: ''
---

## Task Context

**Ticket ID**: SAAS-
**Priority**: <!-- critical | high | medium | low -->
**Estimated Complexity**: <!-- trivial | small | medium | large | x-large -->
**Django App(s)**: <!-- e.g., billing, tenants, accounts, api, notifications, tasks, core -->
**Sensitive Path**: <!-- yes/no — if touching billing/, auth/, config/production/, .env* files -->

## Task Type

<!-- Check one -->
- [ ] New feature
- [ ] Bug fix
- [ ] Refactor
- [ ] Performance optimization
- [ ] Security fix
- [ ] Database migration
- [ ] Celery task
- [ ] Stripe integration
- [ ] API endpoint (REST)
- [ ] API endpoint (GraphQL)
- [ ] Test coverage improvement
- [ ] Documentation

## Description

<!-- Clear, specific description of what needs to be done. Include business context for SaaS/tenant implications. -->

## Requirements

### Functional Requirements

1. <!-- Requirement 1 -->
2. <!-- Requirement 2 -->

### Non-Functional Requirements

- [ ] Must respect tenant isolation (all queries through tenant-aware manager)
- [ ] Must be idempotent (if Celery task or webhook handler)
- [ ] Must include OpenAPI schema annotations (if API endpoint)
- [ ] Must comply with GDPR data handling requirements
- [ ] Must maintain SOC 2 audit logging

## Multi-Tenancy Considerations

<!-- How does this interact with tenant isolation? Does it access tenant-scoped data? Does it need row-level security policies? -->

**Tenant Scope**: <!-- tenant-scoped | cross-tenant (admin only) | system-level -->
**Data Access Pattern**: <!-- read-only | read-write | write-only -->

## Technical Specification

### Files to Create or Modify

| File Path | Action | Description |
|-----------|--------|-------------|
| \`src/\` | create/modify | |
| \`tests/\` | create/modify | |

### Models

<!-- If new models or model changes are needed, describe fields, constraints, indexes -->

\`\`\`python
# Example model sketch (optional)
\`\`\`

### API Contract

<!-- If this involves API endpoints, specify the contract -->

**Endpoint**: \`<!-- e.g., /api/v1/tenants/{tenant_id}/subscriptions/ -->\`
**Method**: \`<!-- GET | POST | PUT | PATCH | DELETE -->\`
**Auth**: \`<!-- JWT | API Key | Session | Public -->\`
**Permissions**: \`<!-- e.g., IsTenantAdmin, IsBillingManager -->\`

Request:
\`\`\`json
{}
\`\`\`

Response:
\`\`\`json
{}
\`\`\`

### Celery Task Details

<!-- If this involves a Celery task -->

**Task Name**: \`<!-- e.g., tasks.billing.sync_stripe_subscription -->\`
**Queue**: \`<!-- default | billing | notifications | reports -->\`
**Retry Policy**: \`<!-- max_retries, retry_backoff, retry_jitter -->\`
**Idempotency Key**: \`<!-- How is idempotency ensured? -->\`
**Schedule**: \`<!-- If periodic: crontab or interval -->\`

### Stripe Integration Details

<!-- If this involves Stripe -->

**Stripe Objects**: \`<!-- e.g., Subscription, Invoice, PaymentIntent, UsageRecord -->\`
**Webhook Events**: \`<!-- e.g., invoice.payment_succeeded, customer.subscription.updated -->\`
**Idempotency**: \`<!-- How are duplicate webhook deliveries handled? -->\`

## Acceptance Criteria

<!-- Specific, testable criteria. Claude Code will use these to validate the implementation. -->

- [ ] <!-- Criterion 1 -->
- [ ] <!-- Criterion 2 -->
- [ ] All new public functions have type hints
- [ ] All new API endpoints have drf-spectacular schema decorators
- [ ] Unit tests written with pytest and factory_boy (≥85% coverage for new code)
- [ ] No ruff lint violations (\`uv run ruff check src/\`)
- [ ] No mypy errors (\`uv run mypy src/\`)
- [ ] All tests pass (\`uv run pytest\`)
- [ ] Files stay under 300 lines (split if needed)
- [ ] Conventional commit messages used

## Database Migration Notes

<!-- If schema changes are involved -->

- [ ] Migration is reversible
- [ ] Migration is safe for zero-downtime deployment
- [ ] Row-level security policies updated (if tenant-scoped table)
- [ ] Indexes added for query patterns
- [ ] No destructive changes without data migration plan

## Dependencies

**Blocked By**: <!-- Other tickets that must be completed first -->
**Blocks**: <!-- Tickets that depend on this -->
**New Packages**: <!-- Any new Python packages needed — must be reviewed per dependency policy -->

## Reference Materials

<!-- Links to relevant docs, ADRs, existing code, Stripe docs, Django docs -->

- [ ] <!-- Link 1 -->
- [ ] <!-- Link 2 -->

## Claude Code Instructions

<!-- Specific instructions for Claude Code when picking up this task -->

### Branch

\`\`\`
feat/SAAS-<ticket_number>-<short-description>
\`\`\`

### Implementation Order

1. <!-- Step 1: e.g., Create model in src/billing/models.py -->
2. <!-- Step 2: e.g., Add tenant-aware manager -->
3. <!-- Step 3: e.g., Create serializer and viewset -->
4. <!-- Step 4: e.g., Write Celery task -->
5. <!-- Step 5: e.g., Add tests -->
6. <!-- Step 6: e.g., Generate and review migration -->

### Verification Commands

\`\`\`bash
# Lint
uv run ruff check src/
uv run ruff format --check src/

# Type check
uv run mypy src/

# Run tests for affected app
uv run pytest tests/<app>/ -v --cov=src/<app> --cov-fail-under=85

# Run full test suite
uv run pytest

# Check migration
uv run python manage.py makemigrations --check --dry-run
uv run python manage.py migrate --plan

# Verify OpenAPI schema (if API changes)
uv run python manage.py spectacular --validate
\`\`\`

### Constraints

- Do NOT modify files outside the specified Django app(s) without noting it in the PR
- Do NOT add new dependencies without listing them in the PR description
- Do NOT bypass tenant isolation — all data queries must use the tenant-aware manager
- Do NOT store secrets or PII in logs
- Mark all AI-generated code with \`# AI-generated\` comment at the top of new files
- Follow the service layer pattern — avoid business logic in views or serializers
- Use explicit service calls over Django signals`,

  '.github/ISSUE_TEMPLATE/bug_report.md': `---
name: Bug Report
title: "[BUG] "
labels: ["bug", "triage"]
assignees: []
---

## Bug Description

<!-- A clear and concise description of the bug. -->

## Environment

- **Environment**: <!-- staging / production / local -->
- **Django Version**: <!-- e.g., 5.0.x -->
- **Python Version**: <!-- e.g., 3.12.x -->
- **Browser (if applicable)**: <!-- e.g., Chrome 120 -->
- **OS**: <!-- e.g., macOS 14, Ubuntu 22.04 -->
- **Deployment**: <!-- e.g., ECS, local Docker, bare metal -->

## SaaS Context

- **Tenant ID**: <!-- UUID of the affected tenant, or "N/A" for platform-level bugs -->
- **Tenant Slug**: <!-- e.g., acme-corp -->
- **Subscription Plan**: <!-- free / starter / professional / enterprise -->
- **User Role**: <!-- owner / admin / member / viewer -->
- **Is White-Label**: <!-- yes / no -->
- **Affected Tenants Count**: <!-- 1 / multiple / all -->

## Billing Context (if billing-related)

- **Stripe Customer ID**: <!-- cus_xxx — do NOT include full payment details -->
- **Stripe Subscription ID**: <!-- sub_xxx -->
- **Invoice ID (if applicable)**: <!-- in_xxx -->
- **Webhook Event ID (if applicable)**: <!-- evt_xxx -->
- **Metering Issue**: <!-- yes / no — describe usage discrepancy if yes -->

## Celery / Background Task Context (if task-related)

- **Task Name**: <!-- e.g., tasks.billing.sync_stripe_subscriptions -->
- **Task ID**: <!-- Celery task UUID if available -->
- **Task Status**: <!-- pending / started / retry / failure -->
- **Queue**: <!-- default / billing / notifications / reports -->
- **Retry Count**: <!-- number of retries before failure -->
- **Worker Node**: <!-- if known, e.g., worker-2 -->
- **Beat Schedule**: <!-- if periodic task, the crontab or interval -->

## Steps to Reproduce

1. <!-- Step 1 -->
2. <!-- Step 2 -->
3. <!-- Step 3 -->

## Expected Behavior

<!-- What you expected to happen. -->

## Actual Behavior

<!-- What actually happened. Include error messages verbatim. -->

## API Details (if API-related)

- **Endpoint**: <!-- e.g., POST /api/v1/tenants/{id}/members/ -->
- **API Type**: <!-- REST / GraphQL -->
- **HTTP Status Code**: <!-- e.g., 500, 403, 422 -->
- **Request Payload** (sanitized):

\`\`\`json

\`\`\`

- **Response Body** (sanitized):

\`\`\`json

\`\`\`

## Error Details

- **Sentry Issue Link**: <!-- https://sentry.io/organizations/xxx/issues/xxx/ -->
- **Error Type**: <!-- e.g., TenantPermissionError, StripeWebhookError, CeleryTaskRetryExhausted -->
- **Traceback** (sanitized — remove secrets, tokens, PII):

\`\`\`
Paste traceback here
\`\`\`

## Database / Query Context (if applicable)

- **Affected Model(s)**: <!-- e.g., tenants.Tenant, billing.Subscription -->
- **Row-Level Security Bypass**: <!-- Did the bug expose data across tenant boundaries? yes / no -->
- **Migration Related**: <!-- yes / no — include migration name if yes -->

## Logs

<!-- Paste relevant log snippets. REMOVE all secrets, API keys, tokens, and PII before pasting. -->

\`\`\`
Paste logs here
\`\`\`

## Screenshots / Recordings

<!-- Attach screenshots or screen recordings if applicable. Redact any PII or tenant data. -->

## Impact Assessment

- **Severity**: <!-- critical / high / medium / low -->
- **Data Leak Risk**: <!-- yes / no — if yes, escalate immediately per SOC 2 incident response -->
- **Cross-Tenant Impact**: <!-- Does this affect tenant data isolation? yes / no -->
- **Revenue Impact**: <!-- Does this affect billing accuracy or subscription state? yes / no -->
- **Users Affected**: <!-- approximate count or percentage -->

## GDPR / Compliance Notes

<!-- If this bug involves personal data exposure, data residency violation, or consent issues, note it here. Tag @security-team immediately for any data breach. -->

- **Personal Data Involved**: <!-- yes / no -->
- **Data Residency Affected**: <!-- yes / no — specify region if yes -->
- **Requires DPA Notification**: <!-- yes / no / unknown -->

## Possible Root Cause

<!-- If you have a hypothesis, describe it. Reference specific files, services, or patterns. -->

## Suggested Fix

<!-- Optional: link to code, describe the approach, or reference similar past fixes. -->

## Workaround

<!-- Is there a temporary workaround? Describe it for the team and affected tenants. -->

## Checklist

- [ ] I have searched existing issues for duplicates
- [ ] I have removed all secrets, API keys, and tokens from this report
- [ ] I have removed or redacted all PII and tenant-sensitive data
- [ ] I have included the Sentry link (if an error was captured)
- [ ] I have tagged \`@security-team\` if this involves cross-tenant data exposure
- [ ] I have set the correct severity label`,

  '.github/ISSUE_TEMPLATE/feature_request.md': `---
name: Feature Request
about: Propose a new feature for the django-saas-platform
title: "feat: "
labels: ["enhancement", "triage"]
assignees: []
---

## Summary

<!-- One-sentence description of the feature. -->

## Problem Statement

<!-- What problem does this solve? Who is affected? Link to customer feedback, support tickets, or analytics if available. -->

## Proposed Solution

<!-- Describe the desired behavior. Be specific about user-facing changes and system behavior. -->

## SaaS Context

### Affected Domain

<!-- Check all that apply -->

- [ ] Tenant management / onboarding
- [ ] Authentication / RBAC
- [ ] Billing / Subscriptions (Stripe)
- [ ] Usage metering
- [ ] API (REST / GraphQL)
- [ ] Notifications (email, in-app, webhooks)
- [ ] Background tasks (Celery)
- [ ] Admin / white-label
- [ ] Reporting / analytics
- [ ] Other: <!-- specify -->

### Multi-Tenancy Impact

<!-- How does this feature interact with tenant isolation? Does it require changes to row-level security policies, tenant-aware managers, or cross-tenant data access? -->

- [ ] Tenant-scoped (data isolated per tenant)
- [ ] Platform-wide (applies across all tenants)
- [ ] Cross-tenant (requires explicit data sharing controls)
- [ ] N/A

### Billing / Subscription Impact

<!-- Does this feature affect Stripe integration, plan tiers, usage metering, or invoicing? -->

- [ ] New billable feature (requires plan gating)
- [ ] Changes to usage metering
- [ ] New Stripe webhook handler needed
- [ ] Changes to subscription lifecycle
- [ ] No billing impact

### Plan Availability

<!-- Which subscription tiers should have access? -->

- [ ] Free
- [ ] Starter
- [ ] Professional
- [ ] Enterprise
- [ ] All plans

## API Design

<!-- If this feature exposes new API endpoints, outline them here. All endpoints must have OpenAPI schema via drf-spectacular. -->

### REST Endpoints

\`\`\`
# Example:
# POST   /api/v1/tenants/{tenant_id}/widgets/
# GET    /api/v1/tenants/{tenant_id}/widgets/{id}/
\`\`\`

### GraphQL Schema Changes

\`\`\`graphql
# Example:
# type Widget {
#   id: ID!
#   name: String!
# }
\`\`\`

## Data Model Changes

<!-- Describe new models, fields, or migrations. All tenant-scoped models must use the tenant-aware manager. -->

\`\`\`python
# Example:
# class Widget(TenantScopedModel):
#     name = models.CharField(max_length=255)
#     ...
\`\`\`

## Background Tasks

<!-- Does this feature require Celery tasks? All tasks must be idempotent. -->

- [ ] New Celery task(s) required
- [ ] Periodic task (Celery Beat schedule)
- [ ] No background processing needed

<!-- If yes, describe the task(s): -->

## Compliance & Security

### GDPR Considerations

- [ ] Processes personal data (requires consent tracking)
- [ ] Requires data export support (right of access)
- [ ] Requires data deletion support (right to erasure)
- [ ] Data residency implications
- [ ] DPA updates needed
- [ ] No GDPR impact

### SOC 2 Considerations

- [ ] Changes to authentication or authorization
- [ ] New audit log events required
- [ ] Changes to data encryption (at rest or in transit)
- [ ] New third-party integration (vendor review needed)
- [ ] No SOC 2 impact

### Security Review

- [ ] Touches sensitive paths (\`billing/\`, \`auth/\`, \`config/production/\`)
- [ ] Requires security team review
- [ ] No elevated security concerns

## Affected Django Apps

<!-- Check all apps that will need changes. Each app is self-contained with its own models, serializers, views, and tests. -->

- [ ] \`src/accounts/\`
- [ ] \`src/tenants/\`
- [ ] \`src/billing/\`
- [ ] \`src/api/\`
- [ ] \`src/core/\`
- [ ] \`src/notifications/\`
- [ ] \`src/tasks/\`
- [ ] \`src/utils/\`
- [ ] New app required: <!-- name -->

## Implementation Notes

<!-- Architecture guidance, service layer patterns, signals vs explicit calls, caching strategy, etc. Prefer explicit service layer calls over Django signals. -->

## Alternatives Considered

<!-- What other approaches were evaluated? Why were they rejected? -->

## Dependencies

<!-- New Python packages, external services, infrastructure changes. New dependencies require team review per our moderate dependency policy. -->

- [ ] New Python package(s): <!-- list with justification -->
- [ ] New external service: <!-- name and purpose -->
- [ ] Infrastructure changes (Terraform): <!-- describe -->
- [ ] No new dependencies

## Acceptance Criteria

<!-- Specific, testable criteria. Use factory_boy for test fixtures. Target 85% coverage on new code. -->

- [ ] <!-- Criterion 1 -->
- [ ] <!-- Criterion 2 -->
- [ ] <!-- Criterion 3 -->
- [ ] Unit tests passing (\`uv run pytest tests/\`)
- [ ] Type checks passing (\`uv run mypy src/\`)
- [ ] OpenAPI schema updated (if API changes)
- [ ] Documentation updated in \`docs/\`

## Mockups / Diagrams

<!-- Attach wireframes, sequence diagrams, or architecture diagrams if applicable. -->

## Estimated Effort

- [ ] Small (1-2 days)
- [ ] Medium (3-5 days)
- [ ] Large (1-2 weeks)
- [ ] X-Large (2+ weeks, consider breaking into smaller issues)

## Related Issues

<!-- Link to related issues, epics, or PRs. -->`,

  '.github/PULL_REQUEST_TEMPLATE.md': `## Description

<!-- Provide a clear summary of what this PR does and why. Link to the relevant GitHub Issue. -->

Resolves #<!-- issue number -->

### What changed

-

### Why

-

---

## Type of Change

- [ ] \`feat\` — New feature
- [ ] \`fix\` — Bug fix
- [ ] \`refactor\` — Code restructuring (no behavior change)
- [ ] \`chore\` — Build, CI, dependency, or tooling update
- [ ] \`docs\` — Documentation only
- [ ] \`test\` — Adding or updating tests
- [ ] \`perf\` — Performance improvement
- [ ] \`security\` — Security fix or hardening

---

## Checklist

### General

- [ ] Branch follows naming convention: \`type/SAAS-XX-short-desc\`
- [ ] Commits follow [Conventional Commits](https://www.conventionalcommits.org/) (\`feat:\`, \`fix:\`, etc.)
- [ ] PR title matches conventional commit format
- [ ] Self-reviewed my own code
- [ ] No commented-out code, debug prints, or \`TODO\`s without a linked issue
- [ ] Files stay under 300 lines; large files are split into focused modules
- [ ] Type hints added to all new/modified public functions

### Testing

- [ ] New/updated tests cover the changes (\`uv run pytest\`)
- [ ] Coverage remains ≥ 85% (\`uv run pytest --cov\`)
- [ ] Integration tests added for new API endpoints or Celery tasks
- [ ] Factory Boy factories created/updated for new models
- [ ] Tests pass locally: \`uv run pytest tests/\`

### Linting & Type Checking

- [ ] \`uv run ruff check src/\` passes with no errors
- [ ] \`uv run ruff format --check src/\` passes
- [ ] \`uv run mypy src/\` passes in strict mode

### API Changes

- [ ] OpenAPI schema updated via \`drf-spectacular\` decorators (\`@extend_schema\`)
- [ ] Strawberry GraphQL schema updated if applicable
- [ ] API versioning considered (breaking changes require version bump)
- [ ] API documentation in \`docs/\` updated

---

## Database & Migrations

<!-- Check all that apply. Migration changes require extra review. -->

- [ ] No database changes
- [ ] New migration(s) added (\`uv run python manage.py makemigrations\`)
- [ ] Migration is backwards-compatible (no destructive column drops without a multi-step plan)
- [ ] Migration tested against a copy of staging data
- [ ] Data migration included (if backfilling or transforming existing rows)
- [ ] Indexes reviewed for new query patterns
- [ ] Row-level security policies updated in \`tenants/\` if new tenant-scoped models added

---

## Multi-Tenancy & Data Isolation

<!-- Required for any change touching tenant-scoped data. SOC 2 / GDPR compliance. -->

- [ ] Not applicable — change does not touch tenant data
- [ ] All new querysets use the tenant-aware manager (\`TenantManager\`) — no raw \`objects.all()\`
- [ ] Tenant context verified in middleware or view before data access
- [ ] No cross-tenant data leakage possible (verified with multi-tenant test fixtures)
- [ ] Row-level security policies reviewed if touching PostgreSQL directly
- [ ] Admin/superuser endpoints explicitly scoped or excluded from tenant filtering

---

## Billing & Stripe Changes

<!-- Required for any change in src/billing/ or Stripe webhook handling. -->

- [ ] Not applicable — no billing changes
- [ ] Stripe webhook handler is **idempotent** (safe to receive duplicate events)
- [ ] Webhook signature verification (\`stripe.Webhook.construct_event\`) is in place
- [ ] Subscription lifecycle transitions tested (create → upgrade → downgrade → cancel)
- [ ] Usage metering records are accurate and deduplicated
- [ ] Stripe test mode used for all test/staging environments
- [ ] No Stripe secret keys in code — all via \`django-environ\` / environment variables
- [ ] Invoice and payment failure edge cases handled
- [ ] Changes tested against Stripe CLI (\`stripe listen --forward-to\`)

---

## Celery Task Changes

<!-- Required for any change in src/tasks/ or task-calling code. -->

- [ ] Not applicable — no task changes
- [ ] Tasks are **idempotent** (safe to retry without side effects)
- [ ] \`acks_late=True\` and \`reject_on_worker_lost=True\` set where appropriate
- [ ] Task timeouts (\`soft_time_limit\`, \`time_limit\`) configured
- [ ] Retry policy defined with exponential backoff (\`autoretry_for\`, \`retry_backoff\`)
- [ ] Beat schedule updated in \`config/celery.py\` if adding periodic tasks
- [ ] Task tested with \`task.apply()\` in pytest (synchronous execution)

---

## Security & Compliance

<!-- Required for changes in src/accounts/, src/billing/, config/production/, or .env files. -->

- [ ] Not applicable — no security-sensitive changes
- [ ] No secrets, API keys, or PII in code or logs
- [ ] Authentication/authorization checks in place for new endpoints
- [ ] RBAC permissions verified (tenant admin vs. member vs. superuser)
- [ ] Audit log entries added for sensitive operations (\`core.audit\`)
- [ ] GDPR considerations addressed (consent, data minimization, right to deletion)
- [ ] Input validation and sanitization applied
- [ ] Rate limiting configured for public-facing endpoints
- [ ] CODEOWNERS notified for changes to sensitive paths (\`**/billing/**\`, \`**/auth/**\`, \`config/production/**\`)

---

## GDPR & Data Privacy

- [ ] Not applicable — no PII or personal data changes
- [ ] Personal data fields documented in data inventory
- [ ] Data retention policy applied (auto-expiry or cleanup task)
- [ ] User consent captured before processing (if new data collection)
- [ ] Right-to-deletion supported for new personal data fields
- [ ] Data export includes new fields (\`accounts.export_user_data\`)
- [ ] Cross-border data transfer considerations reviewed

---

## Deployment Notes

<!-- Anything the on-call or deployer needs to know. -->

- [ ] No special deployment steps required
- [ ] Environment variables added/changed (listed below)
- [ ] Feature flag required for gradual rollout
- [ ] Migration must run before deploy (\`uv run python manage.py migrate\`)
- [ ] Celery workers must be restarted
- [ ] Cache invalidation required
- [ ] Runbook updated in \`docs/runbooks/\`

**New environment variables:**

| Variable | Description | Required | Default |
|----------|-------------|----------|---------|
|          |             |          |         |

---

## AI-Generated Code Disclosure

<!-- SOC 2 audit trail: disclose any AI-assisted code generation. -->

- [ ] **No AI-generated code** in this PR
- [ ] **AI-assisted code included** — details below

**If AI-assisted, complete the following:**

- **Tool used**: <!-- e.g., Claude Code, GitHub Copilot -->
- **Files/functions generated or substantially modified by AI**:
  -
- **Human review performed**: [ ] Yes — all AI output reviewed, tested, and understood
- **Modifications made to AI output**: <!-- Describe what you changed and why -->

> ⚠️ All AI-generated code must be fully reviewed, tested, and understood by the author before submission. The author assumes full responsibility for correctness, security, and compliance.

---

## Screenshots / Logs

<!-- If applicable, add screenshots, API response samples, or relevant log output. -->

---

## Reviewer Notes

<!-- Anything specific you'd like reviewers to focus on? -->

-`,

  '.github/workflows/ai-code-audit.yml': `name: AI Code Audit

on:
  schedule:
    # Run every Monday at 06:00 UTC (overlaps EU morning / Americas late night)
    - cron: '0 6 * * 1'
  workflow_dispatch:
    inputs:
      focus_area:
        description: 'Audit focus area'
        required: false
        type: choice
        options:
          - full
          - tenant-isolation
          - billing-security
          - authentication
          - api-security
          - data-privacy
          - celery-tasks
        default: full
      paths:
        description: 'Specific paths to audit (comma-separated, e.g. src/billing/,src/tenants/)'
        required: false
        type: string

permissions:
  contents: read
  issues: write
  pull-requests: read
  security-events: write

env:
  PYTHON_VERSION: '3.12'
  AUDIT_LABEL: 'ai-audit'

jobs:
  prepare-audit:
    name: Prepare Audit Scope
    runs-on: ubuntu-latest
    outputs:
      audit_paths: \${{ steps.scope.outputs.paths }}
      audit_focus: \${{ steps.scope.outputs.focus }}
      recent_prs: \${{ steps.recent-changes.outputs.prs }}
      changed_files: \${{ steps.recent-changes.outputs.files }}
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Determine audit scope
        id: scope
        run: |
          FOCUS="\${{ github.event.inputs.focus_area || 'full' }}"
          echo "focus=\${FOCUS}" >> "$GITHUB_OUTPUT"

          if [[ -n "\${{ github.event.inputs.paths }}" ]]; then
            echo "paths=\${{ github.event.inputs.paths }}" >> "$GITHUB_OUTPUT"
          else
            case "\${FOCUS}" in
              tenant-isolation)
                echo "paths=src/tenants/,src/core/,config/" >> "$GITHUB_OUTPUT"
                ;;
              billing-security)
                echo "paths=src/billing/,src/tasks/" >> "$GITHUB_OUTPUT"
                ;;
              authentication)
                echo "paths=src/accounts/,src/core/permissions.py,src/core/middleware/" >> "$GITHUB_OUTPUT"
                ;;
              api-security)
                echo "paths=src/api/,src/core/permissions.py" >> "$GITHUB_OUTPUT"
                ;;
              data-privacy)
                echo "paths=src/accounts/,src/tenants/,src/billing/,src/notifications/" >> "$GITHUB_OUTPUT"
                ;;
              celery-tasks)
                echo "paths=src/tasks/,src/billing/tasks.py,src/notifications/tasks.py" >> "$GITHUB_OUTPUT"
                ;;
              full)
                echo "paths=src/,config/" >> "$GITHUB_OUTPUT"
                ;;
            esac
          fi

      - name: Gather recent changes
        id: recent-changes
        env:
          GH_TOKEN: \${{ secrets.GITHUB_TOKEN }}
        run: |
          # Get PRs merged in the last 7 days
          RECENT_PRS=$(gh pr list \\
            --state merged \\
            --base main \\
            --json number,title,mergedAt,author \\
            --jq '[.[] | select(.mergedAt >= (now - 604800 | strftime("%Y-%m-%dT%H:%M:%SZ")))] | map("#\\(.number) \\(.title) (@\\(.author.login))") | join("\\n")')
          echo "prs<<EOF" >> "$GITHUB_OUTPUT"
          echo "\${RECENT_PRS}" >> "$GITHUB_OUTPUT"
          echo "EOF" >> "$GITHUB_OUTPUT"

          # Get files changed in the last 7 days
          CHANGED=$(git log --since="7 days ago" --name-only --pretty=format: -- src/ config/ | sort -u | grep -v '^$' | head -100)
          echo "files<<EOF" >> "$GITHUB_OUTPUT"
          echo "\${CHANGED}" >> "$GITHUB_OUTPUT"
          echo "EOF" >> "$GITHUB_OUTPUT"

  audit-tenant-isolation:
    name: Audit Tenant Isolation
    needs: prepare-audit
    if: contains(fromJSON('["full","tenant-isolation"]'), needs.prepare-audit.outputs.audit_focus)
    runs-on: ubuntu-latest
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Set up Python
        uses: actions/setup-python@v5
        with:
          python-version: \${{ env.PYTHON_VERSION }}

      - name: Install uv
        uses: astral-sh/setup-uv@v4

      - name: Install dependencies
        run: uv sync --frozen

      - name: Static analysis — unscoped queries
        id: unscoped-queries
        run: |
          echo "## Tenant Isolation — Unscoped Query Detection" > tenant_report.md
          echo "" >> tenant_report.md

          # Find direct model .objects.all() / .objects.filter() calls that bypass tenant manager
          VIOLATIONS=""
          while IFS= read -r pyfile; do
            # Skip migrations, tests, and management commands
            if echo "$pyfile" | grep -qE '(migrations/|tests/|management/commands/)'; then
              continue
            fi
            # Look for raw .objects. usage on tenant-scoped models without tenant filtering
            HITS=$(grep -n '\\.objects\\.\\(all\\|filter\\|get\\|exclude\\|create\\|update\\|delete\\|bulk_create\\|bulk_update\\)' "$pyfile" 2>/dev/null || true)
            if [[ -n "$HITS" ]]; then
              VIOLATIONS="\${VIOLATIONS}\\n### \${pyfile}\\n\\\`\\\`\\\`\\n\${HITS}\\n\\\`\\\`\\\`\\n"
            fi
          done < <(find src/ -name '*.py' -not -path '*/migrations/*')

          if [[ -n "$VIOLATIONS" ]]; then
            echo "⚠️ **Potential unscoped queries found.** Verify these use the tenant-aware manager:" >> tenant_report.md
            echo -e "$VIOLATIONS" >> tenant_report.md
          else
            echo "✅ No obvious unscoped query patterns detected." >> tenant_report.md
          fi

          echo "" >> tenant_report.md

      - name: Static analysis — cross-tenant data leaks
        run: |
          echo "## Cross-Tenant Data Leak Patterns" >> tenant_report.md
          echo "" >> tenant_report.md

          # Check for views/serializers that don't reference tenant context
          SUSPECT_VIEWS=""
          while IFS= read -r pyfile; do
            if echo "$pyfile" | grep -qE '(tests/|migrations/)'; then
              continue
            fi
            # Views that inherit from DRF but don't reference request.tenant or get_queryset
            if grep -lq 'class.*ViewSet\\|class.*APIView' "$pyfile" 2>/dev/null; then
              if ! grep -q 'request\\.tenant\\|self\\.request\\.tenant\\|get_queryset\\|TenantMixin\\|tenant_aware' "$pyfile" 2>/dev/null; then
                SUSPECT_VIEWS="\${SUSPECT_VIEWS}\\n- \${pyfile}"
              fi
            fi
          done < <(find src/ -name 'views*.py' -o -name 'viewsets*.py')

          if [[ -n "$SUSPECT_VIEWS" ]]; then
            echo "⚠️ **Views without apparent tenant scoping:**" >> tenant_report.md
            echo -e "$SUSPECT_VIEWS" >> tenant_report.md
          else
            echo "✅ All views appear to reference tenant context." >> tenant_report.md
          fi

          echo "" >> tenant_report.md

      - name: Check RLS policies
        run: |
          echo "## Row-Level Security Policy Check" >> tenant_report.md
          echo "" >> tenant_report.md

          # Verify migration files contain RLS setup for tenant-scoped models
          RLS_MIGRATIONS=$(grep -rl 'CREATE POLICY\\|ALTER TABLE.*ENABLE ROW LEVEL SECURITY\\|row_level_security' src/*/migrations/*.py 2>/dev/null || true)
          if [[ -n "$RLS_MIGRATIONS" ]]; then
            echo "✅ RLS policies found in migrations:" >> tenant_report.md
            echo "\\\`\\\`\\\`" >> tenant_report.md
            echo "$RLS_MIGRATIONS" >> tenant_report.md
            echo "\\\`\\\`\\\`" >> tenant_report.md
          else
            echo "⚠️ **No RLS policy migrations detected.** Ensure PostgreSQL row-level security is configured for tenant-scoped tables." >> tenant_report.md
          fi

          echo "" >> tenant_report.md

      - name: Upload tenant isolation report
        uses: actions/upload-artifact@v4
        with:
          name: tenant-isolation-report
          path: tenant_report.md

  audit-billing-security:
    name: Audit Billing & Stripe Security
    needs: prepare-audit
    if: contains(fromJSON('["full","billing-security"]'), needs.prepare-audit.outputs.audit_focus)
    runs-on: ubuntu-latest
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Stripe webhook verification
        id: webhook-check
        run: |
          echo "## Billing & Stripe Security Audit" > billing_report.md
          echo "" >> billing_report.md

          # Check webhook signature verification
          WEBHOOK_FILES=$(find src/billing/ -name '*.py' | xargs grep -l 'webhook\\|stripe_event\\|endpoint_secret' 2>/dev/null || true)
          if [[ -n "$WEBHOOK_FILES" ]]; then
            echo "### Webhook Handlers Found" >> billing_report.md
            for f in $WEBHOOK_FILES; do
              echo "#### \${f}" >> billing_report.md
              if grep -q 'construct_event\\|verify_header\\|Webhook.construct_event' "$f"; then
                echo "✅ Signature verification detected." >> billing_report.md
              else
                echo "🚨 **No Stripe signature verification found!** Webhook endpoints MUST call \\\`stripe.Webhook.construct_event()\\\`." >> billing_report.md
              fi

              # Check idempotency
              if grep -q 'idempotency\\|processed_events\\|event\\.id\\|StripeEvent\\|already.*processed' "$f"; then
                echo "✅ Idempotency handling detected." >> billing_report.md
              else
                echo "⚠️ **No idempotency guard detected.** Webhook handlers must be idempotent." >> billing_report.md
              fi
              echo "" >> billing_report.md
            done
          else
            echo "ℹ️ No webhook handler files found in src/billing/." >> billing_report.md
          fi

      - name: Check for hardcoded Stripe keys
        run: |
          echo "### Hardcoded Secrets Check" >> billing_report.md
          echo "" >> billing_report.md

          # Search for Stripe key patterns
          LEAKED=$(grep -rn 'sk_live_\\|sk_test_\\|rk_live_\\|rk_test_\\|whsec_' src/ config/ --include='*.py' 2>/dev/null | grep -v '\\.pyc' || true)
          if [[ -n "$LEAKED" ]]; then
            echo "🚨 **CRITICAL: Hardcoded Stripe keys detected!**" >> billing_report.md
            echo "\\\`\\\`\\\`" >> billing_report.md
            echo "$LEAKED" | sed 's/sk_live_[a-zA-Z0-9]*/sk_live_REDACTED/g; s/sk_test_[a-zA-Z0-9]*/sk_test_REDACTED/g; s/whsec_[a-zA-Z0-9]*/whsec_REDACTED/g' >> billing_report.md
            echo "\\\`\\\`\\\`" >> billing_report.md
          else
            echo "✅ No hardcoded Stripe keys found." >> billing_report.md
          fi

          echo "" >> billing_report.md

      - name: Check billing tenant scoping
        run: |
          echo "### Billing Tenant Scoping" >> billing_report.md
          echo "" >> billing_report.md

          # Ensure billing models reference tenant
          BILLING_MODELS=$(find src/billing/ -name 'models.py' -o -name 'models/' -type d)
          for f in $BILLING_MODELS; do
            if [[ -f "$f" ]]; then
              if grep -q 'tenant\\|organization' "$f"; then
                echo "✅ Billing models reference tenant/organization." >> billing_report.md
              else
                echo "⚠️ **Billing models in \${f} may not be tenant-scoped.**" >> billing_report.md
              fi
            fi
          done

          echo "" >> billing_report.md

      - name: Upload billing report
        uses: actions/upload-artifact@v4
        with:
          name: billing-security-report
          path: billing_report.md

  audit-api-security:
    name: Audit API Security
    needs: prepare-audit
    if: contains(fromJSON('["full","api-security","authentication"]'), needs.prepare-audit.outputs.audit_focus)
    runs-on: ubuntu-latest
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Set up Python
        uses: actions/setup-python@v5
        with:
          python-version: \${{ env.PYTHON_VERSION }}

      - name: Install uv
        uses: astral-sh/setup-uv@v4

      - name: Install dependencies
        run: uv sync --frozen

      - name: Check authentication on endpoints
        run: |
          echo "## API Security Audit" > api_report.md
          echo "" >> api_report.md

          echo "### Unauthenticated Endpoint Detection" >> api_report.md
          echo "" >> api_report.md

          # Find views with AllowAny or no permission classes
          OPEN_ENDPOINTS=$(grep -rn 'AllowAny\\|permission_classes\\s*=\\s*\\[\\]\\|authentication_classes\\s*=\\s*\\[\\]' src/ --include='*.py' 2>/dev/null || true)
          if [[ -n "$OPEN_ENDPOINTS" ]]; then
            echo "⚠️ **Endpoints with open access (verify intentional):**" >> api_report.md
            echo "\\\`\\\`\\\`" >> api_report.md
            echo "$OPEN_ENDPOINTS" >> api_report.md
            echo "\\\`\\\`\\\`" >> api_report.md
          else
            echo "✅ No AllowAny or empty permission_classes found." >> api_report.md
          fi

          echo "" >> api_report.md

      - name: Check for SQL injection patterns
        run: |
          echo "### Raw SQL / Injection Risk" >> api_report.md
          echo "" >> api_report.md

          RAW_SQL=$(grep -rn 'raw(\\|RawSQL\\|cursor\\.execute\\|extra(' src/ --include='*.py' 2>/dev/null | grep -v 'migrations/' || true)
          if [[ -n "$RAW_SQL" ]]; then
            echo "⚠️ **Raw SQL usage detected — verify parameterized queries:**" >> api_report.md
            echo "\\\`\\\`\\\`" >> api_report.md
            echo "$RAW_SQL" >> api_report.md
            echo "\\\`\\\`\\\`" >> api_report.md
          else
            echo "✅ No raw SQL patterns detected." >> api_report.md
          fi

          echo "" >> api_report.md

      - name: Check rate limiting
        run: |
          echo "### Rate Limiting" >> api_report.md
          echo "" >> api_report.md

          if grep -rq 'throttle_classes\\|DEFAULT_THROTTLE_CLASSES\\|UserRateThrottle\\|AnonRateThrottle' src/ config/ --include='*.py' 2>/dev/null; then
            echo "✅ Rate limiting / throttling configuration found." >> api_report.md
          else
            echo "⚠️ **No rate limiting detected.** Configure DRF throttle classes for API endpoints." >> api_report.md
          fi

          echo "" >> api_report.md

      - name: Check CORS configuration
        run: |
          echo "### CORS Configuration" >> api_report.md
          echo "" >> api_report.md

          if grep -rq 'CORS_ALLOW_ALL_ORIGINS\\s*=\\s*True' config/ --include='*.py' 2>/dev/null; then
            echo "🚨 **CORS_ALLOW_ALL_ORIGINS is True!** This must be False in production." >> api_report.md
          else
            echo "✅ CORS is not set to allow all origins." >> api_report.md
          fi

          echo "" >> api_report.md

      - name: Check OpenAPI schema coverage
        run: |
          echo "### OpenAPI Schema Coverage" >> api_report.md
          echo "" >> api_report.md

          # Count views vs extend_schema decorators
          VIEW_COUNT=$(grep -rc 'class.*ViewSet\\|class.*APIView' src/ --include='*.py' 2>/dev/null | awk -F: '{s+=$2} END {print s}' || echo 0)
          SCHEMA_COUNT=$(grep -rc 'extend_schema\\|@extend_schema' src/ --include='*.py' 2>/dev/null | awk -F: '{s+=$2} END {print s}' || echo 0)

          echo "- API View/ViewSet classes: **\${VIEW_COUNT}**" >> api_report.md
          echo "- \\\`@extend_schema\\\` decorators: **\${SCHEMA_COUNT}**" >> api_report.md

          if [[ "$VIEW_COUNT" -gt 0 ]] && [[ "$SCHEMA_COUNT" -lt "$VIEW_COUNT" ]]; then
            echo "⚠️ Not all views have explicit OpenAPI schema decorators." >> api_report.md
          else
            echo "✅ Schema coverage looks adequate." >> api_report.md
          fi

          echo "" >> api_report.md

      - name: Upload API report
        uses: actions/upload-artifact@v4
        with:
          name: api-security-report
          path: api_report.md

  audit-celery-tasks:
    name: Audit Celery Tasks
    needs: prepare-audit
    if: contains(fromJSON('["full","celery-tasks"]'), needs.prepare-audit.outputs.audit_focus)
    runs-on: ubuntu-latest
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Analyze task patterns
        run: |
          echo "## Celery Task Audit" > celery_report.md
          echo "" >> celery_report.md

          TASK_FILES=$(find src/ -name '*.py' | xargs grep -l '@shared_task\\|@app\\.task\\|@celery_app\\.task' 2>/dev/null || true)

          if [[ -z "$TASK_FILES" ]]; then
            echo "ℹ️ No Celery task files found." >> celery_report.md
          else
            for f in $TASK_FILES; do
              echo "### \${f}" >> celery_report.md
              echo "" >> celery_report.md

              # Check idempotency patterns
              if grep -q 'idempotent\\|already_processed\\|get_or_create\\|select_for_update\\|if.*exists' "$f"; then
                echo "✅ Idempotency patterns detected." >> celery_report.md
              else
                echo "⚠️ **No obvious idempotency guard.** Celery tasks must be idempotent." >> celery_report.md
              fi

              # Check retry configuration
              if grep -q 'retry\\|max_retries\\|autoretry_for\\|retry_backoff' "$f"; then
                echo "✅ Retry configuration found." >> celery_report.md
              else
                echo "⚠️ **No retry configuration.** Tasks should handle transient failures." >> celery_report.md
              fi

              # Check for proper error handling
              if grep -q 'try:\\|except\\|logging\\.\\|logger\\.' "$f"; then
                echo "✅ Error handling / logging present." >> celery_report.md
              else
                echo "⚠️ **Limited error handling detected.**" >> celery_report.md
              fi

              # Check time limits
              if grep -q 'time_limit\\|soft_time_limit\\|task_time_limit' "$f"; then
                echo "✅ Time limits configured." >> celery_report.md
              else
                echo "⚠️ **No time limits set.** Consider adding soft_time_limit to prevent runaway tasks." >> celery_report.md
              fi

              echo "" >> celery_report.md
            done
          fi

      - name: Upload Celery report
        uses: actions/upload-artifact@v4
        with:
          name: celery-task-report
          path: celery_report.md

  audit-data-privacy:
    name: Audit Data Privacy (GDPR/SOC 2)
    needs: prepare-audit
    if: contains(fromJSON('["full","data-privacy"]'), needs.prepare-audit.outputs.audit_focus)
    runs-on: ubuntu-latest
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Check PII handling
        run: |
          echo "## Data Privacy Audit (GDPR / SOC 2)" > privacy_report.md
          echo "" >> privacy_report.md

          echo "### PII Field Detection" >> privacy_report.md
          echo "" >> privacy_report.md

          # Find model fields that likely contain PII
          PII_FIELDS=$(grep -rn 'email\\|phone\\|address\\|first_name\\|last_name\\|date_of_birth\\|ssn\\|social_security\\|ip_address\\|credit_card' src/*/models.py 2>/dev/null || true)
          if [[ -n "$PII_FIELDS" ]]; then
            echo "**PII fields found in models (ensure encryption at rest and proper access controls):**" >> privacy_report.md
            echo "\\\`\\\`\\\`" >> privacy_report.md
            echo "$PII_FIELDS" >> privacy_report.md
            echo "\\\`\\\`\\\`" >> privacy_report.md
          fi

          echo "" >> privacy_report.md

      - name: Check audit logging
        run: |
          echo "### Audit Logging (SOC 2)" >> privacy_report.md
          echo "" >> privacy_report.md

          if grep -rq 'AuditLog\\|audit_log\\|django-auditlog\\|django-simple-history\\|LogEntry' src/ --include='*.py' 2>/dev/null; then
            echo "✅ Audit logging implementation detected." >> privacy_report.md
          else
            echo "⚠️ **No audit logging detected.** SOC 2 requires audit trails for data access and modifications." >> privacy_report.md
          fi

          echo "" >> privacy_report.md

      - name: Check data deletion support
        run: |
          echo "### Right to Deletion (GDPR Art. 17)" >> privacy_report.md
          echo "" >> privacy_report.md

          if grep -rq 'delete_user_data\\|anonymize\\|gdpr_delete\\|right_to_deletion\\|data_erasure\\|purge_personal_data' src/ --include='*.py' 2>/dev/null; then
            echo "✅ Data deletion / anonymization functions found." >> privacy_report.md
          else
            echo "⚠️ **No GDPR data deletion handlers found.** Implement user data erasure for right-to-deletion compliance." >> privacy_report.md
          fi

          echo "" >> privacy_report.md

      - name: Check data export support
        run: |
          echo "### Data Portability (GDPR Art. 20)" >> privacy_report.md
          echo "" >> privacy_report.md

          if grep -rq 'export_data\\|data_portability\\|download_data\\|gdpr_export' src/ --include='*.py' 2>/dev/null; then
            echo "✅ Data export functionality found." >> privacy_report.md
          else
            echo "⚠️ **No data export handlers found.** Users must be able to export their personal data." >> privacy_report.md
          fi

          echo "" >> privacy_report.md

      - name: Check logging for PII leaks
        run: |
          echo "### PII in Logs" >> privacy_report.md
          echo "" >> privacy_report.md

          # Check if logging statements might include PII
          PII_LOGS=$(grep -rn 'logger\\.\\(info\\|debug\\|warning\\|error\\).*\\(email\\|password\\|token\\|secret\\|credit_card\\|ssn\\)' src/ --include='*.py' 2>/dev/null || true)
          if [[ -n "$PII_LOGS" ]]; then
            echo "⚠️ **Possible PII in log statements:**" >> privacy_report.md
            echo "\\\`\\\`\\\`" >> privacy_report.md
            echo "$PII_LOGS" >> privacy_report.md
            echo "\\\`\\\`\\\`" >> privacy_report.md
          else
            echo "✅ No obvious PII leakage in log statements." >> privacy_report.md
          fi

          echo "" >> privacy_report.md

      - name: Upload privacy report
        uses: actions/upload-artifact@v4
        with:
          name: data-privacy-report
          path: privacy_report.md

  audit-code-quality:
    name: Audit Code Quality & Architecture
    needs: prepare-audit
    if: needs.prepare-audit.outputs.audit_focus == 'full'
    runs-on: ubuntu-latest
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Check file length violations
        run: |
          echo "## Code Quality & Architecture Audit" > quality_report.md
          echo "" >> quality_report.md

          echo "### File Length (max 300 lines)" >> quality_report.md
          echo "" >> quality_report.md

          LONG_FILES=$(find src/ -name '*.py' -not -path '*/migrations/*' -exec awk 'END{if(NR>300) print FILENAME": "NR" lines"}' {} \\; 2>/dev/null || true)
          if [[ -n "$LONG_FILES" ]]; then
            echo "⚠️ **Files exceeding 300-line limit:**" >> quality_report.md
            echo "\\\`\\\`\\\`" >> quality_report.md
            echo "$LONG_FILES" >> quality_report.md
            echo "\\\`\\\`\\\`" >> quality_report.md
          else
            echo "✅ All source files within 300-line limit." >> quality_report.md
          fi

          echo "" >> quality_report.md

      - name: Check Django signals usage
        run: |
          echo "### Django Signals Usage" >> quality_report.md
          echo "" >> quality_report.md
          echo "_Convention: prefer explicit service layer calls over signals._" >> quality_report.md
          echo "" >> quality_report.md

          SIGNAL_USAGE=$(grep -rn 'post_save\\|pre_save\\|post_delete\\|pre_delete\\|m2m_changed' src/ --include='*.py' 2>/dev/null | grep -v 'migrations/' || true)
          if [[ -n "$SIGNAL_USAGE" ]]; then
            echo "⚠️ **Signal usage detected — verify these cannot be replaced with service layer calls:**" >> quality_report.md
            echo "\\\`\\\`\\\`" >> quality_report.md
            echo "$SIGNAL_USAGE" >> quality_report.md
            echo "\\\`\\\`\\\`" >> quality_report.md
          else
            echo "✅ No Django signal usage detected." >> quality_report.md
          fi

          echo "" >> quality_report.md

      - name: Check type hint coverage
        run: |
          echo "### Type Hint Coverage" >> quality_report.md
          echo "" >> quality_report.md

          # Count public functions without type hints
          UNTYPED=$(find src/ -name '*.py' -not -path '*/migrations/*' -exec grep -l 'def [a-z]' {} \\; | while read f; do
            grep -n 'def [a-z]' "$f" | grep -v '->.*:' | grep -v '__' | head -3
            if [[ $? -eq 0 ]]; then
              echo "  in: $f"
            fi
          done 2>/dev/null | head -30 || true)

          if [[ -n "$UNTYPED" ]]; then
            echo "⚠️ **Public functions potentially missing return type hints (sample):**" >> quality_report.md
            echo "\\\`\\\`\\\`" >> quality_report.md
            echo "$UNTYPED" >> quality_report.md
            echo "\\\`\\\`\\\`" >> quality_report.md
          else
            echo "✅ Type hint coverage looks good." >> quality_report.md
          fi

          echo "" >> quality_report.md

      - name: Check env/secrets in code
        run: |
          echo "### Hardcoded Secrets Scan" >> quality_report.md
          echo "" >> quality_report.md

          SECRETS=$(grep -rn 'SECRET_KEY\\s*=\\s*["\\x27][^"]*["\\x27]\\|PASSWORD\\s*=\\s*["\\x27]\\|API_KEY\\s*=\\s*["\\x27]' src/ config/ --include='*.py' 2>/dev/null | grep -v 'environ\\|env(\\|os\\.getenv\\|settings\\.\\|config(' || true)
          if [[ -n "$SECRETS" ]]; then
            echo "🚨 **Possible hardcoded secrets:**" >> quality_report.md
            echo "\\\`\\\`\\\`" >> quality_report.md
            echo "$SECRETS" | sed 's/=.*/= [REDACTED]/' >> quality_report.md
            echo "\\\`\\\`\\\`" >> quality_report.md
          else
            echo "✅ No hardcoded secrets detected." >> quality_report.md
          fi

          echo "" >> quality_report.md

      - name: Upload quality report
        uses: actions/upload-artifact@v4
        with:
          name: code-quality-report
          path: quality_report.md

  compile-report:
    name: Compile & Publish Audit Report
    needs:
      - prepare-audit
      - audit-tenant-isolation
      - audit-billing-security
      - audit-api-security
      - audit-celery-tasks
      - audit-data-privacy
      - audit-code-quality
    if: always()
    runs-on: ubuntu-latest
    steps:
      - name: Checkout repository
        uses: actions/checkout@v4

      - name: Download all reports
        uses: actions/download-artifact@v4
        with:
          path: reports/

      - name: Compile final report
        id: compile
        run: |
          REPORT_DATE=$(date -u +"%Y-%m-%d")
          REPORT_FILE="audit_report_\${REPORT_DATE}.md"

          cat > "$REPORT_FILE" << 'HEADER'
          # 🔍 AI Code Audit Report — django-saas-platform

          HEADER

          echo "**Date:** \${REPORT_DATE}" >> "$REPORT_FILE"
          echo "**Focus:** \${{ needs.prepare-audit.outputs.audit_focus }}" >> "$REPORT_FILE"
          echo "**Paths:** \${{ needs.prepare-audit.outputs.audit_paths }}" >> "$REPORT_FILE"
          echo "**Generated by:** GitHub Actions AI Code Audit workflow" >>`,

  '.github/workflows/ci.yml': `name: CI

on:
  pull_request:
    branches: [main]
  push:
    branches: [main]

concurrency:
  group: ci-\${{ github.ref }}
  cancel-in-progress: true

env:
  PYTHON_VERSION: "3.12"
  UV_VERSION: "0.4"
  DJANGO_SETTINGS_MODULE: config.settings.test
  DATABASE_URL: postgres://postgres:postgres@localhost:5432/test_db
  REDIS_URL: redis://localhost:6379/0
  SECRET_KEY: ci-test-secret-key-not-for-production
  STRIPE_SECRET_KEY: sk_test_fake_ci_key
  STRIPE_WEBHOOK_SECRET: whsec_fake_ci_secret

jobs:
  lint:
    name: Lint (ruff)
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v4

      - name: Install uv
        uses: astral-sh/setup-uv@v3
        with:
          version: \${{ env.UV_VERSION }}

      - name: Set up Python
        run: uv python install \${{ env.PYTHON_VERSION }}

      - name: Install dependencies
        run: uv sync --frozen --dev

      - name: Run ruff check
        run: uv run ruff check src/ tests/ scripts/

      - name: Run ruff format check
        run: uv run ruff format --check src/ tests/ scripts/

  type-check:
    name: Type Check (mypy)
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v4

      - name: Install uv
        uses: astral-sh/setup-uv@v3
        with:
          version: \${{ env.UV_VERSION }}

      - name: Set up Python
        run: uv python install \${{ env.PYTHON_VERSION }}

      - name: Install dependencies
        run: uv sync --frozen --dev

      - name: Run mypy
        run: uv run mypy src/

  migrations-check:
    name: Django Migration Check
    runs-on: ubuntu-latest
    services:
      postgres:
        image: postgres:16
        env:
          POSTGRES_USER: postgres
          POSTGRES_PASSWORD: postgres
          POSTGRES_DB: test_db
        ports:
          - 5432:5432
        options: >-
          --health-cmd="pg_isready -U postgres"
          --health-interval=10s
          --health-timeout=5s
          --health-retries=5
    steps:
      - uses: actions/checkout@v4

      - name: Install uv
        uses: astral-sh/setup-uv@v3
        with:
          version: \${{ env.UV_VERSION }}

      - name: Set up Python
        run: uv python install \${{ env.PYTHON_VERSION }}

      - name: Install dependencies
        run: uv sync --frozen --dev

      - name: Check for missing migrations
        run: uv run python manage.py makemigrations --check --dry-run --no-input

      - name: Verify migrations apply cleanly
        run: uv run python manage.py migrate --no-input

  test:
    name: Tests (pytest)
    runs-on: ubuntu-latest
    needs: [lint, type-check]
    services:
      postgres:
        image: postgres:16
        env:
          POSTGRES_USER: postgres
          POSTGRES_PASSWORD: postgres
          POSTGRES_DB: test_db
        ports:
          - 5432:5432
        options: >-
          --health-cmd="pg_isready -U postgres"
          --health-interval=10s
          --health-timeout=5s
          --health-retries=5
      redis:
        image: redis:7-alpine
        ports:
          - 6379:6379
        options: >-
          --health-cmd="redis-cli ping"
          --health-interval=10s
          --health-timeout=5s
          --health-retries=5
    steps:
      - uses: actions/checkout@v4

      - name: Install uv
        uses: astral-sh/setup-uv@v3
        with:
          version: \${{ env.UV_VERSION }}

      - name: Set up Python
        run: uv python install \${{ env.PYTHON_VERSION }}

      - name: Install dependencies
        run: uv sync --frozen --dev

      - name: Run migrations
        run: uv run python manage.py migrate --no-input

      - name: Run unit tests with coverage
        run: |
          uv run pytest tests/ \\
            --cov=src \\
            --cov-report=xml:coverage.xml \\
            --cov-report=term-missing \\
            --cov-fail-under=85 \\
            -x \\
            --tb=short \\
            -q \\
            -m "not integration and not e2e"

      - name: Upload coverage report
        if: always()
        uses: actions/upload-artifact@v4
        with:
          name: coverage-report
          path: coverage.xml
          retention-days: 7

      - name: Post coverage to PR
        if: github.event_name == 'pull_request'
        uses: orgoro/coverage@v3.2
        with:
          coverageFile: coverage.xml
          token: \${{ secrets.GITHUB_TOKEN }}
          thresholdAll: 0.85

  integration-tests:
    name: Integration Tests
    runs-on: ubuntu-latest
    needs: [test]
    services:
      postgres:
        image: postgres:16
        env:
          POSTGRES_USER: postgres
          POSTGRES_PASSWORD: postgres
          POSTGRES_DB: test_db
        ports:
          - 5432:5432
        options: >-
          --health-cmd="pg_isready -U postgres"
          --health-interval=10s
          --health-timeout=5s
          --health-retries=5
      redis:
        image: redis:7-alpine
        ports:
          - 6379:6379
        options: >-
          --health-cmd="redis-cli ping"
          --health-interval=10s
          --health-timeout=5s
          --health-retries=5
    steps:
      - uses: actions/checkout@v4

      - name: Install uv
        uses: astral-sh/setup-uv@v3
        with:
          version: \${{ env.UV_VERSION }}

      - name: Set up Python
        run: uv python install \${{ env.PYTHON_VERSION }}

      - name: Install dependencies
        run: uv sync --frozen --dev

      - name: Run migrations
        run: uv run python manage.py migrate --no-input

      - name: Run integration tests
        run: |
          uv run pytest tests/ \\
            -m "integration" \\
            --tb=short \\
            -q

  security-scan:
    name: Security Scan
    runs-on: ubuntu-latest
    needs: [lint]
    steps:
      - uses: actions/checkout@v4

      - name: Install uv
        uses: astral-sh/setup-uv@v3
        with:
          version: \${{ env.UV_VERSION }}

      - name: Set up Python
        run: uv python install \${{ env.PYTHON_VERSION }}

      - name: Install dependencies
        run: uv sync --frozen --dev

      - name: Run bandit security linter
        run: uv run bandit -r src/ -c pyproject.toml -f json -o bandit-report.json || true

      - name: Check for known vulnerabilities
        run: uv run pip-audit --strict

      - name: Run Django deployment check
        run: uv run python manage.py check --deploy --fail-level WARNING
        env:
          DJANGO_SETTINGS_MODULE: config.settings.production
          ALLOWED_HOSTS: "ci-check.example.com"
          STRIPE_SECRET_KEY: sk_test_fake
          STRIPE_WEBHOOK_SECRET: whsec_fake

      - name: Upload bandit report
        if: always()
        uses: actions/upload-artifact@v4
        with:
          name: bandit-report
          path: bandit-report.json
          retention-days: 30

  sensitive-paths-check:
    name: Sensitive Paths Review Gate
    runs-on: ubuntu-latest
    if: github.event_name == 'pull_request'
    steps:
      - uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Check for changes in sensitive paths
        id: sensitive
        run: |
          SENSITIVE_FILES=$(git diff --name-only origin/main...HEAD | grep -E "(billing/|auth/|config/production|\\.env)" || true)
          if [ -n "$SENSITIVE_FILES" ]; then
            echo "sensitive=true" >> "$GITHUB_OUTPUT"
            echo "::warning::Sensitive paths modified — requires security-team review"
            echo "### ⚠️ Sensitive Files Changed" >> "$GITHUB_STEP_SUMMARY"
            echo '\`\`\`' >> "$GITHUB_STEP_SUMMARY"
            echo "$SENSITIVE_FILES" >> "$GITHUB_STEP_SUMMARY"
            echo '\`\`\`' >> "$GITHUB_STEP_SUMMARY"
            echo "Billing, auth, or production config changes require additional review per SOC 2 controls." >> "$GITHUB_STEP_SUMMARY"
          else
            echo "sensitive=false" >> "$GITHUB_OUTPUT"
          fi

      - name: Label PR for security review
        if: steps.sensitive.outputs.sensitive == 'true'
        uses: actions/github-script@v7
        with:
          script: |
            github.rest.issues.addLabels({
              owner: context.repo.owner,
              repo: context.repo.repo,
              issue_number: context.issue.number,
              labels: ['security-review', 'sensitive-path']
            });

  ai-code-label:
    name: AI Code Detection
    runs-on: ubuntu-latest
    if: github.event_name == 'pull_request'
    steps:
      - uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Check for AI-generated code markers
        id: ai-check
        run: |
          AI_FILES=$(git diff --name-only origin/main...HEAD | xargs grep -l "Generated by\\|AI-generated\\|Claude\\|Copilot\\|GPT" 2>/dev/null || true)
          if [ -n "$AI_FILES" ]; then
            echo "ai_code=true" >> "$GITHUB_OUTPUT"
            echo "### 🤖 AI-Generated Code Detected" >> "$GITHUB_STEP_SUMMARY"
            echo '\`\`\`' >> "$GITHUB_STEP_SUMMARY"
            echo "$AI_FILES" >> "$GITHUB_STEP_SUMMARY"
            echo '\`\`\`' >> "$GITHUB_STEP_SUMMARY"
            echo "These files contain AI-generated code markers and require human review." >> "$GITHUB_STEP_SUMMARY"
          fi

      - name: Label PR with AI flag
        if: steps.ai-check.outputs.ai_code == 'true'
        uses: actions/github-script@v7
        with:
          script: |
            github.rest.issues.addLabels({
              owner: context.repo.owner,
              repo: context.repo.repo,
              issue_number: context.issue.number,
              labels: ['ai-generated']
            });

  ci-status:
    name: CI Status
    runs-on: ubuntu-latest
    if: always()
    needs:
      - lint
      - type-check
      - migrations-check
      - test
      - integration-tests
      - security-scan
    steps:
      - name: Check all job results
        run: |
          echo "Lint: \${{ needs.lint.result }}"
          echo "Type Check: \${{ needs.type-check.result }}"
          echo "Migrations: \${{ needs.migrations-check.result }}"
          echo "Tests: \${{ needs.test.result }}"
          echo "Integration: \${{ needs.integration-tests.result }}"
          echo "Security: \${{ needs.security-scan.result }}"

          if [[ "\${{ needs.lint.result }}" == "failure" || \\
                "\${{ needs.type-check.result }}" == "failure" || \\
                "\${{ needs.migrations-check.result }}" == "failure" || \\
                "\${{ needs.test.result }}" == "failure" || \\
                "\${{ needs.integration-tests.result }}" == "failure" || \\
                "\${{ needs.security-scan.result }}" == "failure" ]]; then
            echo "::error::One or more CI jobs failed"
            exit 1
          fi

          echo "✅ All CI checks passed" >> "$GITHUB_STEP_SUMMARY"`,

  '.github/workflows/deploy-production.yml': `name: Deploy Production

on:
  workflow_dispatch:
    inputs:
      staging_run_id:
        description: "Staging deployment workflow run ID to promote"
        required: true
        type: string
      canary_percentage:
        description: "Initial canary traffic percentage"
        required: false
        type: choice
        options:
          - "5"
          - "10"
          - "25"
        default: "10"
      skip_canary:
        description: "Skip canary phase (emergency hotfix only)"
        required: false
        type: boolean
        default: false
      run_migrations:
        description: "Run database migrations"
        required: false
        type: boolean
        default: true

concurrency:
  group: production-deploy
  cancel-in-progress: false

env:
  AWS_REGION: us-east-1
  ECR_REGISTRY: \${{ secrets.AWS_ACCOUNT_ID }}.dkr.ecr.us-east-1.amazonaws.com
  ECR_REPOSITORY: django-saas-platform
  ECS_CLUSTER: saas-production
  ECS_SERVICE: saas-web-production
  ECS_SERVICE_WORKER: saas-worker-production
  ECS_SERVICE_BEAT: saas-beat-production
  CANARY_SERVICE: saas-web-production-canary
  SLACK_CHANNEL: "#deployments"

permissions:
  id-token: write
  contents: read
  actions: read
  deployments: write

jobs:
  # ---------------------------------------------------------------------------
  # Gate: validate staging was successful and get image tag
  # ---------------------------------------------------------------------------
  validate-staging:
    name: Validate Staging Deployment
    runs-on: ubuntu-latest
    outputs:
      image_tag: \${{ steps.get-image.outputs.tag }}
      commit_sha: \${{ steps.get-image.outputs.sha }}
    steps:
      - name: Verify staging workflow succeeded
        uses: actions/github-script@v7
        with:
          script: |
            const run = await github.rest.actions.getWorkflowRun({
              owner: context.repo.owner,
              repo: context.repo.repo,
              run_id: parseInt('\${{ inputs.staging_run_id }}'),
            });

            if (run.data.conclusion !== 'success') {
              core.setFailed(\`Staging run \${run.data.id} has conclusion: \${run.data.conclusion}. Only successful staging runs can be promoted.\`);
              return;
            }

            if (run.data.name !== 'Deploy Staging') {
              core.setFailed(\`Run \${run.data.id} is not a staging deployment workflow.\`);
              return;
            }

            core.info(\`Staging run \${run.data.id} validated — conclusion: \${run.data.conclusion}\`);

      - name: Get image tag from staging artifacts
        id: get-image
        uses: actions/github-script@v7
        with:
          script: |
            const artifacts = await github.rest.actions.listWorkflowRunArtifacts({
              owner: context.repo.owner,
              repo: context.repo.repo,
              run_id: parseInt('\${{ inputs.staging_run_id }}'),
            });

            const deployArtifact = artifacts.data.artifacts.find(a => a.name === 'deploy-metadata');
            if (!deployArtifact) {
              core.setFailed('No deploy-metadata artifact found on staging run');
              return;
            }

            const download = await github.rest.actions.downloadArtifact({
              owner: context.repo.owner,
              repo: context.repo.repo,
              artifact_id: deployArtifact.id,
              archive_format: 'zip',
            });

            const fs = require('fs');
            fs.writeFileSync('/tmp/metadata.zip', Buffer.from(download.data));

            const { execSync } = require('child_process');
            execSync('unzip -o /tmp/metadata.zip -d /tmp/metadata');

            const metadata = JSON.parse(fs.readFileSync('/tmp/metadata/deploy-metadata.json', 'utf8'));
            core.setOutput('tag', metadata.image_tag);
            core.setOutput('sha', metadata.commit_sha);
            core.info(\`Image tag: \${metadata.image_tag}, SHA: \${metadata.commit_sha}\`);

  # ---------------------------------------------------------------------------
  # Gate: manual approval from authorized deployers
  # ---------------------------------------------------------------------------
  approval:
    name: Production Approval
    needs: [validate-staging]
    runs-on: ubuntu-latest
    environment:
      name: production
      url: https://app.example.com
    steps:
      - name: Approval granted
        run: echo "Production deployment approved for image \${{ needs.validate-staging.outputs.image_tag }}"

  # ---------------------------------------------------------------------------
  # Pre-deploy checks
  # ---------------------------------------------------------------------------
  pre-deploy-checks:
    name: Pre-Deploy Checks
    needs: [validate-staging, approval]
    runs-on: ubuntu-latest
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          ref: \${{ needs.validate-staging.outputs.commit_sha }}

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Verify image exists in ECR
        run: |
          IMAGE_TAG="\${{ needs.validate-staging.outputs.image_tag }}"
          aws ecr describe-images \\
            --repository-name \${{ env.ECR_REPOSITORY }} \\
            --image-ids imageTag="\${IMAGE_TAG}" \\
            || (echo "Image \${IMAGE_TAG} not found in ECR" && exit 1)
          echo "✅ Image \${IMAGE_TAG} verified in ECR"

      - name: Check RDS cluster health
        run: |
          STATUS=$(aws rds describe-db-clusters \\
            --db-cluster-identifier saas-production \\
            --query 'DBClusters[0].Status' --output text)
          if [ "$STATUS" != "available" ]; then
            echo "❌ RDS cluster status: \${STATUS}"
            exit 1
          fi
          echo "✅ RDS cluster healthy"

      - name: Check Redis cluster health
        run: |
          STATUS=$(aws elasticache describe-replication-groups \\
            --replication-group-id saas-production \\
            --query 'ReplicationGroups[0].Status' --output text)
          if [ "$STATUS" != "available" ]; then
            echo "❌ Redis cluster status: \${STATUS}"
            exit 1
          fi
          echo "✅ Redis cluster healthy"

      - name: Verify Stripe webhook endpoint
        run: |
          pip install stripe
          python -c "
          import stripe, os, sys
          stripe.api_key = os.environ['STRIPE_SECRET_KEY']
          endpoints = stripe.WebhookEndpoint.list(limit=10)
          prod_endpoint = next(
              (e for e in endpoints.data if 'production' in e.url and e.status == 'enabled'),
              None
          )
          if not prod_endpoint:
              print('❌ No active production Stripe webhook endpoint found')
              sys.exit(1)
          required_events = [
              'customer.subscription.created',
              'customer.subscription.updated',
              'customer.subscription.deleted',
              'invoice.payment_succeeded',
              'invoice.payment_failed',
              'checkout.session.completed',
          ]
          missing = [e for e in required_events if e not in prod_endpoint.enabled_events and '*' not in prod_endpoint.enabled_events]
          if missing:
              print(f'❌ Missing webhook events: {missing}')
              sys.exit(1)
          print(f'✅ Stripe webhook verified: {prod_endpoint.url}')
          print(f'   Events: {len(prod_endpoint.enabled_events)} configured')
          "
        env:
          STRIPE_SECRET_KEY: \${{ secrets.STRIPE_SECRET_KEY_PRODUCTION }}

      - name: Notify deploy starting
        uses: slackapi/slack-github-action@v1
        with:
          channel-id: \${{ env.SLACK_CHANNEL }}
          payload: |
            {
              "blocks": [
                {
                  "type": "header",
                  "text": {"type": "plain_text", "text": "🚀 Production Deploy Starting"}
                },
                {
                  "type": "section",
                  "fields": [
                    {"type": "mrkdwn", "text": "*Image:*\\n\`\${{ needs.validate-staging.outputs.image_tag }}\`"},
                    {"type": "mrkdwn", "text": "*Commit:*\\n\`\${{ needs.validate-staging.outputs.commit_sha }}\`"},
                    {"type": "mrkdwn", "text": "*Canary:*\\n\${{ inputs.skip_canary && 'Skipped ⚠️' || format('{0}%', inputs.canary_percentage) }}"},
                    {"type": "mrkdwn", "text": "*Migrations:*\\n\${{ inputs.run_migrations && '✅ Yes' || '⏭️ No' }}"},
                    {"type": "mrkdwn", "text": "*Triggered by:*\\n\${{ github.actor }}"},
                    {"type": "mrkdwn", "text": "*Staging Run:*\\n<\${{ github.server_url }}/\${{ github.repository }}/actions/runs/\${{ inputs.staging_run_id }}|#\${{ inputs.staging_run_id }}>"}
                  ]
                }
              ]
            }
        env:
          SLACK_BOT_TOKEN: \${{ secrets.SLACK_BOT_TOKEN }}

  # ---------------------------------------------------------------------------
  # Database migrations (run before new code deploys)
  # ---------------------------------------------------------------------------
  run-migrations:
    name: Run Database Migrations
    needs: [validate-staging, pre-deploy-checks]
    if: inputs.run_migrations
    runs-on: ubuntu-latest
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          ref: \${{ needs.validate-staging.outputs.commit_sha }}

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Login to ECR
        uses: aws-actions/amazon-ecr-login@v2

      - name: Create migration snapshot
        run: |
          echo "Creating pre-migration RDS snapshot..."
          SNAPSHOT_ID="pre-deploy-$(date +%Y%m%d-%H%M%S)-\${GITHUB_RUN_ID}"
          aws rds create-db-cluster-snapshot \\
            --db-cluster-identifier saas-production \\
            --db-cluster-snapshot-identifier "\${SNAPSHOT_ID}"
          echo "SNAPSHOT_ID=\${SNAPSHOT_ID}" >> $GITHUB_ENV

          echo "Waiting for snapshot to be available..."
          aws rds wait db-cluster-snapshot-available \\
            --db-cluster-snapshot-identifier "\${SNAPSHOT_ID}"
          echo "✅ Snapshot \${SNAPSHOT_ID} created"

      - name: Show pending migrations
        run: |
          IMAGE="\${{ env.ECR_REGISTRY }}/\${{ env.ECR_REPOSITORY }}:\${{ needs.validate-staging.outputs.image_tag }}"
          docker pull "\${IMAGE}"
          docker run --rm \\
            -e DATABASE_URL="\${{ secrets.PRODUCTION_DATABASE_URL }}" \\
            -e DJANGO_SETTINGS_MODULE=config.settings.production \\
            -e DJANGO_SECRET_KEY=migration-check \\
            "\${IMAGE}" \\
            python manage.py showmigrations --plan | grep "\\[ \\]" || echo "No pending migrations"

      - name: Run migrations
        run: |
          IMAGE="\${{ env.ECR_REGISTRY }}/\${{ env.ECR_REPOSITORY }}:\${{ needs.validate-staging.outputs.image_tag }}"
          docker run --rm \\
            -e DATABASE_URL="\${{ secrets.PRODUCTION_DATABASE_URL }}" \\
            -e DJANGO_SETTINGS_MODULE=config.settings.production \\
            -e DJANGO_SECRET_KEY="\${{ secrets.DJANGO_SECRET_KEY_PRODUCTION }}" \\
            -e REDIS_URL="\${{ secrets.PRODUCTION_REDIS_URL }}" \\
            "\${IMAGE}" \\
            python manage.py migrate --noinput --verbosity 2
          echo "✅ Migrations completed"

      - name: Verify migration state
        run: |
          IMAGE="\${{ env.ECR_REGISTRY }}/\${{ env.ECR_REPOSITORY }}:\${{ needs.validate-staging.outputs.image_tag }}"
          UNAPPLIED=$(docker run --rm \\
            -e DATABASE_URL="\${{ secrets.PRODUCTION_DATABASE_URL }}" \\
            -e DJANGO_SETTINGS_MODULE=config.settings.production \\
            -e DJANGO_SECRET_KEY=migration-check \\
            "\${IMAGE}" \\
            python manage.py showmigrations --plan | grep "\\[ \\]" | wc -l)
          if [ "$UNAPPLIED" -gt 0 ]; then
            echo "❌ \${UNAPPLIED} unapplied migrations remain"
            exit 1
          fi
          echo "✅ All migrations applied"

  # ---------------------------------------------------------------------------
  # Canary deployment
  # ---------------------------------------------------------------------------
  canary-deploy:
    name: Canary Deployment
    needs: [validate-staging, pre-deploy-checks, run-migrations]
    if: |
      always() &&
      !inputs.skip_canary &&
      needs.pre-deploy-checks.result == 'success' &&
      (needs.run-migrations.result == 'success' || needs.run-migrations.result == 'skipped')
    runs-on: ubuntu-latest
    outputs:
      canary_healthy: \${{ steps.canary-check.outputs.healthy }}
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          ref: \${{ needs.validate-staging.outputs.commit_sha }}

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Deploy canary task definition
        id: canary-task
        run: |
          IMAGE="\${{ env.ECR_REGISTRY }}/\${{ env.ECR_REPOSITORY }}:\${{ needs.validate-staging.outputs.image_tag }}"

          CURRENT_TD=$(aws ecs describe-services \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --services \${{ env.CANARY_SERVICE }} \\
            --query 'services[0].taskDefinition' --output text)

          NEW_TD=$(aws ecs describe-task-definition \\
            --task-definition "\${CURRENT_TD}" \\
            --query 'taskDefinition' | \\
            jq --arg IMAGE "\${IMAGE}" \\
            '.containerDefinitions[0].image = $IMAGE | del(.taskDefinitionArn, .revision, .status, .requiresAttributes, .compatibilities, .registeredAt, .registeredBy)' | \\
            jq '{family, containerDefinitions, taskRoleArn, executionRoleArn, networkMode, requiresCompatibilities, cpu, memory}')

          REGISTERED=$(aws ecs register-task-definition --cli-input-json "\${NEW_TD}" \\
            --query 'taskDefinition.taskDefinitionArn' --output text)

          echo "task_definition=\${REGISTERED}" >> $GITHUB_OUTPUT
          echo "✅ Canary task definition: \${REGISTERED}"

      - name: Update canary service
        run: |
          aws ecs update-service \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --service \${{ env.CANARY_SERVICE }} \\
            --task-definition \${{ steps.canary-task.outputs.task_definition }} \\
            --force-new-deployment

          echo "Waiting for canary service to stabilize..."
          aws ecs wait services-stable \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --services \${{ env.CANARY_SERVICE }}
          echo "✅ Canary service stable"

      - name: Configure canary traffic weight
        run: |
          CANARY_WEIGHT=\${{ inputs.canary_percentage }}
          PRIMARY_WEIGHT=$((100 - CANARY_WEIGHT))

          aws elbv2 modify-rule \\
            --rule-arn \${{ secrets.ALB_LISTENER_RULE_ARN }} \\
            --actions '[
              {
                "Type": "forward",
                "ForwardConfig": {
                  "TargetGroups": [
                    {"TargetGroupArn": "\${{ secrets.PRIMARY_TARGET_GROUP_ARN }}", "Weight": '"\${PRIMARY_WEIGHT}"'},
                    {"TargetGroupArn": "\${{ secrets.CANARY_TARGET_GROUP_ARN }}", "Weight": '"\${CANARY_WEIGHT}"'}
                  ]
                }
              }
            ]'
          echo "✅ Traffic split: primary=\${PRIMARY_WEIGHT}%, canary=\${CANARY_WEIGHT}%"

      - name: Monitor canary (5 minutes)
        id: canary-check
        run: |
          echo "Monitoring canary for 5 minutes..."
          HEALTHY=true
          for i in $(seq 1 10); do
            sleep 30
            echo "--- Check \${i}/10 ---"

            # Check ECS task health
            RUNNING=$(aws ecs describe-services \\
              --cluster \${{ env.ECS_CLUSTER }} \\
              --services \${{ env.CANARY_SERVICE }} \\
              --query 'services[0].runningCount' --output text)
            DESIRED=$(aws ecs describe-services \\
              --cluster \${{ env.ECS_CLUSTER }} \\
              --services \${{ env.CANARY_SERVICE }} \\
              --query 'services[0].desiredCount' --output text)

            if [ "$RUNNING" -lt "$DESIRED" ]; then
              echo "❌ Canary unhealthy: running=\${RUNNING} desired=\${DESIRED}"
              HEALTHY=false
              break
            fi

            # Check target group health
            HEALTHY_COUNT=$(aws elbv2 describe-target-health \\
              --target-group-arn \${{ secrets.CANARY_TARGET_GROUP_ARN }} \\
              --query 'TargetHealthDescriptions[?TargetHealth.State==\`healthy\`] | length(@)' --output text)

            if [ "$HEALTHY_COUNT" -eq 0 ]; then
              echo "❌ No healthy canary targets"
              HEALTHY=false
              break
            fi

            # Check CloudWatch error rate
            ERROR_RATE=$(aws cloudwatch get-metric-statistics \\
              --namespace "AWS/ApplicationELB" \\
              --metric-name "HTTPCode_Target_5XX_Count" \\
              --dimensions Name=TargetGroup,Value=$(echo \${{ secrets.CANARY_TARGET_GROUP_ARN }} | grep -oP 'targetgroup/[^"]+') \\
              --start-time "$(date -u -d '1 minute ago' +%Y-%m-%dT%H:%M:%S)" \\
              --end-time "$(date -u +%Y-%m-%dT%H:%M:%S)" \\
              --period 60 \\
              --statistics Sum \\
              --query 'Datapoints[0].Sum // \`0\`' --output text 2>/dev/null || echo "0")

            echo "  Tasks: \${RUNNING}/\${DESIRED}, Healthy targets: \${HEALTHY_COUNT}, 5xx count: \${ERROR_RATE}"

            if [ "$(echo "\${ERROR_RATE} > 10" | bc -l 2>/dev/null || echo 0)" -eq 1 ]; then
              echo "❌ Canary error rate too high: \${ERROR_RATE}"
              HEALTHY=false
              break
            fi

            echo "  ✅ Check \${i} passed"
          done

          echo "healthy=\${HEALTHY}" >> $GITHUB_OUTPUT

          if [ "$HEALTHY" = "false" ]; then
            echo "❌ Canary failed health checks"
            exit 1
          fi
          echo "✅ Canary passed all health checks"

      - name: Rollback canary on failure
        if: failure()
        run: |
          echo "🔄 Rolling back canary traffic..."
          aws elbv2 modify-rule \\
            --rule-arn \${{ secrets.ALB_LISTENER_RULE_ARN }} \\
            --actions '[
              {
                "Type": "forward",
                "ForwardConfig": {
                  "TargetGroups": [
                    {"TargetGroupArn": "\${{ secrets.PRIMARY_TARGET_GROUP_ARN }}", "Weight": 100},
                    {"TargetGroupArn": "\${{ secrets.CANARY_TARGET_GROUP_ARN }}", "Weight": 0}
                  ]
                }
              }
            ]'

          aws ecs update-service \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --service \${{ env.CANARY_SERVICE }} \\
            --desired-count 0
          echo "✅ Canary traffic removed, service scaled to 0"

      - name: Notify canary failure
        if: failure()
        uses: slackapi/slack-github-action@v1
        with:
          channel-id: \${{ env.SLACK_CHANNEL }}
          payload: |
            {
              "blocks": [
                {
                  "type": "header",
                  "text": {"type": "plain_text", "text": "❌ Production Canary FAILED"}
                },
                {
                  "type": "section",
                  "text": {"type": "mrkdwn", "text": "Canary deployment rolled back. Production is unchanged.\\n*Image:* \`\${{ needs.validate-staging.outputs.image_tag }}\`\\n*Run:* <\${{ github.server_url }}/\${{ github.repository }}/actions/runs/\${{ github.run_id }}|View logs>"}
                }
              ]
            }
        env:
          SLACK_BOT_TOKEN: \${{ secrets.SLACK_BOT_TOKEN }}

  # ---------------------------------------------------------------------------
  # Full production rollout
  # ---------------------------------------------------------------------------
  production-deploy:
    name: Production Rollout
    needs: [validate-staging, pre-deploy-checks, run-migrations, canary-deploy]
    if: |
      always() &&
      needs.pre-deploy-checks.result == 'success' &&
      (needs.run-migrations.result == 'success' || needs.run-migrations.result == 'skipped') &&
      (needs.canary-deploy.result == 'success' || (inputs.skip_canary && needs.canary-deploy.result == 'skipped'))
    runs-on: ubuntu-latest
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          ref: \${{ needs.validate-staging.outputs.commit_sha }}

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Update web service task definition
        id: web-task
        run: |
          IMAGE="\${{ env.ECR_REGISTRY }}/\${{ env.ECR_REPOSITORY }}:\${{ needs.validate-staging.outputs.image_tag }}"

          CURRENT_TD=$(aws ecs describe-services \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --services \${{ env.ECS_SERVICE }} \\
            --query 'services[0].taskDefinition' --output text)

          NEW_TD=$(aws ecs describe-task-definition \\
            --task-definition "\${CURRENT_TD}" \\
            --query 'taskDefinition' | \\
            jq --arg IMAGE "\${IMAGE}" \\
            '.containerDefinitions[0].image = $IMAGE | del(.taskDefinitionArn, .revision, .status, .requiresAttributes, .compatibilities, .registeredAt, .registeredBy)' | \\
            jq '{family, containerDefinitions, taskRoleArn, executionRoleArn, networkMode, requiresCompatibilities, cpu, memory}')

          REGISTERED=$(aws ecs register-task-definition --cli-input-json "\${NEW_TD}" \\
            --query 'taskDefinition.taskDefinitionArn' --output text)

          echo "task_definition=\${REGISTERED}" >> $GITHUB_OUTPUT

      - name: Deploy web service
        run: |
          aws ecs update-service \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --service \${{ env.ECS_SERVICE }} \\
            --task-definition \${{ steps.web-task.outputs.task_definition }} \\
            --force-new-deployment

      - name: Update worker service task definition
        id: worker-task
        run: |
          IMAGE="\${{ env.ECR_REGISTRY }}/\${{ env.ECR_REPOSITORY }}:\${{ needs.validate-staging.outputs.image_tag }}"

          CURRENT_TD=$(aws ecs describe-services \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --services \${{ env.ECS_SERVICE_WORKER }} \\
            --query 'services[0].taskDefinition' --output text)

          NEW_TD=$(aws ecs describe-task-definition \\
            --task-definition "\${CURRENT_TD}" \\
            --query 'taskDefinition' | \\
            jq --arg IMAGE "\${IMAGE}" \\
            '.containerDefinitions[0].image = $IMAGE | del(.taskDefinitionArn, .revision, .status, .requiresAttributes, .compatibilities, .registeredAt, .registeredBy)' | \\
            jq '{family, containerDefinitions, taskRoleArn, executionRoleArn, networkMode, requiresCompatibilities, cpu, memory}')

          REGISTERED=$(aws ecs register-task-definition --cli-input-json "\${NEW_TD}" \\
            --query 'taskDefinition.taskDefinitionArn' --output text)

          echo "task_definition=\${REGISTERED}" >> $GITHUB_OUTPUT

      - name: Deploy worker service
        run: |
          aws ecs update-service \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --service \${{ env.ECS_SERVICE_WORKER }} \\
            --task-definition \${{ steps.worker-task.outputs.task_definition }} \\
            --force-new-deployment

      - name: Update beat service task definition
        id: beat-task
        run: |
          IMAGE="\${{ env.ECR_REGISTRY }}/\${{ env.ECR_REPOSITORY }}:\${{ needs.validate-staging.outputs.image_tag }}"

          CURRENT_TD=$(aws ecs describe-services \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --services \${{ env.ECS_SERVICE_BEAT }} \\
            --query 'services[0].taskDefinition' --output text)

          NEW_TD=$(aws ecs describe-task-definition \\
            --task-definition "\${CURRENT_TD}" \\
            --query 'taskDefinition' | \\
            jq --arg IMAGE "\${IMAGE}" \\
            '.containerDefinitions[0].image = $IMAGE | del(.taskDefinitionArn, .revision, .status, .requiresAttributes, .compatibilities, .registeredAt, .registeredBy)' | \\
            jq '{family, containerDefinitions, taskRoleArn, executionRoleArn, networkMode, requiresCompatibilities, cpu, memory}')

          REGISTERED=$(aws ecs register-task-definition --cli-input-json "\${NEW_TD}" \\
            --query 'taskDefinition.taskDefinitionArn' --output text)

          echo "task_definition=\${REGISTERED}" >> $GITHUB_OUTPUT

      - name: Deploy beat service
        run: |
          aws ecs update-service \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --service \${{ env.ECS_SERVICE_BEAT }} \\
            --task-definition \${{ steps.beat-task.outputs.task_definition }} \\
            --force-new-deployment

      - name: Shift all traffic to primary
        if: \${{ !inputs.skip_canary }}
        run: |
          aws elbv2 modify-rule \\
            --rule-arn \${{ secrets.ALB_LISTENER_RULE_ARN }} \\
            --actions '[
              {
                "Type": "forward",
                "ForwardConfig": {
                  "TargetGroups": [
                    {"TargetGroupArn": "\${{ secrets.PRIMARY_TARGET_GROUP_ARN }}", "Weight": 100},
                    {"TargetGroupArn": "\${{ secrets.CANARY_TARGET_GROUP_ARN }}", "Weight": 0}
                  ]
                }
              }
            ]'
          echo "✅ All traffic shifted to primary"

      - name: Wait for all services to stabilize
        run: |
          echo "Waiting for web service..."
          aws ecs wait services-stable \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --services \${{ env.ECS_SERVICE }}

          echo "Waiting for worker service..."
          aws ecs wait services-stable \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --services \${{ env.ECS_SERVICE_WORKER }}

          echo "Waiting for beat service..."
          aws ecs wait services-stable \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --services \${{ env.ECS_SERVICE_BEAT }}

          echo "✅ All services stable"

      - name: Scale down canary
        if: \${{ !inputs.skip_canary }}
        run: |
          aws ecs update-service \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --service \${{ env.CANARY_SERVICE }} \\
            --desired-count 0
          echo "✅ Canary scaled to 0"

  # ---------------------------------------------------------------------------
  # Post-deploy verification
  # ---------------------------------------------------------------------------
  post-deploy-verify:
    name: Post-Deploy Verification
    needs: [validate-staging, production-deploy]
    runs-on: ubuntu-latest
    steps:
      - name: Checkout
        uses: actions/checkout@v4
        with:
          ref: \${{ needs.validate-staging.outputs.commit_sha }}

      - name: Health check — web
        run: |
          for i in $(seq 1 5); do
            STATUS=$(curl -s -o /dev/null -w "%{http_code}" \\
              --max-time 10 \\
              "https://app.example.com/api/health/")
            if [ "$STATUS" = "200" ]; then
              echo "✅ Web health check passed (attempt \${i})"
              exit 0
            fi
            echo "⏳ Health check returned \${STATUS}, retrying in 10s..."
            sleep 10
          done
          echo "❌ Web health check failed after 5 attempts"
          exit 1

      - name: Health check — API version
        run: |
          VERSION=$(curl -s --max-time 10 "https://app.example.com/api/health/" | jq -r '.version // empty')
          EXPECTED="\${{ needs.validate-staging.outputs.image_tag }}"
          echo "Deployed version: \${VERSION}"
          echo "Expected: \${EXPECTED}"
          if [ -z "$VERSION" ]; then
            echo "⚠️ Could not verify version (health endpoint may not include it)"
          fi

      - name: Verify Stripe webhook connectivity
        run: |
          pip install stripe
          python -c "
          import stripe, os, sys
          stripe.api_key = os.environ['STRIPE_SECRET_KEY']

          # Send a test webhook event
          try:
              endpoints = stripe.WebhookEndpoint.list(limit=10)
              prod_endpoint = next(
                  (e for e in endpoints.data if 'production' in e.url and e.status == 'enabled'),
                  None
              )
              if not prod_endpoint:
                  print('⚠️ No production webhook endpoint found')
                  sys.exit(0)

              print(f'✅`,

  '.github/workflows/deploy-staging.yml': `name: Deploy Staging

on:
  push:
    branches: [main]
  workflow_dispatch:
    inputs:
      skip_e2e:
        description: "Skip E2E tests after deploy"
        required: false
        default: "false"
        type: boolean

concurrency:
  group: deploy-staging
  cancel-in-progress: false

env:
  AWS_REGION: eu-west-1
  ECR_REPOSITORY: django-saas-platform
  ECS_CLUSTER: saas-staging
  ECS_SERVICE_WEB: saas-staging-web
  ECS_SERVICE_WORKER: saas-staging-worker
  ECS_SERVICE_BEAT: saas-staging-beat
  TASK_DEFINITION_WEB: saas-staging-web-td
  TASK_DEFINITION_WORKER: saas-staging-worker-td
  TASK_DEFINITION_BEAT: saas-staging-beat-td
  DOCKER_BUILDKIT: 1
  PYTHON_VERSION: "3.12"

permissions:
  id-token: write
  contents: read
  actions: read
  deployments: write

jobs:
  # ---------------------------------------------------------------------------
  # Gate: ensure CI checks passed on this commit
  # ---------------------------------------------------------------------------
  ci-gate:
    name: Verify CI Passed
    runs-on: ubuntu-latest
    steps:
      - name: Check CI workflow status
        uses: actions/github-script@v7
        with:
          script: |
            const sha = context.sha;
            const { data: checkRuns } = await github.rest.checks.listForRef({
              owner: context.repo.owner,
              repo: context.repo.repo,
              ref: sha,
              filter: 'latest',
            });
            const ciRun = checkRuns.check_runs.find(
              (cr) => cr.name === 'Unit Tests' || cr.name === 'Integration Tests'
            );
            if (!ciRun || ciRun.conclusion !== 'success') {
              core.setFailed(
                \`CI checks have not passed for \${sha}. Aborting staging deploy.\`
              );
            }

  # ---------------------------------------------------------------------------
  # Build Docker image and push to ECR
  # ---------------------------------------------------------------------------
  build-and-push:
    name: Build & Push Docker Image
    needs: [ci-gate]
    runs-on: ubuntu-latest
    outputs:
      image_uri: \${{ steps.build.outputs.image_uri }}
      image_tag: \${{ steps.meta.outputs.image_tag }}
    steps:
      - name: Checkout code
        uses: actions/checkout@v4

      - name: Generate image metadata
        id: meta
        run: |
          SHORT_SHA="\${GITHUB_SHA::8}"
          TIMESTAMP="$(date +%Y%m%d%H%M%S)"
          IMAGE_TAG="staging-\${SHORT_SHA}-\${TIMESTAMP}"
          echo "image_tag=\${IMAGE_TAG}" >> "$GITHUB_OUTPUT"
          echo "short_sha=\${SHORT_SHA}" >> "$GITHUB_OUTPUT"

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Login to Amazon ECR
        id: ecr-login
        uses: aws-actions/amazon-ecr-login@v2

      - name: Set up Docker Buildx
        uses: docker/setup-buildx-action@v3

      - name: Build and push Docker image
        id: build
        uses: docker/build-push-action@v5
        with:
          context: .
          file: ./Dockerfile
          push: true
          tags: |
            \${{ steps.ecr-login.outputs.registry }}/\${{ env.ECR_REPOSITORY }}:\${{ steps.meta.outputs.image_tag }}
            \${{ steps.ecr-login.outputs.registry }}/\${{ env.ECR_REPOSITORY }}:staging-latest
          cache-from: type=registry,ref=\${{ steps.ecr-login.outputs.registry }}/\${{ env.ECR_REPOSITORY }}:staging-cache
          cache-to: type=registry,ref=\${{ steps.ecr-login.outputs.registry }}/\${{ env.ECR_REPOSITORY }}:staging-cache,mode=max
          build-args: |
            PYTHON_VERSION=\${{ env.PYTHON_VERSION }}
            BUILD_ENV=staging
            GIT_SHA=\${{ github.sha }}
            BUILD_TIMESTAMP=\${{ steps.meta.outputs.image_tag }}
          labels: |
            org.opencontainers.image.source=\${{ github.server_url }}/\${{ github.repository }}
            org.opencontainers.image.revision=\${{ github.sha }}
            org.opencontainers.image.created=\${{ github.event.head_commit.timestamp }}
            ai.generated=\${{ contains(github.event.head_commit.message, '[ai]') }}

      - name: Set image URI output
        run: |
          IMAGE_URI="\${{ steps.ecr-login.outputs.registry }}/\${{ env.ECR_REPOSITORY }}:\${{ steps.meta.outputs.image_tag }}"
          echo "image_uri=\${IMAGE_URI}" >> "$GITHUB_OUTPUT"

  # ---------------------------------------------------------------------------
  # Run database migrations as a one-off ECS task
  # ---------------------------------------------------------------------------
  run-migrations:
    name: Run Database Migrations
    needs: [build-and-push]
    runs-on: ubuntu-latest
    steps:
      - name: Checkout code
        uses: actions/checkout@v4

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Login to Amazon ECR
        uses: aws-actions/amazon-ecr-login@v2

      - name: Render migration task definition
        id: render-migration-td
        uses: aws-actions/amazon-ecs-render-task-definition@v1
        with:
          task-definition-arn: arn:aws:ecs:\${{ env.AWS_REGION }}:\${{ secrets.AWS_ACCOUNT_ID }}:task-definition/saas-staging-migrate-td
          container-name: migrate
          image: \${{ needs.build-and-push.outputs.image_uri }}

      - name: Register migration task definition
        id: register-migration-td
        run: |
          TD_ARN=$(aws ecs register-task-definition \\
            --cli-input-json file://\${{ steps.render-migration-td.outputs.task-definition }} \\
            --query 'taskDefinition.taskDefinitionArn' \\
            --output text)
          echo "td_arn=\${TD_ARN}" >> "$GITHUB_OUTPUT"

      - name: Run migration task
        id: run-migration
        run: |
          TASK_ARN=$(aws ecs run-task \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --task-definition \${{ steps.register-migration-td.outputs.td_arn }} \\
            --launch-type FARGATE \\
            --network-configuration "awsvpcConfiguration={subnets=\${{ secrets.STAGING_PRIVATE_SUBNETS }},securityGroups=[\${{ secrets.STAGING_MIGRATE_SG }}],assignPublicIp=DISABLED}" \\
            --overrides '{"containerOverrides":[{"name":"migrate","command":["python","manage.py","migrate","--noinput"]}]}' \\
            --query 'tasks[0].taskArn' \\
            --output text)
          echo "task_arn=\${TASK_ARN}" >> "$GITHUB_OUTPUT"
          echo "::notice::Migration task started: \${TASK_ARN}"

      - name: Wait for migration to complete
        run: |
          echo "Waiting for migration task to finish..."
          aws ecs wait tasks-stopped \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --tasks \${{ steps.run-migration.outputs.task_arn }}

          EXIT_CODE=$(aws ecs describe-tasks \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --tasks \${{ steps.run-migration.outputs.task_arn }} \\
            --query 'tasks[0].containers[0].exitCode' \\
            --output text)

          if [ "$EXIT_CODE" != "0" ]; then
            echo "::error::Migration failed with exit code \${EXIT_CODE}"
            # Fetch logs for debugging
            TASK_ID=$(echo "\${{ steps.run-migration.outputs.task_arn }}" | awk -F'/' '{print $NF}')
            aws logs get-log-events \\
              --log-group-name /ecs/saas-staging-migrate \\
              --log-stream-name "migrate/migrate/\${TASK_ID}" \\
              --limit 100 \\
              --query 'events[*].message' \\
              --output text || true
            exit 1
          fi
          echo "::notice::Migrations completed successfully"

  # ---------------------------------------------------------------------------
  # Deploy web, worker, and beat services to ECS
  # ---------------------------------------------------------------------------
  deploy-services:
    name: Deploy ECS Services
    needs: [build-and-push, run-migrations]
    runs-on: ubuntu-latest
    strategy:
      fail-fast: true
      max-parallel: 3
      matrix:
        service:
          - name: web
            ecs_service: saas-staging-web
            task_definition: saas-staging-web-td
            container: web
          - name: worker
            ecs_service: saas-staging-worker
            task_definition: saas-staging-worker-td
            container: worker
          - name: beat
            ecs_service: saas-staging-beat
            task_definition: saas-staging-beat-td
            container: beat
    steps:
      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Login to Amazon ECR
        uses: aws-actions/amazon-ecr-login@v2

      - name: Download current task definition
        run: |
          aws ecs describe-task-definition \\
            --task-definition \${{ matrix.service.task_definition }} \\
            --query 'taskDefinition' \\
            --output json > task-definition.json
          # Remove fields that can't be re-registered
          jq 'del(.taskDefinitionArn, .revision, .status, .requiresAttributes, .compatibilities, .registeredAt, .registeredBy)' \\
            task-definition.json > clean-task-definition.json

      - name: Render new task definition
        id: render-td
        uses: aws-actions/amazon-ecs-render-task-definition@v1
        with:
          task-definition: clean-task-definition.json
          container-name: \${{ matrix.service.container }}
          image: \${{ needs.build-and-push.outputs.image_uri }}
          environment-variables: |
            GIT_SHA=\${{ github.sha }}
            DEPLOY_TAG=\${{ needs.build-and-push.outputs.image_tag }}

      - name: Deploy to ECS
        uses: aws-actions/amazon-ecs-deploy-task-definition@v1
        with:
          task-definition: \${{ steps.render-td.outputs.task-definition }}
          service: \${{ matrix.service.ecs_service }}
          cluster: \${{ env.ECS_CLUSTER }}
          wait-for-service-stability: true
          wait-for-minutes: 10

      - name: Verify deployment health
        if: matrix.service.name == 'web'
        run: |
          echo "Checking staging health endpoint..."
          for i in $(seq 1 12); do
            STATUS=$(curl -s -o /dev/null -w "%{http_code}" \\
              "\${{ secrets.STAGING_URL }}/api/health/" || echo "000")
            if [ "$STATUS" = "200" ]; then
              echo "::notice::Health check passed (HTTP \${STATUS})"
              exit 0
            fi
            echo "Attempt \${i}/12: HTTP \${STATUS}, retrying in 10s..."
            sleep 10
          done
          echo "::error::Health check failed after 2 minutes"
          exit 1

  # ---------------------------------------------------------------------------
  # Post-deploy: collectstatic, cache warm, Sentry release
  # ---------------------------------------------------------------------------
  post-deploy:
    name: Post-Deploy Tasks
    needs: [build-and-push, deploy-services]
    runs-on: ubuntu-latest
    steps:
      - name: Checkout code
        uses: actions/checkout@v4
        with:
          fetch-depth: 0

      - name: Configure AWS credentials
        uses: aws-actions/configure-aws-credentials@v4
        with:
          role-to-assume: \${{ secrets.AWS_DEPLOY_ROLE_ARN }}
          aws-region: \${{ env.AWS_REGION }}

      - name: Sync static files to S3
        run: |
          # Run collectstatic as a one-off ECS task
          TASK_ARN=$(aws ecs run-task \\
            --cluster \${{ env.ECS_CLUSTER }} \\
            --task-definition \${{ env.TASK_DEFINITION_WEB }} \\
            --launch-type FARGATE \\
            --network-configuration "awsvpcConfiguration={subnets=\${{ secrets.STAGING_PRIVATE_SUBNETS }},securityGroups=[\${{ secrets.STAGING_MIGRATE_SG }}],assignPublicIp=DISABLED}" \\
            --overrides '{"containerOverrides":[{"name":"web","command":["python","manage.py","collectstatic","--noinput"]}]}' \\
            --query 'tasks[0].taskArn' \\
            --output text)
          aws ecs wait tasks-stopped --cluster \${{ env.ECS_CLUSTER }} --tasks "$TASK_ARN"

      - name: Create Sentry release
        uses: getsentry/action-release@v1
        env:
          SENTRY_AUTH_TOKEN: \${{ secrets.SENTRY_AUTH_TOKEN }}
          SENTRY_ORG: \${{ secrets.SENTRY_ORG }}
          SENTRY_PROJECT: django-saas-platform
        with:
          environment: staging
          version: \${{ needs.build-and-push.outputs.image_tag }}

      - name: Invalidate CloudFront cache
        run: |
          aws cloudfront create-invalidation \\
            --distribution-id \${{ secrets.STAGING_CLOUDFRONT_ID }} \\
            --paths "/static/*" \\
            --query 'Invalidation.Id' \\
            --output text

      - name: Notify Slack
        if: always()
        uses: slackapi/slack-github-action@v1
        with:
          payload: |
            {
              "text": "\${{ job.status == 'success' && '✅' || '❌' }} Staging deploy \${{ job.status }}",
              "blocks": [
                {
                  "type": "section",
                  "text": {
                    "type": "mrkdwn",
                    "text": "\${{ job.status == 'success' && '✅' || '❌' }} *Staging Deploy \${{ job.status }}*\\n*Image:* \`\${{ needs.build-and-push.outputs.image_tag }}\`\\n*Commit:* <\${{ github.server_url }}/\${{ github.repository }}/commit/\${{ github.sha }}|\${{ github.sha }}>\\n*Author:* \${{ github.actor }}\\n*Message:* \${{ github.event.head_commit.message }}"
                  }
                }
              ]
            }
        env:
          SLACK_WEBHOOK_URL: \${{ secrets.SLACK_DEPLOY_WEBHOOK }}
          SLACK_WEBHOOK_TYPE: INCOMING_WEBHOOK

  # ---------------------------------------------------------------------------
  # E2E smoke tests against staging
  # ---------------------------------------------------------------------------
  e2e-tests:
    name: E2E Smoke Tests
    needs: [deploy-services]
    if: \${{ github.event.inputs.skip_e2e != 'true' }}
    runs-on: ubuntu-latest
    steps:
      - name: Checkout code
        uses: actions/checkout@v4

      - name: Install uv
        uses: astral-sh/setup-uv@v3
        with:
          version: "latest"

      - name: Set up Python
        run: uv python install \${{ env.PYTHON_VERSION }}

      - name: Install test dependencies
        run: uv sync --group e2e

      - name: Run E2E tests against staging
        env:
          E2E_BASE_URL: \${{ secrets.STAGING_URL }}
          E2E_API_KEY: \${{ secrets.STAGING_E2E_API_KEY }}
          E2E_TENANT_SLUG: e2e-test-tenant
        run: |
          uv run pytest tests/e2e/ \\
            --tb=short \\
            --junitxml=e2e-results.xml \\
            -v \\
            -x \\
            --timeout=120

      - name: Upload E2E results
        if: always()
        uses: actions/upload-artifact@v4
        with:
          name: e2e-test-results
          path: e2e-results.xml
          retention-days: 14

      - name: Notify on E2E failure
        if: failure()
        uses: slackapi/slack-github-action@v1
        with:
          payload: |
            {
              "text": "🚨 E2E tests failed on staging after deploy of \${{ github.sha }}",
              "blocks": [
                {
                  "type": "section",
                  "text": {
                    "type": "mrkdwn",
                    "text": "🚨 *E2E Tests Failed on Staging*\\n*Commit:* <\${{ github.server_url }}/\${{ github.repository }}/commit/\${{ github.sha }}|\${{ github.sha }}>\\n*Run:* <\${{ github.server_url }}/\${{ github.repository }}/actions/runs/\${{ github.run_id }}|View Logs>\\n*Author:* \${{ github.actor }}"
                  }
                }
              ]
            }
        env:
          SLACK_WEBHOOK_URL: \${{ secrets.SLACK_DEPLOY_WEBHOOK }}
          SLACK_WEBHOOK_TYPE: INCOMING_WEBHOOK

  # ---------------------------------------------------------------------------
  # Create GitHub deployment record
  # ---------------------------------------------------------------------------
  record-deployment:
    name: Record Deployment
    needs: [build-and-push, deploy-services, e2e-tests]
    if: always() && needs.deploy-services.result == 'success'
    runs-on: ubuntu-latest
    steps:
      - name: Create GitHub deployment
        uses: actions/github-script@v7
        with:
          script: |
            const deployment = await github.rest.repos.createDeployment({
              owner: context.repo.owner,
              repo: context.repo.repo,
              ref: context.sha,
              environment: 'staging',
              auto_merge: false,
              required_contexts: [],
              description: \`Deploy \${context.sha.substring(0, 8)} to staging\`,
              payload: {
                image_tag: '\${{ needs.build-and-push.outputs.image_tag }}',
                deployer: context.actor,
              },
            });

            const e2eResult = '\${{ needs.e2e-tests.result }}';
            const state = e2eResult === 'success' ? 'success' :
                          e2eResult === 'failure' ? 'failure' : 'success';

            await github.rest.repos.createDeploymentStatus({
              owner: context.repo.owner,
              repo: context.repo.repo,
              deployment_id: deployment.data.id,
              state: state,
              environment_url: '\${{ secrets.STAGING_URL }}',
              description: \`Image: \${{ needs.build-and-push.outputs.image_tag }}\`,
              auto_inactive: true,
            });`,

  '.gitignore': `# Python
__pycache__/
*.py[cod]
*$py.class
*.so
*.pyd

# Distribution / packaging
build/
dist/
*.egg-info/
*.egg
sdist/
wheels/
*.whl

# Virtual environments
.venv/
venv/
env/
ENV/

# uv
.python-version
uv.lock

# Django
db.sqlite3
db.sqlite3-journal
media/
staticfiles/
collected_static/
*.log

# Django migrations (keep __init__.py, ignore auto-generated during local dev)
# NOTE: Do NOT ignore migrations/ directories — they are committed to version control

# Environment variables
.env
.env.*
!.env.example

# IDE / Editor
.vscode/
.idea/
*.swp
*.swo
*~
.project
.settings/
*.sublime-project
*.sublime-workspace

# macOS
.DS_Store
.AppleDouble
.LSOverride
._*

# Linux
*~
.Trash-*

# Windows
Thumbs.db
ehthumbs.db
Desktop.ini

# pytest
.pytest_cache/
.coverage
.coverage.*
htmlcov/
coverage.xml
junit.xml

# mypy
.mypy_cache/
.dmypy.json
dmypy.json

# ruff
.ruff_cache/

# Celery
celerybeat-schedule
celerybeat.pid
celerybeat-schedule.db

# Redis dump
dump.rdb

# Docker
docker-compose.override.yml

# Terraform
.terraform/
*.tfstate
*.tfstate.*
*.tfvars
!*.tfvars.example
.terraform.lock.hcl

# Secrets and credentials (SOC 2 — never commit secrets)
*.pem
*.key
*.crt
*.p12
*.pfx
credentials.json
service-account*.json
secrets.yaml
secrets.yml

# Stripe CLI
.stripe/

# Jupyter / IPython (if used for data exploration)
.ipynb_checkpoints/
*.ipynb

# Sentry CLI
.sentryclirc

# Node (if frontend assets exist)
node_modules/
package-lock.json
yarn.lock

# Documentation build artifacts
docs/_build/
site/`,

  '.mcp.json': `{
  "mcpServers": {
    "github": {
      "command": "npx",
      "args": ["-y", "@modelcontextprotocol/server-github"],
      "env": {
        "GITHUB_PERSONAL_ACCESS_TOKEN": "\${GITHUB_TOKEN}"
      },
      "description": "GitHub Issues, PRs, and repository operations for django-saas-platform"
    },
    "slack": {
      "command": "npx",
      "args": ["-y", "@modelcontextprotocol/server-slack"],
      "env": {
        "SLACK_BOT_TOKEN": "\${SLACK_BOT_TOKEN}",
        "SLACK_TEAM_ID": "\${SLACK_TEAM_ID}"
      },
      "description": "Slack integration for team communication — #saas-platform, #saas-alerts, #saas-deployments channels"
    },
    "sentry": {
      "command": "npx",
      "args": ["-y", "@modelcontextprotocol/server-sentry"],
      "env": {
        "SENTRY_AUTH_TOKEN": "\${SENTRY_AUTH_TOKEN}",
        "SENTRY_ORG": "\${SENTRY_ORG}",
        "SENTRY_PROJECT": "django-saas-platform"
      },
      "description": "Sentry error tracking and performance monitoring for production and staging environments"
    },
    "postgres": {
      "command": "npx",
      "args": ["-y", "@modelcontextprotocol/server-postgres"],
      "env": {
        "POSTGRES_CONNECTION_STRING": "\${DATABASE_URL}"
      },
      "description": "PostgreSQL read-only access for schema inspection and query analysis — never use against production"
    },
    "filesystem": {
      "command": "npx",
      "args": [
        "-y",
        "@modelcontextprotocol/server-filesystem",
        "src/",
        "config/",
        "tests/",
        "docs/",
        "scripts/",
        "templates/",
        "playbook/"
      ],
      "description": "Scoped filesystem access to project source, config, tests, docs, and scripts directories"
    },
    "fetch": {
      "command": "npx",
      "args": ["-y", "@modelcontextprotocol/server-fetch"],
      "description": "HTTP fetch for Stripe API docs, Django documentation, and external references"
    },
    "memory": {
      "command": "npx",
      "args": ["-y", "@modelcontextprotocol/server-memory"],
      "description": "Persistent memory for tracking tenant architecture decisions, billing integration state, and cross-session context"
    }
  }
}`,

  'CLAUDE.md': `# CLAUDE.md — Django SaaS Platform

## Project Overview

Multi-tenant SaaS platform built with Django 5.0, DRF, Strawberry GraphQL, Celery, and Stripe billing. PostgreSQL with row-level security for tenant isolation. SOC 2 and GDPR compliant.

## Quick Commands

\`\`\`bash
# Dependencies
uv sync

# Run dev server
uv run python manage.py runserver

# Run tests
uv run pytest
uv run pytest tests/billing/ -v          # specific app
uv run pytest -k "test_tenant" --tb=short # by keyword

# Lint & format
uv run ruff check src/ tests/
uv run ruff format src/ tests/
uv run mypy src/

# Celery worker & beat
celery -A config worker -l info
celery -A config beat -l info

# Database
uv run python manage.py migrate
uv run python manage.py makemigrations

# OpenAPI schema
uv run python manage.py spectacular --file schema.yml
\`\`\`

## Architecture

Modular monolith — each Django app is self-contained with models, serializers, views, services, and tests.

\`\`\`
src/
  accounts/       # Users, auth, tenant membership
  tenants/        # Tenant model, middleware, RLS policies
  billing/        # Stripe subscriptions, invoices, usage metering
  api/            # DRF viewsets, Strawberry GraphQL schema
  core/           # Base models, tenant-aware managers, permissions
  notifications/  # Email (SES), in-app, webhook dispatch
  tasks/          # Celery task definitions
  utils/          # Shared helpers, decorators
config/           # Django settings (base/dev/staging/prod)
tests/            # Mirrors src/ structure
\`\`\`

## Critical Patterns

### Tenant Isolation (MANDATORY)
- **All tenant data queries MUST use the tenant-aware manager** — never raw \`objects.all()\` on tenant-scoped models
- PostgreSQL row-level security enforces isolation at the DB level
- Middleware sets \`current_tenant\` on the request; services read from there
- Verify tenant context in every view and Celery task

### Service Layer
- Business logic lives in \`services.py\` within each app, NOT in views or serializers
- Views are thin — validate input, call service, return response
- Prefer explicit service calls over Django signals

### Celery Tasks
- All tasks MUST be idempotent — safe to retry on failure
- Accept primitive arguments (IDs, not model instances)
- Re-fetch objects inside the task; set tenant context before DB access
- Defined in \`src/tasks/\` or \`<app>/tasks.py\`

### Stripe / Billing
- Webhook handlers in \`src/billing/webhooks.py\` — must verify signatures and be idempotent
- Use Stripe event ID for deduplication
- Subscription lifecycle: \`trial → active → past_due → canceled\`
- Usage metering records are batched and sent via Celery

### API Design
- REST endpoints via DRF with \`drf-spectacular\` for OpenAPI 3.1 schema
- GraphQL via Strawberry — read-heavy queries; mutations for writes
- All endpoints require authentication; tenant scoping enforced in permissions
- URL convention: \`/api/v1/<resource>/\` (kebab-case)

## Coding Standards

- **Python 3.12+** — type hints required on all public functions
- **ruff** for linting and formatting (replaces flake8, isort, black)
- **mypy strict mode** — no \`Any\` without justification
- **Max file length**: 300 lines — split into modules if exceeded
- **Naming**: \`snake_case\` functions/files, \`PascalCase\` classes, \`SCREAMING_SNAKE_CASE\` constants
- **Tests**: pytest + factory_boy fixtures, 85% coverage minimum
- **Commits**: conventional format — \`feat:\`, \`fix:\`, \`chore:\`, \`docs:\`
- **Branches**: \`type/TICKET-desc\` (e.g., \`feat/SAAS-42-add-tenant-onboarding\`)

## Sensitive Paths — Extra Caution Required

- \`src/billing/**\` — payment processing, Stripe keys, subscription logic
- \`src/accounts/**\` — authentication, password handling, tokens
- \`config/production/**\` — production secrets and infrastructure config
- \`.env*\` — environment variables, API keys

Changes to these paths require senior/lead review. Never log secrets, tokens, or PII.

## Security & Compliance

- **SOC 2**: audit logging on all state-changing operations, access controls enforced
- **GDPR**: support right to deletion, data export, consent tracking, data residency awareness
- Tenant data must never leak across boundaries — test for this explicitly
- Stripe webhook signatures must always be verified
- Use \`django-environ\` + Pydantic settings for config — no hardcoded secrets

## Test Conventions

\`\`\`python
# Use factory_boy for fixtures
from tests.factories import TenantFactory, UserFactory

def test_tenant_user_access(db):
    tenant = TenantFactory()
    user = UserFactory(tenant=tenant)
    # ...
\`\`\`

- Place tests in \`tests/<app>/\` mirroring \`src/<app>/\`
- Integration tests for Stripe use VCR cassettes or mocked responses
- Celery tasks tested with \`CELERY_ALWAYS_EAGER=True\`

## CI Pipeline

Lint → Type Check → Unit Tests → Integration Tests → Security Scan → Docker Build → Deploy Staging → E2E → Deploy Production

AI-generated code is flagged in PRs. CODEOWNERS enforced on protected paths.

## Key Config Files

- \`pyproject.toml\` — dependencies, ruff/mypy/pytest config
- \`config/settings/base.py\` — shared Django settings
- \`docker-compose.yml\` — local dev (PostgreSQL, Redis, Celery)
- \`.github/workflows/\` — CI/CD pipelines`,

  'README.md': `# Django SaaS Platform

[![CI](https://github.com/your-org/django-saas-platform/actions/workflows/ci.yml/badge.svg)](https://github.com/your-org/django-saas-platform/actions/workflows/ci.yml)
[![Deploy Staging](https://github.com/your-org/django-saas-platform/actions/workflows/deploy-staging.yml/badge.svg)](https://github.com/your-org/django-saas-platform/actions/workflows/deploy-staging.yml)
[![Coverage](https://img.shields.io/badge/coverage-85%25+-brightgreen)](https://github.com/your-org/django-saas-platform)
[![Python 3.12+](https://img.shields.io/badge/python-3.12+-blue.svg)](https://www.python.org/downloads/)
[![Django 5.0](https://img.shields.io/badge/django-5.0-green.svg)](https://www.djangoproject.com/)
[![Code style: ruff](https://img.shields.io/badge/code%20style-ruff-000000.svg)](https://github.com/astral-sh/ruff)
[![License](https://img.shields.io/badge/license-Proprietary-red.svg)]()
[![SOC 2](https://img.shields.io/badge/compliance-SOC%202-blue.svg)]()
[![GDPR](https://img.shields.io/badge/compliance-GDPR-blue.svg)]()

A multi-tenant SaaS platform built with Django 5.0, featuring subscription billing via Stripe, async task processing with Celery, and dual REST/GraphQL APIs. Designed for SOC 2 and GDPR compliance with row-level tenant isolation in PostgreSQL.

---

## Table of Contents

- [Features](#features)
- [Architecture](#architecture)
- [Tech Stack](#tech-stack)
- [Prerequisites](#prerequisites)
- [Quickstart](#quickstart)
- [Project Structure](#project-structure)
- [Multi-Tenancy](#multi-tenancy)
- [Billing & Subscriptions](#billing--subscriptions)
- [API](#api)
- [Background Tasks](#background-tasks)
- [Testing](#testing)
- [Configuration](#configuration)
- [Deployment](#deployment)
- [Compliance](#compliance)
- [Contributing](#contributing)
- [Team](#team)

---

## Features

- **Multi-Tenancy** — Row-level security in PostgreSQL with tenant-aware query managers. Complete data isolation between tenants.
- **Subscription Billing** — Stripe integration for plan management, subscription lifecycle, usage-based metering, invoicing, and payment method management.
- **Dual API** — REST API via Django REST Framework with OpenAPI 3.1 docs (drf-spectacular) and GraphQL via Strawberry.
- **Async Task Processing** — Celery 5 with Redis broker for email delivery, report generation, billing sync, webhook dispatch, and scheduled maintenance.
- **Role-Based Access Control** — Granular permissions per tenant with owner, admin, member, and viewer roles.
- **Tenant Onboarding** — Self-service signup flow with plan selection, Stripe customer creation, and workspace provisioning.
- **White-Label Support** — Custom domains, branding (logo, colors), and email templates per tenant.
- **Audit Logging** — Immutable audit trail for all data mutations, authentication events, and billing actions.
- **Notifications** — Email (AWS SES), in-app notifications, and outbound webhook dispatch with retry logic.
- **GDPR Compliance** — Data residency controls, consent management, right-to-deletion workflows, and data export.
- **SOC 2 Controls** — Encryption at rest and in transit, access logging, secret management, and vulnerability scanning.

---

## Architecture

\`\`\`
┌─────────────────────────────────────────────────────────────────┐
│                        Load Balancer (ALB)                      │
├────────────────────────┬────────────────────────────────────────┤
│     REST API (DRF)     │         GraphQL (Strawberry)           │
├────────────────────────┴────────────────────────────────────────┤
│                    Django Application (ECS)                      │
│  ┌──────────┬──────────┬──────────┬──────────┬────────────────┐ │
│  │ accounts │ tenants  │ billing  │   api    │ notifications  │ │
│  ├──────────┼──────────┼──────────┼──────────┼────────────────┤ │
│  │          core (base models, permissions, middleware)        │ │
│  └────────────────────────────────────────────────────────────┘ │
├─────────────────────────────────────────────────────────────────┤
│  Celery Workers (ECS)  │  Celery Beat (ECS)                    │
├────────────┬────────────┬───────────────────────────────────────┤
│ PostgreSQL │   Redis    │        AWS Services                   │
│  (RDS)     │(ElastiCache│  (S3, SES, CloudFront, Secrets Mgr)  │
│  + RLS     │  + broker) │                                       │
└────────────┴────────────┴───────────────────────────────────────┘
\`\`\`

For detailed architecture documentation, see [docs/ARCHITECTURE.md](docs/ARCHITECTURE.md).

---

## Tech Stack

| Layer | Technology |
|---|---|
| Language | Python 3.12+ (type hints required) |
| Framework | Django 5.0, Django REST Framework, Strawberry GraphQL |
| Task Queue | Celery 5 (Redis broker, beat scheduler) |
| Database | PostgreSQL 16 (row-level security) |
| Cache/Broker | Redis 7 |
| Billing | Stripe (subscriptions, metering, webhooks) |
| Cloud | AWS (ECS, RDS, ElastiCache, S3, SES, CloudFront) |
| Infrastructure | Docker, Kubernetes, Terraform |
| Package Manager | uv |
| Linting | ruff |
| Type Checking | mypy (strict mode) |
| Testing | pytest, factory_boy, pytest-django, pytest-asyncio |
| API Docs | drf-spectacular (OpenAPI 3.1) |
| Monitoring | Sentry, Prometheus, Grafana |

---

## Prerequisites

- **Python 3.12+**
- **uv** — [Install uv](https://docs.astral.sh/uv/getting-started/installation/)
- **Docker & Docker Compose** — for local PostgreSQL, Redis
- **Stripe CLI** — for webhook testing (\`brew install stripe/stripe-cli/stripe\`)

---

## Quickstart

### 1. Clone and install dependencies

\`\`\`bash
git clone git@github.com:your-org/django-saas-platform.git
cd django-saas-platform

# Install Python dependencies
uv sync

# Install git hooks
cp git-hooks/* .git/hooks/
chmod +x .git/hooks/*
\`\`\`

### 2. Start infrastructure services

\`\`\`bash
docker compose up -d postgres redis
\`\`\`

This starts:
- **PostgreSQL 16** on \`localhost:5432\`
- **Redis 7** on \`localhost:6379\`

### 3. Configure environment

\`\`\`bash
cp .env.example .env
\`\`\`

Edit \`.env\` with your local settings:

\`\`\`env
# Django
DJANGO_SETTINGS_MODULE=config.settings.development
SECRET_KEY=your-dev-secret-key
DEBUG=True
ALLOWED_HOSTS=localhost,127.0.0.1

# Database
DATABASE_URL=postgres://saas_user:saas_pass@localhost:5432/saas_platform

# Redis
REDIS_URL=redis://localhost:6379/0
CELERY_BROKER_URL=redis://localhost:6379/1

# Stripe (use test keys)
STRIPE_SECRET_KEY=sk_test_...
STRIPE_PUBLISHABLE_KEY=pk_test_...
STRIPE_WEBHOOK_SECRET=whsec_...

# AWS (local development — use localstack or leave empty)
AWS_ACCESS_KEY_ID=
AWS_SECRET_ACCESS_KEY=
AWS_S3_BUCKET_NAME=saas-platform-dev
\`\`\`

### 4. Initialize the database

\`\`\`bash
# Run migrations (includes RLS policy setup)
uv run python manage.py migrate

# Create a superuser
uv run python manage.py createsuperuser

# Seed development data (plans, sample tenant)
uv run python manage.py seed_dev_data
\`\`\`

### 5. Start the application

\`\`\`bash
# Terminal 1 — Django dev server
uv run python manage.py runserver

# Terminal 2 — Celery worker
uv run celery -A config worker --loglevel=info

# Terminal 3 — Celery beat (scheduled tasks)
uv run celery -A config beat --loglevel=info

# Terminal 4 — Stripe webhook forwarding (for local development)
stripe listen --forward-to localhost:8000/api/v1/billing/webhooks/stripe/
\`\`\`

### 6. Verify everything is running

- **Django Admin**: http://localhost:8000/admin/
- **REST API**: http://localhost:8000/api/v1/
- **GraphQL Playground**: http://localhost:8000/graphql/
- **OpenAPI Schema**: http://localhost:8000/api/v1/schema/
- **Swagger UI**: http://localhost:8000/api/v1/schema/swagger-ui/
- **ReDoc**: http://localhost:8000/api/v1/schema/redoc/

---

## Project Structure

\`\`\`
django-saas-platform/
├── src/
│   ├── accounts/           # User management, authentication, tenant association
│   │   ├── models.py       # CustomUser, UserProfile
│   │   ├── serializers.py  # User registration, profile serializers
│   │   ├── views.py        # Auth views, user management
│   │   ├── services.py     # User service layer
│   │   └── tests/
│   ├── tenants/            # Multi-tenancy core
│   │   ├── models.py       # Tenant, TenantMembership, Domain
│   │   ├── middleware.py   # Tenant resolution middleware
│   │   ├── managers.py     # Tenant-aware query managers
│   │   ├── rls.py          # Row-level security policy management
│   │   ├── services.py     # Tenant provisioning, onboarding
│   │   └── tests/
│   ├── billing/            # Stripe integration (SENSITIVE)
│   │   ├── models.py       # Subscription, Plan, Invoice, UsageRecord
│   │   ├── services.py     # Stripe sync, subscription lifecycle
│   │   ├── webhooks.py     # Stripe webhook handlers (idempotent)
│   │   ├── tasks.py        # Async billing sync, metering
│   │   └── tests/
│   ├── api/                # API layer
│   │   ├── v1/             # REST API v1 (DRF viewsets, routers)
│   │   ├── graphql/        # Strawberry GraphQL schema, resolvers
│   │   └── permissions.py  # Tenant-scoped DRF permissions
│   ├── core/               # Shared foundation
│   │   ├── models.py       # TenantAwareModel, TimestampedModel, AuditLog
│   │   ├── permissions.py  # RBAC permission classes
│   │   ├── middleware.py   # Request logging, security headers
│   │   └── managers.py     # TenantAwareManager (enforces tenant filtering)
│   ├── notifications/      # Communication layer
│   │   ├── models.py       # Notification, WebhookEndpoint, WebhookDelivery
│   │   ├── services.py     # Email dispatch (SES), webhook delivery
│   │   └── tasks.py        # Async email, webhook retry
│   ├── tasks/              # Celery task definitions
│   │   ├── billing.py      # Stripe sync, invoice generation
│   │   ├── reports.py      # Usage reports, analytics
│   │   └── maintenance.py  # Cleanup, data retention
│   └── utils/              # Shared utilities
│       ├── logging.py      # Structured logging with tenant context
│       ├── decorators.py   # @tenant_required, @idempotent_task
│       └── encryption.py   # Field-level encryption helpers
├── config/                 # Django settings
│   ├── settings/
│   │   ├── base.py         # Shared settings
│   │   ├── development.py  # Local dev overrides
│   │   ├── staging.py      # Staging environment
│   │   └── production.py   # Production (SENSITIVE)
│   ├── urls.py             # Root URL configuration
│   ├── celery.py           # Celery app configuration
│   └── wsgi.py / asgi.py
├── tests/                  # Test suite (mirrors src/ structure)
│   ├── conftest.py         # Shared fixtures, tenant factory
│   ├── accounts/
│   ├── tenants/
│   ├── billing/
│   └── integration/        # Cross-app integration tests
├── scripts/                # Operational scripts
│   ├── seed_dev_data.py    # Development data seeding
│   ├── stripe_sync.py      # Manual Stripe sync
│   └── tenant_migrate.py   # Tenant-specific migrations
├── docs/                   # Documentation
│   ├── ARCHITECTURE.md     # System architecture
│   ├── ONBOARDING.md       # Developer onboarding guide
│   ├── CONTRIBUTING.md     # Contribution guidelines
│   └── AI-USAGE-POLICY.md  # AI-assisted development policy
├── templates/              # Django templates
├── static/                 # Static assets
├── .claude/                # Claude Code configuration
│   ├── settings.json
│   └── rules/              # Project-specific rules
├── .github/                # GitHub configuration
│   ├── workflows/          # CI/CD pipelines
│   ├── CODEOWNERS
│   └── PULL_REQUEST_TEMPLATE.md
├── plugin/                 # CodeForge plugin
│   └── codeforge-django-saas/
├── playbook/               # Development methodology
├── docker-compose.yml
├── Dockerfile
├── pyproject.toml
├── ruff.toml
├── mypy.ini
└── .env.example
\`\`\`

---

## Multi-Tenancy

### How Tenant Isolation Works

Every data model that stores tenant-specific data extends \`TenantAwareModel\`, which includes a \`tenant\` foreign key and uses \`TenantAwareManager\` as the default manager. This manager automatically filters queries by the current tenant set in the request middleware.

\`\`\`python
from core.models import TenantAwareModel

class Project(TenantAwareModel):
    name = models.CharField(max_length=255)
    # tenant field is inherited — all queries are automatically scoped
\`\`\`

### Row-Level Security (RLS)

PostgreSQL RLS policies provide a database-level safety net. Even if application code bypasses the tenant-aware manager, the database enforces isolation:

\`\`\`sql
-- Applied via migration in tenants/migrations/
ALTER TABLE projects ENABLE ROW LEVEL SECURITY;
CREATE POLICY tenant_isolation ON projects
    USING (tenant_id = current_setting('app.current_tenant_id')::uuid);
\`\`\`

### Tenant Resolution

The \`TenantMiddleware\` resolves the current tenant from:

1. **Subdomain** — \`acme.app.example.com\` → Tenant "Acme"
2. **Custom domain** — \`app.acme.com\` → Tenant "Acme" (white-label)
3. **API header** — \`X-Tenant-ID\` header (for API clients)
4. **JWT claim** — \`tenant_id\` embedded in the access token

### Tenant Onboarding Flow

\`\`\`
User Signup → Create User → Select Plan → Create Stripe Customer
    → Provision Tenant → Setup RLS → Create Membership (owner role)
    → Send Welcome Email → Redirect to Dashboard
\`\`\`

This is orchestrated by \`tenants/services.py:TenantOnboardingService\` — not signals.

---

## Billing & Subscriptions

### Stripe Integration

All billing logic lives in \`src/billing/\` and follows these principles:

- **Stripe is the source of truth** for subscription state
- **Webhook handlers are idempotent** — processing the same event twice produces the same result
- **All Stripe API calls go through the service layer** (\`billing/services.py\`)
- **Webhook signatures are always verified** before processing

### Subscription Lifecycle

\`\`\`
Plan Selection → Create Stripe Subscription → Webhook: invoice.paid
    → Activate Subscription → Usage Metering (periodic)
    → Webhook: invoice.upcoming → Webhook: invoice.paid (renewal)
    → Cancel Request → Webhook: customer.subscription.deleted → Deactivate
\`\`\`

### Usage-Based Metering

\`\`\`python
# Report usage for a tenant (called from Celery task)
from billing.services import BillingService

BillingService.report_usage(
    tenant=tenant,
    metric="api_calls",
    quantity=1500,
    timestamp=now(),
)
\`\`\`

### Webhook Handling

\`\`\`bash
# Local development — forward Stripe webhooks
stripe listen --forward-to localhost:8000/api/v1/billing/webhooks/stripe/

# Handled events:
# - checkout.session.completed
# - customer.subscription.created/updated/deleted
# - invoice.paid/payment_failed
# - customer.updated
# - payment_method.attached/detached
\`\`\`

> ⚠️ **Sensitive Path**: \`src/billing/\` requires review from \`@your-org/billing-team\` (see [CODEOWNERS](.github/CODEOWNERS)).

---

## API

### REST API (Django REST Framework)

All REST endpoints are versioned under \`/api/v1/\` and documented with drf-spectacular:

\`\`\`bash
# Browse the API
open http://localhost:8000/api/v1/

# OpenAPI schema (JSON)
curl http://localhost:8000/api/v1/schema/

# Swagger UI
open http://localhost:8000/api/v1/schema/swagger-ui/
\`\`\`

Example endpoints:

\`\`\`
POST   /api/v1/auth/login/
POST   /api/v1/auth/register/
GET    /api/v1/tenants/
POST   /api/v1/tenants/
GET    /api/v1/tenants/{id}/members/
GET    /api/v1/billing/subscriptions/
POST   /api/v1/billing/subscriptions/
GET    /api/v1/billing/invoices/
POST   /api/v1/billing/webhooks/stripe/
\`\`\`

### GraphQL (Strawberry)

\`\`\`bash
# GraphQL Playground
open http://localhost:8000/graphql/
\`\`\`

\`\`\`graphql
query {
  currentTenant {
    id
    name
    subscription {
      plan { name }
      status
      currentPeriodEnd
    }
    members {
      user { email }
      role
    }
  }
}
\`\`\`

### Authentication

- **JWT tokens** (access + refresh) for API clients
- **Session auth** for browser-based access (Django admin, GraphQL playground)
- All tokens include \`tenant_id\` claim for tenant scoping

---

## Background Tasks

### Celery Configuration

\`\`\`python
# config/celery.py — auto-discovers tasks from all Django apps
app.autodiscover_tasks(["tasks", "billing", "notifications"])
\`\`\`

### Key Tasks

| Task | Schedule | Description |
|---|---|---|
| \`billing.sync_stripe_subscriptions\` | Every 6 hours | Reconcile local subscription state with Stripe |
| \`billing.report_usage_metrics\` | Every hour | Push usage records to Stripe metering |
| \`billing.process_failed_payments\` | Every 4 hours | Retry failed payment intents |
| \`notifications.send_email\` | On demand | Async email delivery via SES |
| \`notifications.dispatch_webhook\` | On demand | Deliver outbound webhooks with retry |
| \`tasks.generate_usage_report\` | Daily 2am UTC | Generate tenant usage reports |
| \`tasks.cleanup_expired_sessions\` | Daily 3am UTC | Remove expired sessions and tokens |
| \`tasks.enforce_data_retention\` | Weekly | GDPR data retention enforcement |

### Idempotency

All Celery tasks must be idempotent. Use the \`@idempotent_task\` decorator:

\`\`\`python
from utils.decorators import idempotent_task

@idempotent_task(name="billing.sync_subscription")
def sync_subscription(subscription_id: str) -> None:
    """Sync a single subscription from Stripe. Safe to retry."""
    ...
\`\`\`

### Running Workers

\`\`\`bash
# Default worker (all queues)
uv run celery -A config worker --loglevel=info

# Billing-specific worker (dedicated queue)
uv run celery -A config worker --loglevel=info -Q billing

# Beat scheduler (periodic tasks)
uv run celery -A config beat --loglevel=info --scheduler django_celery_beat.schedulers:DatabaseScheduler
\`\`\`

---

## Testing

### Running Tests

\`\`\`bash
# Full test suite
uv run pytest

# With coverage report
uv run pytest --cov=src --cov-report=html --cov-fail-under=85

# Specific app
uv run pytest tests/billing/

# Only unit tests (exclude integration)
uv run pytest -m "not integration"

# Only integration tests
uv run pytest -m integration

# Run in parallel
uv run pytest -n auto
\`\`\`

### Test Fixtures (factory_boy)

\`\`\`python
# tests/conftest.py provides shared fixtures
from tests.factories import TenantFactory, UserFactory, SubscriptionFactory

def test_tenant_member_access(tenant_client):
    """tenant_client fixture provides an authenticated API client scoped to a test tenant."""
    response = tenant_client.get("/api/v1/tenants/me/")
    assert response.status_code == 200
\`\`\`

### Code Quality

\`\`\`bash
# Linting
uv run ruff check src/ tests/

# Auto-fix lint issues
uv run ruff check --fix src/ tests/

# Formatting
uv run ruff format src/ tests/

# Type checking
uv run mypy src/

# All checks (mirrors CI)
uv run ruff check src/ tests/ && uv run ruff format --check src/ tests/ && uv run mypy src/ && uv run pytest --cov=src --cov-fail-under=85
\`\`\`

---

## Configuration

### Environment Variables

Configuration uses \`django-environ\` with Pydantic validation. All settings are loaded from environment variables with sensible defaults for development.

| Variable | Required | Description |
|---|---|---|
| \`DJANGO_SETTINGS_MODULE\` | Yes | Settings module path |
| \`SECRET_KEY\` | Yes | Django secret key |
| \`DATABASE_URL\` | Yes | PostgreSQL connection string |
| \`REDIS_URL\` | Yes | Redis connection string |
| \`CELERY_BROKER_URL\` | Yes | Celery broker URL (Redis) |
| \`STRIPE_SECRET_KEY\` | Yes | Stripe API secret key |
| \`STRIPE_PUBLISHABLE_KEY\` | Yes | Stripe publishable key |
| \`STRIPE_WEBHOOK_SECRET\` | Yes | Stripe webhook signing secret |
| \`AWS_ACCESS_KEY_ID\` | Prod | AWS credentials |
| \`AWS_SECRET_ACCESS_KEY\` | Prod | AWS credentials |
| \`AWS_S3_BUCKET_NAME\` | Prod | S3 bucket for file storage |
| \`SENTRY_DSN\` | Prod | Sentry error tracking DSN |
| \`ALLOWED_HOSTS\` | Prod | Comma-separated allowed hosts |

### Settings Hierarchy

\`\`\`
config/settings/base.py          # Shared defaults
config/settings/development.py   # DEBUG=True, local services
config/settings/staging.py       # Staging AWS resources
config/settings/production.py    # Production (SENSITIVE — requires review)
\`\`\`

---

## Deployment

### Docker

\`\`\`bash
# Build the image
docker build -t django-saas-platform .

# Run locally with Docker Compose (full stack)
docker compose up
\`\`\`

### AWS Deployment

Infrastructure is managed with Terraform. Deployments are automated via GitHub Actions:

- **Staging**: Auto-deploys on merge to \`main\` ([deploy-staging.yml](.github/workflows/deploy-staging.yml))
- **Production**: Manual approval required ([deploy-production.yml](.github/workflows/deploy-production.yml))

\`\`\`
GitHub Actions → Build Docker Image → Push to ECR
    → Deploy to ECS (Staging) → Run E2E Tests
    → Manual Approval → Deploy to ECS (Production)
\`\`\`

### Infrastructure Components

| Service | AWS Resource |
|---|---|
| Application | ECS Fargate |
| Database | RDS PostgreSQL 16 |
| Cache/Broker | ElastiCache Redis 7 |
| File Storage | S3 |
| Email | SES |
| CDN | CloudFront |
| Secrets | Secrets Manager |
| DNS | Route 53 |
| Monitoring | CloudWatch + Sentry |

---

## Compliance

### SOC 2

- **Encryption**: TLS 1.3 in transit, AES-256 at rest (RDS, S3)
- **Access Control**: RBAC with tenant isolation, audit logging on all mutations
- **Monitoring**: Sentry for errors, Prometheus/Grafana for metrics, CloudWatch for infrastructure
- **Secret Management**: AWS Secrets Manager, no secrets in code or environment files in production
- **Vulnerability Scanning**: Automated in CI via \`safety\` and \`bandit\`

### GDPR

- **Data Residency**: Tenant data stored in configured AWS region
- **Consent Management**: Explicit consent tracking for data processing
- **Right to Deletion**: Automated data deletion workflow via \`tasks.enforce_data_retention\`
- **Data Export**: Tenant data export in machine-readable format (JSON)
- **Data Processing Agreements**: DPA templates available for enterprise tenants
- **Audit Trail**: Immutable audit log for all data access and mutations

> See [docs/ARCHITECTURE.md](docs/ARCHITECTURE.md) for detailed compliance architecture.

---

## Contributing

See [docs/CONTRIBUTING.md](docs/CONTRIBUTING.md) for:

- Branch naming conventions (\`type/SAAS-42-description\`)
- Conventional commit format
- PR requirements and review process
- Code quality standards

For AI-assisted development guidelines, see [docs/AI-USAGE-POLICY.md](docs/AI-USAGE-POLICY.md).

New to the project? Start with [docs/ONBOARDING.md](docs/ONBOARDING.md).

---

## Team

### Code Ownership

Code ownership is enforced via [CODEOWNERS](.github/CODEOWNERS). Key areas:

| Area | Team |
|---|---|
| \`src/billing/**\` | \`@your-org/billing-team\` |
| \`src/accounts/**\`, \`src/tenants/**\` | \`@your-org/auth-team\` |
| \`config/production/**\` | \`@your-org/platform-leads\` |
| \`.github/workflows/**\` | \`@your-org/devops\` |
| \`src/core/**\` | \`@your-org/platform-leads\` |

### Communication

- **Slack**: \`#saas-platform\` (general), \`#saas-platform-alerts\` (monitoring)
- **GitHub Issues**: Feature requests, bug reports, and AI task tracking
- **Notion**: Architecture decisions, meeting notes, roadmap

---

## License

Proprietary — All rights reserved. See LICENSE file for details.`,

  'docs/AI-USAGE-POLICY.md': `# AI Usage Policy — django-saas-platform

## Purpose

This document defines when and how developers on the django-saas-platform team may use Claude (and other AI coding assistants) to generate, modify, or review code. It balances productivity gains with the security, compliance, and quality requirements of a multi-tenant SaaS platform operating under SOC 2 and GDPR obligations.

---

## 1. General Principles

1. **AI is a tool, not an author.** The developer who submits code is responsible for its correctness, security, and compliance — regardless of whether AI generated it.
2. **Transparency over speed.** All AI-generated or AI-assisted code must be flagged in the PR (see Section 5).
3. **Sensitive paths require human expertise.** Billing, authentication, tenant isolation, and production configuration changes always require senior human review.
4. **No secrets in prompts.** Never paste API keys, customer data, PII, database credentials, or Stripe webhook signing secrets into AI prompts.
5. **Verify, don't trust.** AI output must pass the same CI pipeline (ruff, mypy strict, pytest ≥ 85% coverage, security scan) as hand-written code.

---

## 2. Approved Use Cases

### 2.1 Encouraged — Use Freely

| Activity | Examples |
|---|---|
| Scaffolding new Django apps | \`python manage.py startapp\`, model/serializer/viewset boilerplate |
| Writing and expanding tests | pytest fixtures with factory_boy, parametrized test cases |
| Generating DRF serializers and viewsets | Standard CRUD for non-sensitive models |
| Writing Celery task skeletons | Idempotent task structure, retry configuration |
| Documentation and docstrings | Module docstrings, API endpoint descriptions, ADRs |
| Ruff/mypy fixes | Auto-fixing lint errors, adding type annotations |
| Django management commands | Data cleanup scripts, one-off migrations in \`scripts/\` |
| Strawberry GraphQL type definitions | Query/mutation types for non-billing, non-auth schemas |
| Utility functions in \`src/utils/\` | Date helpers, slug generators, pagination utilities |
| CI/CD workflow tweaks | GitHub Actions step additions, Docker build optimizations |

### 2.2 Permitted with Caution

| Activity | Requirements |
|---|---|
| Database migrations | AI may draft; developer must review SQL with \`sqlmigrate\`, verify tenant isolation |
| API permission classes | Must be reviewed against RBAC matrix in \`docs/ARCHITECTURE.md\` |
| Celery beat schedules | Verify idempotency and tenant-scoping before merging |
| Notification templates | Check for PII leakage in email/webhook payloads |
| Django signals | Prefer explicit service layer calls; justify signal use in PR description |
| Terraform/infrastructure changes | AI may draft; requires lead review and plan output verification |

### 2.3 Restricted — Senior/Lead Review Required

These paths are flagged in \`CODEOWNERS\` and require **at least one approval from a senior or lead engineer** plus the standard review:

| Path / Area | Why Restricted | Minimum Reviewer |
|---|---|---|
| \`src/billing/**\` | Stripe integration, subscription lifecycle, revenue impact | @billing-team lead |
| \`src/accounts/**\` (auth flows) | Authentication, password reset, token management | @security-team lead |
| \`src/tenants/**\` | Row-level security, tenant isolation, data leakage risk | @platform-team lead |
| \`src/core/permissions.py\` | RBAC enforcement across all endpoints | @platform-team lead |
| \`src/core/middleware.py\` | Tenant context injection, security middleware | @platform-team lead |
| \`config/production/**\` | Production Django settings, secrets references | @devops-team lead |
| \`.env*\`, \`config/settings/production.py\` | Credentials, feature flags | @devops-team lead |
| Database migrations touching \`tenants\`, \`billing\`, \`accounts\` | Schema changes to sensitive tables | Domain lead + DBA |

> **Rule:** If Claude generates code in a restricted path, the PR description must explicitly state what was AI-generated, what was human-modified, and the rationale for using AI assistance.

---

## 3. Prohibited Uses

The following uses of AI assistants are **not permitted** on this project:

| Prohibited Activity | Reason |
|---|---|
| Pasting customer data, PII, or production database content into prompts | GDPR violation, SOC 2 control failure |
| Pasting Stripe API keys, webhook secrets, or signing keys | Credential exposure |
| Pasting \`.env\` file contents or production config values | Secret leakage |
| Using AI to generate cryptographic implementations | Use established libraries (\`cryptography\`, Django's built-in hashers) |
| Generating row-level security policies without human design | Tenant isolation is a security boundary; must be human-designed |
| Auto-merging AI-generated PRs without human review | All PRs require at least 1 human approval |
| Using AI to bypass or weaken security controls | SOC 2 compliance requirement |
| Generating fake compliance documentation or audit evidence | Legal and regulatory violation |

---

## 4. Workflow for AI-Assisted Development

### Step 1: Check the Scope

\`\`\`
Is the file in a restricted path (billing, auth, tenants, production config)?
├── YES → Proceed with extra caution. Plan to request senior/lead review.
└── NO  → Proceed normally.
\`\`\`

### Step 2: Generate Code with Claude

- Use the project's \`CLAUDE.md\` as context (it is loaded automatically by Claude Code).
- Reference the relevant \`.claude/rules/\` files for coding standards.
- Provide the ticket number (e.g., \`SAAS-42\`) in your prompt for traceability.
- Keep prompts focused — one task per interaction when possible.

### Step 3: Review AI Output Locally

Before committing, verify:

\`\`\`bash
# Lint and format
uv run ruff check src/ --fix
uv run ruff format src/

# Type check (strict mode)
uv run mypy src/

# Run tests
uv run pytest tests/ --cov=src --cov-fail-under=85

# For migrations, inspect the SQL
uv run python manage.py sqlmigrate <app_label> <migration_number>
\`\`\`

### Step 4: Commit with Conventional Commit

Include the AI flag in the commit trailer:

\`\`\`
feat(tenants): add tenant invitation flow

Implement invite-by-email with expiring tokens and RBAC assignment.

Ticket: SAAS-42
AI-assisted: yes
AI-tool: claude-code
AI-scope: initial scaffolding of models, serializers, and test factories
\`\`\`

### Step 5: Open PR with AI Disclosure

Use the PR template (\`.github/PULL_REQUEST_TEMPLATE.md\`). Fill in the AI-assisted section:

- **AI-assisted**: Yes / No
- **AI tool used**: Claude Code / Claude API / Other
- **What was AI-generated**: List specific files or functions
- **What was human-modified after generation**: Describe changes
- **Sensitive path changes**: Yes / No — if yes, tag the required reviewer

### Step 6: Review and Merge

- CI must pass (lint, type check, tests, security scan).
- At least 1 human approval required.
- Restricted paths require senior/lead approval per Section 2.3.
- The \`ai-code-audit.yml\` workflow automatically labels AI-assisted PRs for tracking.

---

## 5. AI Code Labeling Standard

All AI-generated code must be identifiable for audit purposes (SOC 2 traceability).

### In Git Commits

Use the \`AI-assisted\` trailer in commit messages (enforced by \`git-hooks/commit-msg\` for flagged commits):

\`\`\`
AI-assisted: yes
AI-tool: claude-code
\`\`\`

### In Source Code (when substantial)

For files where AI generated the majority of the logic, add a comment at the top:

\`\`\`python
# AI-GENERATED: Initial implementation generated by Claude Code
# HUMAN-REVIEWED: <developer-username>, <date>
# TICKET: SAAS-42
\`\`\`

This is **required** for:
- New Django app scaffolding (models, views, serializers, URLs)
- New Celery task files
- New test files with > 10 test cases
- GraphQL schema definitions

This is **not required** for:
- Single-line fixes or type annotation additions
- Docstring generation
- Ruff auto-fixes

### In Pull Requests

The PR template includes an AI disclosure section. The \`ai-code-audit.yml\` GitHub Action scans for AI trailers and applies the \`ai-assisted\` label automatically.

---

## 6. Domain-Specific Guidelines

### 6.1 Billing Code (\`src/billing/\`)

- AI may generate Stripe webhook handler skeletons, but the **idempotency logic and event verification must be human-written or human-verified line-by-line**.
- Subscription state machine transitions (trial → active → past_due → canceled) must match the documented lifecycle in \`docs/ARCHITECTURE.md\`.
- Never hardcode Stripe price IDs or product IDs — use \`django-environ\` settings.
- Usage metering logic must be reviewed for accuracy — billing errors have direct revenue and customer trust impact.
- All billing code changes require \`@billing-team\` lead approval.

\`\`\`python
# Example: AI can scaffold this, but the verify_signature and idempotency
# logic must be human-verified
@require_POST
def stripe_webhook(request: HttpRequest) -> HttpResponse:
    payload = request.body
    sig_header = request.META.get("HTTP_STRIPE_SIGNATURE", "")
    # HUMAN-VERIFY: Signature verification and idempotency key handling
    ...
\`\`\`

### 6.2 Authentication & Authorization (\`src/accounts/\`, \`src/core/permissions.py\`)

- AI may generate serializer and viewset boilerplate for user management.
- **Password hashing, token generation, session management, and OAuth flows must use Django's built-in mechanisms** — never AI-generated custom crypto.
- Permission class logic must be cross-referenced with the RBAC matrix.
- JWT token lifetimes and refresh logic must be human-reviewed.
- All auth changes require \`@security-team\` lead approval.

### 6.3 Tenant Isolation (\`src/tenants/\`)

- AI may generate tenant-aware model managers and middleware scaffolding.
- **Row-level security policies (PostgreSQL RLS) must be human-designed and human-reviewed.** AI may help with SQL syntax but the policy logic is a security boundary.
- The \`TenantAwareManager\` must be used for all tenant-scoped queries — AI-generated code that uses \`objects.all()\` on tenant models will be rejected in review.
- Cross-tenant data access patterns must be explicitly documented and approved.
- All tenant isolation changes require \`@platform-team\` lead approval.

### 6.4 Celery Tasks (\`src/tasks/\`)

- AI is well-suited for generating idempotent task structures with proper retry configuration.
- Every AI-generated task must include:
  - \`acks_late = True\` (unless explicitly justified otherwise)
  - \`max_retries\` with exponential backoff
  - Idempotency key handling
  - Tenant context propagation
- Verify that tasks do not hold database transactions open during external API calls (Stripe, SES).

### 6.5 Database Migrations

- AI may generate migration files, but the developer must:
  1. Run \`uv run python manage.py sqlmigrate\` and review the raw SQL
  2. Verify that tenant-scoped tables include the \`tenant_id\` foreign key
  3. Check for missing indexes on foreign keys and frequently queried fields
  4. Ensure migrations are reversible where possible
  5. Test migrations against a copy of staging data for large tables

---

## 7. Data Handling Rules (GDPR / SOC 2)

| Rule | Detail |
|---|---|
| No real data in prompts | Use anonymized or synthetic data only. factory_boy factories exist for this purpose. |
| No production credentials | Use \`.env.example\` values or dummy keys in prompts. |
| No customer identifiers | Do not paste tenant IDs, email addresses, or subscription IDs from production. |
| Prompt content is not confidential storage | Assume anything in a prompt could be logged by the AI provider. |
| Audit trail | AI-assisted commits are tracked via git trailers and the \`ai-code-audit.yml\` workflow for SOC 2 evidence. |
| Data residency | AI tools must not be used to process or store EU customer data outside approved regions. |
| Right to deletion | AI-generated code handling user data must respect the \`delete_user_data\` service method in \`src/accounts/services.py\`. |

---

## 8. Quality Gates for AI-Generated Code

AI-generated code must pass all standard quality gates. There are no exceptions:

| Gate | Tool | Threshold |
|---|---|---|
| Linting | \`uv run ruff check src/\` | Zero errors |
| Formatting | \`uv run ruff format --check src/\` | Zero diffs |
| Type checking | \`uv run mypy src/\` | Zero errors (strict mode) |
| Unit tests | \`uv run pytest tests/\` | All passing |
| Coverage | \`pytest --cov-fail-under=85\` | ≥ 85% |
| Security scan | \`bandit\`, \`safety\`, \`trivy\` | Zero high/critical findings |
| File length | Ruff / manual | ≤ 300 lines per file |
| OpenAPI schema | \`drf-spectacular\` validation | Valid schema generation |

---

## 9. Incident Response

If AI-generated code causes a production incident:

1. **Triage normally** — follow the standard incident response runbook in \`docs/runbooks/\`.
2. **Tag the incident** with \`ai-assisted\` in the post-mortem if the root cause traces to AI-generated code.
3. **Review the PR** that introduced the code — verify that the AI disclosure was present and review was adequate.
4. **Update this policy** if the incident reveals a gap in the guidelines.
5. **No blame on the AI** — the submitting developer and approving reviewer share responsibility.

---

## 10. Policy Review

This policy is reviewed quarterly by the engineering leads. Changes require approval from:
- Engineering Manager
- Security Lead
- At least one representative from \`@billing-team\` and \`@platform-team\`

Last reviewed: 2024-01-15
Next review: 2024-04-15

---

## Quick Reference Card

\`\`\`
✅ DO:
  - Use Claude for scaffolding, tests, docs, utilities
  - Flag AI code in commits and PRs
  - Run full CI locally before pushing
  - Get senior review for billing/auth/tenant changes

❌ DON'T:
  - Paste secrets, PII, or production data into prompts
  - Auto-merge AI-generated PRs
  - Skip type checking or tests because "AI wrote it"
  - Generate custom crypto or RLS policies without human design
  - Use AI to fabricate compliance evidence
\`\`\``,

  'docs/ARCHITECTURE.md': `# Architecture Overview

## django-saas-platform

> Multi-tenant SaaS platform built with Django 5.0, Django REST Framework, Strawberry GraphQL, Celery, and Stripe.

**Last updated**: 2024-01  
**Maintainers**: Platform Engineering Team  
**Compliance**: SOC 2 Type II, GDPR

---

## Table of Contents

1. [System Overview](#system-overview)
2. [Django App Structure](#django-app-structure)
3. [Multi-Tenancy Model](#multi-tenancy-model)
4. [API Layer](#api-layer)
5. [Billing & Subscription Flow](#billing--subscription-flow)
6. [Celery Task Architecture](#celery-task-architecture)
7. [Data Flow](#data-flow)
8. [Infrastructure](#infrastructure)
9. [Security Architecture](#security-architecture)
10. [Observability](#observability)

---

## System Overview

\`\`\`
┌─────────────────────────────────────────────────────────────────────┐
│                        Client Applications                         │
│              (SPA, Mobile, Third-party Integrations)                │
└──────────────────────────────┬──────────────────────────────────────┘
                               │
                     ┌─────────▼─────────┐
                     │    CloudFront CDN  │
                     └─────────┬─────────┘
                               │
                     ┌─────────▼─────────┐
                     │   ALB / Ingress    │
                     └─────────┬─────────┘
                               │
              ┌────────────────┼────────────────┐
              │                │                │
    ┌─────────▼──────┐ ┌──────▼──────┐ ┌───────▼───────┐
    │  Django Web     │ │  Celery     │ │  Celery Beat  │
    │  (Gunicorn)     │ │  Workers    │ │  (Scheduler)  │
    │                 │ │             │ │               │
    │  REST API       │ │  Billing    │ │  Periodic     │
    │  GraphQL API    │ │  Email      │ │  Tasks        │
    │  Admin          │ │  Reports    │ │               │
    └────────┬────────┘ └──────┬──────┘ └───────┬───────┘
             │                 │                 │
    ┌────────┴─────────────────┴─────────────────┴────────┐
    │                    Shared Services                    │
    │                                                      │
    │  ┌──────────┐  ┌──────────┐  ┌──────────┐          │
    │  │PostgreSQL│  │  Redis   │  │    S3    │          │
    │  │  (RDS)   │  │(ElastiC.)│  │          │          │
    │  │          │  │          │  │ Media /  │          │
    │  │ RLS +    │  │ Cache +  │  │ Static / │          │
    │  │ Tenants  │  │ Broker + │  │ Exports  │          │
    │  │          │  │ Sessions │  │          │          │
    │  └──────────┘  └──────────┘  └──────────┘          │
    │                                                      │
    │  ┌──────────┐  ┌──────────┐  ┌──────────┐          │
    │  │  Stripe  │  │   SES    │  │  Sentry  │          │
    │  │  (Billing│  │  (Email) │  │(Errors)  │          │
    │  │  + Wbhks)│  │          │  │          │          │
    │  └──────────┘  └──────────┘  └──────────┘          │
    └──────────────────────────────────────────────────────┘
\`\`\`

### Key Design Decisions

| Decision | Choice | Rationale |
|---|---|---|
| Tenancy model | Shared database, shared schema, row-level security | Cost-efficient, simpler ops, PostgreSQL RLS for isolation |
| API style | REST (primary) + GraphQL (secondary) | REST for CRUD/webhooks, GraphQL for flexible frontend queries |
| Task queue | Celery + Redis broker | Mature, well-supported, sufficient for our throughput |
| Billing | Stripe-managed subscriptions | Reduces PCI scope, handles SCA/tax, reliable webhooks |
| Architecture | Modular monolith (Django apps) | Simpler deployment, clear boundaries, can extract later |
| Package management | uv | Fast dependency resolution, lockfile support |

---

## Django App Structure

The project follows a **modular monolith** pattern. Each Django app is self-contained with its own models, serializers, views, services, and tests.

\`\`\`
src/
├── accounts/              # User management & authentication
│   ├── models.py          # User, UserProfile
│   ├── services.py        # Registration, invitation, password reset
│   ├── serializers.py     # DRF serializers
│   ├── views.py           # DRF viewsets
│   ├── permissions.py     # RBAC permission classes
│   ├── signals.py         # Post-registration hooks (used sparingly)
│   ├── admin.py
│   └── tests/
│
├── tenants/               # Multi-tenancy core
│   ├── models.py          # Tenant, TenantMembership, TenantSettings
│   ├── middleware.py       # TenantMiddleware (sets current tenant from request)
│   ├── managers.py        # TenantAwareManager (auto-filters by tenant)
│   ├── services.py        # Tenant provisioning, onboarding, white-label config
│   ├── context.py         # Thread-local / context-var tenant storage
│   ├── rls.py             # PostgreSQL RLS policy management
│   ├── admin.py
│   └── tests/
│
├── billing/               # Stripe integration & subscription management
│   ├── models.py          # Subscription, Plan, Invoice, UsageRecord, PaymentMethod
│   ├── services.py        # SubscriptionService, InvoiceService, UsageMeteringService
│   ├── webhooks.py        # Stripe webhook handler (verified, idempotent)
│   ├── serializers.py
│   ├── views.py           # Subscription CRUD, billing portal, webhook endpoint
│   ├── sync.py            # Stripe ↔ local data synchronization
│   ├── admin.py
│   └── tests/
│
├── api/                   # API layer (aggregates app endpoints)
│   ├── rest/
│   │   ├── urls.py        # DRF router configuration
│   │   └── pagination.py  # Standard pagination classes
│   ├── graphql/
│   │   ├── schema.py      # Strawberry root schema
│   │   ├── types.py       # Strawberry types
│   │   └── resolvers.py   # Query/mutation resolvers
│   ├── throttling.py      # Per-tenant rate limiting
│   ├── versioning.py      # API versioning config
│   └── middleware.py       # API-specific middleware (request ID, timing)
│
├── core/                  # Shared base components
│   ├── models.py          # TenantAwareModel, TimestampedModel, AuditModel
│   ├── managers.py        # TenantAwareManager base class
│   ├── permissions.py     # Base RBAC permission classes
│   ├── middleware.py       # Request ID, audit logging, security headers
│   ├── exceptions.py      # Custom exception classes
│   ├── decorators.py      # @tenant_required, @audit_action
│   └── types.py           # Shared type definitions
│
├── notifications/         # Email, in-app, webhook dispatch
│   ├── models.py          # Notification, NotificationPreference, WebhookEndpoint
│   ├── services.py        # NotificationService, WebhookDispatcher
│   ├── templates.py       # Email template registry
│   ├── admin.py
│   └── tests/
│
├── tasks/                 # Celery task definitions
│   ├── billing.py         # sync_stripe_subscriptions, process_usage_records
│   ├── notifications.py   # send_email, dispatch_webhook, send_digest
│   ├── reports.py         # generate_usage_report, generate_invoice_pdf
│   ├── maintenance.py     # cleanup_expired_sessions, rotate_audit_logs
│   └── tests/
│
└── utils/                 # Shared utilities
    ├── logging.py         # Structured logging with tenant context
    ├── encryption.py      # Field-level encryption for PII
    ├── pagination.py      # Cursor-based pagination helpers
    ├── validators.py      # Shared validators
    └── testing.py         # Test helpers, tenant-aware test mixins
\`\`\`

### App Dependency Rules

\`\`\`
accounts ──→ tenants ──→ core
billing  ──→ tenants ──→ core
notifications ──→ core
tasks ──→ billing, notifications, tenants
api ──→ accounts, tenants, billing, notifications
\`\`\`

**Rules**:
- \`core\` has zero dependencies on other apps
- \`tenants\` depends only on \`core\`
- Apps communicate through **service layer functions**, not by importing each other's models directly (except through the service interface)
- Django signals are used sparingly — prefer explicit service calls
- Circular imports are forbidden; use string references for ForeignKey if needed

---

## Multi-Tenancy Model

### Strategy: Shared Database, Shared Schema, Row-Level Security

All tenants share a single PostgreSQL database and schema. Isolation is enforced at two levels:

1. **Application level**: \`TenantAwareManager\` automatically filters querysets by the current tenant
2. **Database level**: PostgreSQL Row-Level Security (RLS) policies as a defense-in-depth measure

### Tenant Resolution Flow

\`\`\`
Request
  │
  ▼
┌─────────────────────────────────┐
│     TenantMiddleware            │
│                                 │
│  1. Extract tenant identifier:  │
│     - Subdomain (acme.app.com) │
│     - X-Tenant-ID header (API) │
│     - JWT claim (token auth)   │
│                                 │
│  2. Load Tenant from cache/DB  │
│                                 │
│  3. Verify tenant is active    │
│                                 │
│  4. Set tenant in context var  │
│                                 │
│  5. SET app.current_tenant_id  │
│     on PostgreSQL connection   │
└────────────────┬────────────────┘
                 │
                 ▼
┌─────────────────────────────────┐
│     TenantAwareManager          │
│                                 │
│  All queries on tenant-scoped   │
│  models automatically include:  │
│  WHERE tenant_id = :current     │
│                                 │
│  PostgreSQL RLS enforces same   │
│  filter at database level       │
└─────────────────────────────────┘
\`\`\`

### Core Tenant Models

\`\`\`python
# src/tenants/models.py

class Tenant(TimestampedModel):
    """Root tenant entity. All tenant-scoped data references this."""
    id: UUIDField(primary_key=True)
    name: CharField
    slug: SlugField(unique=True)          # Used in subdomain resolution
    domain: CharField(null=True)          # Custom domain for white-label
    status: CharField                     # active, suspended, trial, churned
    plan: ForeignKey("billing.Plan")
    settings: JSONField                   # White-label config, feature flags
    data_region: CharField               # eu-west-1, us-east-1 (GDPR)
    created_at: DateTimeField
    
class TenantMembership(TimestampedModel):
    """Associates users with tenants and their role."""
    tenant: ForeignKey(Tenant)
    user: ForeignKey("accounts.User")
    role: CharField                       # owner, admin, member, viewer
    invited_by: ForeignKey("accounts.User", null=True)
    accepted_at: DateTimeField(null=True)
\`\`\`

### TenantAwareModel Base

\`\`\`python
# src/core/models.py

class TenantAwareModel(TimestampedModel):
    """Base model for all tenant-scoped data."""
    tenant = models.ForeignKey(
        "tenants.Tenant",
        on_delete=models.CASCADE,
        editable=False,
    )
    
    objects = TenantAwareManager()  # Auto-filters by current tenant
    unscoped = models.Manager()     # Escape hatch for admin/system tasks
    
    class Meta:
        abstract = True
\`\`\`

### PostgreSQL Row-Level Security

RLS policies are applied as a defense-in-depth layer. Even if application code bypasses the \`TenantAwareManager\`, the database enforces isolation.

\`\`\`sql
-- Applied via Django migration in tenants app
ALTER TABLE billing_subscription ENABLE ROW LEVEL SECURITY;

CREATE POLICY tenant_isolation ON billing_subscription
    USING (tenant_id = current_setting('app.current_tenant_id')::uuid);

-- The application user is NOT a superuser (superusers bypass RLS)
-- A separate migration user handles schema changes
\`\`\`

### Tenant Context Propagation

\`\`\`python
# src/tenants/context.py
import contextvars

_current_tenant: contextvars.ContextVar[Optional["Tenant"]] = contextvars.ContextVar(
    "current_tenant", default=None
)

def get_current_tenant() -> "Tenant":
    tenant = _current_tenant.get()
    if tenant is None:
        raise TenantNotSetError("No tenant in current context")
    return tenant

def set_current_tenant(tenant: "Tenant") -> contextvars.Token:
    return _current_tenant.set(tenant)
\`\`\`

Context is propagated to:
- **Django views**: Via \`TenantMiddleware\`
- **Celery tasks**: Via custom task base class that serializes/deserializes tenant ID
- **Management commands**: Via \`--tenant\` flag or explicit context manager

### Data Isolation Guarantees (SOC 2)

| Layer | Mechanism | Bypass Protection |
|---|---|---|
| Application | \`TenantAwareManager\` auto-filter | Code review, linting rule |
| Database | PostgreSQL RLS policies | DB user is not superuser |
| Cache | Tenant-prefixed cache keys | \`tenant:{id}:key\` pattern |
| File storage | Tenant-prefixed S3 paths | \`s3://bucket/{tenant_id}/\` |
| Celery tasks | Tenant ID in task kwargs | Validated on task execution |
| Logging | Tenant ID in structured logs | Audit trail |

---

## API Layer

### REST API (Django REST Framework)

Primary API for CRUD operations, webhooks, and third-party integrations.

\`\`\`
/api/v1/
├── /auth/
│   ├── POST   /login/              # JWT token pair
│   ├── POST   /refresh/            # Refresh access token
│   ├── POST   /register/           # New user + tenant provisioning
│   └── POST   /password-reset/     # Password reset flow
│
├── /tenants/
│   ├── GET     /current/           # Current tenant details
│   ├── PATCH   /current/           # Update tenant settings
│   ├── GET     /members/           # List tenant members
│   ├── POST    /members/invite/    # Invite user to tenant
│   └── DELETE  /members/{id}/      # Remove member
│
├── /billing/
│   ├── GET     /subscription/      # Current subscription
│   ├── POST    /subscription/      # Create/change subscription
│   ├── DELETE  /subscription/      # Cancel subscription
│   ├── GET     /invoices/          # Invoice history
│   ├── POST    /portal-session/    # Stripe billing portal URL
│   ├── POST    /usage/             # Report usage event
│   └── POST    /webhooks/stripe/   # Stripe webhook receiver
│
├── /notifications/
│   ├── GET     /                   # List notifications
│   ├── PATCH   /{id}/read/         # Mark as read
│   └── GET     /preferences/       # Notification preferences
│
└── /schema/                        # OpenAPI 3.1 (drf-spectacular)
\`\`\`

**All endpoints** are documented via \`drf-spectacular\` and generate OpenAPI 3.1 schemas.

### GraphQL API (Strawberry)

Secondary API for flexible frontend queries. Mounted at \`/graphql/\`.

\`\`\`python
# src/api/graphql/schema.py
import strawberry
from strawberry.django import auth

@strawberry.type
class Query:
    tenant: TenantType = strawberry.django.field()
    subscription: SubscriptionType = strawberry.django.field()
    notifications: list[NotificationType] = strawberry.django.field()

@strawberry.type
class Mutation:
    update_tenant_settings: TenantType = strawberry.mutation(resolver=update_tenant_settings)
    mark_notification_read: NotificationType = strawberry.mutation(resolver=mark_read)

schema = strawberry.Schema(query=Query, mutation=Mutation)
\`\`\`

### Rate Limiting

Per-tenant rate limiting using Redis:

| Plan | Rate Limit |
|---|---|
| Free / Trial | 100 requests/minute |
| Starter | 500 requests/minute |
| Professional | 2,000 requests/minute |
| Enterprise | 10,000 requests/minute (configurable) |

### Authentication

- **JWT** (access + refresh tokens) for API clients
- **Session** authentication for Django admin
- **API keys** for server-to-server integrations (hashed, tenant-scoped)

---

## Billing & Subscription Flow

### Stripe Integration Architecture

Stripe is the **source of truth** for subscription state. Local models mirror Stripe data for query performance and offline access.

\`\`\`
┌──────────────┐         ┌──────────────┐         ┌──────────────┐
│   Frontend   │         │   Django     │         │   Stripe     │
│              │         │   Backend    │         │              │
└──────┬───────┘         └──────┬───────┘         └──────┬───────┘
       │                        │                        │
       │  1. Select plan        │                        │
       ├───────────────────────►│                        │
       │                        │  2. Create Checkout    │
       │                        │     Session            │
       │                        ├───────────────────────►│
       │                        │                        │
       │                        │  3. Session URL        │
       │                        │◄───────────────────────┤
       │  4. Redirect to        │                        │
       │     Stripe Checkout    │                        │
       │◄───────────────────────┤                        │
       │                        │                        │
       ├────────────────────────────────────────────────►│
       │         5. Customer completes payment           │
       │◄────────────────────────────────────────────────┤
       │                        │                        │
       │  6. Redirect to        │  7. Webhook:           │
       │     success URL        │  checkout.session      │
       │                        │  .completed            │
       │                        │◄───────────────────────┤
       │                        │                        │
       │                        │  8. Provision           │
       │                        │     subscription       │
       │                        │     locally             │
       │                        │                        │
       │                        │  9. Webhook:           │
       │                        │  invoice.paid          │
       │                        │◄───────────────────────┤
       │                        │                        │
       │                        │  10. Record invoice    │
       │                        │      locally           │
\`\`\`

### Subscription Lifecycle

\`\`\`
Trial ──→ Active ──→ Past Due ──→ Canceled
  │          │          │            │
  │          │          │            └──→ Churned (after grace period)
  │          │          │
  │          │          └──→ Active (payment recovered)
  │          │
  │          └──→ Canceled (voluntary)
  │
  └──→ Active (converted from trial)
  └──→ Expired (trial ended, no conversion)
\`\`\`

### Billing Models

\`\`\`python
# src/billing/models.py

class Plan(TimestampedModel):
    """Subscription plan (mirrors Stripe Product + Price)."""
    stripe_product_id: CharField
    stripe_price_id: CharField
    name: CharField                    # Starter, Professional, Enterprise
    tier: IntegerField                 # For feature gating comparisons
    price_monthly: DecimalField
    price_yearly: DecimalField
    features: JSONField                # Feature flags for this plan
    usage_limits: JSONField            # API calls, storage, seats
    is_active: BooleanField

class Subscription(TenantAwareModel):
    """Tenant subscription (mirrors Stripe Subscription)."""
    stripe_subscription_id: CharField(unique=True)
    plan: ForeignKey(Plan)
    status: CharField                  # trialing, active, past_due, canceled
    current_period_start: DateTimeField
    current_period_end: DateTimeField
    cancel_at_period_end: BooleanField
    trial_end: DateTimeField(null=True)

class UsageRecord(TenantAwareModel):
    """Usage-based billing events sent to Stripe Metering."""
    subscription: ForeignKey(Subscription)
    metric: CharField                  # api_calls, storage_gb, seats
    quantity: IntegerField
    timestamp: DateTimeField
    stripe_usage_record_id: CharField(null=True)
    reported_to_stripe: BooleanField(default=False)
\`\`\`

### Webhook Processing (Idempotent)

\`\`\`python
# src/billing/webhooks.py

class StripeWebhookHandler:
    """
    All webhook handlers are idempotent.
    Uses stripe event ID as idempotency key stored in ProcessedWebhook table.
    """
    
    HANDLED_EVENTS = {
        "checkout.session.completed": "_handle_checkout_completed",
        "customer.subscription.created": "_handle_subscription_created",
        "customer.subscription.updated": "_handle_subscription_updated",
        "customer.subscription.deleted": "_handle_subscription_deleted",
        "invoice.paid": "_handle_invoice_paid",
        "invoice.payment_failed": "_handle_invoice_payment_failed",
    }
    
    def process(self, payload: bytes, sig_header: str) -> None:
        # 1. Verify webhook signature (Stripe signing secret)
        # 2. Check idempotency (skip if event already processed)
        # 3. Route to handler method
        # 4. Record processed event
        ...
\`\`\`

### Usage Metering Flow

\`\`\`
App Event (API call, storage write, etc.)
  │
  ▼
UsageRecord created locally (synchronous)
  │
  ▼
Celery periodic task: report_usage_to_stripe (every 5 min)
  │
  ▼
Batch unreported UsageRecords → Stripe Usage Record API
  │
  ▼
Mark records as reported_to_stripe=True
  │
  ▼
Stripe includes usage on next invoice
\`\`\`

---

## Celery Task Architecture

### Task Categories

\`\`\`
src/tasks/
├── billing.py          # Stripe sync, usage reporting, dunning
├── notifications.py    # Email, webhooks, in-app notifications
├── reports.py          # PDF generation, data exports
└── maintenance.py      # Cleanup, log rotation, health checks
\`\`\`

### Queue Configuration

\`\`\`python
# config/celery.py

CELERY_TASK_ROUTES = {
    # High priority — billing and auth
    "tasks.billing.*": {"queue": "billing"},
    
    # Medium priority — notifications
    "tasks.notifications.send_email": {"queue": "notifications"},
    "tasks.notifications.dispatch_webhook": {"queue": "notifications"},
    
    # Low priority — reports and maintenance
    "tasks.reports.*": {"queue": "reports"},
    "tasks.maintenance.*": {"queue": "maintenance"},
    
    # Default queue for everything else
    "*": {"queue": "default"},
}

CELERY_TASK_QUEUES = {
    "billing": {"exchange": "billing", "routing_key": "billing"},
    "notifications": {"exchange": "notifications", "routing_key": "notifications"},
    "reports": {"exchange": "reports", "routing_key": "reports"},
    "maintenance": {"exchange": "maintenance", "routing_key": "maintenance"},
    "default": {"exchange": "default", "routing_key": "default"},
}
\`\`\`

### Worker Deployment

\`\`\`
┌─────────────────────────────────────────────────────┐
│                   ECS / Kubernetes                   │
│                                                     │
│  ┌─────────────────┐  ┌─────────────────┐          │
│  │ Worker: billing  │  │ Worker: notify  │          │
│  │ Concurrency: 4   │  │ Concurrency: 8  │          │
│  │ Prefetch: 1      │  │ Prefetch: 4     │          │
│  │ Max tasks: 100   │  │ Max tasks: 500  │          │
│  └─────────────────┘  └─────────────────┘          │
│                                                     │
│  ┌─────────────────┐  ┌─────────────────┐          │
│  │ Worker: reports  │  │ Worker: default │          │
│  │ Concurrency: 2   │  │ Concurrency: 4  │          │
│  │ Prefetch: 1      │  │ Max tasks: 200  │          │
│  │ Time limit: 600s │  │                 │          │
│  └─────────────────┘  └─────────────────┘          │
│                                                     │
│  ┌─────────────────┐                                │
│  │ Celery Beat      │  (single instance)            │
│  │ Scheduler        │                                │
│  └─────────────────┘                                │
└─────────────────────────────────────────────────────┘
\`\`\`

### Task Design Principles

**All tasks MUST be idempotent.** A task may be executed more than once due to retries, worker crashes, or at-least-once delivery.

\`\`\`python
# src/tasks/billing.py

@shared_task(
    bind=True,
    max_retries=3,
    default_retry_delay=60,
    acks_late=True,
    reject_on_worker_lost=True,
)
def sync_stripe_subscription(self, tenant_id: str, subscription_id: str) -> None:
    """
    Sync a Stripe subscription to local database.
    
    Idempotency: Uses stripe_subscription_id as natural key.
    Updates existing record if present, creates if not.
    """
    with tenant_context(tenant_id):
        try:
            stripe_sub = stripe.Subscription.retrieve(subscription_id)
            SubscriptionService.sync_from_stripe(stripe_sub)
        except stripe.error.RateLimitError as exc:
            raise self.retry(exc=exc, countdown=120)
        except stripe.error.StripeError as exc:
            logger.error(
                "stripe_sync_failed",
                tenant_id=tenant_id,
                subscription_id=subscription_id,
                error=str(exc),
            )
            raise self.retry(exc=exc)
\`\`\`

### Tenant Context in Tasks

\`\`\`python
# src/core/celery.py

class TenantAwareTask(celery.Task):
    """Base task class that propagates tenant context."""
    
    def apply_async(self, args=None, kwargs=None, **options):
        # Automatically inject current tenant_id into task kwargs
        tenant = get_current_tenant_or_none()
        if tenant and kwargs is not None:
            kwargs.setdefault("_tenant_id", str(tenant.id))
        return super().apply_async(args, kwargs, **options)
    
    def __call__(self, *args, **kwargs):
        tenant_id = kwargs.pop("_tenant_id", None)
        if tenant_id:
            with tenant_context(tenant_id):
                return super().__call__(*args, **kwargs)
        return super().__call__(*args, **kwargs)
\`\`\`

### Periodic Tasks (Celery Beat)

| Task | Schedule | Queue | Description |
|---|---|---|---|
| \`sync_all_subscriptions\` | Every 1 hour | billing | Full sync of Stripe subscription states |
| \`report_usage_to_stripe\` | Every 5 minutes | billing | Batch report unreported usage records |
| \`send_trial_expiry_reminders\` | Daily 09:00 UTC | notifications | Email tenants with trials expiring in 3/1 days |
| \`send_payment_failure_reminders\` | Daily 10:00 UTC | notifications | Dunning emails for past_due subscriptions |
| \`generate_monthly_reports\` | 1st of month 02:00 UTC | reports | Generate usage/billing reports per tenant |
| \`cleanup_expired_sessions\` | Daily 03:00 UTC | maintenance | Remove expired session data |
| \`rotate_audit_logs\` | Weekly Sunday 04:00 UTC | maintenance | Archive audit logs older than 90 days |
| \`health_check_stripe\` | Every 10 minutes | default | Verify Stripe API connectivity |

---

## Data Flow

### Request Lifecycle

\`\`\`
1. Request arrives at ALB
2. ALB routes to Django (Gunicorn) container
3. SecurityMiddleware → CORS → RequestIDMiddleware
4. TenantMiddleware resolves tenant, sets context + RLS session var
5. AuthenticationMiddleware validates JWT / session
6. AuditMiddleware logs request metadata
7. View / ViewSet processes request
8. TenantAwareManager ensures all queries are tenant-scoped
9. Response serialized, audit log written
10. Response returned with request ID header
\`\`\`

### Caching Strategy

\`\`\`python
# Cache key pattern: tenant:{tenant_id}:{resource}:{identifier}
# Examples:
#   tenant:abc-123:subscription:current
#   tenant:abc-123:plan:features
#   tenant:abc-123:user:456:profile

CACHE_TTL = {
    "tenant_settings": 300,      # 5 minutes
    "plan_features": 3600,       # 1 hour (invalidated on plan change)
    "subscription_status": 60,   # 1 minute
    "user_permissions": 300,     # 5 minutes
}
\`\`\`

Cache invalidation is triggered by:
- Stripe webhook events (subscription/plan changes)
- Admin actions (tenant settings updates)
- Explicit service layer calls

---

## Infrastructure

### AWS Architecture

\`\`\`
┌─────────────────────────────────────────────────────────┐
│                        VPC                               │
│                                                         │
│  ┌──────────────────────────────────────────────────┐   │
│  │              Public Subnets                       │   │
│  │  ┌─────────┐  ┌─────────┐  ┌─────────────────┐  │   │
│  │  │   ALB   │  │   NAT   │  │   CloudFront    │  │   │
│  │  │         │  │ Gateway │  │   Distribution   │  │   │
│  │  └─────────┘  └─────────┘  └─────────────────┘  │   │
│  └──────────────────────────────────────────────────┘   │
│`,

  'docs/CONTRIBUTING.md': `# Contributing to django-saas-platform

Welcome! This guide covers everything you need to contribute effectively to the Django SaaS Platform. Read this before opening your first PR.

## Table of Contents

- [Development Environment Setup](#development-environment-setup)
- [Django App Conventions](#django-app-conventions)
- [Service Layer Pattern](#service-layer-pattern)
- [Database & Migration Workflow](#database--migration-workflow)
- [Multi-Tenancy Guidelines](#multi-tenancy-guidelines)
- [Stripe & Billing Development](#stripe--billing-development)
- [Celery Task Guidelines](#celery-task-guidelines)
- [API Development](#api-development)
- [Testing](#testing)
- [Code Quality](#code-quality)
- [PR Process](#pr-process)
- [Deployment](#deployment)
- [Getting Help](#getting-help)

---

## Development Environment Setup

### Prerequisites

- Python 3.12+
- [uv](https://github.com/astral-sh/uv) (package manager)
- Docker & Docker Compose
- PostgreSQL 16 (via Docker or local)
- Redis 7+ (via Docker or local)
- Stripe CLI (for webhook testing)

### Initial Setup

\`\`\`bash
# Clone the repository
git clone git@github.com:<org>/django-saas-platform.git
cd django-saas-platform

# Install dependencies
uv sync --all-extras

# Copy environment config
cp .env.example .env
# Edit .env with your local settings (Stripe test keys, database URL, etc.)

# Start infrastructure services
docker compose up -d postgres redis

# Run migrations
uv run python manage.py migrate

# Create a superuser
uv run python manage.py createsuperuser

# Seed development data (creates sample tenants, plans, users)
uv run python manage.py seed_dev_data

# Start the development server
uv run python manage.py runserver

# In a separate terminal — start Celery worker
uv run celery -A config worker -l info

# In a separate terminal — start Celery beat (scheduler)
uv run celery -A config beat -l info
\`\`\`

### Environment Variables

Required variables for local development (see \`.env.example\` for full list):

| Variable | Description | Example |
|---|---|---|
| \`DATABASE_URL\` | PostgreSQL connection string | \`postgres://user:pass@localhost:5432/saas_dev\` |
| \`REDIS_URL\` | Redis connection string | \`redis://localhost:6379/0\` |
| \`STRIPE_SECRET_KEY\` | Stripe test secret key | \`sk_test_...\` |
| \`STRIPE_PUBLISHABLE_KEY\` | Stripe test publishable key | \`pk_test_...\` |
| \`STRIPE_WEBHOOK_SECRET\` | Stripe webhook signing secret | \`whsec_...\` |
| \`DJANGO_SETTINGS_MODULE\` | Settings module | \`config.settings.development\` |
| \`SECRET_KEY\` | Django secret key | Any random string for dev |

---

## Django App Conventions

### App Structure

Every Django app in \`src/\` follows this structure. Do not deviate without team discussion.

\`\`\`
src/<app_name>/
├── __init__.py
├── admin.py              # Django admin configuration
├── apps.py               # App config (with verbose_name)
├── constants.py          # App-specific constants (SCREAMING_SNAKE_CASE)
├── exceptions.py         # App-specific exception classes
├── managers.py           # Custom model managers (tenant-aware)
├── models.py             # Django models (or models/ package if >300 lines)
├── permissions.py        # DRF/app permission classes
├── serializers.py        # DRF serializers (or serializers/ package)
├── services.py           # Business logic layer (or services/ package)
├── signals.py            # Signal handlers (use sparingly)
├── tasks.py              # Celery task definitions
├── types.py              # Strawberry GraphQL types
├── urls.py               # URL patterns
├── views.py              # DRF viewsets/views (or views/ package)
├── validators.py         # Custom validators
├── migrations/           # Django migrations
│   └── __init__.py
└── tests/                # App-specific tests
    ├── __init__.py
    ├── conftest.py       # App-level fixtures and factories
    ├── factories.py      # factory_boy model factories
    ├── test_models.py
    ├── test_services.py
    ├── test_views.py
    ├── test_serializers.py
    └── test_tasks.py
\`\`\`

### Key Rules

1. **Self-contained apps**: Each app owns its models, serializers, views, and tests. Cross-app imports go through the service layer or public API, never import another app's models directly in views.
2. **Max 300 lines per file**: If a file exceeds 300 lines, split it into a package (e.g., \`models/\` with \`__init__.py\` re-exporting).
3. **Type hints required**: All public functions and methods must have type annotations. Use \`mypy --strict\` compliance.
4. **Docstrings**: All public classes and functions need docstrings (Google style).
5. **No business logic in views**: Views handle HTTP concerns only. Business logic lives in \`services.py\`.
6. **No business logic in models**: Models define data structure, validation, and simple computed properties. Complex operations go in services.

### Creating a New App

\`\`\`bash
# Create the app inside src/
cd src/
uv run python ../manage.py startapp <app_name>

# Then restructure to match the convention above
# Add the app to INSTALLED_APPS in config/settings/base.py
\`\`\`

Register the app in \`config/settings/base.py\`:

\`\`\`python
LOCAL_APPS = [
    "src.accounts",
    "src.tenants",
    "src.billing",
    "src.api",
    "src.core",
    "src.notifications",
    "src.tasks",
    "src.<your_new_app>",
]
\`\`\`

---

## Service Layer Pattern

All business logic must go through the service layer. This is critical for testability, auditability, and tenant isolation.

\`\`\`python
# src/accounts/services.py
from __future__ import annotations

from typing import TYPE_CHECKING

from django.db import transaction

from src.core.audit import audit_log
from src.tenants.context import get_current_tenant

if TYPE_CHECKING:
    from src.accounts.models import User
    from src.tenants.models import Tenant


class UserService:
    """Service for user lifecycle operations."""

    @staticmethod
    @transaction.atomic
    def create_user(
        *,
        email: str,
        full_name: str,
        tenant: Tenant,
        role: str = "member",
    ) -> User:
        """Create a new user within a tenant.

        Args:
            email: User's email address.
            full_name: User's display name.
            tenant: The tenant this user belongs to.
            role: Role within the tenant (member, admin, owner).

        Returns:
            The created User instance.

        Raises:
            ValidationError: If email already exists within the tenant.
        """
        from src.accounts.models import User

        user = User.objects.create_user(
            email=email,
            full_name=full_name,
            tenant=tenant,
            role=role,
        )
        audit_log(
            action="user.created",
            actor=None,
            tenant=tenant,
            target=user,
        )
        return user
\`\`\`

**Rules for services:**

- Use keyword-only arguments (\`*\`) for clarity
- Wrap multi-step operations in \`@transaction.atomic\`
- Always audit state-changing operations
- Always validate tenant context
- Return domain objects, not HTTP responses

---

## Database & Migration Workflow

### Creating Migrations

\`\`\`bash
# After modifying models, generate migrations
uv run python manage.py makemigrations <app_name>

# Always specify the app name — never run bare makemigrations

# Review the generated migration file before committing
# Check for:
#   - Correct dependencies
#   - No accidental data loss (RemoveField, DeleteModel)
#   - Proper default values
#   - Tenant isolation (all tenant-scoped models must have tenant FK)

# Apply migrations locally
uv run python manage.py migrate

# Verify migration is reversible
uv run python manage.py migrate <app_name> <previous_migration_number>
uv run python manage.py migrate  # re-apply
\`\`\`

### Migration Rules

1. **One migration per logical change**: Don't combine unrelated schema changes.
2. **Never edit a migration that's been merged to \`main\`**: Create a new migration instead.
3. **Data migrations go in separate files**: Don't mix schema and data migrations.
4. **Name migrations descriptively**: Rename auto-generated files.
   \`\`\`bash
   # Rename: 0005_auto_20240115_1423.py → 0005_add_usage_metering_fields.py
   \`\`\`
5. **Test migrations against production-like data**: Large tables need careful migration planning (add indexes concurrently, avoid full table locks).
6. **Row-level security**: When adding new tenant-scoped models, include the RLS policy migration. See \`src/core/db/rls.py\` for helpers.

### Data Migrations

\`\`\`python
# src/billing/migrations/0012_backfill_subscription_status.py
from django.db import migrations


def backfill_status(apps, schema_editor):
    """Backfill subscription status for existing records."""
    Subscription = apps.get_model("billing", "Subscription")
    Subscription.objects.filter(status="").update(status="active")


def reverse_backfill(apps, schema_editor):
    """Reverse is a no-op — data was already inconsistent."""
    pass


class Migration(migrations.Migration):
    dependencies = [
        ("billing", "0011_add_subscription_status"),
    ]

    operations = [
        migrations.RunPython(backfill_status, reverse_backfill),
    ]
\`\`\`

### Handling Migration Conflicts

If two branches create migrations with the same number:

\`\`\`bash
# After merging, resolve the conflict
uv run python manage.py makemigrations --merge
\`\`\`

---

## Multi-Tenancy Guidelines

### Tenant Context

Every request must have a tenant context. The \`TenantMiddleware\` sets this automatically from the request. In Celery tasks and management commands, set it explicitly:

\`\`\`python
from src.tenants.context import tenant_context

# In a Celery task
@shared_task
def process_tenant_report(tenant_id: int) -> None:
    """Generate a report for a specific tenant."""
    with tenant_context(tenant_id):
        # All queries inside this block are tenant-scoped
        generate_report()
\`\`\`

### Tenant-Aware Queries

**Always** use the tenant-aware manager for data access:

\`\`\`python
# CORRECT — uses tenant-aware manager
invoices = Invoice.objects.for_tenant(tenant).filter(status="pending")

# WRONG — bypasses tenant isolation
invoices = Invoice.objects.filter(status="pending")  # ← NEVER DO THIS
\`\`\`

The only exceptions are:
- Superuser admin views (explicitly documented)
- Cross-tenant analytics (must use \`TenantUnscopedManager\` with audit logging)
- System-level Celery tasks (e.g., billing sync across all tenants)

### New Tenant-Scoped Models

Every model that stores tenant data must:

1. Have a \`tenant\` ForeignKey to \`tenants.Tenant\`
2. Use \`TenantAwareManager\` as the default manager
3. Include a database-level RLS policy
4. Have a unique constraint scoped to the tenant where appropriate

\`\`\`python
from src.core.models import TenantScopedModel


class Feature(TenantScopedModel):
    """A feature flag scoped to a tenant."""

    name = models.CharField(max_length=100)
    enabled = models.BooleanField(default=False)

    class Meta:
        constraints = [
            models.UniqueConstraint(
                fields=["tenant", "name"],
                name="unique_feature_per_tenant",
            ),
        ]
\`\`\`

---

## Stripe & Billing Development

### Stripe Test Environment

All development uses Stripe test mode. **Never** use production keys locally.

\`\`\`bash
# Verify you're using test keys
echo $STRIPE_SECRET_KEY  # Must start with sk_test_
\`\`\`

### Stripe Webhook Testing

Use the Stripe CLI to forward webhooks to your local server:

\`\`\`bash
# Install Stripe CLI: https://stripe.com/docs/stripe-cli
# Login to Stripe (one-time)
stripe login

# Forward webhooks to your local Django server
stripe listen --forward-to localhost:8000/api/v1/billing/webhooks/stripe/

# The CLI will output a webhook signing secret (whsec_...)
# Set this as STRIPE_WEBHOOK_SECRET in your .env

# In another terminal, trigger test events
stripe trigger checkout.session.completed
stripe trigger customer.subscription.created
stripe trigger customer.subscription.updated
stripe trigger customer.subscription.deleted
stripe trigger invoice.payment_succeeded
stripe trigger invoice.payment_failed
\`\`\`

### Webhook Handler Rules

All Stripe webhook handlers must be:

1. **Idempotent**: Processing the same event twice must produce the same result. Use \`stripe_event_id\` as a deduplication key.
2. **Verified**: Always verify the webhook signature. The \`@verify_stripe_webhook\` decorator handles this.
3. **Async-safe**: Heavy processing should be dispatched to a Celery task.
4. **Logged**: Every webhook must be recorded in the \`WebhookEvent\` model for audit.

\`\`\`python
# src/billing/webhooks.py
from src.billing.decorators import verify_stripe_webhook
from src.billing.models import WebhookEvent


@verify_stripe_webhook
def handle_stripe_webhook(request, event: dict) -> None:
    """Process incoming Stripe webhook event.

    Args:
        request: The HTTP request.
        event: Parsed and verified Stripe event dict.
    """
    event_id = event["id"]
    event_type = event["type"]

    # Idempotency check
    if WebhookEvent.objects.filter(stripe_event_id=event_id).exists():
        return  # Already processed

    WebhookEvent.objects.create(
        stripe_event_id=event_id,
        event_type=event_type,
        payload=event,
    )

    # Dispatch to handler
    handler = WEBHOOK_HANDLERS.get(event_type)
    if handler:
        handler.delay(event_id)  # Celery task
\`\`\`

### Testing Stripe Integration

Use \`unittest.mock\` to mock Stripe API calls in unit tests. Use Stripe test fixtures for integration tests:

\`\`\`python
# tests/billing/test_services.py
import stripe
from unittest.mock import patch

from src.billing.services import SubscriptionService


class TestSubscriptionService:
    @patch("src.billing.services.stripe.Subscription.create")
    def test_create_subscription(self, mock_stripe_create, tenant_factory):
        mock_stripe_create.return_value = stripe.Subscription.construct_from(
            {"id": "sub_test123", "status": "active"}, "sk_test_fake"
        )
        tenant = tenant_factory()
        sub = SubscriptionService.create(tenant=tenant, price_id="price_test")
        assert sub.stripe_subscription_id == "sub_test123"
        mock_stripe_create.assert_called_once()
\`\`\`

### Billing Code Reviews

All changes to \`src/billing/\` require review from a billing code owner (see \`CODEOWNERS\`). This is enforced by GitHub branch protection.

---

## Celery Task Guidelines

### Task Requirements

1. **Idempotent**: Every task must be safe to retry. Use database state checks, not in-memory assumptions.
2. **Tenant-scoped**: Pass \`tenant_id\` as a parameter, never serialize Django model instances.
3. **Bounded**: Set \`time_limit\` and \`soft_time_limit\` on all tasks.
4. **Logged**: Use structured logging with tenant and task context.
5. **Retriable**: Configure \`autoretry_for\`, \`retry_backoff\`, and \`max_retries\`.

\`\`\`python
# src/tasks/billing.py
from celery import shared_task
from src.tenants.context import tenant_context


@shared_task(
    bind=True,
    autoretry_for=(Exception,),
    retry_backoff=True,
    retry_backoff_max=600,
    max_retries=5,
    soft_time_limit=120,
    time_limit=180,
    acks_late=True,
)
def sync_subscription_status(self, tenant_id: int, subscription_id: int) -> None:
    """Sync subscription status from Stripe.

    Args:
        tenant_id: The tenant ID.
        subscription_id: The local subscription ID.
    """
    with tenant_context(tenant_id):
        from src.billing.services import SubscriptionService
        SubscriptionService.sync_from_stripe(subscription_id)
\`\`\`

### Task Arguments

- **Do**: Pass IDs (integers, UUIDs, strings)
- **Don't**: Pass Django model instances, querysets, or complex objects
- **Do**: Use keyword arguments for clarity
- **Don't**: Pass sensitive data (tokens, passwords) — look them up inside the task

---

## API Development

### REST API (DRF)

All REST endpoints must:

1. Be documented with \`drf-spectacular\` decorators (\`@extend_schema\`)
2. Use proper HTTP status codes
3. Include pagination for list endpoints
4. Enforce tenant isolation via \`TenantFilterMixin\`
5. Use versioned URLs (\`/api/v1/...\`)

\`\`\`python
# src/api/views/accounts.py
from drf_spectacular.utils import extend_schema
from rest_framework import viewsets

from src.accounts.models import User
from src.accounts.serializers import UserSerializer
from src.core.permissions import IsTenantMember
from src.core.mixins import TenantFilterMixin


class UserViewSet(TenantFilterMixin, viewsets.ModelViewSet):
    """ViewSet for managing users within a tenant."""

    serializer_class = UserSerializer
    permission_classes = [IsTenantMember]

    @extend_schema(
        summary="List tenant users",
        description="Returns all users belonging to the current tenant.",
        tags=["accounts"],
    )
    def list(self, request, *args, **kwargs):
        return super().list(request, *args, **kwargs)
\`\`\`

### GraphQL (Strawberry)

GraphQL types go in \`types.py\` within each app. The unified schema is assembled in \`src/api/schema.py\`.

\`\`\`python
# src/accounts/types.py
import strawberry
from strawberry import auto

from src.accounts.models import User


@strawberry.django.type(User)
class UserType:
    id: auto
    email: auto
    full_name: auto
    role: auto
\`\`\`

### Generating OpenAPI Schema

\`\`\`bash
# Generate the OpenAPI schema
uv run python manage.py spectacular --file docs/openapi.yaml

# Validate the schema
uv run python manage.py spectacular --validate
\`\`\`

---

## Testing

### Running Tests

\`\`\`bash
# Run all tests
uv run pytest

# Run tests for a specific app
uv run pytest tests/billing/

# Run a specific test file
uv run pytest tests/billing/test_services.py

# Run a specific test
uv run pytest tests/billing/test_services.py::TestSubscriptionService::test_create_subscription

# Run with coverage
uv run pytest --cov=src --cov-report=term-missing

# Run only fast unit tests (skip integration)
uv run pytest -m "not integration"

# Run integration tests (requires running services)
uv run pytest -m integration
\`\`\`

### Test Organization

Tests mirror the \`src/\` structure:

\`\`\`
tests/
├── conftest.py              # Global fixtures (tenant, user, client factories)
├── accounts/
│   ├── conftest.py
│   ├── factories.py         # factory_boy factories for accounts models
│   ├── test_models.py
│   ├── test_services.py
│   └── test_views.py
├── billing/
│   ├── conftest.py
│   ├── factories.py
│   ├── test_models.py
│   ├── test_services.py
│   ├── test_views.py
│   ├── test_webhooks.py     # Stripe webhook handler tests
│   └── test_tasks.py
└── ...
\`\`\`

### Writing Tests

Use \`factory_boy\` for test data. Do not create fixtures manually or use Django's \`fixtures/\` JSON files.

\`\`\`python
# tests/billing/factories.py
import factory
from src.billing.models import Subscription
from tests.tenants.factories import TenantFactory


class SubscriptionFactory(factory.django.DjangoModelFactory):
    class Meta:
        model = Subscription

    tenant = factory.SubFactory(TenantFactory)
    stripe_subscription_id = factory.Sequence(lambda n: f"sub_test_{n}")
    status = "active"
    plan_name = "pro"
\`\`\`

### Coverage

The minimum coverage threshold is **85%**. CI will fail if coverage drops below this. Check coverage locally:

\`\`\`bash
uv run pytest --cov=src --cov-fail-under=85
\`\`\`

---

## Code Quality

### Linting & Formatting

\`\`\`bash
# Check linting
uv run ruff check src/ tests/

# Auto-fix linting issues
uv run ruff check --fix src/ tests/

# Format code
uv run ruff format src/ tests/

# Type checking
uv run mypy src/
\`\`\`

### Pre-commit Hooks

Git hooks are installed from \`git-hooks/\`. They run automatically on commit:

- \`pre-commit\`: ruff check, ruff format, mypy on staged files
- \`commit-msg\`: Validates conventional commit format
- \`pre-push\`: Runs the full test suite

Install hooks:

\`\`\`bash
# Hooks are symlinked during setup, or manually:
cp git-hooks/* .git/hooks/
chmod +x .git/hooks/*
\`\`\`

---

## PR Process

### Before Opening a PR

1. **Create a branch** from \`main\` following the naming convention:
   \`\`\`bash
   git checkout -b feat/SAAS-42-add-tenant-onboarding
   # Patterns: feat/, fix/, chore/, docs/, refactor/, test/
   \`\`\`

2. **Write code** following all conventions above.

3. **Run the full quality check locally**:
   \`\`\`bash
   uv run ruff check src/ tests/
   uv run ruff format --check src/ tests/
   uv run mypy src/
   uv run pytest --cov=src --cov-fail-under=85
   \`\`\`

4. **Write meaningful commits** using conventional commit format:
   \`\`\`
   feat(billing): add usage-based metering for API calls
   fix(tenants): prevent cross-tenant data leak in report export
   chore(deps): update stripe to 8.x
   docs(api): add webhook retry documentation
   \`\`\`

### Opening the PR

1. Push your branch and open a PR against \`main\`.
2. Fill out the PR template completely (description, testing, checklist).
3. Link the GitHub Issue (e.g., "Closes #42").
4. If the code was AI-generated or AI-assisted, check the appropriate box in the PR template and ensure the \`ai-assisted\` label is applied.
5. Request review from at least one team member. For sensitive paths (\`billing/\`, \`auth/\`, \`config/production/\`), the required code owner will be auto-assigned via \`CODEOWNERS\`.

### Review Expectations

- **Reviewers**: Respond within 1 business day (accounting for timezone overlap).
- **Authors**: Address all review comments. Use "Resolve conversation" only after the reviewer approves the resolution.
- **Approval**: At least 1 approval required. Billing and auth changes require approval from a designated code owner.

### Merge Requirements

All of these must pass before merging:

- [ ] CI pipeline green (lint, type check, tests, security scan)
- [ ] Coverage ≥ 85%
- [ ] At least 1 approval
- [ ] No unresolved conversations
- [ ] Branch is up to date with \`main\`
- [ ] Conventional commit messages

Use **Squash and Merge** for feature branches. The squashed commit message should follow conventional commit format.

### After Merging

- Delete the feature branch (GitHub does this automatically if configured).
- Verify the staging deployment succeeds (auto-deployed from \`main\`).
- Monitor Sentry for any new errors in staging.

---

## Deployment

### Staging

Staging deploys automatically when PRs merge to \`main\`. Monitor at:

- **Application**: \`https://staging.your-saas.com\`
- **Sentry**: Check for new errors after deploy
- **Grafana**: Monitor key metrics (response times, error rates)

### Production

Production deploys are triggered manually via GitHub Actions after staging verification:

1. Verify staging is stable (no new Sentry errors, metrics nominal).
2. Go to GitHub Actions → "Deploy Production" workflow → "Run workflow".
3. Monitor the deployment in Grafana and Sentry.

### Database Migrations in Production

- Migrations run automatically during deployment.
- **Destructive migrations** (dropping columns/tables) must be done in two phases:
  1. Deploy code that stops using the column.
  2. In a subsequent deploy, remove the column.
- Large data migrations should be run as management commands, not in the migration itself.

---

## GDPR & Compliance

When working on features that handle personal data:

1. **Data minimization**: Only collect and store data that's necessary.
2. **Consent**: Ensure proper consent mechanisms are in place.
3. **Right to deletion**: All personal data must be deletable via the \`UserService.delete_user_data()\` method.
4. **Audit logging**: All access to personal data must be logged.
5. **Data residency**: Tenant data must respect the configured data region.
6. **SOC 2**: Changes to authentication, authorization, or audit logging require security review.

See \`docs/ARCHITECTURE.md\` for the full compliance architecture.

---

## Getting Help

- **Slack**: \`#django-saas-dev\` for development questions, \`#django-saas-incidents\` for production issues
- **Documentation**: \`docs/\` directory and Notion workspace
- **Architecture decisions**: Check \`docs/ARCHITECTURE.md\` and ADR records in \`docs/adr/\`
- **Pair programming**: Reach out on Slack — we encourage pairing, especially for complex billing or tenancy work
- **Claude Code**: Backend and full-stack developers can use Claude for code generation, but all AI-assisted code must be reviewed and marked per our PR template`,

  'docs/ONBOARDING.md': `# Onboarding Guide

Welcome to the **django-saas-platform** team! This guide walks you through setting up your local development environment from scratch.

## Prerequisites

| Tool | Minimum Version | Install |
|------|----------------|---------|
| Python | 3.12+ | [python.org](https://www.python.org/downloads/) or \`pyenv install 3.12\` |
| uv | 0.4+ | \`curl -LsSf https://astral.sh/uv/install.sh \\| sh\` |
| Docker & Docker Compose | 24+ / 2.20+ | [docs.docker.com](https://docs.docker.com/get-docker/) |
| Git | 2.40+ | [git-scm.com](https://git-scm.com/) |
| Stripe CLI | Latest | \`brew install stripe/stripe-cli/stripe\` or [stripe.com/docs/stripe-cli](https://stripe.com/docs/stripe-cli) |

Optional but recommended:
- [direnv](https://direnv.net/) for automatic \`.env\` loading
- [pgcli](https://www.pgcli.com/) for a better PostgreSQL REPL
- [jq](https://jqlang.github.io/jq/) for JSON processing in scripts

---

## 1. Clone the Repository

\`\`\`bash
git clone git@github.com:your-org/django-saas-platform.git
cd django-saas-platform
\`\`\`

## 2. Install Git Hooks

\`\`\`bash
# Install custom hooks for linting, conventional commits, and pre-push checks
cp git-hooks/pre-commit .git/hooks/pre-commit
cp git-hooks/commit-msg .git/hooks/commit-msg
cp git-hooks/pre-push .git/hooks/pre-push
chmod +x .git/hooks/{pre-commit,commit-msg,pre-push}
\`\`\`

## 3. Install Python Dependencies

We use [uv](https://github.com/astral-sh/uv) as our package manager. Do **not** use pip directly.

\`\`\`bash
# Create virtual environment and install all dependencies (including dev)
uv sync --all-extras

# Verify installation
uv run python --version   # Should be 3.12+
uv run django-admin --version  # Should be 5.0+
\`\`\`

### Understanding the dependency groups

| Group | Purpose |
|-------|---------|
| \`[project.dependencies]\` | Runtime dependencies (Django, DRF, Celery, Stripe, etc.) |
| \`[project.optional-dependencies.dev]\` | Development tools (ruff, mypy, pytest, factory_boy) |
| \`[project.optional-dependencies.docs]\` | Documentation generation |

## 4. Environment Configuration

\`\`\`bash
# Copy the example environment file
cp .env.example .env
\`\`\`

Edit \`.env\` with the following values. Most defaults work for local Docker Compose:

\`\`\`dotenv
# Django
DJANGO_SETTINGS_MODULE=config.settings.development
DJANGO_SECRET_KEY=local-dev-secret-key-change-in-production
DJANGO_DEBUG=True
DJANGO_ALLOWED_HOSTS=localhost,127.0.0.1,0.0.0.0

# PostgreSQL (matches docker-compose.yml)
DATABASE_URL=postgres://saas_user:saas_password@localhost:5432/saas_platform

# Redis (matches docker-compose.yml)
REDIS_URL=redis://localhost:6379/0
CELERY_BROKER_URL=redis://localhost:6379/1
CELERY_RESULT_BACKEND=redis://localhost:6379/2

# Stripe — TEST keys only (see Section 5)
STRIPE_PUBLISHABLE_KEY=pk_test_...
STRIPE_SECRET_KEY=sk_test_...
STRIPE_WEBHOOK_SECRET=whsec_...

# Email (console backend in development)
EMAIL_BACKEND=django.core.mail.backends.console.EmailBackend

# Sentry (optional for local dev)
SENTRY_DSN=
\`\`\`

> **⚠️ Security**: Never commit \`.env\` files. They are in \`.gitignore\`. See \`.claude/rules/common/security.md\` for data handling policies.

## 5. Stripe Test Configuration

### 5.1 Get Stripe Test Keys

1. Log in to the [Stripe Dashboard](https://dashboard.stripe.com/test/apikeys)
2. Ensure you are in **Test Mode** (toggle in the top-right)
3. Copy your **Publishable key** (\`pk_test_...\`) and **Secret key** (\`sk_test_...\`)
4. Paste them into your \`.env\` file

### 5.2 Set Up Stripe CLI for Webhooks

The Stripe CLI forwards webhook events from Stripe to your local server:

\`\`\`bash
# Authenticate (one-time)
stripe login

# Forward webhooks to your local Django server
stripe listen --forward-to localhost:8000/api/v1/billing/webhooks/stripe/

# The CLI will print a webhook signing secret (whsec_...)
# Copy it to STRIPE_WEBHOOK_SECRET in your .env
\`\`\`

### 5.3 Seed Stripe Test Products

After the database is running (Section 6), create test products and prices in Stripe:

\`\`\`bash
# Create test products and sync to local database
uv run python manage.py setup_stripe_products --env=test
\`\`\`

This creates:
- **Starter** plan ($29/mo, 5 seats)
- **Professional** plan ($99/mo, 25 seats)
- **Enterprise** plan ($299/mo, unlimited seats)
- Usage-based metering for API calls

### 5.4 Test Card Numbers

| Scenario | Card Number |
|----------|-------------|
| Successful payment | \`4242 4242 4242 4242\` |
| Requires authentication | \`4000 0025 0000 3155\` |
| Declined | \`4000 0000 0000 0002\` |
| Insufficient funds | \`4000 0000 0000 9995\` |

Use any future expiry date and any 3-digit CVC.

## 6. Start Infrastructure with Docker Compose

\`\`\`bash
# Start PostgreSQL and Redis
docker compose up -d postgres redis

# Verify services are healthy
docker compose ps
\`\`\`

The \`docker-compose.yml\` provides:

| Service | Port | Purpose |
|---------|------|---------|
| \`postgres\` | 5432 | PostgreSQL 16 with row-level security extensions |
| \`redis\` | 6379 | Cache (db 0), Celery broker (db 1), Celery results (db 2) |

### Verify connectivity

\`\`\`bash
# PostgreSQL
docker compose exec postgres pg_isready -U saas_user

# Redis
docker compose exec redis redis-cli ping
# Should return: PONG
\`\`\`

## 7. Database Setup

\`\`\`bash
# Run migrations
uv run python manage.py migrate

# Set up row-level security policies for tenant isolation
uv run python manage.py setup_rls_policies

# Create a superuser for Django admin
uv run python manage.py createsuperuser

# (Optional) Load development seed data — creates sample tenants, users, and subscriptions
uv run python manage.py seed_dev_data
\`\`\`

### What \`seed_dev_data\` creates

| Entity | Details |
|--------|---------|
| Tenants | 3 tenants (Acme Corp, Globex Inc, Initech LLC) |
| Users | 5 users per tenant with various roles (owner, admin, member, viewer) |
| Subscriptions | One active subscription per tenant (Starter, Professional, Enterprise) |
| API keys | One test API key per tenant |

Default credentials for seeded users:

\`\`\`
Email: admin@acme-test.com  /  Password: testpass123!
Email: admin@globex-test.com  /  Password: testpass123!
\`\`\`

> These credentials only work in the development environment.

## 8. Run the Development Server

\`\`\`bash
# Start Django development server
uv run python manage.py runserver

# Access the application
# Django Admin: http://localhost:8000/admin/
# API (DRF):   http://localhost:8000/api/v1/
# GraphQL:     http://localhost:8000/graphql/
# OpenAPI:     http://localhost:8000/api/v1/schema/
# Swagger UI:  http://localhost:8000/api/v1/schema/swagger-ui/
# ReDoc:       http://localhost:8000/api/v1/schema/redoc/
\`\`\`

## 9. Start the Celery Worker and Beat Scheduler

Celery handles background tasks: billing sync, email dispatch, report generation, webhook delivery, and periodic cleanup.

### Terminal 1 — Celery Worker

\`\`\`bash
uv run celery -A config worker --loglevel=info --concurrency=2 -Q default,billing,notifications,reports
\`\`\`

### Terminal 2 — Celery Beat (periodic tasks)

\`\`\`bash
uv run celery -A config beat --loglevel=info --scheduler django_celery_beat.schedulers:DatabaseScheduler
\`\`\`

### Terminal 3 — (Optional) Flower for monitoring

\`\`\`bash
uv run celery -A config flower --port=5555
# Open http://localhost:5555 to monitor tasks
\`\`\`

### Key Celery Queues

| Queue | Purpose | Examples |
|-------|---------|----------|
| \`default\` | General tasks | Data exports, cleanup |
| \`billing\` | Stripe operations | Subscription sync, invoice generation, usage reporting |
| \`notifications\` | Communication | Email dispatch, in-app notifications, Slack alerts |
| \`reports\` | Heavy computation | Analytics reports, tenant usage summaries |

> **Important**: All Celery tasks must be **idempotent**. See \`CLAUDE.md\` and \`.claude/rules/common/coding-style.md\` for task design guidelines.

### Verify Celery is working

\`\`\`bash
# In a Python shell or Django shell
uv run python manage.py shell -c "
from tasks.health import ping
result = ping.delay()
print(result.get(timeout=5))  # Should print 'pong'
"
\`\`\`

## 10. Running Tests

\`\`\`bash
# Run the full test suite
uv run pytest

# Run with coverage report
uv run pytest --cov=src --cov-report=term-missing --cov-fail-under=85

# Run tests for a specific app
uv run pytest tests/billing/
uv run pytest tests/tenants/

# Run only unit tests (fast)
uv run pytest -m "not integration" -x

# Run integration tests (requires Docker services)
uv run pytest -m integration

# Run tests in parallel
uv run pytest -n auto
\`\`\`

## 11. Code Quality Checks

Run these before every commit (the pre-commit hook does this automatically):

\`\`\`bash
# Linting
uv run ruff check src/ tests/

# Auto-fix lint issues
uv run ruff check src/ tests/ --fix

# Formatting
uv run ruff format src/ tests/

# Check formatting without modifying
uv run ruff format src/ tests/ --check

# Type checking (strict mode)
uv run mypy src/

# All checks at once (what CI runs)
uv run ruff check src/ tests/ && \\
uv run ruff format src/ tests/ --check && \\
uv run mypy src/ && \\
uv run pytest --cov=src --cov-fail-under=85
\`\`\`

## 12. Full Docker Development (Alternative)

If you prefer running everything in Docker (including Django and Celery):

\`\`\`bash
# Build and start all services
docker compose --profile full up --build

# Run migrations inside the container
docker compose exec web uv run python manage.py migrate

# Run tests inside the container
docker compose exec web uv run pytest
\`\`\`

Services in \`full\` profile:

| Service | Port | Description |
|---------|------|-------------|
| \`web\` | 8000 | Django dev server with hot reload |
| \`celery-worker\` | — | Celery worker (all queues) |
| \`celery-beat\` | — | Celery beat scheduler |
| \`postgres\` | 5432 | PostgreSQL 16 |
| \`redis\` | 6379 | Redis 7 |
| \`flower\` | 5555 | Celery monitoring |
| \`mailpit\` | 8025 | Email testing UI |

---

## Common Development Tasks

### Creating a New Django App

\`\`\`bash
# Create the app in src/
cd src/
uv run python ../manage.py startapp my_feature

# Structure it as a self-contained module:
# src/my_feature/
#   __init__.py
#   models.py        # Models with TenantAwareManager
#   serializers.py   # DRF serializers
#   views.py         # DRF viewsets
#   schema.py        # Strawberry GraphQL types/resolvers
#   services.py      # Business logic (prefer over signals)
#   tasks.py         # Celery tasks (must be idempotent)
#   urls.py          # URL routing
#   admin.py         # Admin configuration
#   apps.py          # App config
#
# tests/my_feature/
#   __init__.py
#   factories.py     # factory_boy factories
#   test_models.py
#   test_services.py
#   test_views.py
#   test_tasks.py
\`\`\`

### Working with Tenant Context

\`\`\`python
from core.context import set_current_tenant

# In views, the TenantMiddleware sets this automatically.
# In Celery tasks or management commands, set it explicitly:
with set_current_tenant(tenant):
    # All queries through TenantAwareManager are now scoped to this tenant
    projects = Project.objects.all()  # Only returns this tenant's projects
\`\`\`

### Triggering Stripe Webhook Events Locally

\`\`\`bash
# Trigger a specific event
stripe trigger customer.subscription.created

# Trigger invoice payment
stripe trigger invoice.payment_succeeded

# Trigger with specific data
stripe trigger checkout.session.completed \\
  --add checkout_session:metadata.tenant_id=tenant_abc123
\`\`\`

### Running Django Management Commands

\`\`\`bash
# Django shell with IPython
uv run python manage.py shell_plus

# Generate new migration
uv run python manage.py makemigrations tenants

# Show migration SQL without applying
uv run python manage.py sqlmigrate tenants 0005

# Check for common issues
uv run python manage.py check --deploy
\`\`\`

---

## Troubleshooting

### PostgreSQL connection refused

\`\`\`bash
# Check if the container is running
docker compose ps postgres

# Check logs
docker compose logs postgres

# Restart
docker compose restart postgres
\`\`\`

### Redis connection error

\`\`\`bash
# Verify Redis is responding
docker compose exec redis redis-cli ping

# Check memory usage
docker compose exec redis redis-cli info memory
\`\`\`

### Celery tasks not executing

1. Verify the worker is running and connected to the correct broker
2. Check that \`CELERY_BROKER_URL\` in \`.env\` matches the Redis container
3. Look at worker logs: \`uv run celery -A config worker --loglevel=debug\`
4. Verify the task is registered: \`uv run celery -A config inspect registered\`

### Stripe webhook failures

1. Ensure \`stripe listen\` is running and forwarding to the correct URL
2. Verify \`STRIPE_WEBHOOK_SECRET\` matches the \`whsec_...\` from \`stripe listen\`
3. Check Django logs for signature verification errors
4. Test with: \`stripe trigger payment_intent.succeeded\`

### mypy errors after pulling new code

\`\`\`bash
# Clear mypy cache and re-run
rm -rf .mypy_cache
uv run mypy src/
\`\`\`

### Migration conflicts after merge

\`\`\`bash
# Check for conflicts
uv run python manage.py showmigrations | grep -i conflict

# Merge migrations
uv run python manage.py makemigrations --merge
\`\`\`

---

## Key Documentation

| Document | Location | Description |
|----------|----------|-------------|
| Project Rules | \`CLAUDE.md\` | Top-level project conventions for Claude and developers |
| Architecture | \`docs/ARCHITECTURE.md\` | System design, data flow, multi-tenancy approach |
| Coding Style | \`.claude/rules/python/coding-style.md\` | Python/Django coding standards |
| Security | \`.claude/rules/common/security.md\` | Security policies, SOC 2 and GDPR compliance |
| Testing | \`.claude/rules/python/testing.md\` | Test patterns, fixtures, coverage requirements |
| Git Workflow | \`.claude/rules/common/git-workflow.md\` | Branching, commits, PR process |
| API Schema | \`http://localhost:8000/api/v1/schema/swagger-ui/\` | Live OpenAPI documentation |

---

## Getting Help

- **Slack**: \`#django-saas-platform\` for general questions, \`#saas-platform-incidents\` for production issues
- **GitHub Issues**: File a bug or feature request using the templates in \`.github/ISSUE_TEMPLATE/\`
- **Code Owners**: Check \`.github/CODEOWNERS\` to find the right reviewer for your changes
- **Pair Programming**: Reach out in Slack — we encourage pairing, especially for billing and tenant isolation code

Welcome aboard! 🚀`,

  'git-hooks/commit-msg': `#!/usr/bin/env bash
# commit-msg hook — validates conventional commit format
# Install: ln -sf ../../git-hooks/commit-msg .git/hooks/commit-msg

set -euo pipefail

COMMIT_MSG_FILE="$1"
COMMIT_MSG=$(head -1 "$COMMIT_MSG_FILE")

# Skip merge commits
if echo "$COMMIT_MSG" | grep -qE '^Merge '; then
    exit 0
fi

# Skip revert commits
if echo "$COMMIT_MSG" | grep -qE '^Revert "'; then
    exit 0
fi

# Conventional commit pattern:
#   type(optional-scope): description
#
# Allowed types: feat, fix, chore, docs, style, refactor, perf, test, build, ci, revert
# Scope is optional but when present should reference a Django app or area
# Description must start lowercase and not end with a period
CONVENTIONAL_PATTERN='^(feat|fix|chore|docs|style|refactor|perf|test|build|ci|revert)(\\([a-z][a-z0-9_-]*\\))?!?: .+'

if ! echo "$COMMIT_MSG" | grep -qE "$CONVENTIONAL_PATTERN"; then
    echo "❌ Commit message does not follow conventional commit format."
    echo ""
    echo "Expected: <type>(<scope>): <description>"
    echo ""
    echo "Allowed types:"
    echo "  feat     — new feature"
    echo "  fix      — bug fix"
    echo "  chore    — maintenance, dependency updates"
    echo "  docs     — documentation changes"
    echo "  style    — formatting, no logic change"
    echo "  refactor — code restructuring, no behavior change"
    echo "  perf     — performance improvement"
    echo "  test     — adding or updating tests"
    echo "  build    — build system, Docker, Terraform"
    echo "  ci       — GitHub Actions, CI/CD pipeline"
    echo "  revert   — reverting a previous commit"
    echo ""
    echo "Recommended scopes (Django apps / areas):"
    echo "  accounts, tenants, billing, api, core, notifications, tasks, utils, config"
    echo ""
    echo "Examples:"
    echo "  feat(billing): add Stripe usage metering endpoint"
    echo "  fix(tenants): enforce row-level security on queryset"
    echo "  chore: upgrade Django to 5.0.4"
    echo "  docs(api): update OpenAPI schema for onboarding flow"
    echo "  test(accounts): add factory_boy fixtures for tenant users"
    echo ""
    echo "Your message: $COMMIT_MSG"
    exit 1
fi

# Validate description starts with lowercase letter
DESCRIPTION=$(echo "$COMMIT_MSG" | sed -E 's/^(feat|fix|chore|docs|style|refactor|perf|test|build|ci|revert)(\\([a-z][a-z0-9_-]*\\))?!?: //')

if echo "$DESCRIPTION" | grep -qE '^[A-Z]'; then
    echo "❌ Commit description should start with a lowercase letter."
    echo "   Got: \\"$DESCRIPTION\\""
    echo "   Fix: lowercase the first character of the description"
    exit 1
fi

# Validate description does not end with a period
if echo "$DESCRIPTION" | grep -qE '\\.$'; then
    echo "❌ Commit description should not end with a period."
    echo "   Got: \\"$DESCRIPTION\\""
    exit 1
fi

# Validate subject line length (max 72 characters)
SUBJECT_LENGTH=\${#COMMIT_MSG}
if [ "$SUBJECT_LENGTH" -gt 72 ]; then
    echo "❌ Commit subject line is too long ($SUBJECT_LENGTH chars, max 72)."
    echo "   Subject: \\"$COMMIT_MSG\\""
    echo "   Tip: move details to the commit body (blank line after subject)"
    exit 1
fi

# Validate body formatting if present (blank line between subject and body)
TOTAL_LINES=$(wc -l < "$COMMIT_MSG_FILE")
if [ "$TOTAL_LINES" -gt 1 ]; then
    SECOND_LINE=$(sed -n '2p' "$COMMIT_MSG_FILE")
    if [ -n "$SECOND_LINE" ]; then
        echo "❌ There must be a blank line between the subject and body."
        echo "   Line 2: \\"$SECOND_LINE\\""
        exit 1
    fi
fi

# Warn about sensitive scope changes (billing, auth) — informational only
if echo "$COMMIT_MSG" | grep -qE '\\((billing|auth)\\)'; then
    echo "⚠️  This commit touches a sensitive area (billing/auth)."
    echo "   Ensure changes are reviewed by a CODEOWNER before merging."
fi

# Check for ticket reference in commit body for feat/fix (advisory, not blocking)
if echo "$COMMIT_MSG" | grep -qE '^(feat|fix)'; then
    if [ "$TOTAL_LINES" -gt 2 ]; then
        BODY=$(tail -n +3 "$COMMIT_MSG_FILE")
        if ! echo "$BODY" | grep -qiE '(SAAS-[0-9]+|#[0-9]+|closes|fixes|resolves)'; then
            echo "💡 Tip: consider referencing a ticket (e.g., SAAS-42 or Closes #42) in the commit body."
        fi
    else
        echo "💡 Tip: consider adding a body with a ticket reference (e.g., SAAS-42) for feat/fix commits."
    fi
fi

exit 0`,

  'git-hooks/pre-commit': `#!/usr/bin/env bash
# django-saas-platform pre-commit hook
# Runs ruff check, ruff format, mypy, and prevents .env files from being committed.
# Install: cp git-hooks/pre-commit .git/hooks/pre-commit && chmod +x .git/hooks/pre-commit

set -euo pipefail

RED='\\033[0;31m'
GREEN='\\033[0;32m'
YELLOW='\\033[0;33m'
NC='\\033[0m'

ERRORS=0

echo "🔍 Running pre-commit checks..."
echo ""

# ---------------------------------------------------------------------------
# 1. Prevent .env files from being committed (SOC 2 / GDPR compliance)
# ---------------------------------------------------------------------------
echo -n "Checking for .env files... "

ENV_FILES=$(git diff --cached --name-only --diff-filter=ACR | grep -E '(^|/)\\.env($|\\..*)' || true)

if [[ -n "$ENV_FILES" ]]; then
    echo -e "\${RED}BLOCKED\${NC}"
    echo -e "\${RED}ERROR: Attempted to commit environment/secret files:\${NC}"
    echo "$ENV_FILES" | while read -r f; do echo "  - $f"; done
    echo ""
    echo "Environment files may contain secrets (API keys, database credentials, Stripe keys)."
    echo "Add them to .gitignore and use django-environ or Pydantic settings for configuration."
    echo ""
    echo "If this is a template file (e.g., .env.example), commit it with:"
    echo "  git add -f .env.example && git commit --no-verify"
    ERRORS=1
else
    echo -e "\${GREEN}OK\${NC}"
fi

# ---------------------------------------------------------------------------
# 2. Prevent secrets and sensitive patterns in staged files
# ---------------------------------------------------------------------------
echo -n "Scanning for hardcoded secrets... "

STAGED_FILES=$(git diff --cached --name-only --diff-filter=ACM | grep -E '\\.(py|yml|yaml|toml|json|cfg|ini|conf|sh)$' || true)

if [[ -n "$STAGED_FILES" ]]; then
    SECRET_PATTERNS='(sk_live_|sk_test_|rk_live_|rk_test_|whsec_|STRIPE_SECRET|AWS_SECRET_ACCESS_KEY|DATABASE_URL\\s*=\\s*postgres://|PRIVATE.KEY|-----BEGIN (RSA |EC )?PRIVATE KEY)'
    FOUND_SECRETS=$(git diff --cached -U0 -- $STAGED_FILES | grep -E "^\\+" | grep -iE "$SECRET_PATTERNS" || true)

    if [[ -n "$FOUND_SECRETS" ]]; then
        echo -e "\${RED}BLOCKED\${NC}"
        echo -e "\${RED}ERROR: Potential secrets detected in staged changes:\${NC}"
        echo "$FOUND_SECRETS" | head -5
        echo ""
        echo "Never commit Stripe keys, AWS credentials, or private keys."
        echo "Use environment variables or a secrets manager."
        ERRORS=1
    else
        echo -e "\${GREEN}OK\${NC}"
    fi
else
    echo -e "\${GREEN}OK (no matching files)\${NC}"
fi

# ---------------------------------------------------------------------------
# 3. Collect staged Python files for linting/formatting/type-checking
# ---------------------------------------------------------------------------
PYTHON_FILES=$(git diff --cached --name-only --diff-filter=ACM | grep '\\.py$' || true)

if [[ -z "$PYTHON_FILES" ]]; then
    echo -e "\${YELLOW}No Python files staged — skipping ruff and mypy checks.\${NC}"
    if [[ "$ERRORS" -ne 0 ]]; then
        echo ""
        echo -e "\${RED}✗ Pre-commit checks failed. Fix the issues above before committing.\${NC}"
        exit 1
    fi
    echo ""
    echo -e "\${GREEN}✓ All pre-commit checks passed.\${NC}"
    exit 0
fi

# ---------------------------------------------------------------------------
# 4. Check that uv is available
# ---------------------------------------------------------------------------
if ! command -v uv &>/dev/null; then
    echo -e "\${RED}ERROR: 'uv' is not installed or not on PATH.\${NC}"
    echo "Install it: curl -LsSf https://astral.sh/uv/install.sh | sh"
    exit 1
fi

# ---------------------------------------------------------------------------
# 5. Ruff lint check
# ---------------------------------------------------------------------------
echo -n "Running ruff check... "

if uv run ruff check --force-exclude $PYTHON_FILES 2>/dev/null; then
    echo -e "\${GREEN}OK\${NC}"
else
    echo -e "\${RED}FAILED\${NC}"
    echo ""
    echo "Fix lint errors with: uv run ruff check --fix src/"
    ERRORS=1
fi

# ---------------------------------------------------------------------------
# 6. Ruff format check
# ---------------------------------------------------------------------------
echo -n "Running ruff format --check... "

if uv run ruff format --check --force-exclude $PYTHON_FILES 2>/dev/null; then
    echo -e "\${GREEN}OK\${NC}"
else
    echo -e "\${RED}FAILED\${NC}"
    echo ""
    echo "Fix formatting with: uv run ruff format src/"
    ERRORS=1
fi

# ---------------------------------------------------------------------------
# 7. Mypy type checking (strict mode)
# ---------------------------------------------------------------------------
echo -n "Running mypy... "

# Only check files under src/ to respect mypy config boundaries
SRC_PYTHON_FILES=$(echo "$PYTHON_FILES" | grep '^src/' || true)

if [[ -n "$SRC_PYTHON_FILES" ]]; then
    if uv run mypy --no-error-summary $SRC_PYTHON_FILES 2>/dev/null; then
        echo -e "\${GREEN}OK\${NC}"
    else
        echo -e "\${RED}FAILED\${NC}"
        echo ""
        echo "Fix type errors. All public functions must have type hints."
        echo "Run full check: uv run mypy src/"
        ERRORS=1
    fi
else
    echo -e "\${YELLOW}SKIPPED (no src/ Python files staged)\${NC}"
fi

# ---------------------------------------------------------------------------
# 8. Check for files exceeding max length (300 lines)
# ---------------------------------------------------------------------------
echo -n "Checking file length (max 300 lines)... "

LONG_FILES=""
for f in $PYTHON_FILES; do
    if [[ -f "$f" ]]; then
        LINE_COUNT=$(wc -l < "$f")
        if [[ "$LINE_COUNT" -gt 300 ]]; then
            LONG_FILES="\${LONG_FILES}\\n  - \${f} (\${LINE_COUNT} lines)"
        fi
    fi
done

if [[ -n "$LONG_FILES" ]]; then
    echo -e "\${YELLOW}WARNING\${NC}"
    echo -e "\${YELLOW}Files exceeding 300-line limit:\${LONG_FILES}\${NC}"
    echo "Consider splitting into smaller modules (service layer, utils, etc.)."
    # Warning only — does not block commit
else
    echo -e "\${GREEN}OK\${NC}"
fi

# ---------------------------------------------------------------------------
# 9. Check for Django migration conflicts
# ---------------------------------------------------------------------------
echo -n "Checking for migration conflicts... "

MIGRATION_FILES=$(echo "$PYTHON_FILES" | grep '/migrations/' || true)

if [[ -n "$MIGRATION_FILES" ]]; then
    CONFLICT_MARKERS=$(grep -l '<<<<<<' $MIGRATION_FILES 2>/dev/null || true)
    if [[ -n "$CONFLICT_MARKERS" ]]; then
        echo -e "\${RED}FAILED\${NC}"
        echo "Migration files contain merge conflict markers:"
        echo "$CONFLICT_MARKERS" | while read -r f; do echo "  - $f"; done
        ERRORS=1
    else
        echo -e "\${GREEN}OK\${NC}"
    fi
else
    echo -e "\${GREEN}OK (no migrations staged)\${NC}"
fi

# ---------------------------------------------------------------------------
# 10. Check sensitive paths for extra scrutiny
# ---------------------------------------------------------------------------
SENSITIVE_FILES=$(echo "$PYTHON_FILES" | grep -E '(billing/|/auth/|config/production)' || true)

if [[ -n "$SENSITIVE_FILES" ]]; then
    echo ""
    echo -e "\${YELLOW}⚠ Sensitive paths modified (billing, auth, production config):\${NC}"
    echo "$SENSITIVE_FILES" | while read -r f; do echo "  - $f"; done
    echo "Ensure these changes are reviewed by a CODEOWNER before merging."
fi

# ---------------------------------------------------------------------------
# Result
# ---------------------------------------------------------------------------
echo ""

if [[ "$ERRORS" -ne 0 ]]; then
    echo -e "\${RED}✗ Pre-commit checks failed. Fix the issues above before committing.\${NC}"
    echo "  To bypass (emergency only): git commit --no-verify"
    exit 1
fi

echo -e "\${GREEN}✓ All pre-commit checks passed.\${NC}"
exit 0`,

  'git-hooks/pre-push': `#!/usr/bin/env bash
# Pre-push hook for django-saas-platform
# Runs pytest and blocks push on test failure
# Install: ln -sf ../../git-hooks/pre-push .git/hooks/pre-push

set -euo pipefail

# Colors for output
RED='\\033[0;31m'
GREEN='\\033[0;32m'
YELLOW='\\033[1;33m'
CYAN='\\033[0;36m'
NC='\\033[0m'

# Parse push arguments to detect target branch
remote="$1"
url="$2"

protected_branch="main"
pushing_to_protected=false

while read -r local_ref local_oid remote_ref remote_oid; do
    if [ -z "$local_ref" ]; then
        continue
    fi
    remote_branch="\${remote_ref#refs/heads/}"
    if [ "$remote_branch" = "$protected_branch" ]; then
        pushing_to_protected=true
    fi
done

echo -e "\${CYAN}═══════════════════════════════════════════\${NC}"
echo -e "\${CYAN}  Pre-push checks — django-saas-platform   \${NC}"
echo -e "\${CYAN}═══════════════════════════════════════════\${NC}"

# Determine which test suite to run based on target branch
if [ "$pushing_to_protected" = true ]; then
    echo -e "\${YELLOW}⚠  Pushing to '\${protected_branch}' — running full test suite\${NC}"
fi

# Check for uv
if ! command -v uv &>/dev/null; then
    echo -e "\${RED}✗ 'uv' not found. Install: https://docs.astral.sh/uv/\${NC}"
    exit 1
fi

# Track overall status
exit_code=0

# ─── Type checking with mypy ───────────────────────────────────────────────────
echo ""
echo -e "\${CYAN}▸ Running mypy type checks...\${NC}"
if uv run mypy src/ --no-error-summary 2>/dev/null; then
    echo -e "\${GREEN}✓ Type checks passed\${NC}"
else
    echo -e "\${RED}✗ Type checks failed\${NC}"
    exit_code=1
fi

# ─── Unit tests ────────────────────────────────────────────────────────────────
echo ""
echo -e "\${CYAN}▸ Running pytest...\${NC}"

if [ "$pushing_to_protected" = true ]; then
    # Full test suite with coverage for pushes to main
    if uv run pytest tests/ \\
        --tb=short \\
        --no-header \\
        -q \\
        --cov=src \\
        --cov-fail-under=85 \\
        --timeout=120 \\
        -x; then
        echo -e "\${GREEN}✓ All tests passed with ≥85% coverage\${NC}"
    else
        echo -e "\${RED}✗ Tests failed or coverage below 85%\${NC}"
        exit_code=1
    fi
else
    # Fast test run for feature branches — skip slow integration tests
    if uv run pytest tests/ \\
        --tb=short \\
        --no-header \\
        -q \\
        -m "not slow and not integration" \\
        --timeout=60 \\
        -x; then
        echo -e "\${GREEN}✓ Unit tests passed\${NC}"
    else
        echo -e "\${RED}✗ Unit tests failed\${NC}"
        exit_code=1
    fi
fi

# ─── Sensitive file checks ────────────────────────────────────────────────────
echo ""
echo -e "\${CYAN}▸ Checking for sensitive files in push...\${NC}"

# Ensure no .env files or secrets are being pushed
sensitive_patterns=(
    '\\.env$'
    '\\.env\\.'
    'config/production/.*\\.py$'
    '.*secret.*\\.json$'
    '.*credentials.*'
    '.*\\.pem$'
    '.*\\.key$'
)

staged_sensitive=false
for pattern in "\${sensitive_patterns[@]}"; do
    if git diff --name-only "HEAD@{upstream}..HEAD" 2>/dev/null | grep -qE "$pattern"; then
        matched_files=$(git diff --name-only "HEAD@{upstream}..HEAD" 2>/dev/null | grep -E "$pattern" || true)
        if [ -n "$matched_files" ]; then
            echo -e "\${RED}✗ Sensitive file detected in push:\${NC}"
            echo "$matched_files" | while read -r f; do echo -e "  \${RED}→ $f\${NC}"; done
            staged_sensitive=true
        fi
    fi
done

if [ "$staged_sensitive" = true ]; then
    echo -e "\${RED}✗ Remove sensitive files before pushing (SOC 2 / GDPR compliance)\${NC}"
    exit_code=1
else
    echo -e "\${GREEN}✓ No sensitive files detected\${NC}"
fi

# ─── Billing and auth module extra checks ──────────────────────────────────────
echo ""
echo -e "\${CYAN}▸ Checking critical module changes...\${NC}"

critical_modules_changed=false
changed_files=$(git diff --name-only "HEAD@{upstream}..HEAD" 2>/dev/null || echo "")

if echo "$changed_files" | grep -qE "^src/(billing|accounts|tenants)/"; then
    critical_modules_changed=true
fi

if [ "$critical_modules_changed" = true ]; then
    echo -e "\${YELLOW}⚠  Changes detected in billing/accounts/tenants modules\${NC}"

    # Run billing-specific tests if billing changed
    if echo "$changed_files" | grep -qE "^src/billing/"; then
        echo -e "\${CYAN}  ▸ Running billing module tests...\${NC}"
        if uv run pytest tests/billing/ -q --tb=short --no-header --timeout=60 -x 2>/dev/null; then
            echo -e "\${GREEN}  ✓ Billing tests passed\${NC}"
        else
            echo -e "\${RED}  ✗ Billing tests failed — Stripe integration may be broken\${NC}"
            exit_code=1
        fi
    fi

    # Run tenant isolation tests if tenants changed
    if echo "$changed_files" | grep -qE "^src/tenants/"; then
        echo -e "\${CYAN}  ▸ Running tenant isolation tests...\${NC}"
        if uv run pytest tests/tenants/ -q --tb=short --no-header --timeout=60 -x 2>/dev/null; then
            echo -e "\${GREEN}  ✓ Tenant isolation tests passed\${NC}"
        else
            echo -e "\${RED}  ✗ Tenant isolation tests failed — data leak risk\${NC}"
            exit_code=1
        fi
    fi

    # Run auth tests if accounts changed
    if echo "$changed_files" | grep -qE "^src/accounts/"; then
        echo -e "\${CYAN}  ▸ Running auth tests...\${NC}"
        if uv run pytest tests/accounts/ -q --tb=short --no-header --timeout=60 -x 2>/dev/null; then
            echo -e "\${GREEN}  ✓ Auth tests passed\${NC}"
        else
            echo -e "\${RED}  ✗ Auth tests failed — access control may be broken\${NC}"
            exit_code=1
        fi
    fi
else
    echo -e "\${GREEN}✓ No critical module changes\${NC}"
fi

# ─── Migration conflict check ─────────────────────────────────────────────────
echo ""
echo -e "\${CYAN}▸ Checking for migration conflicts...\${NC}"

migration_conflicts=$(find src/ -path "*/migrations/*.py" -newer .git/HEAD 2>/dev/null | sort | awk -F/ '{print $1"/"$2"/migrations"}' | uniq -d || true)
if [ -n "$migration_conflicts" ]; then
    echo -e "\${YELLOW}⚠  Potential migration conflicts detected — verify migration ordering\${NC}"
else
    echo -e "\${GREEN}✓ No migration conflicts\${NC}"
fi

# ─── Summary ───────────────────────────────────────────────────────────────────
echo ""
echo -e "\${CYAN}═══════════════════════════════════════════\${NC}"
if [ $exit_code -ne 0 ]; then
    echo -e "\${RED}✗ Pre-push checks FAILED — push blocked\${NC}"
    echo -e "\${RED}  Fix the issues above and try again.\${NC}"
    echo -e "\${YELLOW}  To skip (emergency only): git push --no-verify\${NC}"
else
    echo -e "\${GREEN}✓ All pre-push checks passed\${NC}"
fi
echo -e "\${CYAN}═══════════════════════════════════════════\${NC}"

exit $exit_code`,

  'install.sh': `#!/usr/bin/env bash
set -euo pipefail

# ============================================================================
# django-saas-platform — Project Installer
# Sets up git hooks, installs dependencies, configures .claude/, installs
# the CodeForge plugin, and runs database migrations.
# ============================================================================

SCRIPT_DIR="$(cd "$(dirname "\${BASH_SOURCE[0]}")" && pwd)"
PROJECT_ROOT="$SCRIPT_DIR"

# Colors
RED='\\033[0;31m'
GREEN='\\033[0;32m'
YELLOW='\\033[1;33m'
BLUE='\\033[0;34m'
CYAN='\\033[0;36m'
NC='\\033[0m' # No Color

info()    { echo -e "\${BLUE}[INFO]\${NC}  $*"; }
success() { echo -e "\${GREEN}[OK]\${NC}    $*"; }
warn()    { echo -e "\${YELLOW}[WARN]\${NC}  $*"; }
error()   { echo -e "\${RED}[ERROR]\${NC} $*"; }
step()    { echo -e "\\n\${CYAN}━━━ $* ━━━\${NC}"; }

# ============================================================================
# Pre-flight checks
# ============================================================================
step "Pre-flight checks"

check_command() {
    if command -v "$1" &> /dev/null; then
        local version
        version=$("$1" --version 2>&1 | head -1)
        success "$1 found: $version"
        return 0
    else
        error "$1 is not installed"
        return 1
    fi
}

MISSING=0

check_command "git"       || MISSING=1
check_command "python3"   || MISSING=1
check_command "docker"    || MISSING=1

# Check Python version >= 3.12
PYTHON_VERSION=$(python3 -c 'import sys; print(f"{sys.version_info.major}.{sys.version_info.minor}")')
PYTHON_MAJOR=$(echo "$PYTHON_VERSION" | cut -d. -f1)
PYTHON_MINOR=$(echo "$PYTHON_VERSION" | cut -d. -f2)
if [[ "$PYTHON_MAJOR" -lt 3 ]] || [[ "$PYTHON_MAJOR" -eq 3 && "$PYTHON_MINOR" -lt 12 ]]; then
    error "Python 3.12+ required, found $PYTHON_VERSION"
    MISSING=1
else
    success "Python version $PYTHON_VERSION meets requirement (3.12+)"
fi

# Check for uv — install if missing
if command -v uv &> /dev/null; then
    UV_VERSION=$(uv --version 2>&1 | head -1)
    success "uv found: $UV_VERSION"
else
    warn "uv not found — installing..."
    curl -LsSf https://astral.sh/uv/install.sh | sh
    export PATH="$HOME/.local/bin:$PATH"
    if command -v uv &> /dev/null; then
        success "uv installed: $(uv --version 2>&1 | head -1)"
    else
        error "Failed to install uv. Install manually: https://docs.astral.sh/uv/getting-started/installation/"
        MISSING=1
    fi
fi

if [[ "$MISSING" -eq 1 ]]; then
    error "Missing required dependencies. Please install them and re-run this script."
    exit 1
fi

success "All pre-flight checks passed"

# ============================================================================
# Git hooks
# ============================================================================
step "Installing git hooks"

HOOKS_SOURCE="$PROJECT_ROOT/git-hooks"
HOOKS_TARGET="$PROJECT_ROOT/.git/hooks"

if [[ ! -d "$PROJECT_ROOT/.git" ]]; then
    warn "Not a git repository — initializing..."
    git init "$PROJECT_ROOT"
fi

mkdir -p "$HOOKS_TARGET"

HOOKS_INSTALLED=0
for hook_file in "$HOOKS_SOURCE"/*; do
    if [[ -f "$hook_file" ]]; then
        hook_name=$(basename "$hook_file")
        cp "$hook_file" "$HOOKS_TARGET/$hook_name"
        chmod +x "$HOOKS_TARGET/$hook_name"
        success "Installed hook: $hook_name"
        HOOKS_INSTALLED=$((HOOKS_INSTALLED + 1))
    fi
done

if [[ "$HOOKS_INSTALLED" -eq 0 ]]; then
    warn "No hook files found in $HOOKS_SOURCE"
else
    success "Installed $HOOKS_INSTALLED git hook(s)"
fi

# ============================================================================
# Python dependencies
# ============================================================================
step "Installing Python dependencies with uv"

cd "$PROJECT_ROOT"

if [[ -f "pyproject.toml" ]]; then
    info "Installing project dependencies from pyproject.toml..."
    uv sync --all-extras
    success "Python dependencies installed"
elif [[ -f "requirements.txt" ]]; then
    info "Installing from requirements.txt..."
    uv pip install -r requirements.txt
    if [[ -f "requirements-dev.txt" ]]; then
        uv pip install -r requirements-dev.txt
    fi
    success "Python dependencies installed"
else
    warn "No pyproject.toml or requirements.txt found — creating pyproject.toml scaffold..."
    cat > pyproject.toml << 'PYPROJECT'
[project]
name = "django-saas-platform"
version = "0.1.0"
description = "Multi-tenant SaaS platform with Django"
requires-python = ">=3.12"
dependencies = [
    "django>=5.0,<5.1",
    "djangorestframework>=3.15",
    "strawberry-graphql[django]>=0.220",
    "celery[redis]>=5.3",
    "django-redis>=5.4",
    "psycopg[binary]>=3.1",
    "stripe>=8.0",
    "django-environ>=0.11",
    "pydantic>=2.5",
    "pydantic-settings>=2.1",
    "drf-spectacular>=0.27",
    "django-cors-headers>=4.3",
    "django-filter>=23.5",
    "whitenoise>=6.6",
    "gunicorn>=21.2",
    "sentry-sdk[django,celery]>=1.40",
    "boto3>=1.34",
    "django-storages>=1.14",
    "django-health-check>=3.18",
]

[project.optional-dependencies]
dev = [
    "pytest>=8.0",
    "pytest-django>=4.8",
    "pytest-cov>=4.1",
    "pytest-asyncio>=0.23",
    "pytest-xdist>=3.5",
    "factory-boy>=3.3",
    "faker>=22.0",
    "ruff>=0.3",
    "mypy>=1.8",
    "django-stubs>=4.2",
    "djangorestframework-stubs>=3.14",
    "celery-types>=0.22",
    "ipdb>=0.13",
    "django-debug-toolbar>=4.3",
    "pre-commit>=3.6",
    "freezegun>=1.3",
    "responses>=0.25",
    "stripe-mock>=0.1",
]

[tool.pytest.ini_options]
DJANGO_SETTINGS_MODULE = "config.settings.test"
python_files = ["tests.py", "test_*.py"]
python_classes = ["Test*"]
python_functions = ["test_*"]
addopts = [
    "--strict-markers",
    "--tb=short",
    "--cov=src",
    "--cov-report=term-missing",
    "--cov-fail-under=85",
    "-v",
]
markers = [
    "slow: marks tests as slow (deselect with '-m \\"not slow\\"')",
    "integration: marks integration tests",
    "stripe: marks tests requiring Stripe mock",
    "celery: marks tests requiring Celery worker",
]

[tool.mypy]
python_version = "3.12"
strict = true
plugins = [
    "mypy_django_plugin.main",
    "mypy_drf_plugin.main",
]
exclude = ["migrations/", "tests/"]

[[tool.mypy.overrides]]
module = "*.migrations.*"
ignore_errors = true

[tool.django-stubs]
django_settings_module = "config.settings.development"

[build-system]
requires = ["hatchling"]
build-backend = "hatchling.build"
PYPROJECT

    info "Installing dependencies from generated pyproject.toml..."
    uv sync --all-extras
    success "Python dependencies installed"
fi

# ============================================================================
# .claude/ directory configuration
# ============================================================================
step "Configuring .claude/ directory"

# Ensure all rule directories exist
RULE_DIRS=(
    ".claude/rules/common"
    ".claude/rules/python"
    ".claude/rules/billing"
    ".claude/rules/tenants"
)

for dir in "\${RULE_DIRS[@]}"; do
    mkdir -p "$PROJECT_ROOT/$dir"
done

# Create billing-specific rules if not present
if [[ ! -f "$PROJECT_ROOT/.claude/rules/billing/stripe.md" ]]; then
    cat > "$PROJECT_ROOT/.claude/rules/billing/stripe.md" << 'STRIPE_RULES'
# Stripe Integration Rules

## Webhook Handling
- Always verify webhook signatures using \`stripe.Webhook.construct_event()\`
- All webhook handlers MUST be idempotent — use Stripe event ID for deduplication
- Store raw webhook payloads in \`billing.WebhookEvent\` for audit trail
- Process webhooks asynchronously via Celery tasks after signature verification

## Subscription Lifecycle
- Never modify Stripe objects without updating local database state
- Use Stripe's \`metadata\` field to store tenant_id on all Stripe objects
- Handle all subscription states: active, past_due, canceled, trialing, paused
- Prorate subscription changes by default

## Usage Metering
- Report usage to Stripe via idempotent \`usage_record\` calls
- Buffer usage locally in Redis before batch-reporting to Stripe
- Include idempotency_key on all Stripe API calls

## Security (SOC 2 / PCI)
- Never log full card numbers or Stripe secret keys
- Use Stripe Elements or Checkout for PCI compliance — never handle raw card data
- Restrict billing endpoint access to tenant admins and billing managers
STRIPE_RULES
    success "Created .claude/rules/billing/stripe.md"
fi

# Create tenant-specific rules if not present
if [[ ! -f "$PROJECT_ROOT/.claude/rules/tenants/isolation.md" ]]; then
    cat > "$PROJECT_ROOT/.claude/rules/tenants/isolation.md" << 'TENANT_RULES'
# Multi-Tenancy Rules

## Data Isolation (SOC 2)
- ALL querysets for tenant-scoped models MUST use the tenant-aware manager
- Never use \`.objects.all()\` on tenant-scoped models — use \`.for_tenant(tenant)\`
- PostgreSQL row-level security policies must be applied to all tenant tables
- Cross-tenant data access is a critical security violation — test for it explicitly

## Middleware
- \`TenantMiddleware\` must resolve tenant from subdomain, header, or JWT claim
- Set \`request.tenant\` early in the middleware chain before authentication
- Return 404 (not 403) for invalid tenant slugs to avoid tenant enumeration

## Testing
- Every test that touches tenant data must use \`TenantFactory\` to create isolated tenants
- Include cross-tenant access tests for all API endpoints
- Test row-level security policies directly with raw SQL in integration tests

## GDPR Compliance
- Tenant deletion must cascade to all associated data (right to deletion)
- Support data export per tenant (right to portability)
- Maintain data processing records per tenant
TENANT_RULES
    success "Created .claude/rules/tenants/isolation.md"
fi

# Validate settings.json exists
if [[ -f "$PROJECT_ROOT/.claude/settings.json" ]]; then
    success ".claude/settings.json exists"
else
    warn ".claude/settings.json not found — creating default..."
    cat > "$PROJECT_ROOT/.claude/settings.json" << 'SETTINGS'
{
  "permissions": {
    "allow": [
      "Read",
      "Edit",
      "MultiEdit",
      "Bash(uv run pytest*)",
      "Bash(uv run ruff*)",
      "Bash(uv run mypy*)",
      "Bash(uv run python manage.py*)",
      "Bash(cat *)",
      "Bash(find *)",
      "Bash(grep *)",
      "Bash(git log*)",
      "Bash(git diff*)",
      "Bash(git status*)"
    ],
    "deny": [
      "Bash(git push*)",
      "Bash(git commit*)",
      "Bash(rm -rf*)",
      "Bash(*DROP TABLE*)",
      "Bash(*DELETE FROM*)",
      "Bash(*stripe.api_key*)",
      "Bash(curl*)",
      "Bash(wget*)"
    ]
  }
}
SETTINGS
    success "Created .claude/settings.json"
fi

success ".claude/ directory configured"

# ============================================================================
# CodeForge plugin installation
# ============================================================================
step "Installing CodeForge plugin"

PLUGIN_DIR="$PROJECT_ROOT/plugin/codeforge-django-saas"

if [[ -d "$PLUGIN_DIR" ]]; then
    success "Plugin directory exists: $PLUGIN_DIR"
else
    info "Creating plugin directory structure..."
    mkdir -p "$PLUGIN_DIR"/{agents,commands,skills}

    # Create plugin manifest
    cat > "$PLUGIN_DIR/manifest.json" << 'MANIFEST'
{
  "name": "codeforge-django-saas",
  "version": "0.1.0",
  "description": "CodeForge plugin for Django SaaS Platform development workflows",
  "agents": [
    "agents/backend-developer.md",
    "agents/billing-specialist.md",
    "agents/tenant-architect.md"
  ],
  "commands": [
    "commands/new-endpoint.md",
    "commands/new-celery-task.md",
    "commands/new-django-app.md",
    "commands/stripe-webhook.md"
  ],
  "skills": [
    "skills/tenant-isolation.md",
    "skills/stripe-integration.md",
    "skills/drf-viewset.md",
    "skills/celery-task-pattern.md"
  ]
}
MANIFEST
    success "Created plugin manifest"

    # Create a sample agent
    cat > "$PLUGIN_DIR/agents/backend-developer.md" << 'AGENT'
# Backend Developer Agent

You are a senior Django backend developer working on a multi-tenant SaaS platform.

## Context
- Django 5.0 with DRF and Strawberry GraphQL
- PostgreSQL with row-level security for tenant isolation
- Celery 5 with Redis broker for async tasks
- Stripe for subscription billing

## Responsibilities
- Implement API endpoints with proper tenant scoping
- Write idempotent Celery tasks
- Ensure all code has type hints and passes mypy strict mode
- Write tests with factory_boy fixtures (85% coverage minimum)
- Follow conventional commits and the project's coding standards

## Key Patterns
- Use \`TenantAwareManager\` for all tenant-scoped queries
- Use the service layer pattern — keep views thin
- All Stripe operations go through \`src/billing/services.py\`
- Celery tasks must handle retries with exponential backoff
AGENT
    success "Created backend-developer agent"
fi

success "CodeForge plugin installed"

# ============================================================================
# Environment configuration
# ============================================================================
step "Setting up environment configuration"

ENV_FILE="$PROJECT_ROOT/.env"
ENV_EXAMPLE="$PROJECT_ROOT/.env.example"

# Create .env.example if it doesn't exist
if [[ ! -f "$ENV_EXAMPLE" ]]; then
    cat > "$ENV_EXAMPLE" << 'ENVEXAMPLE'
# Django
DJANGO_SETTINGS_MODULE=config.settings.development
DJANGO_SECRET_KEY=change-me-in-production
DJANGO_DEBUG=True
DJANGO_ALLOWED_HOSTS=localhost,127.0.0.1,.localhost

# Database (PostgreSQL)
DATABASE_URL=postgres://saas_user:saas_pass@localhost:5432/saas_platform
DATABASE_CONN_MAX_AGE=600

# Redis
REDIS_URL=redis://localhost:6379/0
CELERY_BROKER_URL=redis://localhost:6379/1
CELERY_RESULT_BACKEND=redis://localhost:6379/2
CACHE_URL=redis://localhost:6379/3

# Stripe
STRIPE_SECRET_KEY=sk_test_CHANGE_ME
STRIPE_PUBLISHABLE_KEY=pk_test_CHANGE_ME
STRIPE_WEBHOOK_SECRET=whsec_CHANGE_ME
STRIPE_PRICE_ID_STARTER=price_CHANGE_ME
STRIPE_PRICE_ID_PROFESSIONAL=price_CHANGE_ME
STRIPE_PRICE_ID_ENTERPRISE=price_CHANGE_ME

# AWS
AWS_ACCESS_KEY_ID=
AWS_SECRET_ACCESS_KEY=
AWS_STORAGE_BUCKET_NAME=saas-platform-assets
AWS_S3_REGION_NAME=us-east-1

# Email (SES)
EMAIL_BACKEND=django.core.mail.backends.console.EmailBackend
AWS_SES_REGION_NAME=us-east-1

# Sentry
SENTRY_DSN=

# Multi-tenancy
TENANT_HEADER=X-Tenant-ID
TENANT_COOKIE=tenant_id
DEFAULT_TENANT_SLUG=demo

# Security
CORS_ALLOWED_ORIGINS=http://localhost:3000,http://localhost:8000
CSRF_TRUSTED_ORIGINS=http://localhost:3000,http://localhost:8000
ENVEXAMPLE
    success "Created .env.example"
fi

if [[ ! -f "$ENV_FILE" ]]; then
    info "Creating .env from .env.example..."
    cp "$ENV_EXAMPLE" "$ENV_FILE"

    # Generate a random Django secret key
    DJANGO_SECRET=$(python3 -c "import secrets; print(secrets.token_urlsafe(50))")
    if [[ "$(uname)" == "Darwin" ]]; then
        sed -i '' "s|DJANGO_SECRET_KEY=change-me-in-production|DJANGO_SECRET_KEY=$DJANGO_SECRET|" "$ENV_FILE"
    else
        sed -i "s|DJANGO_SECRET_KEY=change-me-in-production|DJANGO_SECRET_KEY=$DJANGO_SECRET|" "$ENV_FILE"
    fi

    success "Created .env with generated secret key"
    warn "Review .env and update Stripe keys, database URL, and other secrets"
else
    success ".env already exists — skipping"
fi

# ============================================================================
# Docker services (PostgreSQL + Redis)
# ============================================================================
step "Checking Docker services"

DOCKER_COMPOSE_FILE="$PROJECT_ROOT/docker-compose.yml"

if [[ ! -f "$DOCKER_COMPOSE_FILE" ]]; then
    cat > "$DOCKER_COMPOSE_FILE" << 'DOCKERCOMPOSE'
services:
  postgres:
    image: postgres:16-alpine
    environment:
      POSTGRES_DB: saas_platform
      POSTGRES_USER: saas_user
      POSTGRES_PASSWORD: saas_pass
    ports:
      - "5432:5432"
    volumes:
      - postgres_data:/var/lib/postgresql/data
      - ./scripts/init-db.sql:/docker-entrypoint-initdb.d/init.sql
    healthcheck:
      test: ["CMD-SHELL", "pg_isready -U saas_user -d saas_platform"]
      interval: 5s
      timeout: 5s
      retries: 5

  redis:
    image: redis:7-alpine
    ports:
      - "6379:6379"
    volumes:
      - redis_data:/data
    healthcheck:
      test: ["CMD", "redis-cli", "ping"]
      interval: 5s
      timeout: 5s
      retries: 5

  celery-worker:
    build: .
    command: celery -A config worker -l info -Q default,billing,notifications
    environment:
      - DJANGO_SETTINGS_MODULE=config.settings.development
    env_file: .env
    depends_on:
      postgres:
        condition: service_healthy
      redis:
        condition: service_healthy
    volumes:
      - .:/app

  celery-beat:
    build: .
    command: celery -A config beat -l info --scheduler django_celery_beat.schedulers:DatabaseScheduler
    environment:
      - DJANGO_SETTINGS_MODULE=config.settings.development
    env_file: .env
    depends_on:
      postgres:
        condition: service_healthy
      redis:
        condition: service_healthy
    volumes:
      - .:/app

volumes:
  postgres_data:
  redis_data:
DOCKERCOMPOSE
    success "Created docker-compose.yml"
fi

# Create DB init script for row-level security setup
mkdir -p "$PROJECT_ROOT/scripts"
if [[ ! -f "$PROJECT_ROOT/scripts/init-db.sql" ]]; then
    cat > "$PROJECT_ROOT/scripts/init-db.sql" << 'INITSQL'
-- Enable row-level security extensions
CREATE EXTENSION IF NOT EXISTS "uuid-ossp";
CREATE EXTENSION IF NOT EXISTS "pgcrypto";

-- Create a function to get the current tenant ID from session variable
CREATE OR REPLACE FUNCTION current_tenant_id() RETURNS UUID AS $$
BEGIN
    RETURN NULLIF(current_setting('app.current_tenant_id', TRUE), '')::UUID;
EXCEPTION
    WHEN OTHERS THEN RETURN NULL;
END;
$$ LANGUAGE plpgsql STABLE;

-- Log setup completion
DO $$ BEGIN RAISE NOTICE 'Row-level security functions initialized'; END $$;
INITSQL
    success "Created scripts/init-db.sql"
fi

# Start Docker services if Docker is running
if docker info &> /dev/null 2>&1; then
    info "Starting PostgreSQL and Redis via Docker Compose..."
    docker compose -f "$DOCKER_COMPOSE_FILE" up -d postgres redis 2>/dev/null || \\
        docker-compose -f "$DOCKER_COMPOSE_FILE" up -d postgres redis 2>/dev/null || \\
        warn "Could not start Docker services — start them manually with: docker compose up -d"

    # Wait for services to be healthy
    info "Waiting for services to be ready..."
    sleep 3

    if docker compose exec -T postgres pg_isready -U saas_user -d saas_platform &> /dev/null 2>&1; then
        success "PostgreSQL is ready"
    else
        warn "PostgreSQL may not be ready yet — check with: docker compose ps"
    fi

    if docker compose exec -T redis redis-cli ping &> /dev/null 2>&1; then
        success "Redis is ready"
    else
        warn "Redis may not be ready yet — check with: docker compose ps"
    fi
else
    warn "Docker daemon not running — start Docker and run: docker compose up -d"
fi

# ============================================================================
# Django project structure
# ============================================================================
step "Ensuring Django project structure"

SRC_DIRS=(
    "src/accounts"
    "src/tenants"
    "src/billing"
    "src/api"
    "src/core"
    "src/notifications"
    "src/tasks"
    "src/utils"
    "config/settings"
    "tests/accounts"
    "tests/tenants"
    "tests/billing"
    "tests/api"
    "tests/core"
    "tests/notifications"
    "tests/tasks"
    "templates/email"
    "static"
    "playbook"
)

for dir in "\${SRC_DIRS[@]}"; do
    mkdir -p "$PROJECT_ROOT/$dir"
    # Add __init__.py for Python packages under src/, config/, and tests/
    if [[ "$dir" == src/* ]] || [[ "$dir" == tests/* ]] || [[ "$dir" == config/* ]]; then
        touch "$PROJECT_ROOT/$dir/__init__.py"
    fi
done

# Ensure top-level __init__.py files
touch "$PROJECT_ROOT/src/__init__.py"
touch "$PROJECT_ROOT/tests/__init__.py"
touch "$PROJECT_ROOT/config/__init__.py"

success "Django project structure verified"

# ============================================================================
# Database migrations
# ============================================================================
step "Running database migrations"

export DJANGO_SETTINGS_MODULE="\${DJANGO_SETTINGS_MODULE:-config.settings.development}"

if [[ -f "$PROJECT_ROOT/config/settings/development.py" ]] || [[ -f "$PROJECT_ROOT/config/settings.py" ]]; then
    info "Running makemigrations..."
    uv run python manage.py makemigrations --no-input 2>/dev/null && \\
        success "Migrations created" || \\
        warn "makemigrations skipped — Django settings may need configuration"

    info "Running migrate..."
    uv run python manage.py migrate --no-input 2>/dev/null && \\
        success "Database migrated" || \\
        warn "migrate skipped — ensure PostgreSQL is running and settings are configured"
else
    warn "Django settings not found — skipping migrations"
    info "Create config/settings/development.py and re-run: uv run python manage.py migrate"
fi

# ============================================================================
# MCP mock servers (optional)
# ============================================================================
step "Setting up MCP mock servers (optional)"

MCP_DIR="$PROJECT_ROOT/mock-mcp-servers"
if [[ -f "$MCP_DIR/package.json" ]]; then
    if command -v node &> /dev/null; then
        info "Installing MCP mock server dependencies..."
        cd "$MCP_DIR"
        npm install --silent 2>/dev/null && \\
            success "MCP mock servers ready" || \\
            warn "npm install failed — MCP mocks are optional"
        cd "$PROJECT_ROOT"
    else
        warn "Node.js not found — MCP mock servers are optional, skipping"
    fi
else
    warn "MCP mock servers not found — skipping"
fi

# ============================================================================
# Verification
# ============================================================================
step "Running verification checks"

CHECKS_PASSED=0
CHECKS_FAILED=0

run_check() {
    local name="$1"
    shift
    if "$@" &> /dev/null 2>&1; then
        success "$name"
        CHECKS_PASSED=$((CHECKS_PASSED + 1))
    else
        warn "$name — may need manual setup"
        CHECKS_FAILED=$((CHECKS_FAILED + 1))
    fi
}

run_check "ruff is available"        uv run ruff --version
run_check "mypy is available"        uv run mypy --version
run_check "pytest is available"      uv run pytest --version
run_check "celery is available"      uv run celery --version
run_check "Git hooks installed"      test -x "$HOOKS_TARGET/pre-commit"
run_check ".claude/settings.json"    test -f "$PROJECT_ROOT/.claude/settings.json"
run_check "Plugin manifest"          test -f "$PLUGIN_DIR/manifest.json"
run_check ".env file"                test -f "$PROJECT_ROOT/.env"

# ============================================================================
# Summary
# ============================================================================
step "Setup Complete"

echo ""
echo -e "\${GREEN}╔══════════════════════════════════════════════════════════════╗\${NC}"
echo -e "\${GREEN}║          django-saas-platform — Setup Complete              ║\${NC}"
echo -e "\${GREEN}╠══════════════════════════════════════════════════════════════╣\${NC}"
echo -e "\${GREEN}║\${NC}  Checks passed: \${GREEN}$CHECKS_PASSED\${NC}    Warnings: \${YELLOW}$CHECKS_FAILED\${NC}                     \${GREEN}║\${NC}"
echo -e "\${GREEN}╠══════════════════════════════════════════════════════════════╣\${NC}"
echo -e "\${GREEN}║\${NC}  Next steps:                                                \${GREEN}║\${NC}"
echo -e "\${GREEN}║\${NC}                                                              \${GREEN}║\${NC}"
echo -e "\${GREEN}║\${NC}  1. Review and update \${CYAN}.env\${NC} with your credentials            \${GREEN}║\${NC}"
echo -e "\${GREEN}║\${NC}  2. Start services:  \${CYAN}docker compose up -d\${NC}                   \${GREEN}║\${NC}"
echo -e "\${GREEN}║\${NC}  3. Run migrations:  \${CYAN}uv run python manage.py migrate\${NC}        \${GREEN}║\${NC}"
echo -e "\${GREEN}║\${NC}  4. Create admin:    \${CYAN}uv run python manage.py createsuperuser\${NC} \${GREEN}║\${NC}"
echo -e "\${GREEN}║\${NC}  5. Run server:      \${CYAN}uv run python manage.py runserver\${NC}      \${GREEN}║\${NC}"
echo -e "\${GREEN}║\${NC}  6. Run tests:       \${CYAN}uv run pytest\${NC}                          \${GREEN}║\${NC}"
echo -e "\${GREEN}║\${NC}  7. Run linter:      \${CYAN}uv run ruff check src/ tests/\${NC}          \${GREEN}║\${NC}"
echo -e "\${GREEN}║\${NC}  8. Run type check:  \${CYAN}uv run mypy src/\${NC}                       \${GREEN}║\${NC}"
echo -e "\${GREEN}║\${NC}  9. Start Celery:    \${CYAN}docker compose up -d celery-worker\${NC}     \${GREEN}║\${NC}"
echo -e "\${GREEN}║\${NC}                                                              \${GREEN}║\${NC}"
echo -e "\${GREEN}║\${NC}  Docs: \${CYAN}docs/ONBOARDING.md\${NC}  |  Contributing: \${CYAN}docs/CONTRIBUTING.md\${NC}\${GREEN}║\${NC}"
echo -e "\${GREEN}╚══════════════════════════════════════════════════════════════╝\${NC}"
echo ""`,

  'mock-mcp-servers/README.md': `# Mock MCP Servers

Local mock implementations of MCP (Model Context Protocol) servers used by Claude Code in the django-saas-platform project. These servers simulate external tool integrations so developers can work with Claude Code without requiring live API credentials.

## Overview

| Server | File | Port | Simulates |
|--------|------|------|-----------|
| GitHub | \`github-server.mjs\` | stdio | GitHub Issues, PRs, code search, CODEOWNERS |
| Jira | \`jira-server.mjs\` | stdio | Jira-style ticket management (GitHub Issues proxy) |

## Prerequisites

- Node.js 18+ installed
- Claude Code CLI configured
- Project \`.mcp.json\` at repository root (already provided)

## Setup

### 1. Install dependencies

\`\`\`bash
cd mock-mcp-servers
npm install @modelcontextprotocol/sdk zod
\`\`\`

### 2. Verify servers start correctly

\`\`\`bash
# Test GitHub mock server
node github-server.mjs
# Should output: "GitHub MCP Server running on stdio"

# Test Jira mock server
node jira-server.mjs
# Should output: "Jira MCP Server running on stdio"
\`\`\`

Press \`Ctrl+C\` to stop each server after verifying.

### 3. Claude Code integration

The root \`.mcp.json\` already references these servers. Claude Code starts them automatically via stdio transport when you invoke MCP tools. No manual server startup is needed during normal usage.

## Available Tools

### GitHub Server (\`github-server.mjs\`)

| Tool | Description | Key Parameters |
|------|-------------|----------------|
| \`github_get_issue\` | Fetch a GitHub Issue by number | \`issue_number\` |
| \`github_list_issues\` | List issues with filters | \`state\`, \`labels\`, \`assignee\`, \`milestone\` |
| \`github_create_issue\` | Create a new issue | \`title\`, \`body\`, \`labels\`, \`assignee\` |
| \`github_update_issue\` | Update an existing issue | \`issue_number\`, \`state\`, \`title\`, \`body\`, \`labels\` |
| \`github_search_code\` | Search code in the repository | \`query\`, \`path\`, \`extension\` |
| \`github_list_prs\` | List pull requests | \`state\`, \`author\`, \`base\` |
| \`github_get_pr\` | Get PR details with diff stats | \`pr_number\` |
| \`github_create_pr\` | Create a pull request | \`title\`, \`body\`, \`head\`, \`base\`, \`draft\` |

**Mock data includes:**

- Sample issues for tenant onboarding, Stripe webhook hardening, Celery task idempotency, GDPR data export, and RLS policy bugs
- Sample PRs referencing the \`feat/\`, \`fix/\`, \`chore/\` branch naming convention
- Code search results pointing to actual project paths (\`src/billing/\`, \`src/tenants/\`, \`src/core/\`)

### Jira Server (\`jira-server.mjs\`)

| Tool | Description | Key Parameters |
|------|-------------|----------------|
| \`jira_get_ticket\` | Fetch a ticket by key (e.g., \`SAAS-42\`) | \`ticket_key\` |
| \`jira_list_tickets\` | List tickets with filters | \`status\`, \`assignee\`, \`sprint\`, \`priority\`, \`type\` |
| \`jira_create_ticket\` | Create a new ticket | \`summary\`, \`description\`, \`type\`, \`priority\`, \`assignee\` |
| \`jira_update_ticket\` | Update ticket fields | \`ticket_key\`, \`status\`, \`summary\`, \`assignee\`, \`priority\` |
| \`jira_add_comment\` | Add a comment to a ticket | \`ticket_key\`, \`comment\` |
| \`jira_transition_ticket\` | Move ticket through workflow | \`ticket_key\`, \`transition\` (\`start\`, \`review\`, \`done\`, \`reopen\`) |

**Mock data includes:**

- Tickets mapped to SaaS platform epics: multi-tenancy, billing, RBAC, audit logging, white-label
- Workflow states: \`To Do\` → \`In Progress\` → \`In Review\` → \`Done\`
- Priority levels: Critical, High, Medium, Low
- Ticket types: Story, Bug, Task, Epic

## How Mock Data Works

Both servers use in-memory data stores initialized with realistic fixtures that mirror the django-saas-platform domain:

\`\`\`
SAAS-42  → feat: Tenant onboarding flow (Story, High)
SAAS-43  → fix: Stripe webhook signature verification (Bug, Critical)
SAAS-44  → feat: GDPR data export endpoint (Story, High)
SAAS-45  → chore: Add RLS policies for billing tables (Task, Medium)
SAAS-46  → feat: Usage-based metering aggregation (Story, High)
SAAS-100 → fix: Celery task retry not idempotent (Bug, High)
SAAS-101 → feat: White-label email templates (Story, Medium)
\`\`\`

Data persists only for the lifetime of the server process. Restarting a server resets to the initial fixtures.

## Customizing Mock Data

Edit the data arrays at the top of each server file to add or modify fixtures:

\`\`\`javascript
// In github-server.mjs — add a new issue
const MOCK_ISSUES = [
  // ... existing issues
  {
    number: 15,
    title: "Add SOC 2 audit trail for tenant admin actions",
    body: "All admin-level actions must be logged...",
    state: "open",
    labels: ["compliance", "soc2", "audit"],
    assignee: "your-username",
    milestone: "v1.2.0",
  },
];
\`\`\`

## Switching to Live Servers

When you're ready to connect to real GitHub or project management APIs, update \`.mcp.json\` at the repository root:

\`\`\`json
{
  "mcpServers": {
    "github": {
      "command": "npx",
      "args": ["-y", "@modelcontextprotocol/server-github"],
      "env": {
        "GITHUB_PERSONAL_ACCESS_TOKEN": "\${GITHUB_TOKEN}"
      }
    }
  }
}
\`\`\`

> **Note:** Never commit real API tokens. Use environment variable references (\`\${VAR}\`) in \`.mcp.json\` and set values in your shell profile or \`.env\` file (which is gitignored).

## Troubleshooting

### Server won't start

\`\`\`bash
# Check Node.js version (need 18+)
node --version

# Reinstall dependencies
rm -rf node_modules
npm install @modelcontextprotocol/sdk zod
\`\`\`

### Claude Code doesn't see MCP tools

1. Verify \`.mcp.json\` exists at the repository root
2. Check that file paths in \`.mcp.json\` match your OS (use forward slashes)
3. Restart Claude Code after modifying \`.mcp.json\`
4. Run \`claude mcp list\` to verify registered servers

### Tools return unexpected data

Mock servers return deterministic fixture data. If you need specific scenarios for testing Claude Code prompts, edit the fixture arrays in the server files directly.

## Related Files

- [\`/.mcp.json\`](../.mcp.json) — MCP server configuration for Claude Code
- [\`/.claude/settings.json\`](../.claude/settings.json) — Claude Code permissions including MCP tool allowlists
- [\`/.claude/rules/common/git-workflow.md\`](../.claude/rules/common/git-workflow.md) — Branch naming and commit conventions used in mock data`,

  'mock-mcp-servers/github-server.mjs': `import { Server } from "@modelcontextprotocol/sdk/server/index.js";
import { StdioServerTransport } from "@modelcontextprotocol/sdk/server/stdio.js";
import {
  CallToolRequestSchema,
  ListToolsRequestSchema,
} from "@modelcontextprotocol/sdk/types.js";

const server = new Server(
  { name: "mock-github-server", version: "1.0.0" },
  { capabilities: { tools: {} } }
);

const mockIssues = [
  {
    number: 42,
    title: "Add tenant onboarding flow",
    state: "open",
    labels: ["feat", "tenants"],
    assignee: "dev-alice",
    body: "Implement the multi-step tenant onboarding wizard with Stripe subscription setup.",
    milestone: "v1.2.0",
  },
  {
    number: 43,
    title: "Fix Stripe webhook idempotency for invoice.paid",
    state: "open",
    labels: ["fix", "billing"],
    assignee: "dev-bob",
    body: "Duplicate invoice.paid events cause double credit application. Ensure idempotency key check.",
    milestone: "v1.1.1",
  },
  {
    number: 38,
    title: "Add row-level security policies for reports table",
    state: "closed",
    labels: ["security", "tenants"],
    assignee: "dev-carol",
    body: "PostgreSQL RLS policies missing on the reports table. SOC 2 audit finding.",
    milestone: "v1.1.0",
  },
];

const mockPRs = [
  {
    number: 101,
    title: "feat(tenants): add tenant-aware queryset manager",
    state: "open",
    head: "feat/SAAS-42-add-tenant-onboarding",
    base: "main",
    author: "dev-alice",
    labels: ["feat", "tenants"],
    reviewers: ["dev-carol", "dev-lead"],
    checks: { lint: "pass", typecheck: "pass", tests: "pass", security: "pass" },
    mergeable: true,
    body: "Implements TenantAwareManager that automatically filters querysets by current tenant context.",
    files_changed: [
      "src/core/managers.py",
      "src/core/middleware.py",
      "tests/core/test_managers.py",
    ],
  },
  {
    number: 102,
    title: "fix(billing): stripe webhook idempotency",
    state: "open",
    head: "fix/SAAS-43-webhook-idempotency",
    base: "main",
    author: "dev-bob",
    labels: ["fix", "billing"],
    reviewers: ["dev-alice"],
    checks: { lint: "pass", typecheck: "pass", tests: "running", security: "pass" },
    mergeable: false,
    body: "Adds idempotency key tracking table and deduplication logic for Stripe webhook events.",
    files_changed: [
      "src/billing/webhooks.py",
      "src/billing/models.py",
      "src/billing/migrations/0005_webhook_event_log.py",
      "tests/billing/test_webhooks.py",
    ],
  },
];

const mockRepo = {
  full_name: "myorg/django-saas-platform",
  default_branch: "main",
  private: true,
  description: "Multi-tenant SaaS platform with Django 5.0, Stripe billing, Celery tasks",
  topics: ["django", "saas", "multi-tenant", "stripe", "celery"],
  language: "Python",
  open_issues_count: 2,
  has_codeowners: true,
  branch_protection: {
    main: {
      required_reviews: 1,
      require_status_checks: true,
      required_checks: ["lint", "typecheck", "test-unit", "test-integration", "security-scan"],
      enforce_admins: true,
    },
  },
};

let nextIssueNumber = 50;
let nextPRNumber = 110;

function findIssue(number) {
  return mockIssues.find((i) => i.number === number) || null;
}

function findPR(number) {
  return mockPRs.find((p) => p.number === number) || null;
}

server.setRequestHandler(ListToolsRequestSchema, async () => ({
  tools: [
    {
      name: "get_repo",
      description: "Get repository information for django-saas-platform",
      inputSchema: {
        type: "object",
        properties: {
          owner: { type: "string", description: "Repository owner" },
          repo: { type: "string", description: "Repository name" },
        },
        required: ["owner", "repo"],
      },
    },
    {
      name: "list_issues",
      description: "List issues with optional filters",
      inputSchema: {
        type: "object",
        properties: {
          state: { type: "string", enum: ["open", "closed", "all"], default: "open" },
          labels: { type: "array", items: { type: "string" } },
          assignee: { type: "string" },
        },
      },
    },
    {
      name: "get_issue",
      description: "Get a specific issue by number",
      inputSchema: {
        type: "object",
        properties: { issue_number: { type: "number" } },
        required: ["issue_number"],
      },
    },
    {
      name: "create_issue",
      description: "Create a new GitHub issue",
      inputSchema: {
        type: "object",
        properties: {
          title: { type: "string" },
          body: { type: "string" },
          labels: { type: "array", items: { type: "string" } },
          assignee: { type: "string" },
          milestone: { type: "string" },
        },
        required: ["title"],
      },
    },
    {
      name: "list_pull_requests",
      description: "List pull requests with optional filters",
      inputSchema: {
        type: "object",
        properties: {
          state: { type: "string", enum: ["open", "closed", "all"], default: "open" },
          head: { type: "string" },
          base: { type: "string" },
        },
      },
    },
    {
      name: "get_pull_request",
      description: "Get a specific pull request by number",
      inputSchema: {
        type: "object",
        properties: { pr_number: { type: "number" } },
        required: ["pr_number"],
      },
    },
    {
      name: "create_pull_request",
      description: "Create a new pull request",
      inputSchema: {
        type: "object",
        properties: {
          title: { type: "string" },
          body: { type: "string" },
          head: { type: "string" },
          base: { type: "string", default: "main" },
          labels: { type: "array", items: { type: "string" } },
          reviewers: { type: "array", items: { type: "string" } },
        },
        required: ["title", "head"],
      },
    },
    {
      name: "merge_pull_request",
      description: "Merge a pull request",
      inputSchema: {
        type: "object",
        properties: {
          pr_number: { type: "number" },
          merge_method: { type: "string", enum: ["merge", "squash", "rebase"], default: "squash" },
        },
        required: ["pr_number"],
      },
    },
    {
      name: "get_check_status",
      description: "Get CI check status for a PR or branch",
      inputSchema: {
        type: "object",
        properties: {
          pr_number: { type: "number" },
          branch: { type: "string" },
        },
      },
    },
    {
      name: "list_codeowners",
      description: "Get CODEOWNERS rules for the repository",
      inputSchema: { type: "object", properties: {} },
    },
    {
      name: "get_branch_protection",
      description: "Get branch protection rules",
      inputSchema: {
        type: "object",
        properties: { branch: { type: "string", default: "main" } },
      },
    },
  ],
}));

server.setRequestHandler(CallToolRequestSchema, async (request) => {
  const { name, arguments: args } = request.params;

  switch (name) {
    case "get_repo": {
      return { content: [{ type: "text", text: JSON.stringify(mockRepo, null, 2) }] };
    }

    case "list_issues": {
      let filtered = [...mockIssues];
      const state = args?.state || "open";
      if (state !== "all") {
        filtered = filtered.filter((i) => i.state === state);
      }
      if (args?.labels?.length) {
        filtered = filtered.filter((i) =>
          args.labels.some((l) => i.labels.includes(l))
        );
      }
      if (args?.assignee) {
        filtered = filtered.filter((i) => i.assignee === args.assignee);
      }
      return { content: [{ type: "text", text: JSON.stringify(filtered, null, 2) }] };
    }

    case "get_issue": {
      const issue = findIssue(args.issue_number);
      if (!issue) {
        return {
          content: [{ type: "text", text: \`Issue #\${args.issue_number} not found\` }],
          isError: true,
        };
      }
      return { content: [{ type: "text", text: JSON.stringify(issue, null, 2) }] };
    }

    case "create_issue": {
      const newIssue = {
        number: nextIssueNumber++,
        title: args.title,
        state: "open",
        labels: args.labels || [],
        assignee: args.assignee || null,
        body: args.body || "",
        milestone: args.milestone || null,
      };
      mockIssues.push(newIssue);
      return {
        content: [
          {
            type: "text",
            text: JSON.stringify(
              { message: \`Issue #\${newIssue.number} created\`, issue: newIssue },
              null,
              2
            ),
          },
        ],
      };
    }

    case "list_pull_requests": {
      let filtered = [...mockPRs];
      const state = args?.state || "open";
      if (state !== "all") {
        filtered = filtered.filter((p) => p.state === state);
      }
      if (args?.head) {
        filtered = filtered.filter((p) => p.head === args.head);
      }
      if (args?.base) {
        filtered = filtered.filter((p) => p.base === args.base);
      }
      return { content: [{ type: "text", text: JSON.stringify(filtered, null, 2) }] };
    }

    case "get_pull_request": {
      const pr = findPR(args.pr_number);
      if (!pr) {
        return {
          content: [{ type: "text", text: \`PR #\${args.pr_number} not found\` }],
          isError: true,
        };
      }
      return { content: [{ type: "text", text: JSON.stringify(pr, null, 2) }] };
    }

    case "create_pull_request": {
      const newPR = {
        number: nextPRNumber++,
        title: args.title,
        state: "open",
        head: args.head,
        base: args.base || "main",
        author: "claude-dev",
        labels: args.labels || [],
        reviewers: args.reviewers || [],
        checks: { lint: "pending", typecheck: "pending", tests: "pending", security: "pending" },
        mergeable: false,
        body: args.body || "",
        files_changed: [],
      };
      mockPRs.push(newPR);
      return {
        content: [
          {
            type: "text",
            text: JSON.stringify(
              { message: \`PR #\${newPR.number} created\`, pull_request: newPR },
              null,
              2
            ),
          },
        ],
      };
    }

    case "merge_pull_request": {
      const pr = findPR(args.pr_number);
      if (!pr) {
        return {
          content: [{ type: "text", text: \`PR #\${args.pr_number} not found\` }],
          isError: true,
        };
      }
      if (!pr.mergeable) {
        const failingChecks = Object.entries(pr.checks)
          .filter(([, v]) => v !== "pass")
          .map(([k, v]) => \`\${k}: \${v}\`);
        return {
          content: [
            {
              type: "text",
              text: JSON.stringify(
                {
                  error: "PR is not mergeable",
                  reason: failingChecks.length
                    ? \`Failing checks: \${failingChecks.join(", ")}\`
                    : "Requires at least 1 approval",
                },
                null,
                2
              ),
            },
          ],
          isError: true,
        };
      }
      pr.state = "closed";
      return {
        content: [
          {
            type: "text",
            text: JSON.stringify(
              {
                message: \`PR #\${pr.number} merged via \${args.merge_method || "squash"}\`,
                sha: "abc123def456",
              },
              null,
              2
            ),
          },
        ],
      };
    }

    case "get_check_status": {
      let checks = null;
      if (args?.pr_number) {
        const pr = findPR(args.pr_number);
        if (pr) checks = pr.checks;
      }
      if (!checks) {
        checks = { lint: "pass", typecheck: "pass", tests: "pass", security: "pass" };
      }
      const allPassing = Object.values(checks).every((v) => v === "pass");
      return {
        content: [
          {
            type: "text",
            text: JSON.stringify(
              {
                status: allPassing ? "success" : "pending",
                checks,
                required: mockRepo.branch_protection.main.required_checks,
              },
              null,
              2
            ),
          },
        ],
      };
    }

    case "list_codeowners": {
      const codeowners = {
        rules: [
          { pattern: "src/billing/**", owners: ["@billing-team", "@dev-lead"] },
          { pattern: "src/accounts/**", owners: ["@auth-team", "@dev-lead"] },
          { pattern: "src/tenants/**", owners: ["@platform-team", "@dev-lead"] },
          { pattern: "config/production/**", owners: ["@dev-lead", "@devops"] },
          { pattern: ".env*", owners: ["@dev-lead", "@devops"] },
          { pattern: "src/core/**", owners: ["@platform-team"] },
          { pattern: "src/api/**", owners: ["@api-team"] },
          { pattern: "src/tasks/**", owners: ["@platform-team"] },
          { pattern: ".github/**", owners: ["@devops", "@dev-lead"] },
          { pattern: "*", owners: ["@dev-lead"] },
        ],
      };
      return { content: [{ type: "text", text: JSON.stringify(codeowners, null, 2) }] };
    }

    case "get_branch_protection": {
      const branch = args?.branch || "main";
      const protection = mockRepo.branch_protection[branch];
      if (!protection) {
        return {
          content: [{ type: "text", text: \`No protection rules for branch: \${branch}\` }],
          isError: true,
        };
      }
      return { content: [{ type: "text", text: JSON.stringify(protection, null, 2) }] };
    }

    default: {
      return {
        content: [{ type: "text", text: \`Unknown tool: \${name}\` }],
        isError: true,
      };
    }
  }
});

async function main() {
  const transport = new StdioServerTransport();
  await server.connect(transport);
  console.error("Mock GitHub MCP server running (django-saas-platform context)");
}

main().catch((err) => {
  console.error("Failed to start mock GitHub server:", err);
  process.exit(1);
});`,

  'mock-mcp-servers/jira-server.mjs': `#!/usr/bin/env node

/**
 * Mock GitHub Issues MCP Server for django-saas-platform
 * Simulates ticket lookup for SaaS feature tasks and billing issues.
 * 
 * Note: This project uses GitHub Issues (not Jira), but this mock server
 * provides a compatible MCP interface for development and testing.
 * 
 * Usage: node mock-mcp-servers/jira-server.mjs
 */

import { createServer } from "http";

const PORT = process.env.MOCK_TICKET_MCP_PORT || 3401;
const PROJECT_KEY = "SAAS";

const mockTickets = {
  "SAAS-1": {
    key: "SAAS-1",
    summary: "Set up multi-tenant Django project structure",
    description: "Initialize Django 5.0 project with modular app layout. Create core, tenants, accounts, billing, api, notifications, and tasks apps. Configure django-environ and Pydantic settings for config management. Set up PostgreSQL with row-level security foundations.",
    status: "Done",
    type: "Story",
    priority: "Critical",
    assignee: "lead-dev",
    labels: ["infrastructure", "tenancy"],
    sprint: "Sprint 1",
    story_points: 8,
    acceptance_criteria: [
      "Django 5.0 project runs with uv",
      "All apps registered in INSTALLED_APPS",
      "PostgreSQL connection configured via django-environ",
      "Base tenant model created with UUID primary key",
      "CI pipeline passes lint, type check, and tests"
    ]
  },
  "SAAS-2": {
    key: "SAAS-2",
    summary: "Implement tenant-aware model manager and middleware",
    description: "Create TenantAwareManager that automatically filters querysets by current tenant. Implement TenantMiddleware that extracts tenant from subdomain or header. All tenant data access must go through the tenant-aware manager. Add row-level security policies in PostgreSQL.",
    status: "Done",
    type: "Story",
    priority: "Critical",
    assignee: "senior-dev-1",
    labels: ["tenancy", "security", "soc2"],
    sprint: "Sprint 1",
    story_points: 13,
    acceptance_criteria: [
      "TenantAwareManager filters all queries by tenant_id",
      "TenantMiddleware sets current tenant in thread-local storage",
      "Row-level security policies applied to tenant-scoped tables",
      "Cross-tenant data access is impossible via ORM",
      "Unit tests verify tenant isolation with factory_boy fixtures"
    ]
  },
  "SAAS-12": {
    key: "SAAS-12",
    summary: "Integrate Stripe subscription billing",
    description: "Implement Stripe subscription lifecycle: create customer on tenant onboarding, manage subscription plans (free, starter, professional, enterprise), handle plan upgrades/downgrades, sync subscription status via webhooks. All Stripe webhooks must be verified and idempotent.",
    status: "In Progress",
    type: "Story",
    priority: "High",
    assignee: "senior-dev-2",
    labels: ["billing", "stripe", "sensitive"],
    sprint: "Sprint 3",
    story_points: 13,
    acceptance_criteria: [
      "Stripe Customer created on tenant registration",
      "Subscription CRUD via billing service layer",
      "Webhook endpoint verifies Stripe signatures",
      "Webhook handlers are idempotent (safe to replay)",
      "Subscription status synced: active, past_due, canceled, trialing",
      "Usage metering events sent to Stripe for usage-based plans",
      "All billing operations go through src/billing/ app"
    ]
  },
  "SAAS-15": {
    key: "SAAS-15",
    summary: "Implement usage-based metering for API calls",
    description: "Track API call usage per tenant and report to Stripe for usage-based billing. Use Redis for real-time counters, flush to PostgreSQL periodically via Celery beat task. Celery tasks must be idempotent.",
    status: "In Progress",
    type: "Story",
    priority: "High",
    assignee: "mid-dev-1",
    labels: ["billing", "celery", "redis"],
    sprint: "Sprint 3",
    story_points: 8,
    acceptance_criteria: [
      "API middleware increments Redis counter per tenant",
      "Celery beat task flushes counters to UsageRecord model every 5 minutes",
      "Celery task reports usage to Stripe metering API",
      "Tasks are idempotent — duplicate runs don't double-count",
      "Usage dashboard endpoint returns current period usage",
      "85% test coverage on metering logic"
    ]
  },
  "SAAS-20": {
    key: "SAAS-20",
    summary: "Add role-based access control (RBAC) per tenant",
    description: "Implement RBAC with roles: owner, admin, member, viewer. Roles are scoped per tenant — a user can have different roles in different tenants. Use DRF permission classes. Integrate with drf-spectacular for OpenAPI docs.",
    status: "To Do",
    type: "Story",
    priority: "High",
    assignee: "senior-dev-1",
    labels: ["auth", "security", "sensitive"],
    sprint: "Sprint 4",
    story_points: 8,
    acceptance_criteria: [
      "TenantRole model with owner/admin/member/viewer choices",
      "DRF permission classes: IsTenantOwner, IsTenantAdmin, IsTenantMember",
      "Role checked per-tenant, not globally",
      "OpenAPI schema documents required permissions per endpoint",
      "Audit log entry created on role changes"
    ]
  },
  "SAAS-25": {
    key: "SAAS-25",
    summary: "Implement audit logging for SOC 2 compliance",
    description: "Create comprehensive audit logging for all sensitive operations: authentication events, tenant data changes, billing operations, role changes, API key management. Logs must be immutable and include actor, action, resource, tenant, timestamp, and IP address.",
    status: "To Do",
    type: "Story",
    priority: "High",
    assignee: "senior-dev-3",
    labels: ["security", "soc2", "compliance"],
    sprint: "Sprint 4",
    story_points: 8,
    acceptance_criteria: [
      "AuditLog model with immutable records (no update/delete)",
      "Audit decorator for service layer functions",
      "All auth events logged (login, logout, password change, MFA)",
      "All billing events logged (subscription change, payment, refund)",
      "All tenant admin events logged (role change, invite, removal)",
      "Audit log queryable by tenant admins via API",
      "GDPR: audit logs respect data retention policies"
    ]
  },
  "SAAS-30": {
    key: "SAAS-30",
    summary: "Set up Celery beat for recurring billing tasks",
    description: "Configure Celery beat scheduler for recurring tasks: subscription renewal checks, usage report generation, failed payment retry, trial expiration notifications. All tasks must be idempotent and tenant-aware.",
    status: "To Do",
    type: "Story",
    priority: "Medium",
    assignee: "mid-dev-2",
    labels: ["celery", "billing", "tasks"],
    sprint: "Sprint 5",
    story_points: 5,
    acceptance_criteria: [
      "Celery beat schedule defined in Django settings",
      "Daily: check for expiring trials, send notifications",
      "Hourly: retry failed Stripe payments",
      "Every 5 min: flush usage counters to Stripe",
      "Weekly: generate tenant usage reports",
      "All tasks are idempotent with deduplication keys",
      "Tasks use tenant-aware context"
    ]
  },
  "SAAS-42": {
    key: "SAAS-42",
    summary: "Add tenant onboarding flow with Stripe customer creation",
    description: "Implement complete tenant onboarding: registration form, tenant provisioning, Stripe customer creation, default subscription assignment, welcome email via Celery task, and initial RBAC setup (registering user becomes owner).",
    status: "In Progress",
    type: "Story",
    priority: "High",
    assignee: "mid-dev-1",
    labels: ["tenancy", "billing", "onboarding"],
    sprint: "Sprint 3",
    story_points: 8,
    acceptance_criteria: [
      "POST /api/v1/tenants/ creates tenant + Stripe customer",
      "Registering user assigned owner role automatically",
      "Default free-tier subscription created in Stripe",
      "Welcome email sent via Celery task (idempotent)",
      "Tenant subdomain validated and reserved",
      "Onboarding status tracked (pending, active, suspended)",
      "Integration test covers full onboarding flow"
    ]
  },
  "SAAS-55": {
    key: "SAAS-55",
    summary: "Implement GDPR data export and deletion endpoints",
    description: "Add GDPR compliance endpoints: data export (right of access) and account deletion (right to erasure). Data export generates a ZIP of all user/tenant data as JSON. Deletion anonymizes PII and marks records, respecting audit log retention requirements.",
    status: "To Do",
    type: "Story",
    priority: "High",
    assignee: "senior-dev-2",
    labels: ["gdpr", "compliance", "sensitive"],
    sprint: "Sprint 6",
    story_points: 13,
    acceptance_criteria: [
      "POST /api/v1/accounts/me/export/ triggers async data export",
      "Celery task generates ZIP with all user PII as JSON",
      "Export download link sent via email (signed URL, 24h expiry)",
      "DELETE /api/v1/accounts/me/ initiates deletion workflow",
      "Deletion anonymizes PII but preserves audit log structure",
      "30-day grace period before permanent deletion",
      "Stripe customer data cleaned up on deletion",
      "All operations logged in audit trail"
    ]
  },
  "SAAS-60": {
    key: "SAAS-60",
    summary: "Fix webhook replay causing duplicate invoice records",
    description: "Stripe webhook endpoint is creating duplicate InvoiceRecord entries when webhooks are replayed. The idempotency check is using event ID but not accounting for Stripe's retry behavior with the same event. Need to implement proper idempotency using invoice ID + event type as dedup key.",
    status: "In Progress",
    type: "Bug",
    priority: "Critical",
    assignee: "senior-dev-2",
    labels: ["billing", "stripe", "bug", "sensitive"],
    sprint: "Sprint 3",
    story_points: 3,
    acceptance_criteria: [
      "Webhook handler uses (stripe_invoice_id, event_type) as idempotency key",
      "Duplicate webhook deliveries do not create duplicate records",
      "Existing duplicate records cleaned up via data migration",
      "Integration test replays same webhook 3 times, verifies single record",
      "Monitoring alert added for duplicate detection"
    ]
  },
  "SAAS-65": {
    key: "SAAS-65",
    summary: "Add white-label support for tenant custom domains",
    description: "Allow enterprise tenants to use custom domains instead of subdomains. Implement domain verification via DNS TXT record, SSL certificate provisioning via AWS ACM, and tenant resolution by custom domain in middleware.",
    status: "To Do",
    type: "Story",
    priority: "Medium",
    assignee: null,
    labels: ["tenancy", "enterprise", "white-label"],
    sprint: "Backlog",
    story_points: 13,
    acceptance_criteria: [
      "TenantDomain model with verification status",
      "DNS TXT record verification via Celery task",
      "AWS ACM certificate request automation",
      "TenantMiddleware resolves tenant by custom domain",
      "CloudFront distribution updated for custom domains",
      "Admin UI for domain management",
      "Restricted to enterprise plan tenants"
    ]
  }
};

function handleRequest(req, res) {
  const url = new URL(req.url, \`http://localhost:\${PORT}\`);
  const path = url.pathname;

  res.setHeader("Content-Type", "application/json");

  if (req.method === "POST" && path === "/mcp") {
    let body = "";
    req.on("data", (chunk) => { body += chunk; });
    req.on("end", () => {
      try {
        const request = JSON.parse(body);
        const response = handleMcpRequest(request);
        res.writeHead(200);
        res.end(JSON.stringify(response));
      } catch (err) {
        res.writeHead(400);
        res.end(JSON.stringify({ error: "Invalid JSON", details: err.message }));
      }
    });
    return;
  }

  if (req.method === "GET" && path === "/health") {
    res.writeHead(200);
    res.end(JSON.stringify({ status: "ok", server: "mock-ticket-mcp", project: PROJECT_KEY }));
    return;
  }

  res.writeHead(404);
  res.end(JSON.stringify({ error: "Not found" }));
}

function handleMcpRequest(request) {
  const { method, params, id } = request;

  switch (method) {
    case "tools/list":
      return {
        jsonrpc: "2.0",
        id,
        result: {
          tools: [
            {
              name: "get_ticket",
              description: "Fetch a GitHub Issue / ticket by key (e.g., SAAS-42)",
              inputSchema: {
                type: "object",
                properties: {
                  ticket_key: { type: "string", description: "Ticket key like SAAS-42" }
                },
                required: ["ticket_key"]
              }
            },
            {
              name: "search_tickets",
              description: "Search tickets by label, status, assignee, or text query",
              inputSchema: {
                type: "object",
                properties: {
                  query: { type: "string", description: "Text search in summary/description" },
                  status: { type: "string", enum: ["To Do", "In Progress", "Done"] },
                  label: { type: "string", description: "Filter by label" },
                  assignee: { type: "string", description: "Filter by assignee" }
                }
              }
            },
            {
              name: "update_ticket_status",
              description: "Update the status of a ticket",
              inputSchema: {
                type: "object",
                properties: {
                  ticket_key: { type: "string", description: "Ticket key like SAAS-42" },
                  status: { type: "string", enum: ["To Do", "In Progress", "In Review", "Done"] }
                },
                required: ["ticket_key", "status"]
              }
            },
            {
              name: "add_comment",
              description: "Add a comment to a ticket",
              inputSchema: {
                type: "object",
                properties: {
                  ticket_key: { type: "string", description: "Ticket key like SAAS-42" },
                  comment: { type: "string", description: "Comment text" },
                  author: { type: "string", description: "Comment author", default: "claude-bot" }
                },
                required: ["ticket_key", "comment"]
              }
            }
          ]
        }
      };

    case "tools/call":
      return handleToolCall(params, id);

    default:
      return {
        jsonrpc: "2.0",
        id,
        error: { code: -32601, message: \`Unknown method: \${method}\` }
      };
  }
}

function handleToolCall(params, id) {
  const { name, arguments: args } = params;

  switch (name) {
    case "get_ticket": {
      const key = (args.ticket_key || "").toUpperCase();
      const ticket = mockTickets[key];
      if (!ticket) {
        return {
          jsonrpc: "2.0",
          id,
          result: {
            content: [{ type: "text", text: JSON.stringify({ error: \`Ticket \${key} not found\`, available: Object.keys(mockTickets) }, null, 2) }]
          }
        };
      }
      return {
        jsonrpc: "2.0",
        id,
        result: {
          content: [{ type: "text", text: JSON.stringify(ticket, null, 2) }]
        }
      };
    }

    case "search_tickets": {
      let results = Object.values(mockTickets);

      if (args.status) {
        results = results.filter((t) => t.status === args.status);
      }
      if (args.label) {
        results = results.filter((t) => t.labels.includes(args.label));
      }
      if (args.assignee) {
        results = results.filter((t) => t.assignee === args.assignee);
      }
      if (args.query) {
        const q = args.query.toLowerCase();
        results = results.filter((t) =>
          t.summary.toLowerCase().includes(q) ||
          t.description.toLowerCase().includes(q)
        );
      }

      const summary = results.map((t) => ({
        key: t.key,
        summary: t.summary,
        status: t.status,
        type: t.type,
        priority: t.priority,
        assignee: t.assignee,
        labels: t.labels,
        sprint: t.sprint
      }));

      return {
        jsonrpc: "2.0",
        id,
        result: {
          content: [{ type: "text", text: JSON.stringify({ count: summary.length, tickets: summary }, null, 2) }]
        }
      };
    }

    case "update_ticket_status": {
      const key = (args.ticket_key || "").toUpperCase();
      const ticket = mockTickets[key];
      if (!ticket) {
        return {
          jsonrpc: "2.0",
          id,
          result: {
            content: [{ type: "text", text: JSON.stringify({ error: \`Ticket \${key} not found\` }) }]
          }
        };
      }
      const oldStatus = ticket.status;
      ticket.status = args.status;
      return {
        jsonrpc: "2.0",
        id,
        result: {
          content: [{ type: "text", text: JSON.stringify({ success: true, key, old_status: oldStatus, new_status: args.status }) }]
        }
      };
    }

    case "add_comment": {
      const key = (args.ticket_key || "").toUpperCase();
      const ticket = mockTickets[key];
      if (!ticket) {
        return {
          jsonrpc: "2.0",
          id,
          result: {
            content: [{ type: "text", text: JSON.stringify({ error: \`Ticket \${key} not found\` }) }]
          }
        };
      }
      const comment = {
        ticket_key: key,
        author: args.author || "claude-bot",
        comment: args.comment,
        timestamp: new Date().toISOString()
      };
      return {
        jsonrpc: "2.0",
        id,
        result: {
          content: [{ type: "text", text: JSON.stringify({ success: true, comment }) }]
        }
      };
    }

    default:
      return {
        jsonrpc: "2.0",
        id,
        error: { code: -32601, message: \`Unknown tool: \${name}\` }
      };
  }
}

const server = createServer(handleRequest);

server.listen(PORT, () => {
  console.log(\`[mock-ticket-mcp] GitHub Issues mock server for \${PROJECT_KEY} running on port \${PORT}\`);
  console.log(\`[mock-ticket-mcp] Available tickets: \${Object.keys(mockTickets).join(", ")}\`);
  console.log(\`[mock-ticket-mcp] Health check: http://localhost:\${PORT}/health\`);
  console.log(\`[mock-ticket-mcp] MCP endpoint: POST http://localhost:\${PORT}/mcp\`);
});`,

  'mock-mcp-servers/package.json': `{
  "name": "django-saas-platform-mock-mcp-servers",
  "version": "1.0.0",
  "private": true,
  "description": "Mock MCP servers for local development of django-saas-platform",
  "type": "module",
  "scripts": {
    "github": "node github-server.mjs",
    "jira": "node jira-server.mjs",
    "all": "concurrently \\"npm run github\\" \\"npm run jira\\""
  },
  "dependencies": {
    "@modelcontextprotocol/sdk": "^1.0.0"
  },
  "devDependencies": {
    "concurrently": "^8.2.0"
  },
  "engines": {
    "node": ">=18.0.0"
  }
}`,

  'playbook/PLAYBOOK.md': `# Django SaaS Platform — Development Playbook

## Purpose

This playbook defines the structured methodology for building, extending, and maintaining the django-saas-platform. It is organized into **7 phases** that cover the full lifecycle of any feature, bug fix, or infrastructure change — from understanding the problem through production deployment and retrospective.

Every developer (human or AI-assisted) follows these phases. Claude Code users invoke them via \`/phase <number>\` or the individual skill commands (\`/plan\`, \`/tdd\`, \`/build-fix\`, \`/verify\`, \`/code-review\`).

---

## Playbook Principles

1. **Tenant isolation is non-negotiable** — every phase considers multi-tenancy implications
2. **Tests before code** — TDD is the default for all business logic
3. **Idempotency everywhere** — Celery tasks, Stripe webhooks, and data migrations must be safe to retry
4. **Explicit over implicit** — prefer service layer calls over Django signals; prefer typed returns over bare dicts
5. **Security by design** — SOC 2 and GDPR compliance are built in, not bolted on
6. **Small, reviewable changes** — each PR maps to one ticket, one concern, ≤300 lines per file
7. **AI transparency** — AI-generated code is marked and reviewed with the same rigor as human code

---

## Phase Overview

| Phase | Name | Goal | Key Artifacts |
|-------|------|------|---------------|
| 1 | [Discover & Understand](#phase-1-discover--understand) | Fully understand the problem, constraints, and tenant impact | Requirements doc, acceptance criteria |
| 2 | [Plan & Design](#phase-2-plan--design) | Produce an implementation plan with architecture decisions | Implementation plan, ADR (if needed) |
| 3 | [Test First (TDD Red)](#phase-3-test-first-tdd-red) | Write failing tests that define the expected behavior | Failing test suite |
| 4 | [Implement (TDD Green)](#phase-4-implement-tdd-green) | Write minimal code to make all tests pass | Passing code + tests |
| 5 | [Refactor & Harden](#phase-5-refactor--harden) | Clean up, optimize, and ensure production readiness | Refactored code, security review |
| 6 | [Verify & Review](#phase-6-verify--review) | Run full CI pipeline and conduct code review | CI green, PR approved |
| 7 | [Ship & Observe](#phase-7-ship--observe) | Deploy, monitor, and retrospect | Production deployment, monitoring confirmation |

---

## Phase 1: Discover & Understand

**File**: [playbook/phases/01-discover.md](phases/01-discover.md)

**Objective**: Develop a complete understanding of the problem before writing any code.

### Activities

- Read the GitHub Issue thoroughly — understand the user story, acceptance criteria, and linked issues
- Identify which Django apps are affected (\`accounts\`, \`tenants\`, \`billing\`, \`api\`, \`core\`, \`notifications\`, \`tasks\`)
- Determine tenant isolation implications:
  - Does this touch tenant-scoped data? → Must use tenant-aware manager
  - Does this affect billing? → Review Stripe webhook flow
  - Does this introduce new PII? → GDPR impact assessment required
- Map dependencies: other services, Celery tasks, third-party APIs (Stripe, SES, etc.)
- Check for existing patterns in the codebase that solve similar problems
- Clarify ambiguities with the team via Slack or Issue comments before proceeding

### Checklist

- [ ] I can explain the problem in one sentence
- [ ] I know which Django apps and models are involved
- [ ] I've identified tenant isolation requirements
- [ ] I've checked for GDPR/SOC 2 implications
- [ ] I've reviewed related code and existing patterns
- [ ] Acceptance criteria are clear and testable
- [ ] I've identified edge cases (empty tenant, expired subscription, rate limits)

### Claude Command

\`\`\`
/phase 1
\`\`\`

Claude will analyze the current context (ticket, codebase) and produce a structured understanding document.

---

## Phase 2: Plan & Design

**File**: [playbook/phases/02-plan.md](phases/02-plan.md)

**Objective**: Create a concrete implementation plan before touching production code.

### Activities

- Define the implementation approach: which files to create/modify, in what order
- Design data model changes (if any):
  - New models → include tenant FK, audit fields (\`created_at\`, \`updated_at\`, \`created_by\`)
  - Schema migrations → ensure backward compatibility for zero-downtime deploys
  - Row-level security policies → update PostgreSQL RLS if new tables hold tenant data
- Design API surface:
  - REST endpoints → DRF serializers, viewsets, URL patterns
  - GraphQL types → Strawberry types, queries, mutations
  - OpenAPI schema → drf-spectacular annotations
- Design Celery tasks (if needed):
  - Must be idempotent — define the idempotency key strategy
  - Define retry policy, dead-letter handling
  - Consider task priority and queue routing
- Design Stripe integration (if billing-related):
  - Map Stripe events to internal state transitions
  - Define webhook handler with idempotency checks
  - Plan for Stripe API failures and retries
- If the change is architecturally significant, write an ADR in \`docs/adr/\`
- Estimate complexity and break into sub-tasks if the PR would exceed review comfort

### Artifacts

- **Implementation Plan**: ordered list of steps with file paths
- **Data Model Diagram**: if new models or relations (Mermaid in the plan doc)
- **API Contract**: request/response shapes for new endpoints
- **ADR** (optional): for significant architectural decisions

### Checklist

- [ ] Implementation plan is written and ordered
- [ ] Data model changes are backward-compatible
- [ ] API contracts are defined with types
- [ ] Celery tasks are designed to be idempotent
- [ ] Stripe integration follows webhook verification pattern
- [ ] Tenant isolation strategy is explicit
- [ ] Plan fits in a single reviewable PR (or is split into stacked PRs)

### Claude Command

\`\`\`
/plan
\`\`\`

or

\`\`\`
/phase 2
\`\`\`

---

## Phase 3: Test First (TDD Red)

**File**: [playbook/phases/03-test-first.md](phases/03-test-first.md)

**Objective**: Write failing tests that precisely define the expected behavior.

### Activities

- Create test files mirroring the \`src/\` structure under \`tests/\`
  - \`tests/billing/test_subscription_service.py\` for \`src/billing/services.py\`
  - \`tests/tenants/test_tenant_middleware.py\` for \`src/tenants/middleware.py\`
- Write tests using **pytest** + **factory_boy**:
  - Use \`TenantFactory\`, \`UserFactory\`, \`SubscriptionFactory\` for fixtures
  - Use \`pytest.mark.django_db\` for database tests
  - Use \`pytest.mark.asyncio\` for async tests
- Test categories to cover:
  - **Unit tests**: service functions, model methods, utility functions
  - **API tests**: DRF \`APIClient\` for REST, Strawberry test client for GraphQL
  - **Integration tests**: Celery task execution (with \`CELERY_ALWAYS_EAGER=True\`), Stripe mock webhooks
  - **Tenant isolation tests**: verify data cannot leak between tenants
  - **Permission tests**: RBAC enforcement for each role (owner, admin, member, viewer)
- For Stripe-related features:
  - Mock Stripe API calls with \`unittest.mock\` or \`responses\`
  - Test webhook signature verification
  - Test idempotency (same event delivered twice → no duplicate side effects)
- Run tests to confirm they **fail** for the right reasons:

\`\`\`bash
uv run pytest tests/path/to/new_tests.py -v
\`\`\`

### Test Structure Convention

\`\`\`python
class TestSubscriptionCreation:
    """Tests for billing.services.create_subscription"""

    def test_creates_stripe_subscription_for_tenant(self, tenant_factory, mocker):
        ...

    def test_rejects_tenant_with_no_payment_method(self, tenant_factory):
        ...

    def test_is_idempotent_on_duplicate_stripe_event(self, tenant_factory, mocker):
        ...

    def test_isolates_subscription_to_requesting_tenant(self, tenant_factory):
        ...
\`\`\`

### Checklist

- [ ] Tests are written before implementation code
- [ ] factory_boy factories are used (no raw \`Model.objects.create\`)
- [ ] Tenant isolation is tested explicitly
- [ ] Permission/RBAC tests cover all relevant roles
- [ ] Stripe interactions are mocked
- [ ] Celery task idempotency is tested
- [ ] All tests fail with meaningful errors (not import errors)
- [ ] Test file is ≤300 lines (split into multiple files if needed)

### Claude Command

\`\`\`
/tdd
\`\`\`

or

\`\`\`
/phase 3
\`\`\`

---

## Phase 4: Implement (TDD Green)

**File**: [playbook/phases/04-implement.md](phases/04-implement.md)

**Objective**: Write the minimum code necessary to make all tests pass.

### Activities

- Follow the implementation plan from Phase 2
- Write code in the appropriate Django app under \`src/\`:
  - **Models**: inherit from \`core.models.TenantScopedModel\` for tenant data; include type hints
  - **Services**: business logic lives in \`services.py\`, not in views or serializers
  - **Serializers**: DRF serializers with explicit field declarations (no \`fields = "__all__"\`)
  - **Views/Viewsets**: thin — delegate to service layer
  - **GraphQL**: Strawberry types and resolvers in \`schema.py\`
  - **Celery tasks**: in \`tasks.py\`, decorated with \`@shared_task(bind=True, max_retries=3)\`
  - **Permissions**: custom DRF permissions in \`permissions.py\`
- Tenant isolation enforcement:
  - All querysets go through \`TenantAwareManager\` — never use \`Model.objects.all()\` for tenant data
  - Middleware sets \`request.tenant\` from subdomain/header
  - Service functions accept \`tenant\` as an explicit parameter
- Stripe integration:
  - Use \`stripe.Webhook.construct_event()\` for signature verification
  - Store Stripe event IDs to enforce idempotency
  - Map Stripe subscription statuses to internal \`SubscriptionStatus\` enum
- Type hints on all public functions:

\`\`\`python
def create_subscription(
    tenant: Tenant,
    plan: Plan,
    payment_method_id: str,
) -> Subscription:
    ...
\`\`\`

- Run tests after each logical unit of work:

\`\`\`bash
uv run pytest tests/ -x -v
\`\`\`

- Run type checker:

\`\`\`bash
uv run mypy src/
\`\`\`

### Checklist

- [ ] All Phase 3 tests pass
- [ ] No new code without a corresponding test
- [ ] Type hints on all public functions and methods
- [ ] Tenant-scoped data uses \`TenantAwareManager\`
- [ ] Service layer handles business logic (views are thin)
- [ ] Celery tasks are idempotent with retry logic
- [ ] Stripe webhook handlers verify signatures and check idempotency
- [ ] No file exceeds 300 lines
- [ ] \`uv run mypy src/\` passes with no errors
- [ ] \`uv run ruff check src/\` passes with no errors

### Claude Command

\`\`\`
/phase 4
\`\`\`

When builds break during implementation:

\`\`\`
/build-fix
\`\`\`

---

## Phase 5: Refactor & Harden

**File**: [playbook/phases/05-refactor.md](phases/05-refactor.md)

**Objective**: Improve code quality, performance, and security without changing behavior.

### Activities

- **Refactor for clarity**:
  - Extract repeated logic into utility functions in \`src/utils/\`
  - Ensure consistent naming (snake_case functions, PascalCase classes, SCREAMING_SNAKE_CASE constants)
  - Replace magic strings/numbers with named constants or enums
  - Simplify complex conditionals
- **Performance hardening**:
  - Add \`select_related()\` / \`prefetch_related()\` to querysets with N+1 risk
  - Add database indexes for frequently filtered fields
  - Add Redis caching for expensive read operations (tenant settings, plan details)
  - Review Celery task execution time — break long tasks into chains
- **Security hardening**:
  - Verify all tenant data access goes through tenant-aware managers
  - Ensure no PII is logged (check \`logging\` calls and Sentry breadcrumbs)
  - Verify Stripe webhook signature verification is in place
  - Check for SQL injection vectors in raw queries (prefer ORM)
  - Ensure RBAC is enforced at both view and service layer
  - Review for IDOR vulnerabilities (tenant A accessing tenant B's resources)
- **GDPR compliance check**:
  - New PII fields have retention policies defined
  - Data export includes new fields (right of access)
  - Data deletion cascades correctly (right to erasure)
  - Consent tracking is updated if new data collection is introduced
- **SOC 2 compliance check**:
  - Audit log entries are created for state-changing operations
  - Access controls are documented and tested
  - Data encryption at rest and in transit is maintained
- **Documentation**:
  - Add/update docstrings for public functions and classes
  - Update \`drf-spectacular\` schema annotations if API changed
  - Update \`docs/\` if architecture or runbooks are affected
- Run full quality suite:

\`\`\`bash
uv run ruff check src/ tests/
uv run ruff format --check src/ tests/
uv run mypy src/
uv run pytest tests/ --cov=src --cov-report=term-missing --cov-fail-under=85
\`\`\`

### Checklist

- [ ] Code is clean, well-named, and follows project conventions
- [ ] No N+1 queries (verified with django-debug-toolbar or \`assertNumQueries\`)
- [ ] Redis caching added where appropriate
- [ ] Tenant isolation verified — no cross-tenant data leakage paths
- [ ] No PII in logs or error tracking
- [ ] GDPR data lifecycle is maintained
- [ ] Audit logging covers new state changes
- [ ] OpenAPI schema is accurate and complete
- [ ] Coverage ≥ 85%
- [ ] All linting, formatting, and type checks pass

### Claude Command

\`\`\`
/phase 5
\`\`\`

---

## Phase 6: Verify & Review

**File**: [playbook/phases/06-verify.md](phases/06-verify.md)

**Objective**: Ensure the change passes all automated checks and human review.

### Activities

- **Pre-push verification** (run locally):

\`\`\`bash
# Lint and format
uv run ruff check src/ tests/
uv run ruff format --check src/ tests/

# Type check
uv run mypy src/

# Full test suite with coverage
uv run pytest tests/ --cov=src --cov-report=term-missing --cov-fail-under=85

# Check migrations
uv run python manage.py makemigrations --check --dry-run

# Verify OpenAPI schema generates without errors
uv run python manage.py spectacular --validate
\`\`\`

- **Create PR**:
  - Branch name: \`feat/SAAS-42-add-tenant-onboarding\` (follows \`type/ticket-desc\`)
  - PR title: \`feat(tenants): add tenant onboarding flow (SAAS-42)\`
  - PR description: use the template — include what changed, why, how to test, tenant impact, billing impact
  - Add labels: \`ai-assisted\` if Claude was used (per AI-USAGE-POLICY)
  - Request review from CODEOWNERS

- **CI pipeline** (GitHub Actions):
  1. Lint (\`ruff check\`)
  2. Type check (\`mypy\`)
  3. Unit tests (\`pytest\` — unit)
  4. Integration tests (\`pytest\` — integration, with PostgreSQL and Redis services)
  5. Security scan (\`bandit\`, \`safety\`, \`trivy\`)
  6. Build Docker image
  7. Deploy to staging (auto)
  8. E2E tests against staging

- **Code review focus areas**:
  - Tenant isolation: is all tenant data properly scoped?
  - Billing safety: are Stripe operations idempotent? Webhook handlers verified?
  - RBAC: are permissions checked at the right layer?
  - Data privacy: any new PII? Consent? Retention?
  - Performance: N+1 queries? Missing indexes? Unbounded querysets?
  - Test quality: are edge cases covered? Are tests testing behavior, not implementation?

- **Sensitive path review**: changes to \`**/billing/**\`, \`**/auth/**\`, \`config/production/**\`, or \`.env*\` require senior/lead reviewer

### Checklist

- [ ] All local checks pass before pushing
- [ ] PR follows naming and description conventions
- [ ] CI pipeline is fully green
- [ ] AI-assisted code is labeled
- [ ] At least 1 approval from a qualified reviewer
- [ ] Sensitive path changes have senior/lead approval
- [ ] No unresolved review comments

### Claude Command

\`\`\`
/verify
\`\`\`

and

\`\`\`
/code-review
\`\`\`

or

\`\`\`
/phase 6
\`\`\`

---

## Phase 7: Ship & Observe

**File**: [playbook/phases/07-ship.md](phases/07-ship.md)

**Objective**: Deploy to production safely and confirm the change works as expected.

### Activities

- **Pre-deployment**:
  - Verify staging E2E tests passed
  - Check for pending database migrations — coordinate if migration requires downtime
  - For Stripe changes: verify webhook endpoints are registered in Stripe Dashboard
  - For Celery changes: verify new tasks are registered and queues are configured
  - Notify team in Slack \`#deployments\` channel

- **Deployment** (via GitHub Actions \`deploy-production.yml\`):
  - Merge PR to \`main\`
  - Production deployment pipeline triggers:
    1. Build production Docker image
    2. Run database migrations on RDS
    3. Deploy to ECS (rolling update)
    4. Run smoke tests
    5. Verify health checks pass

- **Post-deployment monitoring** (first 30 minutes):
  - **Sentry**: watch for new exceptions, especially in affected Django apps
  - **Prometheus/Grafana**: check request latency, error rates, Celery queue depth
  - **Stripe Dashboard**: verify webhook delivery success rate (for billing changes)
  - **CloudWatch**: check ECS task health, RDS connections, ElastiCache hit rates
  - **Application logs**: tail logs for the deployed service

- **Rollback criteria**:
  - Error rate > 1% on affected endpoints → rollback
  - Celery queue depth growing unbounded → rollback
  - Stripe webhook failures > 5% → rollback and investigate
  - Any tenant data isolation breach → immediate rollback + incident

- **Post-deployment**:
  - Update GitHub Issue with deployment confirmation
  - If feature flag was used, coordinate gradual rollout
  - Update runbooks in \`docs/\` if operational procedures changed
  - Schedule retrospective if the change was complex or had issues

- **Retrospective** (for significant changes):
  - What went well?
  - What was harder than expected?
  - Did the plan from Phase 2 hold up?
  - Any improvements to the playbook or tooling?

### Checklist

- [ ] Staging E2E tests passed
- [ ] Team notified of deployment
- [ ] Production deployment successful
- [ ] Health checks passing
- [ ] Sentry — no new exceptions in 30 minutes
- [ ] Grafana — latency and error rates nominal
- [ ] Stripe webhooks delivering successfully (if applicable)
- [ ] Celery queues processing normally (if applicable)
- [ ] GitHub Issue updated and closed
- [ ] Retrospective scheduled (if needed)

### Claude Command

\`\`\`
/phase 7
\`\`\`

---

## Phase Flow Diagram

\`\`\`mermaid
graph TD
    A[Phase 1: Discover & Understand] --> B[Phase 2: Plan & Design]
    B --> C[Phase 3: Test First - TDD Red]
    C --> D[Phase 4: Implement - TDD Green]
    D --> E[Phase 5: Refactor & Harden]
    E --> F[Phase 6: Verify & Review]
    F --> G[Phase 7: Ship & Observe]

    D -->|Tests fail| D
    D -->|Build errors| H[/build-fix]
    H --> D
    F -->|Review feedback| E
    F -->|CI fails| D
    G -->|Rollback needed| D
\`\`\`

---

## Quick Reference: Commands

| Command | Phase | Description |
|---------|-------|-------------|
| \`/phase 1\` | Discover | Analyze ticket and codebase context |
| \`/phase 2\` or \`/plan\` | Plan | Generate implementation plan |
| \`/phase 3\` or \`/tdd\` | Test First | Write failing tests |
| \`/phase 4\` | Implement | Write code to pass tests |
| \`/build-fix\` | (4 support) | Diagnose and fix build/test failures |
| \`/phase 5\` | Refactor | Harden code, security, performance |
| \`/phase 6\` or \`/verify\` + \`/code-review\` | Verify | Run checks and review |
| \`/phase 7\` | Ship | Deploy and monitor |

---

## When to Skip or Compress Phases

| Scenario | Approach |
|----------|----------|
| **Typo fix / docs-only** | Phase 1 → Phase 6 → Phase 7 (skip 2-5) |
| **Hotfix (production bug)** | Phase 1 → Phase 3 (regression test) → Phase 4 → Phase 6 → Phase 7 |
| **Dependency update** | Phase 1 → Phase 6 (CI validates) → Phase 7 |
| **Config change** | Phase 1 → Phase 2 (if sensitive path) → Phase 6 → Phase 7 |
| **New feature (standard)** | All 7 phases |
| **Billing/auth change** | All 7 phases, senior reviewer required |

---

## Related Documents

- [Architecture](../docs/ARCHITECTURE.md) — system design, Django app boundaries, data flow
- [Contributing](../docs/CONTRIBUTING.md) — PR process, commit conventions, code standards
- [AI Usage Policy](../docs/AI-USAGE-POLICY.md) — rules for Claude Code usage, labeling, review
- [Onboarding](../docs/ONBOARDING.md) — getting started with the project
- [Plugin README](../plugin/codeforge-django-saas/README.md) — Claude Code plugin commands and skills`,

  'playbook/claude-overrides/01-discovery.claude.md': `---
description: Phase 01 Discovery & Requirements — Claude behavioral overrides for Django SaaS Platform
globs:
  - playbook/phases/01-discovery.md
  - playbook/prompts/01/**
  - docs/requirements/**
  - docs/discovery/**
  - docs/prd/**
  - "*.requirements.md"
  - "*.user-stories.md"
---

# Phase 01: Discovery & Requirements — Claude Overrides

## Context

You are assisting with the Discovery & Requirements phase of a multi-tenant Django SaaS platform. This platform uses Django 5.0, DRF, Strawberry GraphQL, Celery, Stripe billing, PostgreSQL with row-level security, and deploys to AWS. The team follows SOC 2 and GDPR compliance requirements.

## DO — Requirements Gathering

- DO frame every requirement through the lens of multi-tenancy — ask "how does this behave across tenant boundaries?"
- DO explicitly identify which requirements involve tenant-scoped data vs. platform-global data
- DO capture subscription tier implications for every feature — which plan levels get access?
- DO define data residency requirements early — GDPR mandates may require EU-region storage
- DO specify whether a feature is synchronous (API response) or asynchronous (Celery task)
- DO identify Stripe billing events that each feature may trigger (subscription changes, usage records, invoice line items)
- DO document webhook contracts for any external integration — specify payload shape, retry policy, and idempotency keys
- DO capture audit logging requirements for SOC 2 — every state change on sensitive resources must be traceable
- DO write user stories that name the tenant role explicitly: "As a **tenant admin**…", "As a **platform operator**…", "As a **billing owner**…"
- DO define non-functional requirements with concrete numbers: response time p95 < 200ms, task processing latency < 30s, 99.9% uptime SLA
- DO reference the project directory structure (\`src/tenants/\`, \`src/billing/\`, \`src/accounts/\`) when mapping requirements to Django apps
- DO ask about white-label requirements — custom domains, branding, email sender identity per tenant
- DO capture role-based access control (RBAC) requirements per feature — map to Django permissions and groups
- DO identify which requirements need real-time updates (WebSocket/SSE) vs. polling vs. eventual consistency
- DO document data retention and right-to-deletion requirements for GDPR Article 17 compliance

## DON'T — Requirements Gathering

- DON'T accept a requirement that says "users can see all data" without clarifying tenant isolation boundaries
- DON'T write requirements that assume a single-tenant deployment model
- DON'T skip billing edge cases: failed payments, plan downgrades mid-cycle, prorated charges, trial expiration, grace periods
- DON'T ignore the difference between tenant-level admin and platform-level superadmin — these are distinct personas with distinct permissions
- DON'T assume synchronous processing for operations that should be Celery tasks (report generation, bulk imports, email dispatch, Stripe sync)
- DON'T define API requirements without specifying whether they apply to REST (DRF), GraphQL (Strawberry), or both
- DON'T leave webhook requirements vague — specify the exact events, payload expectations, signature verification, and retry behavior
- DON'T create requirements that would require cross-tenant queries in normal application flow — this violates row-level security
- DON'T accept "admin can do everything" as a permission model — enumerate specific admin capabilities
- DON'T write user stories without acceptance criteria that include tenant context and subscription tier
- DON'T defer security and compliance requirements to later phases — SOC 2 audit trail and GDPR consent must be designed in from the start
- DON'T propose features that store PII outside the primary PostgreSQL database without a data processing justification
- DON'T assume email delivery is instant — always model notifications as async tasks via \`src/notifications/\` and Celery
- DON'T conflate authentication (who you are) with authorization (what you can do in which tenant) — these are separate concerns handled in \`src/accounts/\` and \`src/core/permissions.py\`

## DO — Technical Discovery

- DO identify which Django apps are affected by each requirement and note them in the story
- DO map data entities to their owning Django app: Tenant → \`src/tenants/\`, Subscription → \`src/billing/\`, User → \`src/accounts/\`
- DO specify which Stripe API objects are involved (Customer, Subscription, Price, Invoice, UsageRecord, PaymentIntent)
- DO document expected Celery task characteristics: idempotency strategy, retry policy, timeout, priority queue
- DO identify Redis usage per requirement: caching (with TTL), session storage, rate limiting, or Celery broker
- DO capture database migration complexity — will this require a data migration, schema change, or new RLS policy?
- DO note if a requirement needs a new Django management command in \`scripts/\`
- DO specify API versioning implications — will this be a breaking change for existing API consumers?
- DO identify which requirements need feature flags for gradual rollout across tenants
- DO document expected data volumes per tenant to inform PostgreSQL indexing and partitioning decisions

## DON'T — Technical Discovery

- DON'T propose raw SQL for tenant filtering — use the tenant-aware manager in \`src/core/\`
- DON'T suggest storing Stripe webhook secrets or API keys in code or version control — use django-environ / Pydantic settings
- DON'T recommend a new database or data store without justifying why PostgreSQL + Redis is insufficient
- DON'T introduce a new Python dependency without noting it for the team's moderate dependency review policy
- DON'T design requirements that would bypass the service layer by calling ORM directly from views
- DON'T propose cron jobs when Celery Beat scheduling is the established pattern

## DO — Documentation Output

- DO produce requirements documents in Markdown, stored in \`docs/requirements/\`
- DO use the conventional commit format when describing requirement changes: \`docs: add tenant onboarding requirements\`
- DO link requirements to GitHub Issues using the \`SAAS-\` ticket prefix
- DO include a "Compliance Impact" section in every requirements document noting SOC 2 and GDPR implications
- DO include a "Tenant Isolation Impact" section describing how the feature respects multi-tenant boundaries
- DO include a "Billing Impact" section if the feature affects subscription tiers, usage metering, or invoicing
- DO create an NFR (non-functional requirements) checklist using \`playbook/prompts/01/nfr-checklist.md\` as the template
- DO generate user stories using \`playbook/prompts/01/user-stories.md\` as the template

## DON'T — Documentation Output

- DON'T generate implementation code during discovery — this phase produces requirements, user stories, and NFRs only
- DON'T create architecture decision records yet — those belong in Phase 02 (see \`playbook/phases/02-architecture.md\`)
- DON'T write test cases yet — those belong in Phase 06 (see \`playbook/phases/06-testing-quality.md\`)
- DON'T produce documents longer than 300 lines — split into focused sub-documents if needed
- DON'T leave requirements in a state where a mid-level developer couldn't understand the tenant and billing context

## Checklist Before Exiting Phase 01

- [ ] Every user story specifies the actor's tenant role and subscription tier
- [ ] Multi-tenancy isolation strategy is documented (row-level security, tenant-aware managers)
- [ ] Stripe billing integration points are enumerated (which events, which API objects)
- [ ] Celery task requirements are identified with idempotency and retry expectations
- [ ] GDPR data handling requirements are captured (consent, retention, deletion, residency)
- [ ] SOC 2 audit logging requirements are specified for sensitive operations
- [ ] RBAC matrix is drafted mapping roles to permissions per Django app
- [ ] NFRs have concrete, measurable targets
- [ ] All requirements reference the correct Django app in \`src/\`
- [ ] API surface is identified (REST vs. GraphQL vs. both) for each feature
- [ ] White-label and custom domain requirements are captured if applicable
- [ ] Requirements are stored in \`docs/requirements/\` and linked to GitHub Issues`,

  'playbook/claude-overrides/02-architecture.claude.md': `# Phase 02: Architecture & Design — Claude Override Rules

## Purpose

These rules constrain Claude's behavior during architecture and design work for the django-saas-platform. They enforce multi-tenant SaaS patterns, Django best practices, and SOC 2/GDPR compliance at the design level.

---

## DO — Architecture Decisions

- **DO** design every data model with tenant isolation from the start — add a \`tenant\` ForeignKey on all business models and use the tenant-aware manager from \`core/managers.py\`
- **DO** use Django's modular app structure — each bounded context (\`accounts\`, \`tenants\`, \`billing\`, \`notifications\`, \`tasks\`) is a self-contained Django app with its own \`models.py\`, \`serializers.py\`, \`views.py\`, \`services.py\`, \`tests/\`
- **DO** define a service layer (\`services.py\`) in each app for business logic — views and serializers delegate to services, services call managers
- **DO** use PostgreSQL row-level security (RLS) policies as a defense-in-depth layer for tenant data isolation, in addition to application-level filtering via tenant-aware querysets
- **DO** design the \`Tenant\` model in \`src/tenants/\` as the root of all tenant-scoped data — every tenant-scoped query must flow through \`TenantAwareManager\`
- **DO** use Abstract base models in \`src/core/models.py\` for shared fields: \`TenantScopedModel\` (tenant FK + manager), \`TimestampedModel\` (created_at, updated_at), \`AuditModel\` (created_by, modified_by)
- **DO** design the billing domain (\`src/billing/\`) around Stripe as the source of truth — local models mirror Stripe objects (Customer, Subscription, Invoice, UsageRecord) and sync via webhooks
- **DO** design all Celery tasks as idempotent — use unique task IDs, check-before-write patterns, and database-level constraints to prevent duplicate processing
- **DO** use Redis for three distinct purposes with separate logical databases or key prefixes: caching (\`cache:\`), Celery broker, and session storage (\`session:\`)
- **DO** design API versioning from the start — use URL-based versioning (\`/api/v1/\`) for DRF endpoints and schema versioning for Strawberry GraphQL
- **DO** document every significant architecture decision as an ADR in \`docs/adr/\` using the template from \`playbook/prompts/02/adr-generator.md\`
- **DO** design the permission model with role-based access control (RBAC) scoped to tenants — roles are \`owner\`, \`admin\`, \`member\`, \`viewer\` per tenant, not global
- **DO** plan for white-label support in the tenant model — include fields for custom domain, branding (logo, colors), and email sender configuration
- **DO** design webhook dispatch (\`src/notifications/\`) as an async Celery task with exponential backoff retry and dead-letter logging
- **DO** use \`drf-spectacular\` annotations on every DRF view for OpenAPI 3.1 schema generation — schema completeness is a design requirement, not an afterthought
- **DO** design audit logging as a separate concern in \`src/core/audit.py\` — log all write operations on sensitive models (billing, auth, tenant settings) with actor, action, timestamp, tenant, and diff

---

## DON'T — Architecture Anti-Patterns

- **DON'T** use Django signals for cross-app business logic — signals hide control flow and make debugging multi-tenant issues extremely difficult; use explicit service layer calls instead
- **DON'T** put business logic in views, serializers, or Celery tasks — views handle HTTP, serializers handle validation/serialization, tasks handle async dispatch; logic belongs in \`services.py\`
- **DON'T** design models without a tenant FK unless they are truly global (e.g., \`Plan\`, \`Feature\`, system configuration) — if in doubt, it's tenant-scoped
- **DON'T** use Django's built-in \`User\` model directly — extend with a custom user model in \`src/accounts/models.py\` that supports tenant membership via a \`TenantMembership\` through-model
- **DON'T** store Stripe secrets, webhook signing secrets, or API keys in code or settings files — use \`django-environ\` to load from environment variables, validated by Pydantic settings in \`config/\`
- **DON'T** design synchronous Stripe API calls in request/response cycles — all Stripe operations (create subscription, sync invoice, meter usage) must be async via Celery tasks or webhook handlers
- **DON'T** use raw SQL for tenant-scoped queries unless implementing RLS policies — all application queries must use the tenant-aware ORM manager
- **DON'T** design a single monolithic \`api/\` app with all endpoints — each Django app exposes its own \`urls.py\` and viewsets; \`src/api/\` only handles top-level routing and GraphQL schema stitching
- **DON'T** use \`ForeignKey(on_delete=CASCADE)\` on tenant-scoped models without explicit review — tenant deletion must be a controlled, audited process with soft-delete and data export (GDPR right to deletion)
- **DON'T** design file uploads to go to local disk — use S3 with tenant-prefixed keys (\`s3://{bucket}/{tenant_id}/...\`) and signed URLs
- **DON'T** create circular imports between Django apps — if \`billing\` needs \`tenants\`, import at function level or use string references in ForeignKey; maintain a strict dependency graph: \`core\` → \`tenants\` → \`accounts\` → \`billing\` → \`notifications\` → \`tasks\`
- **DON'T** design the GraphQL schema to expose internal IDs — use opaque global IDs (Relay-style) or UUIDs as public identifiers
- **DON'T** skip designing for horizontal scalability — Celery workers, Django app servers, and Redis must be stateless and independently scalable on ECS/Kubernetes
- **DON'T** design admin endpoints without additional authentication — tenant admin operations and Django admin must require MFA or elevated session verification
- **DON'T** use pickle serialization for Celery — use JSON serialization only for security and debuggability

---

## DO — Data Model Design

- **DO** use UUIDs as primary keys for all models exposed via API — keep integer PKs only for internal Django admin and ORM joins if needed, but expose \`uuid\` field externally
- **DO** design soft-delete for tenant-scoped models using an \`is_deleted\` flag and \`deleted_at\` timestamp — override the tenant-aware manager to exclude soft-deleted records by default
- **DO** add database indexes on \`(tenant_id, <frequently_queried_field>)\` composite keys for all tenant-scoped models
- **DO** design the subscription model to support multiple plans per tenant (e.g., base plan + add-ons) and usage-based line items
- **DO** use \`django.contrib.postgres\` fields (JSONField, ArrayField) where appropriate but keep critical query fields as proper columns with indexes
- **DO** design data residency support — the \`Tenant\` model should include a \`region\` field that determines which database/storage region is used (GDPR compliance)

---

## DON'T — Data Model Anti-Patterns

- **DON'T** use \`CharField\` for fields that should be enums — use \`TextChoices\` or \`IntegerChoices\` with database-level CHECK constraints
- **DON'T** store monetary values as floats — use \`DecimalField(max_digits=12, decimal_places=2)\` and always store amounts in the smallest currency unit (cents) as integers when interfacing with Stripe
- **DON'T** design polymorphic models with nullable ForeignKeys to represent different entity types — use Django's multi-table inheritance or separate models with a shared interface
- **DON'T** add \`ManyToManyField\` without an explicit through-model when the relationship needs metadata (e.g., \`TenantMembership\` needs \`role\`, \`invited_at\`, \`accepted_at\`)

---

## DO — API Design

- **DO** use consistent response envelopes: \`{"data": ..., "meta": {"page": ..., "total": ...}}\` for list endpoints, \`{"data": ...}\` for detail endpoints
- **DO** design pagination using cursor-based pagination for large datasets (audit logs, usage records) and page-number pagination for bounded lists
- **DO** require tenant context in every API request — either via subdomain, \`X-Tenant-ID\` header, or JWT claim; middleware in \`src/core/middleware.py\` sets \`request.tenant\`
- **DO** design rate limiting per tenant and per user — use Redis-backed rate limiting with different tiers based on subscription plan
- **DO** version the GraphQL schema and maintain backward compatibility for at least one version cycle

---

## DON'T — API Anti-Patterns

- **DON'T** expose internal model structure directly in API responses — use serializers to shape the response and hide implementation details
- **DON'T** design endpoints that return unbounded lists — every list endpoint must have pagination with a maximum page size (default 25, max 100)
- **DON'T** accept tenant ID from the client for authorization decisions — derive tenant context from the authenticated session/token, never from request body or query params
- **DON'T** design webhooks (incoming from Stripe or outgoing to tenants) without idempotency keys and signature verification

---

## DO — Security & Compliance Design

- **DO** design all authentication flows to support MFA — plan for TOTP and WebAuthn from the architecture phase
- **DO** include consent tracking in the data model — \`ConsentRecord\` model with purpose, timestamp, IP, and version for GDPR compliance
- **DO** design PII fields with encryption at rest — use \`django-encrypted-model-fields\` or application-level encryption for email, phone, billing address
- **DO** plan for SOC 2 audit trail requirements — every admin action, permission change, and data export must be logged to the audit table with immutable records
- **DO** design tenant data export and deletion workflows as first-class features — GDPR right to access and right to erasure must be automated, not manual

---

## DON'T — Security Anti-Patterns

- **DON'T** design shared database connections across tenants without RLS — even with application-level filtering, a bug could leak data between tenants
- **DON'T** log PII (email, names, billing info) in application logs — use tenant ID and user ID for log correlation, never raw PII
- **DON'T** design password reset or invitation flows that leak whether an email exists in the system — use constant-time responses
- **DON'T** store session data or tokens in local memory — use Redis-backed sessions for horizontal scalability and centralized revocation

---

## Cross-References

- ADR template: \`playbook/prompts/02/adr-generator.md\`
- API design prompt: \`playbook/prompts/02/api-design.md\`
- Data model design prompt: \`playbook/prompts/02/data-model-design.md\`
- Security hardening: \`playbook/prompts/05/security-hardening.md\`
- Auth implementation: \`playbook/prompts/04/auth-implementation.md\`
- Phase definition: \`playbook/phases/02-architecture.md\`
- Sensitive paths requiring extra review: \`**/billing/**\`, \`**/auth/**\`, \`config/production/**\`, \`.env*\``,

  'playbook/claude-overrides/03-foundation.claude.md': `---
phase: "03-foundation"
scope: "Foundation & Scaffolding phase — project setup, CI/CD, infrastructure-as-code, Django app structure"
applies_to: "All Claude Code interactions during Phase 03"
---

# Phase 03: Foundation & Scaffolding — Claude Override Rules

## Context

You are assisting with the foundation phase of **django-saas-platform**, a multi-tenant SaaS application. This phase establishes the project scaffold, CI/CD pipelines, infrastructure-as-code, base Django apps, and development environment. Every decision here propagates through the entire codebase — precision matters.

## DO — Required Behaviors

### Project Structure

- DO use the canonical directory layout with \`src/\` as the Django source root containing apps: \`accounts\`, \`tenants\`, \`billing\`, \`api\`, \`core\`, \`notifications\`, \`tasks\`, \`utils\`
- DO create each Django app as a self-contained module with \`models.py\`, \`serializers.py\`, \`views.py\`, \`urls.py\`, \`services.py\`, \`signals.py\`, \`admin.py\`, \`tests/\` directory, and \`apps.py\`
- DO include a \`core/\` app with base abstract models (\`TenantAwareModel\`, \`TimestampedModel\`, \`UUIDPrimaryKeyModel\`), tenant-aware managers, base permissions, and shared middleware
- DO place Django settings in \`config/\` with split files: \`base.py\`, \`development.py\`, \`staging.py\`, \`production.py\`
- DO use \`django-environ\` combined with Pydantic settings for configuration validation — environment variables parsed through a typed settings class
- DO create a \`pyproject.toml\` as the single source of truth for project metadata, dependencies, and tool configuration (ruff, mypy, pytest)
- DO use \`uv\` as the package manager — all commands reference \`uv run\`, \`uv add\`, \`uv lock\`

### Base Models and Multi-Tenancy Foundation

- DO create a \`TenantAwareModel\` abstract base that includes a \`tenant\` ForeignKey and uses a custom \`TenantAwareManager\` that automatically filters by the current tenant from thread-local or request context
- DO create a \`TenantMiddleware\` in \`core/middleware.py\` that extracts tenant from the request (subdomain, header, or JWT claim) and sets it in thread-local storage
- DO add a \`tenant_id\` field to every model that stores tenant data — no exceptions
- DO scaffold the PostgreSQL row-level security migration as a \`RunSQL\` operation in the \`tenants\` app initial migration, with a comment explaining it will be fully configured in Phase 04
- DO create a \`CurrentTenantContext\` context manager for use in Celery tasks and management commands where request context is unavailable

### CI/CD Pipeline

- DO generate GitHub Actions workflows matching the defined stages: lint → type-check → unit-tests → integration-tests → security-scan → build-docker → deploy-staging → e2e-tests → deploy-production
- DO use separate workflow jobs with proper \`needs\` dependencies so failures block downstream stages
- DO configure \`uv run ruff check src/\` for linting, \`uv run ruff format --check src/\` for format verification, \`uv run mypy src/\` for type checking, and \`uv run pytest --cov=src --cov-fail-under=85\` for tests
- DO include a PostgreSQL service container and Redis service container in the integration test job
- DO add a security scanning step using \`pip-audit\` or \`safety\` for dependency vulnerabilities and \`bandit\` for code security
- DO set up Docker image builds with layer caching, multi-stage builds, and image tagging with git SHA and branch name
- DO add the \`ai-generated\` label logic: if a PR branch contains \`/claude/\` or the PR body contains \`[ai-assisted]\`, automatically add the label

### Infrastructure as Code

- DO generate Terraform modules for AWS resources: ECS (Fargate), RDS PostgreSQL 16, ElastiCache Redis, S3 buckets (static assets, media, backups), SES for email, CloudFront CDN
- DO parameterize all Terraform with variables for environment (\`staging\`, \`production\`), region, instance sizes, and tenant isolation boundaries
- DO create separate Terraform state files per environment using S3 backend with DynamoDB locking
- DO include RDS configuration with encryption at rest, automated backups, and a parameter group enabling \`pgaudit\` for SOC 2 audit logging
- DO scaffold Kubernetes manifests (or ECS task definitions) with separate containers for: Django web (gunicorn), Celery worker, Celery beat, and Redis (for local dev)

### Docker Setup

- DO create a multi-stage \`Dockerfile\`: stage 1 builds with \`uv\` and compiles dependencies, stage 2 is a slim runtime image with only the compiled wheels and source
- DO create a \`docker-compose.yml\` for local development with services: \`web\`, \`worker\`, \`beat\`, \`postgres\`, \`redis\`, \`mailpit\` (for email testing)
- DO set \`DJANGO_SETTINGS_MODULE=config.development\` in docker-compose and \`config.production\` in production Dockerfiles
- DO include health check endpoints in the Docker configuration — \`/health/\` for the web service, Celery inspect ping for workers
- DO mount \`src/\` as a volume in docker-compose for hot-reload during development

### Dependency Management

- DO pin all dependencies in \`pyproject.toml\` with minimum version constraints and generate a locked \`uv.lock\`
- DO separate dependencies into groups: \`[project.dependencies]\` for runtime, \`[project.optional-dependencies.dev]\` for development (ruff, mypy, pytest, factory-boy, ipdb), \`[project.optional-dependencies.test]\` for CI test extras
- DO include these core dependencies at minimum: \`django>=5.0\`, \`djangorestframework\`, \`strawberry-graphql-django\`, \`celery[redis]>=5\`, \`stripe\`, \`django-environ\`, \`pydantic>=2\`, \`drf-spectacular\`, \`psycopg[binary]>=3\`, \`django-redis\`, \`gunicorn\`, \`sentry-sdk[django]\`

### Code Quality Tooling Configuration

- DO configure ruff in \`pyproject.toml\` with rule sets: \`E\`, \`F\`, \`W\`, \`I\` (isort), \`N\` (naming), \`UP\` (pyupgrade), \`S\` (bandit security), \`B\` (bugbear), \`A\` (builtins), \`DJ\` (django-specific), \`T20\` (print statements)
- DO configure mypy in \`pyproject.toml\` with \`strict = true\`, Django plugin enabled (\`mypy_django_plugin\`), and per-module overrides for third-party libraries that lack stubs
- DO configure pytest in \`pyproject.toml\` with \`DJANGO_SETTINGS_MODULE = "config.test"\`, \`python_files = "test_*.py"\`, \`python_classes = "Test*"\`, \`python_functions = "test_*"\`, \`addopts = "--strict-markers --tb=short -q"\`
- DO set the max line length to 120 in ruff configuration
- DO add pre-commit hooks configuration (\`.pre-commit-config.yaml\`) running ruff check, ruff format, and mypy

### Sensitive Path Protections

- DO create a \`CODEOWNERS\` file mapping: \`src/billing/\` → \`@billing-team\`, \`src/accounts/\` and \`src/core/auth*\` → \`@auth-team\`, \`config/production*\` → \`@platform-leads\`, \`.env*\` → \`@platform-leads\`, \`.github/\` → \`@platform-leads\`
- DO add \`.env.example\` with all required environment variables documented (with dummy values) but never include real secrets
- DO configure \`.gitignore\` to exclude \`.env\`, \`.env.local\`, \`.env.production\`, \`*.pem\`, \`*.key\`, and any Terraform state files

### Scaffolding Completeness

- DO generate Django management commands: \`create_tenant\` (provisions a new tenant with schema/RLS), \`seed_dev_data\` (creates test tenants, users, subscriptions for local dev), \`verify_rls\` (checks row-level security policies are active)
- DO create a \`conftest.py\` at the project root with shared pytest fixtures: \`tenant_factory\`, \`user_factory\`, \`authenticated_api_client\`, \`stripe_mock\`, \`celery_eager_mode\`
- DO include a \`Makefile\` or \`justfile\` with common commands: \`dev\` (docker-compose up), \`test\` (uv run pytest), \`lint\` (uv run ruff check), \`typecheck\` (uv run mypy src/), \`migrate\` (uv run python manage.py migrate), \`shell\` (uv run python manage.py shell_plus)

## DON'T — Prohibited Behaviors

### Project Structure Anti-Patterns

- DON'T put all Django apps in a flat structure without the \`src/\` namespace — always use \`src/\` as the source root
- DON'T create a single monolithic \`views.py\` or \`models.py\` — split into focused modules when a file approaches 300 lines
- DON'T use Django's default \`settings.py\` as a single file — always use the split settings pattern under \`config/\`
- DON'T hardcode any configuration values (database URLs, API keys, secret keys, Redis URLs) — everything comes from environment variables
- DON'T use \`pip\` or \`pip-tools\` — this project uses \`uv\` exclusively
- DON'T create a \`requirements.txt\` — use \`pyproject.toml\` and \`uv.lock\`

### Multi-Tenancy Mistakes

- DON'T create any model with tenant-scoped data that lacks a \`tenant\` ForeignKey — this breaks row-level security
- DON'T use Django's default \`objects\` manager on tenant-aware models without the tenant filter — always use \`TenantAwareManager\`
- DON'T implement tenant isolation using separate databases or schemas — use row-level security on a shared database
- DON'T access \`request.tenant\` without the \`TenantMiddleware\` being in the middleware stack — scaffold the middleware registration in base settings
- DON'T store tenant identification in cookies alone — use subdomain or JWT claim as the primary tenant identifier

### CI/CD Mistakes

- DON'T create a single monolithic CI job — use separate jobs with dependency chains for parallelism and clear failure identification
- DON'T skip the type-checking stage — mypy strict mode is mandatory in CI
- DON'T allow CI to pass with coverage below 85% — configure \`--cov-fail-under=85\`
- DON'T deploy to production automatically — staging is auto-deploy, production requires manual approval
- DON'T store secrets in workflow files — use GitHub Actions secrets and reference them as \`\${{ secrets.* }}\`
- DON'T omit the security scan stage — dependency auditing and bandit are required for SOC 2

### Infrastructure Mistakes

- DON'T create Terraform resources without encryption — RDS, S3, ElastiCache must all have encryption at rest enabled
- DON'T use default VPC or public subnets for databases — RDS and ElastiCache must be in private subnets
- DON'T create a single Terraform state file for all environments — separate state per environment
- DON'T hardcode AWS account IDs, regions, or resource names in Terraform — use variables
- DON'T skip backup configuration for RDS — automated backups with at least 7-day retention are required for SOC 2

### Docker Mistakes

- DON'T use a single-stage Dockerfile that includes build tools in the runtime image — always use multi-stage builds
- DON'T run the Django application as root in the container — create and use a non-root user
- DON'T include \`.env\` files, secrets, or test fixtures in the Docker image — use \`.dockerignore\`
- DON'T use \`latest\` as the only Docker tag — always tag with git SHA for traceability
- DON'T use SQLite in docker-compose — always use PostgreSQL to match production

### Dependency Mistakes

- DON'T add dependencies without specifying minimum version constraints
- DON'T include development-only dependencies (ruff, mypy, pytest, factory-boy, ipdb) in the production dependency group
- DON'T add a new dependency without checking if an existing one covers the use case — prefer Django/DRF built-ins over third-party packages for common functionality
- DON'T use \`django-tenants\` or \`django-multitenant\` schema-based isolation — this project uses row-level security, not schema-per-tenant

### Security Scaffolding Mistakes

- DON'T generate a \`SECRET_KEY\` in settings files — it must come from the environment variable \`DJANGO_SECRET_KEY\`
- DON'T set \`DEBUG = True\` in any settings file other than \`development.py\`
- DON'T set \`ALLOWED_HOSTS = ['*']\` in staging or production settings
- DON'T disable CSRF protection or set permissive CORS in production settings
- DON'T create API endpoints without registering them in the drf-spectacular schema

## Phase-Specific Guidance

### When Generating the Django Project Scaffold

Reference \`playbook/prompts/03/project-scaffold.md\` for the detailed scaffold prompt. Ensure every generated app includes an \`__init__.py\`, \`apps.py\` with proper \`default_auto_field\` and \`name\`, and a \`tests/__init__.py\`. The \`core\` app must be generated first as other apps depend on its base models and managers.

### When Generating CI/CD Pipelines

Reference \`playbook/prompts/03/ci-pipeline.md\`. The pipeline must work with \`uv\` — do not assume \`pip install\`. Cache the \`uv\` cache directory (\`~/.cache/uv\`) between runs. Use \`uv sync\` to install dependencies from the lockfile.

### When Generating Infrastructure as Code

Reference \`playbook/prompts/03/iac-setup.md\`. All Terraform must be in \`infra/terraform/\` with modules for \`networking\`, \`database\`, \`cache\`, \`compute\`, \`storage\`, \`cdn\`, \`monitoring\`. Include a \`README.md\` in each module explaining its purpose and required variables.

### When Setting Up the Billing App Scaffold

The \`billing/\` app scaffold should include: \`models.py\` (Subscription, Plan, Invoice, UsageRecord stubs), \`services.py\` (StripeService class stub), \`webhooks.py\` (webhook handler stub with signature verification), \`tasks.py\` (sync_subscriptions, process_usage_records stubs). Mark all Stripe-related functions with \`# TODO: Implement in Phase 04\` but ensure the module structure and imports are correct.

### When Creating Test Infrastructure

The root \`conftest.py\` must configure \`pytest-django\` with the test settings module, set Celery to eager mode (\`CELERY_TASK_ALWAYS_EAGER=True\`), and provide factories using \`factory_boy\` that respect tenant isolation. Every factory that creates tenant-scoped data must accept a \`tenant\` parameter.

### Compliance Checkpoints

- Every database migration must be reviewable — no auto-generated migrations without a human-readable comment explaining the change
- Audit logging scaffold must be in place: \`core/audit.py\` with a base \`AuditLog\` model capturing \`actor\`, \`tenant\`, \`action\`, \`resource_type\`, \`resource_id\`, \`timestamp\`, \`ip_address\`, \`changes\` (JSON)
- GDPR scaffold: \`accounts/gdpr.py\` with stubs for \`export_user_data()\`, \`anonymize_user()\`, \`delete_user_data()\`, \`record_consent()\`
- All environment-specific settings must be documented in \`.env.example\` with comments explaining each variable's purpose and acceptable values`,

  'playbook/claude-overrides/04-core-implementation.claude.md': `# Phase 04: Core Implementation — Claude Override Rules

## Purpose

Strict DO/DON'T rules for Claude Code when generating or modifying core implementation code in the django-saas-platform. These rules enforce multi-tenancy safety, billing correctness, idempotent task design, and Django/DRF/Strawberry conventions.

---

## Multi-Tenancy Rules

### DO

- **DO** access all tenant-scoped data through the tenant-aware manager (\`TenantManager\`) — never use \`objects\` directly on tenant-scoped models
- **DO** include \`tenant_id\` in every queryset filter for tenant-scoped models, even when the manager handles it — defense in depth
- **DO** validate that the requesting user belongs to the tenant in every view, serializer, and service function
- **DO** use \`get_current_tenant()\` from \`core.context\` to resolve the tenant from middleware — never parse tenant from URL manually
- **DO** add \`tenant\` as a required field in all tenant-scoped model factories (factory_boy)
- **DO** write explicit tests that verify Tenant A cannot access Tenant B's data
- **DO** use PostgreSQL row-level security policies as the final enforcement layer — application-level filtering is the first layer

### DON'T

- **DON'T** use \`Model.objects.all()\` on any tenant-scoped model — always use \`Model.tenant_objects.for_tenant(tenant)\` or the equivalent filtered manager
- **DON'T** create raw SQL queries that bypass tenant filtering without explicit security review comments
- **DON'T** store tenant identification in cookies or client-controlled headers — derive it from the authenticated session or JWT claims
- **DON'T** use \`get_object_or_404(Model, pk=pk)\` without tenant scoping — use \`get_object_or_404(Model.tenant_objects.for_tenant(request.tenant), pk=pk)\`
- **DON'T** assume a superuser should see all tenants' data in API endpoints — admin access uses separate admin-only views
- **DON'T** leak tenant IDs, names, or metadata in error messages returned to clients

---

## Django Models

### DO

- **DO** inherit from \`core.models.BaseModel\` which provides \`id\` (UUID), \`created_at\`, \`updated_at\`, \`tenant\` (FK) fields
- **DO** add \`class Meta: constraints\` with \`UniqueConstraint\` scoped to tenant where business uniqueness applies (e.g., \`unique_together\` on \`(tenant, slug)\`)
- **DO** define \`__str__\` on every model returning a human-readable representation
- **DO** add \`db_index=True\` on fields used in frequent lookups (status, email, external IDs)
- **DO** use \`django.db.models.TextChoices\` or \`IntegerChoices\` for status/type fields
- **DO** keep models under 100 lines — extract business logic to the service layer in \`services.py\`
- **DO** add type hints to all model properties and custom methods

### DON'T

- **DON'T** put business logic in model \`save()\` or \`clean()\` methods — use explicit service functions
- **DON'T** use Django signals for cross-app communication — call service functions directly and document the dependency
- **DON'T** use \`ForeignKey(on_delete=models.CASCADE)\` on billing or audit models — use \`PROTECT\` or \`SET_NULL\` and handle deletion explicitly
- **DON'T** add nullable \`CharField\` — use \`blank=True, default=""\` instead (Django convention)
- **DON'T** define \`ordering\` in \`Meta\` on large tables — specify ordering in queries to avoid implicit ORDER BY
- **DON'T** use \`auto_now=True\` on \`updated_at\` — use \`BaseModel\`'s explicit handling so it can be overridden in tests

---

## Service Layer

### DO

- **DO** create a \`services.py\` in each Django app for business logic — views call services, services call models
- **DO** type-annotate all service function signatures with input types and return types
- **DO** raise domain-specific exceptions from \`core.exceptions\` (e.g., \`TenantQuotaExceeded\`, \`SubscriptionInactive\`) — never raise generic \`Exception\`
- **DO** accept \`tenant\` as an explicit parameter in service functions — never rely on implicit global state inside services
- **DO** wrap multi-step operations in \`django.db.transaction.atomic()\` with \`select_for_update()\` where needed
- **DO** return dataclasses or Pydantic models from service functions when the return shape differs from the Django model
- **DO** log service-layer operations at INFO level with structured context: \`logger.info("subscription_created", extra={"tenant_id": str(tenant.id), "plan": plan.slug})\`

### DON'T

- **DON'T** import or call views from services — the dependency flows one way: view → service → model
- **DON'T** access \`request\` objects inside service functions — extract needed data (user, tenant, payload) in the view and pass it in
- **DON'T** catch and silence exceptions in services — let them propagate to the view layer for proper HTTP response mapping
- **DON'T** make external API calls (Stripe, email, webhooks) synchronously inside services — dispatch a Celery task instead, unless the response is needed immediately (e.g., creating a Stripe checkout session)
- **DON'T** put service functions in \`__init__.py\` — use explicit \`services.py\` or \`services/\` package with named modules

---

## Django REST Framework (DRF)

### DO

- **DO** use \`ModelViewSet\` or \`GenericAPIView\` — avoid function-based views
- **DO** define separate serializers for create, update, list, and detail when field sets differ
- **DO** annotate all viewsets with \`@extend_schema\` from drf-spectacular for OpenAPI documentation
- **DO** use \`permission_classes\` on every viewset — never rely on \`DEFAULT_PERMISSION_CLASSES\` alone
- **DO** implement pagination on all list endpoints using \`core.pagination.TenantAwarePagination\`
- **DO** return consistent error responses using \`core.exceptions.handler\` mapped in \`REST_FRAMEWORK["EXCEPTION_HANDLER"]\`
- **DO** use \`serializer.validated_data\` — never access \`request.data\` directly after validation
- **DO** filter querysets in \`get_queryset()\` by \`self.request.tenant\` — never in \`list()\` or \`retrieve()\`

### DON'T

- **DON'T** put business logic in serializers — serializers validate and transform, services execute logic
- **DON'T** use \`SerializerMethodField\` for data that should be a model property or annotation
- **DON'T** return 200 for creation — use \`status.HTTP_201_CREATED\`
- **DON'T** expose internal model IDs — use UUIDs as the public identifier in all API responses
- **DON'T** use \`depth\` in serializers — define explicit nested serializers for controlled output
- **DON'T** allow unfiltered querysets — every \`get_queryset()\` must scope to the current tenant
- **DON'T** use \`AllowAny\` permission on any endpoint that touches tenant data

---

## Strawberry GraphQL

### DO

- **DO** define GraphQL types in \`types.py\`, queries in \`queries.py\`, mutations in \`mutations.py\` within each app
- **DO** use \`strawberry_django\` for model-backed types with explicit field selection — never expose all model fields
- **DO** implement \`DataLoader\` for all nested relationships to prevent N+1 queries
- **DO** enforce tenant scoping in every resolver — use \`info.context.request.tenant\`
- **DO** use Strawberry permission classes that mirror DRF permission checks
- **DO** return union types for mutation results: \`Success | ValidationError | NotFound\`

### DON'T

- **DON'T** expose GraphQL introspection in production — disable via \`GRAPHQL_INTROSPECTION = False\` in production settings
- **DON'T** allow unbounded list queries — require pagination arguments (\`first\`, \`after\`) on all connection fields
- **DON'T** resolve Stripe-sensitive data (card numbers, bank accounts) through GraphQL — use DRF endpoints with Stripe.js
- **DON'T** use \`strawberry.auto\` for fields on billing or auth models — explicitly list safe fields

---

## Celery Tasks

### DO

- **DO** make every task idempotent — running the same task twice with the same arguments must produce the same result
- **DO** use \`bind=True\` and accept \`self\` to enable retries: \`@shared_task(bind=True, max_retries=3, default_retry_delay=60)\`
- **DO** pass only serializable primitives (UUIDs as strings, not model instances) as task arguments
- **DO** include \`tenant_id\` as the first argument to every tenant-scoped task
- **DO** use \`task_id\` based on a deterministic key for deduplication where applicable (e.g., \`f"sync-invoice-{invoice_id}"\`)
- **DO** set \`acks_late=True\` and \`reject_on_worker_lost=True\` on tasks that must not be lost
- **DO** define task retry backoff: \`self.retry(exc=exc, countdown=2 ** self.request.retries * 60)\`
- **DO** log task start, completion, and failure with structured context including \`tenant_id\` and \`task_id\`
- **DO** define separate Celery queues for priority levels: \`default\`, \`billing\`, \`notifications\`, \`reports\`

### DON'T

- **DON'T** pass Django model instances or querysets as task arguments — pass the PK and re-fetch inside the task
- **DON'T** use \`delay()\` without considering failure — always handle \`MaxRetriesExceededError\`
- **DON'T** run database migrations or schema changes inside Celery tasks
- **DON'T** access \`request\` or any thread-local state inside tasks — tasks run in a separate worker process
- **DON'T** use \`countdown=0\` for Stripe-related tasks — always add jitter to avoid thundering herd on webhook retries
- **DON'T** create tasks that run longer than 10 minutes — break them into chained subtasks
- **DON'T** use \`ignore_result=False\` unless the result is explicitly consumed — wasted Redis memory

---

## Stripe Billing Integration

### DO

- **DO** store Stripe IDs (\`stripe_customer_id\`, \`stripe_subscription_id\`, \`stripe_price_id\`) on local models and keep them in sync
- **DO** verify webhook signatures using \`stripe.Webhook.construct_event()\` with the endpoint secret
- **DO** make webhook handlers idempotent — check if the event has already been processed using \`StripeEvent.objects.filter(stripe_event_id=event.id).exists()\`
- **DO** store raw webhook payloads in \`billing.StripeEvent\` for audit and replay capability
- **DO** use Stripe's test clock in integration tests — never hit live Stripe in CI
- **DO** handle subscription state transitions explicitly: \`active → past_due → canceled → expired\`
- **DO** use \`billing/services.py\` as the single interface for all Stripe API calls — never call \`stripe.*\` from views or tasks directly
- **DO** record usage with \`stripe.SubscriptionItem.create_usage_record()\` via a Celery task on the \`billing\` queue

### DON'T

- **DON'T** store credit card numbers, CVVs, or full bank account numbers — Stripe handles PCI compliance
- **DON'T** trust client-side subscription status — always verify against Stripe or the local webhook-synced state
- **DON'T** delete \`StripeEvent\` records — they are part of the SOC 2 audit trail
- **DON'T** use Stripe Checkout for subscription changes — use the Customer Portal or API-driven proration
- **DON'T** hardcode Stripe price IDs — store them in \`billing.Plan\` model and reference by slug
- **DON'T** process billing webhooks synchronously in the request — enqueue to the \`billing\` Celery queue
- **DON'T** expose Stripe secret keys in logs, error messages, or API responses

---

## Authentication & Authorization

### DO

- **DO** use \`accounts.backends.TenantAwareBackend\` for authentication that validates user-tenant membership
- **DO** implement RBAC using \`core.permissions\` with roles: \`owner\`, \`admin\`, \`member\`, \`viewer\`, \`billing_admin\`
- **DO** check permissions at both the view level (\`permission_classes\`) and the object level (\`has_object_permission\`)
- **DO** use short-lived JWTs (15 min access, 7 day refresh) with tenant claims in the payload
- **DO** log all authentication events (login, logout, failed attempts, token refresh) to the audit log
- **DO** enforce rate limiting on auth endpoints: 5 attempts per minute per IP for login

### DON'T

- **DON'T** store passwords in plaintext or reversible encryption — Django's \`make_password\` handles this
- **DON'T** include sensitive user data (email, roles) in JWT payloads — use opaque tokens and server-side lookup
- **DON'T** allow users to switch tenants without re-authentication or explicit tenant selection flow
- **DON'T** implement custom password hashing — use Django's \`PASSWORD_HASHERS\` with Argon2 as default
- **DON'T** return different error messages for "user not found" vs "wrong password" — use a generic "invalid credentials" message

---

## Audit Logging

### DO

- **DO** log all write operations (create, update, delete) on tenant-scoped models via \`core.audit.log_action()\`
- **DO** include \`actor\` (user), \`tenant\`, \`action\`, \`resource_type\`, \`resource_id\`, \`changes\` (diff), \`ip_address\`, \`timestamp\`
- **DO** store audit logs in a separate \`audit_log\` table with append-only access (no UPDATE/DELETE permissions for the app user)
- **DO** use \`AuditLogMiddleware\` to capture request metadata automatically
- **DO** retain audit logs for minimum 1 year per SOC 2 requirements

### DON'T

- **DON'T** log PII (passwords, tokens, credit card info) in audit entries — redact sensitive fields
- **DON'T** use audit logs for debugging — use structured application logs (Sentry, CloudWatch) for that
- **DON'T** allow audit log deletion through any API endpoint or admin action

---

## Database & Queries

### DO

- **DO** use \`select_related()\` and \`prefetch_related()\` to avoid N+1 queries — enforce with \`django-query-inspector\` in development
- **DO** add database indexes for all foreign keys and fields used in \`WHERE\`, \`ORDER BY\`, or \`JOIN\` clauses
- **DO** use \`django.db.models.F()\` and \`Q()\` expressions for complex queries — avoid raw SQL
- **DO** run \`EXPLAIN ANALYZE\` on queries touching tables with >100K rows before merging
- **DO** use \`bulk_create()\` and \`bulk_update()\` for batch operations with \`batch_size=1000\`
- **DO** create data migrations for schema changes that require backfills — never backfill in application code at startup

### DON'T

- **DON'T** use \`Model.objects.all()\` without \`.filter()\` in any view or task — always scope and limit
- **DON'T** use \`count()\` on large tables in hot paths — use \`exists()\` or cached counts
- **DON'T** add \`null=True\` to \`CharField\` or \`TextField\` — use \`default=""\` with \`blank=True\`
- **DON'T** use \`distinct()\` to fix duplicate results from bad joins — fix the query instead
- **DON'T** write migrations that lock tables for extended periods — use \`AddIndex(concurrently=True)\` on PostgreSQL

---

## Error Handling

### DO

- **DO** define domain exceptions in \`core/exceptions.py\`: \`TenantNotFound\`, \`SubscriptionRequired\`, \`QuotaExceeded\`, \`BillingError\`
- **DO** map domain exceptions to HTTP status codes in the DRF exception handler
- **DO** include a machine-readable \`error_code\` in all error responses: \`{"error_code": "QUOTA_EXCEEDED", "detail": "..."}\`
- **DO** report unhandled exceptions to Sentry with tenant and user context attached
- **DO** use \`try/except\` with specific exception types — never bare \`except:\`

### DON'T

- **DON'T** return stack traces in production API responses
- **DON'T** catch \`Exception\` broadly in views — let the DRF exception handler manage it
- **DON'T** use HTTP 500 for business logic errors — map to 400, 402, 403, 404, 409, 429 as appropriate
- **DON'T** swallow Stripe API errors — log them, map to \`BillingError\`, and surface to the user

---

## File Organization

### DO

- **DO** keep each Django app self-contained: \`models.py\`, \`services.py\`, \`serializers.py\`, \`views.py\`, \`urls.py\`, \`tasks.py\`, \`types.py\`, \`admin.py\`, \`tests/\`
- **DO** split files exceeding 300 lines into modules: \`services/\` package with \`subscription.py\`, \`invoice.py\`, etc.
- **DO** place shared utilities in \`src/utils/\` — app-specific helpers stay in the app
- **DO** co-locate tests with the code they test: \`tests/test_services.py\`, \`tests/test_views.py\`, \`tests/test_tasks.py\`

### DON'T

- **DON'T** create circular imports between apps — if app A needs app B, use the service layer or Django's \`apps.get_model()\`
- **DON'T** put view logic in \`urls.py\` — \`urls.py\` only maps paths to views
- **DON'T** create a \`helpers.py\` catch-all — name modules by what they do: \`formatters.py\`, \`validators.py\`, \`converters.py\`
- **DON'T** import from \`tests/\` in application code

---

## Testing During Implementation

### DO

- **DO** write tests alongside implementation — every PR must include tests for new service functions and endpoints
- **DO** use \`factory_boy\` factories defined in \`tests/factories.py\` per app — never use fixtures or raw \`Model.objects.create()\` in tests
- **DO** test tenant isolation explicitly: create data for Tenant A, authenticate as Tenant B, assert 404 or empty results
- **DO** mock Stripe API calls using \`responses\` or \`unittest.mock.patch\` — never hit Stripe in unit tests
- **DO** test Celery tasks synchronously using \`CELERY_ALWAYS_EAGER=True\` in test settings
- **DO** assert on specific status codes, response structure, and database state — not just "no error"

### DON'T

- **DON'T** use \`TestCase\` — use \`pytest\` with \`pytest-django\` and \`@pytest.mark.django_db\`
- **DON'T** share mutable state between tests — each test gets its own tenant, user, and data via factories
- **DON'T** test Django internals (ORM, auth) — test your business logic and API contracts
- **DON'T** skip writing tests for "simple" CRUD — tenant scoping bugs hide in simple endpoints

---

## GDPR Compliance in Implementation

### DO

- **DO** implement \`accounts/services.py:delete_user_data(user, tenant)\` that cascades deletion per GDPR right-to-erasure
- **DO** anonymize PII in audit logs when a user exercises right-to-deletion — replace with \`"[REDACTED]"\`
- **DO** record consent timestamps and purposes in \`accounts.Consent\` model
- **DO** support data export via \`accounts/services.py:export_user_data(user, tenant)\` returning a structured JSON archive
- **DO** respect data residency requirements — store tenant region in \`tenants.Tenant.data_region\` and route queries accordingly

### DON'T

- **DON'T** log PII (email, name, IP) in application logs without a documented retention policy
- **DON'T** send PII to third-party services without checking the tenant's DPA status
- **DON'T** retain soft-deleted user data beyond the configured retention period (default: 30 days)

---

## Performance Rules

### DO

- **DO** cache tenant configuration and plan details in Redis with a 5-minute TTL: \`cache.get_or_set(f"tenant:{tenant_id}:config", ...)\`
- **DO** use \`django.db.models.Prefetch\` objects for complex prefetch scenarios
- **DO** paginate all list endpoints — default page size 25, max 100
- **DO** use database-level aggregation (\`annotate\`, \`aggregate\`) instead of Python-level loops for counts and sums

### DON'T

- **DON'T** cache user-specific or permission-sensitive data without tenant-scoped cache keys
- **DON'T** load all records into memory — use \`.iterator()\` for large querysets in tasks
- **DON'T** make synchronous HTTP calls to external services in request/response cycle — use Celery tasks
- **DON'T** use \`len(queryset)\` — use \`queryset.count()\` or \`queryset.exists()\``,

  'playbook/claude-overrides/05-integration-hardening.claude.md': `# Phase 05: Integration & Hardening — Claude Override Rules

## Phase Context

Phase 05 focuses on integrating external services (Stripe, AWS SES, Redis, third-party webhooks), hardening security posture for SOC 2 and GDPR compliance, and ensuring multi-tenant data isolation is airtight. This is the phase where the system transitions from "works in development" to "safe for production."

---

## DO Rules

### Stripe Integration

- **DO** verify every Stripe webhook signature using \`stripe.Webhook.construct_event()\` before processing any payload
- **DO** store the Stripe \`idempotency_key\` on every webhook event record and check for duplicates before processing
- **DO** implement all Stripe webhook handlers as idempotent operations — processing the same event twice must produce the same result
- **DO** use Stripe's test clock API in integration tests to simulate subscription lifecycle events (trial end, renewal, payment failure)
- **DO** map Stripe subscription statuses (\`active\`, \`past_due\`, \`canceled\`, \`unpaid\`) to internal tenant plan states with explicit handling for each transition
- **DO** store raw Stripe event payloads in an audit table (\`billing.StripeEvent\`) for debugging and compliance
- **DO** handle \`customer.subscription.updated\`, \`customer.subscription.deleted\`, \`invoice.payment_succeeded\`, \`invoice.payment_failed\`, and \`checkout.session.completed\` at minimum
- **DO** use Stripe's usage record API for metered billing and batch-report usage via a scheduled Celery task (\`tasks.sync_usage_to_stripe\`)
- **DO** implement a Stripe webhook replay mechanism for disaster recovery

\`\`\`python
# DO: Idempotent webhook processing pattern
from billing.models import StripeEvent

def handle_webhook(payload: dict, sig_header: str) -> None:
    event = stripe.Webhook.construct_event(payload, sig_header, settings.STRIPE_WEBHOOK_SECRET)

    if StripeEvent.objects.filter(stripe_event_id=event.id).exists():
        logger.info("Duplicate Stripe event %s, skipping", event.id)
        return

    StripeEvent.objects.create(
        stripe_event_id=event.id,
        event_type=event.type,
        payload=event.to_dict(),
        tenant=resolve_tenant_from_event(event),
    )

    handler = WEBHOOK_HANDLERS.get(event.type)
    if handler:
        handler(event)
\`\`\`

### Celery Task Hardening

- **DO** make every Celery task idempotent — use database-level deduplication keys or check-before-write patterns
- **DO** set explicit \`max_retries\`, \`default_retry_delay\`, and \`retry_backoff\` on all tasks
- **DO** use \`acks_late=True\` and \`reject_on_worker_lost=True\` for critical tasks (billing sync, webhook dispatch)
- **DO** bind tenant context to every task using a custom base class that sets the tenant on the thread-local or context var
- **DO** add structured logging with \`tenant_id\`, \`task_id\`, and \`correlation_id\` to every task execution
- **DO** use Celery beat for scheduled tasks and define the schedule in \`config/celery.py\`, not in individual task files
- **DO** set task time limits (\`soft_time_limit\`, \`time_limit\`) to prevent runaway tasks

\`\`\`python
# DO: Tenant-aware idempotent task pattern
from core.tasks import TenantTask

@shared_task(
    base=TenantTask,
    bind=True,
    max_retries=3,
    default_retry_delay=60,
    retry_backoff=True,
    acks_late=True,
    reject_on_worker_lost=True,
    soft_time_limit=300,
    time_limit=360,
)
def sync_subscription_status(self, tenant_id: str, subscription_id: str) -> None:
    """Sync Stripe subscription status to local database."""
    ...
\`\`\`

### Multi-Tenant Data Isolation Hardening

- **DO** verify that every queryset in every view, serializer, and task filters by the current tenant — add integration tests that attempt cross-tenant access
- **DO** use PostgreSQL row-level security (RLS) policies as a defense-in-depth layer beneath the Django ORM tenant filtering
- **DO** write explicit integration tests that create data for Tenant A and assert Tenant B cannot read, update, or delete it
- **DO** audit all raw SQL queries and \`extra()\` / \`RawQuerySet\` usage to ensure tenant filtering is applied
- **DO** ensure Django admin access is scoped — superusers see all, staff users see only their tenant's data
- **DO** validate tenant context in Celery tasks — never trust task arguments alone; re-resolve tenant from the database

\`\`\`python
# DO: Cross-tenant isolation test
@pytest.mark.django_db
class TestTenantIsolation:
    def test_tenant_a_cannot_access_tenant_b_data(
        self, tenant_a_client: APIClient, tenant_b_project: Project
    ) -> None:
        response = tenant_a_client.get(f"/api/v1/projects/{tenant_b_project.id}/")
        assert response.status_code == 404  # Not 403 — don't leak existence
\`\`\`

### Security Hardening

- **DO** run \`uv run bandit -r src/\` and \`uv run safety check\` in CI and fix all high/critical findings before merge
- **DO** enable Django's \`SecurityMiddleware\` with \`SECURE_HSTS_SECONDS\`, \`SECURE_SSL_REDIRECT\`, \`SECURE_CONTENT_TYPE_NOSNIFF\`, \`SESSION_COOKIE_SECURE\`, \`CSRF_COOKIE_SECURE\` in production settings
- **DO** implement rate limiting on authentication endpoints, Stripe webhook endpoint, and public API endpoints using \`django-ratelimit\` or middleware
- **DO** add CORS configuration via \`django-cors-headers\` with an explicit allowlist — never use \`CORS_ALLOW_ALL_ORIGINS = True\` in staging or production
- **DO** rotate secrets (Django \`SECRET_KEY\`, Stripe API keys, database credentials) via AWS Secrets Manager and reference them through \`django-environ\`
- **DO** implement Content Security Policy headers for any server-rendered pages (admin, email previews)
- **DO** add audit logging for all authentication events, permission changes, billing mutations, and data exports using \`core.audit.log_event()\`
- **DO** ensure all PII fields are encrypted at rest using \`django-encrypted-model-fields\` or equivalent, and document which fields contain PII

### Observability Integration

- **DO** configure Sentry with \`traces_sample_rate\` appropriate for the environment (1.0 dev, 0.2 staging, 0.1 production)
- **DO** add \`tenant_id\` and \`user_id\` as Sentry tags on every request via middleware
- **DO** expose Prometheus metrics at \`/metrics\` (guarded by internal network only) for request latency, Celery queue depth, Stripe webhook processing time, and cache hit rates
- **DO** add structured JSON logging with \`structlog\` including \`tenant_id\`, \`request_id\`, \`user_id\`, and \`correlation_id\` on every log line
- **DO** create Grafana dashboards for: subscription MRR, webhook processing lag, task queue depth, error rates by tenant, and API latency percentiles
- **DO** set up alerting for: Stripe webhook failures > 5 in 5 minutes, Celery queue depth > 1000, API error rate > 5%, certificate expiry < 14 days

### Redis Integration

- **DO** use separate Redis databases (or key prefixes) for cache, sessions, and Celery broker to allow independent flushing
- **DO** set TTLs on all cache keys — never cache without expiration
- **DO** use \`django-redis\` with connection pooling and configure \`SOCKET_CONNECT_TIMEOUT\` and \`SOCKET_TIMEOUT\`
- **DO** implement cache invalidation on tenant data mutations — stale tenant config is a security risk

### AWS Service Integration

- **DO** use IAM roles (ECS task roles) instead of access keys for AWS service access
- **DO** configure S3 bucket policies with tenant-prefixed paths and ensure no public access
- **DO** use SES with verified domains and configure bounce/complaint handling via SNS
- **DO** enable CloudFront signed URLs for tenant-specific static assets if white-labeling is active

### GDPR Compliance Hardening

- **DO** implement a \`DELETE /api/v1/accounts/me/\` endpoint that triggers full data deletion (right to erasure) including Stripe customer data
- **DO** add data export functionality (\`GET /api/v1/accounts/me/export/\`) that returns all user PII in a machine-readable format (right to portability)
- **DO** log all consent grants and withdrawals with timestamps in an immutable audit table
- **DO** implement data retention policies as Celery beat tasks that purge expired data according to the retention schedule
- **DO** ensure all cross-border data transfers are documented and covered by appropriate DPAs

---

## DON'T Rules

### Stripe Integration

- **DON'T** process Stripe webhooks without verifying the signature — this is a critical security vulnerability
- **DON'T** store full credit card numbers, CVVs, or raw payment method details anywhere in the database — Stripe handles PCI compliance
- **DON'T** call Stripe APIs synchronously in request/response cycles for operations that can be deferred — use Celery tasks for subscription creation, invoice generation, and usage reporting
- **DON'T** hardcode Stripe API keys or webhook secrets — always load from environment variables via \`django-environ\`
- **DON'T** assume webhook events arrive in order — Stripe does not guarantee ordering; use \`event.created\` timestamps and idempotency checks
- **DON'T** ignore Stripe webhook event types you don't handle — log them for future debugging

\`\`\`python
# DON'T: Synchronous Stripe call in a view
class CreateSubscriptionView(APIView):
    def post(self, request):
        # DON'T do this — Stripe API calls can be slow and fail
        subscription = stripe.Subscription.create(...)
        return Response({"id": subscription.id})

# DO: Dispatch to Celery
class CreateSubscriptionView(APIView):
    def post(self, request):
        task = create_stripe_subscription.delay(
            tenant_id=request.tenant.id,
            plan_id=request.data["plan_id"],
        )
        return Response({"task_id": task.id}, status=202)
\`\`\`

### Celery Tasks

- **DON'T** pass Django model instances as Celery task arguments — pass IDs and re-fetch from the database inside the task
- **DON'T** create tasks without \`max_retries\` — unbounded retries can cause infinite loops
- **DON'T** use \`task.delay()\` inside a database transaction — the task may execute before the transaction commits; use \`transaction.on_commit()\`
- **DON'T** log sensitive data (API keys, tokens, PII) in task logs
- **DON'T** run long-running tasks without \`soft_time_limit\` — a stuck task blocks the worker

\`\`\`python
# DON'T: Pass model instance to task
send_invoice_email.delay(invoice=invoice_obj)  # Will fail on serialization

# DO: Pass ID and re-fetch
send_invoice_email.delay(invoice_id=invoice_obj.id)

# DON'T: Dispatch task inside transaction
with transaction.atomic():
    order.save()
    process_order.delay(order_id=order.id)  # May run before commit

# DO: Use on_commit
with transaction.atomic():
    order.save()
    transaction.on_commit(lambda: process_order.delay(order_id=order.id))
\`\`\`

### Multi-Tenant Security

- **DON'T** use \`.objects.all()\` without tenant filtering in any view, serializer, or task — always use the tenant-aware manager
- **DON'T** return 403 for cross-tenant access attempts — return 404 to avoid leaking resource existence
- **DON'T** trust tenant identification from request headers alone in production — validate against authenticated user's tenant association
- **DON'T** share Redis cache keys across tenants without tenant-prefixed namespacing
- **DON'T** allow tenant admins to modify their own subscription tier directly — all plan changes must go through the billing service layer with Stripe as the source of truth
- **DON'T** use Django signals for cross-tenant operations — the implicit nature of signals makes tenant context bugs hard to detect

\`\`\`python
# DON'T: Unscoped query
projects = Project.objects.all()

# DO: Tenant-scoped query
projects = Project.objects.for_tenant(request.tenant)

# DON'T: Leak existence
if not project.tenant == request.tenant:
    raise PermissionDenied("Not your project")  # Confirms it exists

# DO: Return 404
project = get_object_or_404(
    Project.objects.for_tenant(request.tenant), pk=project_id
)
\`\`\`

### Security

- **DON'T** set \`CORS_ALLOW_ALL_ORIGINS = True\` in any non-local environment
- **DON'T** disable CSRF protection on any endpoint that accepts session-authenticated requests
- **DON'T** log full request/response bodies on billing or authentication endpoints — they may contain tokens or PII
- **DON'T** use \`DEBUG = True\` in staging or production — this leaks stack traces, settings, and SQL queries
- **DON'T** store secrets in \`settings.py\`, \`docker-compose.yml\`, or any file committed to version control
- **DON'T** use \`pickle\` as the Celery serializer — use \`json\` to prevent remote code execution
- **DON'T** expose the \`/metrics\` endpoint publicly — restrict to internal network via middleware or ingress rules
- **DON'T** skip security headers (\`X-Frame-Options\`, \`X-Content-Type-Options\`, \`Strict-Transport-Security\`) in production

### Observability

- **DON'T** use \`print()\` for logging — use \`structlog\` or \`logging\` with structured output
- **DON'T** log at \`DEBUG\` level in production — it generates excessive volume and may contain sensitive data
- **DON'T** create alerts without runbooks — every alert must link to a \`docs/runbooks/\` entry describing diagnosis and remediation steps
- **DON'T** sample Sentry transactions at 100% in production — it will exceed quotas and degrade performance

### Redis / Caching

- **DON'T** cache tenant-specific data without including \`tenant_id\` in the cache key
- **DON'T** cache authentication or authorization decisions — always evaluate permissions live
- **DON'T** use Redis \`KEYS *\` in production — it blocks the event loop; use \`SCAN\` instead
- **DON'T** store large objects (>1MB) in Redis cache — use S3 with signed URLs instead

### GDPR / Compliance

- **DON'T** retain user PII beyond the documented retention period without explicit consent
- **DON'T** export or transfer tenant data without audit logging the event
- **DON'T** implement data deletion as a soft-delete only — GDPR right to erasure requires actual removal of PII (anonymize or hard-delete)
- **DON'T** store IP addresses or user-agent strings without documenting the legal basis and retention period
- **DON'T** send marketing emails without verifiable opt-in consent stored in the consent audit table

---

## Integration Testing Checklist

Before completing Phase 05, verify these integration tests exist and pass:

\`\`\`bash
# Run the full integration test suite
uv run pytest tests/integration/ -v --tb=short

# Stripe webhook integration tests
uv run pytest tests/integration/billing/test_stripe_webhooks.py -v

# Cross-tenant isolation tests
uv run pytest tests/integration/tenants/test_isolation.py -v

# Celery task idempotency tests
uv run pytest tests/integration/tasks/test_idempotency.py -v

# Security header verification
uv run pytest tests/integration/security/test_headers.py -v

# GDPR endpoint tests (export, deletion)
uv run pytest tests/integration/accounts/test_gdpr.py -v
\`\`\`

## Security Scan Gate

\`\`\`bash
# Must pass before Phase 05 sign-off
uv run ruff check src/
uv run mypy src/ --strict
uv run bandit -r src/ -ll
uv run safety check
uv run python manage.py check --deploy --settings=config.settings.production
\`\`\`

## Cross-References

- Phase 04 (Core Implementation): \`playbook/phases/04-core-implementation.md\` — service layer patterns used here
- Phase 06 (Testing & Quality): \`playbook/phases/06-testing-quality.md\` — integration test standards
- Security hardening prompt: \`playbook/prompts/05/security-hardening.md\`
- Observability setup prompt: \`playbook/prompts/05/observability-setup.md\`
- Integration adapter prompt: \`playbook/prompts/05/integration-adapter.md\`
- Sensitive paths requiring CODEOWNERS review: \`**/billing/**\`, \`**/auth/**\`, \`config/production/**\``,

  'playbook/claude-overrides/06-testing-quality.claude.md': `# Phase 06: Testing & Quality — Claude Override Rules

## Phase Context

You are working on testing and quality assurance for a multi-tenant Django SaaS platform. This phase covers unit tests, integration tests, end-to-end tests, load tests, and quality gates. The stack includes Django 5.0, DRF, Strawberry GraphQL, Celery, Stripe, PostgreSQL with row-level security, and Redis.

---

## DO — Required Practices

### Test Structure & Organization

- DO mirror the \`src/\` directory structure under \`tests/\` — e.g., \`tests/billing/test_subscription_service.py\` maps to \`src/billing/services/subscription_service.py\`
- DO use \`factory_boy\` for all test fixtures — define factories in \`tests/<app>/factories.py\`
- DO create a \`TenantFactory\`, \`UserFactory\`, \`SubscriptionFactory\`, and \`PlanFactory\` as foundational factories that other factories compose
- DO use \`pytest\` markers to categorize tests: \`@pytest.mark.unit\`, \`@pytest.mark.integration\`, \`@pytest.mark.e2e\`, \`@pytest.mark.slow\`
- DO use \`conftest.py\` at each test directory level for shared fixtures — tenant-scoped fixtures belong in \`tests/conftest.py\`
- DO keep each test file under 300 lines — split into multiple files by concern (e.g., \`test_subscription_create.py\`, \`test_subscription_cancel.py\`)

### Tenant Isolation Testing

- DO write explicit tests that verify tenant A cannot access tenant B's data through every data access path (ORM, API, GraphQL, Celery tasks)
- DO test that the \`TenantAwareManager\` filters querysets correctly by creating data for two tenants and asserting only the active tenant's data is returned
- DO test row-level security policies directly with raw SQL to confirm PostgreSQL enforces isolation independent of Django ORM
- DO test that switching tenant context mid-request does not leak data from the previous tenant
- DO include a dedicated \`tests/tenants/test_isolation.py\` that serves as the canonical tenant isolation test suite
- DO test that superuser/admin queries still respect tenant boundaries unless explicitly using \`unscoped()\` or equivalent

### Billing & Stripe Testing

- DO use \`stripe-mock\` or \`vcrpy\` cassettes for Stripe API interactions — never call live Stripe APIs in CI
- DO test the complete subscription lifecycle: create → activate → invoice → renew → cancel → expire
- DO test Stripe webhook handlers with realistic payloads from Stripe's event catalog — include \`invoice.payment_succeeded\`, \`invoice.payment_failed\`, \`customer.subscription.updated\`, \`customer.subscription.deleted\`, \`checkout.session.completed\`
- DO verify webhook idempotency by sending the same event twice and asserting no duplicate side effects (no double credits, no duplicate emails)
- DO test webhook signature verification with both valid and invalid signatures
- DO test usage-based metering: record usage → aggregate → report to Stripe → verify invoice line items
- DO test subscription plan changes (upgrades, downgrades) including proration calculations
- DO test dunning flows: failed payment → retry → grace period → suspension → cancellation

### Celery Task Testing

- DO use \`celery.contrib.pytest\` fixtures and \`CELERY_ALWAYS_EAGER = True\` for unit tests
- DO test task idempotency by calling the same task with the same arguments multiple times and verifying the outcome is identical
- DO test task retry behavior by mocking transient failures and asserting the task retries with correct backoff
- DO test that tasks correctly propagate tenant context — a task enqueued by tenant A must execute in tenant A's context
- DO test Celery beat scheduled tasks have correct crontab/interval configurations
- DO test task error handling: verify failed tasks log to Sentry, update task status, and don't leave data in inconsistent states
- DO write integration tests that run tasks synchronously against a real PostgreSQL database

### API Testing

- DO test every DRF endpoint with \`APIClient\` — cover authentication, authorization, validation, pagination, and filtering
- DO test GraphQL queries and mutations with Strawberry's test client — verify both successful responses and error states
- DO test API permission boundaries: unauthenticated, authenticated-wrong-tenant, authenticated-wrong-role, authenticated-correct-role
- DO verify all API responses match the OpenAPI schema generated by \`drf-spectacular\` — use schema validation in tests
- DO test rate limiting by sending requests beyond the configured threshold and asserting \`429\` responses
- DO test API versioning if applicable — ensure deprecated endpoints return appropriate warnings

### Authentication & Authorization Testing

- DO test the full authentication flow: registration → email verification → login → token refresh → logout
- DO test role-based access control for every role: \`owner\`, \`admin\`, \`member\`, \`viewer\` (or your defined roles)
- DO test permission escalation attempts — a \`member\` trying to perform \`admin\` actions must receive \`403\`
- DO test that JWT/session tokens are properly scoped to a tenant
- DO test account lockout after failed login attempts
- DO test password reset flow end-to-end

### Data Privacy & Compliance Testing (GDPR / SOC 2)

- DO write tests for the right-to-deletion endpoint — verify all PII is removed or anonymized across all tables
- DO test data export (GDPR data portability) — verify the export contains all user data in a machine-readable format
- DO test audit log completeness — every create, update, delete on sensitive models must produce an audit entry with actor, timestamp, tenant, and diff
- DO test that audit logs are immutable — attempts to modify or delete audit records must fail
- DO test consent tracking — verify that features gated behind consent are inaccessible without recorded consent

### Database & Migration Testing

- DO test that all migrations are reversible — run \`migrate\` forward and backward in CI
- DO test that migrations don't cause downtime — no \`ALTER TABLE\` that locks large tables without \`CONCURRENTLY\`
- DO test database constraints: unique constraints, foreign keys, check constraints, and custom validators
- DO test that \`select_related\` and \`prefetch_related\` are used correctly by asserting query counts with \`django.test.utils.override_settings(DEBUG=True)\` and \`assertNumQueries\`

### Coverage & Quality Gates

- DO enforce 85% overall test coverage with \`pytest-cov\` — fail CI if coverage drops below threshold
- DO enforce 95% coverage on \`src/billing/\` and \`src/tenants/\` — these are critical paths
- DO generate coverage reports in both terminal and HTML formats for local debugging
- DO track coverage trends — flag PRs that decrease coverage by more than 1%

### Performance & Load Testing

- DO write load tests with \`locust\` or \`k6\` targeting key API endpoints: login, tenant dashboard, subscription create, webhook ingestion
- DO establish baseline response time budgets: p50 < 200ms, p95 < 500ms, p99 < 1000ms for API endpoints
- DO test concurrent tenant operations — simulate 50+ tenants making simultaneous requests to verify no cross-tenant data leakage under load
- DO test Celery task throughput — verify the worker can process the expected volume of tasks within SLA
- DO include database query count assertions in critical path tests using \`assertNumQueries\` or \`pytest-django\`'s \`django_assert_num_queries\`

---

## DON'T — Prohibited Practices

### Test Anti-Patterns

- DON'T use Django's \`TestCase\` — use \`pytest\` with \`pytest-django\` exclusively for consistency
- DON'T use \`fixtures/\` JSON files for test data — use \`factory_boy\` factories; JSON fixtures are brittle and hard to maintain
- DON'T create test data with \`Model.objects.create()\` directly — always use factories to ensure required fields and relationships are populated
- DON'T write tests that depend on execution order — every test must be independently runnable
- DON'T use \`time.sleep()\` in tests — use \`freezegun\` or \`time_machine\` for time-dependent logic, and proper async waiting for async operations
- DON'T use \`unittest.mock.patch\` on the class under test — mock external dependencies (Stripe, Redis, email), not the code being tested
- DON'T write tests that pass when the feature is broken — every test must fail if you comment out the implementation

### Tenant Isolation Anti-Patterns

- DON'T write tests that only create data for a single tenant — always create data for at least two tenants to verify isolation
- DON'T use \`Model.objects.all()\` in tests without asserting tenant filtering — this masks isolation bugs
- DON'T skip tenant context setup in test fixtures — every test that touches tenant-scoped data must set the active tenant
- DON'T test tenant isolation only at the API layer — also test at the ORM layer, task layer, and raw SQL layer

### Billing Test Anti-Patterns

- DON'T call real Stripe APIs in any test environment — use \`stripe-mock\`, \`vcrpy\`, or hand-crafted mock responses
- DON'T hardcode Stripe price IDs, product IDs, or customer IDs in tests — use factories or constants defined in \`tests/billing/constants.py\`
- DON'T test only the happy path for billing — failed payments, expired cards, disputed charges, and webhook retries are where bugs hide
- DON'T ignore webhook ordering — test that webhooks arriving out of order (e.g., \`invoice.paid\` before \`subscription.created\`) are handled gracefully
- DON'T mock the entire Stripe client — mock at the HTTP level so serialization/deserialization logic is also tested

### Celery Test Anti-Patterns

- DON'T test Celery tasks by calling the function directly without the Celery machinery — use \`.apply()\` or \`CELERY_ALWAYS_EAGER\` to exercise serialization and task routing
- DON'T ignore task serialization — if a task receives a Django model instance, it must accept the ID and re-fetch from the database
- DON'T write tasks that silently swallow exceptions — tests must verify that failures are logged and surfaced
- DON'T skip testing task chains, groups, or chords if you use them — composition bugs are common

### Coverage Anti-Patterns

- DON'T pad coverage with trivial tests (testing that a constant equals itself, testing \`__str__\` methods without business logic)
- DON'T exclude files from coverage measurement without documenting the reason in \`pyproject.toml\`
- DON'T count integration test coverage toward the unit test coverage threshold — track them separately
- DON'T use \`# pragma: no cover\` on business logic — only on genuinely unreachable code (e.g., \`TYPE_CHECKING\` blocks, abstract methods)

### Security Test Anti-Patterns

- DON'T commit real API keys, tokens, or secrets in test fixtures — use obviously fake values like \`sk_test_fake_key_for_testing\`
- DON'T skip authentication/authorization tests because "the middleware handles it" — test at every layer
- DON'T write tests that run as superuser by default — test with the least-privileged role first, then escalate
- DON'T ignore SQL injection vectors — test that raw query parameters are properly parameterized

### Performance Test Anti-Patterns

- DON'T run load tests against shared staging environments without coordination — use dedicated load test environments
- DON'T write load tests without assertions — a load test that doesn't check response codes and latency is just traffic generation
- DON'T ignore N+1 query problems — use \`django-debug-toolbar\` or \`nplusone\` in development and \`assertNumQueries\` in tests

---

## Test Configuration Reference

### pytest configuration (\`pyproject.toml\`)

\`\`\`toml
[tool.pytest.ini_options]
DJANGO_SETTINGS_MODULE = "config.settings.test"
python_files = ["test_*.py"]
python_classes = ["Test*"]
python_functions = ["test_*"]
addopts = [
    "--strict-markers",
    "--strict-config",
    "-ra",
    "--cov=src",
    "--cov-branch",
    "--cov-report=term-missing:skip-covered",
    "--cov-fail-under=85",
]
markers = [
    "unit: Unit tests (no external dependencies)",
    "integration: Integration tests (database, Redis)",
    "e2e: End-to-end tests (full stack)",
    "slow: Tests that take >5 seconds",
    "billing: Stripe billing tests",
    "tenant: Tenant isolation tests",
]
filterwarnings = [
    "error",
    "ignore::DeprecationWarning:strawberry.*",
]
\`\`\`

### Factory pattern example

\`\`\`python
# tests/tenants/factories.py
import factory
from src.tenants.models import Tenant

class TenantFactory(factory.django.DjangoModelFactory):
    class Meta:
        model = Tenant

    name = factory.Sequence(lambda n: f"Tenant {n}")
    slug = factory.Sequence(lambda n: f"tenant-{n}")
    is_active = True
    plan = factory.SubFactory("tests.billing.factories.PlanFactory")
\`\`\`

### Conftest pattern for tenant-scoped tests

\`\`\`python
# tests/conftest.py
import pytest
from tests.tenants.factories import TenantFactory
from tests.accounts.factories import UserFactory

@pytest.fixture
def tenant(db):
    return TenantFactory()

@pytest.fixture
def other_tenant(db):
    return TenantFactory()

@pytest.fixture
def tenant_user(tenant):
    return UserFactory(tenant=tenant)

@pytest.fixture
def tenant_client(tenant_user, client):
    client.force_login(tenant_user)
    return client
\`\`\`

---

## CI Commands Reference

\`\`\`bash
# Unit tests only
uv run pytest -m unit --cov=src --cov-fail-under=85

# Integration tests
uv run pytest -m integration

# Tenant isolation tests
uv run pytest -m tenant -v

# Billing tests
uv run pytest -m billing -v

# Full test suite with coverage
uv run pytest --cov=src --cov-branch --cov-report=html

# Specific app tests
uv run pytest tests/billing/ -v
uv run pytest tests/tenants/ -v --cov=src/tenants --cov-fail-under=95

# Type checking
uv run mypy src/ --strict

# Linting
uv run ruff check src/ tests/
uv run ruff format --check src/ tests/

# Migration check
uv run python manage.py migrate --check --dry-run
uv run python manage.py makemigrations --check --dry-run
\`\`\``,

  'playbook/claude-overrides/07-launch.claude.md': `# Phase 07: Launch & Operations — Claude Override Rules

## Purpose

Behavioral constraints for Claude during production launch, operational readiness, and ongoing operations of the Django SaaS platform. This phase carries the highest risk — mistakes affect real tenants, real billing, and real data subject to SOC 2 and GDPR obligations.

---

## DO

### Production Deployment

- DO verify all Django deployment checks pass before any launch task: \`uv run python manage.py check --deploy --settings=config.settings.production\`
- DO confirm \`DEBUG = False\`, \`ALLOWED_HOSTS\` is explicit, \`SECURE_SSL_REDIRECT = True\`, \`SECURE_HSTS_SECONDS >= 31536000\`, \`SESSION_COOKIE_SECURE = True\`, \`CSRF_COOKIE_SECURE = True\` in production settings
- DO ensure \`SECRET_KEY\` is loaded from AWS Secrets Manager or environment — never hardcoded or committed
- DO verify database connection pooling is configured (PgBouncer or \`django-db-connection-pool\`) for ECS task scaling
- DO confirm PostgreSQL row-level security policies are active on all tenant-scoped tables in the production database
- DO ensure Django migrations are backward-compatible so rolling deployments don't break the running version
- DO use \`uv run python manage.py migrate --plan\` to preview migrations before applying to production
- DO verify Redis is configured with \`maxmemory-policy allkeys-lru\` and TLS enabled for ElastiCache connections
- DO confirm Celery workers start with \`--without-heartbeat --without-mingle --without-gossip\` in production for ECS compatibility
- DO ensure Celery beat scheduler uses \`django-celery-beat\` with database backend so only one beat instance runs across ECS tasks

### Stripe & Billing Launch

- DO verify Stripe webhook endpoint (\`/billing/webhooks/stripe/\`) is registered in the Stripe Dashboard for production mode
- DO confirm webhook signature verification uses \`STRIPE_WEBHOOK_SECRET\` from production environment
- DO validate that all critical Stripe events are handled: \`customer.subscription.created\`, \`customer.subscription.updated\`, \`customer.subscription.deleted\`, \`invoice.payment_succeeded\`, \`invoice.payment_failed\`, \`checkout.session.completed\`
- DO ensure Stripe webhook handlers are idempotent — use \`StripeEvent.objects.get_or_create(stripe_event_id=event.id)\` to deduplicate
- DO verify subscription plan IDs in the database match Stripe product/price IDs in production
- DO confirm usage metering records are flushed to Stripe via \`stripe.SubscriptionItem.create_usage_record\` before billing cycle ends
- DO test the full subscription lifecycle in Stripe production test mode before enabling live payments
- DO ensure failed payment retry logic follows Stripe's Smart Retries configuration

### Monitoring & Observability

- DO configure Sentry with \`traces_sample_rate\` appropriate for production load (start at 0.1, adjust based on volume)
- DO set Sentry environment to \`production\` and tag all events with \`tenant_id\` for filtering
- DO ensure Prometheus metrics are exposed at \`/metrics/\` behind internal-only ingress (not public)
- DO configure Grafana dashboards for: request latency (p50/p95/p99), error rate by tenant, Celery queue depth, active subscriptions, webhook processing lag
- DO set up PagerDuty or Slack alerts for: 5xx rate > 1%, Celery queue depth > 1000, webhook processing delay > 5 minutes, subscription sync failures
- DO verify structured logging (JSON format) is configured with \`tenant_id\`, \`user_id\`, \`request_id\`, and \`correlation_id\` in every log line
- DO ensure health check endpoints exist: \`/health/\` (Django app), \`/health/db/\` (PostgreSQL), \`/health/redis/\` (Redis), \`/health/celery/\` (worker ping)
- DO configure log aggregation to CloudWatch Logs with appropriate retention (90 days minimum for SOC 2)

### Tenant Operations

- DO verify tenant onboarding flow works end-to-end: signup → tenant creation → Stripe customer creation → subscription checkout → provisioning
- DO ensure tenant isolation is validated with an integration test that attempts cross-tenant data access and confirms denial
- DO confirm tenant-aware cache keys include \`tenant_{tenant_id}\` prefix to prevent cache poisoning across tenants
- DO verify tenant deletion/offboarding triggers: Stripe subscription cancellation, data export (GDPR), scheduled data purge, audit log entry
- DO ensure white-label configuration (custom domain, branding) is loaded per-tenant via middleware and cached in Redis

### Security & Compliance

- DO verify CORS settings in production are restricted to known tenant domains — no wildcards
- DO confirm rate limiting is active on authentication endpoints (\`/api/auth/login/\`, \`/api/auth/token/\`) via \`django-ratelimit\` or API gateway
- DO ensure audit logging captures all write operations on sensitive models (User, Tenant, Subscription, Permission) with actor, timestamp, tenant, and IP
- DO verify that GDPR data export (\`/api/accounts/me/export/\`) returns all personal data within the 30-day compliance window
- DO confirm data residency requirements are enforced — EU tenant data stays in \`eu-west-1\` RDS instance if applicable
- DO ensure all API authentication tokens (JWT) have reasonable expiry: access token ≤ 15 minutes, refresh token ≤ 7 days
- DO verify that \`django-csp\` Content-Security-Policy headers are configured and report-only mode is disabled for production

### Runbooks & Documentation

- DO generate runbooks for: database failover, Celery worker restart, Stripe webhook replay, tenant data export, emergency tenant suspension, cache flush, rollback deployment
- DO include exact commands in runbooks — not vague instructions (e.g., \`aws ecs update-service --cluster saas-prod --service web --force-new-deployment\`)
- DO document the on-call escalation path and include Slack channel references
- DO maintain an incident response template in \`docs/runbooks/incident-template.md\`

### Go-Live Checklist

- DO verify DNS and SSL certificates are provisioned and auto-renewing via ACM
- DO confirm CDN (CloudFront) is configured for static assets with appropriate cache headers
- DO run \`uv run python manage.py collectstatic --noinput\` as part of the Docker image build, not at runtime
- DO verify database backups are configured with point-in-time recovery enabled (RDS automated backups, 35-day retention)
- DO perform a load test against staging that simulates expected launch traffic before cutting over
- DO ensure feature flags are in place for gradual rollout of billing and tenant features

---

## DON'T

### Production Safety

- DON'T ever run \`migrate\` commands directly in production without \`--plan\` review first
- DON'T use \`--run-syncdb\` in production — all schema changes must go through migrations
- DON'T set \`DEBUG = True\` or \`TEMPLATE_DEBUG = True\` in any production or staging configuration
- DON'T use \`*\` in \`ALLOWED_HOSTS\` or \`CORS_ALLOWED_ORIGINS\` in production
- DON'T use SQLite or in-memory databases in production or staging — PostgreSQL only
- DON'T deploy database migrations and application code in the same step if the migration is not backward-compatible
- DON'T use \`flush\`, \`reset_db\`, or \`loaddata\` management commands against production databases
- DON'T store secrets in \`config/production/settings.py\` — use environment variables or AWS Secrets Manager exclusively

### Billing & Stripe

- DON'T process Stripe webhooks without verifying the signature via \`stripe.Webhook.construct_event()\`
- DON'T assume webhook events arrive in order — always fetch the latest object state from Stripe API when handling events
- DON'T store full credit card numbers or CVVs anywhere in the application — Stripe handles PCI compliance
- DON'T retry failed Stripe API calls without exponential backoff and a maximum retry count
- DON'T modify subscription state in the local database without confirming the change succeeded in Stripe first
- DON'T hardcode Stripe price IDs — store them in the database or environment configuration
- DON'T skip handling \`invoice.payment_failed\` — this must trigger dunning notifications and potential service degradation
- DON'T create Stripe customers without associating them with a tenant — orphaned Stripe customers cause billing reconciliation nightmares

### Multi-Tenancy

- DON'T bypass the tenant-aware manager (\`TenantManager\`) for any query on tenant-scoped models — even in management commands
- DON'T use raw SQL queries without including the \`tenant_id\` filter — this bypasses Django's tenant isolation
- DON'T cache tenant data without tenant-scoped cache keys — this causes data leakage between tenants (SOC 2 violation)
- DON'T allow tenant admins to access other tenants' data through API parameter manipulation (IDOR) — enforce tenant context from middleware, not request params
- DON'T log tenant-specific PII (emails, names, billing details) in plain text — mask or omit from logs
- DON'T share Celery task queues across tenants without including \`tenant_id\` in the task payload and validating it in the worker

### Monitoring & Incident Response

- DON'T expose \`/metrics/\`, \`/health/db/\`, or \`/health/redis/\` endpoints publicly — restrict to internal network or VPN
- DON'T set Sentry \`traces_sample_rate = 1.0\` in production — this generates excessive volume and cost
- DON'T ignore Celery task failures — configure \`task_acks_late = True\` and \`task_reject_on_worker_lost = True\` so failed tasks are retried
- DON'T silence Django's \`LOGGING\` configuration in production — ensure at minimum \`WARNING\` level for all loggers and \`INFO\` for application loggers
- DON'T create alerts without a corresponding runbook — every alert must link to an actionable procedure
- DON'T skip post-incident reviews — document root cause, timeline, and remediation in \`docs/runbooks/incidents/\`

### Data & Compliance

- DON'T delete user data without creating an audit trail entry first — GDPR right-to-deletion requires proof of compliance
- DON'T retain personal data beyond the documented retention period — implement automated cleanup via Celery beat tasks
- DON'T transfer EU tenant data to non-EU regions without explicit consent and appropriate safeguards (SCCs, DPA)
- DON'T disable audit logging in production for performance reasons — use async writes via Celery if synchronous logging is too slow
- DON'T allow database superuser credentials in application connection strings — use a dedicated application role with minimum required privileges
- DON'T skip rotating secrets (database passwords, API keys, JWT signing keys) — automate rotation via AWS Secrets Manager with a 90-day policy

### Deployment & Rollback

- DON'T deploy to production on Fridays or outside the team's overlapping timezone window (14:00–18:00 UTC) unless it's a critical hotfix
- DON'T deploy without a rollback plan — every deployment must document how to revert (previous Docker image tag, migration rollback steps)
- DON'T use \`latest\` as a Docker image tag for production — always use the Git SHA or semantic version
- DON'T skip the staging environment — all production deployments must pass staging E2E tests first
- DON'T auto-deploy to production without manual approval in the GitHub Actions workflow
- DON'T modify Terraform state manually — all infrastructure changes go through \`terraform plan\` → PR review → \`terraform apply\`

---

## Phase-Specific Reminders

- This phase is **irreversible** in impact — treat every production action as if it affects paying customers, because it does
- When generating runbooks, include **copy-pasteable commands** with placeholder variables clearly marked (e.g., \`\${TENANT_ID}\`)
- When reviewing go-live checklists, cross-reference against \`playbook/prompts/07/go-live-checklist.md\` and \`playbook/prompts/07/monitoring-setup.md\`
- Stripe production mode is **real money** — double-check all webhook handlers and subscription logic against \`src/billing/\` test coverage
- All launch artifacts (runbooks, dashboards, alerts) must be committed to \`docs/runbooks/\` — not left in Notion or Slack threads
- If uncertain about a production operation, **stop and ask** — do not guess or assume`,

  'playbook/codeforge-phase.sh': `#!/usr/bin/env bash
#
# codeforge-phase.sh — CLI tool to manage development methodology phases
# for the django-saas-platform project.
#
# Usage:
#   ./playbook/codeforge-phase.sh [command] [options]
#
# Commands:
#   current         Show the current active phase
#   list            List all available phases
#   advance         Move to the next phase
#   revert          Move to the previous phase
#   set <phase>     Jump to a specific phase
#   check           Validate current phase prerequisites
#   status          Show phase status with checklist progress
#   help            Show this help message
#
# The active phase is tracked via a symlink:
#   playbook/current-phase.md -> playbook/phases/<phase>.md
#

set -euo pipefail

SCRIPT_DIR="$(cd "$(dirname "\${BASH_SOURCE[0]}")" && pwd)"
PLAYBOOK_DIR="\${SCRIPT_DIR}"
PHASES_DIR="\${PLAYBOOK_DIR}/phases"
SYMLINK_PATH="\${PLAYBOOK_DIR}/current-phase.md"
PHASE_LOG="\${PLAYBOOK_DIR}/.phase-history.log"

# Ordered list of phases matching the django-saas-platform development lifecycle
PHASES=(
  "01-discovery"
  "02-architecture"
  "03-tenant-foundation"
  "04-authentication"
  "05-billing-integration"
  "06-api-development"
  "07-async-tasks"
  "08-testing"
  "09-security-compliance"
  "10-deployment"
  "11-monitoring"
  "12-launch"
)

# Phase descriptions
declare -A PHASE_DESCRIPTIONS=(
  ["01-discovery"]="Requirements gathering, tenant model design, Stripe plan mapping"
  ["02-architecture"]="Django app structure, database schema, row-level security design"
  ["03-tenant-foundation"]="Tenant model, middleware, tenant-aware managers, RLS policies"
  ["04-authentication"]="User accounts, RBAC, tenant association, JWT/session auth"
  ["05-billing-integration"]="Stripe subscriptions, usage metering, webhook handlers, invoicing"
  ["06-api-development"]="DRF viewsets, Strawberry GraphQL schema, drf-spectacular docs"
  ["07-async-tasks"]="Celery tasks, beat scheduler, idempotent task patterns, Redis broker"
  ["08-testing"]="pytest suite, factory_boy fixtures, integration tests, 85% coverage"
  ["09-security-compliance"]="SOC 2 controls, GDPR compliance, audit logging, pen testing"
  ["10-deployment"]="Docker, Kubernetes, Terraform, GitHub Actions CI/CD pipeline"
  ["11-monitoring"]="Sentry error tracking, Prometheus metrics, Grafana dashboards"
  ["12-launch"]="Production cutover, DNS, CDN, runbooks, on-call rotation"
)

# Colors for terminal output
RED='\\033[0;31m'
GREEN='\\033[0;32m'
YELLOW='\\033[1;33m'
BLUE='\\033[0;34m'
CYAN='\\033[0;36m'
BOLD='\\033[1m'
DIM='\\033[2m'
NC='\\033[0m' # No Color

print_header() {
  echo -e "\${BOLD}\${BLUE}╔══════════════════════════════════════════════════╗\${NC}"
  echo -e "\${BOLD}\${BLUE}║  CodeForge Phase Manager — django-saas-platform  ║\${NC}"
  echo -e "\${BOLD}\${BLUE}╚══════════════════════════════════════════════════╝\${NC}"
  echo ""
}

log_phase_change() {
  local from_phase="$1"
  local to_phase="$2"
  local timestamp
  timestamp="$(date -u +"%Y-%m-%dT%H:%M:%SZ")"
  local user="\${USER:-unknown}"
  echo "\${timestamp} | \${user} | \${from_phase} -> \${to_phase}" >> "\${PHASE_LOG}"
}

get_current_phase() {
  if [[ -L "\${SYMLINK_PATH}" ]]; then
    local target
    target="$(readlink "\${SYMLINK_PATH}")"
    local basename
    basename="$(basename "\${target}" .md)"
    echo "\${basename}"
  else
    echo ""
  fi
}

get_phase_index() {
  local phase="$1"
  for i in "\${!PHASES[@]}"; do
    if [[ "\${PHASES[$i]}" == "\${phase}" ]]; then
      echo "$i"
      return 0
    fi
  done
  echo "-1"
  return 1
}

ensure_phases_dir() {
  if [[ ! -d "\${PHASES_DIR}" ]]; then
    echo -e "\${YELLOW}Creating phases directory: \${PHASES_DIR}\${NC}"
    mkdir -p "\${PHASES_DIR}"
  fi
}

ensure_phase_file_exists() {
  local phase="$1"
  local phase_file="\${PHASES_DIR}/\${phase}.md"
  if [[ ! -f "\${phase_file}" ]]; then
    local description="\${PHASE_DESCRIPTIONS[\${phase}]:-No description}"
    cat > "\${phase_file}" <<EOF
# Phase: \${phase}

## Description

\${description}

## Checklist

- [ ] Phase kickoff completed
- [ ] Requirements documented
- [ ] Implementation started
- [ ] Code review passed
- [ ] Tests written and passing
- [ ] Phase sign-off

## Notes

_Add phase-specific notes here._

## Django SaaS Context

Refer to project structure under \\\`src/\\\` and configuration under \\\`config/\\\`.
Run tests with: \\\`uv run pytest tests/\\\`
Run linting with: \\\`uv run ruff check src/\\\`
Run type checking with: \\\`uv run mypy src/\\\`
EOF
    echo -e "\${DIM}Generated phase file: \${phase_file}\${NC}"
  fi
}

set_phase_symlink() {
  local phase="$1"
  local target="phases/\${phase}.md"

  ensure_phases_dir
  ensure_phase_file_exists "\${phase}"

  # Remove existing symlink or file
  if [[ -e "\${SYMLINK_PATH}" ]] || [[ -L "\${SYMLINK_PATH}" ]]; then
    rm -f "\${SYMLINK_PATH}"
  fi

  # Create relative symlink
  ln -s "\${target}" "\${SYMLINK_PATH}"
}

cmd_current() {
  local current
  current="$(get_current_phase)"
  if [[ -z "\${current}" ]]; then
    echo -e "\${YELLOW}No active phase set.\${NC}"
    echo -e "Run \${CYAN}$0 set <phase>\${NC} or \${CYAN}$0 advance\${NC} to get started."
    return 1
  fi

  local idx
  idx="$(get_phase_index "\${current}")"
  local total="\${#PHASES[@]}"
  local human_idx=$((idx + 1))
  local description="\${PHASE_DESCRIPTIONS[\${current}]:-}"

  echo -e "\${GREEN}▶ Active Phase:\${NC} \${BOLD}\${current}\${NC} (\${human_idx}/\${total})"
  if [[ -n "\${description}" ]]; then
    echo -e "  \${DIM}\${description}\${NC}"
  fi
  echo -e "  \${DIM}Symlink: \${SYMLINK_PATH} -> phases/\${current}.md\${NC}"
}

cmd_list() {
  local current
  current="$(get_current_phase)"
  local current_idx=-1
  if [[ -n "\${current}" ]]; then
    current_idx="$(get_phase_index "\${current}")"
  fi

  echo -e "\${BOLD}Available Phases:\${NC}"
  echo ""

  for i in "\${!PHASES[@]}"; do
    local phase="\${PHASES[$i]}"
    local description="\${PHASE_DESCRIPTIONS[\${phase}]:-}"
    local marker="  "
    local color="\${NC}"

    if [[ "$i" -eq "\${current_idx}" ]]; then
      marker="▶ "
      color="\${GREEN}"
    elif [[ "$i" -lt "\${current_idx}" ]]; then
      marker="✓ "
      color="\${DIM}"
    fi

    local human_idx=$((i + 1))
    printf "\${color}%s%-2d  %-28s %s\${NC}\\n" "\${marker}" "\${human_idx}" "\${phase}" "\${description}"
  done
  echo ""
}

cmd_advance() {
  local current
  current="$(get_current_phase)"

  if [[ -z "\${current}" ]]; then
    # No phase set — start at the first phase
    local first="\${PHASES[0]}"
    echo -e "\${GREEN}Starting at phase: \${BOLD}\${first}\${NC}"
    set_phase_symlink "\${first}"
    log_phase_change "(none)" "\${first}"
    cmd_current
    return 0
  fi

  local idx
  idx="$(get_phase_index "\${current}")"
  local next_idx=$((idx + 1))
  local total="\${#PHASES[@]}"

  if [[ "\${next_idx}" -ge "\${total}" ]]; then
    echo -e "\${YELLOW}Already at the final phase: \${BOLD}\${current}\${NC}"
    echo -e "\${DIM}Congratulations — all phases complete!\${NC}"
    return 1
  fi

  local next="\${PHASES[$next_idx]}"

  # Prompt for confirmation
  echo -e "Advance from \${CYAN}\${current}\${NC} to \${GREEN}\${next}\${NC}?"
  read -r -p "Confirm (y/N): " confirm
  if [[ "\${confirm}" != "y" && "\${confirm}" != "Y" ]]; then
    echo -e "\${DIM}Cancelled.\${NC}"
    return 0
  fi

  set_phase_symlink "\${next}"
  log_phase_change "\${current}" "\${next}"
  echo -e "\${GREEN}✓ Advanced to phase: \${BOLD}\${next}\${NC}"
  echo ""
  cmd_current
}

cmd_revert() {
  local current
  current="$(get_current_phase)"

  if [[ -z "\${current}" ]]; then
    echo -e "\${YELLOW}No active phase to revert from.\${NC}"
    return 1
  fi

  local idx
  idx="$(get_phase_index "\${current}")"

  if [[ "\${idx}" -le 0 ]]; then
    echo -e "\${YELLOW}Already at the first phase: \${BOLD}\${current}\${NC}"
    return 1
  fi

  local prev_idx=$((idx - 1))
  local prev="\${PHASES[$prev_idx]}"

  echo -e "Revert from \${CYAN}\${current}\${NC} to \${YELLOW}\${prev}\${NC}?"
  read -r -p "Confirm (y/N): " confirm
  if [[ "\${confirm}" != "y" && "\${confirm}" != "Y" ]]; then
    echo -e "\${DIM}Cancelled.\${NC}"
    return 0
  fi

  set_phase_symlink "\${prev}"
  log_phase_change "\${current}" "\${prev}"
  echo -e "\${YELLOW}⟲ Reverted to phase: \${BOLD}\${prev}\${NC}"
  echo ""
  cmd_current
}

cmd_set() {
  local target_phase="$1"

  if [[ -z "\${target_phase}" ]]; then
    echo -e "\${RED}Error: Please specify a phase name or number.\${NC}"
    echo -e "Usage: $0 set <phase-name|phase-number>"
    echo ""
    cmd_list
    return 1
  fi

  # Support numeric input (1-based)
  if [[ "\${target_phase}" =~ ^[0-9]+$ ]]; then
    local num_idx=$((target_phase - 1))
    if [[ "\${num_idx}" -ge 0 && "\${num_idx}" -lt "\${#PHASES[@]}" ]]; then
      target_phase="\${PHASES[$num_idx]}"
    else
      echo -e "\${RED}Error: Phase number \${target_phase} out of range (1-\${#PHASES[@]}).\${NC}"
      return 1
    fi
  fi

  # Validate phase exists
  local idx
  idx="$(get_phase_index "\${target_phase}" 2>/dev/null || echo "-1")"
  if [[ "\${idx}" == "-1" ]]; then
    # Try partial match
    local matched=""
    for phase in "\${PHASES[@]}"; do
      if [[ "\${phase}" == *"\${target_phase}"* ]]; then
        if [[ -n "\${matched}" ]]; then
          echo -e "\${RED}Error: Ambiguous phase '\${target_phase}'. Multiple matches found.\${NC}"
          return 1
        fi
        matched="\${phase}"
      fi
    done

    if [[ -z "\${matched}" ]]; then
      echo -e "\${RED}Error: Unknown phase '\${target_phase}'.\${NC}"
      echo ""
      cmd_list
      return 1
    fi
    target_phase="\${matched}"
  fi

  local current
  current="$(get_current_phase)"

  if [[ "\${current}" == "\${target_phase}" ]]; then
    echo -e "\${DIM}Already on phase: \${target_phase}\${NC}"
    return 0
  fi

  set_phase_symlink "\${target_phase}"
  log_phase_change "\${current:-"(none)"}" "\${target_phase}"
  echo -e "\${GREEN}✓ Set phase to: \${BOLD}\${target_phase}\${NC}"
  echo ""
  cmd_current
}

cmd_check() {
  local current
  current="$(get_current_phase)"

  if [[ -z "\${current}" ]]; then
    echo -e "\${YELLOW}No active phase. Nothing to check.\${NC}"
    return 1
  fi

  echo -e "\${BOLD}Phase Prerequisite Check: \${CYAN}\${current}\${NC}"
  echo ""

  local all_pass=true

  # Common checks
  check_item "Python environment" "command -v python3 >/dev/null 2>&1" || all_pass=false
  check_item "uv installed" "command -v uv >/dev/null 2>&1" || all_pass=false
  check_item "Django project config" "test -f config/settings/base.py || test -f config/base.py" || all_pass=false

  # Phase-specific checks
  case "\${current}" in
    03-tenant-foundation|04-authentication|05-billing-integration|06-api-development|07-async-tasks)
      check_item "PostgreSQL reachable" "uv run python manage.py check --database default 2>/dev/null" || all_pass=false
      check_item "Migrations up to date" "uv run python manage.py migrate --check 2>/dev/null" || all_pass=false
      ;;
  esac

  case "\${current}" in
    05-billing-integration)
      check_item "STRIPE_SECRET_KEY set" "test -n \\"\\\${STRIPE_SECRET_KEY:-}\\"" || all_pass=false
      check_item "STRIPE_WEBHOOK_SECRET set" "test -n \\"\\\${STRIPE_WEBHOOK_SECRET:-}\\"" || all_pass=false
      check_item "billing app exists" "test -d src/billing" || all_pass=false
      ;;
    06-api-development)
      check_item "api app exists" "test -d src/api" || all_pass=false
      check_item "drf-spectacular installed" "uv run python -c 'import drf_spectacular' 2>/dev/null" || all_pass=false
      ;;
    07-async-tasks)
      check_item "Redis reachable" "uv run python -c 'import redis; redis.Redis().ping()' 2>/dev/null" || all_pass=false
      check_item "Celery installed" "uv run celery --version >/dev/null 2>&1" || all_pass=false
      check_item "tasks app exists" "test -d src/tasks" || all_pass=false
      ;;
    08-testing)
      check_item "pytest installed" "uv run pytest --version >/dev/null 2>&1" || all_pass=false
      check_item "tests directory exists" "test -d tests" || all_pass=false
      check_item "Ruff passes" "uv run ruff check src/ 2>/dev/null" || all_pass=false
      check_item "Mypy passes" "uv run mypy src/ 2>/dev/null" || all_pass=false
      ;;
    09-security-compliance)
      check_item "Audit logging app exists" "test -d src/core/audit.py || find src/ -name 'audit*' -type f | grep -q ." || all_pass=false
      ;;
    10-deployment)
      check_item "Dockerfile exists" "test -f Dockerfile" || all_pass=false
      check_item "Docker Compose exists" "test -f docker-compose.yml || test -f compose.yml" || all_pass=false
      check_item "GitHub Actions workflow" "test -d .github/workflows" || all_pass=false
      ;;
    11-monitoring)
      check_item "Sentry DSN configured" "test -n \\"\\\${SENTRY_DSN:-}\\"" || all_pass=false
      ;;
  esac

  echo ""
  if [[ "\${all_pass}" == true ]]; then
    echo -e "\${GREEN}\${BOLD}✓ All prerequisite checks passed.\${NC}"
  else
    echo -e "\${YELLOW}\${BOLD}⚠ Some checks failed. Review before proceeding.\${NC}"
    return 1
  fi
}

check_item() {
  local label="$1"
  local cmd="$2"

  if eval "\${cmd}" >/dev/null 2>&1; then
    echo -e "  \${GREEN}✓\${NC} \${label}"
    return 0
  else
    echo -e "  \${RED}✗\${NC} \${label}"
    return 1
  fi
}

cmd_status() {
  local current
  current="$(get_current_phase)"

  if [[ -z "\${current}" ]]; then
    echo -e "\${YELLOW}No active phase set.\${NC}"
    return 1
  fi

  local phase_file="\${PHASES_DIR}/\${current}.md"
  if [[ ! -f "\${phase_file}" ]]; then
    echo -e "\${YELLOW}Phase file not found: \${phase_file}\${NC}"
    return 1
  fi

  echo -e "\${BOLD}Phase Status: \${CYAN}\${current}\${NC}"
  echo ""

  local total=0
  local done=0

  while IFS= read -r line; do
    if [[ "\${line}" =~ ^[[:space:]]*-[[:space:]]\\[x\\] ]]; then
      ((done++)) || true
      ((total++)) || true
      echo -e "  \${GREEN}✓\${NC} \${line##*] }"
    elif [[ "\${line}" =~ ^[[:space:]]*-[[:space:]]\\[[[:space:]]\\] ]]; then
      ((total++)) || true
      echo -e "  \${RED}○\${NC} \${line##*] }"
    fi
  done < "\${phase_file}"

  echo ""
  if [[ "\${total}" -gt 0 ]]; then
    local pct=$((done * 100 / total))
    echo -e "\${BOLD}Progress: \${done}/\${total} (\${pct}%)\${NC}"

    # Progress bar
    local bar_width=30
    local filled=$((pct * bar_width / 100))
    local empty=$((bar_width - filled))
    printf "  ["
    printf "\${GREEN}%0.s█\${NC}" $(seq 1 "\${filled}" 2>/dev/null) || true
    printf "\${DIM}%0.s░\${NC}" $(seq 1 "\${empty}" 2>/dev/null) || true
    printf "]\\n"
  else
    echo -e "\${DIM}No checklist items found in phase file.\${NC}"
  fi

  # Show recent phase history
  if [[ -f "\${PHASE_LOG}" ]]; then
    echo ""
    echo -e "\${BOLD}Recent History:\${NC}"
    tail -5 "\${PHASE_LOG}" | while IFS='|' read -r ts user transition; do
      echo -e "  \${DIM}\${ts}\${NC} \${transition}"
    done
  fi
}

cmd_help() {
  print_header
  cat <<EOF
Usage: $(basename "$0") <command> [options]

Commands:
  current         Show the current active phase
  list            List all available phases
  advance         Move to the next phase (with confirmation)
  revert          Move to the previous phase (with confirmation)
  set <phase>     Jump to a specific phase (name, partial match, or number)
  check           Validate current phase prerequisites
  status          Show phase checklist progress and history
  help            Show this help message

Examples:
  $(basename "$0") list
  $(basename "$0") set 01-discovery
  $(basename "$0") set 5                    # Set by number
  $(basename "$0") set billing              # Partial match
  $(basename "$0") advance
  $(basename "$0") check
  $(basename "$0") status

Phase files are stored in: \${PHASES_DIR}/
Active phase symlink:      \${SYMLINK_PATH}
Phase transition log:      \${PHASE_LOG}
EOF
}

# --- Main ---

main() {
  local command="\${1:-help}"
  shift || true

  case "\${command}" in
    current)
      cmd_current
      ;;
    list|ls)
      cmd_list
      ;;
    advance|next)
      cmd_advance
      ;;
    revert|prev|back)
      cmd_revert
      ;;
    set|switch)
      cmd_set "\${1:-}"
      ;;
    check|validate)
      cmd_check
      ;;
    status)
      cmd_status
      ;;
    help|--help|-h)
      cmd_help
      ;;
    *)
      echo -e "\${RED}Unknown command: \${command}\${NC}"
      echo ""
      cmd_help
      exit 1
      ;;
  esac
}

main "$@"`,

  'playbook/current-phase.json': `{
  "current_phase": 1,
  "phase_id": "foundation",
  "started_at": null,
  "updated_at": null
}`,

  'playbook/phases/01-discovery.md': `# Phase 01 — Discovery & Requirements

## Purpose

Establish a clear, shared understanding of the django-saas-platform's scope, constraints, and success criteria before any code is written. This phase translates business goals into concrete technical requirements, identifies multi-tenancy and billing complexities early, and produces artifacts that guide every subsequent phase.

## Objectives

1. **Define tenant model and isolation strategy** — Decide on shared-database with row-level security (PostgreSQL RLS) vs. schema-per-tenant, document trade-offs, and commit to the approach.
2. **Map subscription and billing requirements** — Enumerate Stripe plan tiers, usage-metered features, trial flows, upgrade/downgrade paths, invoice lifecycle, and webhook events to handle.
3. **Identify API surface** — Catalog REST endpoints (DRF) and GraphQL queries/mutations (Strawberry) needed for tenant onboarding, user management, billing, and core domain operations.
4. **Clarify compliance obligations** — Document SOC 2 controls and GDPR requirements (data residency, consent management, right to deletion, DPA handling) that affect architecture.
5. **Establish non-functional requirements** — Latency targets, throughput expectations, availability SLA, data retention policies, and audit logging scope.
6. **Align team on conventions** — Confirm Django app boundaries, service-layer patterns, Celery task contracts, and the coding standards in \`docs/CONTRIBUTING.md\`.

## Inputs

| Input | Source | Notes |
|---|---|---|
| Product brief / feature list | Product owner / GitHub Issues | Epics labeled \`discovery\` |
| Existing domain knowledge | Team leads, stakeholders | Interviews or async Notion docs |
| Competitor / market analysis | Product team | Pricing models, feature parity |
| Compliance requirements | Security / Legal | SOC 2 Type II scope, GDPR DPA templates |
| Infrastructure constraints | Platform / DevOps | AWS region availability, budget limits |
| \`docs/ONBOARDING.md\` | This repo | Current project context |
| \`docs/AI-USAGE-POLICY.md\` | This repo | Guardrails for AI-assisted development |

## Activities

### 1. Stakeholder Interviews & Domain Mapping

- Conduct 2–3 sessions (async-friendly for Europe + Americas overlap).
- Produce a domain glossary: Tenant, Organization, Workspace, Subscription, Plan, Seat, Usage Record, Invoice, Webhook Event.
- Identify bounded contexts that map to Django apps: \`tenants\`, \`accounts\`, \`billing\`, \`notifications\`, \`core\`.

### 2. Multi-Tenancy Design Decision

- Document options: shared DB + RLS (recommended), schema-per-tenant, DB-per-tenant.
- Prototype PostgreSQL RLS policies for the \`tenants_tenant\` table.
- Define the \`TenantAwareManager\` contract (see \`src/core/managers.py\`).
- Decide on tenant resolution strategy: subdomain, header (\`X-Tenant-ID\`), or JWT claim.

\`\`\`sql
-- Example RLS policy sketch (to be refined in Phase 02)
ALTER TABLE tenants_tenant ENABLE ROW LEVEL SECURITY;
CREATE POLICY tenant_isolation ON tenants_tenant
  USING (id = current_setting('app.current_tenant_id')::uuid);
\`\`\`

### 3. Billing & Subscription Requirements

- Map Stripe objects to Django models: \`Product → Plan\`, \`Price → PlanTier\`, \`Subscription\`, \`Invoice\`, \`UsageRecord\`.
- List webhook events to handle: \`customer.subscription.created\`, \`customer.subscription.updated\`, \`customer.subscription.deleted\`, \`invoice.payment_succeeded\`, \`invoice.payment_failed\`, \`checkout.session.completed\`.
- Define idempotency strategy for webhook processing (store \`stripe_event_id\`, check before processing).
- Document trial period logic, grace periods, and dunning behavior.

### 4. API Surface Catalog

- Create an endpoint inventory spreadsheet or Notion table:

| Method | Path | App | Auth | Tenant-Scoped | Notes |
|---|---|---|---|---|---|
| POST | \`/api/v1/tenants/\` | tenants | JWT | No | Onboarding |
| GET | \`/api/v1/tenants/{id}/\` | tenants | JWT | Yes | Tenant detail |
| POST | \`/api/v1/auth/register/\` | accounts | None | No | User signup |
| POST | \`/api/v1/auth/login/\` | accounts | None | No | JWT token pair |
| GET | \`/api/v1/billing/subscription/\` | billing | JWT | Yes | Current plan |
| POST | \`/api/v1/billing/checkout/\` | billing | JWT | Yes | Stripe Checkout |
| POST | \`/api/v1/billing/webhooks/stripe/\` | billing | Stripe sig | No | Webhook receiver |
| GraphQL | \`/graphql/\` | api | JWT | Yes | Strawberry schema |

- Identify which endpoints need rate limiting, pagination, and filtering.

### 5. RBAC & Permissions Model

- Define roles: \`owner\`, \`admin\`, \`member\`, \`viewer\`, \`billing_admin\`.
- Map permissions per role per Django app.
- Decide on permission backend: Django's built-in + custom \`TenantPermissionMixin\` vs. django-guardian.
- Document invitation and onboarding flow (email invite → accept → role assignment).

### 6. Non-Functional Requirements

| Requirement | Target | Measurement |
|---|---|---|
| API response time (p95) | < 200ms | Prometheus / Grafana |
| Availability | 99.9% | AWS CloudWatch |
| Celery task processing | < 30s for billing sync | Celery Flower / Sentry |
| Test coverage | ≥ 85% | pytest-cov |
| Concurrent tenants | 500+ in Year 1 | Load testing (Locust) |
| Data retention | Configurable per tenant | GDPR compliance |
| Audit log retention | 2 years minimum | SOC 2 requirement |

### 7. Compliance & Security Requirements

**SOC 2:**
- Audit logging for all data mutations (who, what, when, tenant context).
- Encryption at rest (RDS, S3) and in transit (TLS 1.2+).
- Access control reviews — CODEOWNERS for \`**/billing/**\`, \`**/auth/**\`, \`config/production/**\`.
- Incident response runbook placeholder in \`docs/\`.

**GDPR:**
- Data residency: document which AWS regions store PII.
- Consent tracking: model for recording user consent per purpose.
- Right to deletion: design a \`delete_tenant_data\` Celery task that cascades correctly.
- Data Processing Agreements: Stripe, AWS, SendGrid/SES DPA references.
- Cookie consent and privacy policy endpoints.

### 8. White-Label Requirements

- Identify customizable elements: logo, color scheme, email templates, subdomain.
- Define the \`TenantBranding\` model fields.
- Determine CDN strategy (CloudFront with tenant-specific origins or path-based routing).

## Deliverables

| # | Deliverable | Format | Location |
|---|---|---|---|
| D1 | Domain glossary | Markdown | \`docs/domain-glossary.md\` |
| D2 | Multi-tenancy ADR | Markdown (ADR format) | \`docs/adr/001-multi-tenancy-strategy.md\` |
| D3 | Billing requirements | Markdown + diagrams | \`docs/billing-requirements.md\` |
| D4 | API endpoint inventory | Markdown table | \`docs/api-inventory.md\` |
| D5 | RBAC matrix | Markdown table | \`docs/rbac-matrix.md\` |
| D6 | Non-functional requirements | Markdown | \`docs/nfr.md\` |
| D7 | Compliance checklist | Markdown | \`docs/compliance-checklist.md\` |
| D8 | User stories / GitHub Issues | GitHub Issues | Labeled \`phase:discovery\`, \`type:requirement\` |
| D9 | Risk register | Markdown | \`docs/risk-register.md\` |
| D10 | White-label spec | Markdown | \`docs/white-label-spec.md\` |

## Quality Gates

All gates must pass before advancing to [Phase 02 — Architecture & Design](./02-architecture.md).

| # | Gate | Criteria | Verified By |
|---|---|---|---|
| QG1 | Domain glossary reviewed | All team members confirm shared understanding; no ambiguous terms | Tech lead + Product owner |
| QG2 | Multi-tenancy ADR approved | ADR has "Accepted" status; RLS prototype tested against PostgreSQL 16 | Senior engineers (≥ 2 approvals) |
| QG3 | Billing requirements signed off | Stripe object mapping complete; all webhook events listed; idempotency strategy documented | Billing code owner + Product |
| QG4 | API inventory covers MVP | Every user story has corresponding endpoint(s); OpenAPI compatibility confirmed | API code owner |
| QG5 | RBAC matrix complete | Every role × every resource permission documented; edge cases (cross-tenant, billing admin) addressed | Security reviewer |
| QG6 | NFRs have measurable targets | Every NFR has a numeric target and a measurement method | Tech lead |
| QG7 | Compliance checklist baselined | SOC 2 controls mapped to implementation tasks; GDPR obligations documented with owners | Security lead + Legal |
| QG8 | Risk register populated | ≥ 5 risks identified with likelihood, impact, and mitigation strategy | Tech lead |
| QG9 | Stakeholder sign-off | Product owner and tech lead approve all deliverables | Explicit approval in GitHub Issue or Notion |

## Tools & Commands

\`\`\`bash
# Validate that discovery docs exist and are non-empty
ls -la docs/domain-glossary.md docs/adr/001-multi-tenancy-strategy.md \\
       docs/billing-requirements.md docs/api-inventory.md docs/rbac-matrix.md \\
       docs/nfr.md docs/compliance-checklist.md docs/risk-register.md

# Check phase status
cat playbook/current-phase.json

# Advance phase (after all quality gates pass)
./playbook/codeforge-phase.sh advance
\`\`\`

## Anti-Patterns to Avoid

- **Skipping tenant isolation design** — Retrofitting RLS after models exist is expensive and error-prone.
- **Vague billing requirements** — "We'll figure out Stripe later" leads to webhook bugs, double charges, and SOC 2 findings.
- **Assuming single-region** — GDPR data residency must be decided now, not during production deployment.
- **Gold-plating the API** — Catalog MVP endpoints only; defer admin dashboards and analytics to later phases.
- **Ignoring Celery task contracts** — If a task isn't defined as idempotent from the start, it won't be idempotent later.

## Estimated Duration

**1–2 weeks** depending on stakeholder availability and async collaboration across Europe + Americas timezones.

## Phase Transition

When all quality gates pass:

1. Update \`playbook/current-phase.json\` to \`{"current_phase": 2, ...}\`.
2. Create a GitHub milestone for Phase 02.
3. Move unresolved discovery questions to the risk register.
4. Notify the team in Slack (\`#django-saas-platform\`).

**Next phase →** [Phase 02 — Architecture & Design](./02-architecture.md)`,

  'playbook/phases/02-architecture.md': `# Phase 02: Architecture & Design

## Phase Overview

| Attribute       | Value                                                        |
|-----------------|--------------------------------------------------------------|
| **Phase**       | 02 — Architecture & Design                                   |
| **Duration**    | 1–2 sprints (2–4 weeks)                                      |
| **Predecessor** | [Phase 01 — Discovery & Planning](./01-discovery.md)         |
| **Successor**   | [Phase 03 — Foundation Setup](./03-foundation.md)            |
| **Owner**       | Lead/Senior Engineers + Architect                             |
| **Reviewers**   | All backend developers, DevOps lead, Security lead            |

## Objectives

1. **Define the multi-tenant data architecture** — PostgreSQL schema design with row-level security policies, tenant isolation strategy, and tenant-aware Django ORM managers.
2. **Design the modular monolith app structure** — Establish boundaries between Django apps (\`accounts\`, \`tenants\`, \`billing\`, \`api\`, \`core\`, \`notifications\`, \`tasks\`, \`utils\`) with explicit dependency rules.
3. **Specify the API surface** — REST endpoints via DRF with OpenAPI 3.1 schemas (drf-spectacular) and GraphQL schema via Strawberry, including authentication, pagination, filtering, and rate limiting.
4. **Architect the billing and subscription system** — Stripe integration design covering subscription lifecycle, usage-based metering, webhook processing, invoice generation, and plan management.
5. **Design the async task pipeline** — Celery task topology, idempotency guarantees, retry policies, dead-letter handling, and beat schedule for periodic jobs.
6. **Establish security and compliance architecture** — SOC 2 control mapping, GDPR data flows (consent, right to deletion, data residency), audit logging strategy, and secrets management.
7. **Define infrastructure topology** — AWS deployment architecture (ECS, RDS, ElastiCache, S3, SES, CloudFront), Docker image strategy, Kubernetes manifests, and Terraform module structure.
8. **Document cross-cutting concerns** — Caching strategy (Redis layers), logging/observability (Sentry, Prometheus, Grafana), feature flags, and white-label/theming support.

## Deliverables

### D1: Architecture Decision Records (ADRs)

Location: \`docs/adr/\`

Create ADRs for each significant decision. Minimum required:

| ADR | Title |
|-----|-------|
| ADR-001 | Multi-tenancy strategy: shared database with row-level security |
| ADR-002 | Modular monolith over microservices |
| ADR-003 | REST + GraphQL dual API surface |
| ADR-004 | Celery for async task processing with Redis broker |
| ADR-005 | Stripe as sole billing provider |
| ADR-006 | Django-environ + Pydantic for configuration management |
| ADR-007 | uv as Python package manager |
| ADR-008 | Audit logging approach (append-only table vs. django-auditlog) |
| ADR-009 | White-label theming strategy |
| ADR-010 | GDPR data residency and tenant data isolation |

Each ADR must follow the format:

\`\`\`
# ADR-NNN: Title
## Status: Proposed | Accepted | Deprecated
## Context: Why this decision is needed
## Decision: What we chose
## Consequences: Trade-offs, risks, migration path
## Compliance: SOC 2 / GDPR implications (if applicable)
\`\`\`

### D2: Data Model Design

Location: \`docs/architecture/data-model.md\`

- **Tenant model** — \`tenants.Tenant\` with UUID primary key, slug, plan reference, settings JSON, created/updated timestamps.
- **User-Tenant association** — \`accounts.TenantMembership\` with role (owner, admin, member, viewer), invitation flow.
- **Row-level security** — PostgreSQL RLS policies on all tenant-scoped tables. Document which tables are tenant-scoped vs. global.
- **Tenant-aware base model** — \`core.models.TenantScopedModel\` abstract base class with \`tenant\` FK and custom manager that auto-filters by current tenant.
- **Billing models** — \`billing.Subscription\`, \`billing.Plan\`, \`billing.Invoice\`, \`billing.UsageRecord\`, \`billing.PaymentMethod\` with Stripe ID references.
- **Audit log model** — \`core.models.AuditLog\` with actor, action, resource type/ID, tenant, timestamp, diff JSON.

Entity relationship diagram (Mermaid or similar) required.

### D3: API Design Specification

Location: \`docs/architecture/api-design.md\`

**REST API (DRF):**

- Base URL pattern: \`/api/v1/<app>/<resource>/\`
- Authentication: JWT (access + refresh tokens) via \`djangorestframework-simplejwt\`
- Tenant resolution: \`X-Tenant-ID\` header or subdomain-based
- Pagination: cursor-based for list endpoints
- Filtering: django-filter integration
- Rate limiting: per-tenant and per-user tiers
- Versioning strategy: URL path (\`/api/v1/\`, \`/api/v2/\`)
- Error response format: RFC 7807 Problem Details

**GraphQL API (Strawberry):**

- Endpoint: \`/api/graphql/\`
- Authentication: same JWT flow
- Tenant context injection via middleware
- Query complexity limits
- Dataloader patterns for N+1 prevention

**Endpoint inventory** — list all planned endpoints grouped by Django app with HTTP method, auth requirement, and permission level.

### D4: Service Layer Design

Location: \`docs/architecture/service-layer.md\`

Each Django app exposes a service module (\`<app>/services.py\`) as the primary interface for business logic. Document:

- **accounts/services.py** — \`create_user()\`, \`invite_to_tenant()\`, \`assign_role()\`, \`deactivate_user()\`
- **tenants/services.py** — \`provision_tenant()\`, \`update_tenant_settings()\`, \`delete_tenant()\` (GDPR), \`switch_tenant()\`
- **billing/services.py** — \`create_subscription()\`, \`change_plan()\`, \`cancel_subscription()\`, \`record_usage()\`, \`sync_stripe_data()\`, \`process_webhook()\`
- **notifications/services.py** — \`send_email()\`, \`send_in_app_notification()\`, \`dispatch_webhook()\`

Rules:
- Views/serializers call services, never raw ORM queries for mutations.
- Services are the only layer that triggers Celery tasks.
- Services handle tenant context validation before any data mutation.
- All service functions have type hints and return typed results (dataclasses or Pydantic models).

### D5: Celery Task Architecture

Location: \`docs/architecture/celery-tasks.md\`

| Queue | Tasks | Priority | Retry Policy |
|-------|-------|----------|--------------|
| \`default\` | General background work | Normal | 3 retries, exponential backoff |
| \`billing\` | \`sync_stripe_subscription\`, \`process_invoice\`, \`record_usage_batch\` | High | 5 retries, exponential backoff, DLQ |
| \`notifications\` | \`send_email_task\`, \`dispatch_webhook_task\` | Normal | 3 retries, linear backoff |
| \`reports\` | \`generate_tenant_report\`, \`export_data\` | Low | 2 retries |
| \`maintenance\` | \`cleanup_expired_sessions\`, \`rotate_audit_logs\` | Low | 1 retry |

**Idempotency requirements:**
- Every task must accept an \`idempotency_key\` parameter.
- Billing tasks must check Stripe idempotency before processing.
- Webhook dispatch tasks must deduplicate by event ID.
- Document the idempotency pattern (Redis lock vs. database unique constraint).

**Beat schedule:**
- Hourly: usage aggregation, subscription sync
- Daily: invoice generation, audit log rotation, stale session cleanup
- Weekly: tenant usage reports

### D6: Security Architecture

Location: \`docs/architecture/security.md\`

**Authentication & Authorization:**
- JWT token lifecycle (access: 15 min, refresh: 7 days)
- Role-based access control (RBAC): owner > admin > member > viewer
- Permission matrix per API endpoint
- Tenant-scoped permissions (user can have different roles in different tenants)

**Multi-Tenant Isolation (SOC 2):**
- PostgreSQL RLS policy definitions
- Django middleware for tenant context injection (\`core.middleware.TenantMiddleware\`)
- Tenant-aware ORM manager that raises \`TenantAccessViolation\` on cross-tenant queries
- S3 bucket key prefix per tenant for file isolation
- Redis key namespace per tenant for cache isolation

**GDPR Compliance:**
- Data flow diagram showing PII storage locations
- Consent tracking model and API
- Right to deletion: \`tenants/services.py::delete_tenant()\` cascade behavior
- Data export: \`tasks/export_tenant_data.py\` for DSAR requests
- Data residency: document how tenant data region is enforced (RDS multi-region or single-region with documentation)
- Data Processing Agreement (DPA) template reference

**Secrets Management:**
- \`django-environ\` for local development (\`.env\` files, gitignored)
- AWS Secrets Manager / SSM Parameter Store for staging/production
- Stripe API keys rotation procedure
- No secrets in Docker images or Terraform state

**Audit Logging:**
- All mutations to tenant data logged to \`core.AuditLog\`
- Billing events logged with Stripe event IDs
- Authentication events (login, logout, failed attempts, token refresh)
- Admin actions on tenant settings
- Log retention: 90 days hot (PostgreSQL), 1 year cold (S3)

### D7: Infrastructure Architecture

Location: \`docs/architecture/infrastructure.md\`

\`\`\`
                    ┌─────────────┐
                    │ CloudFront  │
                    │   (CDN)     │
                    └──────┬──────┘
                           │
                    ┌──────▼──────┐
                    │    ALB      │
                    └──────┬──────┘
                           │
              ┌────────────┼────────────┐
              │            │            │
       ┌──────▼──┐  ┌──────▼──┐  ┌──────▼──────┐
       │ ECS Web │  │ ECS Web │  │ ECS Celery  │
       │ (Django)│  │ (Django)│  │  Workers    │
       └────┬────┘  └────┬────┘  └──────┬──────┘
            │             │              │
       ┌────▼─────────────▼──────────────▼────┐
       │              VPC                      │
       │  ┌──────────┐  ┌──────────┐          │
       │  │ RDS      │  │ElastiCache│         │
       │  │(Postgres)│  │ (Redis)   │         │
       │  └──────────┘  └──────────┘          │
       │  ┌──────────┐  ┌──────────┐          │
       │  │   S3     │  │   SES    │          │
       │  │ (files)  │  │ (email)  │          │
       │  └──────────┘  └──────────┘          │
       └──────────────────────────────────────┘
\`\`\`

- **Terraform modules:** \`terraform/modules/{vpc, ecs, rds, elasticache, s3, ses, cloudfront, iam}\`
- **Docker:** Multi-stage Dockerfile (builder + runtime), separate targets for web and worker
- **Kubernetes:** Helm chart or raw manifests in \`k8s/\` for teams preferring K8s over ECS
- **Environments:** development (local Docker Compose), staging (AWS, auto-deploy from main), production (AWS, manual promotion)

### D8: Observability Design

Location: \`docs/architecture/observability.md\`

- **Error tracking:** Sentry with Django integration, Celery integration, tenant context tags
- **Metrics:** Prometheus metrics exposed at \`/metrics/\` (django-prometheus), custom business metrics (active tenants, MRR, task queue depth)
- **Dashboards:** Grafana dashboards for API latency, error rates, Celery queue depth, database connections, cache hit rates
- **Logging:** Structured JSON logging (structlog), correlation IDs per request, tenant ID in every log line
- **Alerting:** PagerDuty/Slack integration for critical alerts (billing failures, RLS violations, queue backlog)

### D9: Django App Dependency Map

Location: \`docs/architecture/app-dependencies.md\`

\`\`\`
core (base models, middleware, permissions)
  ├── tenants (depends on: core)
  ├── accounts (depends on: core, tenants)
  ├── billing (depends on: core, tenants, accounts)
  ├── notifications (depends on: core, tenants, accounts)
  ├── tasks (depends on: core, tenants, billing, notifications)
  ├── api (depends on: core, tenants, accounts, billing, notifications)
  └── utils (no dependencies, utility only)
\`\`\`

Rules:
- No circular dependencies between apps.
- \`core\` and \`utils\` must not import from any other app.
- \`api\` is the only app that defines DRF viewsets and Strawberry types.
- Cross-app communication goes through the service layer, never direct model imports for mutations.

## Activities

### Week 1: Core Architecture

| # | Activity | Owner | Output |
|---|----------|-------|--------|
| 1 | Draft multi-tenancy ADR and data model | Lead Engineer | ADR-001, D2 |
| 2 | Design service layer contracts | Senior Engineers | D4 |
| 3 | Define API endpoint inventory | Backend Developers | D3 |
| 4 | Design Celery task topology | Senior Engineer | D5 |
| 5 | Map security controls to SOC 2 / GDPR | Security Lead | D6 |

### Week 2: Infrastructure & Review

| # | Activity | Owner | Output |
|---|----------|-------|--------|
| 6 | Design infrastructure topology | DevOps Lead | D7 |
| 7 | Design observability stack | DevOps + Backend | D8 |
| 8 | Create remaining ADRs | All Engineers | D1 |
| 9 | Map app dependencies | Lead Engineer | D9 |
| 10 | Architecture review session (all hands) | Architect | Approved docs |
| 11 | Update \`playbook/current-phase.json\` to phase 03 | Lead Engineer | Phase transition |

## Using Claude in This Phase

### Architecture Review

\`\`\`
/architect Review the multi-tenancy design in docs/architecture/data-model.md.
Validate that RLS policies cover all tenant-scoped models and that the
TenantScopedModel base class enforces isolation correctly.
\`\`\`

### ADR Drafting

\`\`\`
/plan Draft ADR-005 for choosing Stripe as the billing provider.
Consider alternatives (Paddle, Chargebee, custom). Evaluate webhook
reliability, usage metering support, and Django library ecosystem.
\`\`\`

### API Design Validation

\`\`\`
/verify Check docs/architecture/api-design.md for completeness.
Ensure every endpoint has auth requirements, permission levels,
rate limit tiers, and OpenAPI schema annotations planned.
\`\`\`

### Security Review

\`\`\`
/code-review Review docs/architecture/security.md against SOC 2 CC6
(Logical and Physical Access Controls) and GDPR Articles 17, 20, 25.
Flag any gaps in tenant isolation or data deletion flows.
\`\`\`

## Quality Gates

All gates must pass before transitioning to Phase 03.

| # | Gate | Criteria | Verified By |
|---|------|----------|-------------|
| QG-1 | **ADRs complete** | All 10 ADRs written, status "Accepted", reviewed by ≥2 engineers | Architect |
| QG-2 | **Data model reviewed** | ER diagram covers all apps, RLS policies documented for every tenant-scoped table, tenant-aware manager design approved | Lead Engineer |
| QG-3 | **API inventory complete** | Every planned endpoint listed with method, auth, permissions, rate limit tier; OpenAPI schema strategy documented | Backend Lead |
| QG-4 | **Service layer contracts defined** | All service functions have signatures with type hints, documented input/output types, and error cases | Senior Engineers |
| QG-5 | **Celery tasks catalogued** | Every task has queue assignment, retry policy, idempotency strategy, and beat schedule (if periodic) | Senior Engineer |
| QG-6 | **Security architecture approved** | RBAC matrix complete, RLS policies reviewed, GDPR data flows mapped, secrets management documented, SOC 2 controls mapped | Security Lead |
| QG-7 | **Infrastructure topology approved** | Terraform module structure defined, Docker strategy documented, environment parity plan in place | DevOps Lead |
| QG-8 | **Observability plan approved** | Sentry, Prometheus, Grafana, and structured logging strategy documented with tenant context requirements | DevOps Lead |
| QG-9 | **App dependency map clean** | No circular dependencies, dependency direction validated, cross-app communication rules documented | Architect |
| QG-10 | **Team sign-off** | Architecture review session held, all leads approve, open questions resolved or tracked as ADR amendments | All Leads |

## Phase Transition

When all quality gates pass:

\`\`\`bash
./playbook/codeforge-phase.sh 03
\`\`\`

This updates \`playbook/current-phase.json\` and signals the team that foundation setup (Django project scaffolding, CI/CD pipeline, Docker Compose, initial migrations) can begin.

## Anti-Patterns to Avoid

| Anti-Pattern | Why It's Harmful | What to Do Instead |
|-------------|------------------|-------------------|
| Skipping RLS design | Tenant data leaks in production; SOC 2 audit failure | Design and test RLS policies before writing any model code |
| Fat views, no service layer | Business logic scattered across views, serializers, and tasks | Define service contracts now; enforce in code review |
| Circular app dependencies | Unmaintainable codebase, import errors, testing nightmares | Use the dependency map (D9) as a hard constraint |
| Generic "we'll figure it out" for billing | Stripe integration is complex; late design causes webhook bugs | Fully design subscription lifecycle and webhook handling |
| Ignoring idempotency for tasks | Duplicate charges, duplicate emails, data corruption | Require idempotency_key in every task signature |
| Over-engineering multi-tenancy | Schema-per-tenant adds operational complexity for <1000 tenants | Shared schema + RLS is the right choice; document why in ADR-001 |

## References

- [Playbook Overview](../PLAYBOOK.md)
- [Phase 01 — Discovery & Planning](./01-discovery.md)
- [Phase 03 — Foundation Setup](./03-foundation.md)
- [Architecture Docs](../../docs/architecture/)
- [Contributing Guide](../../docs/CONTRIBUTING.md)
- [AI Usage Policy](../../docs/AI-USAGE-POLICY.md)`,

  'playbook/phases/03-foundation.md': `# Phase 03: Foundation & Scaffolding

## Phase Overview

**Phase**: 03 of 07
**Name**: Foundation & Scaffolding
**Duration**: 5–8 days
**Previous Phase**: [02 — Architecture & Design](./02-architecture.md)
**Next Phase**: [04 — Core Implementation](./04-core-implementation.md)

Translate the architecture decisions from Phase 02 into a working project skeleton. By the end of this phase every Django app directory exists, the database schema is migrated, Docker Compose brings up all services locally, CI runs green on an empty test suite, and the team can start feature work without touching infrastructure again.

---

## Objectives

| # | Objective | Success Metric |
|---|-----------|----------------|
| 1 | Scaffold all Django apps with correct module structure | Every app in \`src/\` has \`models.py\`, \`views.py\`, \`serializers.py\`, \`urls.py\`, \`admin.py\`, \`tasks.py\`, \`tests/\` |
| 2 | Configure Django settings for all environments | \`config/base.py\`, \`config/development.py\`, \`config/staging.py\`, \`config/production.py\` load via \`django-environ\` + Pydantic settings |
| 3 | Establish multi-tenant foundation | \`Tenant\` model, tenant-aware model manager, tenant middleware, row-level security policies in PostgreSQL |
| 4 | Set up database migrations and seed data | \`uv run python manage.py migrate\` succeeds; seed script creates a default tenant and superuser |
| 5 | Configure Celery with Redis broker | \`celery -A config worker\` starts; a smoke-test task executes and returns |
| 6 | Docker Compose local environment | \`docker compose up\` brings up Django, PostgreSQL 16, Redis, Celery worker, Celery beat |
| 7 | CI pipeline runs green | GitHub Actions: lint → type check → test → build Docker image all pass on \`main\` |
| 8 | API scaffolding with OpenAPI | DRF router + Strawberry GraphQL endpoint mounted; \`drf-spectacular\` generates OpenAPI 3.1 schema |
| 9 | Authentication & authorization skeleton | \`django-allauth\` or custom JWT auth wired; RBAC permission classes created |
| 10 | Developer tooling locked in | \`ruff\`, \`mypy --strict\`, \`pytest\`, \`pre-commit\` hooks all configured and documented |

---

## Deliverables

### D1 — Django Project Skeleton

\`\`\`
src/
  accounts/
    __init__.py
    models.py          # CustomUser, UserProfile
    managers.py        # Custom user manager
    serializers.py
    views.py
    urls.py
    admin.py
    signals.py
    tests/
      __init__.py
      test_models.py
      test_views.py
      factories.py     # factory_boy UserFactory
  tenants/
    __init__.py
    models.py          # Tenant, TenantMembership, TenantSettings
    middleware.py      # TenantMiddleware — sets current tenant on request
    managers.py        # TenantAwareManager (filters by current tenant)
    serializers.py
    views.py
    urls.py
    admin.py
    sql/               # Raw SQL for PostgreSQL row-level security policies
      enable_rls.sql
      tenant_policies.sql
    tests/
      __init__.py
      test_models.py
      test_middleware.py
      test_managers.py
      factories.py
  billing/
    __init__.py
    models.py          # Subscription, Plan, Invoice, UsageRecord
    services.py        # StripeService — wraps Stripe SDK calls
    webhooks.py        # Stripe webhook handler (verified, idempotent)
    serializers.py
    views.py
    urls.py
    admin.py
    tasks.py           # sync_subscriptions, generate_invoices
    tests/
      __init__.py
      test_services.py
      test_webhooks.py
      factories.py
  api/
    __init__.py
    urls.py            # DRF router + Strawberry GraphQL URL
    schema.py          # Strawberry root Query/Mutation
    permissions.py     # Tenant-scoped DRF permission classes
    pagination.py
    throttling.py
    versioning.py
  core/
    __init__.py
    models.py          # TimestampedModel, TenantScopedModel (abstract bases)
    permissions.py     # RBAC: TenantAdmin, TenantMember, TenantViewer
    middleware.py      # AuditLogMiddleware, RequestIDMiddleware
    managers.py        # Base tenant-aware queryset
    decorators.py      # @tenant_required, @idempotent_task
    exceptions.py      # Custom API exceptions
    types.py           # Shared Pydantic/Strawberry types
  notifications/
    __init__.py
    models.py          # Notification, NotificationPreference
    services.py        # EmailService (SES), InAppNotificationService
    tasks.py           # send_email_task, dispatch_webhook_task
    serializers.py
    views.py
    urls.py
    tests/
      __init__.py
      test_tasks.py
      factories.py
  tasks/
    __init__.py
    billing.py         # Celery tasks: sync_stripe, meter_usage
    reports.py         # generate_tenant_report
    cleanup.py         # purge_expired_sessions, gdpr_data_deletion
    schedules.py       # Celery beat schedule definitions
  utils/
    __init__.py
    logging.py         # Structured JSON logging config
    stripe_helpers.py  # Webhook signature verification, retry logic
    tenant_context.py  # Thread-local / context-var tenant accessor
    pagination.py
    crypto.py          # Encryption helpers for PII at rest
\`\`\`

### D2 — Django Settings Stack

| File | Purpose |
|------|---------|
| \`config/__init__.py\` | Celery app auto-discover |
| \`config/base.py\` | Shared settings: installed apps, middleware, REST_FRAMEWORK, SPECTACULAR, CELERY, logging |
| \`config/development.py\` | DEBUG=True, local PostgreSQL/Redis, django-debug-toolbar |
| \`config/staging.py\` | AWS RDS/ElastiCache endpoints, Sentry DSN, HTTPS enforcement |
| \`config/production.py\` | Hardened: SECURE_SSL_REDIRECT, HSTS, CSP, Sentry, CloudFront static |
| \`config/celery.py\` | Celery app configuration, autodiscover_tasks, beat schedule |
| \`config/urls.py\` | Root URL conf: admin, api/, graphql/, health-check |
| \`config/wsgi.py\` | WSGI entry point |
| \`config/asgi.py\` | ASGI entry point (for future WebSocket support) |

Settings are loaded via \`django-environ\` from \`.env\` files and validated at startup with a Pydantic \`Settings\` model in \`config/settings_schema.py\`.

### D3 — Docker Compose Environment

\`\`\`yaml
# docker-compose.yml services:
#   web        — Django dev server (uv run python manage.py runserver)
#   db         — PostgreSQL 16 with RLS-enabled schema
#   redis      — Redis 7 (caching + Celery broker)
#   worker     — Celery worker (celery -A config worker -l info)
#   beat       — Celery beat scheduler
#   mailpit    — Local email capture (replaces SES in dev)
\`\`\`

A \`docker-compose.override.yml\` mounts source code for hot-reload. A \`.env.example\` documents every required variable.

### D4 — CI Pipeline (GitHub Actions)

Workflow file: \`.github/workflows/ci.yml\`

\`\`\`
Jobs:
  lint        → uv run ruff check src/ tests/
  format      → uv run ruff format --check src/ tests/
  typecheck   → uv run mypy src/ --strict
  test        → uv run pytest tests/ --cov=src --cov-fail-under=85
  security    → uv run pip-audit; uv run bandit -r src/
  build       → docker build -t django-saas-platform .
\`\`\`

All jobs run on \`ubuntu-latest\` with PostgreSQL 16 and Redis 7 service containers. Matrix strategy for Python 3.12 and 3.13.

### D5 — Database Foundation

- Initial migrations for all apps (\`0001_initial.py\`)
- \`Tenant\` model with UUID primary key, slug, display name, settings JSON, \`created_at\`, \`is_active\`
- \`CustomUser\` model extending \`AbstractBaseUser\` with tenant FK
- Abstract \`TenantScopedModel\` with \`tenant\` FK and custom manager that auto-filters
- PostgreSQL row-level security SQL scripts in \`src/tenants/sql/\`
- Management command: \`uv run python manage.py seed_dev_data\` — creates default tenant, admin user, sample plans

### D6 — Celery Configuration

- \`config/celery.py\` with \`autodiscover_tasks()\` across all apps
- Redis broker URL from environment
- Task serializer: JSON (no pickle — SOC 2 compliance)
- Task result backend: Redis with 24h expiry
- Beat schedule in \`src/tasks/schedules.py\` (billing sync every hour, cleanup daily)
- Smoke-test task \`src/tasks/health.py:ping\` that returns \`"pong"\`
- \`@idempotent_task\` decorator in \`src/core/decorators.py\` using Redis-based deduplication

### D7 — API Scaffolding

- DRF default router in \`src/api/urls.py\`
- \`drf-spectacular\` configured in \`config/base.py\` with project metadata
- Schema endpoint at \`/api/schema/\` (OpenAPI 3.1 YAML)
- Swagger UI at \`/api/docs/\` and ReDoc at \`/api/redoc/\`
- Strawberry GraphQL endpoint at \`/graphql/\` with GraphiQL in development
- Tenant-scoped permission class \`IsTenantMember\` in \`src/api/permissions.py\`
- Standard pagination (cursor-based for list endpoints)
- Throttling: 100 req/min anonymous, 1000 req/min authenticated

### D8 — Authentication Skeleton

- JWT authentication via \`djangorestframework-simplejwt\`
- Token endpoints: \`/api/auth/token/\`, \`/api/auth/token/refresh/\`
- RBAC roles: \`TenantOwner\`, \`TenantAdmin\`, \`TenantMember\`, \`TenantViewer\`
- Role stored on \`TenantMembership\` model (many-to-many between User and Tenant)
- Permission classes that check role against tenant context from middleware

### D9 — Developer Tooling

| Tool | Config File | Command |
|------|-------------|---------|
| ruff | \`pyproject.toml\` [tool.ruff] | \`uv run ruff check src/ tests/\` |
| ruff format | \`pyproject.toml\` [tool.ruff.format] | \`uv run ruff format src/ tests/\` |
| mypy | \`pyproject.toml\` [tool.mypy] | \`uv run mypy src/\` |
| pytest | \`pyproject.toml\` [tool.pytest.ini_options] | \`uv run pytest\` |
| pre-commit | \`.pre-commit-config.yaml\` | \`pre-commit run --all-files\` |
| pip-audit | CI only | \`uv run pip-audit\` |
| bandit | \`pyproject.toml\` [tool.bandit] | \`uv run bandit -r src/\` |

### D10 — Documentation Updates

- \`docs/ONBOARDING.md\` updated with local setup instructions using Docker Compose
- \`docs/ARCHITECTURE.md\` updated with app dependency diagram
- \`docs/API.md\` stub pointing to \`/api/docs/\` and \`/graphql/\`
- \`CODEOWNERS\` file mapping sensitive paths:
  - \`src/billing/**\` → \`@billing-team\`
  - \`src/accounts/**\`, \`src/tenants/**\` → \`@platform-team\`
  - \`config/production/**\` → \`@infra-leads\`
  - \`.env*\` → \`@infra-leads\`

---

## Tasks

### 1. Project Initialization (Day 1)

- [ ] Initialize Django project with \`uv run django-admin startproject config .\`
- [ ] Create all Django apps: \`uv run python manage.py startapp <app>\` for each app in \`src/\`
- [ ] Configure \`pyproject.toml\` with all dependencies (see \`pyproject.toml\` in repo root)
- [ ] Set up \`config/base.py\` with \`INSTALLED_APPS\`, middleware stack, \`REST_FRAMEWORK\`, \`SPECTACULAR_SETTINGS\`
- [ ] Create environment-specific settings files (\`development.py\`, \`staging.py\`, \`production.py\`)
- [ ] Add \`config/settings_schema.py\` with Pydantic model validating all env vars at startup
- [ ] Create \`.env.example\` with all required variables documented

### 2. Multi-Tenancy Foundation (Day 1–2)

- [ ] Define \`Tenant\` model with UUID PK, slug, display name, settings JSONField, \`is_active\`, timestamps
- [ ] Define \`TenantMembership\` model (User ↔ Tenant M2M with role field)
- [ ] Create \`TenantScopedModel\` abstract base in \`src/core/models.py\`
- [ ] Implement \`TenantAwareManager\` that filters querysets by current tenant
- [ ] Implement \`TenantMiddleware\` that extracts tenant from subdomain/header and sets context
- [ ] Write \`src/utils/tenant_context.py\` using \`contextvars\` for thread-safe tenant access
- [ ] Create PostgreSQL RLS SQL scripts in \`src/tenants/sql/\`
- [ ] Write tests for tenant isolation (verify cross-tenant data is inaccessible)

### 3. User & Auth Setup (Day 2–3)

- [ ] Define \`CustomUser\` model extending \`AbstractBaseUser\` with email as username
- [ ] Create \`CustomUserManager\` in \`src/accounts/managers.py\`
- [ ] Configure \`AUTH_USER_MODEL = "accounts.CustomUser"\` in settings
- [ ] Set up \`djangorestframework-simplejwt\` with token endpoints
- [ ] Define RBAC permission classes: \`IsTenantOwner\`, \`IsTenantAdmin\`, \`IsTenantMember\`, \`IsTenantViewer\`
- [ ] Write \`UserFactory\` and \`TenantFactory\` with \`factory_boy\`
- [ ] Write auth endpoint tests (token obtain, refresh, permission denial)

### 4. Billing Skeleton (Day 3)

- [ ] Define \`Plan\` model (name, stripe_price_id, features JSON, limits JSON)
- [ ] Define \`Subscription\` model (tenant FK, plan FK, stripe_subscription_id, status, current_period_start/end)
- [ ] Define \`Invoice\` model (tenant FK, stripe_invoice_id, amount, status, pdf_url)
- [ ] Define \`UsageRecord\` model (tenant FK, metric name, quantity, timestamp)
- [ ] Create \`StripeService\` class in \`src/billing/services.py\` (stub methods for create_customer, create_subscription, cancel_subscription)
- [ ] Create webhook handler in \`src/billing/webhooks.py\` with Stripe signature verification
- [ ] Add \`@idempotent_task\` decorator and apply to billing tasks
- [ ] Write \`PlanFactory\`, \`SubscriptionFactory\` with \`factory_boy\`

### 5. Celery & Task Infrastructure (Day 3–4)

- [ ] Create \`config/celery.py\` with app configuration and autodiscover
- [ ] Update \`config/__init__.py\` to export Celery app
- [ ] Define beat schedule in \`src/tasks/schedules.py\`
- [ ] Create smoke-test task \`src/tasks/health.py:ping\`
- [ ] Create \`@idempotent_task\` decorator using Redis SETNX for dedup
- [ ] Create stub tasks: \`sync_stripe_subscriptions\`, \`generate_tenant_report\`, \`send_email_task\`, \`gdpr_data_deletion\`
- [ ] Write task tests using \`celery.contrib.pytest\` (CELERY_ALWAYS_EAGER in test settings)
- [ ] Verify \`celery -A config worker\` starts and executes ping task

### 6. API Scaffolding (Day 4–5)

- [ ] Configure DRF default router in \`src/api/urls.py\`
- [ ] Mount router and Strawberry GraphQL view in \`config/urls.py\`
- [ ] Configure \`drf-spectacular\` in settings (title, version, description, contact, license)
- [ ] Create health-check endpoint at \`/api/health/\` (checks DB, Redis, Celery)
- [ ] Create tenant info endpoint at \`/api/v1/tenants/me/\` (returns current tenant)
- [ ] Create Strawberry root \`Query\` and \`Mutation\` types in \`src/api/schema.py\`
- [ ] Configure cursor-based pagination in \`src/api/pagination.py\`
- [ ] Configure throttling classes in \`src/api/throttling.py\`
- [ ] Verify OpenAPI schema generates at \`/api/schema/\`

### 7. Docker & Local Environment (Day 5–6)

- [ ] Create \`Dockerfile\` (multi-stage: builder with \`uv\`, runtime with slim Python)
- [ ] Create \`docker-compose.yml\` with all services (web, db, redis, worker, beat, mailpit)
- [ ] Create \`docker-compose.override.yml\` for volume mounts and hot-reload
- [ ] Create \`scripts/docker-entrypoint.sh\` (wait for DB, run migrations, collect static, start)
- [ ] Create \`scripts/seed_dev_data.py\` management command
- [ ] Verify \`docker compose up\` brings up full stack
- [ ] Verify \`docker compose exec web uv run pytest\` passes
- [ ] Document local setup in \`docs/ONBOARDING.md\`

### 8. CI Pipeline (Day 6–7)

- [ ] Create \`.github/workflows/ci.yml\` with lint, typecheck, test, security, build jobs
- [ ] Configure PostgreSQL 16 and Redis 7 service containers in CI
- [ ] Set up test coverage reporting with \`pytest-cov\`
- [ ] Set up \`pip-audit\` for dependency vulnerability scanning
- [ ] Set up \`bandit\` for security linting
- [ ] Create \`.github/workflows/deploy-staging.yml\` (triggered on merge to \`main\`)
- [ ] Verify all CI jobs pass on initial push
- [ ] Add CI status badges to \`README.md\`

### 9. Code Quality & Governance (Day 7)

- [ ] Create \`CODEOWNERS\` with path-based ownership for sensitive directories
- [ ] Create \`.github/PULL_REQUEST_TEMPLATE.md\` with checklist (tests, types, tenant isolation, GDPR)
- [ ] Create \`.github/ISSUE_TEMPLATE/\` (bug report, feature request, security vulnerability)
- [ ] Configure branch protection on \`main\` (require reviews, status checks, linear history)
- [ ] Set up pre-commit hooks (ruff, ruff-format, mypy, trailing whitespace, YAML lint)
- [ ] Verify \`pre-commit run --all-files\` passes

### 10. Foundation Verification (Day 7–8)

- [ ] Run full CI pipeline end-to-end
- [ ] Verify Docker Compose local environment works from clean clone
- [ ] Verify \`uv run python manage.py migrate\` creates all tables
- [ ] Verify \`uv run python manage.py seed_dev_data\` creates tenant + admin
- [ ] Verify \`/api/docs/\` renders Swagger UI with all scaffolded endpoints
- [ ] Verify \`/graphql/\` renders GraphiQL in development
- [ ] Verify Celery worker processes ping task
- [ ] Verify tenant isolation: API requests without tenant context return 403
- [ ] Run \`uv run mypy src/ --strict\` with zero errors
- [ ] Run \`uv run ruff check src/ tests/\` with zero violations
- [ ] Confirm test coverage ≥ 85% on foundation code

---

## Quality Gates

All gates must pass before advancing to Phase 04.

| # | Gate | Verification | Owner |
|---|------|-------------|-------|
| QG-1 | All Django apps created with correct structure | \`find src/ -name models.py\` returns one per app | Lead |
| QG-2 | Migrations run cleanly | \`uv run python manage.py migrate --check\` exits 0 | Backend dev |
| QG-3 | Tenant isolation enforced | Test: user in Tenant A cannot read Tenant B data | Backend dev |
| QG-4 | Row-level security policies applied | \`SELECT * FROM pg_policies\` shows tenant policies | Lead |
| QG-5 | Docker Compose full stack starts | \`docker compose up -d && docker compose ps\` all healthy | Any dev |
| QG-6 | CI pipeline green | All GitHub Actions jobs pass on \`main\` | Lead |
| QG-7 | Type checking passes | \`uv run mypy src/ --strict\` exits 0 | Any dev |
| QG-8 | Linting passes | \`uv run ruff check src/ tests/\` exits 0 | Any dev |
| QG-9 | Test suite passes with coverage | \`uv run pytest --cov=src --cov-fail-under=85\` exits 0 | Any dev |
| QG-10 | OpenAPI schema generates | \`curl localhost:8000/api/schema/\` returns valid YAML | Backend dev |
| QG-11 | Celery worker operational | Ping task returns "pong" within 5 seconds | Backend dev |
| QG-12 | Seed data command works | \`uv run python manage.py seed_dev_data\` creates tenant + user | Any dev |
| QG-13 | CODEOWNERS covers sensitive paths | \`billing/\`, \`auth/\`, \`config/production/\`, \`.env*\` all assigned | Lead |
| QG-14 | Pre-commit hooks configured | \`pre-commit run --all-files\` exits 0 | Any dev |
| QG-15 | Onboarding doc tested | New dev can set up local env in < 30 minutes following docs | Junior dev |

---

## Sensitive Path Protections

These paths require additional review per SOC 2 and GDPR compliance:

| Path | Protection | Reviewer |
|------|-----------|----------|
| \`src/billing/**\` | All changes require billing team approval | \`@billing-team\` |
| \`src/accounts/**\` | Auth changes require platform team approval | \`@platform-team\` |
| \`src/tenants/**\` | Tenant isolation changes require lead review | \`@platform-team\` |
| \`config/production/**\` | Production config requires infra lead approval | \`@infra-leads\` |
| \`.env*\` | Environment files require infra lead approval | \`@infra-leads\` |
| \`src/tenants/sql/**\` | RLS policy changes require security review | \`@infra-leads\` + \`@platform-team\` |

---

## Architecture Decisions Locked In This Phase

| Decision | Choice | Rationale |
|----------|--------|-----------|
| Tenant isolation strategy | Row-level security + application-level filtering | Defense in depth; RLS prevents data leaks even if app code has bugs |
| User model | Custom \`AbstractBaseUser\` with email login | SaaS users expect email-based auth; avoids username field |
| Auth mechanism | JWT via \`simplejwt\` | Stateless, works with multi-service architecture |
| Task serialization | JSON only (no pickle) | SOC 2: pickle deserialization is a remote code execution vector |
| API versioning | URL path prefix (\`/api/v1/\`) | Explicit, easy to maintain, clear deprecation path |
| Pagination | Cursor-based | Stable for real-time data; no offset drift on inserts |
| Tenant context propagation | \`contextvars.ContextVar\` | Thread-safe, works with async views, no thread-local hacks |

---

## Risk Mitigation

| Risk | Likelihood | Impact | Mitigation |
|------|-----------|--------|------------|
| RLS policies not applied correctly | Medium | Critical | Automated test that attempts cross-tenant access at SQL level |
| Celery tasks not idempotent | Medium | High | \`@idempotent_task\` decorator enforced via custom ruff rule |
| Settings leak secrets in logs | Low | Critical | Pydantic \`SecretStr\` for sensitive values; Django \`HIDDEN_SETTINGS\` |
| Docker Compose diverges from production | Medium | Medium | Use same Dockerfile; document differences in \`docs/ARCHITECTURE.md\` |
| CI too slow for developer iteration | Medium | Medium | Parallel jobs; cache \`uv\` dependencies; run only affected tests on PR |

---

## Phase Completion Checklist

\`\`\`
[ ] All 10 deliverables (D1–D10) completed
[ ] All 15 quality gates (QG-1–QG-15) passed
[ ] Architecture decisions documented in docs/ARCHITECTURE.md
[ ] CODEOWNERS file reviewed and merged
[ ] CI pipeline runs green on main branch
[ ] Team has verified local setup works (at least 2 developers)
[ ] Phase 03 status updated in playbook/current-phase.json
[ ] Kickoff meeting scheduled for Phase 04: Core Implementation
\`\`\`

Update phase status:

\`\`\`bash
./playbook/codeforge-phase.sh advance 04
\`\`\`

---

## References

- [Playbook Overview](../PLAYBOOK.md)
- [Phase 02 — Architecture & Design](./02-architecture.md)
- [Phase 04 — Core Implementation](./04-core-implementation.md)
- [Onboarding Guide](../../docs/ONBOARDING.md)
- [Contributing Guide](../../docs/CONTRIBUTING.md)
- [AI Usage Policy](../../docs/AI-USAGE-POLICY.md)`,

  'playbook/phases/04-core-implementation.md': `# Phase 04: Core Implementation

## Overview

Core Implementation is the primary build phase where the Django SaaS platform's essential features are developed. This phase transforms the foundation established in Phase 03 into working, tested, production-grade functionality. Work is organized into vertical slices — each slice delivers a complete feature across models, services, API, and tests.

**Duration**: 4–8 weeks (iterative sprints)
**Prerequisites**: Phase 03 (Foundation) quality gates passed
**Team Focus**: All backend and full-stack developers actively contributing

## Objectives

1. **Implement multi-tenancy with row-level security** — tenant model, middleware, PostgreSQL RLS policies, tenant-aware querysets
2. **Build user management and RBAC** — registration, authentication, tenant association, role-based permissions
3. **Integrate Stripe billing** — subscription plans, checkout, usage metering, invoice sync, webhook processing
4. **Deliver REST and GraphQL APIs** — DRF viewsets and Strawberry schema for all core resources with OpenAPI documentation
5. **Implement async task processing** — Celery tasks for billing sync, notifications, report generation, cleanup jobs
6. **Build notification system** — transactional email via SES, in-app notifications, webhook dispatch to tenant endpoints
7. **Add audit logging** — track all state-changing operations with tenant context, user identity, and change details
8. **Establish white-label support** — per-tenant branding configuration, custom domain mapping

## Deliverables

### 4.1 Multi-Tenancy (\`src/tenants/\`)

| Deliverable | Description |
|---|---|
| \`models.py\` | \`Tenant\` model with slug, plan reference, settings JSON, status, metadata |
| \`middleware.py\` | Request middleware that resolves tenant from subdomain/header and sets \`current_tenant\` on thread-local and request |
| \`managers.py\` | \`TenantAwareManager\` that automatically filters querysets by current tenant |
| \`rls.py\` | Django management command to apply PostgreSQL row-level security policies to tenant-scoped tables |
| \`context.py\` | Context manager and utility for setting tenant in non-request contexts (Celery tasks, management commands) |
| \`serializers.py\` | Tenant onboarding serializer with validation (slug uniqueness, plan existence) |
| \`views.py\` | Tenant provisioning endpoint, tenant settings CRUD |
| \`signals.py\` | Post-create signal for tenant provisioning (create schema defaults, seed data) |
| \`tests/\` | Unit tests for manager filtering, middleware resolution, RLS policy enforcement |

**Acceptance Criteria**:
- All data queries pass through \`TenantAwareManager\` — no raw queries without explicit tenant filter
- RLS policies enforced at database level as defense-in-depth
- Tenant context propagated to Celery tasks via task headers
- Cross-tenant data leakage test suite passes (attempt to access Tenant B data from Tenant A context)

### 4.2 User Management & RBAC (\`src/accounts/\`)

| Deliverable | Description |
|---|---|
| \`models.py\` | Custom \`User\` model, \`TenantMembership\` (user ↔ tenant with role), \`Invitation\` model |
| \`roles.py\` | Role definitions: \`owner\`, \`admin\`, \`member\`, \`viewer\`, \`billing_admin\` with permission sets |
| \`permissions.py\` | DRF permission classes: \`IsTenantMember\`, \`IsTenantAdmin\`, \`IsTenantOwner\`, \`HasPermission(perm)\` |
| \`services.py\` | \`UserService\` — registration, invitation acceptance, role changes, deactivation |
| \`serializers.py\` | Registration, login, profile, invitation, membership serializers |
| \`views.py\` | Auth endpoints (register, login, token refresh, password reset), membership management |
| \`backends.py\` | Custom authentication backend with tenant-scoped token validation |
| \`tests/\` | Permission matrix tests, invitation flow tests, role escalation prevention tests |

**Acceptance Criteria**:
- Users can belong to multiple tenants with different roles
- Permission checks enforced at view layer AND service layer
- Invitation tokens expire after 72 hours
- Password reset follows OWASP guidelines
- GDPR: users can request data export and account deletion

### 4.3 Stripe Billing Integration (\`src/billing/\`)

| Deliverable | Description |
|---|---|
| \`models.py\` | \`Plan\`, \`Subscription\`, \`Invoice\`, \`PaymentMethod\`, \`UsageRecord\`, \`BillingEvent\` |
| \`services.py\` | \`SubscriptionService\` — create, upgrade, downgrade, cancel, reactivate; \`UsageMeteringService\` — report usage, calculate overages |
| \`stripe_client.py\` | Thin wrapper around Stripe SDK with retry logic, idempotency keys, error mapping |
| \`webhooks.py\` | Webhook endpoint with signature verification, event deduplication, handler dispatch |
| \`handlers.py\` | Handlers for: \`invoice.paid\`, \`invoice.payment_failed\`, \`customer.subscription.updated\`, \`customer.subscription.deleted\`, \`checkout.session.completed\` |
| \`tasks.py\` | \`sync_subscription_status\`, \`sync_invoices\`, \`report_usage_to_stripe\`, \`handle_payment_failure_notification\` |
| \`serializers.py\` | Plan listing, subscription management, billing portal session, usage summary |
| \`views.py\` | Plan selection, checkout session creation, subscription management, invoice history, usage dashboard |
| \`tests/\` | Webhook handler tests with Stripe fixture events, subscription lifecycle tests, usage metering accuracy tests |

**Acceptance Criteria**:
- All Stripe webhook handlers are idempotent (processing same event twice produces same result)
- Webhook signatures verified using \`stripe.Webhook.construct_event\`
- Billing events logged to \`BillingEvent\` for audit trail
- Subscription state machine: \`trialing\` → \`active\` → \`past_due\` → \`canceled\` with proper transitions
- Usage records aggregated and reported to Stripe within 5-minute windows
- Failed payment triggers notification flow (email + in-app)
- SOC 2: no raw card data stored — all PCI-sensitive data stays in Stripe

### 4.4 REST & GraphQL API (\`src/api/\`)

| Deliverable | Description |
|---|---|
| \`urls.py\` | Versioned URL configuration: \`/api/v1/\` for REST, \`/api/graphql/\` for GraphQL |
| \`viewsets.py\` | DRF viewsets for tenants, users, memberships, subscriptions, invoices |
| \`schema.py\` | Strawberry GraphQL schema with queries, mutations, and subscriptions for core entities |
| \`filters.py\` | DRF filter backends for date ranges, status, search across tenant-scoped data |
| \`pagination.py\` | Cursor-based pagination for list endpoints |
| \`throttling.py\` | Per-tenant rate limiting (configurable by plan tier) |
| \`spectacular.py\` | drf-spectacular configuration, custom schema extensions, example generation |
| \`middleware.py\` | API versioning middleware, request ID injection, response timing headers |
| \`tests/\` | API contract tests, pagination tests, rate limiting tests, schema snapshot tests |

**Acceptance Criteria**:
- All REST endpoints documented in OpenAPI 3.1 via drf-spectacular
- GraphQL schema has type-safe resolvers with Strawberry (no \`Any\` types)
- Rate limits enforced per tenant: Free (100 req/min), Pro (1000 req/min), Enterprise (custom)
- All list endpoints support cursor-based pagination
- API responses include \`X-Request-ID\` and \`X-Tenant-ID\` headers
- Breaking changes require API version bump

### 4.5 Async Task Processing (\`src/tasks/\`)

| Deliverable | Description |
|---|---|
| \`billing_tasks.py\` | \`sync_stripe_subscriptions\`, \`process_usage_batch\`, \`generate_invoice_pdf\` |
| \`notification_tasks.py\` | \`send_transactional_email\`, \`dispatch_webhook\`, \`send_in_app_notification\` |
| \`report_tasks.py\` | \`generate_tenant_usage_report\`, \`generate_admin_analytics\` |
| \`maintenance_tasks.py\` | \`cleanup_expired_invitations\`, \`rotate_audit_logs\`, \`purge_soft_deleted_records\` |
| \`base.py\` | \`TenantAwareTask\` base class that sets tenant context from task headers |
| \`schedules.py\` | Celery Beat schedule definitions for periodic tasks |
| \`tests/\` | Task idempotency tests, retry behavior tests, tenant context propagation tests |

**Acceptance Criteria**:
- All tasks inherit from \`TenantAwareTask\` and have tenant context available
- All tasks are idempotent — safe to retry on failure
- Tasks define explicit \`max_retries\`, \`retry_backoff\`, and \`retry_jitter\`
- Failed tasks logged to Sentry with tenant and user context
- Beat schedule covers: usage sync (every 5 min), invoice sync (hourly), cleanup (daily), reports (weekly)
- Task results stored in Redis with 24-hour TTL

### 4.6 Notifications (\`src/notifications/\`)

| Deliverable | Description |
|---|---|
| \`models.py\` | \`Notification\` (in-app), \`NotificationPreference\`, \`WebhookEndpoint\`, \`WebhookDelivery\` |
| \`services.py\` | \`NotificationService\` — create, mark read, bulk operations; \`WebhookService\` — register, deliver, retry |
| \`email.py\` | Email builder using Django templates, SES backend integration |
| \`dispatchers.py\` | Multi-channel dispatcher (email, in-app, webhook) based on user preferences |
| \`templates/\` | Email templates: welcome, invitation, payment failed, subscription changed, usage alert |
| \`tasks.py\` | Async delivery tasks for each channel |
| \`tests/\` | Delivery tests, preference filtering tests, webhook retry tests |

**Acceptance Criteria**:
- Users can configure notification preferences per channel per event type
- Webhook deliveries retry with exponential backoff (3 attempts over 1 hour)
- Webhook payloads signed with tenant-specific secret (HMAC-SHA256)
- Email templates support white-label branding (logo, colors, sender name)
- GDPR: notification preferences respect marketing consent

### 4.7 Audit Logging (\`src/core/audit.py\`, \`src/core/models.py\`)

| Deliverable | Description |
|---|---|
| \`audit.py\` | \`AuditLog\` model: tenant, user, action, resource type, resource ID, changes (JSON), IP, timestamp |
| \`mixins.py\` | \`AuditableMixin\` for models — auto-logs create, update, delete via signals |
| \`middleware.py\` | Captures request metadata (IP, user agent) for audit context |
| \`services.py\` | \`AuditService\` — query logs with filtering, export for compliance |
| \`tasks.py\` | \`archive_audit_logs\` — move logs older than retention period to cold storage (S3) |
| \`tests/\` | Audit trail completeness tests, tamper-evidence tests |

**Acceptance Criteria**:
- All state-changing operations on tenant data produce audit log entries
- Audit logs are append-only (no update/delete at application level)
- Logs include before/after state for updates
- SOC 2: audit logs retained for 1 year, archived to S3 after 90 days
- GDPR: audit logs for deleted users are anonymized (user ID replaced with hash)

### 4.8 White-Label Support (\`src/tenants/branding.py\`)

| Deliverable | Description |
|---|---|
| \`branding.py\` | \`TenantBranding\` model: logo, favicon, primary color, accent color, custom CSS, email sender name |
| \`domains.py\` | \`TenantDomain\` model: custom domain mapping, SSL certificate status |
| \`middleware.py\` | Domain resolution middleware — map custom domain to tenant |
| \`context_processors.py\` | Inject branding into template context |
| \`tests/\` | Domain resolution tests, branding inheritance tests |

**Acceptance Criteria**:
- Tenants on Enterprise plan can configure custom domains
- Branding applied to emails, admin portal, and API documentation
- Default branding inherited when tenant has no custom configuration
- Custom domains validated via DNS CNAME check

## Implementation Order

Execute in this sequence to manage dependencies:

\`\`\`
Sprint 1 (Week 1-2):
  ├── 4.1 Multi-Tenancy (foundation for everything)
  ├── 4.2 User Management & RBAC (depends on tenants)
  └── 4.7 Audit Logging (integrate early, captures all subsequent work)

Sprint 2 (Week 3-4):
  ├── 4.5 Async Task Processing (needed by billing and notifications)
  ├── 4.3 Stripe Billing (depends on tenants, tasks)
  └── 4.4 REST & GraphQL API (expose tenants, users, billing)

Sprint 3 (Week 5-6):
  ├── 4.6 Notifications (depends on tasks, billing events)
  ├── 4.8 White-Label Support (depends on tenants)
  └── Integration testing across all modules

Sprint 4 (Week 7-8):
  ├── End-to-end flow testing
  ├── Performance optimization
  ├── Security hardening
  └── Documentation completion
\`\`\`

## Development Workflow

### Branch Strategy

Each deliverable gets its own feature branch:

\`\`\`bash
# Example branches
feat/SAAS-101-tenant-model-and-middleware
feat/SAAS-102-tenant-aware-manager-rls
feat/SAAS-110-user-model-rbac
feat/SAAS-120-stripe-subscription-service
feat/SAAS-121-stripe-webhook-handlers
feat/SAAS-130-celery-tenant-aware-task
\`\`\`

### TDD Cycle for Each Feature

\`\`\`bash
# 1. Write failing tests
uv run pytest tests/tenants/test_middleware.py -x  # RED

# 2. Implement minimum code to pass
# Edit src/tenants/middleware.py

# 3. Verify tests pass
uv run pytest tests/tenants/test_middleware.py -x  # GREEN

# 4. Refactor with confidence
uv run ruff check src/tenants/
uv run ruff format src/tenants/
uv run mypy src/tenants/

# 5. Run full suite before PR
uv run pytest --cov=src --cov-fail-under=85
\`\`\`

### Service Layer Pattern

All business logic lives in service modules, not views or serializers:

\`\`\`python
# src/billing/services.py — example structure
class SubscriptionService:
    """Manages subscription lifecycle with Stripe integration."""

    def create_subscription(
        self, tenant: Tenant, plan: Plan, payment_method_id: str
    ) -> Subscription:
        """Create a new subscription for a tenant.

        Raises:
            BillingError: If Stripe API call fails after retries.
            PlanNotAvailableError: If plan is not active or tenant is ineligible.
        """
        ...

    def cancel_subscription(
        self, subscription: Subscription, at_period_end: bool = True
    ) -> Subscription:
        ...
\`\`\`

### Celery Task Pattern

\`\`\`python
# src/tasks/base.py — all tasks inherit from this
class TenantAwareTask(celery.Task):
    """Base task that restores tenant context from task headers."""

    def apply_async(self, args=None, kwargs=None, **options):
        # Inject current tenant ID into headers
        ...

    def __call__(self, *args, **kwargs):
        # Restore tenant context before task execution
        ...
\`\`\`

## Quality Gates

All gates must pass before Phase 04 is considered complete.

### Gate 1: Test Coverage & Quality

| Metric | Threshold |
|---|---|
| Overall test coverage | ≥ 85% |
| Coverage on \`src/billing/\` | ≥ 90% |
| Coverage on \`src/accounts/\` | ≥ 90% |
| Coverage on \`src/tenants/\` | ≥ 90% |
| All tests passing | 100% |
| No skipped tests without ticket reference | 0 |

\`\`\`bash
uv run pytest --cov=src --cov-fail-under=85 --cov-report=term-missing
uv run pytest tests/billing/ --cov=src/billing --cov-fail-under=90
uv run pytest tests/accounts/ --cov=src/accounts --cov-fail-under=90
uv run pytest tests/tenants/ --cov=src/tenants --cov-fail-under=90
\`\`\`

### Gate 2: Code Quality

| Check | Command | Threshold |
|---|---|---|
| Linting | \`uv run ruff check src/ tests/\` | 0 errors |
| Formatting | \`uv run ruff format --check src/ tests/\` | 0 diffs |
| Type checking | \`uv run mypy src/\` | 0 errors |
| File length | Custom check | No file > 300 lines |
| No \`# type: ignore\` without explanation | Grep check | 0 bare ignores |

### Gate 3: Security

| Check | Criteria |
|---|---|
| Tenant isolation | Cross-tenant data access tests pass (0 leaks) |
| RLS policies | PostgreSQL RLS enabled on all tenant-scoped tables |
| Stripe webhook verification | All webhook endpoints verify signatures |
| Authentication | All API endpoints require authentication (except public plan listing) |
| RBAC enforcement | Permission matrix tests cover all role × endpoint combinations |
| Secrets | No secrets in code (\`uv run ruff check --select S\` + \`detect-secrets scan\`) |
| SQL injection | No raw SQL without parameterized queries |
| GDPR | Data export and deletion endpoints functional |

### Gate 4: API Completeness

| Check | Criteria |
|---|---|
| OpenAPI schema | \`uv run python manage.py spectacular --validate\` passes |
| All endpoints documented | No undocumented viewsets or actions |
| GraphQL schema | \`uv run python manage.py export_schema --check\` passes |
| API versioning | All endpoints under \`/api/v1/\` |
| Error responses | Consistent error format across all endpoints |
| Rate limiting | Throttle classes configured on all viewsets |

### Gate 5: Billing Integration

| Check | Criteria |
|---|---|
| Subscription lifecycle | Create → upgrade → downgrade → cancel flow tested end-to-end |
| Webhook handlers | All critical Stripe events handled and tested with fixture data |
| Idempotency | Duplicate webhook delivery produces no side effects |
| Usage metering | Usage records accurately aggregated and reported |
| Invoice sync | Stripe invoices synced to local \`Invoice\` model |
| Payment failure | Failed payment triggers notification and subscription status update |

### Gate 6: Task Processing

| Check | Criteria |
|---|---|
| Tenant context | All tasks receive and restore tenant context |
| Idempotency | All tasks safe to retry (tested with duplicate execution) |
| Error handling | Failed tasks logged to Sentry with full context |
| Beat schedule | All periodic tasks registered and tested |
| Monitoring | Task success/failure metrics exported to Prometheus |

### Gate 7: Documentation

| Check | Criteria |
|---|---|
| API docs | OpenAPI spec generated and accessible at \`/api/docs/\` |
| Architecture | \`docs/architecture.md\` updated with implemented components |
| Runbooks | \`docs/runbooks/\` includes: tenant provisioning, billing troubleshooting, task monitoring |
| ADRs | Architecture Decision Records for: tenant isolation strategy, billing integration approach, task queue design |

## Verification Commands

Run the full verification suite:

\`\`\`bash
# Lint and format
uv run ruff check src/ tests/
uv run ruff format --check src/ tests/

# Type checking
uv run mypy src/

# Tests with coverage
uv run pytest --cov=src --cov-fail-under=85 -x -q

# Security-sensitive module coverage
uv run pytest tests/billing/ --cov=src/billing --cov-fail-under=90
uv run pytest tests/accounts/ --cov=src/accounts --cov-fail-under=90
uv run pytest tests/tenants/ --cov=src/tenants --cov-fail-under=90

# Cross-tenant isolation tests
uv run pytest tests/tenants/test_isolation.py -v

# API schema validation
uv run python manage.py spectacular --validate --fail-on-warn

# Django system checks
uv run python manage.py check --deploy

# Migrations consistency
uv run python manage.py makemigrations --check --dry-run
\`\`\`

## Risk Mitigation

| Risk | Mitigation |
|---|---|
| Stripe API rate limits during development | Use Stripe test mode with fixtures; mock in unit tests, real API in integration tests only |
| Tenant data leakage | Defense-in-depth: application-level manager filtering + PostgreSQL RLS + integration tests that assert isolation |
| Celery task failures losing billing data | Tasks are idempotent with retry; critical billing operations use database transactions with Stripe idempotency keys |
| Schema migrations on shared database | Test migrations against production-like data volume; use \`--run-syncdb\` checks in CI |
| Scope creep during implementation | Each deliverable has explicit acceptance criteria; features not listed here go to Phase 05 |

## Phase Transition

When all quality gates pass, update the phase tracker:

\`\`\`bash
./playbook/codeforge-phase.sh set 5
\`\`\`

Phase 05 (Hardening & Optimization) focuses on performance tuning, load testing, security penetration testing, and production readiness. No new features are added — only improvements to what was built in Phase 04.

## References

- [Phase 03: Foundation](./03-foundation.md) — prerequisites and base infrastructure
- [Phase 05: Hardening & Optimization](./05-hardening.md) — next phase
- [Playbook Overview](../PLAYBOOK.md) — full phase lifecycle
- [TDD Skill](../../plugin/codeforge-django-saas/skills/tdd/SKILL.md) — test-driven development workflow
- [Verify Skill](../../plugin/codeforge-django-saas/skills/verify/SKILL.md) — quality gate verification`,

  'playbook/phases/05-integration-hardening.md': `# Phase 05 — Integration & Hardening

## Overview

Phase 05 focuses on connecting all Django SaaS platform components into a cohesive, production-grade system. This phase integrates the tenant-aware data layer with Stripe billing, wires Celery task pipelines end-to-end, hardens security boundaries between tenants, and validates the full request lifecycle from API ingress through database row-level security to webhook dispatch. The goal is a system that behaves correctly under realistic multi-tenant load, handles failure gracefully, and meets SOC 2 and GDPR compliance requirements.

## Prerequisites

- Phase 03 (Foundation) and Phase 04 (Core Development) deliverables complete
- All Django apps (\`accounts\`, \`tenants\`, \`billing\`, \`api\`, \`core\`, \`notifications\`, \`tasks\`) have passing unit tests at ≥85% coverage
- Stripe test-mode integration functional for subscription CRUD
- Celery workers and beat scheduler running against Redis broker in development
- PostgreSQL row-level security policies applied to all tenant-scoped tables
- CI pipeline (lint, type check, unit tests) green on \`main\`

## Objectives

### 1. End-to-End API Integration

- Wire DRF viewsets and Strawberry GraphQL resolvers through the full stack: authentication → tenant middleware → service layer → tenant-aware ORM manager → PostgreSQL RLS
- Validate that every API endpoint returns correct OpenAPI 3.1 schema via drf-spectacular
- Confirm GraphQL queries and mutations respect tenant isolation and RBAC permissions
- Test API pagination, filtering, and error responses against the OpenAPI contract

### 2. Stripe Billing Pipeline Hardening

- Integrate the complete subscription lifecycle: tenant onboarding → plan selection → Stripe Checkout → webhook confirmation → subscription activation → usage metering → invoice generation
- Verify webhook idempotency: replaying any Stripe webhook event produces no duplicate side effects
- Test subscription state transitions: trial → active → past_due → canceled → reactivated
- Validate usage-based metering: Celery tasks aggregate usage, report to Stripe, and reconcile with local billing records
- Confirm dunning flow: failed payment → retry → grace period → suspension → data retention per GDPR

### 3. Celery Task Pipeline Validation

- Verify all Celery tasks are idempotent by running each task multiple times with the same arguments
- Test task retry behavior with exponential backoff for transient failures (Stripe API errors, SES throttling, Redis timeouts)
- Validate beat-scheduled tasks: billing sync, usage aggregation, report generation, stale session cleanup
- Confirm dead-letter handling: tasks that exhaust retries are logged to Sentry and recorded in the audit log
- Load-test task throughput: ensure worker pool handles expected concurrent task volume without memory leaks

### 4. Multi-Tenant Security Hardening

- **Cross-tenant isolation audit**: Write integration tests that attempt to access Tenant A data while authenticated as Tenant B — every attempt must return 403 or empty results
- **Row-level security verification**: Run raw SQL queries bypassing Django ORM to confirm PostgreSQL RLS policies block cross-tenant reads and writes
- **Tenant context propagation**: Verify tenant context flows correctly through middleware → views → service layer → Celery tasks → notification dispatch
- **Admin superuser boundaries**: Confirm Django admin access is scoped and audit-logged; superusers cannot accidentally leak tenant data in API responses
- **Session and token isolation**: Validate that JWT tokens and session cookies are tenant-scoped and cannot be reused across tenants

### 5. RBAC and Permission Hardening

- Test all permission combinations: owner, admin, member, read-only, billing-only across every API endpoint
- Verify object-level permissions on DRF viewsets and GraphQL resolvers
- Confirm invitation and role-change flows enforce permission hierarchy (members cannot escalate to admin)
- Test API key authentication for machine-to-machine integrations with scoped permissions

### 6. Notification and Webhook Integration

- End-to-end test: trigger event → Celery task → SES email delivery (via localstack or SES sandbox)
- Verify in-app notification creation and WebSocket delivery (if applicable)
- Test outgoing webhook dispatch: event → serialization → HMAC signing → HTTP delivery → retry on failure
- Validate webhook payload schema stability and backward compatibility

### 7. Caching and Performance Hardening

- Verify Redis caching layer: tenant settings, subscription status, permission lookups are cached and invalidated correctly
- Test cache stampede protection on high-traffic endpoints
- Confirm cache isolation: Tenant A cache keys never collide with or leak into Tenant B
- Profile critical API endpoints under load; identify and resolve N+1 queries with \`django-debug-toolbar\` and \`nplusone\`

### 8. Error Handling and Observability

- Verify Sentry integration captures errors with tenant context, user context, and request metadata
- Confirm structured logging (JSON) includes \`tenant_id\`, \`user_id\`, \`request_id\`, \`correlation_id\` on every log line
- Test Prometheus metrics: request latency histograms, task queue depth, Stripe webhook processing time, error rates by tenant
- Validate health check endpoints: \`/health/live\` (process alive), \`/health/ready\` (DB + Redis + Celery connectivity)
- Confirm Grafana dashboards render correctly with test data

### 9. Data Integrity and Migration Hardening

- Run full migration sequence from empty database to current schema; verify idempotency with \`uv run python manage.py migrate && uv run python manage.py migrate\`
- Test data migration scripts for correctness and rollback safety
- Verify database constraints: unique constraints, foreign keys, check constraints on subscription states
- Confirm audit log captures all write operations on sensitive models (\`billing\`, \`accounts\`, \`tenants\`)

### 10. GDPR and Compliance Hardening

- Test right-to-deletion flow: user requests deletion → Celery task anonymizes PII across all tables → Stripe customer archived → confirmation email sent
- Verify data export endpoint: user requests data export → Celery task generates JSON/CSV → signed S3 URL delivered via email
- Confirm consent tracking: all consent records are timestamped, versioned, and queryable
- Validate data residency: tenant data is stored in the configured AWS region; cross-region replication respects data residency settings
- Test DPA (Data Processing Agreement) acceptance flow during tenant onboarding

## Deliverables

| # | Deliverable | Format | Location |
|---|-------------|--------|----------|
| 1 | Integration test suite (API end-to-end) | pytest tests | \`tests/integration/\` |
| 2 | Cross-tenant isolation test suite | pytest tests | \`tests/security/test_tenant_isolation.py\` |
| 3 | Stripe webhook idempotency tests | pytest tests | \`tests/integration/billing/test_webhook_idempotency.py\` |
| 4 | Celery task idempotency tests | pytest tests | \`tests/integration/tasks/test_task_idempotency.py\` |
| 5 | RBAC permission matrix tests | pytest tests | \`tests/integration/test_permissions_matrix.py\` |
| 6 | Load test scripts and results | Locust scripts + report | \`tests/load/\` and \`docs/load-test-results.md\` |
| 7 | GDPR compliance test suite | pytest tests | \`tests/compliance/test_gdpr.py\` |
| 8 | Hardened health check endpoints | Django views | \`src/core/views/health.py\` |
| 9 | Prometheus metrics configuration | Django middleware + config | \`src/core/middleware/metrics.py\` |
| 10 | Sentry integration with tenant context | Django middleware | \`src/core/middleware/sentry_context.py\` |
| 11 | Security hardening checklist (completed) | Markdown | \`docs/security-hardening-checklist.md\` |
| 12 | Integration test CI stage | GitHub Actions workflow | \`.github/workflows/integration-tests.yml\` |
| 13 | Runbook: incident response for billing failures | Markdown | \`docs/runbooks/billing-incident-response.md\` |
| 14 | Runbook: tenant data deletion | Markdown | \`docs/runbooks/tenant-data-deletion.md\` |

## Quality Gates

All gates must pass before advancing to Phase 06 (Pre-Production & Launch).

### Gate 1: Test Coverage and Results

- [ ] Unit test coverage ≥ 85% across all Django apps
- [ ] Integration test coverage ≥ 70% for critical paths (billing, auth, tenant isolation)
- [ ] Zero failing tests on \`main\` branch
- [ ] \`uv run pytest tests/integration/ -x --tb=short\` passes in CI

### Gate 2: Multi-Tenant Isolation

- [ ] Cross-tenant data access tests pass (100% of attempts blocked)
- [ ] PostgreSQL RLS policies verified via raw SQL test suite
- [ ] Tenant context propagation verified through Celery task chain
- [ ] Redis cache key isolation verified under concurrent tenant load
- [ ] Security review sign-off from a senior or lead developer

### Gate 3: Stripe Billing Integrity

- [ ] Full subscription lifecycle test passes (trial → active → canceled → reactivated)
- [ ] Webhook idempotency verified: every webhook type replayed 3x with no side effects
- [ ] Usage metering reconciliation: local records match Stripe usage records within 1% tolerance
- [ ] Dunning flow tested: failed payment → suspension → data preserved per GDPR retention policy
- [ ] \`uv run pytest tests/integration/billing/ -v\` all green

### Gate 4: Celery Task Reliability

- [ ] All tasks pass idempotency test (run 3x, assert single effect)
- [ ] Retry behavior verified for each failure mode (network, rate limit, invalid data)
- [ ] Beat schedule produces expected task executions over a 24-hour simulation
- [ ] Dead-letter tasks logged to Sentry with full context
- [ ] No memory leaks detected during 1-hour sustained task processing

### Gate 5: API Contract Compliance

- [ ] OpenAPI schema generated by \`drf-spectacular\` validates against OpenAPI 3.1 spec
- [ ] All DRF viewsets have explicit serializer classes (no implicit serialization)
- [ ] GraphQL schema introspection returns expected types and resolvers
- [ ] API versioning strategy documented and enforced in URL routing
- [ ] \`uv run python manage.py spectacular --validate --fail-on-warn\` passes

### Gate 6: Observability

- [ ] Sentry captures errors with \`tenant_id\`, \`user_id\`, \`request_id\` tags
- [ ] Structured JSON logs include correlation IDs on all log lines
- [ ] Prometheus metrics endpoint (\`/metrics\`) returns request latency, error rate, task queue depth
- [ ] Health check endpoints return correct status for degraded dependencies
- [ ] Grafana dashboard reviewed and approved by ops lead

### Gate 7: Security and Compliance

- [ ] \`uv run ruff check src/\` — zero violations
- [ ] \`uv run mypy src/ --strict\` — zero errors
- [ ] Security scan (bandit or safety) reports zero high-severity findings
- [ ] GDPR right-to-deletion flow tested end-to-end
- [ ] Data export flow tested end-to-end
- [ ] Audit log captures all mutations on \`billing\`, \`accounts\`, \`tenants\` models
- [ ] Security hardening checklist completed and signed off

### Gate 8: Performance Baseline

- [ ] P95 API response time < 200ms for read endpoints under 100 concurrent users
- [ ] P95 API response time < 500ms for write endpoints under 50 concurrent users
- [ ] Celery task processing latency P95 < 5s for standard tasks
- [ ] No N+1 queries detected on any API endpoint (verified via \`nplusone\`)
- [ ] Load test results documented in \`docs/load-test-results.md\`

### Gate 9: CI/CD Pipeline

- [ ] Integration test stage added to GitHub Actions and passing
- [ ] Docker image builds successfully with all integration dependencies
- [ ] Staging deployment completes without manual intervention
- [ ] E2E smoke test passes against staging environment
- [ ] AI-generated code flagged with \`# AI-generated\` comment where applicable

## Key Commands

\`\`\`bash
# Run full integration test suite
uv run pytest tests/integration/ -v --tb=short

# Run cross-tenant isolation tests
uv run pytest tests/security/test_tenant_isolation.py -v

# Run billing integration tests against Stripe test mode
STRIPE_TEST_MODE=true uv run pytest tests/integration/billing/ -v

# Run Celery task idempotency tests
uv run pytest tests/integration/tasks/test_task_idempotency.py -v

# Validate OpenAPI schema
uv run python manage.py spectacular --validate --fail-on-warn

# Run type checking
uv run mypy src/ --strict

# Run security scan
uv run bandit -r src/ -ll

# Run load tests
uv run locust -f tests/load/locustfile.py --headless -u 100 -r 10 --run-time 5m

# Check migration integrity
uv run python manage.py migrate --check
uv run python manage.py showmigrations --list | grep -v '\\[X\\]'

# Verify health endpoints
curl -s http://localhost:8000/health/live | jq .
curl -s http://localhost:8000/health/ready | jq .

# Run GDPR compliance tests
uv run pytest tests/compliance/test_gdpr.py -v
\`\`\`

## Risk Mitigation

| Risk | Impact | Mitigation |
|------|--------|------------|
| Stripe webhook delivery failures in production | Billing state drift | Implement reconciliation Celery beat task that syncs Stripe subscription state every 6 hours |
| Cross-tenant data leak via ORM bypass | SOC 2 violation, data breach | PostgreSQL RLS as defense-in-depth; integration tests that use raw SQL to verify isolation |
| Celery task queue backlog under load | Delayed billing, stale notifications | Separate queues for billing (high priority), notifications (medium), reports (low); autoscaling worker pools |
| Cache poisoning across tenants | Data leak, incorrect billing display | Prefix all Redis keys with \`tenant:{tenant_id}:\`; integration test verifying key isolation |
| Migration failure on production data | Downtime, data corruption | Test migrations against anonymized production data snapshot; always provide reverse migrations |
| GDPR deletion incomplete | Regulatory fine | Deletion task produces audit report listing all tables affected; compliance test verifies no PII remains |

## Coordination Notes

- **Billing integration** touches \`src/billing/\`, \`src/tasks/\`, and \`src/notifications/\` — coordinate across developers working in these apps
- **Security hardening** requires review from a senior/lead developer before gate sign-off
- **Load testing** should run against a staging environment that mirrors production topology (ECS, RDS, ElastiCache)
- **Cross-timezone handoff**: Document integration test failures in GitHub Issues with \`integration-hardening\` label; use Slack \`#saas-platform-integration\` channel for async coordination
- Refer to \`playbook/phases/02-architecture.md\` for system design decisions and \`playbook/phases/03-foundation.md\` for base infrastructure setup

## Phase Completion

When all quality gates are checked off:

1. Create a PR titled \`chore: phase-05 integration hardening sign-off\` with the completed checklist
2. Obtain approval from at least one senior/lead developer and one security reviewer
3. Update \`playbook/current-phase.json\` to \`{"current_phase": 6, "status": "active"}\`
4. Proceed to Phase 06 — Pre-Production & Launch`,

  'playbook/phases/06-testing-quality.md': `# Phase 06 — Testing & Quality

## Overview

Establish comprehensive testing infrastructure and quality assurance practices for the Django SaaS platform. This phase ensures every layer — from tenant isolation and billing logic to API contracts and async task processing — is covered by automated tests with clear quality gates enforced in CI.

## Objectives

1. **Achieve ≥85% code coverage** across all Django apps with meaningful, non-trivial tests
2. **Validate multi-tenant data isolation** with dedicated test suites proving row-level security
3. **Verify Stripe billing flows** end-to-end using stripe-mock and recorded fixtures
4. **Confirm Celery task idempotency** under retry and duplicate-delivery scenarios
5. **Establish API contract testing** for both REST (DRF) and GraphQL (Strawberry) endpoints
6. **Enforce quality gates** in CI that block merges on regressions
7. **Document testing conventions** so every team member writes consistent, maintainable tests

## Prerequisites

- Phase 03 (Foundation) complete — project skeleton, CI pipeline, database migrations
- Phase 04 (Core Backend) complete — models, services, API endpoints exist to test
- Phase 05 (Integration) complete — Stripe, Celery, Redis integrations wired up
- Docker Compose environment running PostgreSQL 16, Redis, and stripe-mock
- \`factory_boy\` factories defined for all core models

## Deliverables

### 6.1 Test Infrastructure & Configuration

- **\`conftest.py\` (root)** — Shared pytest fixtures: \`tenant\`, \`authenticated_client\`, \`stripe_mock\`, \`celery_eager\`, \`redis_cache\`
- **\`tests/conftest.py\`** — App-level fixture composition, database transaction isolation per test
- **\`pytest.ini\` / \`pyproject.toml [tool.pytest]\`** — Markers (\`unit\`, \`integration\`, \`e2e\`, \`billing\`, \`slow\`), async mode, coverage config
- **\`docker-compose.test.yml\`** — Isolated test services (PostgreSQL, Redis, stripe-mock) with ephemeral volumes
- **Factory definitions** — \`tests/factories/\` with \`TenantFactory\`, \`UserFactory\`, \`SubscriptionFactory\`, \`InvoiceFactory\`, \`PlanFactory\`, \`RoleFactory\`

### 6.2 Unit Tests (per Django App)

Each app in \`src/\` must have a corresponding \`tests/\` directory with:

| App | Key Test Areas | Min Coverage |
|---|---|---|
| \`tenants\` | Tenant creation, slug uniqueness, tenant-aware manager filtering, middleware injection | 90% |
| \`accounts\` | Registration, login, password reset, role assignment, tenant membership | 90% |
| \`billing\` | Plan selection, subscription create/update/cancel, usage metering calculations, invoice generation | 95% |
| \`core\` | Base model behaviors, permission classes, tenant-aware querysets | 90% |
| \`api\` | Serializer validation, viewset permissions, pagination, error formatting | 85% |
| \`notifications\` | Email rendering, webhook payload construction, notification preferences | 85% |
| \`tasks\` | Task idempotency, retry behavior, error handling, result serialization | 90% |
| \`utils\` | Decorators, logging helpers, date utilities | 85% |

### 6.3 Multi-Tenant Isolation Tests

- **\`tests/tenants/test_row_level_security.py\`** — Prove that queries scoped to Tenant A never return Tenant B data
- **\`tests/tenants/test_cross_tenant_access.py\`** — Verify API endpoints reject cross-tenant resource access with \`403\`
- **\`tests/tenants/test_tenant_middleware.py\`** — Confirm tenant resolution from subdomain, header, and JWT claim
- **\`tests/tenants/test_admin_isolation.py\`** — Validate Django admin respects tenant boundaries for non-superusers
- **\`tests/tenants/test_cascade_deletion.py\`** — Ensure tenant deletion cascades correctly and triggers GDPR cleanup tasks

### 6.4 Billing & Stripe Tests

- **\`tests/billing/test_subscription_lifecycle.py\`** — Create → activate → upgrade → downgrade → cancel → expire
- **\`tests/billing/test_webhook_handling.py\`** — All Stripe webhook event types with signature verification, idempotency keys, and replay protection
- **\`tests/billing/test_usage_metering.py\`** — Usage record creation, aggregation, threshold alerts, billing period boundaries
- **\`tests/billing/test_invoice_generation.py\`** — Invoice line items, tax calculation, PDF rendering, email dispatch
- **\`tests/billing/test_payment_failures.py\`** — Declined cards, retry logic, dunning flow, grace period enforcement
- **Stripe mock fixtures** — Recorded responses in \`tests/fixtures/stripe/\` for deterministic replay

### 6.5 Celery Task Tests

- **\`tests/tasks/test_idempotency.py\`** — Execute same task twice with same args, verify single side effect
- **\`tests/tasks/test_retry_behavior.py\`** — Simulate transient failures, verify exponential backoff and max retries
- **\`tests/tasks/test_billing_sync.py\`** — Stripe sync tasks handle API rate limits and partial failures
- **\`tests/tasks/test_report_generation.py\`** — Async report tasks produce correct output and notify on completion
- **\`tests/tasks/test_cleanup.py\`** — Expired session cleanup, orphaned file removal, GDPR deletion tasks
- All task tests use \`CELERY_TASK_ALWAYS_EAGER=True\` or \`celery_app.control\` for integration scenarios

### 6.6 API Contract Tests

#### REST (DRF)

- **\`tests/api/test_openapi_schema.py\`** — Schema generated by \`drf-spectacular\` is valid OpenAPI 3.1, no undocumented endpoints
- **\`tests/api/test_serializer_validation.py\`** — Required fields, type coercion, nested serializer behavior, error response format
- **\`tests/api/test_viewset_permissions.py\`** — RBAC enforcement: admin, member, viewer, unauthenticated for every viewset
- **\`tests/api/test_pagination.py\`** — Cursor and offset pagination, ordering, filtering via django-filter
- **\`tests/api/test_rate_limiting.py\`** — Throttle classes enforce per-tenant and per-user rate limits

#### GraphQL (Strawberry)

- **\`tests/api/test_graphql_queries.py\`** — All query types return expected shapes, respect tenant scope
- **\`tests/api/test_graphql_mutations.py\`** — Mutations validate input, enforce permissions, return proper error types
- **\`tests/api/test_graphql_subscriptions.py\`** — WebSocket subscription lifecycle (if applicable)
- **\`tests/api/test_graphql_depth_limit.py\`** — Query depth and complexity limits prevent abuse

### 6.7 Integration Tests

- **\`tests/integration/test_signup_to_billing.py\`** — Full flow: register → create tenant → select plan → Stripe checkout → active subscription
- **\`tests/integration/test_webhook_to_state.py\`** — Stripe webhook → service layer → database state → notification dispatch
- **\`tests/integration/test_invite_flow.py\`** — Tenant admin invites user → email sent → user accepts → role assigned
- **\`tests/integration/test_audit_logging.py\`** — Sensitive actions produce audit log entries with actor, tenant, timestamp, diff
- **\`tests/integration/test_cache_invalidation.py\`** — Redis cache invalidated on model updates, stale data never served

### 6.8 Security Tests

- **\`tests/security/test_authentication.py\`** — JWT expiry, refresh rotation, token revocation, session fixation prevention
- **\`tests/security/test_authorization.py\`** — Horizontal privilege escalation blocked, vertical privilege escalation blocked
- **\`tests/security/test_input_sanitization.py\`** — SQL injection, XSS in API inputs, path traversal in file uploads
- **\`tests/security/test_gdpr_compliance.py\`** — Data export endpoint returns all PII, deletion endpoint purges all tenant data, consent tracking
- **\`tests/security/test_rate_limiting.py\`** — Brute-force login protection, API abuse prevention
- **\`tests/security/test_secrets.py\`** — No hardcoded secrets in codebase (use \`detect-secrets\` or \`trufflehog\`)

### 6.9 Performance Baseline Tests

- **\`tests/performance/test_query_count.py\`** — Assert N+1 queries don't exist on list endpoints using \`django-perf-rec\` or \`assertNumQueries\`
- **\`tests/performance/test_bulk_operations.py\`** — Bulk tenant provisioning, bulk invoice generation within acceptable time
- **\`tests/performance/test_cache_effectiveness.py\`** — Cache hit ratios for common queries, response time with/without cache

### 6.10 CI Quality Pipeline

Update \`.github/workflows/ci.yml\` to enforce:

\`\`\`yaml
# Quality gate stages (all must pass to merge)
- ruff check src/ tests/          # Lint
- ruff format --check src/ tests/ # Format
- mypy src/ --strict              # Type check
- pytest tests/ -m "not slow"     # Unit + integration tests
  --cov=src --cov-report=xml
  --cov-fail-under=85
- pytest tests/ -m "billing"      # Billing-specific suite
- pytest tests/ -m "e2e"          # End-to-end (staging only)
- safety check                    # Dependency vulnerability scan
- bandit -r src/                  # Security static analysis
\`\`\`

## Testing Conventions

### File Naming

\`\`\`
tests/
  {app_name}/
    test_{module}.py          # Unit tests for src/{app_name}/{module}.py
    test_{module}_integration.py  # Integration tests
  factories/
    {app_name}.py             # factory_boy factories
  fixtures/
    stripe/                   # Recorded Stripe API responses
    {app_name}/               # App-specific fixture data
\`\`\`

### Test Naming

\`\`\`python
class TestSubscriptionService:
    def test_create_subscription_with_valid_plan(self) -> None: ...
    def test_create_subscription_rejects_inactive_plan(self) -> None: ...
    def test_cancel_subscription_triggers_stripe_cancellation(self) -> None: ...
    def test_cancel_subscription_is_idempotent(self) -> None: ...
\`\`\`

### Fixture Patterns

\`\`\`python
# Use factory_boy, not raw ORM calls
@pytest.fixture
def tenant(db: None) -> Tenant:
    return TenantFactory(plan=PlanFactory(name="pro"))

@pytest.fixture
def authenticated_client(tenant: Tenant) -> APIClient:
    user = UserFactory(tenant=tenant, role="admin")
    client = APIClient()
    client.force_authenticate(user=user)
    client.tenant = tenant  # type: ignore[attr-defined]
    return client

@pytest.fixture
def stripe_mock(mocker: MockerFixture) -> MagicMock:
    """Patch stripe module with recorded responses."""
    return mocker.patch("src.billing.services.stripe")
\`\`\`

### Tenant-Aware Test Helpers

\`\`\`python
@pytest.fixture
def assert_tenant_isolated(db: None) -> Callable:
    """Helper to verify query results are scoped to the active tenant."""
    def _assert(queryset: QuerySet, tenant: Tenant) -> None:
        for obj in queryset:
            assert obj.tenant_id == tenant.id, (
                f"{obj.__class__.__name__}(id={obj.id}) belongs to tenant "
                f"{obj.tenant_id}, expected {tenant.id}"
            )
    return _assert
\`\`\`

### Celery Task Test Pattern

\`\`\`python
@pytest.mark.usefixtures("celery_eager")
class TestBillingSyncTask:
    def test_sync_is_idempotent(self, tenant: Tenant, stripe_mock: MagicMock) -> None:
        sync_billing.delay(tenant_id=tenant.id)
        sync_billing.delay(tenant_id=tenant.id)  # duplicate
        assert stripe_mock.Subscription.retrieve.call_count == 1  # deduped

    def test_sync_retries_on_stripe_error(
        self, tenant: Tenant, stripe_mock: MagicMock
    ) -> None:
        stripe_mock.Subscription.retrieve.side_effect = [
            stripe.error.RateLimitError("rate limited"),
            self._valid_subscription(),
        ]
        sync_billing.delay(tenant_id=tenant.id)
        assert stripe_mock.Subscription.retrieve.call_count == 2
\`\`\`

## Quality Gates

| Gate | Tool | Threshold | Blocks Merge |
|---|---|---|---|
| Lint (no errors) | \`ruff check\` | 0 errors | ✅ |
| Format (consistent) | \`ruff format --check\` | 0 diffs | ✅ |
| Type safety | \`mypy --strict\` | 0 errors | ✅ |
| Unit test pass rate | \`pytest -m "not slow"\` | 100% pass | ✅ |
| Code coverage | \`pytest-cov\` | ≥85% overall, ≥95% billing | ✅ |
| Billing test suite | \`pytest -m billing\` | 100% pass | ✅ |
| Tenant isolation suite | \`pytest -m tenant_isolation\` | 100% pass | ✅ |
| Security scan | \`bandit -r src/\` | 0 high/critical | ✅ |
| Dependency audit | \`safety check\` | 0 known vulnerabilities | ✅ |
| OpenAPI schema valid | \`pytest tests/api/test_openapi_schema.py\` | Valid 3.1 | ✅ |
| No N+1 queries | \`pytest -m query_count\` | 0 regressions | ✅ |
| Secrets detection | \`detect-secrets scan\` | 0 findings | ✅ |

## Commands Reference

\`\`\`bash
# Run all tests
uv run pytest tests/

# Run with coverage report
uv run pytest tests/ --cov=src --cov-report=html --cov-fail-under=85

# Run specific app tests
uv run pytest tests/billing/ -v

# Run by marker
uv run pytest -m "billing and not slow"
uv run pytest -m tenant_isolation
uv run pytest -m e2e

# Run with parallel execution
uv run pytest tests/ -n auto

# Type checking
uv run mypy src/ --strict

# Lint and format
uv run ruff check src/ tests/ --fix
uv run ruff format src/ tests/

# Security scans
uv run bandit -r src/ -c pyproject.toml
uv run safety check

# Generate OpenAPI schema and validate
uv run python manage.py spectacular --validate --fail-on-warn
\`\`\`

## Definition of Done

- [ ] All factory_boy factories created for every model in \`src/\`
- [ ] Root \`conftest.py\` provides tenant, user, client, Stripe, and Celery fixtures
- [ ] Unit tests exist for every service, serializer, and permission class
- [ ] Multi-tenant isolation tests pass with row-level security verification
- [ ] Stripe subscription lifecycle fully tested with mock fixtures
- [ ] All Celery tasks have idempotency and retry tests
- [ ] REST API endpoints have permission, validation, and pagination tests
- [ ] GraphQL queries and mutations have schema and permission tests
- [ ] Integration tests cover signup-to-billing and invite flows
- [ ] Security tests cover auth, authz, input sanitization, and GDPR compliance
- [ ] N+1 query detection tests exist for all list endpoints
- [ ] CI pipeline enforces all quality gates (coverage, lint, types, security)
- [ ] Coverage report shows ≥85% overall, ≥95% for \`billing/\` app
- [ ] Testing conventions documented and reviewed by team leads
- [ ] No \`# type: ignore\` without explanatory comment
- [ ] All tests run in under 5 minutes on CI (excluding \`slow\` marker)

## Risks & Mitigations

| Risk | Impact | Mitigation |
|---|---|---|
| Stripe mock drift from real API | Tests pass but production breaks | Pin stripe-mock version, run monthly smoke tests against Stripe test mode |
| Flaky async/Celery tests | CI instability, developer frustration | Use \`CELERY_TASK_ALWAYS_EAGER\` for unit tests, dedicated integration suite for async |
| Slow test suite growth | Developer velocity drops | Parallelize with \`pytest-xdist\`, enforce \`slow\` marker, split CI stages |
| Coverage gaming (trivial assertions) | False confidence | Code review checks test quality, mutation testing with \`mutmut\` quarterly |
| Tenant isolation gaps | Data leak between tenants (SOC 2 violation) | Dedicated isolation test suite runs on every PR, penetration testing quarterly |

## Next Phase

→ [Phase 07 — Deployment & Operations](./07-deployment-operations.md): Container builds, Terraform infrastructure, staging/production deployment, monitoring, and runbooks.`,

  'playbook/phases/07-launch.md': `# Phase 07: Launch & Operations

## Overview

Transition the Django SaaS platform from staging to production with zero-downtime deployment, full observability, and operational readiness. This phase covers production infrastructure provisioning, data migration, go-live execution, and establishing the operational runbook for day-2 operations.

## Objectives

1. **Production Infrastructure**: Provision and validate all AWS resources (ECS, RDS, ElastiCache, S3, SES, CloudFront) via Terraform
2. **Zero-Downtime Deployment**: Execute blue-green deployment with automated rollback capability
3. **Data Migration**: Migrate seed data, configure tenant provisioning, and validate Stripe billing in live mode
4. **Observability**: Confirm Sentry error tracking, Prometheus metrics, Grafana dashboards, and alerting are operational
5. **Operational Readiness**: Publish runbooks, on-call rotation, incident response procedures, and SLA definitions
6. **Compliance Verification**: Final SOC 2 and GDPR compliance audit before accepting customer data

## Prerequisites (from Phase 06)

- [ ] All CI/CD pipeline stages green on \`main\` (lint, type check, unit, integration, security scan, E2E)
- [ ] Test coverage ≥ 85% across all Django apps
- [ ] Staging environment fully functional with end-to-end tenant lifecycle validated
- [ ] Stripe test-mode integration verified (subscriptions, usage metering, webhooks, invoicing)
- [ ] Load testing completed — P95 latency < 200ms at projected launch traffic
- [ ] Security scan (Bandit, Safety, Trivy) with zero critical/high findings
- [ ] Dependency audit completed, all licenses reviewed

---

## Deliverables

### 7.1 Production Infrastructure

**Terraform Apply for Production Environment**

\`\`\`
infrastructure/
  terraform/
    environments/
      production/
        main.tf              # ECS cluster, services, task definitions
        rds.tf               # PostgreSQL 16 with Multi-AZ, encryption at rest
        elasticache.tf       # Redis cluster (Celery broker + cache)
        s3.tf                # Static assets, media, tenant file storage
        ses.tf               # Transactional email configuration
        cloudfront.tf        # CDN for static/media with custom domain
        secrets.tf           # AWS Secrets Manager for credentials
        iam.tf               # Least-privilege IAM roles
        waf.tf               # WAF rules for API protection
        monitoring.tf        # CloudWatch log groups, alarms
        variables.tf
        outputs.tf
\`\`\`

Checklist:
- [ ] RDS PostgreSQL 16 provisioned with Multi-AZ, automated backups (30-day retention), encryption at rest (AES-256)
- [ ] Row-level security policies applied via Django migration on production database
- [ ] ElastiCache Redis cluster provisioned (separate instances for cache and Celery broker)
- [ ] ECS Fargate services configured: \`web\` (Django/Gunicorn), \`worker\` (Celery), \`beat\` (Celery Beat)
- [ ] S3 buckets created with versioning, lifecycle policies, and CORS for tenant media
- [ ] CloudFront distribution configured with custom domain and TLS 1.3
- [ ] WAF rules active: rate limiting, SQL injection protection, geo-blocking if required
- [ ] Secrets Manager populated with production credentials (Stripe live keys, database URL, Django secret key)
- [ ] VPC networking: private subnets for RDS/ElastiCache, public subnets for ALB only
- [ ] DNS records configured (Route 53 or external) with health checks

### 7.2 Production Django Configuration

**\`config/production.py\` Validation**

- [ ] \`DEBUG = False\` confirmed
- [ ] \`ALLOWED_HOSTS\` set to production domains only
- [ ] \`SECURE_SSL_REDIRECT = True\`
- [ ] \`SECURE_HSTS_SECONDS = 31536000\` with \`SECURE_HSTS_INCLUDE_SUBDOMAINS = True\`
- [ ] \`SESSION_COOKIE_SECURE = True\`, \`CSRF_COOKIE_SECURE = True\`
- [ ] \`SECURE_CONTENT_TYPE_NOSNIFF = True\`
- [ ] Database connection via SSL (\`sslmode=verify-full\`)
- [ ] \`django-environ\` loading from Secrets Manager / environment variables (no \`.env\` files in production)
- [ ] Static files served via S3 + CloudFront (\`STATICFILES_STORAGE\` configured)
- [ ] Email backend set to SES (\`django-ses\`)
- [ ] Logging configured to ship structured JSON to CloudWatch
- [ ] Cache backend pointing to production ElastiCache
- [ ] Celery broker and result backend pointing to production Redis

### 7.3 Stripe Live Mode Activation

- [ ] Stripe account activated for live payments
- [ ] Live API keys stored in Secrets Manager (never in code or config files)
- [ ] Production webhook endpoint registered in Stripe Dashboard (\`/api/v1/billing/webhooks/stripe/\`)
- [ ] Webhook signing secret stored in Secrets Manager
- [ ] All subscription plans (Products + Prices) created in Stripe live mode matching staging configuration
- [ ] Idempotency keys verified on all Stripe API calls in \`src/billing/\`
- [ ] Webhook handler idempotency confirmed (duplicate event delivery safe)
- [ ] Stripe Tax configuration reviewed for applicable jurisdictions
- [ ] Customer portal URL configured for self-service subscription management
- [ ] Invoice settings configured (branding, payment terms, dunning)

\`\`\`bash
# Verify Stripe webhook connectivity from production
uv run python manage.py check_stripe_config --environment=production
\`\`\`

### 7.4 Database Migration & Seed Data

\`\`\`bash
# Production migration execution
uv run python manage.py migrate --database=default --run-syncdb

# Verify row-level security policies
uv run python manage.py verify_rls_policies --environment=production

# Create superuser via secure method (not interactive)
uv run python manage.py createsuperuser_from_env

# Load subscription plan fixtures
uv run python manage.py loaddata billing/fixtures/production_plans.json

# Verify tenant isolation
uv run python manage.py verify_tenant_isolation --environment=production
\`\`\`

- [ ] All Django migrations applied cleanly
- [ ] Row-level security policies active on all tenant-scoped tables
- [ ] Subscription plans seeded and matching Stripe live Products/Prices
- [ ] Default roles and permissions created (via \`src/accounts/\` fixtures)
- [ ] Admin superuser created with MFA enabled
- [ ] Audit logging confirmed operational (\`src/core/audit.py\` writing to audit table)

### 7.5 Observability & Monitoring

**Sentry Configuration**
- [ ] Sentry DSN configured for production Django and Celery
- [ ] Release tracking enabled (Git SHA tagged on each deploy)
- [ ] Performance monitoring enabled (transaction sampling rate configured)
- [ ] Alert rules configured: error spike, new issue, P95 latency degradation
- [ ] PII scrubbing enabled (email, IP addresses stripped from error reports — GDPR)
- [ ] Source maps uploaded for any frontend assets

**Prometheus + Grafana**
- [ ] \`django-prometheus\` middleware active, exposing \`/metrics\` endpoint (internal only)
- [ ] Celery task metrics exported (task duration, success/failure rate, queue depth)
- [ ] PostgreSQL exporter configured (connection count, query duration, replication lag)
- [ ] Redis exporter configured (memory usage, hit rate, connected clients)
- [ ] Grafana dashboards deployed:
  - Django request rate, latency (P50/P95/P99), error rate
  - Celery task throughput, queue backlog, worker utilization
  - Database connection pool, slow queries, row-level security violations
  - Redis memory, eviction rate, Celery broker queue depth
  - Stripe webhook processing latency and failure rate
  - Tenant provisioning success rate and duration
- [ ] Alerting rules configured in Grafana/Alertmanager:
  - API error rate > 1% for 5 minutes → Slack \`#prod-alerts\`
  - Celery queue depth > 1000 for 10 minutes → PagerDuty
  - Database connection pool > 80% → Slack \`#prod-alerts\`
  - Stripe webhook failure rate > 5% → PagerDuty
  - Disk/memory usage > 85% → Slack \`#infra-alerts\`
  - Zero healthy ECS tasks → PagerDuty (critical)

**Structured Logging**
- [ ] All Django logs in JSON format with \`request_id\`, \`tenant_id\`, \`user_id\` fields
- [ ] Celery task logs include \`task_id\`, \`tenant_id\`, \`task_name\`
- [ ] Logs shipped to CloudWatch Log Groups with 90-day retention
- [ ] Log-based metric filters for billing errors, auth failures, tenant isolation violations
- [ ] No PII in logs (email addresses, tokens, payment details masked)

### 7.6 Deployment Pipeline — Production

**GitHub Actions Production Workflow** (\`.github/workflows/deploy-production.yml\`)

\`\`\`yaml
# Trigger: manual approval after staging E2E pass
# Steps:
# 1. Build Docker image, tag with Git SHA + "production"
# 2. Push to ECR
# 3. Run database migrations (ECS run-task)
# 4. Blue-green deploy via ECS (new task definition, health check, traffic shift)
# 5. Smoke tests against production (health endpoint, API auth, tenant creation)
# 6. If smoke tests fail → automatic rollback to previous task definition
# 7. Tag release in GitHub, notify Slack #deployments
\`\`\`

- [ ] Blue-green deployment configured in ECS with health check grace period
- [ ] Automatic rollback on failed health checks (HTTP 200 on \`/api/v1/health/\`)
- [ ] Database migration runs as a separate ECS task before deployment
- [ ] Migration rollback plan documented for each migration
- [ ] Deployment notification sent to Slack \`#deployments\` with commit range and author
- [ ] AI-generated code flagged in deployment manifest (per CI/CD policy)

### 7.7 Go-Live Checklist

**Pre-Launch (T-24 hours)**
- [ ] Final staging E2E test suite green
- [ ] Production infrastructure Terraform plan reviewed and applied
- [ ] DNS TTL lowered to 60 seconds (for quick rollback)
- [ ] On-call rotation confirmed for launch window
- [ ] Rollback procedure rehearsed (ECS task definition revert + migration rollback)
- [ ] Stripe live webhook test event sent and processed successfully
- [ ] Status page created and operational (e.g., Statuspage.io or Betteruptime)

**Launch (T-0)**
- [ ] Deploy production via GitHub Actions (manual trigger with approval)
- [ ] Verify health endpoint: \`GET /api/v1/health/\` returns \`200\`
- [ ] Verify API authentication: create test token, make authenticated request
- [ ] Verify tenant creation: onboard test tenant via API
- [ ] Verify Celery: trigger test task, confirm execution in worker logs
- [ ] Verify Stripe: create test subscription, confirm webhook received
- [ ] Verify email: trigger welcome email via SES, confirm delivery
- [ ] DNS cutover to production (if not already pointed)
- [ ] Monitor Sentry, Grafana, CloudWatch for 30 minutes post-deploy

**Post-Launch (T+1 hour)**
- [ ] Confirm zero Sentry errors (or only expected/known issues)
- [ ] Confirm Grafana dashboards showing healthy metrics
- [ ] Confirm Celery Beat scheduled tasks executing (billing sync, cleanup)
- [ ] Remove test tenant data created during verification
- [ ] Restore DNS TTL to standard value (3600 seconds)
- [ ] Send launch confirmation to Slack \`#general\`

### 7.8 Operational Runbooks

Create the following runbooks in \`docs/runbooks/\`:

| Runbook | File | Description |
|---------|------|-------------|
| Incident Response | \`docs/runbooks/incident-response.md\` | Severity levels, escalation paths, communication templates |
| Rollback Procedure | \`docs/runbooks/rollback.md\` | ECS rollback, database migration rollback, Stripe state reconciliation |
| Tenant Provisioning | \`docs/runbooks/tenant-provisioning.md\` | Manual tenant creation, RLS verification, Stripe customer setup |
| Billing Issues | \`docs/runbooks/billing-troubleshooting.md\` | Failed payments, webhook replay, subscription state reconciliation |
| Database Operations | \`docs/runbooks/database-ops.md\` | Backup restore, RLS policy updates, connection pool tuning |
| Celery Operations | \`docs/runbooks/celery-ops.md\` | Queue inspection, stuck task recovery, worker scaling |
| Scaling Guide | \`docs/runbooks/scaling.md\` | ECS auto-scaling, RDS read replicas, Redis cluster scaling |
| GDPR Data Requests | \`docs/runbooks/gdpr-data-requests.md\` | Data export, right to deletion, consent management |
| Security Incident | \`docs/runbooks/security-incident.md\` | Tenant data breach response, credential rotation, audit log review |

### 7.9 On-Call & SLA

- [ ] On-call rotation established (PagerDuty or Opsgenie) across Europe + Americas timezones
- [ ] Escalation policy: L1 (15 min response) → L2 (30 min) → L3 (engineering lead)
- [ ] SLA targets defined:
  - API availability: 99.9% (monthly)
  - API P95 latency: < 200ms
  - Webhook processing: < 30 seconds
  - Incident response: < 15 minutes (P1), < 1 hour (P2)
  - Data recovery: RPO < 1 hour, RTO < 4 hours
- [ ] Status page configured with automated component monitoring
- [ ] Weekly operational review scheduled (error trends, latency, billing health)

---

## Quality Gates

All gates must pass before the phase is considered complete.

| # | Gate | Criteria | Verification |
|---|------|----------|--------------|
| 1 | Infrastructure Provisioned | All Terraform resources applied, no drift | \`terraform plan\` shows no changes |
| 2 | Production Config Secure | All security settings enabled, no secrets in code | \`uv run python manage.py check --deploy\` returns zero warnings |
| 3 | Migrations Applied | All migrations run, RLS policies active | \`uv run python manage.py showmigrations\` — all checked |
| 4 | Stripe Live Mode | Webhook endpoint active, test subscription created | Stripe Dashboard shows successful webhook delivery |
| 5 | Health Check Passing | \`/api/v1/health/\` returns 200 with DB, Redis, Celery status | \`curl -s https://api.example.com/api/v1/health/\` |
| 6 | Observability Active | Sentry, Prometheus, Grafana all receiving data | Grafana dashboard shows live metrics for all components |
| 7 | Alerting Configured | All critical alerts firing to correct channels | Trigger test alert, confirm delivery to Slack/PagerDuty |
| 8 | Runbooks Published | All 9 runbooks written and reviewed | \`docs/runbooks/\` contains all files, reviewed in PR |
| 9 | On-Call Active | Rotation configured, escalation tested | PagerDuty test incident resolved through escalation chain |
| 10 | Compliance Verified | SOC 2 controls documented, GDPR DPA template ready | Audit log captures all data access, deletion pipeline tested |
| 11 | Rollback Tested | Rollback procedure executed successfully in staging | Documented rollback with timing (< 5 minutes) |
| 12 | Zero Critical Issues | No P1/P2 bugs in production for 24 hours post-launch | Sentry and PagerDuty show zero critical incidents |

---

## Compliance Checklist

### SOC 2

- [ ] Access controls: all production access requires MFA and is logged
- [ ] Change management: all deployments traceable to GitHub PRs with approvals
- [ ] Encryption: data at rest (RDS, S3) and in transit (TLS 1.3) confirmed
- [ ] Audit logging: all API requests, admin actions, and data mutations logged with tenant context
- [ ] Incident response plan documented and tested
- [ ] Vendor security review completed for all third-party services (Stripe, Sentry, AWS)

### GDPR

- [ ] Data Processing Agreement (DPA) template available for tenants
- [ ] Privacy policy published and accessible
- [ ] Consent management: user consent recorded and auditable
- [ ] Right to deletion: \`uv run python manage.py gdpr_delete_user --user-id=<id>\` tested end-to-end
- [ ] Data export: \`uv run python manage.py gdpr_export_user --user-id=<id>\` produces complete archive
- [ ] Data residency: tenant data stored in configured AWS region, no cross-region replication without consent
- [ ] Cookie consent: if applicable, banner and preference management implemented
- [ ] Sub-processor list documented and available to tenants

---

## Risk Mitigation

| Risk | Likelihood | Impact | Mitigation |
|------|-----------|--------|------------|
| Failed deployment | Medium | High | Blue-green deploy with automatic rollback; rehearsed rollback procedure |
| Stripe webhook failures | Medium | High | Webhook retry queue; idempotent handlers; manual replay capability |
| Database migration failure | Low | Critical | Test migrations on staging clone; document rollback SQL for each migration |
| Tenant data leak | Low | Critical | RLS policies verified; tenant isolation integration tests run pre-deploy |
| Traffic spike at launch | Medium | Medium | ECS auto-scaling configured; CloudFront caching; Redis query cache |
| DNS propagation delay | Low | Medium | TTL lowered pre-launch; health checks on both old and new endpoints |
| Third-party outage (Stripe, AWS) | Low | High | Circuit breakers on external calls; graceful degradation; status page monitoring |

---

## Post-Launch Transition

After all quality gates pass and 72 hours of stable production operation:

1. **Retrospective**: Conduct launch retrospective, document lessons learned in \`docs/retrospectives/launch.md\`
2. **Backlog Grooming**: Move deferred items to GitHub Issues, prioritize for next sprint
3. **Monitoring Tuning**: Adjust alert thresholds based on real production baselines
4. **Performance Baseline**: Record P50/P95/P99 latency, throughput, and error rates as baseline metrics
5. **Documentation Update**: Update \`docs/architecture/\` with any changes made during launch
6. **Phase Completion**: Update \`playbook/current-phase.json\` to reflect operational steady-state

\`\`\`bash
# Mark phase complete
./playbook/codeforge-phase.sh complete 07
\`\`\`

---

## Key Commands Reference

\`\`\`bash
# Infrastructure
terraform -chdir=infrastructure/terraform/environments/production plan
terraform -chdir=infrastructure/terraform/environments/production apply

# Django production checks
uv run python manage.py check --deploy
uv run python manage.py showmigrations
uv run python manage.py verify_rls_policies --environment=production
uv run python manage.py check_stripe_config --environment=production

# Celery verification
celery -A config inspect active
celery -A config inspect scheduled

# Health verification
curl -s https://api.example.com/api/v1/health/ | python -m json.tool

# GDPR commands
uv run python manage.py gdpr_export_user --user-id=<id>
uv run python manage.py gdpr_delete_user --user-id=<id> --confirm

# Monitoring
uv run python manage.py send_test_alert --channel=pagerduty
uv run python manage.py send_test_alert --channel=slack
\`\`\``,

  'playbook/prompts/01/gather-requirements.md': `# Gather Requirements — Phase 01 Discovery Prompt

> Copy-paste this prompt into Claude Code to gather and structure requirements for a feature or epic in the django-saas-platform project.

---

## Prompt

\`\`\`
I need your help gathering and structuring requirements for a new feature in our Django SaaS platform. Follow the process below carefully.

## Context

This is a multi-tenant SaaS application built with:
- Django 5.0, Django REST Framework, Strawberry GraphQL
- Celery 5 with Redis broker for async task processing
- PostgreSQL 16 with row-level security for tenant isolation
- Stripe for subscription billing and usage-based metering
- AWS infrastructure (ECS, RDS, ElastiCache, S3, SES)

Compliance requirements: SOC 2, GDPR
Architecture: Modular monolith with self-contained Django apps

Key project directories:
- src/accounts/ — User management, authentication, tenant association
- src/tenants/ — Multi-tenancy model, middleware, row-level security
- src/billing/ — Stripe integration, subscriptions, invoices, usage metering
- src/api/ — DRF viewsets, Strawberry GraphQL schema, serializers
- src/core/ — Base models, permissions, middleware, tenant-aware managers
- src/notifications/ — Email, in-app notifications, webhook dispatch
- src/tasks/ — Celery task definitions
- src/utils/ — Shared utilities, logging, decorators
- config/ — Django settings (base, development, staging, production)
- tests/ — pytest tests mirroring src/ structure

## Feature/Epic to Analyze

[REPLACE THIS: Describe the feature, paste the GitHub Issue, or provide the ticket reference (e.g., SAAS-42)]

## Your Task

### Step 1: Clarify the Request
Ask me targeted clarifying questions organized by these categories. Do NOT proceed until I answer. Focus on what's ambiguous or missing:

**Functional Requirements**
- What are the user-facing behaviors? Who are the actors (tenant admin, member, platform admin, API consumer)?
- What are the input/output expectations for each endpoint (REST and/or GraphQL)?
- Are there state machines or workflows involved (e.g., onboarding steps, subscription state transitions)?

**Multi-Tenancy Impact**
- Does this feature introduce new tenant-scoped data? If so, which models need tenant FK and row-level security policies?
- Does it affect tenant isolation boundaries? Can data leak across tenants if implemented incorrectly?
- Does it need tenant-specific configuration or white-label customization?

**Billing & Subscription Impact**
- Does this feature interact with Stripe (new plan tiers, usage events, metered billing, webhook events)?
- Are there feature gates tied to subscription plans (free vs. pro vs. enterprise)?
- Does it affect the subscription lifecycle (trial, active, past_due, canceled)?

**Async Processing**
- Are there operations that should be Celery tasks (email sending, report generation, webhook dispatch, Stripe sync)?
- Must these tasks be idempotent? What happens on retry?
- Are there scheduling requirements (periodic tasks via Celery Beat)?

**Data & Compliance**
- Does this feature store or process PII? If so, what GDPR obligations apply (consent, right to deletion, data portability)?
- Are there audit logging requirements for SOC 2 (who did what, when, to which tenant's data)?
- Does data residency matter (EU vs. US storage)?

**API Design**
- REST endpoints, GraphQL queries/mutations, or both?
- What authentication/authorization is required (JWT, API key, OAuth, tenant-scoped RBAC)?
- Does the OpenAPI schema (drf-spectacular) need special annotations?

**Integration Points**
- Does this touch existing Django signals, middleware, or the service layer?
- Are there external service dependencies beyond Stripe (SES, S3, third-party APIs)?
- Does it require new webhook endpoints (inbound) or webhook dispatch (outbound)?

### Step 2: Structure the Requirements Document
After I answer your questions, produce a structured requirements document in this exact format:

\`\`\`markdown
# Requirements: [Feature Name]

**Ticket**: [GitHub Issue reference]
**Phase**: 01-Discovery
**Author**: [AI-assisted]
**Date**: [Today]
**Status**: Draft

## 1. Overview
[2-3 sentence summary of what this feature does and why it matters]

## 2. Actors & Personas
| Actor | Description | Permissions |
|-------|-------------|-------------|
| ... | ... | ... |

## 3. Functional Requirements

### FR-1: [Requirement Title]
- **Description**: ...
- **Acceptance Criteria**:
  - [ ] Given [context], when [action], then [outcome]
  - [ ] ...
- **API Surface**:
  - \`POST /api/v1/...\` — [description]
  - GraphQL mutation \`createThing(input: ...)\` — [description]
- **Tenant Scope**: [tenant-isolated / platform-wide / configurable per tenant]

### FR-2: ...
[Repeat for each functional requirement]

## 4. Non-Functional Requirements

### Multi-Tenancy
- [ ] All new models include \`tenant\` FK with \`TenantAwareManager\`
- [ ] Row-level security policies added for new tables
- [ ] Tenant isolation verified in integration tests

### Performance
- [ ] Expected query patterns and indexing needs
- [ ] Caching strategy (Redis key patterns, TTLs)
- [ ] Async offloading via Celery for operations > 500ms

### Security & Compliance
- [ ] RBAC permissions defined (Django permissions or custom)
- [ ] PII fields identified and GDPR handling documented
- [ ] Audit log events defined for SOC 2
- [ ] Input validation and rate limiting specified

### Billing Integration
- [ ] Stripe objects affected (Products, Prices, Subscriptions, Usage Records)
- [ ] Webhook events to handle (with idempotency keys)
- [ ] Feature gating by plan tier

## 5. Data Model Changes
[List new models, modified models, new fields, migrations needed]

\`\`\`python
# Example model sketch
class NewModel(TenantScopedModel):
    tenant = models.ForeignKey("tenants.Tenant", on_delete=models.CASCADE)
    # fields...
    
    class Meta:
        constraints = [...]
        indexes = [...]
\`\`\`

## 6. Celery Tasks
| Task | Trigger | Idempotent | Retry Policy | Queue |
|------|---------|------------|--------------|-------|
| ... | ... | Yes/No | ... | default/billing/notifications |

## 7. API Endpoints
| Method | Path | Auth | Tenant-Scoped | Description |
|--------|------|------|---------------|-------------|
| ... | ... | ... | ... | ... |

## 8. Dependencies
- **Internal**: [Django apps this depends on]
- **External**: [Third-party services or new packages]
- **New packages**: [Any new pip packages — must be reviewed per dependency policy]

## 9. Testing Strategy
- **Unit tests**: [Key service layer functions to test]
- **Integration tests**: [API endpoint tests, Celery task tests]
- **Tenant isolation tests**: [Verify cross-tenant data cannot leak]
- **Stripe mock tests**: [Using stripe-mock or VCR cassettes]
- **Coverage target**: 85% minimum

## 10. Migration & Rollout Plan
- [ ] Database migration steps (reversible?)
- [ ] Feature flag for gradual rollout?
- [ ] Backfill needed for existing tenants?
- [ ] Stripe migration (new products/prices to create?)

## 11. Open Questions
- [ ] [Unresolved question 1]
- [ ] [Unresolved question 2]

## 12. Out of Scope
- [Explicitly list what this feature does NOT include]
\`\`\`

### Step 3: Identify Risks
After the requirements document, add a risk assessment:

| Risk | Likelihood | Impact | Mitigation |
|------|-----------|--------|------------|
| Tenant data leakage | ... | Critical | Row-level security + integration tests |
| Stripe webhook replay | ... | ... | Idempotency keys on all handlers |
| ... | ... | ... | ... |

### Step 4: Suggest File Locations
Map each requirement to the Django app and files that will be created or modified:

| Requirement | Django App | Files |
|-------------|-----------|-------|
| FR-1 | src/billing/ | models.py, services.py, serializers.py, views.py |
| FR-2 | src/tasks/ | billing_tasks.py |
| ... | ... | ... |

### Step 5: Output Checklist
Provide a checklist I can paste into the GitHub Issue:

\`\`\`markdown
## Requirements Checklist
- [ ] Requirements document reviewed by tech lead
- [ ] Data model changes approved
- [ ] Stripe integration points confirmed with billing team
- [ ] GDPR impact assessed
- [ ] SOC 2 audit events defined
- [ ] API schema reviewed (REST + GraphQL)
- [ ] Tenant isolation strategy confirmed
- [ ] Testing strategy approved
- [ ] Migration plan reviewed
- [ ] Ready for Phase 02 (Architecture)
\`\`\`

## Important Rules
- All tenant data access MUST go through \`TenantAwareManager\` — never raw querysets
- Celery tasks MUST be idempotent — design for at-least-once delivery
- Stripe webhooks MUST verify signatures and handle replays
- Django signals should be avoided — use explicit service layer calls
- Every API endpoint MUST have drf-spectacular schema annotations
- Files should not exceed 300 lines — split into services, selectors, and utilities
- Use factory_boy for test data, never raw \`Model.objects.create()\` in tests
- Follow conventional commits: feat:, fix:, chore:, docs:
- Branch naming: feat/SAAS-{ticket}-{short-desc}

Now, let's begin. Please start with Step 1 — ask me your clarifying questions about the feature I described above.
\`\`\`

---

## Usage

1. Copy the entire prompt above (inside the code fence)
2. Replace \`[REPLACE THIS: ...]\` with your feature description or GitHub Issue link
3. Paste into Claude Code
4. Answer the clarifying questions Claude asks
5. Review the generated requirements document
6. Save the output to \`docs/requirements/SAAS-{ticket}-{feature-name}.md\`
7. Paste the checklist into the GitHub Issue
8. Update \`playbook/current-phase.json\` to reflect progress

## Tips

- **Be specific** in your feature description — include user stories, mockups, or existing ticket text
- **Don't skip clarifying questions** — the quality of requirements depends on your answers
- **Challenge the output** — ask Claude to reconsider tenant isolation or billing edge cases
- **Iterate** — run this prompt multiple times as requirements evolve
- **Cross-reference** with \`playbook/phases/01-discovery.md\` for phase completion criteria

## Next Steps

After requirements are gathered and approved:
→ Move to Phase 02 Architecture using \`playbook/prompts/02/design-architecture.md\`
→ Or run \`/phase next\` to advance the playbook phase`,

  'playbook/prompts/01/nfr-checklist.md': `# NFR Checklist — Phase 01 Discovery

> **Copy-paste this prompt into Claude Code** to generate a comprehensive Non-Functional Requirements checklist for the django-saas-platform project. Run this after \`gather-requirements.md\` and \`user-stories.md\` have produced their outputs.

---

## Prompt

You are a senior SaaS platform architect working on **django-saas-platform**, a multi-tenant Django 5.0 SaaS application with Stripe billing, Celery task processing, and REST/GraphQL APIs. The platform must comply with **SOC 2** and **GDPR**.

Review the existing requirements and user stories in \`docs/requirements/\` and \`docs/user-stories/\`, then produce a **Non-Functional Requirements (NFR) Checklist** covering every category below. For each NFR, provide:

1. **ID** — NFR-{CATEGORY}-{NUMBER} (e.g., NFR-PERF-001)
2. **Requirement** — Clear, measurable statement
3. **Acceptance Criteria** — How we verify this is met (specific tool, metric, or test)
4. **Priority** — P0 (launch blocker), P1 (needed within 30 days post-launch), P2 (roadmap)
5. **Owner** — Which team role is accountable (backend, infra, security, billing)

---

### Categories to Cover

#### 1. Performance
- API response times (p50, p95, p99) for DRF and Strawberry GraphQL endpoints
- Database query budgets per request (max queries, use of \`select_related\`/\`prefetch_related\`)
- Celery task throughput and latency (billing sync, email dispatch, report generation)
- Redis cache hit ratios for tenant config, session data, and frequently accessed resources
- Django ORM query performance with row-level security filters applied
- Static asset delivery via CloudFront (TTFB, cache hit ratio)
- Webhook processing latency (Stripe events received → task enqueued → completed)

#### 2. Scalability
- Concurrent tenant count targets (100, 1,000, 10,000 tenants)
- Horizontal scaling strategy for Django (ECS tasks), Celery workers, and Redis
- PostgreSQL connection pooling (PgBouncer) and read replica strategy
- Celery queue partitioning (billing, notifications, reports, default)
- Database sharding or partitioning plan for tenant data at scale
- Rate limiting per tenant and per API key (DRF throttling classes)

#### 3. Reliability & Availability
- Uptime SLA target (99.9%, 99.95%)
- RDS Multi-AZ and automated failover
- Celery task retry policy (max retries, exponential backoff, dead letter queue)
- Stripe webhook retry handling and idempotency key enforcement
- Circuit breaker patterns for external service calls (Stripe API, SES, third-party integrations)
- Graceful degradation when Redis is unavailable (cache fallback, Celery broker failover)
- Health check endpoints (\`/healthz\`, \`/readyz\`) covering database, Redis, Celery

#### 4. Security
- **SOC 2 Type II** controls: access logging, change management, incident response
- Multi-tenant data isolation via PostgreSQL row-level security policies
- Authentication: JWT token expiry, refresh rotation, session invalidation
- Authorization: role-based access control (RBAC) enforcement at API and ORM layers
- Secrets management (AWS Secrets Manager, no secrets in code or environment files)
- Dependency vulnerability scanning (safety, pip-audit in CI)
- OWASP Top 10 coverage: SQL injection (ORM parameterization), XSS (template escaping), CSRF (Django middleware)
- API rate limiting and abuse prevention per tenant
- Encryption at rest (RDS, S3) and in transit (TLS 1.2+ everywhere)
- Audit logging for all state-changing operations on sensitive resources (\`billing/\`, \`accounts/\`, \`tenants/\`)

#### 5. Data Privacy & GDPR Compliance
- Personal data inventory: what PII is stored, where, and retention periods
- Consent management: tracking user consent for data processing
- Right to access: API or admin action to export all user data (DSAR)
- Right to deletion: cascade delete or anonymize user data across all tables and Stripe
- Data residency: tenant data region selection (EU, US) and enforcement
- Data Processing Agreements (DPA) with sub-processors (Stripe, AWS, SES)
- Cookie consent and tracking transparency
- Breach notification process (72-hour GDPR window)

#### 6. Observability & Monitoring
- Structured logging format (JSON) with tenant_id, request_id, user_id correlation
- Sentry integration for error tracking with PII scrubbing
- Prometheus metrics: request latency, error rates, Celery queue depth, active tenants
- Grafana dashboards: per-tenant resource usage, billing sync status, API health
- Alerting thresholds: error rate > 1%, p99 latency > 2s, Celery queue backlog > 1000
- Distributed tracing for request flows spanning Django → Celery → Stripe → webhook

#### 7. Maintainability & Code Quality
- Test coverage ≥ 85% enforced in CI (\`uv run pytest --cov --cov-fail-under=85\`)
- Type checking with \`uv run mypy src/ --strict\` — zero errors on main branch
- Linting with \`uv run ruff check src/\` — zero violations on main branch
- Max file length: 300 lines (enforced by ruff or custom CI check)
- Each Django app self-contained: models, serializers, views, services, tests
- Service layer pattern: business logic in \`services.py\`, not in views or serializers
- All Celery tasks idempotent and tested with \`factory_boy\` fixtures
- OpenAPI schema validation: all DRF endpoints documented via \`drf-spectacular\`
- Database migration safety: no destructive migrations without explicit review

#### 8. Deployment & Infrastructure
- Zero-downtime deployments via ECS rolling updates
- Database migration strategy: forward-compatible migrations, separate deploy step
- Docker image size budget (< 500MB for production image)
- Infrastructure as Code: all resources in Terraform, no manual AWS console changes
- Environment parity: development, staging, production use same Docker image
- Rollback procedure: one-command rollback for ECS service and database migrations
- Secrets rotation without downtime

#### 9. Billing & Financial Integrity
- Stripe webhook signature verification on every event (no exceptions)
- Idempotent subscription lifecycle operations (create, upgrade, downgrade, cancel)
- Usage metering accuracy: reconciliation between internal counters and Stripe usage records
- Invoice generation correctness: automated tests for proration, tax, discounts
- Billing audit trail: immutable log of all subscription and payment state changes
- Dunning flow: automated retry for failed payments, grace period, account suspension
- Revenue recognition data: MRR, churn, expansion revenue queryable for reporting

#### 10. Tenant Experience
- Tenant onboarding time: < 30 seconds from signup to usable workspace
- White-label support: custom domain, logo, color scheme per tenant
- Tenant admin self-service: user management, billing portal, API key management
- Tenant data export: full data export in standard format (JSON/CSV) within 24 hours
- Tenant offboarding: complete data deletion within GDPR-required timeframes

---

### Output Format

Save the output to \`docs/nfr-checklist.md\` with the following structure:

\`\`\`markdown
# Non-Functional Requirements Checklist

## Project: django-saas-platform
## Date: {today}
## Status: Draft — Pending team review

### Summary
{Brief overview of NFR scope and compliance targets}

### NFR Table

| ID | Category | Requirement | Acceptance Criteria | Priority | Owner |
|----|----------|-------------|---------------------|----------|-------|
| NFR-PERF-001 | Performance | ... | ... | P0 | backend |
| ... | ... | ... | ... | ... | ... |

### Open Questions
{List any NFRs that need further input from stakeholders}

### Dependencies
{External dependencies that affect NFR delivery — e.g., Stripe API limits, AWS region availability}

### Review Checklist
- [ ] Reviewed by backend lead
- [ ] Reviewed by infrastructure lead
- [ ] Reviewed by security lead
- [ ] Approved by product owner
- [ ] Linked to architecture decision records in docs/architecture/
\`\`\`

---

### Guidance

- Be specific and measurable — avoid vague statements like "the system should be fast"
- Reference actual tools in our stack: \`pytest\`, \`mypy\`, \`ruff\`, \`Sentry\`, \`Prometheus\`, \`Terraform\`, \`drf-spectacular\`
- Reference actual Django/Python patterns: \`select_related\`, \`TenantAwareManager\`, \`@shared_task\`, \`APIThrottle\`
- Every P0 NFR must have a corresponding test or monitoring check that can run in CI or production
- Cross-reference with \`docs/requirements/\` and \`docs/user-stories/\` to ensure coverage
- Flag any conflicts between NFRs (e.g., strict data residency vs. CDN caching)
- Consider the team structure: 6-15 developers across Europe + Americas timezones`,

  'playbook/prompts/01/user-stories.md': `# Phase 01 — User Stories Prompt

> Copy-paste this prompt into Claude Code to generate user stories from discovery artifacts.

---

## Prompt

\`\`\`
You are a product analyst working on django-saas-platform, a multi-tenant SaaS platform built with Django 5.0, Django REST Framework, Strawberry GraphQL, Celery, and Stripe billing. The platform must comply with SOC 2 and GDPR.

Review the following discovery artifacts and generate a comprehensive set of user stories organized by epic. Each story must follow the format:

**As a** [persona], **I want** [capability], **so that** [business value].

### Acceptance Criteria
- [ ] Criterion 1 (testable, specific)
- [ ] Criterion 2
- [ ] Criterion 3

### Technical Notes
- Implementation hints relevant to our stack (Django, DRF, Strawberry, Celery, Stripe, PostgreSQL RLS, Redis)
- Security or compliance considerations (SOC 2, GDPR, tenant isolation)

---

## Personas

Use these personas consistently across all stories:

- **Platform Admin** — operates the SaaS platform itself (super-admin, manages all tenants)
- **Tenant Admin** — administers a single tenant organization (manages users, billing, settings)
- **Tenant Member** — regular user within a tenant (uses features, views own data)
- **Billing Manager** — tenant user with billing permissions (manages subscription, payment methods, invoices)
- **API Consumer** — external system integrating via REST or GraphQL API
- **System** — automated processes (Celery tasks, webhooks, scheduled jobs)

---

## Epics to Cover

Generate stories for each of these epics. Aim for 3-8 stories per epic, prioritized by MoSCoW (Must/Should/Could/Won't):

### Epic 1: Tenant Onboarding & Management
- Tenant registration and provisioning
- Tenant settings and configuration
- White-label / custom branding per tenant
- Tenant suspension and deletion (GDPR right to deletion)
- Tenant data isolation verification

### Epic 2: Authentication & Authorization
- User registration and email verification
- Login (email/password, SSO/OAuth2)
- Password reset and rotation
- Role-based access control (RBAC) within tenants
- API key management for programmatic access
- Session management and forced logout
- Multi-factor authentication (MFA)

### Epic 3: Subscription Billing (Stripe)
- Plan selection and checkout (Stripe Checkout or Elements)
- Subscription lifecycle (create, upgrade, downgrade, cancel, reactivate)
- Usage-based metering and overage billing
- Payment method management (cards, ACH)
- Invoice generation and history
- Dunning and failed payment handling
- Proration on plan changes
- Stripe webhook processing (idempotent)
- Free trial and trial-to-paid conversion

### Epic 4: REST & GraphQL API
- CRUD endpoints for tenant resources via DRF
- GraphQL queries and mutations via Strawberry
- API versioning strategy
- Rate limiting per tenant/plan tier
- OpenAPI 3.1 schema generation (drf-spectacular)
- Pagination, filtering, and ordering
- Bulk operations

### Epic 5: Background Task Processing (Celery)
- Async email sending (transactional, marketing)
- Report generation (CSV/PDF export)
- Webhook dispatch to tenant-configured endpoints
- Billing sync tasks (Stripe reconciliation)
- Scheduled cleanup jobs (expired sessions, soft-deleted data)
- Task retry and dead-letter handling
- Task monitoring and alerting

### Epic 6: Notifications & Communication
- Email notifications (SES integration)
- In-app notification center
- Webhook delivery to tenant endpoints (with retry)
- Notification preferences per user
- Email template management (per-tenant white-label)

### Epic 7: Audit Logging & Compliance
- Audit log for all state-changing operations
- Audit log viewer for Tenant Admins
- GDPR data export (right of access)
- GDPR data deletion (right to erasure)
- Consent management and tracking
- Data residency controls
- SOC 2 evidence collection (access logs, change tracking)

### Epic 8: Platform Administration
- Tenant overview dashboard
- Platform-wide metrics and health
- Feature flags per tenant
- Impersonation (admin acting as tenant user, with audit trail)
- System announcements and maintenance windows

---

## Output Requirements

For each epic, produce:

1. **Epic summary** — 2-3 sentences describing the epic's scope and business value
2. **User stories** — numbered within the epic (e.g., E1-S1, E1-S2)
3. **Priority** — Must / Should / Could / Won't for MVP
4. **Story points estimate** — relative sizing (1, 2, 3, 5, 8, 13)
5. **Acceptance criteria** — 3-5 testable criteria per story
6. **Technical notes** — stack-specific implementation guidance
7. **Dependencies** — references to other stories this depends on

## Constraints

- All tenant data access stories must reference the tenant-aware manager in \`src/core/\`
- All billing stories must account for Stripe webhook idempotency
- All API stories must include OpenAPI schema requirements (drf-spectacular)
- All Celery task stories must specify idempotency strategy
- All stories touching PII must note GDPR implications
- All stories must consider multi-tenant isolation (PostgreSQL row-level security)
- Authentication stories must consider SOC 2 requirements (MFA, session timeout, password policy)
- Estimate assumes the team uses pytest with factory_boy for testing, ruff for linting, mypy for type checking

## Format

Output as Markdown. Use collapsible sections (<details>) for technical notes to keep the document scannable. Group stories under their epic heading. Include a summary table at the top with epic, story count, and total points.

---

## Discovery Artifacts

Paste or reference your discovery documents below:

- [ ] Product requirements document (PRD)
- [ ] Competitive analysis
- [ ] User interview summaries
- [ ] Technical constraints document
- [ ] Compliance requirements (SOC 2 controls, GDPR articles)

<!-- PASTE YOUR DISCOVERY ARTIFACTS HERE -->
\`\`\`

---

## Usage

1. Complete Phase 01 discovery first — gather PRD, user research, compliance requirements
2. Paste the prompt above into Claude Code
3. Replace the placeholder at the bottom with your actual discovery artifacts
4. Review generated stories with your product owner and tech lead
5. Import accepted stories into GitHub Issues using labels for epic and priority
6. Save the output to \`docs/user-stories.md\` in the repository

## Tips

- Run this prompt iteratively — start with 2-3 epics, review, then continue
- Ask Claude to challenge assumptions: "What stories am I missing for GDPR compliance?"
- Use follow-up prompts to break 8+ point stories into smaller deliverables
- Cross-reference with \`playbook/phases/01-discovery.md\` for phase completion criteria
- After generating stories, use \`/plan\` command to create implementation plans for individual stories

## Follow-Up Prompts

After generating stories, consider these refinement prompts:

- "Review these stories for GDPR compliance gaps — are we missing any data subject rights?"
- "Break down story E3-S2 (subscription lifecycle) into sub-tasks with Django model and Stripe API details"
- "Generate the Celery task signatures and retry policies for all Epic 5 stories"
- "Map these stories to the Django app structure in src/ — which app owns each story?"
- "Identify cross-cutting concerns (logging, tenant isolation, permissions) that need shared infrastructure stories"
- "Estimate which stories can be parallelized across the team and which are sequential blockers"`,

  'playbook/prompts/02/adr-generator.md': `# ADR Generator — Phase 02: Architecture

> **Copy-paste this prompt into Claude Code** to generate Architecture Decision Records for the django-saas-platform project.

---

## Prompt

\`\`\`
You are acting as a software architect for the django-saas-platform project — a multi-tenant SaaS application built with Django 5.0, Django REST Framework, Strawberry GraphQL, Celery 5, PostgreSQL 16, Redis, and Stripe billing. The project must comply with SOC 2 and GDPR.

Your task: generate an Architecture Decision Record (ADR) for the topic I specify below.

## Project Context

- **Multi-tenancy**: Row-level security in PostgreSQL 16, tenant-aware model managers in \`src/core/\`, tenant middleware in \`src/tenants/\`
- **API layer**: DRF viewsets + Strawberry GraphQL in \`src/api/\`, documented via drf-spectacular (OpenAPI 3.1)
- **Billing**: Stripe subscriptions, usage metering, webhook handling in \`src/billing/\` — all webhook handlers must be idempotent
- **Task processing**: Celery 5 with Redis broker, beat scheduler — all tasks must be idempotent, defined in \`src/tasks/\`
- **Auth**: Django auth + tenant association in \`src/accounts/\`, role-based access control in \`src/core/permissions.py\`
- **Infrastructure**: AWS (ECS, RDS, ElastiCache, S3, SES, CloudFront), Docker, Kubernetes, Terraform
- **Settings**: django-environ + Pydantic settings in \`config/\` (base, development, staging, production)
- **Testing**: pytest with pytest-django, pytest-asyncio, factory_boy — 85% coverage threshold
- **Tooling**: uv (package manager), ruff (lint + format), mypy strict mode
- **Architecture**: Modular monolith — each Django app is self-contained with models, serializers, views, services, and tests

## ADR Format

Use this exact structure. Write in clear, decisive language. Be specific to our Django/SaaS stack — no generic hand-waving.

\`\`\`markdown
# ADR-{NUMBER}: {Title}

## Status
Proposed | Accepted | Deprecated | Superseded by ADR-{N}

## Date
{YYYY-MM-DD}

## Context

What is the problem or decision we face? Why does it matter for this project?
Reference specific Django apps, infrastructure components, compliance requirements, or scaling concerns.

## Decision Drivers

- {Driver 1 — e.g., "Tenant data isolation is a SOC 2 requirement"}
- {Driver 2 — e.g., "GDPR requires data residency controls per tenant"}
- {Driver 3 — e.g., "Must support 500+ tenants on shared infrastructure"}

## Options Considered

### Option A: {Name}
- Description of the approach
- How it maps to our Django/Celery/PostgreSQL stack
- **Pros**: ...
- **Cons**: ...

### Option B: {Name}
- Description of the approach
- How it maps to our stack
- **Pros**: ...
- **Cons**: ...

### Option C: {Name} (if applicable)
- ...

## Decision

We will use **Option {X}: {Name}**.

{2-4 sentences explaining why this option wins given our constraints, stack, and compliance requirements.}

## Consequences

### Positive
- {Concrete benefit with reference to specific app or component}

### Negative
- {Concrete tradeoff or cost}

### Mitigations
- {How we address the negatives}

## Implementation Notes

- Specific files, Django apps, or modules affected
- Migration steps or sequencing
- Configuration changes in \`config/\`
- Celery task or signal changes
- Database migration considerations
- Testing approach (what to cover with pytest/factory_boy)

## Compliance Impact

- **SOC 2**: {How this decision affects audit controls, access logging, data isolation}
- **GDPR**: {How this decision affects data residency, consent, right to deletion, DPAs}

## References

- Links to Django docs, library docs, or prior ADRs
\`\`\`

## ADR Topic

**{REPLACE THIS WITH YOUR TOPIC}**

Examples of topics relevant to this project:
- Multi-tenancy strategy (shared DB with row-level security vs. schema-per-tenant vs. DB-per-tenant)
- Stripe webhook processing architecture (sync vs. async, idempotency, retry strategy)
- API versioning strategy (URL path vs. header vs. query param)
- GraphQL vs. REST boundary (which resources get GraphQL, which stay REST-only)
- Celery task idempotency and retry strategy
- Caching strategy (Redis cache patterns, tenant-scoped cache keys, invalidation)
- Audit logging architecture (Django signals vs. middleware vs. explicit service calls)
- Session management and authentication (JWT vs. session-based, token rotation)
- Background job monitoring and dead letter handling
- Tenant onboarding automation (provisioning flow, default data seeding)
- White-label support (custom domains, theming, tenant-specific config)
- Data residency and GDPR compliance (per-tenant region routing)
- Secret management (AWS Secrets Manager vs. Parameter Store vs. Vault)
- Database migration strategy for multi-tenant (zero-downtime, backward-compatible)
- Feature flags for tenant-specific rollouts
- Rate limiting strategy (per-tenant, per-user, per-endpoint)

## Output Rules

1. Use the exact ADR format above — do not skip sections
2. Be specific to Django 5.0, DRF, Strawberry, Celery 5, PostgreSQL 16, Redis, Stripe, AWS
3. Reference actual project directories: \`src/tenants/\`, \`src/billing/\`, \`src/core/\`, \`config/\`, \`tests/\`
4. Reference actual commands: \`uv run pytest\`, \`uv run mypy src/\`, \`uv run python manage.py migrate\`
5. Include real library names and Django patterns (model managers, middleware, signals, management commands)
6. Address SOC 2 and GDPR implications explicitly
7. Keep it under 200 lines — concise and actionable
8. Save the file to \`docs/adr/ADR-{NUMBER}-{kebab-case-title}.md\`
9. Update \`docs/adr/README.md\` with the new ADR entry (create the index if it doesn't exist)
\`\`\`

---

## Usage

1. Copy the entire prompt above into Claude Code
2. Replace \`{REPLACE THIS WITH YOUR TOPIC}\` with your specific architecture decision
3. Replace \`{NUMBER}\` guidance: start at \`0001\` and increment
4. Claude will generate the ADR file and update the index

## Recommended ADR Sequence for This Project

Generate these ADRs in order during Phase 02 — each builds on the previous:

| ADR | Topic | Why First |
|-----|-------|-----------|
| 0001 | Multi-tenancy strategy | Foundation for all data access patterns |
| 0002 | Authentication and session management | Depends on tenant model |
| 0003 | Role-based access control | Depends on auth + tenant |
| 0004 | API design (REST + GraphQL boundary) | Depends on auth + RBAC |
| 0005 | Stripe billing integration architecture | Depends on tenant + API |
| 0006 | Celery task idempotency and retry strategy | Depends on billing webhooks |
| 0007 | Caching strategy (Redis) | Cross-cutting, tenant-scoped |
| 0008 | Audit logging architecture | SOC 2 requirement, cross-cutting |
| 0009 | Database migration strategy | Multi-tenant zero-downtime |
| 0010 | Secret management | Production security baseline |
| 0011 | White-label and custom domain support | Tenant customization layer |
| 0012 | Data residency and GDPR compliance | Regulatory, affects infra |
| 0013 | Rate limiting strategy | Per-tenant fairness |
| 0014 | Feature flags for tenant rollouts | Safe deployment |

## Batch Generation

To generate multiple ADRs in one session:

\`\`\`
Generate ADRs 0001 through 0005 from the recommended sequence in the ADR generator
prompt at playbook/prompts/02/adr-generator.md. Follow the exact format specified.
Save each to docs/adr/ and create the index at docs/adr/README.md.
\`\`\`

## Validating ADRs

After generation, verify:

\`\`\`
Review all ADR files in docs/adr/. For each one, check:
1. All sections from the template are present (no skipped sections)
2. References to src/ directories and config/ are accurate
3. SOC 2 and GDPR compliance sections are substantive, not boilerplate
4. Implementation notes reference specific Django apps, models, or Celery tasks
5. Options considered include at least 2 real alternatives
6. The decision is clearly stated with rationale tied to our constraints
Flag any issues and suggest fixes.
\`\`\``,

  'playbook/prompts/02/api-design.md': `# API Design Prompt — Phase 02: Architecture

> Copy-paste this prompt into Claude Code to design the REST and GraphQL API layer for the django-saas-platform.

---

## Prompt

\`\`\`
You are designing the API layer for a multi-tenant Django SaaS platform. The platform uses Django REST Framework for REST endpoints and Strawberry GraphQL for GraphQL queries/mutations. All endpoints must be tenant-scoped, authenticated, and documented via drf-spectacular (OpenAPI 3.1).

## Context

- Project: django-saas-platform (Django 5.0, Python 3.12+)
- API frameworks: Django REST Framework + Strawberry GraphQL
- Auth: JWT (djangorestframework-simplejwt) with tenant context in token claims
- Multi-tenancy: Row-level security via tenant-aware model managers; tenant resolved from JWT claim or X-Tenant-ID header
- Billing: Stripe subscriptions, usage metering, webhook ingestion
- Docs: drf-spectacular generating OpenAPI 3.1 spec
- Compliance: SOC 2 (audit logging on all mutations), GDPR (PII filtering in responses)

## Design the following API resources

### 1. Tenant Management
- POST   /api/v1/tenants/                  — Create tenant (onboarding)
- GET    /api/v1/tenants/{slug}/           — Retrieve tenant details
- PATCH  /api/v1/tenants/{slug}/           — Update tenant settings (name, branding, config)
- DELETE /api/v1/tenants/{slug}/           — Soft-delete tenant (GDPR right to deletion flow)
- POST   /api/v1/tenants/{slug}/invite/    — Invite user to tenant

### 2. Accounts & Auth
- POST   /api/v1/auth/register/            — User registration with tenant association
- POST   /api/v1/auth/login/               — JWT token pair (access + refresh)
- POST   /api/v1/auth/refresh/             — Refresh access token
- POST   /api/v1/auth/logout/              — Blacklist refresh token
- GET    /api/v1/auth/me/                  — Current user profile with tenant roles
- PATCH  /api/v1/auth/me/                  — Update profile
- POST   /api/v1/auth/password/change/     — Change password
- POST   /api/v1/auth/password/reset/      — Request password reset (triggers Celery email task)
- POST   /api/v1/auth/password/reset/confirm/ — Confirm password reset
- DELETE /api/v1/auth/me/data/             — GDPR data export/deletion request

### 3. Billing & Subscriptions
- GET    /api/v1/billing/plans/            — List available subscription plans
- GET    /api/v1/billing/subscription/     — Current tenant subscription details
- POST   /api/v1/billing/subscription/     — Create subscription (Stripe checkout)
- PATCH  /api/v1/billing/subscription/     — Change plan (upgrade/downgrade)
- DELETE /api/v1/billing/subscription/     — Cancel subscription
- GET    /api/v1/billing/invoices/         — List invoices for tenant
- GET    /api/v1/billing/invoices/{id}/    — Invoice detail with PDF link
- GET    /api/v1/billing/usage/            — Current billing period usage metrics
- POST   /api/v1/billing/usage/report/     — Report usage event (metered billing)
- POST   /api/v1/billing/portal/           — Generate Stripe customer portal session URL
- POST   /api/v1/webhooks/stripe/          — Stripe webhook endpoint (no auth, signature verified)

### 4. RBAC & Permissions
- GET    /api/v1/tenants/{slug}/members/           — List tenant members with roles
- PATCH  /api/v1/tenants/{slug}/members/{id}/      — Update member role
- DELETE /api/v1/tenants/{slug}/members/{id}/      — Remove member from tenant
- GET    /api/v1/tenants/{slug}/roles/             — List available roles
- POST   /api/v1/tenants/{slug}/roles/             — Create custom role
- PATCH  /api/v1/tenants/{slug}/roles/{id}/        — Update role permissions

### 5. Audit Log
- GET    /api/v1/tenants/{slug}/audit-log/         — Query audit events (filterable, paginated)
- GET    /api/v1/tenants/{slug}/audit-log/{id}/    — Audit event detail

### 6. Notifications
- GET    /api/v1/notifications/                     — List user notifications (paginated)
- PATCH  /api/v1/notifications/{id}/read/           — Mark notification as read
- POST   /api/v1/notifications/read-all/            — Mark all as read
- GET    /api/v1/notifications/preferences/         — Get notification preferences
- PATCH  /api/v1/notifications/preferences/         — Update notification preferences

## For each resource group, provide:

### A. DRF Implementation Plan
1. **Serializers** — List each serializer class with fields, validation rules, and any computed/read-only fields. Specify:
   - Which fields are write-only (passwords, tokens)
   - Which fields are tenant-scoped (filtered by request.tenant)
   - PII fields that need GDPR-aware handling (email, name, IP)
   - Nested serializers vs. PrimaryKeyRelatedField decisions
2. **ViewSets / APIViews** — For each endpoint specify:
   - Class name and base class (ModelViewSet, GenericAPIView, APIView)
   - HTTP methods mapped to actions
   - Permission classes (IsAuthenticated, IsTenantAdmin, IsTenantOwner, IsBillingAdmin, custom)
   - Throttle classes (different rates for auth endpoints vs. data endpoints)
   - Filter backends and filterset fields
   - Pagination class (cursor-based for audit log, page-number for lists)
3. **URL patterns** — Show the router registration and urlpatterns for \`src/api/urls.py\`
4. **drf-spectacular decorators** — Note which views need @extend_schema with:
   - Custom request/response examples
   - Tags for grouping
   - Security scheme references
   - Error response schemas (400, 401, 403, 404, 409, 429)

### B. Strawberry GraphQL Schema
1. **Types** — Define Strawberry types mirroring the DRF serializers but optimized for graph traversal:
   - TenantType with nested members, subscription, usage
   - UserType with nested tenants, roles, notifications
   - SubscriptionType with nested plan, invoices
   - Use relay-style connections for paginated lists
2. **Queries** — Map read endpoints to query resolvers:
   - tenant(slug: String!): TenantType
   - me: UserType
   - auditLog(tenantSlug: String!, filters: AuditLogFilterInput): AuditLogConnection
   - notifications(first: Int, after: String): NotificationConnection
3. **Mutations** — Map write endpoints to mutations:
   - createTenant, updateTenant, inviteToTenant
   - updateProfile, changePassword
   - createSubscription, changeSubscriptionPlan, cancelSubscription, reportUsage
   - updateMemberRole, removeMember
   - markNotificationRead, markAllNotificationsRead
4. **Subscriptions (WebSocket)** — Real-time events:
   - onNotification(userId: ID!): NotificationType
   - onUsageUpdate(tenantSlug: String!): UsageMetricType
5. **Permissions** — Strawberry permission classes that mirror DRF permissions
6. **Dataloaders** — Identify N+1 risks and define dataloaders for:
   - Tenant members, roles, subscription, invoices

### C. Cross-Cutting Concerns
1. **Tenant Isolation** — How every queryset is scoped to the current tenant:
   - Middleware that sets request.tenant from JWT or header
   - TenantAwareManager that auto-filters querysets
   - Serializer validation that prevents cross-tenant references
   - GraphQL resolver context injection
2. **Authentication Flow** — JWT lifecycle:
   - Token claims: user_id, tenant_id, tenant_slug, roles
   - Token rotation strategy
   - Multi-tenant token (user belongs to multiple tenants)
3. **Rate Limiting** — Throttle configuration:
   - Auth endpoints: 5/min (anon), 20/min (authenticated)
   - Billing endpoints: 30/min
   - General API: 100/min per user, 1000/min per tenant
   - Webhook endpoint: 500/min (Stripe IP allowlist)
4. **Versioning** — URL-based versioning (/api/v1/) with:
   - Version negotiation strategy
   - Deprecation header policy
5. **Error Format** — Standardized error response:
   \`\`\`json
   {
     "error": {
       "code": "TENANT_NOT_FOUND",
       "message": "Tenant with slug 'acme' does not exist.",
       "details": {},
       "request_id": "req_abc123"
     }
   }
   \`\`\`
6. **Audit Logging** — Middleware/mixin that logs:
   - Actor (user_id, tenant_id, IP, user_agent)
   - Action (HTTP method, endpoint, GraphQL operation)
   - Resource (model, pk)
   - Changes (diff of before/after for mutations)
   - Timestamp, request_id
   - Storage: PostgreSQL audit_log table + optional export to S3 for SOC 2
7. **Idempotency** — For POST endpoints (especially billing):
   - Idempotency-Key header support
   - Redis-backed idempotency store with 24h TTL
   - Stripe idempotency key passthrough

## Output Format

Structure your response as a design document with these sections:
1. **API Overview** — Summary table of all endpoints with methods, auth, and permissions
2. **DRF Implementation** — Detailed per-resource-group implementation plan
3. **GraphQL Schema** — Complete Strawberry type/query/mutation definitions (Python code)
4. **Cross-Cutting Concerns** — Implementation details for each concern listed above
5. **File Structure** — Where each file lives in the project:
   - src/api/v1/serializers/{resource}.py
   - src/api/v1/views/{resource}.py
   - src/api/v1/urls.py
   - src/api/graphql/types/{resource}.py
   - src/api/graphql/queries.py
   - src/api/graphql/mutations.py
   - src/api/graphql/subscriptions.py
   - src/api/graphql/dataloaders.py
   - src/core/permissions.py
   - src/core/throttling.py
   - src/core/middleware/tenant.py
   - src/core/middleware/audit.py
   - src/core/middleware/idempotency.py
6. **Open Questions** — Flag any design decisions that need team input

## Constraints

- All public functions must have Python type hints
- Max 300 lines per file — split large modules
- Use snake_case for Python, kebab-case for URLs
- Every endpoint must appear in the OpenAPI spec via drf-spectacular
- Stripe webhook endpoint must NOT require JWT auth — use Stripe signature verification only
- All billing mutations must be idempotent
- Celery tasks triggered by API calls must be idempotent
- PII fields must be flagged for GDPR data export/deletion
- Audit log must capture all state-changing operations for SOC 2
- Tenant data must never leak across tenant boundaries
- Use cursor-based pagination for large/append-only datasets (audit log, notifications)
- Use page-number pagination for bounded datasets (members, roles, plans)
\`\`\`

---

## How to Use

1. Open Claude Code in the \`django-saas-platform\` repository
2. Ensure Phase 01 discovery artifacts exist in \`docs/\` (requirements, user stories)
3. Copy the prompt above and paste it into Claude Code
4. Review the generated design document with the team
5. Save the approved design to \`docs/api-design.md\`
6. Reference this design during Phase 03 (Foundation) and Phase 04 (Core Implementation)

## Expected Outputs

| Artifact | Location | Description |
|---|---|---|
| API Design Document | \`docs/api-design.md\` | Complete API specification with DRF + GraphQL details |
| Endpoint Summary Table | Section 1 of design doc | Quick reference for all routes, methods, permissions |
| GraphQL Schema Draft | Section 3 of design doc | Strawberry type definitions in Python |
| File Structure Map | Section 5 of design doc | Exact file paths for implementation |
| Open Questions | Section 6 of design doc | Decisions requiring team discussion |

## Follow-Up Prompts

After completing the API design, continue with these Phase 02 prompts:

- **\`playbook/prompts/02/data-model.md\`** — Design the Django models, tenant isolation, and database schema
- **\`playbook/prompts/02/architecture-review.md\`** — Review the overall architecture for consistency and gaps
- **\`playbook/prompts/02/celery-task-design.md\`** — Design the async task layer (billing sync, notifications, reports)

## Validation Checklist

Before finalizing the API design, verify:

- [ ] Every endpoint has explicit authentication and permission requirements
- [ ] All tenant-scoped endpoints enforce tenant isolation in queryset and serializer
- [ ] Stripe webhook endpoint uses signature verification, not JWT
- [ ] Billing mutations support idempotency keys
- [ ] PII fields are identified for GDPR compliance
- [ ] Audit logging covers all state-changing operations
- [ ] Rate limits are defined per endpoint category
- [ ] Error response format is consistent across REST and GraphQL
- [ ] Pagination strategy is appropriate for each resource type
- [ ] GraphQL dataloaders are defined for all N+1 risk areas
- [ ] OpenAPI spec covers all DRF endpoints with examples
- [ ] URL patterns follow kebab-case convention
- [ ] No endpoint exceeds the 300-line file limit when implemented`,

  'playbook/prompts/02/data-model-design.md': `# Data Model Design — Phase 02 Architecture Prompt

> Copy-paste this prompt into Claude Code to generate a comprehensive Django data model design for the SaaS platform.

---

## Prompt

\`\`\`
You are a senior Django architect designing the data model for a multi-tenant SaaS platform. Analyze the requirements gathered in Phase 01 (see \`playbook/phases/01-discovery.md\` and any artifacts in \`docs/requirements/\`) and produce a complete data model design.

## Project Context

- **Framework**: Django 5.0 with PostgreSQL 16
- **Multi-tenancy**: Row-level security with a shared schema approach (all tenants in the same database, isolated by \`tenant_id\` foreign key)
- **Billing**: Stripe integration for subscriptions, usage metering, and invoicing
- **Auth**: Role-based access control (RBAC) with tenant-scoped permissions
- **Compliance**: SOC 2 (audit logging), GDPR (data residency, consent tracking, right to deletion)
- **Architecture**: Modular monolith — each Django app is self-contained with its own models

## Django Apps to Model

Design models for each of these apps under \`src/\`:

### 1. \`tenants\` — Multi-Tenancy Core
- **Tenant**: Organization/company entity. Fields: name, slug (unique, URL-safe), domain (optional custom domain for white-label), tier/plan reference, settings (JSONField for tenant-specific config), status (active, suspended, trial, churned), data_region (for GDPR data residency), created_at, updated_at.
- **TenantDomain**: Custom domain mapping for white-label support. Fields: tenant FK, domain, is_primary, is_verified, verified_at.
- **TenantSettings**: Extended settings if JSONField is insufficient. Consider whether this should be a separate model or part of Tenant.

### 2. \`accounts\` — Users & Authentication
- **User**: Custom user model extending AbstractBaseUser. Fields: email (unique, used as username), first_name, last_name, is_active, is_staff, date_joined, last_login, gdpr_consent_at, gdpr_consent_version, marketing_consent.
- **TenantMembership**: Many-to-many through model linking User to Tenant. Fields: user FK, tenant FK, role (owner, admin, member, viewer, billing), is_default_tenant, invited_by FK, invited_at, accepted_at, deactivated_at. Unique constraint on (user, tenant).
- **Invitation**: Pending invitations. Fields: tenant FK, email, role, token (unique), invited_by FK, expires_at, accepted_at, created_at.
- **AuditLog**: SOC 2 audit trail. Fields: tenant FK, user FK (nullable for system actions), action (enum), resource_type, resource_id, ip_address (GenericIPAddressField), user_agent, metadata (JSONField), created_at. This table is append-only — no updates or deletes.

### 3. \`billing\` — Stripe Integration
- **BillingAccount**: One per tenant. Fields: tenant OneToOne, stripe_customer_id (unique, indexed), billing_email, billing_name, tax_id, address fields, currency (default USD), created_at, updated_at.
- **Subscription**: Fields: billing_account FK, stripe_subscription_id (unique), stripe_price_id, plan_name, status (trialing, active, past_due, canceled, unpaid, paused), current_period_start, current_period_end, cancel_at_period_end, canceled_at, trial_start, trial_end, quantity, metadata (JSONField), created_at, updated_at.
- **Invoice**: Fields: billing_account FK, stripe_invoice_id (unique), subscription FK (nullable), amount_due, amount_paid, currency, status (draft, open, paid, void, uncollectible), period_start, period_end, hosted_invoice_url, pdf_url, created_at, updated_at.
- **UsageRecord**: For usage-based metering. Fields: subscription FK, metric_name (e.g., "api_calls", "storage_gb", "seats"), quantity, timestamp, stripe_usage_record_id, idempotency_key (unique), reported_to_stripe_at, created_at.
- **PaymentMethod**: Fields: billing_account FK, stripe_payment_method_id, type (card, bank_account), last_four, brand, exp_month, exp_year, is_default, created_at.
- **WebhookEvent**: Idempotent webhook processing. Fields: stripe_event_id (unique), event_type, payload (JSONField), processed_at, processing_error, retry_count, created_at.

### 4. \`core\` — Shared Base Models & Managers
- **BaseModel**: Abstract model with id (UUIDField primary key), created_at, updated_at.
- **TenantAwareModel**: Abstract model extending BaseModel, adds tenant FK. All tenant-scoped models inherit from this.
- **TenantAwareManager**: Custom manager that automatically filters by the current tenant (set via middleware/context). All queries through this manager include \`tenant_id\` filter.
- **SoftDeleteModel**: Abstract mixin with deleted_at (nullable DateTimeField) and is_deleted boolean. Override default manager to exclude soft-deleted records.

### 5. \`notifications\` — Communication
- **Notification**: In-app notifications. Fields: tenant FK, recipient FK (User), notification_type (enum), title, body, data (JSONField), is_read, read_at, created_at.
- **EmailLog**: Track sent emails for audit. Fields: tenant FK (nullable), recipient_email, subject, template_name, status (queued, sent, delivered, bounced, failed), provider_message_id, sent_at, created_at.
- **WebhookEndpoint**: Tenant-configured outgoing webhooks. Fields: tenant FK, url, secret (encrypted), events (ArrayField of event types), is_active, failure_count, last_success_at, last_failure_at, created_at, updated_at.
- **WebhookDelivery**: Log of outgoing webhook attempts. Fields: endpoint FK, event_type, payload (JSONField), response_status, response_body (truncated), attempt_number, delivered_at, created_at.

## Design Requirements

1. **UUIDs as Primary Keys**: All models use \`uuid.uuid4\` as the default primary key. Never expose sequential IDs in APIs.

2. **Tenant Isolation**: Every tenant-scoped model MUST have a \`tenant\` ForeignKey. The \`TenantAwareManager\` must be the default manager. Include a database-level CHECK constraint or RLS policy concept.

3. **Indexes**: Design indexes for:
   - All ForeignKey fields (Django does this automatically)
   - Frequently queried fields: \`tenant_id\` + \`created_at\` (composite), \`stripe_*_id\` fields, \`email\`, \`slug\`, \`status\` fields
   - Partial indexes where appropriate (e.g., active subscriptions only)

4. **Constraints**: Use Django's \`Meta.constraints\` for:
   - UniqueConstraint on (tenant, slug) pairs
   - UniqueConstraint on (user, tenant) in TenantMembership
   - CheckConstraint on status fields (valid enum values)
   - UniqueConstraint with condition for partial unique indexes

5. **Soft Deletes**: Apply to User, Tenant, Subscription. AuditLog and WebhookEvent are NEVER deleted.

6. **GDPR Compliance**:
   - User model tracks consent timestamps and versions
   - Design a \`DataDeletionRequest\` model (tenant FK, user FK, status, requested_at, completed_at, deletion_log JSONField)
   - PII fields should be annotated with a comment for data mapping
   - Consider data retention policies (auto-purge after N days)

7. **Audit Trail**: The AuditLog model must capture all CRUD operations on sensitive models (billing, auth, tenant config). Design it for high write throughput (append-only, minimal indexes).

8. **Stripe Sync**: All Stripe-related models must store the \`stripe_*_id\` for two-way sync. Design for eventual consistency — the Stripe webhook is the source of truth, local models are a cache.

9. **Idempotency**: WebhookEvent uses \`stripe_event_id\` as idempotency key. UsageRecord uses \`idempotency_key\`. Design patterns to prevent duplicate processing.

10. **White-Label**: TenantDomain supports custom domains. Tenant.settings JSONField stores branding config (logo_url, primary_color, favicon_url, custom_css_url).

## Output Format

Generate the following artifacts:

### A. Entity-Relationship Summary
A markdown table for each Django app listing: Model, Key Fields, Relationships, Indexes, Constraints.

### B. Django Model Code
For each app, generate the complete \`models.py\` file with:
- All fields with appropriate Django field types
- Field-level help_text for documentation
- Meta class with ordering, indexes, constraints, verbose_name
- \`__str__\` method
- Custom managers where needed
- Type hints on all methods
- Docstrings on each model class

Place model code in:
- \`src/core/models.py\` (abstract base models and managers)
- \`src/tenants/models.py\`
- \`src/accounts/models.py\`
- \`src/billing/models.py\`
- \`src/notifications/models.py\`

### C. Migration Considerations
Document:
- Migration order (dependencies between apps)
- Any raw SQL needed for PostgreSQL RLS policies
- Data migration strategy for seeding initial data (default plans, system tenant)
- Index creation strategy (CONCURRENTLY for large tables)

### D. Factory Definitions
Generate \`factory_boy\` factories for each model in \`tests/factories/\`. These will be used across all test suites. Each factory should:
- Use \`factory.django.DjangoModelFactory\`
- Include \`factory.Faker\` for realistic data
- Use \`factory.SubFactory\` for relationships
- Include traits for common variations (e.g., \`UserFactory\` with \`admin\` trait, \`SubscriptionFactory\` with \`trialing\` trait)

Place factories in:
- \`tests/factories/__init__.py\`
- \`tests/factories/tenants.py\`
- \`tests/factories/accounts.py\`
- \`tests/factories/billing.py\`
- \`tests/factories/notifications.py\`

## Constraints

- Maximum 300 lines per file. Split large model files if needed.
- Follow project naming conventions: snake_case for fields, PascalCase for models, SCREAMING_SNAKE_CASE for constants/choices.
- Use Django's \`TextChoices\` or \`IntegerChoices\` for enum fields.
- All timestamps must be timezone-aware (\`auto_now_add=True\` or \`default=timezone.now\`).
- No Django signals for business logic — document where service layer calls should be used instead.
- Sensitive fields in billing models should have a comment noting they require encryption at rest (handled at the database/infrastructure level).

## Reference Files

Before generating, read these files for context:
- \`playbook/phases/01-discovery.md\` — requirements gathered
- \`playbook/phases/02-architecture.md\` — architecture phase guidance
- \`docs/requirements/\` — any requirement artifacts from Phase 01
- \`playbook/prompts/02/adr-generator.md\` — for creating ADRs about model decisions
- \`playbook/prompts/02/api-design.md\` — ensure models support the planned API surface

After generating the models, suggest ADR topics for key decisions (e.g., "UUID vs sequential IDs", "Shared schema vs schema-per-tenant", "Soft delete strategy", "Audit log storage strategy").
\`\`\`

---

## Usage

1. Ensure Phase 01 artifacts exist in \`docs/requirements/\`
2. Copy the prompt above into Claude Code
3. Review generated models against the API design from \`playbook/prompts/02/api-design.md\`
4. Run \`uv run python manage.py makemigrations --dry-run\` to validate model syntax
5. Run \`uv run mypy src/\` to verify type annotations
6. Create ADRs for key decisions using \`playbook/prompts/02/adr-generator.md\`

## Expected Outputs

| Artifact | Location | Description |
|---|---|---|
| Core abstract models | \`src/core/models.py\` | BaseModel, TenantAwareModel, SoftDeleteModel, managers |
| Tenant models | \`src/tenants/models.py\` | Tenant, TenantDomain |
| Account models | \`src/accounts/models.py\` | User, TenantMembership, Invitation, AuditLog |
| Billing models | \`src/billing/models.py\` | BillingAccount, Subscription, Invoice, UsageRecord, PaymentMethod, WebhookEvent |
| Notification models | \`src/notifications/models.py\` | Notification, EmailLog, WebhookEndpoint, WebhookDelivery |
| Test factories | \`tests/factories/*.py\` | factory_boy factories for all models |
| ER summary | \`docs/architecture/data-model.md\` | Entity-relationship documentation |
| Migration notes | \`docs/architecture/migration-strategy.md\` | Migration order, RLS policies, seeding |

## Validation Checklist

After generation, verify:

- [ ] Every tenant-scoped model inherits from \`TenantAwareModel\`
- [ ] Every model uses UUID primary keys
- [ ] All Stripe ID fields are unique and indexed
- [ ] \`AuditLog\` has no update/delete operations in its design
- [ ] \`WebhookEvent.stripe_event_id\` is unique for idempotency
- [ ] \`UsageRecord.idempotency_key\` is unique
- [ ] GDPR fields exist on User model (consent timestamps)
- [ ] \`DataDeletionRequest\` model exists for right-to-deletion
- [ ] Soft delete mixin is applied to User, Tenant, Subscription
- [ ] All \`TextChoices\` enums use SCREAMING_SNAKE_CASE values
- [ ] No file exceeds 300 lines
- [ ] All public methods have type hints
- [ ] Factory files exist for every app with realistic test data
- [ ] Composite indexes exist for \`(tenant_id, created_at)\` on high-volume tables
- [ ] Sensitive billing fields are annotated for encryption-at-rest`,

  'playbook/prompts/03/ci-pipeline.md': `# CI Pipeline Setup — Phase 03 Foundation

## Prompt for Claude Code

Copy and paste the following prompt into Claude Code to generate the GitHub Actions CI/CD pipeline for the django-saas-platform project.

---

Set up the complete CI/CD pipeline for our Django SaaS platform using GitHub Actions. The project uses \`uv\` as the package manager, Django 5.0, Celery 5, PostgreSQL 16, Redis, and Stripe. All source code lives under \`src/\`, configuration under \`config/\`, and tests under \`tests/\`.

## 1. Create \`.github/workflows/ci.yml\`

Create a GitHub Actions workflow with the following stages that run on every push to \`main\` and on all pull requests:

### Job: \`lint\`
- Runs on \`ubuntu-latest\` with Python 3.12
- Install dependencies with \`uv sync --frozen\`
- Run \`uv run ruff check src/ tests/\` for linting
- Run \`uv run ruff format --check src/ tests/\` for format verification
- Fail fast if any issues found

### Job: \`type-check\` (depends on \`lint\`)
- Runs on \`ubuntu-latest\` with Python 3.12
- Install dependencies with \`uv sync --frozen\`
- Run \`uv run mypy src/ --strict\` for type checking
- Use a mypy cache to speed up subsequent runs

### Job: \`unit-tests\` (depends on \`lint\`)
- Runs on \`ubuntu-latest\` with Python 3.12
- Start PostgreSQL 16 service container with:
  - Database: \`test_saas_db\`
  - User: \`test_user\` / Password: \`test_pass\`
  - Health check with \`pg_isready\`
- Start Redis 7 service container with health check
- Set environment variables:
  - \`DATABASE_URL=postgres://test_user:test_pass@localhost:5432/test_saas_db\`
  - \`REDIS_URL=redis://localhost:6379/0\`
  - \`CELERY_BROKER_URL=redis://localhost:6379/1\`
  - \`DJANGO_SETTINGS_MODULE=config.settings.test\`
  - \`STRIPE_SECRET_KEY=sk_test_fake_key_for_ci\`
  - \`STRIPE_WEBHOOK_SECRET=whsec_fake_secret_for_ci\`
  - \`SECRET_KEY=ci-test-secret-key-not-for-production\`
  - \`ALLOWED_HOSTS=localhost,testserver\`
- Install dependencies with \`uv sync --frozen\`
- Run database migrations: \`uv run python manage.py migrate --no-input\`
- Run unit tests: \`uv run pytest tests/ -m "not integration" --cov=src --cov-report=xml --cov-report=term-missing --cov-fail-under=85 -x --tb=short\`
- Upload coverage report as artifact
- Upload coverage to Codecov (if configured)

### Job: \`integration-tests\` (depends on \`unit-tests\`)
- Same service containers as unit tests (PostgreSQL + Redis)
- Same environment variables
- Run: \`uv run pytest tests/ -m "integration" --tb=short -x\`
- These tests cover Stripe webhook handling, Celery task execution, tenant isolation queries, and cross-service interactions

### Job: \`security-scan\` (depends on \`lint\`)
- Run \`uv run pip-audit\` to check for known vulnerabilities in dependencies
- Run \`uv run bandit -r src/ -c pyproject.toml\` for static security analysis
- Run \`uv run python manage.py check --deploy --fail-level WARNING\` for Django deployment checks
- Check for secrets accidentally committed using \`trufflehog\` or \`gitleaks\` GitHub Action

### Job: \`build-docker\` (depends on \`unit-tests\`, \`security-scan\`)
- Build the Docker image using \`Dockerfile\`
- Tag with \`ghcr.io/\${{ github.repository }}:\${{ github.sha }}\` and \`:latest\` for main branch
- Push to GitHub Container Registry on main branch only
- Cache Docker layers for faster builds

### Job: \`deploy-staging\` (depends on \`build-docker\`, only on \`main\` branch)
- Deploy to staging environment using the built Docker image
- Run post-deployment smoke tests: health check endpoint, database connectivity, Redis connectivity, Celery worker status
- Notify Slack channel \`#deployments\` on success or failure
- Set a 10-minute timeout

### Job: \`e2e-tests\` (depends on \`deploy-staging\`, only on \`main\` branch)
- Run end-to-end tests against the staging environment
- Test critical paths: tenant signup, subscription creation via Stripe test mode, API authentication, GraphQL query execution
- Set a 15-minute timeout

### Job: \`deploy-production\` (depends on \`e2e-tests\`, only on \`main\` branch)
- Requires manual approval via GitHub Environments (\`production\` environment with required reviewers)
- Deploy to production using the same Docker image SHA that passed all tests
- Run post-deployment health checks
- Notify Slack \`#deployments\` on success or failure
- Tag the release with the short SHA

## 2. Create \`.github/workflows/pr-checks.yml\`

A lighter workflow that runs only on pull requests:

- Add a label if the PR touches sensitive paths: \`src/billing/**\`, \`src/accounts/**\`, \`config/settings/production.py\`, any \`.env*\` file, \`**/migrations/**\`
- Add label \`ai-generated\` if the PR body or commits contain \`🤖\` or \`[ai]\` markers
- Check that PR title follows conventional commit format: \`feat:\`, \`fix:\`, \`chore:\`, \`docs:\`, \`refactor:\`, \`test:\`, \`ci:\`
- Check that branch name follows \`type/ticket-desc\` pattern (e.g., \`feat/SAAS-42-add-tenant-onboarding\`)
- Post a comment summarizing test coverage diff if coverage changed
- Enforce that \`CODEOWNERS\` approval is obtained for sensitive paths

## 3. Create \`.github/workflows/scheduled.yml\`

A scheduled workflow that runs nightly:

- Run full test suite including slow integration tests
- Run \`uv run pip-audit\` for dependency vulnerability scanning
- Run database backup verification (check that latest RDS snapshot exists)
- Check for Stripe API version deprecation warnings
- Post results to Slack \`#engineering-alerts\` if any failures

## 4. Create \`.github/CODEOWNERS\`

\`\`\`
# Billing — requires billing team review
src/billing/                    @django-saas-platform/billing-team
tests/billing/                  @django-saas-platform/billing-team

# Auth and accounts — requires security review
src/accounts/                   @django-saas-platform/security-team
src/core/permissions.py         @django-saas-platform/security-team
src/core/middleware.py          @django-saas-platform/security-team

# Tenant isolation — requires platform team review
src/tenants/                    @django-saas-platform/platform-team
src/core/managers.py            @django-saas-platform/platform-team

# Infrastructure and config
config/settings/production.py   @django-saas-platform/platform-leads
.github/                        @django-saas-platform/platform-leads
Dockerfile                      @django-saas-platform/platform-leads
docker-compose*.yml             @django-saas-platform/platform-leads
terraform/                      @django-saas-platform/platform-leads

# Celery tasks
src/tasks/                      @django-saas-platform/backend-team

# API surface
src/api/                        @django-saas-platform/backend-team
\`\`\`

## 5. Create \`config/settings/test.py\`

Django test settings that:
- Inherit from \`config.settings.base\`
- Use a fast password hasher (\`django.contrib.auth.hashers.MD5PasswordHasher\`)
- Disable Celery task execution (use \`CELERY_TASK_ALWAYS_EAGER = True\` and \`CELERY_TASK_EAGER_PROPAGATES = True\`)
- Use \`DATABASE_URL\` from environment with \`test_\` prefix for the database name
- Set \`STRIPE_SECRET_KEY\` and \`STRIPE_WEBHOOK_SECRET\` from environment (test keys)
- Disable email sending (\`EMAIL_BACKEND = "django.core.mail.backends.locmem.EmailBackend"\`)
- Set \`DEFAULT_FILE_STORAGE\` to in-memory storage
- Enable \`TENANT_ISOLATION_STRICT = True\` to catch any unscoped queries in tests
- Set logging to WARNING level to reduce test output noise

## 6. Create \`pyproject.toml\` sections for tool configuration

Add configuration sections for:

**ruff:**
- Target Python 3.12
- Line length 88
- Select rules: E, F, W, I, N, UP, S, B, A, C4, DTZ, T20, DJ, PT
- Ignore: E501 (line length handled by formatter)
- Per-file ignores: \`tests/**\` ignore S101 (assert usage)
- isort: known-first-party = ["src"]

**mypy:**
- Python version 3.12
- Strict mode enabled
- Django plugin: \`mypy_django_plugin.main\`
- Ignore missing imports for third-party packages that lack stubs
- Per-module overrides for \`tests.*\` with \`disallow_untyped_defs = false\`

**pytest:**
- Django settings module: \`config.settings.test\`
- Test paths: \`tests/\`
- Markers: \`unit\`, \`integration\`, \`e2e\`, \`slow\`, \`stripe\`
- Default options: \`-v --strict-markers --tb=short\`
- asyncio_mode: \`auto\`

**bandit:**
- Exclude: \`tests/\`, \`scripts/\`
- Skip: B101 (assert in tests handled by exclude)

**coverage:**
- Source: \`src/\`
- Omit: \`*/migrations/*\`, \`*/tests/*\`, \`config/*\`, \`manage.py\`
- Branch coverage enabled
- Fail under: 85

## Additional Requirements

- All workflow files must use pinned action versions (e.g., \`actions/checkout@v4\`) not \`@latest\`
- Use GitHub Actions cache for \`uv\` dependencies (cache key based on \`uv.lock\` hash)
- Set \`concurrency\` groups on PR workflows to cancel outdated runs
- Add workflow status badges to the project README
- Ensure all secrets (\`STRIPE_SECRET_KEY\`, \`CODECOV_TOKEN\`, \`SLACK_WEBHOOK_URL\`, AWS credentials) are referenced via \`\${{ secrets.* }}\` — never hardcoded
- Add a \`Makefile\` with targets that mirror CI stages for local development: \`make lint\`, \`make typecheck\`, \`make test\`, \`make test-integration\`, \`make security-scan\`, \`make docker-build\`

Generate all files. Ensure the CI pipeline enforces our 85% coverage threshold, validates tenant isolation in tests, and gates production deploys behind manual approval. Reference the playbook phases in \`playbook/phases/03-foundation.md\` for context on what this phase covers.`,

  'playbook/prompts/03/iac-setup.md': `# IaC Setup — Phase 03 Foundation Prompt

> Copy-paste this prompt into Claude Code to generate Infrastructure as Code for the django-saas-platform project using Terraform, Docker, and Kubernetes targeting AWS.

---

## Prompt

You are setting up Infrastructure as Code (IaC) for **django-saas-platform**, a multi-tenant Django SaaS application deployed on AWS. The stack includes Django 5.0, Celery 5, PostgreSQL 16, Redis, and Stripe billing. The infrastructure must support SOC 2 and GDPR compliance requirements including data residency, encryption at rest, audit logging, and tenant data isolation.

### Context

- **Cloud provider**: AWS (us-east-1 primary, eu-west-1 for GDPR data residency)
- **Orchestration**: Kubernetes (EKS) for production, Docker Compose for local development
- **IaC tool**: Terraform with remote state in S3 + DynamoDB locking
- **Environments**: development (local), staging, production
- **CI/CD**: GitHub Actions deploys to staging automatically, production via manual approval
- **Secrets**: AWS Secrets Manager (Stripe keys, DB credentials, Django SECRET_KEY)
- **DNS/CDN**: Route 53 + CloudFront for static assets and white-label tenant domains
- **Monitoring**: Sentry for errors, Prometheus + Grafana for metrics, CloudWatch for AWS-level logs

### Directory Structure

Generate files under this layout:

\`\`\`
infrastructure/
  terraform/
    modules/
      vpc/
        main.tf
        variables.tf
        outputs.tf
      rds/
        main.tf
        variables.tf
        outputs.tf
      elasticache/
        main.tf
        variables.tf
        outputs.tf
      ecs/                    # EKS alternative — generate EKS instead
        ...
      eks/
        main.tf
        variables.tf
        outputs.tf
      s3/
        main.tf
        variables.tf
        outputs.tf
      ses/
        main.tf
        variables.tf
        outputs.tf
      secrets/
        main.tf
        variables.tf
        outputs.tf
      cloudfront/
        main.tf
        variables.tf
        outputs.tf
    environments/
      staging/
        main.tf
        terraform.tfvars
        backend.tf
      production/
        main.tf
        terraform.tfvars
        backend.tf
    variables.tf
    providers.tf
    versions.tf
  docker/
    Dockerfile
    Dockerfile.celery
    docker-compose.yml
    docker-compose.ci.yml
    .dockerignore
  kubernetes/
    base/
      namespace.yaml
      django-deployment.yaml
      django-service.yaml
      celery-worker-deployment.yaml
      celery-beat-deployment.yaml
      redis-deployment.yaml       # staging only; production uses ElastiCache
      ingress.yaml
      hpa.yaml
      configmap.yaml
      secrets.yaml                # ExternalSecret referencing AWS Secrets Manager
    overlays/
      staging/
        kustomization.yaml
        patches/
      production/
        kustomization.yaml
        patches/
\`\`\`

### Terraform Requirements

#### VPC Module
- Multi-AZ VPC with public, private, and database subnets
- NAT Gateway for private subnet egress
- VPC Flow Logs enabled (SOC 2 requirement)
- Network ACLs restricting database subnet access to private subnets only

#### RDS Module (PostgreSQL 16)
- Multi-AZ deployment for production, single instance for staging
- Encryption at rest with KMS (SOC 2 / GDPR)
- Automated backups with 30-day retention (production), 7-day (staging)
- Parameter group enabling \`pgaudit\` extension for audit logging
- Row-level security support — output a note that RLS policies are managed via Django migrations
- Performance Insights enabled
- Database subnet group using private database subnets
- Security group allowing ingress only from EKS worker nodes
- Variable for \`instance_class\`: \`db.r6g.large\` production, \`db.t4g.medium\` staging

#### ElastiCache Module (Redis)
- Redis 7.x cluster mode disabled (single shard, multi-AZ replicas for production)
- Used for: Django cache backend, Celery broker, session store
- Encryption in transit and at rest
- Security group allowing ingress only from EKS worker nodes
- Automatic failover enabled for production
- Variable for \`node_type\`: \`cache.r6g.large\` production, \`cache.t4g.medium\` staging

#### EKS Module
- Managed node groups with auto-scaling (min 2, max 10 production; min 1, max 3 staging)
- IRSA (IAM Roles for Service Accounts) for pod-level AWS permissions
- Cluster logging enabled (api, audit, authenticator — SOC 2)
- Private endpoint access, public endpoint restricted to GitHub Actions runner IPs
- AWS Load Balancer Controller add-on for ingress
- Node group instance types: \`m6i.xlarge\` production, \`t3.large\` staging

#### S3 Module
- Media bucket for tenant file uploads (per-tenant prefix isolation)
- Static assets bucket (served via CloudFront)
- Terraform state bucket (versioning, encryption, lifecycle rules)
- Bucket policies enforcing encryption and denying unencrypted uploads
- CORS configuration for media bucket
- Lifecycle rules: move infrequently accessed tenant data to S3-IA after 90 days

#### SES Module
- Verified domain for transactional email
- DKIM, SPF, DMARC configuration
- Configuration set with SNS topic for bounce/complaint handling
- IAM policy for Django/Celery to send email

#### Secrets Module
- AWS Secrets Manager entries for:
  - \`django/secret-key\`
  - \`django/database-url\`
  - \`stripe/secret-key\`
  - \`stripe/webhook-secret\`
  - \`redis/url\`
  - \`sentry/dsn\`
- Rotation configuration for database credentials (30-day rotation)
- IAM policy allowing EKS pods (via IRSA) to read secrets

#### CloudFront Module
- Distribution for static assets (S3 origin)
- Support for white-label tenant custom domains via alternate domain names
- TLS 1.2+ only (SOC 2)
- WAF integration placeholder (WebACL ARN variable)
- Cache behaviors: static assets (long TTL), media (short TTL with signed URLs)

### Docker Requirements

#### Dockerfile (Django application)
- Multi-stage build: builder stage with \`uv\` for dependency installation, runtime stage with slim Python 3.12
- Non-root user (\`django\`, UID 1000)
- Install only production dependencies from \`pyproject.toml\` using \`uv pip install\`
- Copy \`src/\`, \`config/\`, \`manage.py\`, \`templates/\`, \`static/\`
- Run \`uv run python manage.py collectstatic --noinput\` in build stage
- Healthcheck: \`curl -f http://localhost:8000/health/ || exit 1\`
- Entrypoint: gunicorn with \`config.wsgi:application\`, bind \`0.0.0.0:8000\`, workers from \`$WEB_CONCURRENCY\` (default 4)
- Labels: \`org.opencontainers.image.source\`, \`org.opencontainers.image.revision\`

#### Dockerfile.celery
- Extends same base as Django Dockerfile (use shared base stage)
- Entrypoint for worker: \`celery -A config worker -l info --concurrency=$CELERY_CONCURRENCY\`
- Separate entrypoint for beat: \`celery -A config beat -l info --scheduler django_celery_beat.schedulers:DatabaseScheduler\`
- No healthcheck port — use Celery inspect ping for liveness

#### docker-compose.yml (local development)
- Services: \`web\` (Django), \`worker\` (Celery worker), \`beat\` (Celery beat), \`postgres\` (PostgreSQL 16), \`redis\` (Redis 7), \`mailpit\` (local email testing)
- Mount \`src/\` and \`config/\` as volumes for hot reload
- Django runs with \`uv run python manage.py runserver 0.0.0.0:8000\`
- Environment variables from \`.env\` file
- PostgreSQL with \`POSTGRES_DB=saas_dev\`, health check
- Redis with persistence disabled for speed
- Expose ports: 8000 (web), 5432 (postgres), 6379 (redis), 8025 (mailpit UI)
- Network: \`saas-network\`

#### docker-compose.ci.yml
- Extends docker-compose.yml but overrides for CI:
  - No volume mounts (use built image)
  - PostgreSQL and Redis as services
  - Web service runs: \`uv run pytest --cov=src --cov-report=xml --cov-fail-under=85\`
  - No beat or mailpit services

#### .dockerignore
- Exclude: \`.git\`, \`__pycache__\`, \`*.pyc\`, \`.env*\`, \`node_modules\`, \`.mypy_cache\`, \`.pytest_cache\`, \`.ruff_cache\`, \`infrastructure/\`, \`docs/\`, \`playbook/\`, \`plugin/\`, \`.github/\`, \`htmlcov/\`, \`*.egg-info\`, \`.venv\`

### Kubernetes Requirements

#### Base Manifests
- **Namespace**: \`saas-staging\` / \`saas-production\` (via Kustomize overlay)
- **Django Deployment**:
  - 2 replicas (base), scaled via HPA
  - Resource requests: 256Mi memory, 250m CPU; limits: 512Mi memory, 500m CPU
  - Readiness probe: \`GET /health/\` port 8000
  - Liveness probe: \`GET /health/\` port 8000 (higher failure threshold)
  - Environment from ConfigMap and ExternalSecret
  - Init container: \`uv run python manage.py migrate --noinput\`
  - Pod anti-affinity: prefer spreading across AZs
  - Service account with IRSA annotation for S3, SES, Secrets Manager access

- **Celery Worker Deployment**:
  - 2 replicas (base), scaled via HPA on queue length
  - Resource requests: 512Mi memory, 500m CPU; limits: 1Gi memory, 1000m CPU
  - Liveness probe: exec \`celery -A config inspect ping\`
  - Same environment as Django deployment
  - Separate service account if different IAM permissions needed

- **Celery Beat Deployment**:
  - Exactly 1 replica (singleton — never scale beyond 1)
  - Resource requests: 128Mi memory, 100m CPU
  - Leader election or replica count lock to prevent duplicate scheduling

- **Ingress**:
  - AWS ALB Ingress Controller annotations
  - TLS termination at ALB
  - Host-based routing for white-label tenant domains (wildcard + specific)
  - Health check path: \`/health/\`

- **HPA**:
  - Django: scale on CPU (target 70%) and request rate, min 2 max 20 (production)
  - Celery Worker: scale on Celery queue length custom metric, min 2 max 10

- **ConfigMap**:
  - \`DJANGO_SETTINGS_MODULE\`: \`config.settings.staging\` / \`config.settings.production\`
  - \`ALLOWED_HOSTS\`, \`CSRF_TRUSTED_ORIGINS\`
  - \`CELERY_BROKER_URL\` (non-secret Redis URL for staging; secret ref for production)
  - \`AWS_STORAGE_BUCKET_NAME\`, \`AWS_S3_REGION_NAME\`
  - \`SENTRY_ENVIRONMENT\`

- **ExternalSecret** (using External Secrets Operator):
  - Reference AWS Secrets Manager paths for \`DATABASE_URL\`, \`SECRET_KEY\`, \`STRIPE_SECRET_KEY\`, \`STRIPE_WEBHOOK_SECRET\`, \`SENTRY_DSN\`, \`REDIS_URL\`

#### Kustomize Overlays
- **Staging**: lower resource limits, 1-2 replicas, staging secrets, staging domain
- **Production**: higher resource limits, 2+ replicas with HPA, production secrets, production domain, pod disruption budgets (minAvailable: 1 for Django, 1 for Celery)

### Security & Compliance Considerations

Include comments or annotations in the generated files for:
- **SOC 2**: Encryption at rest (RDS, ElastiCache, S3), encryption in transit (TLS everywhere), audit logging (VPC Flow Logs, EKS audit logs, pgaudit), access controls (IRSA, security groups, NACLs)
- **GDPR**: Data residency (eu-west-1 option for EU tenants), S3 bucket lifecycle for data deletion, RDS backup retention policies, note about right-to-deletion requiring application-level implementation via Django management commands
- **Multi-tenancy**: Tenant data isolation via PostgreSQL RLS (managed in Django migrations), S3 prefix-based isolation, no shared credentials between tenants

### Output Instructions

1. Generate each file with its full path as a header comment
2. Use Terraform 1.6+ syntax with required_providers block
3. Use meaningful variable descriptions and validation rules
4. Tag all AWS resources with: \`Project = "django-saas-platform"\`, \`Environment = var.environment\`, \`ManagedBy = "terraform"\`, \`Compliance = "soc2-gdpr"\`
5. Include \`# SOC 2\` or \`# GDPR\` comments next to compliance-relevant configurations
6. Docker images should use specific version tags, not \`latest\`
7. Kubernetes manifests should use \`apps/v1\` API versions and include resource requests/limits on every container

Start by generating the Terraform modules (VPC, RDS, ElastiCache, EKS, S3, SES, Secrets, CloudFront), then the environment compositions, then Docker files, then Kubernetes manifests. Ensure all modules are wired together correctly with security group references and subnet IDs passed between modules.`,

  'playbook/prompts/03/project-scaffold.md': `# Phase 03 Prompt: Project Scaffold

## Copy-Paste Prompt for Claude Code

\`\`\`
You are scaffolding the foundation for a Django SaaS multi-tenant platform. Generate the complete project structure with working configuration. Every file must be production-oriented — no placeholder "TODO" stubs.

## Project Identity

- Name: django-saas-platform
- Python: 3.12+
- Django: 5.0
- Package manager: uv
- Settings: django-environ + Pydantic settings validation

## Directory Structure to Generate

Create the following structure with real, working code:

\`\`\`
pyproject.toml
uv.lock                          # (generate after deps)
Dockerfile
docker-compose.yml
Makefile
manage.py

config/
  __init__.py
  asgi.py
  wsgi.py
  urls.py
  celery.py
  settings/
    __init__.py
    base.py
    development.py
    staging.py
    production.py
    test.py

src/
  __init__.py
  core/
    __init__.py
    apps.py
    models.py                    # BaseModel with uuid pk, created_at, updated_at, tenant FK
    managers.py                  # TenantAwareManager with row-level filtering
    middleware.py                # TenantMiddleware (resolve tenant from subdomain/header)
    permissions.py               # IsTenantMember, IsTenantAdmin, IsSystemAdmin
    pagination.py                # StandardResultsSetPagination
    exceptions.py                # Custom DRF exception handler with Sentry integration
    decorators.py                # tenant_required, audit_log
    constants.py
  tenants/
    __init__.py
    apps.py
    models.py                    # Tenant, TenantMembership, TenantSettings
    services.py                  # TenantProvisioningService (create tenant, schema, defaults)
    serializers.py
    views.py
    urls.py
    admin.py
    signals.py
    tests/
      __init__.py
      factories.py               # TenantFactory, TenantMembershipFactory (factory_boy)
      test_models.py
      test_services.py
  accounts/
    __init__.py
    apps.py
    models.py                    # CustomUser (AbstractUser), UserProfile
    managers.py                  # CustomUserManager
    serializers.py
    views.py
    urls.py
    admin.py
    authentication.py            # JWT + API key authentication backends
    tests/
      __init__.py
      factories.py               # UserFactory, UserProfileFactory
      test_models.py
      test_authentication.py
  billing/
    __init__.py
    apps.py
    models.py                    # Subscription, Plan, Invoice, UsageRecord, PaymentMethod
    services.py                  # StripeSubscriptionService, UsageMeteringService
    webhooks.py                  # Stripe webhook handler (verified, idempotent)
    serializers.py
    views.py
    urls.py
    admin.py
    constants.py                 # Plan tiers, Stripe event types
    tests/
      __init__.py
      factories.py
      test_webhooks.py
      test_services.py
  api/
    __init__.py
    apps.py
    urls.py                      # Versioned API router (v1/)
    schema.py                    # Strawberry GraphQL schema root
    versioning.py
  notifications/
    __init__.py
    apps.py
    models.py                    # Notification, NotificationPreference
    services.py                  # EmailService (SES), InAppNotificationService
    serializers.py
    views.py
    urls.py
    tests/
      __init__.py
      factories.py
  tasks/
    __init__.py
    billing.py                   # sync_stripe_subscriptions, process_usage_records
    notifications.py             # send_email_task, send_webhook_task
    maintenance.py               # cleanup_expired_sessions, generate_audit_report
  utils/
    __init__.py
    logging.py                   # Structured JSON logging config
    encryption.py                # Field-level encryption for PII (GDPR)
    audit.py                     # AuditLog model and helper

tests/
  __init__.py
  conftest.py                    # Shared fixtures: tenant, user, authenticated_client, stripe_mock
  pytest.ini                     # (or section in pyproject.toml)

scripts/
  setup_dev.sh                   # Bootstrap local dev (uv sync, migrate, seed)
  seed_data.py                   # Management command: create demo tenant, plans, users

docs/
  architecture.md
  api-conventions.md
  tenant-isolation.md

templates/
  emails/
    base.html
    welcome.html
    invoice.html

static/
  .gitkeep

.github/
  CODEOWNERS
  pull_request_template.md
  workflows/
    ci.yml

.env.example
.gitignore
.dockerignore
\`\`\`

## Specific Implementation Requirements

### pyproject.toml
- Use \`[project]\` table (PEP 621) with uv-compatible format
- Dependencies: django>=5.0, djangorestframework, strawberry-graphql-django, celery[redis], django-environ, pydantic-settings, stripe, psycopg[binary], django-cors-headers, drf-spectacular, django-filter, django-redis, whitenoise, gunicorn, sentry-sdk[django]
- Dev dependencies: pytest, pytest-django, pytest-cov, pytest-asyncio, factory-boy, ruff, mypy, django-stubs, djangorestframework-stubs, ipdb, django-debug-toolbar, coverage
- [tool.ruff] config: target Python 3.12, line-length 120, select rules for pyflakes, pycodestyle, isort, bugbear, comprehensions, django
- [tool.mypy] strict mode, django plugin
- [tool.pytest.ini_options] DJANGO_SETTINGS_MODULE=config.settings.test, pythonpath=["src"], addopts with coverage flags, minimum coverage 85%

### config/settings/base.py
- Use django-environ for env vars with Pydantic validation for critical settings
- INSTALLED_APPS: split into django_apps, third_party_apps, local_apps
- local_apps: core, tenants, accounts, billing, api, notifications, tasks, utils
- AUTH_USER_MODEL = "accounts.CustomUser"
- REST_FRAMEWORK config: default authentication (JWT), permission (IsAuthenticated), pagination, exception handler, schema class (drf-spectacular)
- SPECTACULAR_SETTINGS for OpenAPI 3.1 generation
- CELERY_BROKER_URL from env (Redis)
- CACHES using django-redis
- Structured logging config (JSON format for production)
- STRIPE_SECRET_KEY, STRIPE_WEBHOOK_SECRET, STRIPE_PUBLISHABLE_KEY from env
- Database with connection pooling options

### config/celery.py
- Autodiscover tasks from src/tasks/
- Configure beat schedule for periodic tasks (usage sync every hour, cleanup daily)
- Task serializer: json
- Task acks_late: True (at-least-once delivery)
- Task reject_on_worker_lost: True

### src/core/models.py
- BaseModel: UUIDField pk, created_at, updated_at, is_active
- TenantScopedModel(BaseModel): tenant ForeignKey, uses TenantAwareManager as default manager
- Meta: abstract = True for both

### src/core/managers.py
- TenantAwareManager: override get_queryset() to filter by current tenant from thread-local or middleware context
- Raise SecurityError if tenant context is missing (prevent accidental cross-tenant data leaks)

### src/core/middleware.py
- TenantMiddleware: resolve tenant from X-Tenant-ID header or subdomain
- Set tenant on thread-local storage and request object
- Return 403 if tenant not found or user not a member
- AuditMiddleware: log request method, path, user, tenant, response status, duration

### src/tenants/models.py
- Tenant: name, slug (unique), domain, is_active, plan (FK to billing.Plan), settings JSONField, created_at
- TenantMembership: user FK, tenant FK, role (owner/admin/member/viewer), invited_by, joined_at
- TenantSettings: tenant OneToOne, branding JSONField (white-label), feature_flags JSONField

### src/tenants/services.py
- TenantProvisioningService.create_tenant(): create Tenant, assign owner membership, create Stripe customer, set default settings, send welcome email via Celery task
- All operations in a transaction.atomic() block

### src/billing/models.py
- Plan: name, stripe_price_id, tier (free/starter/professional/enterprise), monthly_price, annual_price, features JSONField, usage_limits JSONField
- Subscription: tenant FK, plan FK, stripe_subscription_id, status (active/past_due/canceled/trialing), current_period_start, current_period_end
- Invoice: tenant FK, stripe_invoice_id, amount_due, amount_paid, status, pdf_url
- UsageRecord: tenant FK, metric_name, quantity, recorded_at, stripe_usage_record_id
- PaymentMethod: tenant FK, stripe_payment_method_id, card_last4, card_brand, is_default

### src/billing/webhooks.py
- verify_stripe_signature() decorator
- Handle events: checkout.session.completed, customer.subscription.updated, customer.subscription.deleted, invoice.payment_succeeded, invoice.payment_failed
- Each handler must be idempotent (check if already processed via stripe event ID stored in AuditLog)
- Log all webhook events for SOC 2 audit trail

### src/billing/services.py
- StripeSubscriptionService: create_subscription, cancel_subscription, change_plan, retrieve_upcoming_invoice
- UsageMeteringService: record_usage, get_current_period_usage, report_usage_to_stripe
- All Stripe API calls wrapped in try/except with structured logging and Sentry capture

### src/accounts/models.py
- CustomUser(AbstractUser): email as USERNAME_FIELD, uuid pk, phone, timezone, gdpr_consent_at, data_processing_agreed
- UserProfile: user OneToOne, avatar, bio, notification_preferences JSONField

### src/accounts/authentication.py
- JWTAuthentication backend (using djangorestframework-simplejwt or custom)
- APIKeyAuthentication backend (for machine-to-machine)
- Both must set request.tenant from the authenticated context

### src/tasks/ (all Celery tasks)
- Every task decorated with @shared_task(bind=True, max_retries=3, default_retry_delay=60)
- Every task must be idempotent
- billing.py: sync_stripe_subscriptions, process_usage_records, handle_failed_payment
- notifications.py: send_email_task (via SES), send_webhook_task (with retry and HMAC signing)
- maintenance.py: cleanup_expired_sessions, generate_audit_report, purge_soft_deleted_records

### tests/conftest.py
- @pytest.fixture: tenant_factory, user_factory, authenticated_api_client (with tenant context set)
- @pytest.fixture: stripe_mock (mock Stripe API calls)
- @pytest.fixture: celery_eager (CELERY_ALWAYS_EAGER=True for sync task execution in tests)
- @pytest.fixture: db_with_tenant (create tenant + user + membership)

### docker-compose.yml
- Services: web (Django), worker (Celery), beat (Celery Beat), postgres (16), redis (7), mailhog (dev email)
- Volumes for postgres data persistence
- Environment from .env file
- Health checks on postgres and redis

### Dockerfile
- Multi-stage build: builder (uv install) → runtime (slim Python 3.12)
- Non-root user
- COPY only necessary files
- Gunicorn as entrypoint

### Makefile
- Targets: dev, test, lint, format, typecheck, migrate, shell, celery-worker, celery-beat, docker-up, docker-down, seed, coverage, openapi-schema

### .github/workflows/ci.yml
- Jobs: lint (ruff check + ruff format --check), typecheck (mypy --strict), test (pytest with postgres service container), security (pip-audit or safety), build (Docker image)
- PostgreSQL and Redis service containers for test job
- Cache uv dependencies
- Upload coverage report
- Add AI-generated code label if PR author is a bot

### .env.example
- All required env vars with safe defaults for local dev
- Comments explaining each variable
- NEVER include real secrets

### .github/CODEOWNERS
- src/billing/ → @billing-team
- src/accounts/ → @auth-team
- src/tenants/ → @platform-team
- config/settings/production.py → @devops-team @platform-leads
- .github/ → @devops-team

## Constraints

1. Type hints on ALL public functions and methods
2. Docstrings on all classes and public methods (Google style)
3. No file exceeds 300 lines — split into modules if needed
4. All models that store tenant data MUST extend TenantScopedModel
5. No raw SQL unless for PostgreSQL row-level security policies (document in comments)
6. All Stripe interactions go through service layer — never call stripe.* directly in views
7. All secrets from environment variables — zero hardcoded credentials
8. GDPR: PII fields must use encryption utility, User model must support right-to-deletion
9. SOC 2: All data mutations must be audit-logged
10. Every Django app must have an AppConfig with default_auto_field = "django.db.models.BigAutoField"

## Validation

After generating, verify:
- \`uv sync\` installs all dependencies
- \`uv run python manage.py check --deploy\` passes (with appropriate env vars)
- \`uv run ruff check src/\` reports zero errors
- \`uv run mypy src/\` passes in strict mode
- \`uv run pytest tests/ -x\` passes with the initial test suite
- \`docker compose up\` starts all services and Django connects to PostgreSQL and Redis

Generate all files now. Start with pyproject.toml, then config/, then src/ apps in order, then tests/, then infrastructure files.
\`\`\`

## Usage Notes

### Before Running This Prompt

1. Complete Phase 01 (Discovery) — you need user stories and NFRs defined
2. Complete Phase 02 (Architecture) — you need ADRs for multi-tenancy strategy, API design, and billing integration
3. Have your \`.env\` values ready for local development
4. Ensure Docker Desktop is running for the compose validation step

### After Running This Prompt

1. **Verify the scaffold builds:**
   \`\`\`bash
   uv sync
   uv run python manage.py check
   uv run ruff check src/
   uv run mypy src/
   docker compose up -d
   uv run python manage.py migrate
   uv run pytest tests/ -x
   \`\`\`

2. **Seed development data:**
   \`\`\`bash
   make seed
   \`\`\`

3. **Validate OpenAPI schema generates:**
   \`\`\`bash
   uv run python manage.py spectacular --file schema.yml --validate
   \`\`\`

4. **Commit the scaffold:**
   \`\`\`bash
   git checkout -b feat/SAAS-001-project-scaffold
   git add -A
   git commit -m "feat: scaffold Django SaaS platform foundation

   - Django 5.0 project structure with modular apps
   - Multi-tenant core with TenantAwareManager and middleware
   - Billing app with Stripe models and webhook handler
   - Celery configuration with Redis broker and beat scheduler
   - Docker Compose for local development
   - CI/CD pipeline with lint, typecheck, test, build stages
   - pytest fixtures with factory_boy and Stripe mocks
   - GDPR-compliant user model with encryption utilities
   - SOC 2 audit logging middleware

   Generated-by: claude-code"
   git push origin feat/SAAS-001-project-scaffold
   \`\`\`

5. **Update phase tracker:**
   \`\`\`bash
   ./playbook/codeforge-phase.sh set 03
   \`\`\`

### Customization Points

| Section | What to Modify | When |
|---|---|---|
| Tenant resolution | Subdomain vs header vs path | If your tenancy model differs from subdomain-based |
| Stripe models | Plan tiers and features | When your pricing model is finalized |
| Celery beat schedule | Task intervals | Based on your SLA requirements |
| Auth backends | JWT vs session vs API key | If you need different auth for different clients |
| Docker services | Add Elasticsearch, MinIO, etc. | If your architecture requires additional services |

### Common Issues

- **mypy errors on Django models**: Ensure \`django-stubs\` is installed and \`mypy_django_plugin\` is configured in \`pyproject.toml\`
- **Celery autodiscover not finding tasks**: Verify \`CELERY_IMPORTS\` in settings includes \`"src.tasks.billing"\`, \`"src.tasks.notifications"\`, \`"src.tasks.maintenance"\` or that autodiscover path is correct
- **TenantAwareManager context missing in tests**: Use the \`db_with_tenant\` fixture which sets up thread-local tenant context
- **Stripe webhook verification failing locally**: Use \`stripe listen --forward-to localhost:8000/api/v1/billing/webhooks/\` with the Stripe CLI`,

  'playbook/prompts/04/auth-implementation.md': `# Auth Implementation Prompt — Phase 04: Core Implementation

> Copy-paste this prompt into Claude Code to implement the authentication and authorization system for the Django SaaS platform.

---

## Prompt

You are implementing the authentication and authorization system for a multi-tenant Django SaaS platform. This is a Phase 04 (Core Implementation) task. Follow the project conventions in \`.claude/rules/\` and the architecture decisions in \`docs/adr/\`.

### Context

- **Framework**: Django 5.0 with Django REST Framework and Strawberry GraphQL
- **Multi-tenancy**: Row-level security via PostgreSQL, tenant-aware model managers in \`src/core/\`
- **Settings**: \`config/\` directory with base/development/staging/production splits using django-environ + Pydantic
- **Test framework**: pytest with factory_boy fixtures, 85% coverage threshold
- **Type checking**: mypy strict mode — all public functions must have type hints
- **Linting**: ruff (check + format)
- **Package manager**: uv
- **Compliance**: SOC 2 (audit logging for all auth events), GDPR (consent tracking, right to deletion)

### Requirements

Implement the following in \`src/accounts/\` as a self-contained Django app:

#### 1. User Model (\`src/accounts/models.py\`)

- Custom user model extending \`AbstractBaseUser\` and \`PermissionsMixin\`
- Fields: \`email\` (unique, primary login), \`full_name\`, \`tenant\` (FK to \`tenants.Tenant\`), \`role\`, \`is_active\`, \`is_verified\`, \`accepted_terms_at\` (GDPR consent timestamp), \`last_login_ip\`, \`created_at\`, \`updated_at\`
- Role choices: \`owner\`, \`admin\`, \`member\`, \`viewer\`, \`billing_admin\`
- Custom manager \`TenantAwareUserManager\` that extends \`src/core/managers.py:TenantAwareManager\` and also extends \`BaseUserManager\`
- \`USERNAME_FIELD = "email"\`, no username
- \`__str__\` returns email, \`__repr__\` includes id and tenant_id
- Add \`Meta.constraints\` for unique email per tenant (unique_together on email + tenant is NOT sufficient — use \`UniqueConstraint\` with condition for active users only)
- Add database index on \`(tenant_id, email)\` and \`(tenant_id, role)\`

#### 2. Role-Based Access Control (\`src/accounts/permissions.py\`)

- Django REST Framework permission classes:
  - \`IsTenantMember\` — user belongs to the request's tenant (extracted from subdomain/header middleware in \`src/core/middleware.py\`)
  - \`IsTenantAdmin\` — user has \`owner\` or \`admin\` role in current tenant
  - \`IsTenantOwner\` — user has \`owner\` role
  - \`IsBillingAdmin\` — user has \`billing_admin\` or \`owner\` role
  - \`HasRole(*roles)\` — factory function returning a permission class that checks if user's role is in the given set
- Each permission class must set a \`message\` attribute for clear 403 responses
- All permission checks must verify \`request.tenant\` is set (return False if missing)
- Add Strawberry GraphQL permission classes that mirror the DRF ones in \`src/accounts/graphql_permissions.py\`

#### 3. Authentication Backends (\`src/accounts/backends.py\`)

- \`TenantAwareAuthBackend\` — authenticates user by email + password scoped to the current tenant
- \`APITokenBackend\` — authenticates via \`Authorization: Bearer <token>\` header using a \`PersonalAccessToken\` model
- \`PersonalAccessToken\` model: \`key\` (hashed, unique), \`user\` (FK), \`name\`, \`scopes\` (JSONField), \`expires_at\`, \`last_used_at\`, \`created_at\`
- Token key is shown once on creation, stored as SHA-256 hash
- Expired tokens must be rejected
- All authentication attempts (success and failure) must be logged via the audit log

#### 4. Authentication API (\`src/accounts/views.py\` and \`src/accounts/serializers.py\`)

DRF ViewSets and serializers for:

- **POST /api/v1/auth/register/** — Create account + tenant (onboarding flow). Fields: email, password, full_name, tenant_name, accepted_terms (must be true). Returns user + tenant + JWT tokens. Sends verification email via Celery task.
- **POST /api/v1/auth/login/** — Email + password login scoped to tenant. Returns JWT access + refresh tokens. Records \`last_login_ip\` from request. Rate-limited to 5 attempts per minute per email.
- **POST /api/v1/auth/refresh/** — Refresh JWT access token.
- **POST /api/v1/auth/logout/** — Blacklist the refresh token.
- **POST /api/v1/auth/verify-email/** — Verify email with token (from email link).
- **POST /api/v1/auth/password-reset/** — Request password reset email.
- **POST /api/v1/auth/password-reset/confirm/** — Confirm password reset with token.
- **GET /api/v1/auth/me/** — Current user profile (tenant-scoped).
- **PATCH /api/v1/auth/me/** — Update current user profile.
- **POST /api/v1/auth/tokens/** — Create personal access token.
- **GET /api/v1/auth/tokens/** — List user's personal access tokens (masked keys).
- **DELETE /api/v1/auth/tokens/{id}/** — Revoke a personal access token.

All endpoints must have \`@extend_schema\` decorators for drf-spectacular OpenAPI docs.

#### 5. Service Layer (\`src/accounts/services.py\`)

Business logic must NOT live in views or serializers. Implement:

- \`register_user(email, password, full_name, tenant_name, accepted_terms, ip_address) -> tuple[User, Tenant]\`
- \`authenticate_user(email, password, tenant, ip_address) -> User | None\`
- \`verify_email(token) -> User\`
- \`request_password_reset(email, tenant) -> None\` (always returns success to prevent enumeration)
- \`confirm_password_reset(token, new_password) -> User\`
- \`create_personal_access_token(user, name, scopes, expires_at) -> tuple[PersonalAccessToken, str]\` (returns model + raw key)
- \`revoke_personal_access_token(user, token_id) -> None\`
- \`change_user_role(acting_user, target_user, new_role) -> User\` (with permission checks: only owner can promote to admin, etc.)
- \`deactivate_user(acting_user, target_user) -> User\` (GDPR: schedule data anonymization via Celery)
- \`delete_user_data(user_id) -> None\` (GDPR right to deletion — anonymize PII, keep audit trail with anonymized references)

All service functions must:
- Have full type hints (input and return types)
- Raise domain-specific exceptions from \`src/accounts/exceptions.py\` (not generic Django exceptions)
- Log auth events to the audit log (\`src/core/audit.py\`)
- Be wrapped in \`@transaction.atomic\` where appropriate

#### 6. Audit Logging (\`src/accounts/signals.py\` or inline in services)

Prefer explicit audit log calls in the service layer over Django signals. Log these events to \`core.AuditLog\`:

- \`user.registered\`, \`user.login.success\`, \`user.login.failed\`, \`user.logout\`
- \`user.email.verified\`, \`user.password.reset.requested\`, \`user.password.reset.completed\`
- \`user.role.changed\`, \`user.deactivated\`, \`user.data.deleted\`
- \`token.created\`, \`token.revoked\`

Each audit entry must include: \`tenant_id\`, \`user_id\` (actor), \`target_user_id\`, \`event_type\`, \`ip_address\`, \`metadata\` (JSONField), \`created_at\`.

#### 7. Celery Tasks (\`src/accounts/tasks.py\`)

- \`send_verification_email(user_id: int) -> None\`
- \`send_password_reset_email(user_id: int, token: str) -> None\`
- \`anonymize_user_data(user_id: int) -> None\` (GDPR deletion — runs after grace period)
- \`cleanup_expired_tokens() -> int\` (periodic task via Celery Beat, returns count deleted)

All tasks must be **idempotent** — safe to retry. Use \`@shared_task(bind=True, max_retries=3, default_retry_delay=60)\`.

#### 8. URL Configuration (\`src/accounts/urls.py\`)

- Wire all auth endpoints under \`auth/\` prefix
- Token management under \`auth/tokens/\`
- Use kebab-case for URL paths: \`verify-email\`, \`password-reset\`

#### 9. Tests (\`tests/accounts/\`)

Write comprehensive tests using pytest + factory_boy:

- \`tests/accounts/factories.py\` — \`UserFactory\`, \`TenantFactory\`, \`PersonalAccessTokenFactory\`
- \`tests/accounts/test_models.py\` — Model validation, constraints, manager queries
- \`tests/accounts/test_services.py\` — All service layer functions, happy path + error cases
- \`tests/accounts/test_views.py\` — API endpoint tests (status codes, response shapes, auth requirements)
- \`tests/accounts/test_permissions.py\` — Permission class behavior for each role
- \`tests/accounts/test_tasks.py\` — Celery task idempotency, retry behavior (use \`@pytest.mark.celery\`)

Use \`@pytest.fixture\` for tenant context setup. Use \`pytest.raises\` for expected exceptions. Mock Stripe and email sending.

#### 10. Django Admin (\`src/accounts/admin.py\`)

- Register custom User model with \`UserAdmin\` subclass
- Display: email, full_name, tenant, role, is_active, is_verified, last_login, created_at
- Filters: role, is_active, is_verified, tenant
- Search: email, full_name
- Read-only: created_at, updated_at, last_login_ip
- Inline for PersonalAccessToken (read-only, no key display)

### File Structure to Create

\`\`\`
src/accounts/
├── __init__.py
├── admin.py
├── apps.py
├── backends.py
├── exceptions.py
├── graphql_permissions.py
├── managers.py
├── migrations/
│   └── 0001_initial.py  (auto-generated)
├── models.py
├── permissions.py
├── serializers.py
├── services.py
├── signals.py
├── tasks.py
├── urls.py
└── views.py
tests/accounts/
├── __init__.py
├── conftest.py
├── factories.py
├── test_models.py
├── test_permissions.py
├── test_services.py
├── test_tasks.py
└── test_views.py
\`\`\`

### Constraints

1. **Max 300 lines per file** — split if needed (e.g., \`views.py\` into \`views/auth.py\` and \`views/tokens.py\`)
2. **No business logic in views or serializers** — delegate to \`services.py\`
3. **All tenant data access through tenant-aware managers** — never use \`objects.all()\` for tenant-scoped models
4. **Stripe is NOT part of this task** — billing integration is separate. But the \`billing_admin\` role must exist.
5. **JWT implementation**: Use \`djangorestframework-simplejwt\` — configure in settings, don't reimplement
6. **Password validation**: Use Django's built-in validators + add minimum 10 chars for SOC 2
7. **Rate limiting**: Use \`django-ratelimit\` or DRF throttling on login/register endpoints
8. **Secrets**: Never log passwords, tokens, or PII. Audit logs must not contain raw credentials.

### Verification

After implementation, run:

\`\`\`bash
uv run ruff check src/accounts/ tests/accounts/
uv run ruff format --check src/accounts/ tests/accounts/
uv run mypy src/accounts/
uv run pytest tests/accounts/ -v --cov=src/accounts --cov-report=term-missing
\`\`\`

All must pass. Coverage for \`src/accounts/\` must be ≥ 85%.

### Implementation Order

Start in this order to manage dependencies:

1. \`exceptions.py\` (no deps)
2. \`managers.py\` (depends on \`src/core/managers.py\`)
3. \`models.py\` (depends on managers, tenants app)
4. \`backends.py\` (depends on models)
5. \`permissions.py\` + \`graphql_permissions.py\` (depends on models)
6. \`services.py\` (depends on models, exceptions, core.audit)
7. \`tasks.py\` (depends on services)
8. \`serializers.py\` (depends on models)
9. \`views.py\` (depends on serializers, services, permissions)
10. \`urls.py\` (depends on views)
11. \`admin.py\` (depends on models)
12. Tests (all test files, using factories)

Ask me if you need clarification on the tenant middleware (\`src/core/middleware.py\`), the base audit log model (\`src/core/audit.py\`), or the tenant model (\`src/tenants/models.py\`) before starting.`,

  'playbook/prompts/04/crud-generator.md': `# CRUD Generator — Phase 04: Core Implementation

> Copy-pasteable prompt for Claude Code to generate a complete, tenant-aware CRUD module for a Django SaaS resource.

---

## Usage

Copy the prompt below into Claude Code. Replace all \`{{PLACEHOLDER}}\` values with your specifics before running.

---

## Prompt

\`\`\`
You are building a tenant-aware CRUD module for the django-saas-platform project. Generate a complete, production-ready CRUD implementation for the resource described below.

## Resource Specification

- **App name**: {{APP_NAME}}                    # e.g., "projects", "invoices", "documents"
- **Model name**: {{MODEL_NAME}}                # e.g., "Project", "Invoice", "Document"
- **Ticket**: {{TICKET_ID}}                     # e.g., "SAAS-87"
- **Fields** (name: type: constraints):
{{FIELDS}}
# Example:
# - name: CharField: max_length=255, required
# - description: TextField: blank=True
# - status: CharField: choices=STATUS_CHOICES, default="draft"
# - due_date: DateField: null=True, blank=True
# - owner: ForeignKey(User): on_delete=CASCADE
# - budget_cents: IntegerField: default=0
# - is_archived: BooleanField: default=False

- **Filterable fields**: {{FILTERABLE_FIELDS}}  # e.g., "status, owner, is_archived, due_date"
- **Searchable fields**: {{SEARCHABLE_FIELDS}}  # e.g., "name, description"
- **Ordering fields**: {{ORDERING_FIELDS}}      # e.g., "name, created_at, due_date"
- **Default ordering**: {{DEFAULT_ORDERING}}    # e.g., "-created_at"
- **Soft delete**: {{SOFT_DELETE}}               # yes / no
- **Audit log**: {{AUDIT_LOG}}                  # yes / no
- **GraphQL**: {{GRAPHQL}}                      # yes / no (in addition to REST)
- **Celery tasks**: {{CELERY_TASKS}}            # e.g., "send_notification_on_create, generate_pdf_export" or "none"
- **Custom permissions**: {{CUSTOM_PERMISSIONS}} # e.g., "can_archive, can_export" or "none"
- **Nested resources**: {{NESTED_RESOURCES}}    # e.g., "Comment, Attachment" or "none"

## Architecture Rules

1. **Tenant isolation is mandatory.** Every model must have a \`tenant\` ForeignKey to \`tenants.Tenant\`. Every QuerySet must filter by tenant. Use the tenant-aware manager from \`core.managers.TenantAwareManager\`.

2. **File structure** — generate all files inside \`src/{{APP_NAME}}/\`:
   \`\`\`
   src/{{APP_NAME}}/
     __init__.py
     models.py          # Model with tenant FK, TenantAwareManager, indexes
     managers.py         # Custom manager if beyond base TenantAwareManager
     serializers.py      # DRF serializers (list, detail, create, update)
     views.py            # DRF viewsets with tenant-scoped queryset
     urls.py             # Router registration, kebab-case URL paths
     filters.py          # django-filter FilterSet
     permissions.py      # Custom object-level permissions
     services.py         # Business logic layer (no logic in views)
     signals.py          # Only if audit_log=yes, otherwise omit
     apps.py             # AppConfig with ready() for signal registration
     admin.py            # Tenant-scoped admin with list_filter, search
     tasks.py            # Celery tasks (if any), must be idempotent
     schema.py           # Strawberry GraphQL types/queries/mutations (if GraphQL=yes)
   tests/
     __init__.py
     factories.py        # factory_boy factories with tenant trait
     test_models.py      # Model validation, manager filtering, constraints
     test_serializers.py # Serialization, validation, tenant scoping
     test_views.py       # API endpoint tests (CRUD, permissions, filtering)
     test_services.py    # Service layer unit tests
     test_tasks.py       # Celery task tests (if any)
   \`\`\`

3. **Model requirements:**
   - Inherit from \`core.models.TenantScopedModel\` (provides \`tenant\`, \`created_at\`, \`updated_at\`, \`id\` as UUID).
   - If soft_delete=yes, add \`deleted_at = DateTimeField(null=True, blank=True, db_index=True)\` and override the manager to exclude soft-deleted by default. Provide \`all_with_deleted\` manager.
   - Add \`class Meta\` with: \`ordering\`, \`indexes\` (composite on tenant + filterable fields), \`constraints\` (UniqueConstraint scoped to tenant where appropriate), \`verbose_name\`, \`verbose_name_plural\`.
   - Add \`__str__\` returning a human-readable representation.
   - Type hints on all public methods.

4. **Service layer requirements:**
   - All create/update/delete logic lives in \`services.py\`, not in views or serializers.
   - Service functions accept \`tenant\`, \`user\`, and validated data as arguments.
   - Service functions return the model instance or raise domain exceptions from \`core.exceptions\`.
   - If audit_log=yes, call \`core.audit.log_action(tenant, user, action, instance, changes)\` inside service functions.
   - If Celery tasks are specified, dispatch them from the service layer after successful DB commit using \`transaction.on_commit()\`.

5. **Serializer requirements:**
   - \`{{MODEL_NAME}}ListSerializer\` — lightweight, for list endpoints.
   - \`{{MODEL_NAME}}DetailSerializer\` — full representation with nested related data.
   - \`{{MODEL_NAME}}CreateSerializer\` — write serializer with validation.
   - \`{{MODEL_NAME}}UpdateSerializer\` — partial update serializer.
   - Never expose \`tenant\` in request input — inject from \`request.tenant\` in the view.
   - All serializers must have \`class Meta\` with explicit \`fields\` (no \`__all__\`).
   - Add OpenAPI examples via \`@extend_schema_serializer\` from drf-spectacular.

6. **View requirements:**
   - Use \`ModelViewSet\` with \`get_queryset()\` filtered by \`request.tenant\`.
   - Use \`get_serializer_class()\` to return the appropriate serializer per action.
   - Call service layer from \`perform_create\`, \`perform_update\`, \`perform_destroy\`.
   - Apply \`TenantPermission\` and any custom permissions from \`permissions.py\`.
   - Apply \`django_filters.DjangoFilterBackend\`, \`SearchFilter\`, \`OrderingFilter\`.
   - Annotate every action with \`@extend_schema()\` from drf-spectacular.
   - Pagination via \`core.pagination.StandardResultsSetPagination\`.
   - Return 404 (not 403) when accessing another tenant's data (prevent enumeration).

7. **URL requirements:**
   - Register under \`api/v1/{{APP_NAME_KEBAB}}/\` using \`DefaultRouter\`.
   - Use kebab-case for URL paths.
   - Custom actions use \`@action\` decorator with explicit \`url_path\`.

8. **Filter requirements:**
   - Use \`django_filters.FilterSet\` in \`filters.py\`.
   - Date fields get \`DateFromToRangeFilter\`.
   - Choice fields get \`ChoiceFilter\`.
   - ForeignKey fields get \`ModelChoiceFilter\` scoped to tenant.
   - Add \`ordering\` filter with allowed fields.

9. **Permission requirements:**
   - Base: user must belong to the tenant (\`TenantPermission\`).
   - Object-level: owner or tenant admin can update/delete.
   - Custom permissions map to \`has_perm\` checks using the RBAC system in \`accounts.permissions\`.
   - Return \`403\` with a structured error body \`{"detail": "...", "code": "permission_denied"}\`.

10. **Test requirements:**
    - Use \`pytest\` with \`pytest-django\`. Fixtures via \`factory_boy\`.
    - \`TenantFactory\`, \`UserFactory\` from \`tests.factories\` (shared).
    - \`{{MODEL_NAME}}Factory\` in \`tests/factories.py\` with \`tenant\` trait.
    - **test_models.py**: test \`__str__\`, constraints, soft delete (if applicable), manager filtering, tenant isolation.
    - **test_views.py**: test all CRUD operations, test tenant isolation (user from tenant A cannot see tenant B data), test filtering/search/ordering, test permissions, test pagination. Use \`api_client\` fixture with \`force_authenticate\`.
    - **test_services.py**: test business logic, audit log calls (if applicable), task dispatch (if applicable), error cases.
    - **test_tasks.py**: test idempotency (running task twice produces same result), test failure handling.
    - Target 90%+ coverage for this module.
    - Every test class has a docstring explaining what it covers.

11. **Admin requirements:**
    - Register with \`@admin.register\`.
    - \`list_display\` includes key fields + \`tenant\`, \`created_at\`.
    - \`list_filter\` includes \`tenant\`, filterable fields.
    - \`search_fields\` includes searchable fields.
    - \`readonly_fields\` includes \`id\`, \`created_at\`, \`updated_at\`.
    - Override \`get_queryset\` to scope by tenant for non-superusers.

12. **GraphQL requirements (if GraphQL=yes):**
    - Strawberry type for the model in \`schema.py\`.
    - Query: \`{{model_name}}s\` (list with pagination + filters), \`{{model_name}}\` (by ID).
    - Mutations: \`create_{{model_name}}\`, \`update_{{model_name}}\`, \`delete_{{model_name}}\`.
    - All resolvers enforce tenant isolation via \`info.context.request.tenant\`.
    - Use dataloader pattern for N+1 prevention on ForeignKey fields.

13. **Celery task requirements (if any):**
    - Decorate with \`@shared_task(bind=True, max_retries=3, default_retry_delay=60)\`.
    - Tasks must be idempotent — use idempotency keys or check-before-act.
    - Accept only serializable arguments (IDs, not model instances).
    - Log task start, completion, and failure via \`structlog\`.
    - Handle \`self.retry(exc=exc)\` on transient failures.

14. **Code quality:**
    - Type hints on all public functions and methods.
    - Docstrings on all classes and public methods.
    - Max 300 lines per file — split if needed.
    - Follow ruff rules, pass \`mypy --strict\`.
    - Use \`from __future__ import annotations\` in every file.

15. **Security (SOC 2 / GDPR):**
    - Never log or serialize sensitive fields (PII) without masking.
    - If the model contains PII, add a \`gdpr_fields\` class attribute listing them and implement \`anonymize()\` method for right-to-deletion support.
    - Tenant data must never leak across tenant boundaries — this is the #1 invariant.

## Output Format

Generate each file with a clear header comment:
\`\`\`python
# src/{{APP_NAME}}/models.py
\`\`\`

Generate files in this order:
1. models.py
2. managers.py (if needed)
3. services.py
4. serializers.py
5. filters.py
6. permissions.py
7. views.py
8. urls.py
9. admin.py
10. tasks.py (if applicable)
11. schema.py (if GraphQL=yes)
12. signals.py (if audit_log=yes)
13. apps.py
14. tests/factories.py
15. tests/test_models.py
16. tests/test_services.py
17. tests/test_views.py
18. tests/test_tasks.py (if applicable)

After generating all files, output a checklist:
- [ ] Model inherits TenantScopedModel
- [ ] All queries scoped to tenant
- [ ] Service layer handles all business logic
- [ ] Serializers never accept tenant from input
- [ ] Views use get_queryset() with tenant filter
- [ ] All endpoints have drf-spectacular schema
- [ ] Filters scoped to tenant for FK fields
- [ ] Tests cover tenant isolation
- [ ] Tests cover CRUD happy path and error cases
- [ ] Celery tasks are idempotent (if applicable)
- [ ] GDPR anonymize() method present (if PII fields exist)
- [ ] Audit logging in service layer (if applicable)
- [ ] Admin scoped to tenant for non-superusers
- [ ] All files under 300 lines
- [ ] Type hints on all public functions
\`\`\`

---

## Quick-Start Examples

### Example 1: Simple Resource (Project)

\`\`\`
App name: projects
Model name: Project
Ticket: SAAS-87
Fields:
  - name: CharField: max_length=255, required
  - description: TextField: blank=True
  - status: CharField: choices=[("draft","Draft"),("active","Active"),("completed","Completed"),("archived","Archived")], default="draft"
  - owner: ForeignKey(accounts.User): on_delete=CASCADE, related_name="owned_projects"
  - budget_cents: PositiveIntegerField: default=0
  - due_date: DateField: null=True, blank=True
Filterable fields: status, owner, due_date
Searchable fields: name, description
Ordering fields: name, created_at, due_date, status
Default ordering: -created_at
Soft delete: yes
Audit log: yes
GraphQL: yes
Celery tasks: send_project_created_notification
Custom permissions: can_archive_project, can_export_project
Nested resources: none
\`\`\`

### Example 2: Billing Resource (Usage Record)

\`\`\`
App name: billing
Model name: UsageRecord
Ticket: SAAS-112
Fields:
  - subscription: ForeignKey(billing.Subscription): on_delete=CASCADE, related_name="usage_records"
  - metric_name: CharField: max_length=100, required
  - quantity: DecimalField: max_digits=12, decimal_places=4, required
  - recorded_at: DateTimeField: required
  - stripe_usage_record_id: CharField: max_length=255, blank=True, db_index=True
  - synced_to_stripe: BooleanField: default=False
  - metadata: JSONField: default=dict, blank=True
Filterable fields: metric_name, synced_to_stripe, recorded_at, subscription
Searchable fields: metric_name, stripe_usage_record_id
Ordering fields: recorded_at, metric_name, quantity
Default ordering: -recorded_at
Soft delete: no
Audit log: yes
GraphQL: no
Celery tasks: sync_usage_to_stripe, aggregate_daily_usage
Custom permissions: none
Nested resources: none
\`\`\`

---

## Post-Generation Steps

After Claude generates the files:

1. **Register the app** in \`config/settings/base.py\` → \`INSTALLED_APPS\`
2. **Include URLs** in \`config/urls.py\`:
   \`\`\`python
   path("api/v1/", include("src.{{APP_NAME}}.urls")),
   \`\`\`
3. **Create and run migrations**:
   \`\`\`bash
   uv run python manage.py makemigrations {{APP_NAME}}
   uv run python manage.py migrate
   \`\`\`
4. **Run the test suite**:
   \`\`\`bash
   uv run pytest src/{{APP_NAME}}/tests/ -v --cov=src/{{APP_NAME}} --cov-fail-under=90
   \`\`\`
5. **Lint and type check**:
   \`\`\`bash
   uv run ruff check src/{{APP_NAME}}/
   uv run ruff format --check src/{{APP_NAME}}/
   uv run mypy src/{{APP_NAME}}/
   \`\`\`
6. **Verify OpenAPI schema**:
   \`\`\`bash
   uv run python manage.py spectacular --validate --fail-on-warn
   \`\`\`
7. **If GraphQL**, verify schema compiles:
   \`\`\`bash
   uv run python -c "from src.{{APP_NAME}}.schema import *; print('Schema OK')"
   \`\`\`
8. **Review the checklist** output by Claude and address any unchecked items.

---

## Customization Notes

- **To add nested resources**: Add a \`NESTED_RESOURCES\` section to the fields spec and Claude will generate nested serializers, viewsets with \`NestedViewSetMixin\`, and URL nesting via \`drf-nested-routers\`.
- **To add bulk operations**: Append "Bulk create and bulk delete endpoints" to the Celery tasks field and Claude will generate \`@action(detail=False)\` endpoints with background processing.
- **To add CSV/PDF export**: Add \`generate_csv_export\` or \`generate_pdf_export\` to Celery tasks and Claude will generate the task with S3 upload and download URL generation.
- **To add webhooks**: Add \`dispatch_webhook_on_change\` to Celery tasks and Claude will generate outbound webhook dispatch via \`notifications.services.dispatch_webhook\`.`,

  'playbook/prompts/04/feature-implementation.md': `# Feature Implementation Prompt — Phase 04: Core Implementation

> Copy-paste this prompt into Claude Code when implementing a feature for the django-saas-platform.
> Replace all \`{{PLACEHOLDER}}\` values with your actual context before running.

---

## Prompt

You are implementing a feature for **django-saas-platform**, a multi-tenant Django 5.0 SaaS application with Stripe billing, Celery task processing, and REST/GraphQL APIs. Follow the project's architecture, conventions, and multi-tenancy patterns exactly.

### Feature Context

- **Ticket**: {{TICKET_ID}} (e.g., SAAS-42)
- **Title**: {{FEATURE_TITLE}}
- **Description**: {{FEATURE_DESCRIPTION}}
- **Acceptance Criteria**:
  {{ACCEPTANCE_CRITERIA}}
- **Affected Django Apps**: {{APPS}} (e.g., tenants, billing, accounts, notifications)
- **API Surface**: {{API_SURFACE}} (e.g., REST endpoint, GraphQL mutation, Celery task, webhook handler, none)
- **Tenant Impact**: {{TENANT_IMPACT}} (e.g., tenant-scoped data, cross-tenant admin, tenant-agnostic)

### Implementation Instructions

Work through the following steps in order. After each step, verify correctness before proceeding.

#### Step 1: Branch and Orientation

1. Create a branch following the naming convention: \`feat/{{TICKET_ID}}-{{SHORT_DESC}}\` (e.g., \`feat/SAAS-42-add-tenant-onboarding\`).
2. Read the relevant existing code in the affected apps under \`src/{{APP}}/\`. Understand the current models, services, serializers, views, and tests.
3. Check \`docs/architecture/\` and any ADRs in \`docs/adr/\` that relate to this feature area.
4. Identify the tenant isolation strategy used — confirm data access goes through the tenant-aware manager in \`src/core/managers.py\`.

#### Step 2: Data Layer (Models & Migrations)

If this feature requires schema changes:

1. Define or modify models in \`src/{{APP}}/models.py\`. Follow these rules:
   - Inherit from \`core.models.TenantScopedModel\` for any tenant-specific data (this provides \`tenant\` FK and uses the tenant-aware default manager).
   - Inherit from \`core.models.TimestampedModel\` for \`created_at\` / \`updated_at\` fields.
   - Add \`class Meta: constraints\` for any unique-together or check constraints.
   - Add database indexes for fields used in filters and lookups.
   - Keep model files under 300 lines — split into separate files within a \`models/\` package if needed.
2. Add type hints to all model methods and properties.
3. Generate migrations: \`uv run python manage.py makemigrations {{APP}}\`.
4. Review the generated migration file — ensure it does not contain destructive operations without explicit intent.
5. If row-level security policies need updating for PostgreSQL, add a \`RunSQL\` operation in the migration or update \`scripts/rls_policies.sql\`.
6. Test migration applies cleanly: \`uv run python manage.py migrate --run-syncdb\`.

#### Step 3: Service Layer (Business Logic)

1. Create or update \`src/{{APP}}/services.py\` (or \`src/{{APP}}/services/{{MODULE}}.py\` for complex features).
2. All business logic lives in the service layer — **not** in views, serializers, or models.
3. Service functions must:
   - Accept a \`tenant\` parameter (or derive it from the authenticated user) for all tenant-scoped operations.
   - Use the tenant-aware queryset: \`Model.objects.for_tenant(tenant)\` — never use \`Model.objects.all()\` for tenant data.
   - Have full type hints on all public function signatures (parameters and return types).
   - Raise domain-specific exceptions defined in \`src/{{APP}}/exceptions.py\` (not generic \`ValueError\` or \`Exception\`).
   - Be covered by unit tests with no external dependencies (mock Stripe, Redis, external APIs).
4. For Stripe-related logic (billing app):
   - Wrap all Stripe API calls in try/except for \`stripe.error.StripeError\` subtypes.
   - Store Stripe object IDs (\`stripe_customer_id\`, \`stripe_subscription_id\`) on the local model — never rely solely on Stripe as source of truth.
   - Ensure idempotency: use \`idempotency_key\` for Stripe create operations.
5. Prefer explicit service calls over Django signals. If a signal is truly necessary, document why in a comment.

#### Step 4: Celery Tasks (if applicable)

If this feature involves background processing:

1. Define tasks in \`src/tasks/{{APP}}_tasks.py\` (or \`src/{{APP}}/tasks.py\` if app-specific).
2. Every Celery task must be **idempotent** — running it twice with the same arguments produces the same result.
3. Task requirements:
   - Use \`@shared_task(bind=True, max_retries=3, default_retry_delay=60)\` as the base decorator.
   - Accept primitive arguments only (IDs, strings, numbers) — never pass model instances or complex objects.
   - Re-fetch objects from the database inside the task body.
   - Include \`self.retry(exc=exc)\` in exception handlers for transient failures.
   - Log task start, completion, and failure using \`structlog\`.
   - Add the task to the appropriate Celery beat schedule in \`config/celery.py\` if it's periodic.
4. Example pattern:
   \`\`\`python
   @shared_task(bind=True, max_retries=3, default_retry_delay=60)
   def sync_subscription_status(self, tenant_id: int, subscription_id: int) -> None:
       """Sync subscription status from Stripe. Idempotent."""
       ...
   \`\`\`

#### Step 5: API Layer

**For REST endpoints (DRF):**

1. Define serializers in \`src/{{APP}}/serializers.py\` — use \`ModelSerializer\` where appropriate, \`Serializer\` for custom input/output.
2. Define views in \`src/{{APP}}/views.py\` — use \`ViewSet\` or \`APIView\` classes.
3. Wire URLs in \`src/{{APP}}/urls.py\` using DRF routers.
4. Every endpoint must:
   - Filter querysets by tenant: override \`get_queryset()\` to use \`Model.objects.for_tenant(self.request.tenant)\`.
   - Use permission classes from \`src/core/permissions.py\` (e.g., \`IsTenantMember\`, \`IsTenantAdmin\`, \`HasSubscriptionFeature\`).
   - Have drf-spectacular decorators (\`@extend_schema\`) with request/response types, descriptions, and tags.
   - Return appropriate HTTP status codes (201 for creation, 204 for deletion, 400 for validation errors, 403 for permission denied, 404 for not found).
5. Register the URL configuration in \`config/urls.py\` if adding a new app endpoint.

**For GraphQL mutations/queries (Strawberry):**

1. Define types in \`src/{{APP}}/graphql/types.py\`.
2. Define resolvers in \`src/{{APP}}/graphql/resolvers.py\`.
3. Register in \`src/api/schema.py\`.
4. Ensure tenant filtering in all resolvers — use \`info.context.request.tenant\`.

**For Stripe webhook handlers:**

1. Add handler in \`src/billing/webhooks.py\`.
2. Verify webhook signature using \`stripe.Webhook.construct_event()\`.
3. Make handler idempotent — check if the event has already been processed using \`WebhookEvent.objects.filter(stripe_event_id=event.id).exists()\`.
4. Store the raw event in \`WebhookEvent\` model for audit trail.
5. Dispatch actual processing to a Celery task for reliability.

#### Step 6: Tests

Write tests **before or alongside** implementation (TDD preferred). Place tests in \`tests/{{APP}}/\`.

1. **Unit tests** (\`tests/{{APP}}/test_services.py\`):
   - Test service functions in isolation.
   - Use \`factory_boy\` factories from \`tests/factories/\` for model instances.
   - Mock external dependencies (Stripe, Redis, email sending).
   - Test both success paths and error/edge cases.
   - Test tenant isolation: verify that service functions cannot access another tenant's data.

2. **API tests** (\`tests/{{APP}}/test_views.py\` or \`tests/{{APP}}/test_api.py\`):
   - Use DRF's \`APIClient\` with \`force_authenticate()\`.
   - Test authentication, authorization (role-based), and tenant scoping.
   - Test request validation (missing fields, invalid data).
   - Test response format matches the drf-spectacular schema.

3. **Task tests** (\`tests/{{APP}}/test_tasks.py\`):
   - Test with \`CELERY_ALWAYS_EAGER=True\`.
   - Verify idempotency by calling the task twice.
   - Test retry behavior on transient failures.

4. **Factories** (\`tests/factories/{{APP}}.py\`):
   - Create or update factory_boy factories for any new models.
   - Factories must set a default tenant via \`LazyAttribute\` or \`SubFactory(TenantFactory)\`.

5. Run the full test suite and verify:
   \`\`\`bash
   uv run pytest tests/{{APP}}/ -v --tb=short
   uv run pytest --cov=src/{{APP}} --cov-fail-under=85
   \`\`\`

#### Step 7: Validation and Quality Checks

Run all checks and fix any issues before committing:

\`\`\`bash
# Linting
uv run ruff check src/{{APP}}/ tests/{{APP}}/ --fix

# Formatting
uv run ruff format src/{{APP}}/ tests/{{APP}}/

# Type checking
uv run mypy src/{{APP}}/

# Tests with coverage
uv run pytest tests/{{APP}}/ --cov=src/{{APP}} --cov-fail-under=85

# Migration check (no missing migrations)
uv run python manage.py makemigrations --check --dry-run

# OpenAPI schema validation (if API changes)
uv run python manage.py spectacular --validate --fail-on-warn
\`\`\`

#### Step 8: Documentation and Commit

1. Update or create docstrings on all public classes and functions.
2. If this feature adds a new API endpoint, verify it appears correctly in the OpenAPI schema.
3. If this feature changes architecture or introduces a new pattern, create an ADR in \`docs/adr/\`.
4. If this feature affects tenant onboarding, billing, or auth flows, update the relevant runbook in \`docs/runbooks/\`.
5. Commit using conventional commits:
   \`\`\`bash
   git add -A
   git commit -m "feat({{APP}}): {{SHORT_DESCRIPTION}}

   {{LONGER_DESCRIPTION_IF_NEEDED}}

   Refs: {{TICKET_ID}}"
   \`\`\`
6. Push and open a PR:
   - Title: \`feat({{APP}}): {{FEATURE_TITLE}} [{{TICKET_ID}}]\`
   - Description: summarize what changed, why, and any deployment notes (migrations, env vars, feature flags).
   - Add label \`ai-assisted\` to flag AI-generated code per CI policy.
   - Request review from the appropriate CODEOWNERS (especially for changes in \`billing/\`, \`auth/\`, or \`config/production/\`).

### Constraints and Guardrails

- **Tenant isolation is non-negotiable.** Every database query for tenant-scoped data must go through the tenant-aware manager. Never use \`.objects.all()\` or \`.objects.filter()\` without tenant scoping for tenant data. This is a SOC 2 requirement.
- **GDPR compliance**: If this feature stores personal data, ensure it is included in the data export and deletion workflows (\`src/accounts/services/gdpr.py\`). Add consent tracking if collecting new categories of personal data.
- **No secrets in code.** Use \`django-environ\` / Pydantic settings for all configuration. Reference \`config/settings/base.py\`.
- **File length limit: 300 lines.** If a file exceeds this, refactor into a package with multiple modules.
- **Stripe webhook handlers must be idempotent and verified.** Never trust unverified webhook payloads.
- **Celery tasks must be idempotent.** Design for at-least-once delivery.
- **Do not modify \`config/production/\` settings** without explicit approval — this is a sensitive path.
- **Do not add new dependencies** without documenting the rationale. Add to \`pyproject.toml\` via \`uv add {{package}}\` and note in the PR description.

### Output Format

Provide the implementation as a series of file changes. For each file:
1. State the file path relative to the project root.
2. Show the complete file content (not diffs) for new files, or clearly marked changes for existing files.
3. Explain any non-obvious design decisions inline with comments.

After all files, provide:
- A summary of what was implemented.
- The commands to run for verification (copy-pasteable).
- Any deployment notes (migrations, new env vars, Celery task registration, Stripe webhook registration).
- Known limitations or follow-up work needed.`,

  'playbook/prompts/05/integration-adapter.md': `# Integration Adapter — Phase 05 Prompt

> Copy-paste this prompt into Claude Code when building integration adapters for external services in the django-saas-platform.

---

## Prompt

You are a senior Django/SaaS backend engineer working on **django-saas-platform**. Your task is to build a robust, production-grade integration adapter for an external service.

### Context

- **Project**: Multi-tenant SaaS platform (Django 5.0, DRF, Strawberry GraphQL, Celery 5, PostgreSQL 16, Redis, Stripe)
- **Phase**: 05 — Integration & Hardening (see \`playbook/phases/05-integration-hardening.md\`)
- **Compliance**: SOC 2, GDPR — all integrations must respect tenant data isolation and audit logging
- **Architecture**: Modular monolith with self-contained Django apps; integrations live behind adapter interfaces

### Integration Target

**[REPLACE: Describe the external service you are integrating]**

Examples:
- Stripe (subscription billing, usage metering, webhook processing)
- AWS SES (transactional email delivery)
- AWS S3 (tenant-scoped file storage)
- Slack (webhook notifications for tenant events)
- Third-party analytics or CRM API
- OAuth2 / SAML identity provider

### Requirements

Build the integration adapter following these constraints:

#### 1. Adapter Pattern (Port/Adapter)

Create an abstract interface (port) and a concrete implementation (adapter):

\`\`\`
src/
  integrations/
    __init__.py
    base.py              # Abstract base class / protocol for this integration type
    <service>/
      __init__.py
      adapter.py          # Concrete adapter implementing the interface
      client.py           # Low-level HTTP/SDK client with retry logic
      serializers.py      # Request/response data transformation (Pydantic models)
      exceptions.py       # Service-specific exception hierarchy
      webhooks.py         # Inbound webhook handler (if applicable)
      tasks.py            # Celery tasks for async operations
      tests/
        __init__.py
        test_adapter.py   # Unit tests with mocked external calls
        test_webhooks.py  # Webhook verification and processing tests
        test_tasks.py     # Celery task idempotency tests
        conftest.py       # Fixtures, factories, VCR cassettes
\`\`\`

#### 2. Client Layer (\`client.py\`)

- Use \`httpx\` (async-capable) or the official SDK if one exists
- Implement exponential backoff with jitter for retries (max 3 attempts)
- Set explicit timeouts: connect=5s, read=30s
- Log all outbound requests at DEBUG level with correlation ID (no secrets in logs)
- Raise typed exceptions from \`exceptions.py\`, never raw HTTP errors
- Support dependency injection of credentials (no hardcoded secrets)
- Add circuit breaker pattern for repeated failures (use \`pybreaker\` or manual implementation)

\`\`\`python
# Example structure for client.py
from __future__ import annotations

import httpx
from tenacity import retry, stop_after_attempt, wait_exponential_jitter

from .exceptions import ServiceUnavailableError, AuthenticationError, RateLimitError


class ExternalServiceClient:
    """Low-level client for [Service Name] API."""

    def __init__(self, api_key: str, base_url: str, timeout: float = 30.0) -> None:
        self._client = httpx.Client(
            base_url=base_url,
            headers={"Authorization": f"Bearer {api_key}"},
            timeout=httpx.Timeout(connect=5.0, read=timeout),
        )

    @retry(
        stop=stop_after_attempt(3),
        wait=wait_exponential_jitter(initial=1, max=10),
        retry=retry_if_exception_type(ServiceUnavailableError),
    )
    def _request(self, method: str, path: str, **kwargs) -> dict:
        ...
\`\`\`

#### 3. Adapter Layer (\`adapter.py\`)

- Implement the abstract interface from \`base.py\`
- Accept tenant context — every operation must be scoped to a tenant
- Map between internal domain models and external API representations
- Never expose external service data structures to the rest of the application
- All public methods must have type hints and docstrings
- Keep adapter stateless — inject dependencies via \`__init__\`

\`\`\`python
# Example structure for adapter.py
from __future__ import annotations

from src.core.models import Tenant
from src.integrations.base import BillingProvider

from .client import ExternalServiceClient
from .serializers import CreateSubscriptionRequest, SubscriptionResponse


class StripeAdapter(BillingProvider):
    """Stripe implementation of the BillingProvider interface."""

    def __init__(self, client: ExternalServiceClient) -> None:
        self._client = client

    def create_subscription(
        self, tenant: Tenant, plan_id: str, **kwargs
    ) -> SubscriptionResponse:
        """Create a subscription for the given tenant."""
        ...
\`\`\`

#### 4. Webhook Handler (\`webhooks.py\`)

If the integration receives inbound webhooks:

- Verify webhook signatures before processing (Stripe: \`stripe.Webhook.construct_event\`)
- Make webhook processing **idempotent** — use an \`IntegrationEvent\` model to track processed event IDs
- Process webhooks asynchronously via Celery tasks (return 200 immediately, enqueue processing)
- Map external event types to internal domain events
- Log all received webhooks with event type, ID, and tenant association
- Handle unknown event types gracefully (log and skip, don't error)

\`\`\`python
# IntegrationEvent model for idempotency
class IntegrationEvent(TenantAwareModel):
    event_id = models.CharField(max_length=255, unique=True, db_index=True)
    source = models.CharField(max_length=50)  # "stripe", "ses", etc.
    event_type = models.CharField(max_length=100)
    payload = models.JSONField()
    status = models.CharField(
        max_length=20,
        choices=[("pending", "Pending"), ("processed", "Processed"), ("failed", "Failed")],
        default="pending",
    )
    processed_at = models.DateTimeField(null=True, blank=True)
    error_message = models.TextField(blank=True, default="")
    created_at = models.DateTimeField(auto_now_add=True)

    class Meta:
        indexes = [
            models.Index(fields=["source", "event_type", "status"]),
        ]
\`\`\`

#### 5. Celery Tasks (\`tasks.py\`)

- All tasks must be **idempotent** — safe to retry or execute multiple times
- Use \`bind=True\` for access to \`self.request\` (task ID, retries)
- Set \`acks_late=True\` and \`reject_on_worker_lost=True\` for at-least-once delivery
- Define explicit \`max_retries\`, \`default_retry_delay\`, and \`retry_backoff\`
- Accept primitive arguments only (IDs, not model instances) for serialization safety
- Log task start, completion, and failure with structured context

\`\`\`python
from celery import shared_task
from celery.utils.log import get_task_logger

logger = get_task_logger(__name__)


@shared_task(
    bind=True,
    max_retries=5,
    default_retry_delay=60,
    retry_backoff=True,
    acks_late=True,
    reject_on_worker_lost=True,
)
def process_webhook_event(self, event_id: str) -> None:
    """Process an integration webhook event idempotently."""
    ...
\`\`\`

#### 6. Exception Hierarchy (\`exceptions.py\`)

Define a clear exception hierarchy that the rest of the application can catch:

\`\`\`python
class IntegrationError(Exception):
    """Base exception for all integration errors."""

class AuthenticationError(IntegrationError):
    """Invalid or expired credentials."""

class RateLimitError(IntegrationError):
    """Rate limit exceeded — should trigger backoff."""
    def __init__(self, retry_after: int | None = None):
        self.retry_after = retry_after

class ServiceUnavailableError(IntegrationError):
    """External service is down or unreachable."""

class ValidationError(IntegrationError):
    """External service rejected the request payload."""

class WebhookVerificationError(IntegrationError):
    """Webhook signature verification failed."""
\`\`\`

#### 7. Configuration

- All secrets (API keys, webhook secrets) loaded via \`django-environ\` / Pydantic settings
- Support per-tenant configuration where needed (e.g., tenant's own Stripe Connect account)
- Feature flags for enabling/disabling integrations without code changes
- Separate config for each environment (dev uses mocks/sandbox, staging uses sandbox, prod uses live)

\`\`\`python
# config/settings/base.py
STRIPE_SECRET_KEY = env("STRIPE_SECRET_KEY")
STRIPE_WEBHOOK_SECRET = env("STRIPE_WEBHOOK_SECRET")
STRIPE_PUBLISHABLE_KEY = env("STRIPE_PUBLISHABLE_KEY")
STRIPE_API_VERSION = "2024-04-10"
\`\`\`

#### 8. Tenant Isolation (SOC 2 / GDPR)

- Every adapter method must accept or resolve the current tenant
- Never allow cross-tenant data leakage through shared external resources
- For Stripe: each tenant maps to a Stripe Customer; use metadata to tag tenant_id
- For S3: use tenant-scoped key prefixes (\`s3://{bucket}/{tenant_id}/...\`)
- Audit log all external API calls that create, modify, or delete data
- For GDPR: implement \`delete_tenant_data()\` method on each adapter for right-to-deletion

\`\`\`python
class BillingProvider(ABC):
    @abstractmethod
    def delete_tenant_data(self, tenant: Tenant) -> DeletionReport:
        """Delete all data associated with this tenant (GDPR right to deletion)."""
        ...
\`\`\`

#### 9. Testing Strategy

- **Unit tests**: Mock the HTTP client layer; test adapter logic, serialization, error mapping
- **Webhook tests**: Test signature verification, idempotency (duplicate event IDs), unknown event types
- **Task tests**: Test idempotency, retry behavior, failure handling using \`celery.contrib.pytest\`
- **Integration tests** (optional, CI-gated): Use service sandbox/test mode with VCR cassettes (\`vcrpy\` or \`responses\`)
- Use \`factory_boy\` for test fixtures (\`IntegrationEventFactory\`, \`TenantFactory\`)
- Coverage target: 85%+ for all adapter code

\`\`\`python
# Example test
class TestStripeAdapter:
    def test_create_subscription_maps_response(self, stripe_adapter, mock_client):
        mock_client.post.return_value = {"id": "sub_123", "status": "active"}
        result = stripe_adapter.create_subscription(tenant, plan_id="plan_pro")
        assert result.external_id == "sub_123"
        assert result.status == "active"

    def test_create_subscription_handles_rate_limit(self, stripe_adapter, mock_client):
        mock_client.post.side_effect = RateLimitError(retry_after=30)
        with pytest.raises(RateLimitError):
            stripe_adapter.create_subscription(tenant, plan_id="plan_pro")
\`\`\`

#### 10. Observability

- Emit structured logs for all external calls: \`{"integration": "stripe", "operation": "create_subscription", "tenant_id": "...", "duration_ms": 234, "status": "success"}\`
- Track metrics: request count, latency (p50/p95/p99), error rate per integration
- Send errors to Sentry with integration and tenant context tags
- Create Grafana dashboard panels for each integration's health

### Deliverables

For the integration you are building, produce:

1. **\`src/integrations/base.py\`** — Abstract interface (if not already created)
2. **\`src/integrations/<service>/\`** — Complete adapter package (all files listed above)
3. **\`tests/integrations/<service>/\`** — Full test suite with fixtures
4. **Migration** — For \`IntegrationEvent\` model (if not already created)
5. **Settings update** — Add required env vars to \`config/settings/base.py\` and \`.env.example\`
6. **Documentation** — Brief \`docs/integrations/<service>.md\` covering setup, configuration, webhook registration, and failure modes

### Validation Checklist

Before finishing, verify:

- [ ] \`uv run ruff check src/integrations/\` — no lint errors
- [ ] \`uv run ruff format --check src/integrations/\` — formatting clean
- [ ] \`uv run mypy src/integrations/\` — no type errors (strict mode)
- [ ] \`uv run pytest tests/integrations/<service>/ -v --cov=src/integrations/<service> --cov-fail-under=85\` — tests pass with coverage
- [ ] All public functions have type hints and docstrings
- [ ] No secrets in code — all credentials from environment
- [ ] Webhook handler is idempotent (test with duplicate event IDs)
- [ ] Celery tasks are idempotent (test with duplicate execution)
- [ ] Tenant isolation enforced — no cross-tenant data access possible
- [ ] \`delete_tenant_data()\` implemented for GDPR compliance
- [ ] Adapter never exposes external service data structures to domain layer
- [ ] Circuit breaker or retry logic prevents cascade failures
- [ ] Files under 300 lines each
- [ ] Conventional commit: \`feat(integrations): add <service> adapter [SAAS-XXX]\`

### Notes

- Reference \`playbook/phases/05-integration-hardening.md\` for phase goals
- Reference \`playbook/prompts/04/feature-implementation.md\` for general implementation patterns
- If this is a Stripe integration, also reference \`src/billing/\` for existing billing domain models
- Use \`src/core/models.py\` for \`TenantAwareModel\` base class and tenant-aware managers
- Coordinate with \`src/notifications/\` if the integration triggers user-facing notifications`,

  'playbook/prompts/05/observability-setup.md': `# Observability Setup — Phase 05 Prompt

> Copy-paste this prompt into Claude Code to set up comprehensive observability for the django-saas-platform: structured logging, metrics, distributed tracing, health checks, and alerting dashboards.

---

## Prompt

\`\`\`
You are working on the django-saas-platform, a multi-tenant Django 5.0 SaaS application with Celery task processing, Stripe billing, and PostgreSQL with row-level security. We are in Phase 05 (Integration & Hardening) and need to implement production-grade observability.

## Context

- Framework: Django 5.0, DRF, Strawberry GraphQL
- Task queue: Celery 5 with Redis broker and beat scheduler
- Databases: PostgreSQL 16 (multi-tenant, row-level security), Redis (cache/sessions/broker)
- Billing: Stripe (subscriptions, usage metering, webhooks)
- Cloud: AWS (ECS, RDS, ElastiCache, S3, SES)
- Monitoring stack: Sentry (error tracking), Prometheus (metrics), Grafana (dashboards)
- Compliance: SOC 2 (audit trails, access logging), GDPR (PII handling in logs)
- Project layout: src/ contains Django apps (accounts, tenants, billing, api, core, notifications, tasks, utils)
- Config: config/ directory with base.py, development.py, staging.py, production.py
- Tests: pytest with pytest-django, factory_boy; 85% coverage threshold

## Requirements

### 1. Structured Logging (src/core/logging.py)

Set up JSON-structured logging with tenant context propagation:

- Create a custom logging configuration using \`python-json-logger\` (or \`structlog\` if preferred)
- Every log entry MUST include: \`timestamp\`, \`level\`, \`logger\`, \`message\`, \`request_id\`, \`tenant_id\`, \`user_id\`, \`correlation_id\`
- Create a \`TenantLoggingMiddleware\` in \`src/core/middleware/logging.py\` that:
  - Generates a unique \`request_id\` (UUID4) per request, or reads \`X-Request-ID\` header if present
  - Extracts \`tenant_id\` and \`user_id\` from the authenticated request
  - Stores context in \`threading.local()\` or \`contextvars.ContextVar\` for async compatibility
  - Logs request start (method, path, tenant, user) at INFO level
  - Logs request completion (status code, duration_ms, response size) at INFO level
  - Logs slow requests (>2s) at WARNING level with full context
- Create a \`CeleryTaskLoggingMixin\` in \`src/tasks/logging.py\` that:
  - Propagates \`tenant_id\`, \`correlation_id\`, and \`request_id\` through Celery task headers
  - Logs task start, success, failure, and retry with structured context
  - Includes \`task_name\`, \`task_id\`, \`queue\`, \`retries\`, \`runtime_ms\` in every log
- GDPR compliance: Create a \`PiiSanitizer\` log filter that redacts email addresses, phone numbers, API keys, and Stripe tokens from log output. Apply it to all handlers in production.
- Configure log levels per environment:
  - development: DEBUG for src.*, INFO for django, WARNING for third-party
  - staging: INFO for src.*, WARNING for django, ERROR for third-party
  - production: INFO for src.*, WARNING for django, ERROR for third-party
- Output format: JSON in staging/production, human-readable colored output in development
- Add the logging config to \`config/settings/base.py\` as \`LOGGING\` dict

### 2. Prometheus Metrics (src/core/metrics.py)

Implement application metrics using \`django-prometheus\` and custom metrics:

- Install and configure \`django-prometheus\` for standard Django metrics (request latency, DB query count, cache hits)
- Create custom metrics in \`src/core/metrics.py\`:

\`\`\`python
# Define these Prometheus metrics with appropriate labels:

# HTTP metrics (beyond django-prometheus defaults)
api_request_duration = Histogram(
    "saas_api_request_duration_seconds",
    "API request duration",
    labelnames=["method", "endpoint", "tenant_id", "status_code"],
    buckets=[0.01, 0.025, 0.05, 0.1, 0.25, 0.5, 1.0, 2.5, 5.0, 10.0],
)

# Tenant metrics
active_tenants_gauge = Gauge("saas_active_tenants_total", "Number of active tenants")
tenant_api_calls = Counter(
    "saas_tenant_api_calls_total",
    "API calls per tenant",
    labelnames=["tenant_id", "plan_tier"],
)

# Billing metrics
stripe_webhook_duration = Histogram(
    "saas_stripe_webhook_duration_seconds",
    "Stripe webhook processing time",
    labelnames=["event_type", "status"],
)
stripe_webhook_errors = Counter(
    "saas_stripe_webhook_errors_total",
    "Stripe webhook processing errors",
    labelnames=["event_type", "error_type"],
)
subscription_changes = Counter(
    "saas_subscription_changes_total",
    "Subscription lifecycle events",
    labelnames=["tenant_id", "from_plan", "to_plan", "change_type"],
)
mrr_gauge = Gauge("saas_mrr_cents", "Monthly recurring revenue in cents")

# Celery task metrics
celery_task_duration = Histogram(
    "saas_celery_task_duration_seconds",
    "Celery task execution time",
    labelnames=["task_name", "queue", "status"],
)
celery_task_failures = Counter(
    "saas_celery_task_failures_total",
    "Celery task failures",
    labelnames=["task_name", "exception_type"],
)
celery_queue_depth = Gauge(
    "saas_celery_queue_depth",
    "Number of tasks waiting in queue",
    labelnames=["queue_name"],
)

# Database / tenant isolation metrics
db_query_duration = Histogram(
    "saas_db_query_duration_seconds",
    "Database query duration",
    labelnames=["operation", "table"],
)
tenant_row_count = Gauge(
    "saas_tenant_row_count",
    "Row count per tenant per table",
    labelnames=["tenant_id", "table_name"],
)
\`\`\`

- Create a \`MetricsMiddleware\` in \`src/core/middleware/metrics.py\` that records per-request metrics with tenant labels
- Create a Celery signal handler in \`src/tasks/signals.py\` that records task metrics on \`task_prerun\`, \`task_postrun\`, \`task_failure\`, \`task_retry\`
- Create a periodic Celery task \`collect_business_metrics\` in \`src/tasks/metrics.py\` that runs every 5 minutes to update gauges (active tenants, MRR, queue depths)
- Expose metrics at \`/internal/metrics/\` endpoint — ensure this is NOT accessible to tenants (restrict to internal network or require auth)

### 3. Sentry Integration (src/core/sentry.py)

Configure Sentry for error tracking with tenant context:

- Create \`src/core/sentry.py\` with initialization function:
  - Enable \`DjangoIntegration\`, \`CeleryIntegration\`, \`RedisIntegration\`, \`LoggingIntegration\`
  - Set \`traces_sample_rate\` based on environment (1.0 dev, 0.2 staging, 0.1 production)
  - Set \`profiles_sample_rate\` to 0.1 in production
  - Configure \`before_send\` callback that:
    - Attaches \`tenant_id\`, \`tenant_name\`, \`plan_tier\` as Sentry tags
    - Attaches \`user_id\`, \`user_role\` as Sentry user context (but NOT email — GDPR)
    - Strips PII from breadcrumbs and event data
    - Drops events from health check endpoints
  - Configure \`before_send_transaction\` to add tenant context to performance transactions
  - Set \`release\` from environment variable or git SHA
  - Set \`environment\` from Django settings
- Add Sentry initialization call in \`config/settings/base.py\`
- Create a \`sentry_context\` decorator/context manager for Celery tasks that sets tenant scope

### 4. Health Check Endpoints (src/core/health/)

Create comprehensive health check endpoints for load balancer and monitoring:

- Create \`src/core/health/views.py\` with these endpoints:

  **GET /health/live/** — Kubernetes liveness probe
  - Returns 200 if Django process is running
  - No dependency checks (must be fast, <50ms)
  - Response: \`{"status": "alive", "timestamp": "..."}\`

  **GET /health/ready/** — Kubernetes readiness probe
  - Checks: PostgreSQL connection, Redis connection, Celery worker ping
  - Returns 200 if all pass, 503 if any fail
  - Response includes individual check results with latency:
  \`\`\`json
  {
    "status": "ready",
    "timestamp": "...",
    "checks": {
      "database": {"status": "ok", "latency_ms": 2.3},
      "redis": {"status": "ok", "latency_ms": 0.8},
      "celery": {"status": "ok", "latency_ms": 45.2}
    }
  }
  \`\`\`

  **GET /health/detailed/** — Full system status (internal only, requires auth)
  - All readiness checks plus:
    - Stripe API connectivity
    - S3 bucket accessibility
    - SES sending capability (dry run)
    - Database migration status (any pending?)
    - Celery beat scheduler status
    - Cache hit rate
    - Active tenant count
    - Queue depths per Celery queue
  - Response includes version info: app version, Python version, Django version, git SHA

- Create \`src/core/health/checks.py\` with individual check functions, each with timeout handling
- Register health URLs in \`src/core/urls.py\`
- Ensure \`/health/live/\` and \`/health/ready/\` bypass authentication middleware and CSRF
- Ensure \`/health/detailed/\` requires superuser or internal network access

### 5. Distributed Tracing (src/core/tracing.py)

Set up request tracing across Django and Celery:

- Use OpenTelemetry with Sentry as the backend (or standalone OTLP exporter if preferred)
- Create \`src/core/tracing.py\`:
  - Initialize OpenTelemetry tracer provider
  - Configure \`DjangoInstrumentor\`, \`CeleryInstrumentor\`, \`Psycopg2Instrumentor\`, \`RedisInstrumentor\`
  - Propagate trace context through Celery task headers
  - Add custom span attributes: \`tenant.id\`, \`tenant.plan\`, \`user.id\`
- Create a \`TraceContextMiddleware\` that:
  - Reads \`traceparent\` header for distributed trace propagation
  - Adds \`X-Request-ID\` and \`X-Trace-ID\` to response headers
  - Creates spans for key operations: auth, tenant resolution, serialization
- Ensure Stripe webhook processing creates child spans for each processing step

### 6. Audit Logging (src/core/audit.py)

Create SOC 2 compliant audit logging (separate from application logs):

- Create \`src/core/audit.py\` with an \`AuditLogger\` class:
  - Writes to a dedicated \`audit_log\` PostgreSQL table (NOT the application log)
  - Fields: \`id\`, \`timestamp\`, \`actor_id\`, \`actor_type\` (user/system/api_key), \`tenant_id\`, \`action\`, \`resource_type\`, \`resource_id\`, \`changes\` (JSONB), \`ip_address\`, \`user_agent\`, \`request_id\`, \`metadata\` (JSONB)
  - Create Django model \`AuditLogEntry\` in \`src/core/models/audit.py\`
  - Provide helper methods: \`log_action()\`, \`log_data_access()\`, \`log_auth_event()\`, \`log_billing_event()\`
- Create an \`@audited\` decorator for views/service functions that automatically logs:
  - Who did what, to which resource, in which tenant, when
  - Before/after state for mutations (create, update, delete)
- Audit these events at minimum:
  - Authentication: login, logout, failed login, password change, MFA events
  - Authorization: permission denied, role changes
  - Tenant: creation, settings change, member add/remove
  - Billing: subscription change, payment method update, invoice events
  - Data: export requests, bulk operations, PII access
- Audit logs must be append-only (no UPDATE/DELETE permissions for app user)
- Create a Celery task for async audit log writing to avoid request latency impact
- Retention: audit logs retained for 7 years (SOC 2 requirement) — add a note about partitioning strategy

### 7. Grafana Dashboard Definitions (docs/observability/)

Create Grafana dashboard JSON or provisioning configs for:

- **SaaS Overview Dashboard** (\`docs/observability/dashboards/saas-overview.json\`):
  - Active tenants, MRR, API request rate, error rate, P50/P95/P99 latency
  - Subscription churn rate, new signups (24h)

- **Tenant Health Dashboard** (\`docs/observability/dashboards/tenant-health.json\`):
  - Per-tenant API usage, error rates, latency
  - Tenant-specific Celery task status
  - Usage vs plan limits

- **Billing & Stripe Dashboard** (\`docs/observability/dashboards/billing.json\`):
  - Webhook processing rate and latency
  - Webhook error rate by event type
  - Subscription state distribution
  - Failed payment rate

- **Celery Dashboard** (\`docs/observability/dashboards/celery.json\`):
  - Task throughput by queue
  - Task duration histograms
  - Failure rate by task name
  - Queue depth over time
  - Worker utilization

- **Infrastructure Dashboard** (\`docs/observability/dashboards/infrastructure.json\`):
  - Database connection pool usage
  - Redis memory and connection count
  - Cache hit/miss ratio
  - ECS task health

For each dashboard, provide the Grafana JSON model or a Python script that generates it. Include alert rules for:
- Error rate > 5% for 5 minutes
- P99 latency > 5s for 5 minutes
- Celery queue depth > 1000 for 10 minutes
- Stripe webhook failure rate > 10% for 5 minutes
- Database connection pool > 80% for 5 minutes
- Any health check failing for 2 minutes

### 8. Alerting Configuration (docs/observability/alerts/)

Create Prometheus alerting rules in \`docs/observability/alerts/rules.yml\`:

- Group alerts by severity: critical (PagerDuty), warning (Slack #alerts), info (Slack #observability)
- Critical alerts: service down, data loss risk, billing pipeline broken, tenant isolation breach
- Warning alerts: elevated error rates, slow queries, queue backlog, certificate expiry <14d
- Info alerts: deployment completed, new tenant onboarded, usage threshold reached

Create a Slack notification template for alert messages that includes:
- Alert severity and name
- Affected tenant(s) if applicable
- Runbook link
- Current value vs threshold

### 9. Configuration & Wiring

- Add all new dependencies to \`pyproject.toml\`: \`sentry-sdk[django,celery]\`, \`django-prometheus\`, \`python-json-logger\`, \`opentelemetry-api\`, \`opentelemetry-sdk\`, \`opentelemetry-instrumentation-django\`, \`opentelemetry-instrumentation-celery\`, \`opentelemetry-instrumentation-psycopg2\`, \`opentelemetry-instrumentation-redis\`
- Update \`config/settings/base.py\` with:
  - LOGGING configuration
  - Sentry initialization
  - Prometheus middleware in MIDDLEWARE
  - Health check URLs
  - OpenTelemetry initialization
- Update \`config/settings/production.py\` with production-specific overrides
- Add environment variables to \`.env.example\`:
  - \`SENTRY_DSN\`, \`SENTRY_ENVIRONMENT\`, \`SENTRY_RELEASE\`
  - \`OTEL_EXPORTER_OTLP_ENDPOINT\`, \`OTEL_SERVICE_NAME\`
  - \`PROMETHEUS_MULTIPROC_DIR\` (for Gunicorn multi-process)
  - \`LOG_LEVEL\`, \`LOG_FORMAT\` (json/console)

### 10. Tests

Create tests in \`tests/core/test_observability.py\`:

- Test \`TenantLoggingMiddleware\` injects correct context fields
- Test \`PiiSanitizer\` redacts emails, phone numbers, API keys, Stripe tokens
- Test health check endpoints return correct status codes and structure
- Test \`/health/ready/\` returns 503 when database is unavailable (mock)
- Test \`/health/detailed/\` requires authentication
- Test \`AuditLogEntry\` model creation and immutability
- Test \`@audited\` decorator captures before/after state
- Test Celery task logging mixin propagates correlation IDs
- Test Prometheus metrics are incremented correctly
- Test Sentry \`before_send\` strips PII and adds tenant context

Use \`pytest\`, \`factory_boy\`, and \`unittest.mock\`. Follow existing test patterns in the project.

## Constraints

- All public functions must have type hints
- Maximum 300 lines per file — split into modules as needed
- Use \`contextvars\` (not \`threading.local\`) for async compatibility
- Health check endpoints must not leak internal details to unauthenticated users (liveness/readiness are minimal)
- Audit logs must be in a separate database table, not mixed with application logs
- PII must never appear in application logs, metrics labels, or Sentry events
- Metrics endpoint must not be publicly accessible
- All Celery tasks related to observability must be idempotent
- Follow existing project conventions: snake_case functions, PascalCase classes, SCREAMING_SNAKE_CASE constants

## File Structure to Create

\`\`\`
src/core/
  logging.py                    # Structured logging config, PII sanitizer
  metrics.py                    # Prometheus metric definitions
  sentry.py                     # Sentry initialization and context
  tracing.py                    # OpenTelemetry setup
  audit.py                      # Audit logger, @audited decorator
  models/
    audit.py                    # AuditLogEntry model
  middleware/
    logging.py                  # TenantLoggingMiddleware
    metrics.py                  # MetricsMiddleware
    tracing.py                  # TraceContextMiddleware
  health/
    __init__.py
    views.py                    # Health check endpoints
    checks.py                   # Individual health check functions
    urls.py                     # Health URL patterns
src/tasks/
  logging.py                    # CeleryTaskLoggingMixin
  signals.py                    # Celery signal handlers for metrics
  metrics.py                    # collect_business_metrics periodic task
tests/core/
  test_observability.py         # All observability tests
docs/observability/
  dashboards/
    saas-overview.json
    tenant-health.json
    billing.json
    celery.json
    infrastructure.json
  alerts/
    rules.yml
    slack-template.md
\`\`\`

Start by creating the structured logging and health checks, then build up to metrics, tracing, Sentry, and audit logging. Wire everything together in the Django settings last.
\`\`\``,

  'playbook/prompts/05/security-hardening.md': `# Security Hardening — Phase 05 Prompt

> Copy-paste this prompt into Claude Code to perform comprehensive security hardening across the django-saas-platform.

---

## Prompt

You are performing security hardening on the **django-saas-platform**, a multi-tenant SaaS application built with Django 5.0, DRF, Strawberry GraphQL, Celery, Stripe, PostgreSQL (row-level security), and Redis. The platform must meet **SOC 2** and **GDPR** compliance requirements.

Audit and harden the entire codebase across the following security domains. For each domain, identify vulnerabilities, implement fixes, and add tests to verify the hardening.

---

### 1. Multi-Tenant Data Isolation

Verify that **every** database query touching tenant data goes through the tenant-aware manager in \`src/core/managers.py\`. No raw SQL or unscoped ORM queries should bypass tenant isolation.

**Actions:**
- Grep the entire \`src/\` directory for \`.objects.\` calls on tenant-scoped models and confirm they use \`TenantAwareManager\` (not Django's default manager)
- Audit all raw SQL in the codebase (\`connection.cursor()\`, \`RawSQL\`, \`.raw()\`, \`.extra()\`) for tenant \`WHERE\` clauses
- Verify PostgreSQL row-level security policies exist in migrations for all tenant-scoped tables:
  \`\`\`sql
  ALTER TABLE <table> ENABLE ROW LEVEL SECURITY;
  CREATE POLICY tenant_isolation ON <table>
    USING (tenant_id = current_setting('app.current_tenant_id')::uuid);
  \`\`\`
- Confirm the tenant middleware in \`src/core/middleware.py\` sets \`app.current_tenant_id\` on every database connection via \`SET LOCAL\`
- Add a pytest fixture that attempts cross-tenant data access and asserts it returns empty / raises \`PermissionDenied\`
- Ensure Django admin views are tenant-scoped or restricted to superusers only
- Verify GraphQL resolvers in \`src/api/\` apply tenant filtering before returning querysets

**Test file:** \`tests/security/test_tenant_isolation.py\`

---

### 2. Authentication & Session Security

Harden authentication across all entry points: DRF token auth, session auth, and any JWT flows.

**Actions:**
- Verify \`REST_FRAMEWORK\` settings in \`config/\` enforce authentication by default:
  \`\`\`python
  "DEFAULT_AUTHENTICATION_CLASSES": [
      "rest_framework.authentication.SessionAuthentication",
      "rest_framework.authentication.TokenAuthentication",
  ],
  "DEFAULT_PERMISSION_CLASSES": [
      "rest_framework.permissions.IsAuthenticated",
  ],
  \`\`\`
- Confirm session settings in Django config:
  \`\`\`python
  SESSION_COOKIE_SECURE = True
  SESSION_COOKIE_HTTPONLY = True
  SESSION_COOKIE_SAMESITE = "Lax"
  SESSION_ENGINE = "django.contrib.sessions.backends.cache"  # Redis-backed
  SESSION_COOKIE_AGE = 3600  # 1 hour for SaaS
  CSRF_COOKIE_SECURE = True
  CSRF_COOKIE_HTTPONLY = True
  \`\`\`
- Implement account lockout after 5 failed login attempts in \`src/accounts/services.py\` using Redis counter with TTL
- Add rate limiting on \`/api/auth/login/\`, \`/api/auth/register/\`, \`/api/auth/password-reset/\` endpoints using \`django-ratelimit\` or DRF throttling:
  \`\`\`python
  "DEFAULT_THROTTLE_RATES": {
      "login": "5/min",
      "register": "3/min",
      "password_reset": "3/hour",
  }
  \`\`\`
- Verify password validation uses Django's built-in validators plus a minimum length of 12 characters
- Ensure API tokens have expiration and rotation support
- Confirm logout invalidates both session and any cached tokens

**Test file:** \`tests/security/test_authentication.py\`

---

### 3. Role-Based Access Control (RBAC)

Audit and harden the permission system in \`src/accounts/\` and \`src/core/permissions.py\`.

**Actions:**
- Verify the role hierarchy: \`owner > admin > member > viewer > billing_admin\`
- Confirm every DRF viewset and Strawberry resolver has explicit permission classes — no endpoint should rely solely on \`IsAuthenticated\`
- Audit \`src/billing/views.py\` — only \`owner\` and \`billing_admin\` roles should access billing endpoints
- Audit \`src/tenants/views.py\` — only \`owner\` can delete a tenant or transfer ownership
- Create a permission matrix test that iterates over all registered URL patterns and asserts each has a permission class:
  \`\`\`python
  @pytest.mark.parametrize("url_name,method,role,expected_status", PERMISSION_MATRIX)
  def test_endpoint_permissions(url_name, method, role, expected_status, api_client, tenant):
      ...
  \`\`\`
- Verify object-level permissions: users in Tenant A cannot access objects belonging to Tenant B even if they guess the UUID
- Ensure the GraphQL schema does not expose introspection in production (\`GRAPHQL_INTROSPECTION = False\` in production settings)

**Test file:** \`tests/security/test_rbac.py\`

---

### 4. Stripe Webhook Security

Harden the Stripe webhook handler in \`src/billing/webhooks.py\`.

**Actions:**
- Verify webhook signature verification using \`stripe.Webhook.construct_event()\` with the signing secret from environment
- Confirm the webhook endpoint is exempt from CSRF but NOT exempt from rate limiting
- Implement idempotency: store processed \`event.id\` values in a \`StripeWebhookEvent\` model and skip duplicates:
  \`\`\`python
  class StripeWebhookEvent(models.Model):
      event_id = models.CharField(max_length=255, unique=True, db_index=True)
      event_type = models.CharField(max_length=255)
      processed_at = models.DateTimeField(auto_now_add=True)
      payload = models.JSONField()
  \`\`\`
- Add error handling that returns \`200 OK\` for known-but-unhandled event types (prevent Stripe retries)
- Verify that \`customer.subscription.deleted\`, \`invoice.payment_failed\`, and \`customer.subscription.updated\` events correctly update tenant subscription state
- Ensure webhook handler logs are structured (JSON) and include \`event_id\`, \`event_type\`, \`tenant_id\` for audit trail
- Confirm the webhook URL is not guessable — use a path with a random token or rely solely on signature verification
- Add replay attack test: send the same event twice and verify it's processed only once

**Test file:** \`tests/security/test_stripe_webhooks.py\`

---

### 5. Celery Task Security

Harden all Celery tasks in \`src/tasks/\`.

**Actions:**
- Verify every task is idempotent — re-running with the same arguments produces the same result
- Confirm tasks do not accept arbitrary Python objects — only JSON-serializable primitives (UUIDs as strings, not model instances):
  \`\`\`python
  CELERY_TASK_SERIALIZER = "json"
  CELERY_ACCEPT_CONTENT = ["json"]
  CELERY_RESULT_SERIALIZER = "json"
  \`\`\`
- Add \`task_acks_late = True\` and \`task_reject_on_worker_lost = True\` for at-least-once delivery
- Verify tasks set \`max_retries\` and use exponential backoff:
  \`\`\`python
  @shared_task(bind=True, max_retries=3, default_retry_delay=60)
  def sync_billing(self, tenant_id: str) -> None:
      ...
  \`\`\`
- Confirm tasks that access tenant data set the tenant context before executing
- Ensure no task logs sensitive data (PII, API keys, card numbers) — audit all \`logger.*\` calls in \`src/tasks/\`
- Verify Redis broker connection uses TLS in production (\`rediss://\`)
- Add \`task_time_limit\` and \`task_soft_time_limit\` to prevent runaway tasks

**Test file:** \`tests/security/test_celery_tasks.py\`

---

### 6. Django Security Settings

Verify and harden Django's built-in security middleware and settings.

**Actions:**
- Confirm these settings in \`config/production.py\`:
  \`\`\`python
  DEBUG = False
  ALLOWED_HOSTS = env.list("ALLOWED_HOSTS")
  SECURE_SSL_REDIRECT = True
  SECURE_HSTS_SECONDS = 31536000
  SECURE_HSTS_INCLUDE_SUBDOMAINS = True
  SECURE_HSTS_PRELOAD = True
  SECURE_CONTENT_TYPE_NOSNIFF = True
  SECURE_BROWSER_XSS_FILTER = True  # legacy but harmless
  X_FRAME_OPTIONS = "DENY"
  SECURE_PROXY_SSL_HEADER = ("HTTP_X_FORWARDED_PROTO", "https")
  SECURE_REFERRER_POLICY = "strict-origin-when-cross-origin"
  \`\`\`
- Verify \`SecurityMiddleware\` is first in \`MIDDLEWARE\`
- Add Content-Security-Policy header via middleware or \`django-csp\`:
  \`\`\`python
  CSP_DEFAULT_SRC = ("'self'",)
  CSP_SCRIPT_SRC = ("'self'", "https://js.stripe.com")
  CSP_FRAME_SRC = ("'self'", "https://js.stripe.com")
  CSP_STYLE_SRC = ("'self'", "'unsafe-inline'")  # minimize unsafe-inline
  CSP_IMG_SRC = ("'self'", "data:", "https://*.s3.amazonaws.com")
  \`\`\`
- Confirm \`CORS_ALLOWED_ORIGINS\` is explicitly set (not \`CORS_ALLOW_ALL_ORIGINS = True\`)
- Verify \`SECRET_KEY\` is loaded from environment, not hardcoded
- Ensure \`DATABASES\` password is loaded from environment or AWS Secrets Manager
- Run \`uv run python manage.py check --deploy\` and fix all warnings

**Test file:** \`tests/security/test_django_settings.py\`

---

### 7. Input Validation & Injection Prevention

**Actions:**
- Audit all DRF serializers in \`src/api/serializers/\` for proper field validation — no \`CharField\` without \`max_length\`, no unvalidated \`JSONField\`
- Verify all Strawberry GraphQL input types have validation (use Pydantic validators or custom scalars)
- Confirm no use of \`|safe\` template filter on user-supplied data in \`templates/\`
- Audit for SQL injection: search for string formatting in queries (\`f"SELECT\`, \`% query\`, \`.format(\`)
- Verify file upload endpoints validate file type, size (max 10MB), and store to S3 — never to local filesystem
- Ensure all URL parameters used in ORM lookups are validated (no \`__\` traversal attacks):
  \`\`\`python
  # BAD: request.query_params passed directly to .filter(**params)
  # GOOD: explicit allowlist of filterable fields
  \`\`\`
- Add \`bleach\` or equivalent sanitization for any HTML-accepting fields

**Test file:** \`tests/security/test_input_validation.py\`

---

### 8. Audit Logging

Implement comprehensive audit logging for SOC 2 compliance.

**Actions:**
- Verify the audit log model in \`src/core/models.py\`:
  \`\`\`python
  class AuditLog(models.Model):
      id = models.UUIDField(primary_key=True, default=uuid.uuid4)
      tenant = models.ForeignKey("tenants.Tenant", on_delete=models.CASCADE)
      actor = models.ForeignKey(settings.AUTH_USER_MODEL, on_delete=models.SET_NULL, null=True)
      action = models.CharField(max_length=50)  # create, update, delete, login, export
      resource_type = models.CharField(max_length=100)
      resource_id = models.CharField(max_length=255)
      changes = models.JSONField(default=dict)  # before/after diff
      ip_address = models.GenericIPAddressField(null=True)
      user_agent = models.TextField(blank=True)
      timestamp = models.DateTimeField(auto_now_add=True, db_index=True)
  \`\`\`
- Confirm audit logs are written for: login/logout, failed login, permission denied, CRUD on tenant data, billing changes, role changes, data exports, settings changes
- Ensure audit logs are **append-only** — no update/delete permissions except for retention cleanup
- Verify audit log entries include \`ip_address\` and \`user_agent\` from request middleware
- Confirm audit logs are excluded from tenant data deletion (retained per SOC 2 requirements, anonymized per GDPR after retention period)
- Add a Celery task for audit log retention: anonymize PII in logs older than the configured retention period (default 2 years)

**Test file:** \`tests/security/test_audit_logging.py\`

---

### 9. GDPR Compliance

**Actions:**
- Implement data export endpoint (\`GET /api/v1/me/data-export/\`) that triggers a Celery task to compile all user PII into a downloadable archive — right of access (Article 15)
- Implement account deletion endpoint (\`DELETE /api/v1/me/\`) that:
  - Anonymizes user PII (email → hash, name → "Deleted User")
  - Retains audit logs with anonymized actor
  - Cancels Stripe subscription
  - Queues a Celery task for cascading soft-delete of user content
  - Returns confirmation within 30 days (queue for manual review if tenant owner)
- Verify consent tracking: \`ConsentRecord\` model with \`purpose\`, \`granted_at\`, \`revoked_at\`, \`ip_address\`
- Confirm cookie consent banner integration point exists in \`templates/base.html\`
- Verify data residency: tenant \`region\` field controls which database/S3 bucket is used (EU vs US)
- Ensure all PII fields are identified with a \`pii=True\` marker or documented in \`docs/data-classification.md\`
- Add \`X-Data-Residency\` response header indicating the region serving the request

**Test file:** \`tests/security/test_gdpr_compliance.py\`

---

### 10. Secrets & Environment Security

**Actions:**
- Grep the entire repo for hardcoded secrets: API keys, passwords, tokens, private keys
  \`\`\`bash
  uv run ruff check --select S105,S106,S107 src/  # hardcoded password detection
  \`\`\`
- Verify \`.env\` and \`.env.*\` are in \`.gitignore\`
- Confirm \`config/\` settings load all secrets via \`django-environ\` or Pydantic \`SecretStr\`:
  \`\`\`python
  STRIPE_SECRET_KEY: SecretStr
  DATABASE_URL: SecretStr
  REDIS_URL: SecretStr
  \`\`\`
- Verify no secrets appear in Celery task arguments, log output, error responses, or Sentry breadcrumbs
- Confirm Sentry is configured with \`send_default_pii=False\` and sensitive fields are scrubbed:
  \`\`\`python
  sentry_sdk.init(
      send_default_pii=False,
      before_send=scrub_sensitive_data,
  )
  \`\`\`
- Ensure Docker images don't bake in secrets — use runtime environment variables or AWS Secrets Manager
- Verify \`drf-spectacular\` schema generation does not expose internal implementation details or sensitive field descriptions

**Test file:** \`tests/security/test_secrets.py\`

---

### 11. Dependency Security

**Actions:**
- Run \`uv pip audit\` (or \`pip-audit\`) to check for known vulnerabilities in dependencies
- Verify \`pyproject.toml\` pins major versions and uses compatible release specifiers (\`~=\`)
- Confirm GitHub Actions CI includes a security scan stage (e.g., \`trivy\`, \`safety\`, \`bandit\`):
  \`\`\`yaml
  - name: Security scan
    run: |
      uv run bandit -r src/ -c pyproject.toml
      uv run pip-audit
  \`\`\`
- Run \`uv run bandit -r src/ -ll\` and fix all medium+ severity findings
- Verify Docker base image is pinned to a specific digest and uses a minimal image (\`python:3.12-slim\`)
- Check for unused dependencies and remove them

---

### Output Requirements

For each domain above:

1. **Create or update** the relevant source files with security fixes
2. **Create the test file** specified, with tests that verify the hardening
3. **Add comments** referencing the compliance requirement (e.g., \`# SOC 2 CC6.1\`, \`# GDPR Article 17\`)
4. **Update** \`docs/security-hardening.md\` with a summary of changes, organized by domain
5. **Run** the full verification suite:
   \`\`\`bash
   uv run ruff check src/ tests/
   uv run mypy src/
   uv run pytest tests/security/ -v --tb=short
   uv run python manage.py check --deploy
   uv run bandit -r src/ -ll
   \`\`\`

Use conventional commits: \`fix(security): <description>\` for each logical change. Keep each commit focused on a single security domain.

Reference the phase definition in \`playbook/phases/05-integration-hardening.md\` for acceptance criteria. Mark all AI-generated code with \`# AI-generated\` comment at the top of new files per CI policy.`,

  'playbook/prompts/06/e2e-test-generator.md': `# E2E Test Generator — Phase 06 (Testing & Quality)

## Prompt: End-to-End Test Generator for Django SaaS Platform

Copy and paste the following prompt into Claude Code to generate comprehensive end-to-end tests for critical SaaS user journeys.

---

### Prompt

\`\`\`
You are an expert QA engineer writing end-to-end tests for a multi-tenant Django SaaS platform. Generate comprehensive E2E tests that exercise full user journeys through the running application, covering the REST API, background task processing, Stripe billing integration, and tenant isolation.

## Project Context

- **Framework**: Django 5.0, Django REST Framework, Strawberry GraphQL
- **Task Queue**: Celery 5 with Redis broker
- **Database**: PostgreSQL 16 with row-level security for tenant isolation
- **Billing**: Stripe (subscriptions, usage metering, webhooks, invoicing)
- **Auth**: JWT-based authentication with role-based access control (RBAC)
- **Test Stack**: pytest, pytest-django, pytest-asyncio, factory_boy, responses (HTTP mocking), testcontainers
- **Coverage Threshold**: 85%
- **Run Command**: \`uv run pytest tests/e2e/ -v --tb=short\`

## Architecture

\`\`\`
src/
  accounts/       # User management, authentication, tenant association
  tenants/        # Multi-tenancy model, middleware, row-level security
  billing/        # Stripe integration, subscriptions, invoices, usage metering
  api/            # DRF viewsets, Strawberry GraphQL schema
  core/           # Base models, permissions, middleware, tenant-aware managers
  notifications/  # Email, in-app notifications, webhook dispatch
  tasks/          # Celery task definitions
  utils/          # Shared utilities
config/           # Django settings
tests/
  e2e/            # End-to-end tests (this is what you are generating)
    conftest.py
    test_tenant_onboarding.py
    test_subscription_lifecycle.py
    test_user_management.py
    test_api_workflows.py
    test_billing_webhooks.py
    test_tenant_isolation.py
    test_graphql_workflows.py
    test_notification_delivery.py
    test_white_label.py
\`\`\`

## E2E Test Requirements

### 1. Test Infrastructure (\`tests/e2e/conftest.py\`)

Create shared fixtures that:
- Stand up a real PostgreSQL test database with row-level security policies applied
- Configure a Celery worker in eager mode (\`CELERY_TASK_ALWAYS_EAGER=True\`) for synchronous task execution during tests, with an option to use a real worker for async-specific tests
- Mock Stripe API calls using \`responses\` or \`stripe.mock\` — never hit real Stripe in CI
- Provide a \`live_server\` fixture using Django's \`LiveServerTestCase\` or pytest-django's \`live_server\`
- Create factory fixtures: \`tenant_factory\`, \`user_factory\`, \`subscription_factory\`, \`plan_factory\`
- Provide an authenticated API client fixture that handles JWT token acquisition
- Provide a \`tenant_context\` context manager that sets the current tenant for the request
- Include cleanup fixtures that ensure tenant data isolation between tests
- Set \`DJANGO_SETTINGS_MODULE=config.settings.testing\`

Key fixtures to define:
\`\`\`python
@pytest.fixture
def api_client() -> APIClient

@pytest.fixture
def authenticated_client(api_client, user_factory, tenant_factory) -> tuple[APIClient, User, Tenant]

@pytest.fixture
def stripe_mock() -> Generator[responses.RequestsMock, None, None]

@pytest.fixture
def celery_eager(settings) -> None

@pytest.fixture
def tenant_with_subscription(tenant_factory, subscription_factory, stripe_mock) -> Tenant

@pytest.fixture
def multi_tenant_setup(tenant_factory, user_factory) -> dict[str, tuple[Tenant, User]]
\`\`\`

### 2. Tenant Onboarding Journey (\`test_tenant_onboarding.py\`)

Test the complete tenant signup and onboarding flow:

1. **Signup**: POST to \`/api/v1/auth/register/\` with org name, admin email, password
2. **Email verification**: Simulate clicking the verification link (extract token from outbox)
3. **Tenant creation**: Verify tenant record created with correct schema/RLS policy
4. **Initial setup wizard**: PATCH tenant profile with company details, logo, subdomain
5. **Invite team members**: POST to \`/api/v1/tenants/{id}/invitations/\` with email list
6. **Accept invitation**: Simulate invitation acceptance flow for invited users
7. **Verify RBAC**: Confirm admin has \`owner\` role, invited users have \`member\` role
8. **Verify audit log**: Check that all onboarding actions are recorded in the audit log

Assert:
- HTTP status codes at each step (201, 200, 204)
- Database state after each step (tenant exists, users associated, roles assigned)
- Email outbox contains verification and invitation emails
- Audit log entries exist for each action
- Tenant subdomain is unique and validated

### 3. Subscription Lifecycle (\`test_subscription_lifecycle.py\`)

Test the full Stripe subscription lifecycle:

1. **Select plan**: GET \`/api/v1/billing/plans/\` — verify available plans returned
2. **Create checkout session**: POST \`/api/v1/billing/checkout/\` with plan ID
3. **Simulate Stripe webhook \`checkout.session.completed\`**: POST to \`/api/v1/webhooks/stripe/\`
4. **Verify subscription active**: GET \`/api/v1/billing/subscription/\` — status is \`active\`
5. **Record usage**: POST \`/api/v1/billing/usage/\` with metered usage data
6. **Simulate invoice webhook \`invoice.paid\`**: Verify invoice recorded
7. **Upgrade plan**: POST \`/api/v1/billing/subscription/upgrade/\` with new plan
8. **Simulate \`customer.subscription.updated\` webhook**: Verify plan change
9. **Cancel subscription**: POST \`/api/v1/billing/subscription/cancel/\`
10. **Simulate \`customer.subscription.deleted\` webhook**: Verify access revoked
11. **Verify grace period**: Confirm tenant can still access data during grace period
12. **Verify lockout after grace period**: Confirm tenant is locked out

Assert:
- Stripe API calls are made with correct parameters (verify mock call args)
- Webhook signature verification is enforced (reject unsigned webhooks)
- Webhook idempotency: replaying the same webhook event ID does not create duplicates
- Subscription state transitions are correct in the database
- Usage records are associated with the correct billing period
- Celery tasks for billing sync are triggered
- Tenant feature flags update based on plan tier

### 4. User Management & RBAC (\`test_user_management.py\`)

Test role-based access control across tenant boundaries:

1. **Owner creates admin**: POST \`/api/v1/tenants/{id}/members/\` with role=admin
2. **Admin creates member**: Verify admin can create members but not other admins
3. **Member cannot create users**: Verify 403 Forbidden
4. **Role-based endpoint access**: Test each role against protected endpoints
5. **Cross-tenant access denied**: User from Tenant A cannot access Tenant B resources
6. **Deactivate user**: PATCH user status, verify JWT tokens are invalidated
7. **Password reset flow**: Request reset, verify email, set new password, login
8. **MFA enrollment**: Enable TOTP, verify login requires second factor

Roles to test: \`owner\`, \`admin\`, \`member\`, \`viewer\`, \`billing_admin\`

Permission matrix to verify:
\`\`\`
Endpoint                          | owner | admin | member | viewer | billing_admin
/api/v1/tenants/{id}/settings/    | RW    | RW    | R      | R      | R
/api/v1/tenants/{id}/members/     | CRUD  | CRU   | R      | R      | R
/api/v1/billing/subscription/     | RW    | R     | -      | -      | RW
/api/v1/billing/invoices/         | R     | R     | -      | -      | R
/api/v1/data/export/              | RW    | RW    | RW     | R      | -
\`\`\`

### 5. API Workflow Tests (\`test_api_workflows.py\`)

Test realistic multi-step API workflows:

1. **CRUD lifecycle**: Create → Read → Update → List (with pagination, filtering, ordering) → Delete → Verify 404
2. **Bulk operations**: POST \`/api/v1/resources/bulk/\` with multiple items, verify atomic behavior
3. **Search and filtering**: Test \`?search=\`, \`?status=\`, \`?created_after=\`, \`?ordering=-created_at\`
4. **Pagination**: Verify \`next\`, \`previous\`, \`count\` in paginated responses
5. **Rate limiting**: Send requests exceeding rate limit, verify 429 response with \`Retry-After\` header
6. **Content negotiation**: Test \`Accept: application/json\` vs unsupported types
7. **Validation errors**: Submit invalid data, verify 400 response with field-level errors in DRF format
8. **Concurrent updates**: Simulate optimistic locking conflict, verify 409 response
9. **File upload**: POST multipart form data, verify S3 upload (mocked), verify file association

### 6. Billing Webhook Tests (\`test_billing_webhooks.py\`)

Test Stripe webhook handling in depth:

1. **Signature verification**: Reject webhooks with invalid \`Stripe-Signature\` header (400/401)
2. **Event types**: Test handling of each webhook event type:
   - \`checkout.session.completed\`
   - \`customer.subscription.created\`
   - \`customer.subscription.updated\`
   - \`customer.subscription.deleted\`
   - \`invoice.paid\`
   - \`invoice.payment_failed\`
   - \`customer.updated\`
   - \`payment_method.attached\`
   - \`charge.dispute.created\`
3. **Idempotency**: Send same event ID twice, verify only processed once
4. **Out-of-order events**: Send \`subscription.deleted\` before \`subscription.created\`, verify graceful handling
5. **Payment failure flow**: \`invoice.payment_failed\` → retry logic → dunning emails → eventual suspension
6. **Dispute handling**: \`charge.dispute.created\` → alert notification → audit log entry

For each webhook test:
\`\`\`python
def _build_stripe_event(self, event_type: str, data: dict, event_id: str | None = None) -> dict:
    """Build a properly structured Stripe webhook event payload."""

def _sign_webhook_payload(self, payload: str, secret: str) -> str:
    """Generate a valid Stripe webhook signature for testing."""
\`\`\`

### 7. Tenant Isolation Tests (\`test_tenant_isolation.py\`)

**Critical security tests** — verify multi-tenant data isolation:

1. **Query isolation**: Tenant A creates resources, Tenant B queries — must return empty
2. **Direct ID access**: Tenant B tries to GET \`/api/v1/resources/{tenant_a_resource_id}/\` — must return 404 (not 403, to avoid ID enumeration)
3. **Bulk endpoint isolation**: Tenant B's bulk operations cannot reference Tenant A's IDs
4. **Search isolation**: Full-text search only returns current tenant's data
5. **Celery task isolation**: Tasks queued by Tenant A only process Tenant A's data
6. **Admin panel isolation**: Tenant admin cannot see other tenants' data in Django admin
7. **Export isolation**: Data export only includes current tenant's records
8. **Shared resource access**: Verify that global/shared resources (plans, feature flags) are accessible to all tenants
9. **Database-level isolation**: Verify PostgreSQL RLS policies are active by attempting raw SQL bypass (should fail)
10. **Cache isolation**: Verify Redis cache keys are namespaced per tenant

Structure each test as:
\`\`\`python
def test_<resource>_isolation_between_tenants(
    self,
    multi_tenant_setup: dict[str, tuple[Tenant, User]],
    authenticated_client: ...,
):
    tenant_a, user_a = multi_tenant_setup["tenant_a"]
    tenant_b, user_b = multi_tenant_setup["tenant_b"]
    # Create data as tenant_a
    # Attempt access as tenant_b
    # Assert isolation
\`\`\`

### 8. GraphQL Workflow Tests (\`test_graphql_workflows.py\`)

Test Strawberry GraphQL endpoint at \`/api/graphql/\`:

1. **Query**: Fetch tenant profile with nested members and subscription
2. **Mutation**: Update tenant settings via GraphQL mutation
3. **Pagination**: Test relay-style cursor pagination on list queries
4. **Filtering**: Test GraphQL filter arguments
5. **Authentication**: Verify unauthenticated queries return error
6. **Authorization**: Verify role-based field visibility (e.g., billing fields hidden from \`viewer\` role)
7. **N+1 prevention**: Verify that dataloaders are used (check query count with \`django.test.utils.override_settings(DEBUG=True)\` and \`connection.queries\`)
8. **Error handling**: Verify GraphQL errors follow the spec (errors array with message, locations, path)
9. **Subscription (WebSocket)**: If applicable, test GraphQL subscriptions for real-time updates

### 9. Notification Delivery Tests (\`test_notification_delivery.py\`)

Test the notification pipeline end-to-end:

1. **Email notifications**: Trigger event → Celery task → email in Django outbox
2. **In-app notifications**: Trigger event → notification record created → API returns unread notifications
3. **Webhook dispatch**: Trigger event → Celery task → outbound HTTP call to tenant's webhook URL (mocked)
4. **Webhook retry**: Simulate webhook delivery failure → verify exponential backoff retry
5. **Notification preferences**: User disables email notifications → verify email not sent but in-app still created
6. **Bulk notifications**: Trigger event affecting multiple users → verify all receive notifications
7. **Template rendering**: Verify email templates render correctly with tenant branding (white-label)

### 10. White-Label Tests (\`test_white_label.py\`)

Test white-label/custom branding features:

1. **Custom subdomain**: Request with \`Host: acme.app.example.com\` routes to correct tenant
2. **Custom branding**: Tenant's logo, colors, and name appear in API responses and email templates
3. **Custom domain**: Tenant with custom domain configured — verify routing and SSL context
4. **Email from address**: Outbound emails use tenant's configured from address
5. **Fallback branding**: Tenant without custom branding gets platform defaults

## Code Style Requirements

- Use \`pytest\` style (no \`unittest.TestCase\` unless needed for \`LiveServerTestCase\`)
- Type hints on all test functions and fixtures
- Use \`factory_boy\` factories for all test data — no raw \`Model.objects.create()\`
- Use \`freezegun\` or \`time_machine\` for time-dependent tests (grace periods, trial expiry)
- Use \`responses\` library for mocking external HTTP calls (Stripe, webhooks)
- Each test file should have a module docstring explaining the journey being tested
- Each test function name should describe the scenario: \`test_<action>_<condition>_<expected_result>\`
- Use \`pytest.mark.e2e\` marker on all E2E tests
- Use \`pytest.mark.slow\` on tests that require real Celery worker
- Use \`@pytest.mark.parametrize\` for testing multiple roles or plan tiers
- Group related tests in classes: \`class TestTenantOnboardingJourney:\`
- Assert response bodies, not just status codes
- Verify database state after each significant action
- Include negative tests (unauthorized, invalid input, rate limited)
- All Stripe-related tests must mock the Stripe API — never make real API calls

## GDPR & SOC 2 Compliance Tests

Include in relevant test files:

- **Right to deletion**: Trigger account deletion → verify all PII removed, audit log retained (anonymized)
- **Data export**: Request GDPR data export → verify complete data package generated
- **Consent tracking**: Verify consent records created and queryable
- **Audit trail completeness**: Every state-changing API call has an audit log entry
- **Session management**: Verify session expiry, concurrent session limits
- **Data residency**: If tenant has EU data residency flag, verify data stored in EU region (check metadata)

## Output Structure

Generate each file completely. Start with \`conftest.py\`, then each test file in order. Each file should be runnable independently with:

\`\`\`bash
uv run pytest tests/e2e/<filename>.py -v --tb=short
\`\`\`

Use this marker configuration in \`conftest.py\`:
\`\`\`python
def pytest_configure(config):
    config.addinivalue_line("markers", "e2e: end-to-end test")
    config.addinivalue_line("markers", "slow: slow test requiring real services")
    config.addinivalue_line("markers", "billing: billing/Stripe related test")
    config.addinivalue_line("markers", "isolation: tenant isolation security test")
    config.addinivalue_line("markers", "gdpr: GDPR compliance test")
\`\`\`

## Target Feature/Journey

Generate E2E tests for: [SPECIFY THE JOURNEY — e.g., "tenant onboarding", "subscription lifecycle", "tenant isolation", or "all"]

If "all", generate every file listed above. If a specific journey, generate only \`conftest.py\` and the relevant test file.
\`\`\`

---

### Usage Examples

#### Generate all E2E tests

Append to the prompt:
\`\`\`
Generate E2E tests for: all

Start with conftest.py, then generate each test file. Ensure all files are placed in tests/e2e/.
\`\`\`

#### Generate only tenant isolation tests

Append to the prompt:
\`\`\`
Generate E2E tests for: tenant isolation

Focus on tests/e2e/conftest.py and tests/e2e/test_tenant_isolation.py. This is a security-critical area — be thorough with edge cases including raw SQL bypass attempts, cache key leakage, and Celery task tenant context propagation.
\`\`\`

#### Generate only subscription lifecycle tests

Append to the prompt:
\`\`\`
Generate E2E tests for: subscription lifecycle

Focus on tests/e2e/conftest.py and tests/e2e/test_subscription_lifecycle.py. Include all Stripe webhook event types, idempotency verification, and grace period/lockout behavior. Mock all Stripe API calls.
\`\`\`

#### Generate tests for a specific feature addition

Append to the prompt:
\`\`\`
Generate E2E tests for: usage-based billing metering

We just added a new usage metering endpoint at POST /api/v1/billing/usage/ that accepts:
{
  "metric": "api_calls",
  "quantity": 150,
  "timestamp": "2024-01-15T10:30:00Z"
}

Generate E2E tests covering:
- Recording usage for different metrics
- Usage aggregation per billing period
- Stripe usage record sync (via Celery task)
- Usage limits enforcement based on plan tier
- Usage reporting endpoint GET /api/v1/billing/usage/summary/
- Tenant isolation of usage data
\`\`\`

---

### Validation Checklist

After generating E2E tests, verify:

- [ ] \`conftest.py\` has all required fixtures with proper type hints
- [ ] Stripe API is mocked — no real API calls possible
- [ ] Every test has \`@pytest.mark.e2e\` marker
- [ ] Tenant isolation is verified in every multi-tenant test
- [ ] Webhook tests verify signature and idempotency
- [ ] RBAC tests cover the full permission matrix
- [ ] Negative/error cases are tested (401, 403, 404, 409, 429)
- [ ] Database state is asserted, not just HTTP responses
- [ ] Audit log entries are verified for state-changing operations
- [ ] Time-dependent tests use \`freezegun\` or \`time_machine\`
- [ ] All factories use \`factory_boy\`, no raw \`Model.objects.create()\`
- [ ] Tests can run independently: \`uv run pytest tests/e2e/test_<file>.py -v\`
- [ ] GDPR compliance tests are included (deletion, export, consent)
- [ ] GraphQL tests verify N+1 prevention with query counting
- [ ] File length stays under 300 lines per file (split if needed)

---

### Related Prompts

- **[Test Suite Generator](./test-suite-generator.md)** — Unit and integration test generation (Phase 06)
- **[Load Test Generator](./load-test.md)** — Performance and load testing (Phase 06)
- **[Security Hardening](../05/security-hardening.md)** — Security controls that E2E tests should verify (Phase 05)
- **[Integration Adapter](../05/integration-adapter.md)** — Stripe integration patterns tested here (Phase 05)
- **[Auth Implementation](../04/auth-implementation.md)** — Authentication/RBAC flows tested here (Phase 04)`,

  'playbook/prompts/06/load-test.md': `# Load Test Prompt — Phase 06: Testing & Quality

> Copy-paste this prompt into Claude Code to generate load testing infrastructure for the Django SaaS platform.

---

## Prompt

You are a performance engineer working on **django-saas-platform**, a multi-tenant SaaS application built with Django 5.0, Django REST Framework, Strawberry GraphQL, Celery 5, PostgreSQL 16 (row-level security), Redis, and Stripe billing. The application runs on AWS ECS behind an ALB.

### Objective

Generate a comprehensive load testing suite using **Locust** that validates the platform can handle production-level traffic across all critical paths, with special attention to multi-tenant isolation under load, Celery task queue saturation, and Stripe webhook burst handling.

### Load Test Scenarios to Generate

Create the following files:

#### 1. \`tests/load/locustfile.py\`
Main Locust entry point that orchestrates all user classes with weighted task sets:

- **TenantAPIUser** (weight: 50) — Simulates typical tenant API consumers:
  - \`GET /api/v1/tenants/{tenant_id}/\` — Tenant detail retrieval
  - \`GET /api/v1/tenants/{tenant_id}/members/\` — List tenant members (paginated, test page 1-5)
  - \`POST /api/v1/tenants/{tenant_id}/invitations/\` — Send invitation
  - \`PATCH /api/v1/tenants/{tenant_id}/settings/\` — Update tenant settings
  - Each user authenticates via JWT on start, include token refresh mid-session
  - Set \`X-Tenant-ID\` header on every request
  - Validate that responses never leak data from other tenants (cross-tenant assertion)

- **BillingUser** (weight: 15) — Simulates billing operations:
  - \`GET /api/v1/billing/subscription/\` — Current subscription status
  - \`POST /api/v1/billing/subscription/change-plan/\` — Plan upgrade/downgrade
  - \`GET /api/v1/billing/invoices/\` — Invoice listing (paginated)
  - \`GET /api/v1/billing/usage/\` — Usage metering data for current period
  - \`POST /api/v1/billing/payment-methods/\` — Add payment method (use Stripe test tokens)
  - Include realistic think times (3-8 seconds between billing actions)

- **WebhookFloodUser** (weight: 10) — Simulates Stripe webhook bursts:
  - \`POST /api/v1/webhooks/stripe/\` — Send realistic Stripe webhook payloads
  - Event types: \`invoice.paid\`, \`invoice.payment_failed\`, \`customer.subscription.updated\`, \`customer.subscription.deleted\`, \`charge.succeeded\`, \`charge.refunded\`
  - Include proper Stripe signature headers (use test webhook secret)
  - Test idempotency: send duplicate event IDs and verify 200 responses without side effects
  - Burst pattern: 50 webhooks in 2 seconds, then pause 10 seconds

- **GraphQLUser** (weight: 15) — Simulates GraphQL API consumers:
  - \`POST /graphql/\` — \`query { me { id email tenants { name plan } } }\`
  - \`POST /graphql/\` — \`query { tenant(id: $id) { members { edges { node { email role } } } } }\` with pagination (first: 20, after cursor)
  - \`POST /graphql/\` — \`mutation { updateTenantSettings(input: {...}) { tenant { id } } }\`
  - \`POST /graphql/\` — \`query { billingDashboard { currentPlan usage { metric value limit } } }\`
  - Validate no N+1 query regressions by checking response times stay under 500ms

- **BackgroundTaskUser** (weight: 10) — Triggers endpoints that enqueue Celery tasks:
  - \`POST /api/v1/reports/generate/\` — Trigger async report generation
  - \`POST /api/v1/notifications/broadcast/\` — Trigger bulk notification dispatch
  - \`POST /api/v1/tenants/{tenant_id}/export/\` — Trigger data export
  - After triggering, poll \`GET /api/v1/tasks/{task_id}/status/\` until completion or timeout (60s)
  - Track task queue depth and completion time as custom metrics

#### 2. \`tests/load/config.py\`
Load test configuration with environment-specific profiles:

\`\`\`python
# Profiles: smoke, load, stress, spike, soak, tenant-isolation
# smoke: 5 users, 1 min — sanity check
# load: 200 users, 10 min — expected production traffic
# stress: 500 users, 15 min — find breaking point
# spike: 50→500→50 users over 5 min — sudden traffic burst
# soak: 150 users, 2 hours — memory leaks, connection pool exhaustion
# tenant-isolation: 100 users across 20 tenants, 10 min — verify no data leakage
\`\`\`

Include settings for:
- Target host (from \`LOAD_TEST_HOST\` env var, default \`http://localhost:8000\`)
- Database seeding parameters (number of tenants, users per tenant, records per user)
- Stripe test mode configuration
- Redis connection for custom metric publishing
- Thresholds: p95 < 500ms, p99 < 1500ms, error rate < 1%, zero cross-tenant leaks

#### 3. \`tests/load/factories.py\`
Test data factories using factory_boy patterns (but for load test seeding):

- \`LoadTestTenant\` — Creates tenants with realistic data, different subscription plans (free, starter, professional, enterprise)
- \`LoadTestUser\` — Creates users with hashed passwords, assigned to tenants with roles (owner, admin, member, viewer)
- \`LoadTestSubscription\` — Creates Stripe-like subscription records with different states (active, trialing, past_due, canceled)
- \`LoadTestUsageRecords\` — Creates usage metering data across multiple metrics (api_calls, storage_bytes, seats)
- Seed script that creates 20 tenants, 10-50 users each, with realistic data distribution

#### 4. \`tests/load/custom_metrics.py\`
Custom Locust event listeners that track SaaS-specific metrics:

- **Tenant isolation violations** — Count any response containing data from wrong tenant
- **Celery task queue depth** — Poll Redis for \`celery\` queue length every 5 seconds
- **Celery task completion time** — Track from enqueue to result
- **Stripe webhook processing time** — From receipt to completion
- **Webhook idempotency failures** — Count duplicate processing
- **Database connection pool utilization** — Query \`pg_stat_activity\` periodically
- **Redis memory usage** — Track via \`INFO memory\`
- **Cache hit/miss ratio** — Track via Redis \`INFO stats\`
- Publish all metrics to Prometheus pushgateway for Grafana dashboards

#### 5. \`tests/load/tenant_isolation_validator.py\`
Dedicated module for cross-tenant data leak detection during load tests:

- Each simulated user belongs to exactly one tenant
- After every API response, parse the response body and verify:
  - No foreign tenant IDs appear in response data
  - No foreign user emails appear in response data
  - List endpoints only return records belonging to the authenticated tenant
  - GraphQL responses don't include nodes from other tenants
- If a violation is detected: log full request/response, increment violation counter, optionally halt the test
- Generate a tenant isolation report at test completion

#### 6. \`tests/load/stripe_webhook_payloads.py\`
Realistic Stripe webhook payload generator:

- Generate valid JSON payloads for each event type with proper structure
- Include \`id\`, \`created\`, \`livemode: false\`, \`type\`, \`data.object\` fields
- Compute valid \`Stripe-Signature\` header using test webhook signing secret
- Support generating duplicate events (same \`id\`) for idempotency testing
- Support generating events with timestamps out of order

#### 7. \`tests/load/docker-compose.load-test.yml\`
Docker Compose file for running load tests locally or in CI:

- \`locust-master\` service (web UI on port 8089)
- \`locust-worker\` services (scalable, 4 default)
- \`prometheus-pushgateway\` for custom metrics
- \`grafana\` with pre-configured dashboard for load test visualization
- Network configuration to reach the target application
- Volume mounts for test results and reports

#### 8. \`tests/load/run_load_test.sh\`
Shell script to orchestrate a complete load test run:

- Accept profile name as argument (\`smoke\`, \`load\`, \`stress\`, \`spike\`, \`soak\`, \`tenant-isolation\`)
- Seed test data if \`--seed\` flag is passed (calls Django management command)
- Start Locust in headless mode with appropriate user count and spawn rate
- Wait for completion
- Collect results from Locust CSV output
- Run tenant isolation report
- Check thresholds (p95, p99, error rate, tenant violations)
- Output pass/fail summary
- Exit with non-zero code if any threshold is breached
- Support \`--ci\` flag for GitHub Actions integration (output as GitHub step summary)

#### 9. \`scripts/seed_load_test_data.py\`
Django management command (\`python manage.py seed_load_test_data\`):

- Create tenants, users, subscriptions, usage records per the load test config
- Use bulk operations for performance (\`bulk_create\`)
- Create corresponding Stripe test objects via Stripe API (if \`--stripe\` flag)
- Idempotent — can be run multiple times without duplicating data
- Accept \`--tenants\`, \`--users-per-tenant\`, \`--cleanup\` flags
- Print summary of created data

#### 10. \`.github/workflows/load-test.yml\`
GitHub Actions workflow for automated load testing:

- Trigger: manual (\`workflow_dispatch\`) with profile selection dropdown
- Also trigger on PRs that modify \`src/billing/\`, \`src/tenants/\`, \`src/api/\`, \`src/core/\`
- Spin up PostgreSQL 16 and Redis services
- Run Django migrations and seed data
- Start Django app with gunicorn (4 workers)
- Start Celery worker and beat
- Run Locust in headless mode with selected profile
- Upload results as artifacts (CSV, HTML report)
- Post summary to PR as comment (if PR-triggered)
- Fail the workflow if thresholds are breached
- Post Slack notification on failure

### Technical Requirements

- All Python files must have type hints on public functions
- Use \`snake_case\` for files and functions, \`PascalCase\` for classes
- Follow ruff formatting rules
- Include docstrings on all classes and public functions
- Files must not exceed 300 lines — split into modules as needed
- Use \`django-environ\` for configuration
- All Stripe interactions must use test mode keys
- Tenant isolation checks are **mandatory** — a single cross-tenant leak fails the entire test
- Celery tasks triggered during load tests must be idempotent
- Custom metrics must be compatible with Prometheus/Grafana monitoring stack
- Load test data must be cleanly separable from production data (use \`loadtest_\` prefix on tenant slugs)

### Performance Baselines (SOC 2 / Production SLAs)

| Metric | Target | Critical |
|--------|--------|----------|
| API p50 latency | < 150ms | < 300ms |
| API p95 latency | < 500ms | < 1000ms |
| API p99 latency | < 1500ms | < 3000ms |
| Error rate | < 0.5% | < 1% |
| Webhook processing | < 2s | < 5s |
| Celery task completion | < 30s | < 60s |
| Tenant isolation violations | 0 | 0 |
| DB connection pool usage | < 70% | < 90% |

### Output Format

Generate each file with its full path as a header comment. Include inline comments explaining SaaS-specific load testing decisions. Add a \`tests/load/README.md\` with instructions for running locally, in CI, and interpreting results.

After generating all files, run:
\`\`\`bash
uv run ruff check tests/load/
uv run mypy tests/load/ --ignore-missing-imports
\`\`\`

Fix any issues found. Then provide a summary of:
1. Files created
2. How to run each profile
3. Key metrics to watch during the test
4. How to interpret the tenant isolation report
5. Integration points with the existing Prometheus/Grafana monitoring`,

  'playbook/prompts/06/test-suite-generator.md': `# Test Suite Generator — Phase 06: Testing & Quality

> **Copy-paste this prompt into Claude Code** to generate comprehensive test suites for Django SaaS platform modules.
> Adjust the \`[PLACEHOLDERS]\` before running.

---

## Prompt

\`\`\`
You are a senior QA engineer working on django-saas-platform, a multi-tenant SaaS application. Generate a comprehensive test suite for the module described below.

## Target Module

- **Django app**: [APP_NAME e.g., billing, tenants, accounts, notifications, api]
- **File(s) under test**: [FILE_PATHS e.g., src/billing/services.py, src/billing/webhooks.py]
- **Functionality**: [DESCRIPTION e.g., Stripe subscription lifecycle — create, upgrade, downgrade, cancel, reactivate]
- **Dependencies to mock**: [EXTERNAL_DEPS e.g., stripe.Subscription, stripe.Customer, stripe.Invoice, celery tasks]

## Project Context

This is a multi-tenant Django 5.0 SaaS platform with:
- PostgreSQL with row-level security for tenant isolation
- Stripe integration for subscription billing and usage metering
- Celery 5 for async task processing (Redis broker)
- Django REST Framework + Strawberry GraphQL API layer
- SOC 2 and GDPR compliance requirements
- 85% minimum code coverage threshold

## Tech Stack for Tests

- **Framework**: pytest with pytest-django, pytest-asyncio
- **Fixtures**: factory_boy (all test data via factories, never raw ORM creates)
- **Mocking**: unittest.mock (patch, MagicMock), pytest-mock (mocker fixture)
- **HTTP testing**: DRF's APIClient, Django's RequestFactory
- **Coverage**: pytest-cov (target 85%+)
- **Assertions**: pytest native assertions (no unittest-style self.assert*)

## Test File Structure

Place tests in \`tests/[APP_NAME]/\` mirroring the source structure:
\`\`\`
tests/
  [APP_NAME]/
    __init__.py
    conftest.py          # App-specific fixtures, factories
    test_models.py       # Model validation, constraints, managers
    test_services.py     # Service layer / business logic
    test_views.py        # API endpoint tests (DRF viewsets)
    test_serializers.py  # Serializer validation, output shape
    test_tasks.py        # Celery task tests (idempotency, retries)
    test_webhooks.py     # Webhook handler tests (if applicable)
    test_permissions.py  # RBAC and tenant isolation
    test_signals.py      # Signal handler tests (if any)
\`\`\`

## Generation Requirements

### 1. conftest.py — Factories and Fixtures

Generate factory_boy factories for every model in the app:
- Use \`factory.django.DjangoModelFactory\`
- Use \`factory.Faker\` for realistic field values
- Use \`factory.SubFactory\` for foreign keys
- Use \`factory.LazyAttribute\` for computed fields
- Use \`factory.Trait\` for common variations (e.g., \`active\`, \`expired\`, \`trial\`)
- Every factory must set \`tenant\` via a \`TenantFactory\` SubFactory
- Include a \`@pytest.fixture\` wrapper for each factory for convenience

Example pattern:
\`\`\`python
import factory
from factory.django import DjangoModelFactory

class TenantFactory(DjangoModelFactory):
    class Meta:
        model = "tenants.Tenant"

    name = factory.Faker("company")
    slug = factory.LazyAttribute(lambda o: slugify(o.name))
    is_active = True

    class Params:
        trial = factory.Trait(
            subscription_status="trialing",
            trial_ends_at=factory.LazyFunction(lambda: timezone.now() + timedelta(days=14)),
        )

class UserFactory(DjangoModelFactory):
    class Meta:
        model = "accounts.User"

    email = factory.Faker("email")
    tenant = factory.SubFactory(TenantFactory)
    role = "member"

    class Params:
        admin = factory.Trait(role="admin", is_staff=True)
        owner = factory.Trait(role="owner")
\`\`\`

### 2. Model Tests

For each model in the app, test:
- Field validation (required fields, max_length, choices, unique constraints)
- Custom model methods and properties
- \`__str__\` representation
- Default ordering
- Tenant-aware manager filters only current tenant's data
- Database constraints (unique_together, CheckConstraint)
- Soft delete behavior (if applicable)
- Audit fields (created_at, updated_at, created_by)

### 3. Service Layer Tests

For each service function/class:
- **Happy path**: Expected input → expected output and side effects
- **Edge cases**: Empty inputs, boundary values, None handling
- **Error paths**: Invalid data raises appropriate exceptions (not generic Exception)
- **Tenant isolation**: Service never leaks data across tenants
- **Idempotency**: Calling the same operation twice produces the same result (critical for billing)
- **Transaction safety**: Verify atomic operations roll back on failure
- Mock all external services (Stripe, email, external APIs)

Pattern for Stripe service tests:
\`\`\`python
@pytest.mark.django_db
class TestSubscriptionService:
    def test_create_subscription_success(self, mocker, tenant_factory, user_factory):
        tenant = tenant_factory()
        user = user_factory(tenant=tenant, owner=True)
        mock_stripe = mocker.patch("src.billing.services.stripe.Subscription.create")
        mock_stripe.return_value = StripeMock.subscription(status="active")

        result = SubscriptionService.create(
            tenant=tenant,
            price_id="price_pro_monthly",
            initiated_by=user,
        )

        assert result.status == "active"
        assert result.tenant == tenant
        mock_stripe.assert_called_once()

    def test_create_subscription_idempotent(self, mocker, tenant_factory):
        """Calling create twice with same tenant returns existing subscription."""
        tenant = tenant_factory()
        # ... first call creates, second call returns existing

    def test_create_subscription_stripe_error(self, mocker, tenant_factory):
        """Stripe API failure rolls back local DB changes."""
        mocker.patch(
            "src.billing.services.stripe.Subscription.create",
            side_effect=stripe.error.CardError("declined", "card_declined", 402),
        )
        # ... assert no Subscription record created, appropriate exception raised

    def test_cross_tenant_isolation(self, mocker, tenant_factory):
        """Service cannot access another tenant's subscription."""
        tenant_a = tenant_factory()
        tenant_b = tenant_factory()
        # ... create subscription for tenant_a
        # ... assert tenant_b context cannot see it
\`\`\`

### 4. API / View Tests

For each DRF viewset or Strawberry resolver:
- **Authentication**: Unauthenticated requests return 401
- **Authorization**: Wrong role returns 403; test each RBAC role
- **Tenant isolation**: User from tenant A cannot access tenant B resources (return 404, not 403)
- **CRUD operations**: Test list, retrieve, create, update, partial_update, destroy
- **Pagination**: Verify paginated responses have correct structure
- **Filtering/search**: Test query parameters
- **Validation errors**: Invalid payloads return 400 with structured error response
- **Rate limiting**: Verify rate limit headers (if applicable)
- **OpenAPI schema**: Endpoint is documented via drf-spectacular

Pattern:
\`\`\`python
@pytest.mark.django_db
class TestSubscriptionViewSet:
    endpoint = "/api/v1/billing/subscriptions/"

    def test_list_requires_authentication(self, api_client):
        response = api_client.get(self.endpoint)
        assert response.status_code == 401

    def test_list_returns_only_own_tenant(self, auth_client, subscription_factory):
        own = subscription_factory(tenant=auth_client.user.tenant)
        other = subscription_factory()  # different tenant
        response = auth_client.get(self.endpoint)
        assert response.status_code == 200
        ids = [s["id"] for s in response.data["results"]]
        assert str(own.id) in ids
        assert str(other.id) not in ids

    def test_create_requires_owner_role(self, auth_client):
        auth_client.user.role = "member"
        auth_client.user.save()
        response = auth_client.post(self.endpoint, data={...})
        assert response.status_code == 403
\`\`\`

### 5. Celery Task Tests

For each Celery task:
- **Idempotency**: Running the task twice with the same args produces the same result
- **Retry behavior**: Task retries on transient errors (network, rate limit)
- **Failure handling**: Permanent failures are logged and don't retry infinitely
- **Side effects**: Verify emails sent, records updated, webhooks dispatched
- **Tenant context**: Task operates within correct tenant scope
- Use \`celery.contrib.pytest\` or mock \`task.delay()\` / \`task.apply()\`

Pattern:
\`\`\`python
@pytest.mark.django_db
class TestSyncStripeInvoicesTask:
    def test_syncs_new_invoices(self, mocker, tenant_factory):
        tenant = tenant_factory()
        mock_stripe = mocker.patch("src.tasks.billing.stripe.Invoice.list")
        mock_stripe.return_value = StripeMock.invoice_list(count=3)

        result = sync_stripe_invoices.apply(args=[str(tenant.id)])

        assert result.successful()
        assert Invoice.objects.filter(tenant=tenant).count() == 3

    def test_idempotent_on_rerun(self, mocker, tenant_factory):
        tenant = tenant_factory()
        mock_stripe = mocker.patch("src.tasks.billing.stripe.Invoice.list")
        mock_stripe.return_value = StripeMock.invoice_list(count=3)

        sync_stripe_invoices.apply(args=[str(tenant.id)])
        sync_stripe_invoices.apply(args=[str(tenant.id)])

        assert Invoice.objects.filter(tenant=tenant).count() == 3  # not 6

    def test_retries_on_stripe_rate_limit(self, mocker, tenant_factory):
        tenant = tenant_factory()
        mocker.patch(
            "src.tasks.billing.stripe.Invoice.list",
            side_effect=stripe.error.RateLimitError("Too many requests"),
        )
        with pytest.raises(Retry):
            sync_stripe_invoices.apply(args=[str(tenant.id)])
\`\`\`

### 6. Webhook Tests

For Stripe webhook handlers:
- **Signature verification**: Invalid signatures return 400
- **Idempotency**: Processing the same event ID twice is safe
- **Event routing**: Each event type dispatches to the correct handler
- **State transitions**: Webhook updates local state correctly (e.g., subscription status)
- **Unknown events**: Unhandled event types return 200 (acknowledge but ignore)

Pattern:
\`\`\`python
@pytest.mark.django_db
class TestStripeWebhook:
    endpoint = "/api/v1/billing/webhooks/stripe/"

    def test_rejects_invalid_signature(self, api_client, mocker):
        mocker.patch(
            "stripe.Webhook.construct_event",
            side_effect=stripe.error.SignatureVerificationError("bad sig", "sig"),
        )
        response = api_client.post(
            self.endpoint,
            data=b"{}",
            content_type="application/json",
            HTTP_STRIPE_SIGNATURE="invalid",
        )
        assert response.status_code == 400

    def test_invoice_paid_updates_subscription(self, api_client, mocker, subscription_factory):
        sub = subscription_factory(status="past_due")
        event = StripeMock.webhook_event(
            type="invoice.paid",
            data={"subscription": sub.stripe_subscription_id},
        )
        mocker.patch("stripe.Webhook.construct_event", return_value=event)

        response = api_client.post(
            self.endpoint,
            data=json.dumps(event),
            content_type="application/json",
            HTTP_STRIPE_SIGNATURE="valid",
        )

        assert response.status_code == 200
        sub.refresh_from_db()
        assert sub.status == "active"

    def test_duplicate_event_is_idempotent(self, api_client, mocker, subscription_factory):
        """Processing the same webhook event_id twice has no additional effect."""
        # ...
\`\`\`

### 7. Permission / RBAC Tests

Test the role-based access control matrix:
- **Roles**: owner, admin, member, viewer, billing_admin (or whatever the app defines)
- **Per-endpoint**: Verify each role's access (allow/deny) for each action
- **Tenant admin cannot access platform admin**: Verify isolation between tenant-level and platform-level roles
- **Superuser bypass**: Platform superusers can access cross-tenant (for support tooling)

### 8. GDPR / Compliance Tests

- **Data export**: User can request full data export (right of access)
- **Data deletion**: User deletion cascades or anonymizes all PII
- **Consent tracking**: Consent records are created and timestamped
- **Audit logging**: Sensitive operations create audit log entries
- **PII in logs**: Verify no PII leaks into log output (test log formatters)

### 9. Test Markers and Configuration

Include appropriate pytest markers:
\`\`\`python
# In each test class or function as needed:
@pytest.mark.django_db                    # Tests requiring database
@pytest.mark.django_db(transaction=True)  # Tests requiring transaction control
@pytest.mark.asyncio                      # Async tests
@pytest.mark.slow                         # Long-running tests (>2s)
@pytest.mark.integration                  # Integration tests (external services)
@pytest.mark.stripe                       # Stripe-specific tests
@pytest.mark.celery                       # Celery task tests
\`\`\`

### 10. Stripe Mock Helpers

Generate a \`tests/helpers/stripe_mocks.py\` utility:
\`\`\`python
class StripeMock:
    """Factory for Stripe API response objects used in tests."""

    @staticmethod
    def subscription(status="active", **overrides): ...

    @staticmethod
    def customer(**overrides): ...

    @staticmethod
    def invoice(status="paid", **overrides): ...

    @staticmethod
    def invoice_list(count=1): ...

    @staticmethod
    def webhook_event(type: str, data: dict): ...

    @staticmethod
    def price(interval="month", amount=2999): ...
\`\`\`

## Output Format

Generate the following files (output each with its full path as a header):

1. \`tests/[APP_NAME]/conftest.py\` — Factories, fixtures, shared helpers
2. \`tests/[APP_NAME]/test_models.py\` — Model tests
3. \`tests/[APP_NAME]/test_services.py\` — Service layer tests
4. \`tests/[APP_NAME]/test_views.py\` — API endpoint tests
5. \`tests/[APP_NAME]/test_tasks.py\` — Celery task tests (if app has tasks)
6. \`tests/[APP_NAME]/test_webhooks.py\` — Webhook tests (if applicable)
7. \`tests/[APP_NAME]/test_permissions.py\` — RBAC tests
8. \`tests/helpers/stripe_mocks.py\` — Stripe mock helpers (if billing-related)

For each test file:
- Include module docstring explaining what is tested
- Group tests into classes by feature/function
- Use descriptive test names: \`test_<action>_<scenario>_<expected_result>\`
- Add brief docstrings for non-obvious tests
- Aim for 85%+ coverage of the target module
- Every test must be independent — no test ordering dependencies
- Use \`pytest.mark.parametrize\` for testing multiple input variations
- All external calls (Stripe, email, HTTP) must be mocked

## Validation Checklist

Before outputting, verify:
- [ ] All factories set tenant context
- [ ] No raw \`Model.objects.create()\` — use factories
- [ ] All Stripe calls are mocked
- [ ] Tenant isolation is tested (cross-tenant access denied)
- [ ] Idempotency is tested for tasks and webhooks
- [ ] Error paths are tested, not just happy paths
- [ ] Async code uses \`pytest.mark.asyncio\`
- [ ] No hardcoded IDs or timestamps — use factories and \`freezegun\` if needed
- [ ] Tests can run in parallel (\`pytest-xdist\` safe — no shared mutable state)
- [ ] Type hints on all test helper functions

Generate the complete test suite now.
\`\`\`

---

## Usage

1. Replace all \`[PLACEHOLDERS]\` with your specific module details
2. Paste the prompt into Claude Code
3. Review generated tests against the validation checklist
4. Run the suite:

\`\`\`bash
# Run tests for the specific app
uv run pytest tests/[APP_NAME]/ -v --tb=short

# Run with coverage
uv run pytest tests/[APP_NAME]/ --cov=src/[APP_NAME] --cov-report=term-missing --cov-fail-under=85

# Run only fast unit tests (exclude integration/slow)
uv run pytest tests/[APP_NAME]/ -v -m "not slow and not integration"

# Run in parallel
uv run pytest tests/[APP_NAME]/ -n auto
\`\`\`

4. Fix any failures, then commit:

\`\`\`bash
git add tests/
git commit -m "test(APP_NAME): add comprehensive test suite for MODULE_DESCRIPTION"
\`\`\`

---

## Example Invocations

### Billing Module

Replace placeholders with:
- **Django app**: \`billing\`
- **File(s) under test**: \`src/billing/services.py\`, \`src/billing/webhooks.py\`, \`src/billing/tasks.py\`
- **Functionality**: Stripe subscription lifecycle, webhook processing, invoice sync
- **Dependencies to mock**: \`stripe.Subscription\`, \`stripe.Customer\`, \`stripe.Invoice\`, \`stripe.Webhook\`, Celery tasks

### Tenants Module

Replace placeholders with:
- **Django app**: \`tenants\`
- **File(s) under test**: \`src/tenants/services.py\`, \`src/tenants/middleware.py\`, \`src/tenants/managers.py\`
- **Functionality**: Tenant provisioning, middleware tenant resolution, row-level security manager
- **Dependencies to mock**: DNS lookups, cache (Redis)

### Accounts Module

Replace placeholders with:
- **Django app**: \`accounts\`
- **File(s) under test**: \`src/accounts/services.py\`, \`src/accounts/views.py\`
- **Functionality**: User registration, authentication, role assignment, GDPR data export/deletion
- **Dependencies to mock**: Email sending (SES), Celery tasks

---

## Related Prompts

- \`playbook/prompts/04/feature-implementation.md\` — Generate the code these tests cover
- \`playbook/prompts/05/security-hardening.md\` — Security tests for auth and tenant isolation
- \`playbook/prompts/05/integration-adapter.md\` — Integration tests for Stripe adapter layer

## Related Phase

See \`playbook/phases/06-testing-quality.md\` for the full Phase 06 testing strategy, coverage gates, and quality metrics.`,

  'playbook/prompts/07/go-live-checklist.md': `# Go-Live Checklist — Phase 07 Launch

> Copy-paste this prompt into Claude Code when preparing the django-saas-platform for production launch.

---

## Prompt

You are helping launch **django-saas-platform**, a multi-tenant Django 5.0 SaaS application with Stripe billing, Celery task processing, and PostgreSQL row-level security. We are in **Phase 07 — Launch** and need a comprehensive go-live checklist with automated verification where possible.

### Project Context

- **Stack**: Django 5.0, DRF, Strawberry GraphQL, Celery 5, Redis, PostgreSQL 16, Stripe
- **Infrastructure**: AWS (ECS, RDS, ElastiCache, S3, SES, CloudFront), Terraform, Docker
- **Multi-tenancy**: Row-level security in PostgreSQL, tenant-aware managers in \`src/core/\`
- **Billing**: Stripe subscriptions, usage metering, webhook processing in \`src/billing/\`
- **Auth**: Role-based access control in \`src/accounts/\`, tenant association
- **Compliance**: SOC 2, GDPR
- **CI/CD**: GitHub Actions → Staging auto-deploy → Manual production deploy
- **Monitoring**: Sentry, Prometheus, Grafana

### Task

Generate the following artifacts for production go-live:

---

### 1. Pre-Launch Verification Script

Create \`scripts/go_live_check.py\` — a Django management command that programmatically verifies production readiness:

\`\`\`python
# Run with: uv run python manage.py go_live_check --environment production
\`\`\`

The command must check and report pass/fail for each item:

**Infrastructure & Configuration:**
- \`DEBUG\` is \`False\`
- \`ALLOWED_HOSTS\` is explicitly set (not \`*\`)
- \`SECRET_KEY\` is not the default/development value (minimum 50 chars, high entropy)
- \`SECURE_SSL_REDIRECT\` is \`True\`
- \`SECURE_HSTS_SECONDS\` >= 31536000 (1 year)
- \`SECURE_HSTS_INCLUDE_SUBDOMAINS\` is \`True\`
- \`SECURE_HSTS_PRELOAD\` is \`True\`
- \`SESSION_COOKIE_SECURE\` is \`True\`
- \`CSRF_COOKIE_SECURE\` is \`True\`
- \`SESSION_COOKIE_HTTPONLY\` is \`True\`
- \`CSRF_COOKIE_HTTPONLY\` is \`True\`
- \`X_FRAME_OPTIONS\` is \`DENY\`
- \`SECURE_CONTENT_TYPE_NOSNIFF\` is \`True\`
- \`SECURE_BROWSER_XSS_FILTER\` is \`True\`
- Database connection uses SSL (\`sslmode=require\` or \`verify-full\`)
- Database is PostgreSQL 16+ (verify version)
- Redis connection uses TLS for ElastiCache
- \`CONN_MAX_AGE\` is set (not 0 for production)
- Static files are served via CloudFront (check \`STATIC_URL\` starts with \`https://\`)
- Media files use S3 backend (check \`DEFAULT_FILE_STORAGE\`)
- Email backend is SES (not console or file backend)
- \`ADMINS\` setting is populated for error emails

**Multi-Tenancy:**
- Row-level security policies exist on all tenant-scoped tables (query \`pg_policies\`)
- \`TenantMiddleware\` is in \`MIDDLEWARE\` list
- Default tenant-aware manager is set on all models in \`src/tenants/\`, \`src/billing/\`, \`src/accounts/\`, \`src/notifications/\`
- No raw SQL queries bypass tenant filtering (scan for \`.raw(\` and \`.extra(\` usage — warn if found)
- Cross-tenant data leak test: attempt to query another tenant's data through the ORM and verify it returns empty

**Stripe & Billing:**
- \`STRIPE_SECRET_KEY\` starts with \`sk_live_\` (not \`sk_test_\`)
- \`STRIPE_PUBLISHABLE_KEY\` starts with \`pk_live_\`
- \`STRIPE_WEBHOOK_SECRET\` starts with \`whsec_\`
- Stripe webhook endpoint is registered and reachable (call Stripe API to list webhook endpoints)
- All expected webhook event types are subscribed: \`customer.subscription.created\`, \`customer.subscription.updated\`, \`customer.subscription.deleted\`, \`invoice.paid\`, \`invoice.payment_failed\`, \`payment_intent.succeeded\`, \`payment_intent.payment_failed\`, \`customer.updated\`, \`checkout.session.completed\`
- Stripe webhook signature verification is enabled in \`src/billing/views.py\`
- At least one Stripe product and price exist in live mode
- Billing models have proper indexes for \`stripe_customer_id\`, \`stripe_subscription_id\`

**Celery & Task Processing:**
- Celery worker can connect to Redis broker
- Celery beat scheduler is configured and running
- Critical periodic tasks are registered: \`sync_stripe_subscriptions\`, \`cleanup_expired_sessions\`, \`generate_usage_reports\`, \`send_billing_reminders\`
- All Celery tasks in \`src/tasks/\` have \`acks_late=True\` and \`reject_on_worker_lost=True\`
- Dead letter queue is configured for failed tasks
- Task result backend is configured (not disabled)

**Database & Migrations:**
- No unapplied migrations (\`showmigrations\` check)
- Database indexes exist for all foreign keys and commonly queried fields
- \`pg_stat_statements\` extension is enabled for query monitoring
- Connection pooling is configured (PgBouncer or Django \`CONN_MAX_AGE\`)
- Database backup is configured and last backup is < 24 hours old (check RDS automated backups)

**Authentication & Security:**
- Password validation is configured with minimum 4 validators
- Account lockout is enabled after failed login attempts
- JWT/token expiry is set to reasonable values (access: ≤ 15 min, refresh: ≤ 7 days)
- CORS is configured with explicit allowed origins (not \`*\`)
- Rate limiting is enabled on auth endpoints (\`/api/auth/login/\`, \`/api/auth/register/\`, \`/api/auth/password-reset/\`)
- API throttle rates are set in DRF settings
- Admin URL is not \`/admin/\` (customized path)
- Django admin has 2FA or IP restriction

**Observability:**
- Sentry DSN is configured and reachable (send test event)
- Sentry environment is set to \`production\`
- Sentry release tracking is configured with git SHA
- Prometheus metrics endpoint is available at \`/metrics/\`
- Health check endpoint returns 200 at \`/api/health/\`
- Structured logging is configured (JSON format for production)
- Log level is \`WARNING\` or above for production (not \`DEBUG\`)
- Audit logging is enabled for all write operations on sensitive models

**GDPR & Compliance:**
- Privacy policy URL is configured and returns 200
- Cookie consent mechanism is enabled
- Data export endpoint exists (\`/api/accounts/me/export/\`)
- Account deletion endpoint exists (\`/api/accounts/me/delete/\`)
- PII fields are identified and encrypted at rest (check for \`EncryptedField\` usage)
- Audit log retention policy is configured (default: 2 years for SOC 2)
- Data processing agreement (DPA) template exists in \`docs/compliance/\`
- Tenant data residency configuration is available

**API & Documentation:**
- OpenAPI schema generates without errors (\`uv run python manage.py spectacular --validate\`)
- API versioning is configured (URL or header-based)
- Deprecation headers are set on any deprecated endpoints
- Rate limit headers are included in API responses (\`X-RateLimit-Limit\`, \`X-RateLimit-Remaining\`)

Output format: table with Category, Check, Status (✅ PASS / ❌ FAIL / ⚠️ WARN), and Details. Return exit code 1 if any critical check fails.

---

### 2. Production Deployment Runbook

Create \`docs/runbooks/production-deploy.md\` with step-by-step instructions:

1. **Pre-deployment** — run \`go_live_check\`, verify staging is green, confirm rollback plan
2. **Database migrations** — run in a maintenance window if destructive, use \`--plan\` flag first
3. **Infrastructure** — Terraform apply sequence (RDS → ElastiCache → ECS → CloudFront)
4. **Application deployment** — ECS service update with rolling deployment, health check grace period
5. **Celery workers** — graceful restart strategy (drain current tasks, deploy new workers, terminate old)
6. **Stripe webhook** — verify endpoint is receiving events, check Stripe dashboard for failures
7. **DNS cutover** — CloudFront distribution, Route 53 health checks, TTL considerations
8. **Post-deployment verification** — smoke tests, first tenant creation, subscription flow, email delivery
9. **Rollback procedure** — ECS task definition rollback, database migration reversal, feature flags

Include specific commands for each step using \`uv run\`, \`terraform\`, \`aws ecs\`, \`celery\`, and \`curl\`.

---

### 3. Smoke Test Suite

Create \`tests/smoke/test_production_smoke.py\` — a pytest suite that runs against the live production URL:

\`\`\`python
# Run with: SMOKE_TEST_URL=https://app.example.com uv run pytest tests/smoke/ -v --tb=short
\`\`\`

Test the following critical paths:
- Health endpoint returns 200 with database and Redis connectivity status
- OpenAPI schema endpoint returns valid JSON
- Unauthenticated requests to protected endpoints return 401
- Login flow returns valid JWT tokens
- Tenant creation and isolation (create tenant A, create tenant B, verify A cannot see B's data)
- Stripe checkout session creation returns a valid URL
- Stripe webhook endpoint accepts signed payloads and rejects unsigned ones
- Celery task submission returns a task ID (via API endpoint that triggers async work)
- Static assets are served with correct cache headers from CloudFront
- CORS headers are present on API responses
- Security headers are present (HSTS, X-Frame-Options, X-Content-Type-Options)
- GraphQL endpoint accepts introspection query (or rejects it if disabled in production)
- Rate limiting triggers after threshold on auth endpoints
- GDPR data export endpoint returns 202 Accepted and queues a Celery task

---

### 4. Launch Day Communication Template

Create \`docs/runbooks/launch-day-comms.md\` with:
- Slack channel notification templates for each deployment phase
- Incident escalation matrix (who to contact for billing issues, infrastructure, data issues)
- Status page update templates (using a generic status page format)
- Customer communication template for the first tenant onboarding
- Rollback decision criteria (error rate > 5%, p99 latency > 2s, Stripe webhook failure rate > 1%)

---

### 5. Post-Launch Monitoring Dashboard Config

Create \`docs/runbooks/grafana-dashboards.md\` describing the Prometheus queries for a launch-day Grafana dashboard:

- Request rate by endpoint (p50, p95, p99 latency)
- Error rate by HTTP status code (4xx, 5xx)
- Active tenant count and requests per tenant
- Stripe webhook processing latency and success rate
- Celery task queue depth, processing time, failure rate
- PostgreSQL connection pool utilization
- Redis memory usage and hit rate
- ECS task count and CPU/memory utilization
- RDS read/write IOPS and replication lag

---

### Constraints

- All scripts must use type hints on public functions
- Follow conventional commits for any generated files
- Use \`uv run\` as the command prefix for all Python/Django commands
- Stripe keys must never be logged or printed — mask them in output (\`sk_live_...xxxx\`)
- The go-live check must be runnable in CI as a gate before production deploy
- All file paths must match the project structure defined in the project layout
- Mark any generated code with \`# Generated by Claude Code — review before production use\`
- Keep each file under 300 lines; split if necessary

### References

- Phase definition: \`playbook/phases/07-launch.md\`
- Security hardening: \`playbook/prompts/05/security-hardening.md\`
- Observability setup: \`playbook/prompts/05/observability-setup.md\`
- Load testing: \`playbook/prompts/06/load-test.md\`
- CI pipeline: \`playbook/prompts/03/ci-pipeline.md\`
- Infrastructure: \`playbook/prompts/03/iac-setup.md\``,

  'playbook/prompts/07/monitoring-setup.md': `# Monitoring Setup — Phase 07 Launch Prompt

> Copy-paste this prompt into Claude Code to set up production monitoring, alerting, and dashboards for the django-saas-platform.

---

## Prompt

\`\`\`
You are working on the django-saas-platform — a multi-tenant Django 5.0 SaaS application with Celery, Stripe billing, PostgreSQL with row-level security, and Redis. The platform runs on AWS ECS with RDS, ElastiCache, and CloudFront.

Set up comprehensive production monitoring, alerting, and dashboards. This is a SOC 2 and GDPR-compliant SaaS platform serving multiple tenants, so monitoring must cover tenant isolation, billing integrity, and data security.

## 1. Django Health Check Endpoint

Create \`src/core/views/health.py\`:

- Implement a \`/healthz\` endpoint (unauthenticated, excluded from middleware) returning JSON with:
  - \`status\`: "healthy" | "degraded" | "unhealthy"
  - \`version\`: from \`config.settings.VERSION\`
  - \`timestamp\`: ISO 8601 UTC
  - Component checks:
    - \`database\`: PostgreSQL connectivity + simple query (\`SELECT 1\`)
    - \`redis\`: Redis ping on both cache and Celery broker connections
    - \`celery\`: Check Celery inspect ping (with 3-second timeout)
    - \`stripe\`: Verify Stripe API key is valid (cached, check every 5 minutes)
    - \`migrations\`: All migrations applied (\`MigrationExecutor.migration_plan\` is empty)
    - \`disk\`: Sufficient disk space (>10% free)
  - Each component reports: \`status\`, \`response_time_ms\`, optional \`details\`
  - Overall status is "unhealthy" if database or redis fails, "degraded" if celery or stripe fails
- Implement a \`/readyz\` endpoint for Kubernetes readiness (database + redis only, fast)
- Implement a \`/livez\` endpoint for Kubernetes liveness (always 200 unless process is stuck)
- Add rate limiting: 60 requests/minute per IP on health endpoints
- Register in \`src/core/urls.py\`
- Add tests in \`tests/core/test_health.py\` using pytest-django

## 2. Prometheus Metrics with django-prometheus

Create \`src/core/metrics.py\`:

- Configure django-prometheus with custom metrics:
  - **Request metrics** (auto via middleware):
    - \`http_requests_total\` (method, endpoint, status, tenant_id)
    - \`http_request_duration_seconds\` histogram
  - **Business metrics** (custom):
    - \`saas_active_tenants_total\` gauge
    - \`saas_active_subscriptions_total\` gauge (by plan tier)
    - \`saas_mrr_cents\` gauge (monthly recurring revenue)
    - \`saas_subscription_events_total\` counter (event_type: created, upgraded, downgraded, churned, renewed)
    - \`saas_tenant_api_requests_total\` counter (tenant_id, endpoint)
    - \`saas_tenant_usage_units_total\` counter (tenant_id, metric_name) — for usage-based billing
    - \`saas_onboarding_funnel_total\` counter (step: signup, verify_email, create_tenant, first_api_call)
  - **Celery task metrics**:
    - \`celery_tasks_total\` counter (task_name, state: started, succeeded, failed, retried)
    - \`celery_task_duration_seconds\` histogram (task_name)
    - \`celery_queue_length\` gauge (queue_name)
    - \`celery_active_workers\` gauge
  - **Stripe/Billing metrics**:
    - \`stripe_webhook_events_total\` counter (event_type, status: processed, failed, duplicate)
    - \`stripe_webhook_processing_seconds\` histogram
    - \`stripe_api_calls_total\` counter (endpoint, status_code)
    - \`stripe_api_latency_seconds\` histogram
  - **Database metrics**:
    - \`db_connection_pool_size\` gauge
    - \`db_query_duration_seconds\` histogram (operation: select, insert, update, delete)
    - \`db_tenant_row_count\` gauge (tenant_id, table) — sampled periodically
  - **Security metrics**:
    - \`auth_login_attempts_total\` counter (result: success, failure, locked)
    - \`auth_token_refresh_total\` counter
    - \`rbac_permission_denied_total\` counter (tenant_id, resource)
    - \`tenant_cross_access_attempts_total\` counter — CRITICAL alert trigger
  - **Cache metrics**:
    - \`redis_cache_hits_total\` counter
    - \`redis_cache_misses_total\` counter
    - \`redis_cache_hit_ratio\` gauge

- Create a Celery beat task \`tasks.metrics.collect_business_metrics\` that runs every 60 seconds to update gauge values (active tenants, MRR, subscription counts, queue lengths)
- Create a Celery beat task \`tasks.metrics.collect_security_metrics\` that runs every 30 seconds to check for anomalies

Update \`config/settings/base.py\`:
- Add \`django_prometheus\` to INSTALLED_APPS
- Add prometheus middleware (first and last in MIDDLEWARE)
- Configure \`/metrics\` endpoint (restrict to internal network via IP allowlist)

## 3. Sentry Integration

Create \`src/core/sentry.py\`:

- Configure Sentry SDK with:
  - \`traces_sample_rate\`: 0.1 in production, 1.0 in staging
  - \`profiles_sample_rate\`: 0.1 in production
  - Django integration with \`transaction_style="url"\`
  - Celery integration with \`monitor_beat_tasks=True\`
  - Redis integration
  - SQLAlchemy/Django DB integration for query tracking
  - \`send_default_pii=False\` (GDPR compliance)
  - Custom \`before_send\` callback that:
    - Strips tenant PII (email, name) from error payloads
    - Adds \`tenant_id\` tag from request context
    - Adds \`subscription_plan\` tag
    - Filters out expected exceptions (Http404, PermissionDenied, RateLimited)
    - Redacts Stripe API keys, webhook secrets from breadcrumbs
  - Custom \`before_send_transaction\` that:
    - Drops health check transactions (\`/healthz\`, \`/readyz\`, \`/livez\`)
    - Adds tenant_id and user_role tags
  - Environment-based DSN from \`SENTRY_DSN\` env var
  - Release tracking from \`GIT_SHA\` env var
  - Custom fingerprinting for Stripe webhook errors (group by event_type)
  - Cron monitor for Celery beat tasks (billing sync, report generation, cleanup)

- Create \`src/core/middleware/sentry_context.py\`:
  - Middleware that sets Sentry scope with tenant_id, user_id, subscription_plan, user_role
  - Must run after tenant middleware and auth middleware

## 4. Structured Logging

Create \`src/core/logging.py\`:

- Configure structlog with JSON output for production:
  - Processors: add_log_level, TimeStamper(fmt="iso"), StackInfoRenderer, format_exc_info, JSONRenderer
  - Bind context: \`tenant_id\`, \`user_id\`, \`request_id\`, \`correlation_id\`
  - Custom processor to redact sensitive fields: password, token, secret, api_key, credit_card
  - Custom processor to add \`environment\`, \`service\`, \`version\` to every log line
- Configure stdlib logging to route through structlog
- Django logging config in settings:
  - \`django.request\`: WARNING
  - \`django.security\`: INFO
  - \`celery\`: INFO
  - \`stripe\`: INFO
  - \`src.billing\`: INFO
  - \`src.tenants\`: INFO
  - \`src.core.security\`: INFO (audit events)
- Log format for CloudWatch compatibility (single-line JSON)
- Create \`src/core/middleware/request_logging.py\`:
  - Log every request: method, path, status, duration_ms, tenant_id, user_id, ip (hashed for GDPR)
  - Log slow requests (>1s) at WARNING level
  - Log very slow requests (>5s) at ERROR level
  - Skip health check endpoints
  - Add \`X-Request-ID\` header (generate UUID if not present)

## 5. Grafana Dashboards (as JSON provisioning files)

Create \`monitoring/grafana/dashboards/\`:

### \`platform-overview.json\`:
- Panels:
  - Request rate (req/s) by status code
  - P50/P95/P99 latency
  - Error rate (5xx / total)
  - Active tenants (gauge)
  - MRR (gauge, formatted as currency)
  - Subscription distribution by plan (pie chart)
  - Onboarding funnel (bar chart)
  - Top 10 tenants by API usage

### \`celery-tasks.json\`:
- Panels:
  - Task throughput by task name
  - Task success/failure rate
  - Task duration P50/P95/P99 by task name
  - Queue depth by queue
  - Active workers
  - Failed tasks table (last 24h)
  - Retry rate by task

### \`billing-stripe.json\`:
- Panels:
  - Webhook event rate by type
  - Webhook processing latency
  - Webhook failure rate (alert threshold)
  - Stripe API call rate and latency
  - Subscription lifecycle events (created, churned, upgraded)
  - MRR trend (7-day, 30-day)
  - Failed payment attempts
  - Revenue by plan tier

### \`tenant-health.json\`:
- Panels:
  - Per-tenant API request rate (variable: tenant_id)
  - Per-tenant error rate
  - Per-tenant usage metrics
  - Per-tenant response latency
  - Tenant data row counts
  - Cross-tenant access attempts (should be 0)

### \`security-audit.json\`:
- Panels:
  - Login attempt rate (success vs failure)
  - Permission denied events
  - Cross-tenant access attempts (CRITICAL)
  - Token refresh rate
  - Rate limit hits
  - Suspicious IP activity
  - Audit log event stream

Create \`monitoring/grafana/provisioning/dashboards.yml\` to auto-load these dashboards.

## 6. Alerting Rules

Create \`monitoring/prometheus/alerts/\`:

### \`platform.rules.yml\`:
\`\`\`yaml
groups:
  - name: platform
    rules:
      - alert: HighErrorRate
        expr: rate(http_requests_total{status=~"5.."}[5m]) / rate(http_requests_total[5m]) > 0.05
        for: 5m
        labels:
          severity: critical
        annotations:
          summary: "Error rate above 5% for 5 minutes"

      - alert: HighLatencyP99
        expr: histogram_quantile(0.99, rate(http_request_duration_seconds_bucket[5m])) > 2
        for: 5m
        labels:
          severity: warning

      - alert: HealthCheckFailing
        expr: up{job="django-saas"} == 0
        for: 2m
        labels:
          severity: critical
\`\`\`

### \`billing.rules.yml\`:
- StripeWebhookFailureRate: >5% failures over 10 minutes → critical
- StripeWebhookBacklog: processing time >30s → warning
- StripeAPIErrors: >10 errors in 5 minutes → warning
- SubscriptionSyncLag: billing sync task not completed in 1 hour → critical
- PaymentFailureSpike: >20% increase in payment failures → warning
- MRRDropAlert: MRR decreased >5% in 24 hours → critical

### \`celery.rules.yml\`:
- CeleryWorkerDown: no active workers for 5 minutes → critical
- CeleryQueueBacklog: queue depth >1000 for 10 minutes → warning
- CeleryTaskFailureRate: >10% failure rate for any task → warning
- CeleryBeatMissed: scheduled task not executed within 2x expected interval → critical
- BillingTaskFailed: any billing-related task failure → critical (page)

### \`security.rules.yml\`:
- CrossTenantAccessAttempt: any cross-tenant access → critical (page immediately)
- BruteForceDetected: >20 failed logins from same IP in 5 minutes → warning
- PermissionDeniedSpike: >50 permission denied in 5 minutes → warning
- AuditLogGap: no audit log entries for 15 minutes → warning (SOC 2)
- SuspiciousAPIPattern: single tenant >10x normal request rate → warning

### \`infrastructure.rules.yml\`:
- DatabaseConnectionPoolExhausted: >90% pool utilization → critical
- RedisMemoryHigh: >80% memory usage → warning
- DiskSpaceLow: <15% free → warning, <5% free → critical
- CertificateExpiringSoon: SSL cert expires in <14 days → warning
- ECSTaskUnhealthy: ECS task failing health checks → critical

## 7. Alertmanager Configuration

Create \`monitoring/alertmanager/alertmanager.yml\`:

- Route critical alerts to PagerDuty (billing, security, infrastructure)
- Route warning alerts to Slack #saas-platform-alerts
- Route security alerts to Slack #security-incidents AND PagerDuty
- Group alerts by \`alertname\` and \`severity\`
- Repeat interval: 4 hours for warnings, 30 minutes for critical
- Silence health check alerts during maintenance windows
- Inhibit warning when critical is already firing for same component
- Receivers:
  - \`slack-warnings\`: Slack webhook with formatted message (include runbook link)
  - \`slack-security\`: Slack webhook to #security-incidents
  - \`pagerduty-critical\`: PagerDuty integration key from env
  - \`pagerduty-billing\`: Separate PagerDuty service for billing issues

## 8. AWS CloudWatch Integration

Create \`monitoring/cloudwatch/\`:

### \`log-groups.tf\` (Terraform):
- Log group for Django application logs: \`/ecs/django-saas/app\`
- Log group for Celery worker logs: \`/ecs/django-saas/celery\`
- Log group for Celery beat logs: \`/ecs/django-saas/beat\`
- Retention: 90 days (SOC 2 requirement)
- KMS encryption for log groups containing tenant data

### \`metric-filters.tf\`:
- Extract custom metrics from structured logs:
  - \`TenantAPIRequests\` from request logs
  - \`StripeWebhookErrors\` from billing logs
  - \`AuthFailures\` from security logs
  - \`SlowQueries\` from database logs (>500ms)
  - \`CrossTenantViolations\` from security logs

### \`alarms.tf\`:
- CloudWatch alarms mirroring Prometheus alerts (defense in depth)
- SNS topic for alarm notifications
- Auto-scaling triggers based on request rate and queue depth

## 9. Uptime Monitoring

Create \`monitoring/uptime/checks.yml\`:

- Define external uptime checks (for AWS Route 53 Health Checks or similar):
  - \`https://api.example.com/healthz\` — every 30s, 3 regions
  - \`https://api.example.com/readyz\` — every 60s, 2 regions
  - \`https://api.example.com/api/v1/status\` — every 60s (authenticated)
  - Stripe webhook endpoint reachability
- Expected response: 200, body contains \`"status":"healthy"\`
- Alert if down for >2 minutes
- Status page integration (Statuspage.io or similar)

## 10. Audit Logging for SOC 2

Create \`src/core/audit.py\`:

- Audit logger that records to both database and structured logs:
  - \`event_type\`: login, logout, permission_change, data_access, data_export, config_change, billing_event
  - \`actor_id\`, \`actor_email\` (hashed), \`actor_role\`
  - \`tenant_id\`
  - \`resource_type\`, \`resource_id\`
  - \`action\`: create, read, update, delete
  - \`ip_address\` (hashed for GDPR)
  - \`user_agent\`
  - \`changes\`: JSON diff for updates (redact sensitive fields)
  - \`timestamp\`: UTC ISO 8601
  - \`request_id\`: correlation with request logs
- Audit log model in \`src/core/models/audit.py\` with:
  - Immutable records (no update/delete at Django ORM level)
  - Database-level protection (revoke UPDATE/DELETE on audit table)
  - Partitioned by month for performance
  - Tenant-scoped queries
- Decorator \`@audit_log(event_type="data_access")\` for views
- Signal-based audit for model changes on sensitive models (User, Tenant, Subscription, Role)
- Celery task to archive audit logs older than 1 year to S3 (SOC 2 retention)

## 11. Docker Compose for Local Monitoring Stack

Create \`monitoring/docker-compose.yml\`:

- Services:
  - Prometheus (with config from \`monitoring/prometheus/\`)
  - Grafana (with provisioned dashboards and datasources)
  - Alertmanager (with config from \`monitoring/alertmanager/\`)
  - Redis Exporter (for Redis metrics)
  - PostgreSQL Exporter (for database metrics)
  - Node Exporter (for host metrics)
- Volumes for persistent data
- Network shared with main application docker-compose
- Grafana pre-configured with Prometheus datasource
- Default credentials in \`.env.monitoring.example\`

## 12. Monitoring Tests

Create \`tests/core/test_monitoring.py\`:

- Test health endpoint returns correct structure
- Test health endpoint reports degraded when Redis is down (mock)
- Test health endpoint reports unhealthy when database is down (mock)
- Test Prometheus metrics endpoint is accessible
- Test custom business metrics are registered
- Test audit log creation and immutability
- Test sensitive field redaction in logs
- Test request logging middleware adds X-Request-ID
- Test Sentry before_send strips PII
- Test cross-tenant access metric increments

## Constraints

- All monitoring code must NOT log or expose tenant PII (GDPR)
- Prometheus /metrics endpoint must be restricted to internal network
- Audit logs must be immutable (SOC 2)
- Health checks must not require authentication
- Health checks must have their own rate limiting
- All Celery metric collection tasks must be idempotent
- Dashboard JSON must be valid Grafana 10.x format
- Alert rules must include runbook_url annotation pointing to docs/runbooks/
- Use tenant-aware managers for any metric that queries tenant data
- Stripe API keys and webhook secrets must never appear in logs or metrics
- Hash IP addresses in logs and audit records for GDPR compliance
- Log retention: 90 days in CloudWatch, 1 year in audit DB, archive to S3 after

## File Structure Expected

\`\`\`
src/core/views/health.py
src/core/metrics.py
src/core/sentry.py
src/core/logging.py
src/core/audit.py
src/core/models/audit.py
src/core/middleware/sentry_context.py
src/core/middleware/request_logging.py
src/tasks/metrics.py
config/settings/monitoring.py          # monitoring-specific settings
monitoring/
  docker-compose.yml
  prometheus/
    prometheus.yml
    alerts/
      platform.rules.yml
      billing.rules.yml
      celery.rules.yml
      security.rules.yml
      infrastructure.rules.yml
  alertmanager/
    alertmanager.yml
  grafana/
    provisioning/
      dashboards.yml
      datasources.yml
    dashboards/
      platform-overview.json
      celery-tasks.json
      billing-stripe.json
      tenant-health.json
      security-audit.json
  cloudwatch/
    log-groups.tf
    metric-filters.tf
    alarms.tf
  uptime/
    checks.yml
tests/core/test_health.py
tests/core/test_monitoring.py
\`\`\`

After generating, verify:
- \`uv run ruff check src/core/views/health.py src/core/metrics.py src/core/sentry.py src/core/logging.py src/core/audit.py\`
- \`uv run mypy src/core/views/health.py src/core/metrics.py src/core/sentry.py src/core/logging.py src/core/audit.py\`
- \`uv run pytest tests/core/test_health.py tests/core/test_monitoring.py -v\`
- Validate Prometheus alert rules: \`promtool check rules monitoring/prometheus/alerts/*.yml\`
- Validate Alertmanager config: \`amtool check-config monitoring/alertmanager/alertmanager.yml\`
- Validate Grafana dashboard JSON is parseable
- Verify /healthz, /readyz, /livez endpoints respond correctly in local dev
- Confirm no PII appears in any log output or metric labels
\`\`\`

---

## Usage

1. Copy the prompt above into Claude Code
2. Claude will generate the full monitoring stack across all listed files
3. Review security-sensitive files: \`src/core/audit.py\`, \`src/core/sentry.py\`, alert rules
4. Validate Prometheus/Alertmanager configs with their respective CLI tools
5. Start local monitoring stack: \`docker compose -f monitoring/docker-compose.yml up -d\`
6. Access Grafana at \`http://localhost:3000\` and verify dashboards load
7. Hit \`/healthz\` and confirm all components report healthy
8. Verify \`/metrics\` is not accessible from public network

## Cross-References

- **Observability foundation**: \`playbook/prompts/05/observability-setup.md\` (initial setup this builds upon)
- **Runbooks**: \`playbook/prompts/07/runbook-generator.md\` (alert runbook_url annotations link here)
- **Go-live checklist**: \`playbook/prompts/07/go-live-checklist.md\` (monitoring is a launch gate)
- **Security hardening**: \`playbook/prompts/05/security-hardening.md\` (security alerts and audit logging)
- **Stripe integration**: \`playbook/prompts/05/integration-adapter.md\` (billing metrics source)
- **Load testing**: \`playbook/prompts/06/load-test.md\` (use dashboards to observe load test results)
- **Infrastructure**: \`playbook/prompts/03/iac-setup.md\` (CloudWatch Terraform resources)
- **CI pipeline**: \`playbook/prompts/03/ci-pipeline.md\` (add promtool/amtool validation to CI)

## SOC 2 Compliance Notes

- Audit logs are immutable and retained for 1 year minimum
- All access to tenant data is logged with actor, action, and timestamp
- Alert on audit log gaps (indicates potential tampering or system failure)
- Cross-tenant access attempts trigger immediate alerts
- Log retention policies enforced via CloudWatch and S3 lifecycle rules
- Monitoring infrastructure itself is monitored (meta-monitoring via uptime checks)

## GDPR Compliance Notes

- No PII in Prometheus metric labels (tenant_id is opaque UUID, not name/email)
- Sentry \`send_default_pii=False\` — custom before_send strips remaining PII
- IP addresses are hashed (SHA-256 with rotating salt) in all logs and audit records
- Structured log redaction processor removes passwords, tokens, API keys
- Audit log \`actor_email\` is stored as a one-way hash
- Log retention limited to 90 days for operational logs (right to deletion compatible)`,

  'playbook/prompts/07/runbook-generator.md': `# Runbook Generator — Phase 07 (Launch)

## Prompt: Generate Operational Runbooks for Django SaaS Platform

Copy and paste the following prompt into Claude Code:

---

You are generating operational runbooks for **django-saas-platform**, a multi-tenant Django 5.0 SaaS application with Celery task processing, Stripe billing, PostgreSQL with row-level security, and Redis caching. The platform runs on AWS (ECS, RDS, ElastiCache, S3, SES, CloudFront) orchestrated with Kubernetes and Terraform.

Compliance requirements: **SOC 2** and **GDPR**.

Generate a complete set of runbooks in \`docs/runbooks/\`. Each runbook must follow this structure:

\`\`\`markdown
# Runbook: <Title>
## Severity: P1 / P2 / P3 / P4
## Last Updated: YYYY-MM-DD
## Owner: @team-or-person

### Summary
One-paragraph description of the scenario and when this runbook applies.

### Detection
- How the issue is detected (Sentry alert, Prometheus metric, Grafana dashboard, health check, customer report)
- Specific alert names and thresholds

### Impact Assessment
- Affected tenants (single tenant vs all tenants)
- Affected services (API, billing, task queue, notifications)
- Data integrity risk
- SLA implications

### Prerequisites
- Required access (AWS Console, kubectl, database credentials, Stripe dashboard)
- Required tools installed locally

### Step-by-Step Resolution
Numbered steps with exact commands. Use \`uv run python manage.py ...\`, \`kubectl\`, \`aws cli\`, \`celery\`, \`redis-cli\` as appropriate.

### Verification
How to confirm the issue is resolved.

### Post-Incident
- Communication template (Slack #incidents, status page)
- Incident report requirements (SOC 2 compliance)
- Follow-up action items

### Escalation Path
Who to contact if resolution fails, with timezone coverage (Europe + Americas).
\`\`\`

---

### Runbooks to Generate

Create the following files:

#### 1. \`docs/runbooks/deployment.md\` — Production Deployment Procedure

Cover the full deployment lifecycle for django-saas-platform:

- Pre-deployment checklist (migrations reviewed, feature flags set, Stripe webhook versions confirmed)
- Running \`uv run python manage.py migrate\` safely against multi-tenant PostgreSQL (check for long-running locks, use \`--plan\` first)
- Building and pushing Docker image via GitHub Actions
- Rolling deployment on ECS/Kubernetes with zero downtime
- Celery worker and beat scheduler restart sequence (drain workers before deploy: \`celery -A config control shutdown\`)
- Static asset deployment to S3 + CloudFront invalidation
- Post-deployment smoke tests: health endpoint, API response, Celery task dispatch, Stripe webhook receipt
- Rollback procedure: revert ECS task definition, rollback migration with \`uv run python manage.py migrate <app> <previous_migration>\`
- Database migration rollback considerations for row-level security policies

#### 2. \`docs/runbooks/database-incident.md\` — PostgreSQL Database Incidents

Cover these scenarios:

- **Connection pool exhaustion**: Diagnose with \`SELECT count(*) FROM pg_stat_activity;\`, identify long-running queries, kill with \`pg_terminate_backend()\`, adjust PgBouncer or Django \`CONN_MAX_AGE\`
- **Slow queries**: Use \`pg_stat_statements\`, identify missing indexes, check tenant-scoped query plans with \`EXPLAIN ANALYZE\`
- **Row-level security policy failure**: Tenant data leak detection, emergency response (SOC 2 incident), verify \`current_setting('app.current_tenant')\` is set in all connections
- **RDS failover**: Detect via CloudWatch, verify Django reconnects, check for stale connections in pool
- **Migration failure in production**: Lock detection, safe rollback, handling partial migrations
- **Disk space alerts**: Identify bloated tables, run \`VACUUM ANALYZE\`, check for orphaned tenant data
- **Backup and restore**: RDS snapshot restore procedure, point-in-time recovery, tenant-specific data export for GDPR requests

#### 3. \`docs/runbooks/celery-incident.md\` — Celery Task Queue Incidents

Cover these scenarios:

- **Workers not processing tasks**: Check \`celery -A config inspect active\`, verify Redis broker connectivity with \`redis-cli ping\`, check ECS task status
- **Task backlog growing**: Monitor with \`celery -A config inspect reserved\`, scale workers via Kubernetes HPA or ECS service scaling
- **Stuck/zombie tasks**: Identify with \`celery -A config inspect active\`, revoke with \`celery -A config control revoke <task_id> --terminate\`
- **Beat scheduler not firing**: Verify \`celery -A config beat\` process is running, check \`django_celery_beat\` schedule in admin, ensure single beat instance (leader election)
- **Idempotency failure**: Detect duplicate task execution via audit logs, identify non-idempotent tasks in \`src/tasks/\`, remediation steps
- **Redis broker OOM**: Monitor with \`redis-cli info memory\`, flush completed results, adjust \`result_expires\` in Celery config
- **Billing sync task failure**: \`src/tasks/\` billing tasks failing to sync with Stripe — retry logic, dead letter handling, manual reconciliation via \`uv run python manage.py sync_stripe_subscriptions\`

#### 4. \`docs/runbooks/stripe-billing-incident.md\` — Stripe Billing & Webhook Incidents

Cover these scenarios:

- **Webhook delivery failures**: Check Stripe dashboard webhook logs, verify endpoint URL and signing secret, test with \`stripe listen --forward-to localhost:8000/api/billing/webhooks/\`
- **Webhook signature verification failure**: Rotate \`STRIPE_WEBHOOK_SECRET\`, check clock skew on servers
- **Subscription state mismatch**: Tenant shows active in Django but canceled in Stripe (or vice versa) — reconciliation via \`uv run python manage.py reconcile_subscriptions\`
- **Failed payment handling**: Dunning flow verification, grace period enforcement, tenant access restriction logic in \`src/billing/\`
- **Usage metering discrepancy**: Compare \`src/billing/\` usage records with Stripe usage records, identify missed meter events
- **Stripe API outage**: Detect via Stripe status page, queue billing operations in Celery for retry, communicate to affected tenants
- **Invoice generation failure**: Debug \`invoice.created\` and \`invoice.finalized\` webhook handlers, manual invoice creation
- **PCI compliance**: Confirm no raw card data in logs (SOC 2), verify Stripe.js client-side tokenization, audit \`src/billing/\` for compliance

#### 5. \`docs/runbooks/tenant-isolation-breach.md\` — Multi-Tenant Data Isolation Incident (P1)

This is a **critical security runbook** (SOC 2 mandatory):

- **Detection**: Cross-tenant data in API response, Sentry error with mismatched tenant context, audit log anomaly
- **Immediate containment**: Disable affected API endpoint, revoke sessions for affected tenants, enable maintenance mode if widespread
- **Root cause investigation**: Check \`src/core/\` tenant-aware manager, verify \`TenantMiddleware\` in \`src/tenants/middleware.py\` sets tenant context, audit row-level security policies in PostgreSQL, check Celery task tenant context propagation
- **Data exposure assessment**: Query audit logs to determine scope, identify all affected tenants and data types
- **GDPR notification requirements**: 72-hour breach notification timeline, DPA obligations, data subject notification templates
- **SOC 2 incident documentation**: Evidence collection, timeline reconstruction, control failure analysis
- **Remediation**: Fix tenant context propagation, add regression tests, update row-level security policies, deploy hotfix
- **Post-incident**: Mandatory security review of all tenant-scoped queries in \`src/\`, penetration test scheduling

#### 6. \`docs/runbooks/redis-incident.md\` — Redis / ElastiCache Incidents

Cover these scenarios:

- **ElastiCache node failure**: Detect via CloudWatch, verify automatic failover, check Django cache backend reconnection, check Celery broker reconnection
- **Cache stampede**: Detect via high RDS CPU coinciding with Redis evictions, implement cache warming, verify \`src/core/\` cache decorators use locking
- **Session store failure**: Users logged out en masse, fallback to database sessions, session restoration
- **Memory pressure**: \`redis-cli info memory\`, identify large keys with \`redis-cli --bigkeys\`, review cache TTLs in \`src/core/\`, eviction policy tuning
- **Celery broker vs cache isolation**: Verify separate Redis databases or instances for broker (db 0) and cache (db 1) to prevent cross-contamination

#### 7. \`docs/runbooks/auth-incident.md\` — Authentication & Authorization Incidents

Cover these scenarios:

- **Mass authentication failures**: JWT/session validation errors, check \`src/accounts/\` auth backends, verify secret key rotation didn't invalidate sessions
- **Role-based access control bypass**: User accessing resources outside their role, audit \`src/core/permissions.py\`, check DRF permission classes on viewsets in \`src/api/\`
- **Account takeover detection**: Multiple failed login attempts, credential stuffing patterns, rate limiting verification, account lockout procedure
- **OAuth/SSO provider outage**: Fallback authentication, communication to tenants using SSO
- **API key compromise**: Revoke key, audit usage via logs, notify affected tenant, rotate and reissue

#### 8. \`docs/runbooks/infrastructure-scaling.md\` — Scaling & Performance Incidents

Cover these scenarios:

- **API response time degradation**: Check Prometheus/Grafana dashboards, identify slow endpoints via drf-spectacular metrics, scale ECS tasks or Kubernetes pods
- **ECS/Kubernetes pod crash loops**: Check logs with \`kubectl logs\`, inspect OOM kills, adjust resource limits
- **RDS CPU/IOPS saturation**: Read replica promotion, query optimization, connection pooling tuning
- **S3/CloudFront issues**: Static asset 403/404, CloudFront distribution update, cache invalidation
- **SES sending limits**: Email queue backlog, SES quota increase request, fallback notification via in-app
- **Auto-scaling configuration**: HPA thresholds for API pods, Celery worker scaling based on queue depth, RDS storage auto-scaling

#### 9. \`docs/runbooks/gdpr-data-operations.md\` — GDPR Data Subject Requests

Cover these operational procedures:

- **Right to Access (Data Export)**: Management command \`uv run python manage.py export_tenant_data --tenant-id <id> --format json\`, data inventory across PostgreSQL, Redis, S3, Stripe, audit log inclusion
- **Right to Deletion (Data Erasure)**: Management command \`uv run python manage.py delete_tenant_data --tenant-id <id> --confirm\`, cascade deletion order (Stripe subscription cancellation first, then local data), backup retention policy, anonymization vs hard delete
- **Data Portability**: Export format (JSON, CSV), include all tenant-scoped data from \`src/tenants/\`, \`src/accounts/\`, \`src/billing/\`
- **Consent withdrawal**: Update consent records, disable data processing, notify downstream integrations
- **Data residency**: Verify tenant data stored in correct AWS region, cross-region replication audit
- **30-day compliance timeline**: Tracking requests, escalation if approaching deadline, documentation for SOC 2 audit

#### 10. \`docs/runbooks/incident-response-template.md\` — Incident Response Template

A blank template for any new incident, pre-filled with:

- Severity classification guide (P1: multi-tenant data breach or full outage, P2: single service degraded, P3: non-critical feature broken, P4: cosmetic or minor)
- Communication templates for Slack #incidents channel
- Status page update templates
- SOC 2 incident log fields (timestamp, responder, actions taken, evidence collected)
- Post-incident review (PIR) template with 5-whys analysis
- GDPR breach assessment checklist
- Escalation matrix with timezone coverage (Europe: CET business hours, Americas: ET/PT business hours, overlap window: 14:00-18:00 UTC)

---

### Additional Requirements

1. Every runbook must include exact commands — no placeholders like \`<run the appropriate command>\`. Use the actual project tools:
   - \`uv run python manage.py <command>\`
   - \`uv run pytest tests/ -x\`
   - \`celery -A config inspect active\`
   - \`kubectl get pods -n django-saas\`
   - \`aws ecs describe-services --cluster django-saas-prod\`
   - \`redis-cli -h $REDIS_HOST info memory\`
   - \`stripe listen --forward-to localhost:8000/api/billing/webhooks/\`

2. Reference the actual project directory structure: \`src/tenants/\`, \`src/billing/\`, \`src/core/\`, \`src/accounts/\`, \`src/tasks/\`, \`config/\`

3. Include Sentry, Prometheus, and Grafana references for detection and monitoring

4. All runbooks must address multi-tenant implications — a single-tenant issue vs platform-wide issue

5. Cross-reference between runbooks where incidents may cascade (e.g., Redis failure → Celery incident → billing sync failure)

6. Include estimated time-to-resolve for each severity level

7. Add a \`docs/runbooks/README.md\` index file listing all runbooks with severity and brief description

After generating, verify each runbook by confirming:
- [ ] All commands are copy-pasteable
- [ ] SOC 2 incident documentation requirements are addressed
- [ ] GDPR implications are noted where personal data is involved
- [ ] Escalation paths include timezone-aware contacts
- [ ] Multi-tenant impact assessment is included
- [ ] Cross-references to related runbooks are present`,

  'plugin/codeforge-django-saas/.claude-plugin/plugin.json': `{
  "name": "codeforge-django-saas",
  "version": "1.0.0",
  "description": "CodeForge plugin for Django SaaS Platform — provides agents, commands, and skills for multi-tenant SaaS development with Django 5.0, Celery, Stripe billing, and PostgreSQL row-level security.",
  "author": "django-saas-platform team",
  "license": "MIT",
  "engine": "claude-code",
  "min_engine_version": "1.0.0",
  "repository": "https://github.com/your-org/django-saas-platform",
  "homepage": "https://github.com/your-org/django-saas-platform/tree/main/plugin/codeforge-django-saas",
  "keywords": [
    "django",
    "saas",
    "multi-tenant",
    "stripe",
    "celery",
    "postgresql",
    "rest-api",
    "graphql",
    "billing",
    "subscriptions"
  ],
  "capabilities": {
    "agents": true,
    "commands": true,
    "skills": true,
    "rules": true,
    "playbook": true,
    "mcp_servers": true
  },
  "agents": [
    {
      "id": "backend-developer",
      "name": "Backend Developer",
      "description": "Implements Django views, serializers, models, and service layer logic following modular monolith patterns with tenant isolation.",
      "entry": "../agents/backend-developer.md"
    },
    {
      "id": "billing-engineer",
      "name": "Billing Engineer",
      "description": "Handles Stripe integration — subscription lifecycle, webhook processing, usage metering, invoice generation, and payment failure recovery.",
      "entry": "../agents/billing-engineer.md"
    },
    {
      "id": "task-engineer",
      "name": "Task Engineer",
      "description": "Designs and implements idempotent Celery tasks for background processing — email dispatch, report generation, webhook delivery, and billing sync.",
      "entry": "../agents/task-engineer.md"
    },
    {
      "id": "api-designer",
      "name": "API Designer",
      "description": "Designs REST endpoints with DRF and GraphQL schemas with Strawberry, ensuring OpenAPI 3.1 documentation via drf-spectacular.",
      "entry": "../agents/api-designer.md"
    },
    {
      "id": "security-reviewer",
      "name": "Security Reviewer",
      "description": "Reviews code for SOC 2 compliance, GDPR data handling, tenant data isolation, and common Django security pitfalls.",
      "entry": "../agents/security-reviewer.md"
    }
  ],
  "commands": [
    {
      "id": "new-django-app",
      "name": "New Django App",
      "description": "Scaffolds a new Django app under src/ with models, serializers, views, urls, admin, tasks, tests, and factories.",
      "entry": "../commands/new-django-app.md"
    },
    {
      "id": "new-api-endpoint",
      "name": "New API Endpoint",
      "description": "Creates a DRF viewset or Strawberry GraphQL resolver with serializer, permissions, tests, and OpenAPI schema annotations.",
      "entry": "../commands/new-api-endpoint.md"
    },
    {
      "id": "new-celery-task",
      "name": "New Celery Task",
      "description": "Creates an idempotent Celery task with retry logic, logging, error handling, and corresponding tests.",
      "entry": "../commands/new-celery-task.md"
    },
    {
      "id": "new-stripe-webhook",
      "name": "New Stripe Webhook",
      "description": "Adds a verified, idempotent Stripe webhook handler with event processing, signature verification, and integration tests.",
      "entry": "../commands/new-stripe-webhook.md"
    },
    {
      "id": "new-model",
      "name": "New Model",
      "description": "Creates a tenant-aware Django model with migration, admin registration, factory, and unit tests.",
      "entry": "../commands/new-model.md"
    },
    {
      "id": "run-checks",
      "name": "Run Checks",
      "description": "Runs the full local quality pipeline: ruff check, ruff format --check, mypy strict, pytest with coverage.",
      "entry": "../commands/run-checks.md"
    },
    {
      "id": "debug-tenant-isolation",
      "name": "Debug Tenant Isolation",
      "description": "Audits a queryset or view for proper tenant scoping — checks that all data access goes through the tenant-aware manager.",
      "entry": "../commands/debug-tenant-isolation.md"
    }
  ],
  "skills": [
    {
      "id": "tenant-isolation",
      "name": "Tenant Isolation Patterns",
      "description": "Row-level security, tenant-aware model managers, middleware-based tenant context, and cross-tenant data leak prevention.",
      "entry": "../skills/tenant-isolation.md"
    },
    {
      "id": "stripe-integration",
      "name": "Stripe Integration",
      "description": "Subscription creation, plan changes, cancellation, usage-based metering, webhook verification, and invoice handling with Stripe API.",
      "entry": "../skills/stripe-integration.md"
    },
    {
      "id": "celery-patterns",
      "name": "Celery Task Patterns",
      "description": "Idempotent task design, retry strategies, task chaining, periodic tasks with beat, result backends, and dead letter handling.",
      "entry": "../skills/celery-patterns.md"
    },
    {
      "id": "django-service-layer",
      "name": "Django Service Layer",
      "description": "Business logic encapsulation in service modules, avoiding fat models and fat views, explicit over implicit (no signal abuse).",
      "entry": "../skills/django-service-layer.md"
    },
    {
      "id": "drf-best-practices",
      "name": "DRF Best Practices",
      "description": "Serializer design, viewset composition, permission classes, pagination, filtering, throttling, and drf-spectacular schema generation.",
      "entry": "../skills/drf-best-practices.md"
    },
    {
      "id": "graphql-strawberry",
      "name": "Strawberry GraphQL",
      "description": "Type definitions, resolvers, mutations, subscriptions, DataLoader patterns, and authentication in Strawberry GraphQL.",
      "entry": "../skills/graphql-strawberry.md"
    },
    {
      "id": "testing-patterns",
      "name": "Testing Patterns",
      "description": "pytest-django fixtures, factory_boy factories, tenant-scoped test contexts, Stripe mock fixtures, Celery task testing, and integration test patterns.",
      "entry": "../skills/testing-patterns.md"
    },
    {
      "id": "gdpr-compliance",
      "name": "GDPR Compliance",
      "description": "Data residency, consent management, right to deletion implementation, audit logging, DPA requirements, and PII handling in Django.",
      "entry": "../skills/gdpr-compliance.md"
    },
    {
      "id": "soc2-security",
      "name": "SOC 2 Security",
      "description": "Access controls, audit trails, encryption at rest and in transit, secret management, vulnerability scanning, and incident response patterns.",
      "entry": "../skills/soc2-security.md"
    }
  ],
  "rules": [
    {
      "id": "django-conventions",
      "description": "Django project conventions — app structure, naming, imports, settings organization.",
      "path": "../../.claude/rules/python/django-conventions.md"
    },
    {
      "id": "testing-standards",
      "description": "Testing requirements — pytest, coverage thresholds, factory_boy, tenant-scoped fixtures.",
      "path": "../../.claude/rules/python/testing.md"
    },
    {
      "id": "billing-safety",
      "description": "Billing code safety — Stripe webhook idempotency, subscription state machine, financial data handling.",
      "path": "../../.claude/rules/billing-safety.md"
    },
    {
      "id": "tenant-data-access",
      "description": "Tenant data access rules — always use tenant-aware managers, never bypass row-level security.",
      "path": "../../.claude/rules/tenant-data-access.md"
    }
  ],
  "playbook": {
    "description": "Development methodology phases for the Django SaaS Platform — from ticket analysis through deployment.",
    "path": "../../playbook/"
  },
  "mcp_servers": {
    "description": "MCP server configurations for GitHub Issues, Slack, AWS Console, Sentry, and documentation access.",
    "config_path": "../../.mcp.json"
  },
  "file_associations": {
    "models": "src/**/models.py",
    "serializers": "src/**/serializers.py",
    "views": "src/**/views.py",
    "urls": "src/**/urls.py",
    "tasks": "src/**/tasks.py",
    "admin": "src/**/admin.py",
    "services": "src/**/services.py",
    "permissions": "src/**/permissions.py",
    "factories": "tests/**/factories.py",
    "tests": "tests/**/*test*.py",
    "migrations": "src/**/migrations/*.py",
    "settings": "config/*.py",
    "celery_config": "config/celery.py",
    "graphql_schema": "src/**/schema.py",
    "stripe_webhooks": "src/billing/webhooks.py"
  },
  "sensitive_paths": [
    "src/billing/**",
    "src/accounts/auth/**",
    "config/production.py",
    "config/staging.py",
    ".env*",
    "scripts/deploy*",
    "src/core/permissions.py",
    "src/tenants/middleware.py",
    "src/tenants/managers.py"
  ],
  "quality_gates": {
    "lint": "uv run ruff check src/ tests/",
    "format_check": "uv run ruff format --check src/ tests/",
    "type_check": "uv run mypy src/",
    "unit_tests": "uv run pytest tests/ -x --tb=short",
    "coverage": "uv run pytest tests/ --cov=src --cov-report=term-missing --cov-fail-under=85",
    "security_scan": "uv run bandit -r src/ -c pyproject.toml",
    "migrations_check": "uv run python manage.py makemigrations --check --dry-run"
  }
}`,

  'plugin/codeforge-django-saas/README.md': `# CodeForge Django SaaS Plugin

A Claude Code plugin purpose-built for the **django-saas-platform** project. It provides specialized skills, agents, commands, and hooks for developing a multi-tenant SaaS application with Django 5.0, Celery, Stripe billing, and PostgreSQL row-level security.

## Overview

This plugin encodes the team's development methodology, coding standards, and SaaS-specific patterns directly into Claude Code's workflow. Instead of repeating context in every conversation, the plugin ensures Claude always operates within the project's conventions.

### What's Included

| Component | Count | Purpose |
|-----------|-------|---------|
| **Skills** | 6 | Reusable development methodologies (plan, tdd, verify, build-fix, code-review, phase) |
| **Agents** | 5 | Specialized personas (planner, architect, tdd-guide, code-reviewer, build-error-resolver) |
| **Commands** | 5 | Quick-access slash commands (/plan, /tdd, /build-fix, /verify, /code-review) |
| **Hooks** | 2 | Automated pre-commit and post-build checks |

## Installation

The plugin is included in the repository under \`plugin/codeforge-django-saas/\`. No separate installation is required — Claude Code discovers it automatically via the plugin manifest.

### Verify Plugin Registration

Check that \`.claude-plugin/plugin.json\` is present and valid:

\`\`\`bash
cat plugin/codeforge-django-saas/.claude-plugin/plugin.json
\`\`\`

The manifest declares the plugin slug \`codeforge-django-saas\` and points to all skills, agents, commands, and hooks.

### Prerequisites

Ensure the development environment is set up (see \`install.sh\` or \`docs/ONBOARDING.md\`):

\`\`\`bash
# Install Python dependencies
uv sync

# Verify core tools are available
uv run ruff --version
uv run mypy --version
uv run pytest --version
\`\`\`

## Skills

Skills are reusable methodology documents that Claude follows when performing specific types of work.

### plan

**File:** \`skills/plan/SKILL.md\`

Structured planning methodology for feature work. Produces implementation plans that account for tenant isolation, billing impacts, Celery task design, and API schema changes.

**When to use:** Before starting any feature that touches multiple Django apps or introduces new models/endpoints.

**Key outputs:**
- Affected Django apps and files
- Database migration plan (with tenant isolation considerations)
- API contract changes (DRF serializers, Strawberry types)
- Celery task definitions (idempotency strategy)
- Test plan with coverage targets

### tdd

**File:** \`skills/tdd/SKILL.md\`

Test-driven development workflow using pytest, factory_boy, and pytest-django. Enforces the red-green-refactor cycle with SaaS-specific test patterns.

**When to use:** For all feature implementation. This is the default development skill.

**Key patterns:**
- Tenant-scoped test fixtures via factory_boy
- Stripe webhook mock testing
- Celery task unit testing (with \`@pytest.mark.celery\`)
- Row-level security assertion helpers
- Coverage enforcement at 85% threshold

### verify

**File:** \`skills/verify/SKILL.md\`

Comprehensive verification pipeline that mirrors CI. Runs all quality checks locally before pushing.

**When to use:** Before creating a PR or after completing a feature branch.

**Checks executed:**
\`\`\`bash
uv run ruff check src/ tests/          # Linting
uv run ruff format --check src/ tests/  # Formatting
uv run mypy src/                        # Type checking (strict)
uv run pytest --cov=src --cov-fail-under=85  # Tests + coverage
uv run python manage.py check --deploy  # Django deployment checks
uv run python manage.py makemigrations --check  # Migration drift
\`\`\`

### build-fix

**File:** \`skills/build-fix/SKILL.md\`

Systematic approach to diagnosing and fixing CI/CD failures, Docker build errors, migration conflicts, and dependency issues.

**When to use:** When CI fails, Docker builds break, or \`uv run pytest\` produces unexpected errors.

**Covers:**
- ruff / mypy error resolution
- pytest failure triage (tenant isolation issues, fixture problems)
- Django migration conflict resolution
- Docker build layer debugging
- Celery worker startup failures

### code-review

**File:** \`skills/code-review/SKILL.md\`

Structured code review methodology aligned with the project's PR requirements and SOC 2 / GDPR compliance needs.

**When to use:** When reviewing PRs or when asked to self-review before submitting.

**Review dimensions:**
- Tenant data isolation (all queries go through tenant-aware managers)
- Stripe webhook idempotency
- Celery task idempotency and retry configuration
- OpenAPI schema completeness (drf-spectacular)
- GDPR data handling (PII logging, consent, right to deletion)
- File length (≤300 lines), naming conventions, type hints on public functions

### phase

**File:** \`skills/phase/SKILL.md\`

Maps work to the project's development methodology phases defined in \`playbook/\`. Ensures features progress through planning, implementation, testing, review, and deployment in order.

**When to use:** For larger features spanning multiple PRs or when coordinating work across team members.

## Agents

Agents are specialized personas that Claude adopts for specific types of work. Each agent has deep context about its domain within the SaaS platform.

### planner

**File:** \`agents/planner.md\`

Decomposes GitHub Issues into actionable implementation plans. Understands the Django app boundaries, tenant model relationships, and Stripe integration points.

**Activate with:** \`/plan\` command or by asking Claude to plan a feature.

### architect

**File:** \`agents/architect.md\`

Makes structural decisions about Django app organization, database schema design, API surface area, and Celery task topology. Enforces the modular monolith pattern and tenant isolation at the data layer.

**Activate with:** Asking architectural questions or during the planning phase of large features.

**Domain expertise:**
- PostgreSQL row-level security policies
- Django app dependency graph (no circular imports)
- Multi-tenancy middleware and context propagation
- Stripe subscription model mapping to Django models
- Redis caching strategy (tenant-scoped cache keys)

### tdd-guide

**File:** \`agents/tdd-guide.md\`

Coaches through test-driven development. Writes failing tests first, guides toward minimal passing implementations, then refactors. Knows the project's test infrastructure deeply.

**Activate with:** \`/tdd\` command.

**Test infrastructure knowledge:**
- \`tests/\` directory mirrors \`src/\` structure
- \`conftest.py\` fixtures for tenant context, authenticated API clients, Stripe mocks
- factory_boy factories in each app's \`tests/factories.py\`
- pytest markers: \`@pytest.mark.django_db\`, \`@pytest.mark.celery\`, \`@pytest.mark.integration\`

### code-reviewer

**File:** \`agents/code-reviewer.md\`

Reviews code changes against the project's standards, security requirements, and SaaS-specific patterns. Produces structured review feedback with severity levels.

**Activate with:** \`/code-review\` command.

**Review checklist includes:**
- Sensitive path changes (\`**/billing/**\`, \`**/auth/**\`, \`config/production/**\`)
- CODEOWNERS alignment
- Conventional commit message format
- AI-generated code flagging (per \`docs/AI-USAGE-POLICY.md\`)

### build-error-resolver

**File:** \`agents/build-error-resolver.md\`

Diagnoses and fixes build/CI failures systematically. Reads error output, identifies root causes, and applies targeted fixes without introducing regressions.

**Activate with:** \`/build-fix\` command or when pasting CI error logs.

## Commands

Slash commands provide quick access to common workflows.

| Command | Description | Invokes |
|---------|-------------|---------|
| \`/plan\` | Plan a feature from a GitHub Issue or description | planner agent + plan skill |
| \`/tdd\` | Start TDD workflow for a specific component | tdd-guide agent + tdd skill |
| \`/build-fix\` | Diagnose and fix a build or CI failure | build-error-resolver agent + build-fix skill |
| \`/verify\` | Run the full local verification pipeline | verify skill |
| \`/code-review\` | Review current changes or a specific PR | code-reviewer agent + code-review skill |

### Command Examples

\`\`\`
/plan SAAS-42 Add usage-based metering for API calls
\`\`\`
Claude will analyze the requirement, identify affected apps (\`billing/\`, \`tenants/\`, \`api/\`), plan the Stripe Usage Record integration, design Celery tasks for metering aggregation, and outline the test strategy.

\`\`\`
/tdd src/billing/services/subscription_service.py
\`\`\`
Claude will write failing tests for the subscription service first, then guide implementation of the service with Stripe API calls, tenant scoping, and idempotent webhook handling.

\`\`\`
/build-fix
\`\`\`
Paste your CI error output and Claude will diagnose the failure — whether it's a ruff violation, mypy type error, pytest failure, migration conflict, or Docker build issue.

\`\`\`
/verify
\`\`\`
Claude runs the full check suite locally and reports any issues before you push.

\`\`\`
/code-review
\`\`\`
Claude reviews staged or committed changes against project standards, tenant isolation patterns, and compliance requirements.

## Hooks

Hooks run automatically at specific points in the development workflow.

### Pre-commit Hook

**Trigger:** Before each commit is created.

**Actions:**
- Runs \`uv run ruff check\` on staged files
- Runs \`uv run ruff format --check\` on staged files
- Validates conventional commit message format
- Checks for secrets or \`.env\` files in staged changes
- Warns if sensitive paths (\`**/billing/**\`, \`**/auth/**\`) are modified without tests

### Post-build Hook

**Trigger:** After Docker image build or test suite completion.

**Actions:**
- Validates migration consistency (\`makemigrations --check\`)
- Checks OpenAPI schema generation (\`drf-spectacular\` validation)
- Reports coverage delta against 85% threshold
- Flags any new dependencies added to \`pyproject.toml\` for review

## SaaS-Specific Context

The plugin encodes these project-specific patterns that Claude always respects:

### Multi-Tenancy
- All database queries must use the tenant-aware manager (\`TenantManager\`)
- Tenant context is set via middleware and propagated to Celery tasks via headers
- PostgreSQL row-level security policies are the last line of defense — application-level filtering is the first
- Test fixtures always create tenant context before any data operations

### Stripe Billing
- Webhook handlers must be idempotent (use Stripe event ID for deduplication)
- Subscription state changes flow: Stripe webhook → Django signal → service layer → model update
- Never store full card numbers — only Stripe token references
- All billing operations are audit-logged for SOC 2 compliance

### Celery Tasks
- Every task must be idempotent (safe to retry)
- Tasks accept primitive arguments only (no Django model instances)
- Tenant ID is always the first argument to tenant-scoped tasks
- Use \`autoretry_for\` with exponential backoff for external API calls (Stripe, SES)
- Long-running tasks must implement checkpointing

### Compliance
- GDPR: PII must never appear in logs, all user data access is audit-logged, right-to-deletion cascades through all apps
- SOC 2: Sensitive path changes require additional review, all authentication changes need security team approval via CODEOWNERS

## Customization

### Adding a New Skill

1. Create \`skills/<skill-name>/SKILL.md\` with the methodology
2. Register it in \`.claude-plugin/plugin.json\` under the \`skills\` array
3. Optionally create a matching command in \`commands/<skill-name>.md\`

### Adding a New Agent

1. Create \`agents/<agent-name>.md\` with the persona definition
2. Register it in \`.claude-plugin/plugin.json\` under the \`agents\` array
3. Reference it from relevant commands or skills

### Modifying Hooks

Edit \`hooks/hooks.json\` to adjust triggers, add new checks, or change which tools are invoked. Hook actions should reference commands available in the project's \`uv\` environment.

## Troubleshooting

**Plugin not detected by Claude Code:**
- Ensure \`plugin/codeforge-django-saas/.claude-plugin/plugin.json\` exists and is valid JSON
- Check that the plugin directory is not in \`.gitignore\`

**Commands not available:**
- Verify command files exist in \`commands/\` and are registered in \`plugin.json\`
- Restart Claude Code after adding new commands

**Hooks not firing:**
- Check \`hooks/hooks.json\` for syntax errors
- Ensure hook trigger events match the expected lifecycle points

**Skill context not applied:**
- Skills are advisory — Claude follows them when invoked via commands or agent activation
- For persistent context, ensure relevant rules are also in \`.claude/\` project rules

## Related Documentation

- [Architecture](../../docs/ARCHITECTURE.md) — System design and Django app structure
- [Contributing](../../docs/CONTRIBUTING.md) — Development workflow and PR process
- [AI Usage Policy](../../docs/AI-USAGE-POLICY.md) — Guidelines for AI-assisted development
- [Onboarding](../../docs/ONBOARDING.md) — New developer setup guide`,

  'plugin/codeforge-django-saas/agents/architect.md': `# Architect Agent — Django SaaS Platform

## Identity

You are the **Architect Agent** for the django-saas-platform project. You specialize in designing and evaluating system architecture for a multi-tenant SaaS application built with Django 5.0, Django REST Framework, Strawberry GraphQL, Celery, PostgreSQL with row-level security, Redis, and Stripe billing integration. You make decisions that balance scalability, security, maintainability, and SOC 2 / GDPR compliance.

## Activation

This agent activates when the task involves:

- Designing new Django apps, services, or modules
- Evaluating architectural trade-offs (sync vs async, monolith vs microservice boundaries)
- Multi-tenancy strategy (row-level security, tenant isolation, data residency)
- Database schema design (PostgreSQL models, indexes, migrations, RLS policies)
- API design (REST endpoints, GraphQL schema, versioning, pagination)
- Celery task architecture (idempotency, retry strategies, task routing, beat schedules)
- Stripe billing integration patterns (subscription lifecycle, webhook handling, usage metering)
- Caching strategy (Redis cache layers, invalidation, session management)
- Infrastructure decisions (AWS ECS, RDS, ElastiCache, S3, CloudFront)
- Security architecture (authentication, authorization, RBAC, audit logging)
- Performance optimization and scaling decisions
- Cross-cutting concerns (middleware, signals vs service layer, event-driven patterns)

## Context & Knowledge

### Project Architecture

This is a **modular monolith** Django application with the following app structure:

\`\`\`
src/
  accounts/          # User management, authentication, tenant association
  tenants/           # Multi-tenancy model, middleware, row-level security
  billing/           # Stripe subscriptions, invoices, usage metering, webhooks
  api/               # DRF viewsets, Strawberry GraphQL schema, serializers
  core/              # Base models, permissions, middleware, tenant-aware managers
  notifications/     # Email (SES), in-app notifications, webhook dispatch
  tasks/             # Celery task definitions (billing sync, reports, cleanup)
  utils/             # Shared utilities, logging, decorators
config/              # Django settings (base, development, staging, production)
\`\`\`

### Key Architectural Principles

1. **Tenant Isolation**: All tenant data access goes through \`TenantAwareManager\`. PostgreSQL row-level security policies enforce isolation at the database level. Never bypass the tenant-aware manager.
2. **Service Layer Pattern**: Business logic lives in service modules (\`services.py\`) within each app, not in views or serializers. Django signals are used sparingly — prefer explicit service calls.
3. **Idempotent Operations**: All Celery tasks and Stripe webhook handlers must be idempotent. Use idempotency keys for Stripe API calls and deduplication for task execution.
4. **API-First Design**: Every endpoint must have an OpenAPI schema via drf-spectacular. GraphQL schema uses Strawberry with proper type annotations.
5. **Explicit Over Implicit**: Favor explicit dependency injection and service calls over Django signals, middleware magic, or implicit coupling between apps.

### Technology Constraints

- **Python 3.12+** with type hints on all public functions
- **Django 5.0** with async view support where beneficial
- **PostgreSQL 16** with row-level security, no multi-database tenant isolation
- **Redis** for caching (django-redis), sessions, and Celery broker
- **Celery 5** with Redis broker and beat scheduler
- **Stripe** for all billing (no custom payment processing)
- **AWS** infrastructure (ECS, RDS, ElastiCache, S3, SES, CloudFront)
- **Max file length**: 300 lines — split into modules when exceeded

### Compliance Requirements

- **SOC 2**: Audit logging for all data mutations, access controls, encryption at rest and in transit, change management
- **GDPR**: Data residency awareness, consent tracking, right to deletion (cascade through tenant data), data processing agreements, PII handling with field-level encryption where needed

## Workflow

### 1. Understand the Problem

- Read the ticket or request thoroughly using GitHub Issues context
- Identify which Django apps are affected
- Determine if this is a new app, a cross-app concern, or a modification to existing architecture
- Check \`docs/ARCHITECTURE.md\` for current system design
- Review existing models, services, and API schemas in affected apps

### 2. Analyze Constraints

- **Tenant isolation**: Does this feature handle tenant data? How is isolation enforced?
- **Billing impact**: Does this affect subscription tiers, usage metering, or feature gating?
- **Data model**: What are the PostgreSQL schema implications? Migrations? Indexes? RLS policies?
- **Performance**: What are the expected query patterns? Do we need caching? Read replicas?
- **Async requirements**: Should this be synchronous (request/response) or asynchronous (Celery task)?
- **Security**: Authentication, authorization, RBAC implications? Audit logging requirements?
- **Compliance**: GDPR data handling? SOC 2 audit trail? PII involved?
- **API surface**: REST, GraphQL, or both? Backward compatibility?

### 3. Design the Solution

Produce an architecture document or decision record that includes:

#### Data Model Design
\`\`\`python
# Example: Show Django model with tenant FK, indexes, constraints
class Feature(TenantAwareModel):
    """Always inherit from TenantAwareModel for automatic tenant scoping."""
    tenant = models.ForeignKey("tenants.Tenant", on_delete=models.CASCADE, db_index=True)
    # ... fields with type annotations in docstring
    
    class Meta:
        indexes = [models.Index(fields=["tenant", "created_at"])]
        constraints = [models.UniqueConstraint(fields=["tenant", "slug"], name="unique_tenant_slug")]
\`\`\`

#### Service Layer Design
\`\`\`python
# Services live in src/<app>/services.py
# They accept explicit parameters, not request objects
def create_feature(*, tenant_id: int, name: str, created_by: int) -> Feature:
    """Service functions use keyword-only arguments for clarity."""
    ...
\`\`\`

#### API Design
\`\`\`
# REST: Follow existing DRF patterns
POST   /api/v1/features/          -> Create
GET    /api/v1/features/          -> List (tenant-scoped)
GET    /api/v1/features/{id}/     -> Retrieve
PATCH  /api/v1/features/{id}/     -> Partial update
DELETE /api/v1/features/{id}/     -> Soft delete

# GraphQL: Strawberry types and resolvers
type Feature { id: ID!, name: String!, ... }
\`\`\`

#### Celery Task Design
\`\`\`python
# Tasks in src/tasks/ must be idempotent
@shared_task(bind=True, max_retries=3, default_retry_delay=60)
def process_feature(self, feature_id: int, idempotency_key: str) -> None:
    """Idempotent: check if already processed before executing."""
    ...
\`\`\`

#### Caching Strategy
- Identify cache keys, TTLs, and invalidation triggers
- Use \`tenant:{tenant_id}:\` prefix for all tenant-scoped cache keys

#### Migration Strategy
- Backward-compatible migrations (no column drops without deprecation)
- RLS policy updates when new tables are added
- Data migration scripts in \`scripts/\` if needed

### 4. Evaluate Trade-offs

For every significant decision, document:

| Option | Pros | Cons | Recommendation |
|--------|------|------|----------------|
| Option A | ... | ... | ... |
| Option B | ... | ... | ... |

Consider these dimensions:
- **Complexity**: How much does this add to the codebase? Can junior developers understand it?
- **Scalability**: Will this work at 10x current load? 100x?
- **Tenant isolation**: Is there any risk of data leakage between tenants?
- **Operational cost**: AWS resource implications, monitoring needs
- **Migration path**: Can we deploy this without downtime? Rolling deployment safe?

### 5. Produce Deliverables

Depending on the scope, produce one or more of:

- **Architecture Decision Record (ADR)**: For significant decisions, create \`docs/adr/ADR-NNNN-title.md\`
- **Data Model Diagram**: Mermaid diagram showing entity relationships
- **Sequence Diagram**: For complex flows (e.g., subscription upgrade, webhook processing)
- **Migration Plan**: Step-by-step deployment plan for schema changes
- **App Structure**: Directory layout for new Django apps
- **API Contract**: OpenAPI snippet or GraphQL schema fragment
- **Task Flow**: Celery task chain/chord design with retry and error handling

## Architecture Decision Record Template

When creating ADRs, use this format:

\`\`\`markdown
# ADR-NNNN: Title

## Status
Proposed | Accepted | Deprecated | Superseded by ADR-XXXX

## Context
What is the problem or requirement?

## Decision
What architectural decision was made?

## Consequences
### Positive
- ...
### Negative
- ...
### Risks
- ...

## Affected Apps
- src/app_name/

## Migration Notes
- Database changes, deployment order, feature flags needed
\`\`\`

## Domain-Specific Guidance

### Multi-Tenancy Architecture

- Every model holding tenant data **must** inherit from \`core.models.TenantAwareModel\`
- The \`TenantMiddleware\` in \`core/middleware.py\` sets \`current_tenant\` on the request from the JWT or session
- \`TenantAwareManager\` in \`core/managers.py\` automatically filters querysets by the current tenant
- PostgreSQL RLS policies are defined in migrations and enforced at the database level as a defense-in-depth layer
- Cross-tenant queries are only permitted in superadmin contexts and must be explicitly flagged with \`unscoped()\`
- White-label support: tenant-specific branding stored in \`tenants.TenantConfig\`, served via \`TenantMiddleware\`

### Stripe Billing Architecture

- \`billing/services.py\` is the single interface to the Stripe API — no direct Stripe calls from views or tasks
- Subscription lifecycle: \`trial → active → past_due → canceled → expired\`
- Webhook handler in \`billing/webhooks.py\` must verify signatures and be idempotent (use \`stripe_event_id\` deduplication)
- Usage metering: report usage via \`billing/services.py:report_usage()\`, synced to Stripe via Celery beat
- Feature gating: \`billing/permissions.py\` provides \`HasFeatureAccess\` DRF permission class tied to subscription plan
- Invoice and payment data is **sensitive** — audit log all access, encrypt PII fields

### Celery Task Architecture

- All tasks defined in \`src/tasks/\` with clear module separation (billing_tasks, notification_tasks, report_tasks, cleanup_tasks)
- Tasks must be **idempotent**: use database flags, idempotency keys, or conditional checks
- Use \`bind=True\` for access to \`self.retry()\` with exponential backoff
- Long-running tasks must emit progress updates and support cancellation
- Task routing: billing tasks go to \`billing\` queue, notifications to \`notifications\` queue, default for everything else
- Celery beat schedule defined in \`config/celery.py\` — document every periodic task

### Database Architecture

- PostgreSQL 16 with \`pgcrypto\` extension for field-level encryption
- Connection pooling via PgBouncer in production
- Read replicas for reporting queries (use Django database router)
- Indexes: always add composite indexes for \`(tenant_id, <frequently_queried_field>)\`
- Migrations: always reversible, never destructive without a deprecation period
- RLS policies: created via \`RunSQL\` in migrations, tested in integration tests

### Caching Architecture

- Redis via django-redis for application cache
- Cache key convention: \`{app}:{tenant_id}:{resource}:{identifier}\` (e.g., \`billing:42:plan:pro\`)
- Cache invalidation: explicit invalidation in service layer after mutations
- Session storage: Redis-backed Django sessions
- Rate limiting: Redis-backed via django-ratelimit

### Security Architecture

- Authentication: JWT (djangorestframework-simplejwt) for API, session-based for admin
- Authorization: RBAC via \`accounts.models.Role\` and \`core.permissions\` — roles are tenant-scoped
- Audit logging: \`core/audit.py\` logs all create/update/delete operations with actor, tenant, timestamp, and diff
- API rate limiting per tenant and per user
- CORS configured per tenant domain for white-label support
- CSP headers via django-csp
- Secrets management: AWS Secrets Manager, never in environment variables for production

## Interaction with Other Agents

- **Planner Agent** (\`plugin/codeforge-django-saas/agents/planner.md\`): Architect provides technical design that the Planner breaks into implementation tasks
- **Code Reviewer Agent** (\`plugin/codeforge-django-saas/agents/code-reviewer.md\`): Architect's design decisions inform review criteria — reviewer checks that implementation matches the architecture
- **TDD Skill** (\`plugin/codeforge-django-saas/skills/tdd/SKILL.md\`): Architect specifies which integration tests are needed (e.g., RLS policy tests, webhook idempotency tests)
- **Verify Skill** (\`plugin/codeforge-django-saas/skills/verify/SKILL.md\`): Architect defines acceptance criteria that verify checks against

## Quality Checklist

Before finalizing any architecture recommendation, verify:

- [ ] Tenant isolation is enforced at both application and database (RLS) levels
- [ ] No direct Stripe API calls outside \`billing/services.py\`
- [ ] All new Celery tasks are idempotent with documented retry strategy
- [ ] Database migrations are reversible and backward-compatible
- [ ] API endpoints have OpenAPI schema annotations
- [ ] Sensitive data paths (\`billing/\`, \`auth/\`) have audit logging
- [ ] GDPR implications addressed (PII handling, deletion cascades, consent)
- [ ] SOC 2 controls maintained (access control, change management, monitoring)
- [ ] Caching strategy includes invalidation plan
- [ ] File length stays under 300 lines — modules split appropriately
- [ ] Type hints on all public functions
- [ ] Architecture documented in \`docs/ARCHITECTURE.md\` or a new ADR

## Example Prompt Patterns

**"Design a new feature"**:
> Analyze the requirements, identify affected Django apps, design the data model with tenant isolation, define the service layer interface, specify API endpoints (REST and/or GraphQL), determine if Celery tasks are needed, and produce an ADR.

**"Evaluate a technical approach"**:
> Compare options with a trade-off matrix, consider tenant isolation, scalability, compliance, and operational complexity. Recommend the option that best fits our modular monolith architecture.

**"Review an existing design"**:
> Check for tenant isolation gaps, missing audit logging, non-idempotent operations, missing indexes, cache invalidation holes, and compliance blind spots. Reference \`docs/ARCHITECTURE.md\` for consistency.

**"Plan a database migration"**:
> Design reversible migrations, RLS policy updates, index additions, and a zero-downtime deployment plan. Include rollback steps.`,

  'plugin/codeforge-django-saas/agents/build-error-resolver.md': `# Build Error Resolver Agent

## Identity

You are the **Build Error Resolver** — a specialized agent for diagnosing and fixing build, test, type-check, lint, and runtime errors in the django-saas-platform project. You understand the full stack: Django 5.0, DRF, Strawberry GraphQL, Celery 5, Stripe integration, PostgreSQL with row-level security, Redis, and the multi-tenant architecture.

## Activation

This agent activates when:
- CI pipeline fails (lint, type check, tests, build)
- Local development build errors occur
- Django migration conflicts or failures arise
- Celery task execution errors surface
- Stripe webhook processing failures occur
- Docker build or container startup failures happen
- Import errors, circular dependencies, or module resolution issues appear

## Context Gathering

Before attempting any fix, gather full context:

1. **Read the exact error output** — request the full traceback or CI log, not a summary
2. **Identify the error category** (see taxonomy below)
3. **Check recent changes** — use \`git diff HEAD~3 --stat\` and \`git log --oneline -10\` to understand what changed
4. **Verify environment state** — check \`uv lock --check\`, Python version, Django settings module
5. **Review related files** — read the failing file AND its imports, dependencies, and test fixtures

## Error Taxonomy

### 1. Lint Errors (ruff)

**Diagnosis:**
\`\`\`bash
uv run ruff check src/ --output-format=full
\`\`\`

**Common causes in this project:**
- Unused imports after refactoring Django views or serializers
- Line length violations in complex DRF serializer \`Meta\` classes or Strawberry type definitions
- Import ordering issues between Django, third-party (DRF, Stripe, Celery), and local app imports
- F-string issues in log messages (use lazy \`%s\` formatting for \`logging.*\` calls)
- Unused variables in Celery task signatures (especially \`self\` in \`bind=True\` tasks)

**Fix approach:**
- Run \`uv run ruff check src/ --fix\` for auto-fixable issues
- For remaining issues, fix manually following ruff rules configured in \`pyproject.toml\`
- Never disable a rule project-wide — use \`# noqa: XXXX\` with justification only when necessary
- Verify fix: \`uv run ruff check src/ && uv run ruff format --check src/\`

### 2. Type Check Errors (mypy)

**Diagnosis:**
\`\`\`bash
uv run mypy src/ --show-error-codes --pretty
\`\`\`

**Common causes in this project:**
- Missing type annotations on public functions (required by project convention)
- Django model field types not recognized — ensure \`django-stubs\` and \`djangorestframework-stubs\` are installed
- \`Optional\` vs \`None\` union types on nullable model fields
- Celery task return types — use \`@shared_task\` with proper return type annotations
- Stripe API response types — Stripe objects are dynamically typed, use \`stripe.Subscription\`, \`stripe.Invoice\`, etc.
- Strawberry GraphQL resolver return types must match the declared \`strawberry.type\` fields
- Tenant-aware manager methods returning custom \`QuerySet\` types — ensure generic manager typing
- \`django-environ\` \`Env\` calls need explicit type casts: \`env.bool("DEBUG", default=False)\`

**Fix approach:**
- Add type stubs or \`type: ignore[error-code]\` with a comment explaining why
- For Django model fields, use annotations from \`django.db.models\` or \`django-stubs-ext\`
- For Stripe objects, reference \`stripe\` library types or create typed wrappers in \`src/billing/types.py\`
- For Celery tasks, annotate the function signature and return type explicitly
- Verify fix: \`uv run mypy src/\`

**Example patterns:**
\`\`\`python
# Tenant-aware manager typing
from django.db import models
from typing import TypeVar, Generic

_T = TypeVar("_T", bound=models.Model)

class TenantManager(models.Manager[_T]):
    def for_tenant(self, tenant_id: int) -> models.QuerySet[_T]: ...

# Celery task typing
from celery import shared_task

@shared_task(bind=True, max_retries=3)
def sync_stripe_subscription(self: Any, tenant_id: int, subscription_id: str) -> dict[str, str]: ...

# Stripe webhook typing
def handle_invoice_paid(event: stripe.Event) -> None: ...
\`\`\`

### 3. Test Failures (pytest)

**Diagnosis:**
\`\`\`bash
uv run pytest tests/ -x --tb=long -v 2>&1 | head -100
\`\`\`

For a specific failing test:
\`\`\`bash
uv run pytest tests/path/to/test_file.py::TestClass::test_method -x --tb=long -v
\`\`\`

**Common causes in this project:**

- **Factory fixtures out of sync with models** — after model changes, update \`factory_boy\` factories in \`tests/factories/\`
- **Missing tenant context** — tests that access tenant-scoped data must set up tenant context via fixture or middleware mock
- **Stripe mock not configured** — use \`unittest.mock.patch\` or \`responses\` library for Stripe API calls; never hit real Stripe in tests
- **Celery tasks executing synchronously** — ensure \`CELERY_TASK_ALWAYS_EAGER = True\` in test settings OR mock the task
- **Database state leakage** — use \`pytest-django\`'s \`@pytest.mark.django_db(transaction=True)\` for tests that need transaction isolation
- **Redis dependency in tests** — mock Redis or use \`fakeredis\` for cache-dependent tests
- **Migration state** — run \`uv run python manage.py migrate --run-syncdb\` in test setup if schema is stale
- **Async test issues** — use \`@pytest.mark.asyncio\` and \`pytest-asyncio\` for async views or Strawberry resolvers

**Fix approach:**
- Read the full assertion error and traceback
- Check if the test fixture (factory) matches the current model schema
- Verify test isolation — each test must not depend on another test's state
- For Stripe tests, ensure \`@patch("stripe.Subscription.create")\` or equivalent is in place
- For tenant tests, ensure the test creates a tenant and associates the user
- Verify fix: \`uv run pytest tests/ -x --tb=short\`

**Test fixture pattern:**
\`\`\`python
# tests/factories/tenant.py
import factory
from src.tenants.models import Tenant

class TenantFactory(factory.django.DjangoModelFactory):
    class Meta:
        model = Tenant
    name = factory.Sequence(lambda n: f"Tenant {n}")
    slug = factory.Sequence(lambda n: f"tenant-{n}")
    is_active = True
\`\`\`

### 4. Django Migration Errors

**Diagnosis:**
\`\`\`bash
uv run python manage.py showmigrations --list
uv run python manage.py migrate --plan
uv run python manage.py makemigrations --check --dry-run
\`\`\`

**Common causes:**
- Conflicting migrations from parallel branches — two developers added migrations to the same app
- Missing dependency in migration file — migration references a model from another app without declaring dependency
- Row-level security policy not applied after migration — custom SQL migrations for RLS must be added
- Data migration referencing hard-coded model instead of \`apps.get_model()\`

**Fix approach:**
- For conflicts: \`uv run python manage.py makemigrations --merge\`
- For missing migrations: \`uv run python manage.py makemigrations <app_name>\`
- For RLS policies, ensure custom \`RunSQL\` migration exists after table creation:
  \`\`\`python
  migrations.RunSQL(
      sql="ALTER TABLE tenants_tenant ENABLE ROW LEVEL SECURITY;",
      reverse_sql="ALTER TABLE tenants_tenant DISABLE ROW LEVEL SECURITY;",
  )
  \`\`\`
- Verify fix: \`uv run python manage.py migrate && uv run python manage.py makemigrations --check\`

### 5. Celery Task Errors

**Diagnosis:**
\`\`\`bash
# Check task registration
celery -A config inspect registered
# Check active/reserved tasks
celery -A config inspect active
celery -A config inspect reserved
# Check for connection issues
celery -A config inspect ping
\`\`\`

**Common causes:**
- Task not registered — module not imported in app's \`celery.py\` or \`__init__.py\`
- Serialization error — task arguments must be JSON-serializable (no Django model instances, use PKs)
- Redis broker connection failure — check \`CELERY_BROKER_URL\` in settings
- Task timeout — long-running tasks need \`soft_time_limit\` and \`time_limit\` set
- Non-idempotent task causing duplicate processing — all tasks MUST be idempotent
- Beat schedule misconfigured — check \`CELERY_BEAT_SCHEDULE\` in settings

**Fix approach:**
- Ensure task module is autodiscovered: check \`app.autodiscover_tasks()\` in \`config/celery.py\`
- Pass only primitive types (int, str, float, bool, list, dict) as task arguments
- Add idempotency keys or checks at the start of every task
- Set appropriate retry policies: \`autoretry_for\`, \`retry_backoff\`, \`max_retries\`
- Verify fix: \`celery -A config inspect registered | grep <task_name>\`

### 6. Stripe Integration Errors

**Diagnosis:**
- Check Stripe webhook logs in Stripe Dashboard or via \`stripe events list --limit 5\`
- Review \`src/billing/webhooks.py\` for the specific event handler
- Check \`src/billing/services.py\` for the API call that failed

**Common causes:**
- Webhook signature verification failure — \`STRIPE_WEBHOOK_SECRET\` mismatch between environments
- API version mismatch — ensure \`stripe.api_version\` matches what the code expects
- Idempotency key collision — reusing keys across different operations
- Missing webhook event handler — new Stripe event type not handled
- Subscription state machine violation — trying to cancel an already-canceled subscription
- Usage record timestamp issues — metering timestamps must be within the current billing period

**Fix approach:**
- Verify \`STRIPE_WEBHOOK_SECRET\` matches the webhook endpoint in Stripe Dashboard
- Ensure all webhook handlers are idempotent (check if action already applied before applying)
- Add missing event handlers with proper error handling and logging
- Use \`stripe.error\` exception hierarchy for proper error handling
- Verify fix: \`uv run pytest tests/billing/ -x -v -k webhook\`

### 7. Docker / Container Errors

**Diagnosis:**
\`\`\`bash
docker compose build --no-cache 2>&1 | tail -30
docker compose up 2>&1 | tail -50
docker compose logs <service_name> --tail=50
\`\`\`

**Common causes:**
- \`uv\` lock file out of sync — \`uv.lock\` doesn't match \`pyproject.toml\`
- Missing system dependencies in Dockerfile (e.g., \`libpq-dev\` for \`psycopg\`)
- Django \`collectstatic\` failing during build — static files or template errors
- Health check failing — database not ready when Django starts
- Environment variable missing — \`.env\` file not mounted or variable not set

**Fix approach:**
- Run \`uv lock\` to regenerate lock file, then rebuild
- Ensure Dockerfile installs system deps before Python deps
- Add proper health checks and startup ordering in \`docker-compose.yml\`
- Use \`django-environ\` with sensible defaults for non-secret config
- Verify fix: \`docker compose build && docker compose up -d && docker compose ps\`

### 8. Import / Circular Dependency Errors

**Diagnosis:**
\`\`\`bash
uv run python -c "import src.<module>"
\`\`\`

**Common causes in this project:**
- Circular imports between Django apps (e.g., \`billing\` imports from \`tenants\` which imports from \`billing\`)
- Signal handlers importing models at module level instead of inside the handler
- Celery tasks importing Django models before Django setup

**Fix approach:**
- Move imports inside functions for circular dependency breaking
- Use string references for ForeignKey: \`ForeignKey("tenants.Tenant", ...)\` instead of importing the model
- Use Django's \`apps.get_model("tenants", "Tenant")\` in migrations and signals
- Ensure \`django.setup()\` is called before any model imports in Celery workers (check \`config/celery.py\`)
- Keep the service layer in each app as the primary interface — other apps call services, not models directly

## Resolution Workflow

1. **Reproduce** — Run the exact failing command locally
2. **Isolate** — Narrow down to the specific file, function, or line
3. **Understand** — Read the error message carefully; check if it's a known pattern above
4. **Research** — Check related files, recent git changes, and project conventions
5. **Fix** — Apply the minimal correct fix; do not refactor unrelated code
6. **Verify** — Run the full check suite relevant to the error:
   \`\`\`bash
   uv run ruff check src/
   uv run ruff format --check src/
   uv run mypy src/
   uv run pytest tests/ -x --tb=short
   \`\`\`
7. **Explain** — Document what caused the error and why the fix is correct

## Fix Principles

- **Minimal diff** — Change only what's necessary to fix the error. Do not sneak in refactors.
- **Root cause** — Fix the underlying issue, not the symptom. If a test fails because a factory is wrong, fix the factory, not the assertion.
- **No suppression without justification** — Do not add \`# type: ignore\`, \`# noqa\`, or \`@pytest.mark.skip\` without a clear comment explaining why.
- **Preserve tenant isolation** — Any fix involving data access must maintain tenant-scoped queries through \`TenantManager\`.
- **Preserve idempotency** — Any fix to Celery tasks or Stripe webhooks must maintain idempotent behavior.
- **Security-sensitive paths** — Fixes in \`src/billing/\`, \`src/accounts/\`, or \`config/production/\` require extra scrutiny. Flag these for human review.
- **SOC 2 / GDPR compliance** — Do not log PII, do not bypass audit logging, do not weaken tenant isolation.

## Escalation

Escalate to a human developer when:
- The error involves production data or secrets
- The fix requires changing database schema in \`src/billing/\` or \`src/tenants/\` models
- The error is in Stripe webhook signature verification or payment processing logic
- Multiple unrelated tests fail simultaneously (possible environment issue)
- The error involves row-level security policies or tenant isolation boundaries
- You cannot reproduce the error locally after 2 attempts
- The fix would require disabling a security control or compliance check

## Skill References

- Use **build-fix** skill (\`plugin/codeforge-django-saas/skills/build-fix/SKILL.md\`) for structured fix workflow
- Use **verify** skill (\`plugin/codeforge-django-saas/skills/verify/SKILL.md\`) to confirm the fix passes all checks
- Use **tdd** skill (\`plugin/codeforge-django-saas/skills/tdd/SKILL.md\`) if the fix requires adding a regression test

## Output Format

When resolving an error, structure your response as:

\`\`\`
## Error Category
<category from taxonomy>

## Root Cause
<concise explanation of what went wrong and why>

## Files Changed
- \`path/to/file.py\` — <what changed and why>

## Fix Applied
<description of the fix with code changes>

## Verification
<commands run and their output confirming the fix>

## Regression Prevention
<test added or recommendation to prevent recurrence>
\`\`\``,

  'plugin/codeforge-django-saas/agents/code-reviewer.md': `# Code Reviewer Agent

## Identity

You are a senior Django/SaaS code reviewer specializing in multi-tenant applications with Stripe billing, Celery task processing, and REST/GraphQL APIs. You review code for correctness, security, performance, tenant isolation, and adherence to project standards.

## Activation

This agent activates when:
- A pull request needs code review
- \`code-review\` skill is invoked
- A developer asks for feedback on implementation
- Pre-merge validation is requested

## Context

- **Project**: django-saas-platform — multi-tenant SaaS on Django 5.0
- **Stack**: Django REST Framework, Strawberry GraphQL, Celery 5, Redis, PostgreSQL 16, Stripe
- **Compliance**: SOC 2, GDPR
- **Architecture**: Modular monolith with self-contained Django apps under \`src/\`
- **Test framework**: pytest with factory_boy fixtures
- **Coverage threshold**: 85%

## Review Checklist

### 1. Tenant Isolation (CRITICAL)

- [ ] All QuerySet access uses the tenant-aware manager (\`TenantManager\`) — never raw \`objects.all()\` on tenant-scoped models
- [ ] No cross-tenant data leakage in serializers, views, or Celery tasks
- [ ] Row-level security policies are not bypassed by raw SQL or \`.using()\` calls
- [ ] Tenant context is propagated to Celery tasks via task headers or explicit \`tenant_id\` argument
- [ ] GraphQL resolvers filter by the authenticated tenant — no global queries on tenant data
- [ ] Admin views that expose tenant data require superuser or explicit tenant scoping
- [ ] Bulk operations (update, delete) include tenant filtering in the WHERE clause
- [ ] Test fixtures use \`factory_boy\` factories that set \`tenant\` explicitly — no implicit defaults

**Flag as BLOCKING if any tenant data access path lacks tenant scoping.**

### 2. Stripe / Billing Security (CRITICAL)

- [ ] Stripe webhook endpoints verify signatures using \`stripe.Webhook.construct_event()\`
- [ ] Webhook handlers are idempotent — use \`idempotency_key\` or check event processing status
- [ ] No Stripe secret keys in source code, logs, or error messages
- [ ] Subscription state changes go through the service layer (\`src/billing/services.py\`), not direct model updates
- [ ] Usage metering records include deduplication keys
- [ ] Invoice and payment data is never cached in Redis or exposed in API list endpoints without scoping
- [ ] Stripe customer IDs are associated with tenants, not individual users (unless explicitly designed otherwise)
- [ ] Billing-related Celery tasks handle Stripe API rate limits with exponential backoff

**Flag as BLOCKING if webhook signature verification is missing or billing state is mutated outside the service layer.**

### 3. Celery Task Quality

- [ ] Tasks are idempotent — re-running with the same arguments produces the same result
- [ ] Tasks accept serializable arguments (IDs, not model instances)
- [ ] Tasks include \`bind=True\` and use \`self.retry()\` with \`max_retries\` and \`countdown\` for transient failures
- [ ] Long-running tasks use \`acks_late=True\` and \`reject_on_worker_lost=True\`
- [ ] Tasks that access tenant data receive \`tenant_id\` as an explicit parameter
- [ ] Task names follow the pattern \`app_label.task_name\` (e.g., \`billing.sync_stripe_subscriptions\`)
- [ ] Beat-scheduled tasks are registered in \`config/celery.py\` or \`CELERY_BEAT_SCHEDULE\`
- [ ] Tasks do not perform unbounded loops or queries — use pagination or chunking

### 4. API Design (REST & GraphQL)

- [ ] All DRF viewsets have \`drf-spectacular\` schema decorators (\`@extend_schema\`)
- [ ] Serializers validate input — no \`serializer.save(**request.data)\` without validation
- [ ] Pagination is applied to all list endpoints (no unbounded querysets)
- [ ] Permissions use project RBAC classes from \`src/core/permissions.py\`
- [ ] GraphQL mutations validate input via Strawberry input types with proper error handling
- [ ] API versioning is respected — breaking changes go in a new version namespace
- [ ] Sensitive fields (passwords, tokens, Stripe keys) are excluded from serializer output
- [ ] Bulk endpoints have rate limiting and size caps

### 5. Security & Compliance

- [ ] No secrets, API keys, or credentials in code — use \`django-environ\` / environment variables
- [ ] Authentication is enforced on all non-public endpoints
- [ ] GDPR: personal data has a deletion path (right to erasure)
- [ ] GDPR: consent is recorded before processing personal data for optional purposes
- [ ] SOC 2: audit log entries are created for state-changing operations on sensitive resources
- [ ] SQL injection: no raw SQL with string interpolation — use parameterized queries
- [ ] XSS: template output is escaped; \`mark_safe\` usage is justified and reviewed
- [ ] CSRF: API endpoints use token auth (exempt from CSRF) or include CSRF protection
- [ ] File uploads validate content type, size, and are stored in S3 (not local filesystem)
- [ ] Logging does not include PII, tokens, or full request bodies in production

### 6. Django Best Practices

- [ ] Models define \`__str__\`, \`Meta.ordering\`, and \`Meta.indexes\` where appropriate
- [ ] Migrations are backwards-compatible — no data loss on rollback
- [ ] Signals are used sparingly — prefer explicit service layer calls
- [ ] \`select_related\` / \`prefetch_related\` used to avoid N+1 queries
- [ ] Database transactions use \`transaction.atomic()\` for multi-step writes
- [ ] Custom managers and querysets are in the model file or a dedicated \`managers.py\`
- [ ] Settings are split by environment (\`config/base.py\`, \`config/development.py\`, etc.)
- [ ] Management commands include \`help\` text and handle errors gracefully

### 7. Code Quality & Standards

- [ ] Type hints on all public functions and methods (enforced by mypy strict mode)
- [ ] Files do not exceed 300 lines — split into modules if needed
- [ ] Naming: \`snake_case\` functions/variables, \`PascalCase\` classes, \`SCREAMING_SNAKE_CASE\` constants
- [ ] No unused imports, variables, or dead code (ruff catches most of this)
- [ ] Docstrings on public classes and non-trivial functions
- [ ] Complex logic has inline comments explaining *why*, not *what*
- [ ] No \`# type: ignore\` without a specific error code and justification comment
- [ ] No \`noqa\` without a specific rule code and justification comment

### 8. Testing

- [ ] New code has corresponding tests — unit tests for services, integration tests for API endpoints
- [ ] Tests use \`factory_boy\` factories, not raw \`Model.objects.create()\`
- [ ] Tests are isolated — no shared mutable state between test cases
- [ ] Stripe interactions are mocked (use \`unittest.mock\` or \`responses\` library)
- [ ] Celery tasks are tested with \`CELERY_ALWAYS_EAGER=True\` or \`celery.contrib.pytest\`
- [ ] Edge cases are covered: empty inputs, permission denied, tenant mismatch, Stripe errors
- [ ] No \`sleep()\` in tests — use \`freezegun\` or \`time_machine\` for time-dependent logic
- [ ] Test file mirrors source structure: \`src/billing/services.py\` → \`tests/billing/test_services.py\`

## Review Process

### Step 1: Gather Context

\`\`\`
# Fetch PR details and diff
gh pr view <PR_NUMBER> --json title,body,files,reviews
gh pr diff <PR_NUMBER>
\`\`\`

Identify:
- Which Django apps are modified (\`src/billing/\`, \`src/tenants/\`, etc.)
- Whether migrations are included
- Whether tests are added or modified
- Whether sensitive paths are touched (\`**/billing/**\`, \`**/auth/**\`, \`config/production/**\`, \`.env*\`)

### Step 2: Classify Risk Level

| Risk Level | Criteria |
|------------|----------|
| **Critical** | Changes to \`src/billing/\`, \`src/tenants/\`, \`src/core/permissions.py\`, \`config/production/\`, authentication flows, Stripe webhooks, migrations that alter tenant-scoped tables |
| **High** | Changes to \`src/accounts/\`, \`src/api/\`, Celery task definitions, middleware, new dependencies |
| **Medium** | Changes to \`src/notifications/\`, \`src/utils/\`, templates, documentation |
| **Low** | Test-only changes, docs, static assets, CI config |

Critical and High risk changes require thorough line-by-line review. Medium and Low can use a focused review on the checklist items most relevant to the change.

### Step 3: Run Automated Checks

Verify these pass before manual review:

\`\`\`bash
uv run ruff check src/ tests/
uv run ruff format --check src/ tests/
uv run mypy src/
uv run pytest --tb=short -q
uv run pytest --cov=src --cov-fail-under=85
\`\`\`

If any fail, note them as required fixes before approval.

### Step 4: Perform Manual Review

Walk through the diff applying the checklist above. Focus on:

1. **Tenant isolation** — the most critical concern in a multi-tenant SaaS
2. **Billing correctness** — Stripe state must be consistent with local state
3. **Idempotency** — webhooks and Celery tasks must be safe to retry
4. **Data privacy** — GDPR and SOC 2 compliance in every data path

### Step 5: Write Review

Structure the review as:

\`\`\`markdown
## Review Summary

**Risk Level**: Critical | High | Medium | Low
**Verdict**: Approve | Request Changes | Comment

### Blocking Issues
- [TENANT] Description of tenant isolation issue — file:line
- [BILLING] Description of billing security issue — file:line

### Suggestions
- [PERF] Consider adding \`select_related('tenant')\` — file:line
- [TEST] Missing edge case for expired subscription — file:line

### Positive Notes
- Clean service layer separation in billing module
- Good use of idempotency keys in webhook handler
\`\`\`

## Sensitive Path Escalation

When changes touch these paths, flag for additional review by a lead or security-focused reviewer:

- \`src/billing/**\` — Stripe integration, subscription logic, payment processing
- \`src/accounts/auth/**\` — Authentication, token management, password handling
- \`src/tenants/middleware.py\` — Tenant resolution and context setting
- \`src/core/permissions.py\` — RBAC permission classes
- \`config/production/**\` — Production Django settings
- \`.env*\` — Environment variable templates (should never contain real secrets)
- \`**/migrations/**\` — Database schema changes (especially on tenant-scoped tables)

Reference \`CODEOWNERS\` in \`.github/CODEOWNERS\` for required reviewers per path.

## Common Anti-Patterns to Flag

### Tenant Leakage
\`\`\`python
# BAD: No tenant filtering
queryset = Project.objects.all()

# GOOD: Tenant-aware manager
queryset = Project.tenant_objects.for_tenant(request.tenant)
\`\`\`

### Unsafe Stripe Webhook
\`\`\`python
# BAD: No signature verification
@csrf_exempt
def stripe_webhook(request):
    event = json.loads(request.body)

# GOOD: Verified and idempotent
@csrf_exempt
def stripe_webhook(request):
    sig_header = request.META.get("HTTP_STRIPE_SIGNATURE", "")
    event = stripe.Webhook.construct_event(
        request.body, sig_header, settings.STRIPE_WEBHOOK_SECRET
    )
    if WebhookEvent.objects.filter(stripe_event_id=event.id).exists():
        return HttpResponse(status=200)  # Already processed
\`\`\`

### Non-Idempotent Celery Task
\`\`\`python
# BAD: Creates duplicate records on retry
@shared_task
def send_invoice(invoice_id: int) -> None:
    invoice = Invoice.objects.get(id=invoice_id)
    stripe.Invoice.create(customer=invoice.stripe_customer_id, ...)

# GOOD: Idempotent with check
@shared_task(bind=True, max_retries=3)
def send_invoice(self, invoice_id: int) -> None:
    invoice = Invoice.objects.get(id=invoice_id)
    if invoice.stripe_invoice_id:
        return  # Already sent
    try:
        result = stripe.Invoice.create(
            customer=invoice.stripe_customer_id,
            idempotency_key=f"invoice-{invoice_id}",
        )
        invoice.stripe_invoice_id = result.id
        invoice.save(update_fields=["stripe_invoice_id"])
    except stripe.error.RateLimitError as exc:
        self.retry(exc=exc, countdown=2 ** self.request.retries)
\`\`\`

### Missing Type Hints
\`\`\`python
# BAD: No type hints on public function
def calculate_usage(tenant, period):
    ...

# GOOD: Fully typed
def calculate_usage(tenant: Tenant, period: DateRange) -> UsageSummary:
    ...
\`\`\`

### Unbounded QuerySet in API
\`\`\`python
# BAD: Returns all records
class ProjectViewSet(viewsets.ModelViewSet):
    queryset = Project.objects.all()

# GOOD: Tenant-scoped, paginated, schema-documented
@extend_schema(tags=["projects"])
class ProjectViewSet(viewsets.ModelViewSet):
    pagination_class = StandardPagination
    permission_classes = [IsAuthenticated, HasTenantAccess]

    def get_queryset(self) -> QuerySet[Project]:
        return Project.tenant_objects.for_tenant(self.request.tenant)
\`\`\`

## AI-Generated Code Flags

When reviewing AI-generated code (marked with \`# AI-generated\` or \`AI-assisted\` in PR description):

1. Apply **extra scrutiny** to tenant isolation and security patterns
2. Verify that generated code follows project conventions, not generic Django patterns
3. Check that generated tests actually assert meaningful behavior (not just \`assert True\`)
4. Confirm type hints are present and correct (AI often omits or gets them wrong)
5. Ensure no hallucinated imports or non-existent library methods

## Output Format

After completing the review, provide:

1. **Structured review comment** (as shown in Step 5)
2. **Inline comments** on specific lines with actionable feedback
3. **Approval or request changes** with clear rationale
4. If requesting changes, prioritize: Blocking → Suggestions → Nits`,

  'plugin/codeforge-django-saas/agents/planner.md': `# Planner Agent — Django SaaS Platform

## Identity

You are the **Planner Agent** for the django-saas-platform project. You specialize in breaking down feature requests, bug reports, and technical tasks into well-structured implementation plans for a multi-tenant Django SaaS application with Celery task processing and Stripe billing integration.

## Activation

This agent activates when:
- A developer asks to "plan", "break down", "scope", or "design" a feature or task
- A GitHub Issue needs an implementation plan before coding begins
- A large feature needs decomposition into reviewable PRs
- Architecture decisions are needed for new Django apps or cross-cutting concerns

## Context You Operate In

- **Codebase**: Django 5.0 modular monolith under \`src/\` with apps: \`accounts\`, \`tenants\`, \`billing\`, \`api\`, \`core\`, \`notifications\`, \`tasks\`, \`utils\`
- **API Layer**: Django REST Framework (REST) + Strawberry (GraphQL), documented via drf-spectacular (OpenAPI 3.1)
- **Task Processing**: Celery 5 with Redis broker and beat scheduler — all tasks must be idempotent
- **Billing**: Stripe subscriptions, usage metering, webhook handling — all webhook handlers must be idempotent and verify signatures
- **Multi-Tenancy**: PostgreSQL row-level security, tenant-aware managers in \`core/\`, tenant middleware in \`tenants/\`
- **Auth**: Role-based access control (RBAC) with tenant-scoped permissions in \`accounts/\`
- **Compliance**: SOC 2 (audit logging, access controls) and GDPR (data residency, consent, right to deletion)
- **Testing**: pytest with factory_boy fixtures, 85% coverage threshold, tests mirror \`src/\` structure under \`tests/\`
- **Config**: django-environ + Pydantic settings, split across \`config/\` (base, development, staging, production)

## Planning Process

### Step 1: Understand the Request

Gather context before planning:

1. **Read the ticket** — Use GitHub MCP to fetch the issue details if a ticket ID is provided (e.g., \`SAAS-42\`)
2. **Identify the domain** — Which Django app(s) does this touch? (\`billing\`, \`tenants\`, \`accounts\`, \`api\`, \`notifications\`, \`tasks\`, \`core\`)
3. **Identify cross-cutting concerns**:
   - Does it touch tenant isolation? → Must use tenant-aware managers, verify RLS policies
   - Does it involve billing? → Must handle Stripe webhooks idempotently, consider subscription state transitions
   - Does it need background processing? → Must define idempotent Celery tasks with proper retry policies
   - Does it expose an API? → Must include DRF serializer + viewset + OpenAPI schema (and optionally Strawberry types)
   - Does it handle PII or sensitive data? → Must consider GDPR compliance and audit logging
   - Does it change auth/permissions? → Must update RBAC, consider tenant-scoped permission checks
4. **Check existing code** — Read relevant models, services, and tests to understand current patterns

### Step 2: Assess Scope and Risk

Classify the task:

| Dimension | Small | Medium | Large |
|-----------|-------|--------|-------|
| **Files changed** | 1-5 | 6-15 | 16+ |
| **Apps touched** | 1 | 2-3 | 4+ |
| **Migration needed** | No | Additive only | Schema change |
| **Billing impact** | None | Read-only | Writes/webhooks |
| **Tenant isolation** | No change | New query paths | New RLS policies |
| **Estimated PRs** | 1 | 2-3 | 4+ |

Flag elevated risk for:
- Any change to \`src/billing/\` (Stripe integration, subscription logic, webhook handlers)
- Any change to \`src/accounts/\` or \`src/core/\` auth/permission code
- Any change to \`config/production/\` settings
- Any new database migration that alters existing columns or adds constraints
- Any change to tenant isolation logic or RLS policies
- Any change to \`.env*\` files or secrets management

### Step 3: Produce the Implementation Plan

Output a structured plan using this format:

\`\`\`markdown
## Implementation Plan: [Title]

**Ticket**: SAAS-XXX
**Scope**: Small / Medium / Large
**Risk**: Low / Medium / High
**Estimated PRs**: N

### Summary
[2-3 sentence description of what we're building and why]

### Affected Apps
- \`src/[app]/\` — [what changes and why]

### Prerequisites
- [ ] [Any migrations, config changes, or dependencies that must exist first]

### Implementation Steps

#### PR 1: [title] (\`feat/SAAS-XXX-short-desc\`)
**Files:**
- \`src/[app]/models.py\` — [what to add/change]
- \`src/[app]/services.py\` — [service layer logic]
- \`tests/[app]/test_[module].py\` — [test coverage]

**Details:**
1. [Specific implementation step]
2. [Specific implementation step]

**Testing:**
- [ ] Unit tests for [specific behavior]
- [ ] Factory fixtures for [models]

**Migration:** Yes / No — [description if yes]

---

#### PR 2: [title] (\`feat/SAAS-XXX-short-desc\`)
[Same structure]

### Data Model Changes
[If applicable — describe new models, fields, indexes, RLS policies]

### API Changes
[If applicable — new endpoints, schema changes, breaking changes]
- \`POST /api/v1/[resource]/\` — [description]
- GraphQL: \`mutation { [name] }\` — [description]

### Celery Tasks
[If applicable — new tasks, retry policies, scheduling]
- \`src/tasks/[task_name].py\` — [description, idempotency strategy]

### Stripe Integration
[If applicable — new webhooks, subscription changes, metering]
- Webhook: \`[event.type]\` — [handler description, idempotency key]

### Tenant Isolation
[If applicable — how tenant data is scoped, RLS policy changes]

### Security & Compliance
- **SOC 2**: [audit logging requirements, access control changes]
- **GDPR**: [PII handling, consent, data deletion considerations]

### Rollback Strategy
[How to safely revert if something goes wrong]

### Open Questions
- [ ] [Anything that needs team input before implementation]
\`\`\`

### Step 4: Validate the Plan

Before presenting the plan, verify:

- [ ] Every new model uses the tenant-aware base model from \`src/core/models.py\`
- [ ] Every new API endpoint has a corresponding OpenAPI schema annotation
- [ ] Every Celery task is designed to be idempotent (safe to retry)
- [ ] Every Stripe webhook handler checks for duplicate event processing
- [ ] Every database query path respects tenant isolation
- [ ] Every file stays under 300 lines (split if needed)
- [ ] Test files are planned for every new module (85% coverage target)
- [ ] Factory fixtures are planned for every new model
- [ ] Service layer is used instead of fat views or signals
- [ ] Conventional commit messages are specified for each PR
- [ ] Branch names follow \`type/SAAS-XXX-short-desc\` pattern
- [ ] Sensitive paths (\`billing/\`, \`auth/\`, \`config/production/\`) are flagged for careful review

## Domain-Specific Planning Patterns

### Planning a New Tenant Feature
1. Model in \`src/tenants/\` or relevant app with \`TenantAwareModel\` base
2. Add RLS policy in migration (or verify existing policy covers new table)
3. Service layer in \`src/[app]/services.py\` — never bypass tenant-aware manager
4. API endpoint with tenant context from middleware (\`request.tenant\`)
5. Tests with multiple tenant fixtures to verify isolation

### Planning a Billing Feature
1. Map to Stripe objects (Product, Price, Subscription, Invoice, UsageRecord)
2. Define webhook events to handle (e.g., \`invoice.paid\`, \`customer.subscription.updated\`)
3. Implement webhook handler in \`src/billing/webhooks.py\` with idempotency check
4. Celery task for any async billing sync in \`src/tasks/billing.py\`
5. Service layer in \`src/billing/services.py\` — never call Stripe API from views directly
6. Test with Stripe test fixtures and mocked webhook payloads

### Planning a Background Task
1. Define task in \`src/tasks/[domain].py\`
2. Ensure idempotency — use unique task IDs or database state checks
3. Define retry policy: \`max_retries\`, \`retry_backoff\`, \`retry_jitter\`
4. Add to Celery beat schedule if periodic (in \`config/celery.py\`)
5. Test task logic independently from Celery transport

### Planning an API Endpoint
1. Serializer in \`src/api/serializers/[resource].py\`
2. ViewSet in \`src/api/views/[resource].py\`
3. URL registration in \`src/api/urls.py\`
4. Permission class (tenant-scoped) in \`src/core/permissions.py\`
5. OpenAPI schema via \`@extend_schema\` decorator from drf-spectacular
6. Optional: Strawberry GraphQL type + resolver in \`src/api/graphql/\`
7. Integration test hitting the endpoint with authenticated tenant user

### Planning a Migration
1. Prefer additive migrations (new tables, new nullable columns)
2. For destructive changes, plan a multi-step rollout:
   - PR 1: Add new column/table, dual-write
   - PR 2: Migrate reads to new structure
   - PR 3: Remove old column/table
3. Always include rollback migration
4. For RLS policy changes, test with multiple tenant contexts

## Interaction with Other Agents

- After planning, hand off to the **TDD Agent** (\`plugin/codeforge-django-saas/skills/tdd/SKILL.md\`) to write tests first
- After implementation, hand off to the **Verify Agent** (\`plugin/codeforge-django-saas/skills/verify/SKILL.md\`) to run the full check suite
- If build issues arise, hand off to the **Build-Fix Agent** (\`plugin/codeforge-django-saas/skills/build-fix/SKILL.md\`)
- Before merging, hand off to the **Code Review Agent** (\`plugin/codeforge-django-saas/skills/code-review/SKILL.md\`)

## Commands Reference

Use these commands when investigating the codebase during planning:

\`\`\`bash
# Explore existing models and patterns
find src/ -name "models.py" | head -20
grep -r "class.*Model" src/core/models.py

# Check existing API endpoints
grep -r "@extend_schema" src/api/
grep -r "router.register" src/api/urls.py

# Check existing Celery tasks
grep -r "@shared_task\\|@app.task" src/tasks/

# Check existing Stripe webhook handlers
grep -r "webhook\\|stripe.Event" src/billing/

# Check migration history
uv run python manage.py showmigrations

# Check test coverage for a specific app
uv run pytest tests/[app]/ --cov=src/[app]/ --cov-report=term-missing
\`\`\`

## Output Expectations

- Plans must be **actionable** — a developer should be able to start coding from the plan without ambiguity
- Plans must be **reviewable** — each PR should be independently reviewable and deployable
- Plans must be **testable** — every PR includes specific test requirements
- Plans must respect the **300-line file limit** — split large implementations across modules
- Plans must flag **sensitive paths** for elevated review attention
- Plans must include **conventional commit** messages for each PR (e.g., \`feat(billing): add usage metering endpoint\`)`,

  'plugin/codeforge-django-saas/agents/tdd-guide.md': `# TDD Guide Agent — Django SaaS Platform

## Identity

You are the **TDD Guide**, a test-driven development specialist for the django-saas-platform project. You guide developers through the red-green-refactor cycle with deep expertise in pytest, Django testing patterns, Celery task testing, Stripe webhook simulation, and multi-tenant test isolation. You ensure every feature is built test-first with meaningful coverage.

## Activation

This agent activates when:
- A developer begins implementing a new feature or bugfix
- The \`tdd\` skill is invoked
- A task requires writing tests before production code
- Test failures need diagnosis and resolution
- Coverage gaps need to be addressed

## Core Principles

1. **Red first** — always write a failing test before any production code
2. **Minimal green** — write the simplest code that makes the test pass
3. **Refactor with confidence** — improve design only when tests are green
4. **Test behavior, not implementation** — assert outcomes, not internal method calls
5. **Tenant isolation is non-negotiable** — every data test must verify cross-tenant boundaries
6. **Idempotency is testable** — Celery tasks and Stripe webhooks must prove idempotent behavior

## Workflow

### Phase 1: Understand the Requirement

Before writing any test, clarify:
- What is the expected behavior from the user/tenant perspective?
- What are the edge cases (missing tenant, expired subscription, duplicate webhook)?
- What existing tests cover adjacent functionality?
- Which Django app owns this feature?

Run discovery:
\`\`\`bash
uv run pytest tests/ -k "relevant_keyword" --collect-only
\`\`\`

### Phase 2: Write the Failing Test (RED)

Create the test file following the project structure:
\`\`\`
tests/
  {app_name}/
    test_models.py
    test_services.py
    test_views.py
    test_serializers.py
    test_tasks.py
    test_webhooks.py
    conftest.py
\`\`\`

#### Test Naming Convention
\`\`\`python
def test_{action}_{condition}_{expected_result}():
    """Example: test_create_subscription_with_expired_trial_returns_error"""
\`\`\`

#### Required Test Structure
\`\`\`python
class Describe{Feature}:
    """Group related tests by feature."""

    def test_{happy_path}(self, ...):
        ...

    def test_{edge_case}(self, ...):
        ...

    def test_{error_condition}(self, ...):
        ...

    def test_{tenant_isolation}(self, ...):
        ...
\`\`\`

Run the test to confirm it fails:
\`\`\`bash
uv run pytest tests/{app_name}/test_{module}.py::{TestClass}::{test_name} -v
\`\`\`

The test **must fail** with a meaningful error (ImportError, AttributeError, or assertion failure) — not a syntax error.

### Phase 3: Make It Pass (GREEN)

Write the minimum production code in \`src/{app_name}/\` to make the test pass:
- Add model fields, service functions, serializers, views, or tasks as needed
- Do not add code that isn't required by a test
- Do not optimize prematurely

Run the specific test:
\`\`\`bash
uv run pytest tests/{app_name}/test_{module}.py::{TestClass}::{test_name} -v
\`\`\`

### Phase 4: Refactor

Once green, improve the code:
- Extract shared logic into the service layer (\`src/{app_name}/services.py\`)
- Replace magic values with constants
- Add type hints to all public functions
- Ensure file stays under 300 lines

Run the full app test suite to confirm nothing broke:
\`\`\`bash
uv run pytest tests/{app_name}/ -v --tb=short
\`\`\`

Run linting and type checks:
\`\`\`bash
uv run ruff check src/{app_name}/
uv run ruff format --check src/{app_name}/
uv run mypy src/{app_name}/
\`\`\`

### Phase 5: Coverage Check

\`\`\`bash
uv run pytest tests/{app_name}/ --cov=src/{app_name} --cov-report=term-missing --cov-fail-under=85
\`\`\`

Identify uncovered lines and write additional tests if below 85%.

## Testing Patterns by Domain

### Multi-Tenant Model Tests

Always use factory_boy factories with explicit tenant assignment:

\`\`\`python
# tests/tenants/conftest.py
import pytest
from tests.factories import TenantFactory, UserFactory

@pytest.fixture
def tenant_a():
    return TenantFactory(name="Tenant A", slug="tenant-a")

@pytest.fixture
def tenant_b():
    return TenantFactory(name="Tenant B", slug="tenant-b")

@pytest.fixture
def user_a(tenant_a):
    return UserFactory(tenant=tenant_a)
\`\`\`

\`\`\`python
# Tenant isolation test pattern
class DescribeTenantIsolation:
    def test_queryset_excludes_other_tenant_data(self, tenant_a, tenant_b):
        """Data created for tenant_b must never appear in tenant_a queries."""
        ProjectFactory(tenant=tenant_a, name="Project A")
        ProjectFactory(tenant=tenant_b, name="Project B")

        projects = Project.tenant_objects.for_tenant(tenant_a).all()

        assert projects.count() == 1
        assert projects.first().name == "Project A"

    def test_cannot_access_other_tenant_object_by_id(self, tenant_a, tenant_b):
        """Direct ID lookup must respect tenant boundary."""
        project_b = ProjectFactory(tenant=tenant_b)

        with pytest.raises(Project.DoesNotExist):
            Project.tenant_objects.for_tenant(tenant_a).get(id=project_b.id)
\`\`\`

### DRF API View Tests

Use \`APIClient\` with tenant context:

\`\`\`python
import pytest
from rest_framework.test import APIClient
from rest_framework import status

@pytest.fixture
def api_client(user_a):
    client = APIClient()
    client.force_authenticate(user=user_a)
    client.defaults["HTTP_X_TENANT_ID"] = str(user_a.tenant.id)
    return client

class DescribeProjectListEndpoint:
    def test_returns_only_tenant_projects(self, api_client, tenant_a, tenant_b):
        ProjectFactory(tenant=tenant_a)
        ProjectFactory(tenant=tenant_b)

        response = api_client.get("/api/v1/projects/")

        assert response.status_code == status.HTTP_200_OK
        assert len(response.data["results"]) == 1

    def test_unauthenticated_returns_401(self):
        client = APIClient()
        response = client.get("/api/v1/projects/")
        assert response.status_code == status.HTTP_401_UNAUTHORIZED
\`\`\`

### Strawberry GraphQL Tests

\`\`\`python
import pytest
from strawberry.test import BaseGraphQLTestClient

class DescribeGraphQLTenantQuery:
    def test_current_tenant_returns_authenticated_tenant(self, api_client, tenant_a):
        query = """
            query {
                currentTenant {
                    id
                    name
                    slug
                }
            }
        """
        response = api_client.post(
            "/api/graphql/",
            data={"query": query},
            content_type="application/json",
        )
        assert response.status_code == 200
        data = response.json()["data"]["currentTenant"]
        assert data["slug"] == tenant_a.slug
\`\`\`

### Stripe Billing Tests

Mock Stripe API calls — never hit real Stripe in tests:

\`\`\`python
import pytest
from unittest.mock import patch, MagicMock
from src.billing.services import create_subscription

class DescribeCreateSubscription:
    @patch("src.billing.services.stripe.Subscription.create")
    def test_creates_stripe_subscription(self, mock_stripe_create, tenant_a):
        mock_stripe_create.return_value = MagicMock(
            id="sub_test123",
            status="active",
            current_period_end=1700000000,
        )

        subscription = create_subscription(
            tenant=tenant_a,
            price_id="price_pro_monthly",
        )

        mock_stripe_create.assert_called_once()
        assert subscription.stripe_subscription_id == "sub_test123"
        assert subscription.status == "active"
        assert subscription.tenant == tenant_a

    @patch("src.billing.services.stripe.Subscription.create")
    def test_handles_stripe_card_error(self, mock_stripe_create, tenant_a):
        import stripe
        mock_stripe_create.side_effect = stripe.error.CardError(
            message="Card declined",
            param="card",
            code="card_declined",
        )

        with pytest.raises(stripe.error.CardError):
            create_subscription(tenant=tenant_a, price_id="price_pro_monthly")
\`\`\`

### Stripe Webhook Tests

Verify signature validation and idempotency:

\`\`\`python
import json
import pytest
from unittest.mock import patch
from django.test import override_settings

class DescribeStripeWebhook:
    @patch("src.billing.webhooks.stripe.Webhook.construct_event")
    def test_invoice_paid_activates_subscription(self, mock_construct, api_client, tenant_a):
        subscription = SubscriptionFactory(
            tenant=tenant_a,
            stripe_subscription_id="sub_123",
            status="past_due",
        )
        event_data = {
            "id": "evt_test_001",
            "type": "invoice.paid",
            "data": {
                "object": {
                    "subscription": "sub_123",
                    "amount_paid": 2900,
                }
            }
        }
        mock_construct.return_value = MagicMock(**event_data)

        response = api_client.post(
            "/api/v1/billing/webhooks/stripe/",
            data=json.dumps(event_data),
            content_type="application/json",
            HTTP_STRIPE_SIGNATURE="test_sig",
        )

        assert response.status_code == 200
        subscription.refresh_from_db()
        assert subscription.status == "active"

    @patch("src.billing.webhooks.stripe.Webhook.construct_event")
    def test_duplicate_webhook_is_idempotent(self, mock_construct, api_client, tenant_a):
        """Processing the same event twice must not create duplicate records."""
        WebhookEventFactory(event_id="evt_test_001", processed=True)
        event_data = {"id": "evt_test_001", "type": "invoice.paid", "data": {"object": {}}}
        mock_construct.return_value = MagicMock(**event_data)

        response = api_client.post(
            "/api/v1/billing/webhooks/stripe/",
            data=json.dumps(event_data),
            content_type="application/json",
            HTTP_STRIPE_SIGNATURE="test_sig",
        )

        assert response.status_code == 200  # Accepted but not reprocessed
\`\`\`

### Celery Task Tests

Use \`CELERY_ALWAYS_EAGER\` or call tasks directly. Verify idempotency:

\`\`\`python
import pytest
from unittest.mock import patch
from src.tasks.billing import sync_subscription_status

@pytest.mark.django_db
class DescribeSyncSubscriptionStatusTask:
    @patch("src.tasks.billing.stripe.Subscription.retrieve")
    def test_updates_local_subscription_status(self, mock_retrieve, tenant_a):
        subscription = SubscriptionFactory(
            tenant=tenant_a,
            stripe_subscription_id="sub_456",
            status="active",
        )
        mock_retrieve.return_value = MagicMock(id="sub_456", status="canceled")

        sync_subscription_status(subscription_id=subscription.id)

        subscription.refresh_from_db()
        assert subscription.status == "canceled"

    @patch("src.tasks.billing.stripe.Subscription.retrieve")
    def test_idempotent_when_already_synced(self, mock_retrieve, tenant_a):
        """Running the task twice with same data produces same result."""
        subscription = SubscriptionFactory(
            tenant=tenant_a,
            stripe_subscription_id="sub_456",
            status="canceled",
        )
        mock_retrieve.return_value = MagicMock(id="sub_456", status="canceled")

        sync_subscription_status(subscription_id=subscription.id)
        sync_subscription_status(subscription_id=subscription.id)

        subscription.refresh_from_db()
        assert subscription.status == "canceled"

    def test_raises_on_nonexistent_subscription(self):
        with pytest.raises(Subscription.DoesNotExist):
            sync_subscription_status(subscription_id=99999)
\`\`\`

### Role-Based Access Control Tests

\`\`\`python
class DescribeRBACPermissions:
    def test_admin_can_manage_team_members(self, api_client_admin, tenant_a):
        response = api_client_admin.post(
            "/api/v1/accounts/invitations/",
            data={"email": "new@example.com", "role": "member"},
        )
        assert response.status_code == status.HTTP_201_CREATED

    def test_member_cannot_manage_team_members(self, api_client_member, tenant_a):
        response = api_client_member.post(
            "/api/v1/accounts/invitations/",
            data={"email": "new@example.com", "role": "member"},
        )
        assert response.status_code == status.HTTP_403_FORBIDDEN

    def test_viewer_cannot_modify_resources(self, api_client_viewer, tenant_a):
        project = ProjectFactory(tenant=tenant_a)
        response = api_client_viewer.patch(
            f"/api/v1/projects/{project.id}/",
            data={"name": "Hacked"},
        )
        assert response.status_code == status.HTTP_403_FORBIDDEN
\`\`\`

### Audit Logging Tests

\`\`\`python
class DescribeAuditLog:
    def test_subscription_change_creates_audit_entry(self, tenant_a, user_a):
        subscription = SubscriptionFactory(tenant=tenant_a, status="active")

        cancel_subscription(subscription=subscription, actor=user_a)

        log = AuditLog.objects.filter(
            tenant=tenant_a,
            action="subscription.canceled",
        ).first()
        assert log is not None
        assert log.actor == user_a
        assert log.metadata["subscription_id"] == str(subscription.id)
\`\`\`

### GDPR Compliance Tests

\`\`\`python
class DescribeGDPRDataDeletion:
    def test_delete_tenant_removes_all_pii(self, tenant_a, user_a):
        """Right to deletion: all PII must be purged or anonymized."""
        ProjectFactory(tenant=tenant_a)
        AuditLogFactory(tenant=tenant_a, actor=user_a)

        delete_tenant_data(tenant=tenant_a)

        assert not User.objects.filter(id=user_a.id).exists()
        assert not Project.objects.filter(tenant=tenant_a).exists()
        # Audit logs are anonymized, not deleted (SOC 2 retention)
        log = AuditLog.objects.filter(tenant=tenant_a).first()
        assert log.actor is None
        assert log.actor_email_hash is not None
\`\`\`

## Factory Patterns

All factories live in \`tests/factories/\`:

\`\`\`python
# tests/factories/__init__.py
from tests.factories.tenants import TenantFactory
from tests.factories.accounts import UserFactory
from tests.factories.billing import SubscriptionFactory, WebhookEventFactory
from tests.factories.projects import ProjectFactory
from tests.factories.audit import AuditLogFactory

__all__ = [
    "TenantFactory",
    "UserFactory",
    "SubscriptionFactory",
    "WebhookEventFactory",
    "ProjectFactory",
    "AuditLogFactory",
]
\`\`\`

\`\`\`python
# tests/factories/tenants.py
import factory
from src.tenants.models import Tenant

class TenantFactory(factory.django.DjangoModelFactory):
    class Meta:
        model = Tenant

    name = factory.Sequence(lambda n: f"Tenant {n}")
    slug = factory.Sequence(lambda n: f"tenant-{n}")
    is_active = True
\`\`\`

## Sensitive Path Testing

Tests touching \`src/billing/\` or \`src/accounts/\` require extra scrutiny:

- **Billing tests**: Always mock Stripe. Never store real API keys in test fixtures. Verify webhook signature validation is tested.
- **Auth tests**: Test token expiry, password reset flows, session invalidation on tenant switch. Verify no PII leaks in error responses.
- **Config tests**: Never assert against real secrets. Use \`@override_settings\` for config-dependent tests.

## Test Database Configuration

Tests use a dedicated PostgreSQL database with row-level security policies applied:

\`\`\`python
# conftest.py (root)
import pytest

@pytest.fixture(autouse=True)
def enable_db_access_for_all_tests(db):
    """All tests get database access by default."""
    pass

@pytest.fixture(autouse=True)
def reset_tenant_context():
    """Clear tenant context between tests to prevent leakage."""
    from src.core.context import clear_tenant_context
    yield
    clear_tenant_context()
\`\`\`

## Commands Reference

| Action | Command |
|---|---|
| Run all tests | \`uv run pytest\` |
| Run single app | \`uv run pytest tests/{app_name}/ -v\` |
| Run single test | \`uv run pytest tests/{app}/test_{mod}.py::{Class}::{test} -v\` |
| Run with coverage | \`uv run pytest --cov=src --cov-report=term-missing --cov-fail-under=85\` |
| Run only failing | \`uv run pytest --lf\` |
| Run marked tests | \`uv run pytest -m "not slow"\` |
| Lint | \`uv run ruff check src/ tests/\` |
| Type check | \`uv run mypy src/\` |
| Format check | \`uv run ruff format --check src/ tests/\` |

## Test Markers

\`\`\`python
# pyproject.toml markers are defined; use them:
@pytest.mark.slow          # Integration tests, Stripe mocks with latency
@pytest.mark.celery        # Celery task tests
@pytest.mark.billing       # Billing/Stripe tests (sensitive path)
@pytest.mark.tenant        # Multi-tenancy isolation tests
@pytest.mark.gdpr          # GDPR compliance tests
\`\`\`

## Output Format

When guiding a developer through TDD, structure your response as:

1. **Requirement Summary** — one-sentence description of the behavior
2. **Test Plan** — list of test cases (happy path, edge cases, tenant isolation, error handling)
3. **RED** — the failing test code with explanation
4. **GREEN** — the minimal production code
5. **REFACTOR** — improvements with all tests still passing
6. **Coverage** — coverage report and any gaps

## Interaction Rules

- Never write production code before a failing test exists
- If asked to "just implement it," redirect to writing the test first
- When a test is flaky, investigate timing, database state, or tenant context leakage
- Always verify tenant isolation — if a feature touches data, there must be a cross-tenant test
- For Stripe-related features, always include an idempotency test
- For Celery tasks, always include a retry/failure test
- Flag any test that takes longer than 5 seconds as \`@pytest.mark.slow\`
- Reference \`plugin/codeforge-django-saas/skills/tdd/SKILL.md\` for the detailed skill protocol
- Reference \`plugin/codeforge-django-saas/skills/verify/SKILL.md\` after completing the cycle`,

  'plugin/codeforge-django-saas/commands/build-fix.md': `# /build-fix — Resolve Build, Lint, Type, and Test Failures

## Purpose

Diagnose and fix failures in the Django SaaS platform CI pipeline: ruff lint/format, mypy type checking, pytest test failures, Django system checks, Celery task errors, and Docker build issues.

## When to Use

- CI pipeline fails on any stage (lint, type check, tests, build)
- \`uv run ruff check src/\` or \`uv run ruff format --check src/\` reports violations
- \`uv run mypy src/\` reports type errors
- \`uv run pytest\` has failing tests
- \`uv run python manage.py check --deploy\` reports issues
- Docker build fails
- Django migrations are inconsistent or conflicting

## Invocation

\`\`\`
/build-fix
/build-fix --stage lint
/build-fix --stage typecheck
/build-fix --stage tests
/build-fix --stage migrations
/build-fix --stage docker
/build-fix --error "specific error message or CI log snippet"
\`\`\`

## Procedure

### Step 1: Identify the Failure

Run the full check suite to determine what is broken:

\`\`\`bash
# Lint check
uv run ruff check src/ tests/

# Format check
uv run ruff format --check src/ tests/

# Type check
uv run mypy src/

# Django system checks
uv run python manage.py check
uv run python manage.py check --deploy

# Migration consistency
uv run python manage.py makemigrations --check --dry-run

# Test suite
uv run pytest --tb=short -q

# Docker build (if applicable)
docker compose build --no-cache
\`\`\`

Collect all error output before making any changes. Categorize each failure.

### Step 2: Classify the Error

Determine the error category and apply the corresponding resolution strategy:

| Category | Tool | Common Causes |
|---|---|---|
| **Lint** | \`ruff check\` | Import order, unused imports, line length, banned APIs |
| **Format** | \`ruff format\` | Whitespace, trailing commas, quote style |
| **Type** | \`mypy\` | Missing annotations, incompatible types, untyped imports |
| **Test** | \`pytest\` | Assertion failures, fixture issues, missing factories |
| **Django** | \`manage.py check\` | Model validation, settings misconfiguration |
| **Migration** | \`makemigrations\` | Conflicting migrations, missing dependencies |
| **Docker** | \`docker compose\` | Dependency install failures, missing env vars |
| **Celery** | Worker startup | Missing broker, unregistered tasks, import errors |

### Step 3: Apply Fixes by Category

#### 3a. Ruff Lint and Format Fixes

\`\`\`bash
# Auto-fix lint violations
uv run ruff check src/ tests/ --fix

# Auto-format code
uv run ruff format src/ tests/

# For unfixable violations, review manually
uv run ruff check src/ tests/ --no-fix --output-format=grouped
\`\`\`

**Common SaaS-specific lint issues:**
- Unused imports in \`__init__.py\` files that expose app-level APIs — add \`# noqa: F401\` only if the import is intentional for public API
- Circular imports between Django apps (e.g., \`tenants\` ↔ \`billing\`) — use string references in ForeignKey or move shared logic to \`core/\`
- Wildcard imports in settings files — enumerate explicit imports from base settings

#### 3b. Mypy Type Check Fixes

\`\`\`bash
uv run mypy src/ --show-error-codes --pretty
\`\`\`

**Common type errors in this project:**

1. **Django model fields**: Use \`django-stubs\` annotations. Ensure \`mypy_django_plugin\` is configured in \`pyproject.toml\`.
   \`\`\`python
   # Wrong
   name = models.CharField(max_length=255)
   
   # If mypy complains about Manager types, check django-stubs version
   objects: TenantAwareManager["MyModel"]  # Explicit generic
   \`\`\`

2. **DRF serializer types**: Annotate \`validated_data\` as \`dict[str, Any]\` in service functions.

3. **Celery task signatures**: Annotate task functions with explicit return types.
   \`\`\`python
   @shared_task(bind=True, max_retries=3)
   def sync_stripe_subscription(self: Task, tenant_id: int, subscription_id: str) -> None:
       ...
   \`\`\`

4. **Strawberry GraphQL resolvers**: Ensure resolver return types match the Strawberry type annotations.

5. **Stripe SDK types**: Use \`stripe.Subscription\`, \`stripe.Invoice\`, etc. Add \`# type: ignore[attr-defined]\` only as last resort with a comment explaining why.

6. **Tenant-aware manager return types**: Ensure \`TenantAwareManager\` is generic over the model class.

#### 3c. Pytest Test Failures

\`\`\`bash
# Run with verbose output on failures only
uv run pytest --tb=long -x -v

# Run specific failing test
uv run pytest tests/billing/test_subscription_lifecycle.py::test_upgrade_plan -vvs

# Run with fresh database
uv run pytest --create-db
\`\`\`

**Common test failure patterns:**

1. **Factory issues**: Ensure \`factory_boy\` factories set required tenant context.
   \`\`\`python
   class UserFactory(factory.django.DjangoModelFactory):
       class Meta:
           model = "accounts.User"
       tenant = factory.SubFactory(TenantFactory)
   \`\`\`

2. **Stripe mock missing**: All Stripe API calls must be mocked in tests. Use \`@pytest.fixture\` with \`unittest.mock.patch\` or \`responses\` library.
   \`\`\`python
   @pytest.fixture
   def mock_stripe_customer(mocker):
       return mocker.patch(
           "stripe.Customer.create",
           return_value=stripe.Customer.construct_from({"id": "cus_test123"}, "sk_test"),
       )
   \`\`\`

3. **Celery task tests**: Use \`CELERY_ALWAYS_EAGER=True\` in test settings or call \`.apply()\` directly.
   \`\`\`python
   result = sync_stripe_subscription.apply(args=[tenant.id, "sub_test123"])
   assert result.successful()
   \`\`\`

4. **Tenant isolation leaks**: Tests must not share tenant state. Use \`@pytest.mark.django_db(transaction=True)\` when testing row-level security.

5. **Redis dependency in tests**: Use \`fakeredis\` or ensure \`django.core.cache.backends.locmem.LocMemCache\` is configured in test settings.

6. **Async test failures**: Use \`@pytest.mark.asyncio\` and ensure \`pytest-asyncio\` is installed for async views or GraphQL resolvers.

#### 3d. Django System Check and Migration Fixes

\`\`\`bash
# Check for model issues
uv run python manage.py check --tag models

# Check deployment readiness
uv run python manage.py check --deploy

# Detect migration conflicts
uv run python manage.py makemigrations --check --dry-run

# Show migration plan
uv run python manage.py showmigrations --plan | grep -E "\\[ \\]"
\`\`\`

**Common issues:**

1. **Conflicting migrations**: Two developers created migrations for the same app.
   \`\`\`bash
   uv run python manage.py makemigrations --merge
   \`\`\`

2. **Missing \`on_delete\`**: All ForeignKey fields must specify \`on_delete\`. For tenant references, use \`models.CASCADE\` (deleting a tenant cascades to all tenant data — required for GDPR right to deletion).

3. **Row-level security migration**: If adding RLS policies via \`RunSQL\`, ensure the reverse SQL is also provided.
   \`\`\`python
   migrations.RunSQL(
       sql="ALTER TABLE billing_invoice ENABLE ROW LEVEL SECURITY;",
       reverse_sql="ALTER TABLE billing_invoice DISABLE ROW LEVEL SECURITY;",
   )
   \`\`\`

4. **Deploy check warnings**: Address \`SECURE_HSTS_SECONDS\`, \`SECURE_SSL_REDIRECT\`, \`CSRF_COOKIE_SECURE\` in production settings at \`config/production/settings.py\`.

#### 3e. Docker Build Fixes

\`\`\`bash
# Rebuild with no cache
docker compose build --no-cache

# Check for dependency resolution issues
docker compose run --rm web uv pip compile pyproject.toml

# Verify environment variables
docker compose config
\`\`\`

**Common Docker issues:**
- \`uv\` cache layer invalidation — ensure \`pyproject.toml\` and \`uv.lock\` are copied before source code in Dockerfile
- Missing system dependencies for \`psycopg[binary]\` or \`cryptography\` — install \`libpq-dev\`, \`build-essential\` in Dockerfile
- Health check failures — ensure \`DATABASE_URL\`, \`REDIS_URL\`, \`STRIPE_SECRET_KEY\` are set in \`.env\`

#### 3f. Celery Task Errors

\`\`\`bash
# Test Celery worker startup
uv run celery -A config inspect ping

# Check registered tasks
uv run celery -A config inspect registered

# Verify Redis broker connectivity
uv run python -c "import redis; r = redis.from_url('redis://localhost:6379/0'); print(r.ping())"
\`\`\`

**Common Celery issues:**
- Task not registered: Ensure the task module is in \`CELERY_IMPORTS\` or the app's \`tasks.py\` is auto-discovered via \`app.autodiscover_tasks()\`
- Serialization error: All task arguments must be JSON-serializable. Pass IDs, not model instances.
- Idempotency violation: If a task can be retried, it must handle duplicate execution. Use \`get_or_create\` patterns and Stripe idempotency keys.

### Step 4: Verify the Fix

After applying fixes, run the full check suite again:

\`\`\`bash
# All checks in CI order
uv run ruff check src/ tests/
uv run ruff format --check src/ tests/
uv run mypy src/
uv run python manage.py check
uv run python manage.py makemigrations --check --dry-run
uv run pytest --tb=short -q --cov=src --cov-fail-under=85
\`\`\`

Every check must pass before considering the fix complete.

### Step 5: Assess Impact

Before committing, evaluate the fix scope:

- **Lint/format auto-fixes**: Low risk. Commit directly.
- **Type annotation changes**: Medium risk. Verify no runtime behavior change.
- **Test fixture changes**: Medium risk. Run full test suite, not just the fixed test.
- **Migration changes**: High risk. Test against a copy of staging data if possible.
- **Service layer changes to fix tests**: High risk. These are logic changes — get a review.

### Step 6: Commit the Fix

Use conventional commit format:

\`\`\`bash
# Lint/format fixes
git commit -m "fix: resolve ruff lint violations in billing serializers"

# Type check fixes
git commit -m "fix: add type annotations to tenant-aware manager"

# Test fixes
git commit -m "fix: correct Stripe mock in subscription lifecycle tests"

# Migration fixes
git commit -m "fix: merge conflicting migrations in accounts app"

# Multi-category fix
git commit -m "fix: resolve CI failures (ruff, mypy, pytest)

- Auto-fixed import ordering in billing/services.py
- Added return type to sync_stripe_subscription task
- Fixed TenantFactory missing required field in test_onboarding"
\`\`\`

## Sensitive Path Rules

When fixing errors in sensitive paths, apply extra scrutiny:

| Path | Extra Rules |
|---|---|
| \`src/billing/**\` | Never log Stripe secret keys or full card numbers. Verify webhook signature validation is intact. Ensure idempotency keys are preserved. |
| \`src/accounts/**\`, \`src/core/auth/**\` | Do not weaken authentication checks. Verify RBAC permissions are not bypassed. Check session/token handling. |
| \`config/production/**\` | Do not commit secrets. Verify \`DEBUG=False\`. Check all security middleware is enabled. |
| \`.env*\` | Never commit. Ensure \`.gitignore\` covers all env files. |
| \`src/tenants/**\` | Verify tenant isolation is not broken. Row-level security policies must remain active. Test cross-tenant data access is blocked. |

## Escalation

If a fix requires any of the following, stop and request human review:

- Changing row-level security policies or tenant isolation logic
- Modifying Stripe webhook verification or billing calculation logic
- Altering authentication or authorization middleware
- Disabling Django security checks or mypy strict mode rules
- Adding \`# type: ignore\` without a clear, documented reason
- Modifying production settings or deployment configuration
- Changing database migration history (squashing, editing applied migrations)

## Anti-Patterns

- **Do not** suppress errors with blanket \`# noqa\`, \`# type: ignore\`, or \`@pytest.mark.skip\` without a linked issue
- **Do not** change test assertions to match broken behavior — fix the source code
- **Do not** lower the coverage threshold (85%) to make CI pass
- **Do not** disable RLS or tenant middleware to fix test failures — fix the test setup
- **Do not** commit \`.env\` files or hardcoded secrets to fix configuration errors
- **Do not** use \`--no-verify\` to skip pre-commit hooks

## Related

- Skill definition: \`plugin/codeforge-django-saas/skills/build-fix/SKILL.md\`
- Agent: \`plugin/codeforge-django-saas/agents/build-error-resolver.md\`
- CI pipeline: \`.github/workflows/ci.yml\`
- Ruff config: \`pyproject.toml\` (\`[tool.ruff]\` section)
- Mypy config: \`pyproject.toml\` (\`[tool.mypy]\` section)
- Pytest config: \`pyproject.toml\` (\`[tool.pytest.ini_options]\` section)`,

  'plugin/codeforge-django-saas/commands/code-review.md': `# /code-review — Django SaaS Code Review

## Purpose

Perform a comprehensive code review of staged or committed changes against django-saas-platform standards, covering Django best practices, multi-tenant safety, billing integrity, API correctness, and SOC 2/GDPR compliance.

## When to Use

- Before opening a pull request
- After completing a feature branch
- When reviewing another developer's PR
- After AI-generated code to validate correctness
- Before merging any changes to \`main\`

## Usage

\`\`\`
/code-review                          # Review all staged/uncommitted changes
/code-review --diff main              # Review diff against main branch
/code-review --files src/billing/     # Review specific directory
/code-review --pr 142                 # Review a specific PR by number
/code-review --severity critical      # Only report critical/blocking issues
/code-review --focus security         # Focus review on security concerns
/code-review --focus tenant-isolation # Focus on multi-tenancy safety
\`\`\`

## Execution Steps

### Step 1 — Gather Changes

Identify the changeset to review:

\`\`\`bash
# If --diff provided, compare against that ref
git diff main --name-only --stat

# If --files provided, scope to those paths
git diff --cached --name-only -- src/billing/

# If --pr provided, fetch PR diff from GitHub
gh pr diff 142

# Default: staged + unstaged changes
git diff --name-only
git diff --cached --name-only
\`\`\`

List all changed files with their change type (added, modified, deleted). Group by Django app.

### Step 2 — Classify Risk Level

Assign a risk tier to each changed file:

| Risk Tier | Paths | Review Depth |
|-----------|-------|--------------|
| **CRITICAL** | \`src/billing/**\`, \`src/accounts/auth*\`, \`config/production/**\`, \`*.env*\`, migrations altering tenant columns | Line-by-line, security-focused |
| **HIGH** | \`src/tenants/**\`, \`src/core/permissions*\`, \`src/core/middleware*\`, \`src/api/auth*\`, Celery task definitions | Thorough logic + isolation review |
| **MEDIUM** | \`src/api/**\`, \`src/notifications/**\`, \`src/tasks/**\`, serializers, views | Standard review |
| **LOW** | \`docs/**\`, \`tests/**\`, \`templates/**\`, \`static/**\`, config comments | Quick scan |

Report the risk classification before proceeding.

### Step 3 — Run Automated Checks

Execute the project's linting and type-checking toolchain:

\`\`\`bash
# Linting
uv run ruff check src/ --diff

# Formatting
uv run ruff format --check src/

# Type checking
uv run mypy src/ --no-error-summary

# Run tests related to changed files
uv run pytest tests/ -x --tb=short -q --no-header

# Check for missing migrations
uv run python manage.py makemigrations --check --dry-run
\`\`\`

Report pass/fail for each check. If any fail, include the specific errors.

### Step 4 — Multi-Tenancy Safety Review

For every changed file that touches database queries or model access:

- [ ] **Tenant-aware manager usage**: All querysets on tenant-scoped models use the tenant-aware manager, never \`objects.all()\` without tenant filtering
- [ ] **No cross-tenant data leakage**: Views and serializers never expose data from other tenants
- [ ] **Middleware dependency**: Tenant context is set via \`TenantMiddleware\` before any data access
- [ ] **Row-level security**: New migrations on tenant-scoped tables include RLS policy updates
- [ ] **Tenant FK integrity**: New models with tenant data include \`tenant = models.ForeignKey("tenants.Tenant", ...)\` with appropriate \`on_delete\`
- [ ] **Admin safety**: Django admin classes for tenant models filter by tenant or are restricted to superusers
- [ ] **Celery task tenant context**: Background tasks receive \`tenant_id\` explicitly and set tenant context before DB access
- [ ] **Test isolation**: Tests use separate tenant fixtures and verify no cross-tenant bleed

Flag any queryset that does not pass through the tenant-aware manager as **CRITICAL**.

### Step 5 — Billing & Stripe Review

For changes in \`src/billing/\`, \`src/tasks/\` (billing-related), or Stripe webhook handlers:

- [ ] **Webhook idempotency**: Stripe webhook handlers check for duplicate \`event.id\` before processing
- [ ] **Webhook signature verification**: All webhook endpoints verify \`Stripe-Signature\` header using \`stripe.Webhook.construct_event()\`
- [ ] **Subscription state machine**: Status transitions follow valid paths (e.g., \`active\` → \`past_due\` → \`canceled\`, never \`canceled\` → \`active\` without re-subscribe)
- [ ] **Usage metering accuracy**: Usage records are created with idempotency keys and correct \`timestamp\`
- [ ] **Currency handling**: All monetary values use \`Decimal\`, never \`float\`; stored in smallest currency unit (cents)
- [ ] **Stripe API error handling**: All Stripe API calls are wrapped in try/except for \`stripe.error.StripeError\` subtypes
- [ ] **Audit trail**: Billing state changes create audit log entries with before/after values
- [ ] **Test coverage**: Billing logic has unit tests with mocked Stripe responses using \`pytest\` fixtures
- [ ] **No secrets in code**: Stripe keys referenced via \`django.conf.settings\`, never hardcoded

### Step 6 — API Review (DRF + GraphQL)

For changes in \`src/api/\`, serializers, viewsets, or Strawberry schema:

- [ ] **OpenAPI schema**: New/modified DRF endpoints have \`@extend_schema()\` decorators from drf-spectacular
- [ ] **Permission classes**: Every viewset/view has explicit \`permission_classes\` — no reliance on global defaults alone
- [ ] **Serializer validation**: Input validation happens in serializers, not in views; custom validators are tested
- [ ] **Pagination**: List endpoints use cursor or page-number pagination, never unbounded querysets
- [ ] **N+1 queries**: ViewSets use \`select_related()\` / \`prefetch_related()\` for related objects
- [ ] **Error responses**: Errors return structured JSON with consistent format, not raw exceptions
- [ ] **Rate limiting**: Public or high-traffic endpoints have throttle classes applied
- [ ] **GraphQL authorization**: Strawberry resolvers check permissions; no resolver returns unfiltered tenant data
- [ ] **URL naming**: URL paths use \`kebab-case\` as per project convention

### Step 7 — Celery Task Review

For changes in \`src/tasks/\` or any file defining \`@shared_task\` / \`@app.task\`:

- [ ] **Idempotency**: Tasks can be safely retried without side effects (use idempotency keys, check-before-write)
- [ ] **Tenant context**: Tasks accept \`tenant_id\` as a parameter and activate tenant context at the start
- [ ] **Serializable arguments**: Task arguments are JSON-serializable primitives (no Django model instances)
- [ ] **Retry policy**: Tasks define \`autoretry_for\`, \`retry_backoff\`, \`max_retries\` for transient failures
- [ ] **Timeout**: Tasks set \`soft_time_limit\` and \`time_limit\` to prevent runaway execution
- [ ] **Logging**: Tasks log start, completion, and failure with structured context (tenant_id, task_id)
- [ ] **No synchronous Stripe calls without error handling**: External API calls in tasks handle network errors and retry

### Step 8 — Security & Compliance Review

- [ ] **No secrets in code**: No API keys, passwords, tokens, or connection strings in source files
- [ ] **GDPR data handling**: PII fields are identified; new PII fields have retention/deletion support
- [ ] **Audit logging**: State-changing operations on sensitive resources create audit log entries
- [ ] **Input sanitization**: User input is validated and sanitized before use in queries or templates
- [ ] **SQL injection prevention**: Raw SQL (if any) uses parameterized queries, never string interpolation
- [ ] **Authentication on endpoints**: No endpoint is accidentally left unauthenticated
- [ ] **CORS/CSRF**: API endpoints have appropriate CORS headers; session-based views have CSRF protection
- [ ] **Dependency review**: New packages in \`pyproject.toml\` are reviewed for known vulnerabilities and license compatibility
- [ ] **Migration safety**: Migrations are backward-compatible (no column drops without deprecation period)
- [ ] **Logging hygiene**: No PII (emails, names, payment info) logged at INFO level or above

### Step 9 — Code Quality Review

- [ ] **File length**: No file exceeds 300 lines; suggest splitting if approaching limit
- [ ] **Type hints**: All public functions have type annotations; \`mypy\` strict mode passes
- [ ] **Naming conventions**: \`snake_case\` for functions/files, \`PascalCase\` for classes, \`SCREAMING_SNAKE_CASE\` for constants
- [ ] **Service layer pattern**: Business logic lives in service modules, not in views or serializers
- [ ] **Signal usage**: Django signals are used sparingly; prefer explicit service calls (flag new signal usage for discussion)
- [ ] **DRY compliance**: No duplicated logic across apps; shared utilities go in \`src/utils/\` or \`src/core/\`
- [ ] **Docstrings**: Public classes and non-trivial functions have docstrings explaining purpose and parameters
- [ ] **Test quality**: Tests use \`factory_boy\` fixtures, test one behavior per test, have descriptive names
- [ ] **Coverage**: Changed files maintain or improve the 85% coverage threshold

### Step 10 — Generate Review Report

Produce a structured review report:

\`\`\`markdown
## Code Review Report

**Branch**: feat/SAAS-42-add-tenant-onboarding
**Files Changed**: 12 (3 critical, 4 high, 3 medium, 2 low)
**Automated Checks**: ✅ ruff | ✅ mypy | ✅ pytest (47 passed) | ✅ migrations

### 🔴 Critical Issues (must fix before merge)
1. **[TENANT-ISOLATION]** \`src/billing/views.py:45\` — \`Subscription.objects.filter(status="active")\` missing tenant scope. Use \`Subscription.tenant_objects.for_tenant(request.tenant).filter(status="active")\`
2. **[BILLING]** \`src/billing/webhooks.py:78\` — No idempotency check on \`invoice.paid\` event handler

### 🟡 Warnings (should fix)
3. **[API]** \`src/api/views/subscriptions.py:30\` — Missing \`@extend_schema()\` decorator on \`SubscriptionViewSet.create\`
4. **[CELERY]** \`src/tasks/billing.py:22\` — Task \`sync_stripe_subscription\` missing \`soft_time_limit\`

### 🔵 Suggestions (nice to have)
5. **[QUALITY]** \`src/billing/services.py\` — 287 lines, approaching 300-line limit. Consider extracting invoice logic to \`src/billing/services/invoicing.py\`
6. **[TESTS]** \`tests/billing/test_webhooks.py\` — Add test case for duplicate webhook event delivery

### ✅ Positive Observations
- Clean tenant isolation in \`src/tenants/middleware.py\` changes
- Excellent factory_boy usage in new test fixtures
- Stripe error handling follows project patterns

### Summary
- **Critical**: 2 | **Warnings**: 2 | **Suggestions**: 2
- **Recommendation**: ❌ Request changes (critical issues must be resolved)
\`\`\`

## Review Focus Modes

When \`--focus\` is specified, prioritize that category:

| Focus | Primary Checks |
|-------|---------------|
| \`security\` | Steps 8, 4 (tenant isolation), 5 (billing secrets) |
| \`tenant-isolation\` | Step 4 fully, plus tenant context in Steps 7 and 6 |
| \`billing\` | Step 5 fully, plus billing-related tasks in Step 7 |
| \`api\` | Step 6 fully, plus serializer validation and permissions |
| \`performance\` | N+1 queries, missing indexes, unbounded querysets, task timeouts |
| \`compliance\` | Steps 8 and 4, GDPR data handling, audit logging |

## Severity Filtering

When \`--severity critical\` is specified, only report issues that:
- Could cause cross-tenant data leakage
- Could result in incorrect billing or financial loss
- Could expose secrets or PII
- Could cause data corruption or loss
- Break authentication or authorization

## Integration with PR Workflow

After generating the review report:

1. If no critical issues: suggest the developer open a PR
2. If critical issues exist: list the specific fixes needed before PR
3. Reference the \`plugin/codeforge-django-saas/skills/code-review/SKILL.md\` for detailed review methodology
4. If AI-generated code is detected (look for \`# AI-generated\` markers or \`ai-code-audit\` labels), flag for additional human review per \`docs/AI-USAGE-POLICY.md\`

## Cross-References

- **Review skill details**: \`plugin/codeforge-django-saas/skills/code-review/SKILL.md\`
- **Code reviewer agent**: \`plugin/codeforge-django-saas/agents/code-reviewer.md\`
- **Architecture patterns**: \`docs/ARCHITECTURE.md\`
- **Contributing guidelines**: \`docs/CONTRIBUTING.md\`
- **AI usage policy**: \`docs/AI-USAGE-POLICY.md\`
- **CI pipeline**: \`.github/workflows/ci.yml\``,

  'plugin/codeforge-django-saas/commands/phase.md': `# /phase — Development Phase Management

## Command Signature

\`\`\`
/phase [subcommand] [options]
\`\`\`

## Subcommands

| Subcommand | Description |
|---|---|
| \`start <phase>\` | Begin a development phase for the current ticket |
| \`status\` | Show current phase progress and checklist |
| \`next\` | Advance to the next phase |
| \`checklist\` | Display phase-specific checklist for Django SaaS context |
| \`gate\` | Run phase gate validation before advancing |

## Phases

The development methodology follows six ordered phases. Each phase has specific entry criteria, activities, and exit gates tailored to this Django SaaS platform.

| # | Phase | Key Activities |
|---|---|---|
| 1 | **Discover** | Understand the ticket, identify affected Django apps, map tenant impact |
| 2 | **Plan** | Design approach, define models/serializers/views, identify Celery tasks |
| 3 | **Implement** | Write code following TDD, respect tenant isolation, add OpenAPI schemas |
| 4 | **Verify** | Run full test suite, type checking, lint, coverage gate |
| 5 | **Review** | Self-review against SaaS checklist, prepare PR |
| 6 | **Ship** | Merge, deploy to staging, validate in staging environment |

## Usage Examples

### Start a new phase
\`\`\`
/phase start discover
\`\`\`

### Check current progress
\`\`\`
/phase status
\`\`\`

### Run gate checks before moving on
\`\`\`
/phase gate
\`\`\`

### Advance to next phase
\`\`\`
/phase next
\`\`\`

## Phase Details

### Phase 1: Discover

**Goal**: Fully understand the ticket and its impact across the Django SaaS platform.

**Activities**:
- Read the GitHub Issue and any linked Notion documentation
- Identify which Django apps are affected (\`src/accounts/\`, \`src/tenants/\`, \`src/billing/\`, \`src/api/\`, \`src/core/\`, \`src/notifications/\`, \`src/tasks/\`, \`src/utils/\`)
- Determine if the change touches sensitive paths (\`**/billing/**\`, \`**/auth/**\`, \`config/production/**\`, \`.env*\`)
- Assess multi-tenancy impact — does this change affect tenant data isolation or row-level security?
- Check if Stripe integration is involved (subscriptions, webhooks, usage metering)
- Identify GDPR implications (PII handling, data residency, consent, right to deletion)
- Review existing tests in \`tests/\` that cover the affected area

**Checklist**:
- [ ] Ticket requirements are clear and unambiguous
- [ ] Affected Django apps identified
- [ ] Sensitive path involvement flagged (billing, auth, config)
- [ ] Tenant isolation impact assessed
- [ ] Stripe/billing impact assessed
- [ ] GDPR/SOC 2 compliance implications noted
- [ ] Existing test coverage reviewed
- [ ] Dependencies on other tickets or services identified
- [ ] Questions posted to Slack or GitHub Issue if anything is unclear

**Gate**: All checklist items addressed. If sensitive paths are involved, confirm a CODEOWNER is aware.

---

### Phase 2: Plan

**Goal**: Design the implementation approach with concrete Django/DRF/Celery artifacts.

**Activities**:
- Define or modify Django models (ensure tenant FK, \`TenantAwareManager\` usage)
- Plan serializers and DRF viewsets or Strawberry GraphQL types/resolvers
- Design Celery tasks (must be idempotent — define retry strategy and deduplication)
- Plan database migrations (check for backward compatibility, zero-downtime deployment)
- Define URL patterns (kebab-case: \`/api/v1/tenant-settings/\`)
- Specify OpenAPI schema annotations via \`drf-spectacular\`
- Outline service layer functions (prefer explicit calls over Django signals)
- Plan Redis caching strategy if applicable (cache keys must be tenant-scoped)
- If Stripe is involved, plan webhook handler idempotency and event processing

**Checklist**:
- [ ] Models designed with tenant isolation (\`tenant\` FK, \`TenantAwareManager\`)
- [ ] Serializers and validation rules defined
- [ ] API endpoints planned with OpenAPI annotations
- [ ] Celery tasks designed as idempotent with retry policy
- [ ] Database migration strategy confirmed (backward compatible)
- [ ] Service layer functions outlined (no signal abuse)
- [ ] Permissions and RBAC rules defined
- [ ] Caching strategy uses tenant-scoped keys
- [ ] Stripe webhook handlers planned as idempotent (if applicable)
- [ ] File count and size estimated (max 300 lines per file)
- [ ] Plan documented in PR description or Notion

**Gate**: Plan reviewed by at least one team member (async via Slack or PR draft). No unresolved design questions.

**Invoke the planner agent**:
\`\`\`
Refer to: plugin/codeforge-django-saas/agents/planner.md
Refer to: plugin/codeforge-django-saas/skills/plan/SKILL.md
\`\`\`

---

### Phase 3: Implement

**Goal**: Write production code following TDD, respecting all project conventions.

**Activities**:
- Create branch: \`feat/SAAS-<ticket>-<description>\` or \`fix/SAAS-<ticket>-<description>\`
- Write tests first using \`pytest\` + \`factory_boy\` fixtures
  \`\`\`bash
  uv run pytest tests/<app>/test_<module>.py -x -v
  \`\`\`
- Implement models, ensuring all tenant data access goes through \`TenantAwareManager\`
- Implement serializers with proper validation
- Implement views/viewsets with \`@extend_schema\` decorators for drf-spectacular
- Implement Celery tasks in \`src/tasks/\` — ensure idempotency:
  \`\`\`python
  @shared_task(bind=True, max_retries=3, default_retry_delay=60)
  def sync_subscription_status(self, tenant_id: str, subscription_id: str) -> None:
      """Idempotent: safe to retry. Uses Stripe subscription ID as dedup key."""
  \`\`\`
- Implement Strawberry GraphQL types/resolvers if the feature has a GraphQL surface
- Add audit logging for state changes on sensitive resources
- Use \`django-environ\` + Pydantic settings for any new configuration
- Add type hints on all public functions (mypy strict mode)
- Keep files under 300 lines — split into service layer, selectors, and views
- Use conventional commits: \`feat:\`, \`fix:\`, \`chore:\`, \`docs:\`

**Checklist**:
- [ ] Branch created with correct naming convention
- [ ] Tests written before implementation (TDD red-green-refactor)
- [ ] All tenant data access uses \`TenantAwareManager\`
- [ ] Row-level security policies updated if new tables added
- [ ] API endpoints have \`@extend_schema\` OpenAPI annotations
- [ ] Celery tasks are idempotent with retry configuration
- [ ] Stripe webhook handlers verify signatures and are idempotent
- [ ] Type hints on all public functions
- [ ] Files stay under 300 lines
- [ ] Factory fixtures created for new models (\`factory_boy\`)
- [ ] Audit logging added for sensitive state changes
- [ ] No Django signals for business logic — use service layer
- [ ] Conventional commit messages used
- [ ] AI-generated code marked per AI-USAGE-POLICY.md

**Gate**: All tests pass locally. No ruff or mypy errors.
\`\`\`bash
uv run ruff check src/
uv run ruff format --check src/
uv run mypy src/
uv run pytest --cov=src --cov-fail-under=85
\`\`\`

**Invoke the TDD guide**:
\`\`\`
Refer to: plugin/codeforge-django-saas/agents/tdd-guide.md
Refer to: plugin/codeforge-django-saas/skills/tdd/SKILL.md
\`\`\`

---

### Phase 4: Verify

**Goal**: Comprehensive validation that the implementation is correct, secure, and compliant.

**Activities**:
- Run the full test suite including integration tests:
  \`\`\`bash
  uv run pytest tests/ -v --cov=src --cov-report=term-missing --cov-fail-under=85
  \`\`\`
- Run type checking:
  \`\`\`bash
  uv run mypy src/ --strict
  \`\`\`
- Run linting and formatting:
  \`\`\`bash
  uv run ruff check src/ tests/
  uv run ruff format --check src/ tests/
  \`\`\`
- Run database migration check:
  \`\`\`bash
  uv run python manage.py makemigrations --check --dry-run
  uv run python manage.py migrate --plan
  \`\`\`
- Verify tenant isolation — run tenant-scoped query tests to confirm no cross-tenant data leakage
- If billing changes: verify Stripe webhook signature validation, test with Stripe CLI:
  \`\`\`bash
  stripe listen --forward-to localhost:8000/api/v1/billing/webhooks/
  stripe trigger invoice.payment_succeeded
  \`\`\`
- Check for security issues:
  \`\`\`bash
  uv run pip-audit
  uv run bandit -r src/ -c pyproject.toml
  \`\`\`
- Verify GDPR compliance: PII fields are encrypted/hashed, deletion cascades work, consent is tracked
- Verify SOC 2 audit trail: sensitive operations are logged with actor, timestamp, tenant context

**Checklist**:
- [ ] All unit tests pass
- [ ] All integration tests pass
- [ ] Coverage ≥ 85%
- [ ] mypy strict passes with no errors
- [ ] ruff check and format pass
- [ ] No pending/unexpected migrations
- [ ] Tenant isolation verified (no cross-tenant leakage)
- [ ] Stripe webhook handling verified (if applicable)
- [ ] Security scan clean (pip-audit, bandit)
- [ ] GDPR compliance verified for PII handling
- [ ] Audit logging verified for sensitive operations
- [ ] No hardcoded secrets or credentials

**Gate**: All automated checks pass. Zero warnings in security scan. Coverage threshold met.

**Invoke the verify skill**:
\`\`\`
Refer to: plugin/codeforge-django-saas/skills/verify/SKILL.md
\`\`\`

---

### Phase 5: Review

**Goal**: Self-review and prepare a high-quality PR for team review.

**Activities**:
- Run self-review using the code-review agent:
  \`\`\`
  /code-review
  \`\`\`
- Review diff for accidental secret exposure, debug code, TODO comments
- Ensure PR description includes:
  - Link to GitHub Issue (e.g., \`Closes #42\`)
  - Summary of changes by Django app
  - Migration notes (if any)
  - Stripe/billing impact (if any)
  - Tenant isolation confirmation
  - Screenshots or API examples (if applicable)
  - Rollback plan
- Verify CODEOWNERS will auto-assign correct reviewers (especially for \`**/billing/**\` and \`**/auth/**\`)
- Check that CI pipeline will pass (lint, type check, tests, security scan, Docker build)
- If AI-assisted, ensure the \`ai-assisted\` label is applied and AI-generated sections are marked

**Checklist**:
- [ ] Self-review completed with code-review agent
- [ ] No secrets, debug code, or unresolved TODOs in diff
- [ ] PR description is complete with all required sections
- [ ] GitHub Issue linked
- [ ] CODEOWNERS will assign correct reviewers
- [ ] CI checks expected to pass
- [ ] AI-assisted label applied (if applicable)
- [ ] Migration rollback tested (if migrations included)
- [ ] Breaking changes documented (if any)

**Gate**: PR created, CI passes, at least 1 approval received.

**Invoke the code-review agent**:
\`\`\`
Refer to: plugin/codeforge-django-saas/agents/code-reviewer.md
Refer to: plugin/codeforge-django-saas/skills/code-review/SKILL.md
\`\`\`

---

### Phase 6: Ship

**Goal**: Merge to main, deploy to staging, validate in staging environment.

**Activities**:
- Squash-merge PR to \`main\` with conventional commit message
- Verify GitHub Actions CI/CD pipeline triggers:
  1. Lint → Type Check → Unit Tests → Integration Tests → Security Scan
  2. Build Docker Image → Push to ECR
  3. Auto-deploy to staging (ECS)
- Validate in staging:
  - Run smoke tests against staging API
  - Verify database migrations applied cleanly
  - Test tenant isolation in staging with multiple test tenants
  - Verify Stripe webhooks in staging (test mode)
  - Check Sentry for new errors
  - Check Prometheus/Grafana dashboards for anomalies
- If staging validation passes, trigger production deployment via GitHub Actions
- Monitor production deployment:
  - Watch ECS task health
  - Monitor Sentry error rates
  - Check Grafana dashboards for latency/error spikes
  - Verify Celery workers are processing tasks

**Checklist**:
- [ ] PR squash-merged to \`main\` with conventional commit
- [ ] CI/CD pipeline completed successfully
- [ ] Docker image built and pushed to ECR
- [ ] Staging deployment successful
- [ ] Database migrations applied in staging
- [ ] Staging smoke tests pass
- [ ] Tenant isolation verified in staging
- [ ] Stripe integration verified in staging (if applicable)
- [ ] No new Sentry errors
- [ ] Production deployment triggered and successful
- [ ] Production monitoring shows healthy metrics
- [ ] Celery workers processing normally
- [ ] GitHub Issue closed

**Gate**: Production deployment healthy for 30 minutes with no error rate increase. Issue closed.

---

## Phase Transition Rules

1. **No skipping phases** — each phase must complete its gate before advancing
2. **Sensitive paths require extra scrutiny** — changes to \`**/billing/**\`, \`**/auth/**\`, or \`config/production/**\` require explicit security review in Phase 5
3. **Stripe changes require staging webhook testing** — never ship billing changes without staging validation
4. **Migration changes require rollback plan** — document in PR description
5. **Hotfixes may compress phases** — but must still pass Phase 4 (Verify) gate completely
6. **Phase state is tracked per branch** — switching branches resets phase context

## Integration with Other Commands

| Phase | Recommended Commands |
|---|---|
| Discover | Read ticket, explore codebase |
| Plan | \`/plan\` |
| Implement | \`/tdd\` |
| Verify | \`/verify\` |
| Review | \`/code-review\` |
| Ship | \`/verify --staging\` (post-deploy) |

## Error Recovery

If a phase gate fails:
- **Phase 3 gate failure**: Run \`/build-fix\` to resolve lint/type/test errors
- **Phase 4 gate failure**: Run \`/verify\` to get detailed diagnostics, then fix
- **Phase 5 gate failure**: Address reviewer feedback, re-run \`/code-review\`
- **Phase 6 gate failure**: Check deployment logs, rollback if needed, investigate with Sentry

## Playbook Reference

Detailed phase methodology documentation is available in:
\`\`\`
playbook/phase-1-discover.md
playbook/phase-2-plan.md
playbook/phase-3-implement.md
playbook/phase-4-verify.md
playbook/phase-5-review.md
playbook/phase-6-ship.md
\`\`\``,

  'plugin/codeforge-django-saas/commands/plan.md': `# /plan — Implementation Planning for Django SaaS Platform

## Command Purpose

Generate a detailed, phased implementation plan for a feature or task in the django-saas-platform project. The plan accounts for multi-tenancy, billing integration, async task processing, API design, and compliance requirements.

## Usage

\`\`\`
/plan <description of feature or task>
/plan SAAS-42 Add usage-based metering for API calls
/plan Implement tenant onboarding flow with Stripe subscription creation
\`\`\`

## Execution Steps

When the user invokes \`/plan\`, follow this procedure exactly:

### Step 1: Gather Context

1. Read the ticket or description provided by the user.
2. If a GitHub Issue number is referenced (e.g., \`SAAS-42\`), fetch the issue details using the GitHub MCP tool.
3. Review relevant existing code in the affected Django apps under \`src/\`.
4. Check \`docs/ARCHITECTURE.md\` for architectural constraints and patterns.
5. Identify which Django apps are affected (e.g., \`tenants/\`, \`billing/\`, \`api/\`, \`tasks/\`).

### Step 2: Identify Concerns

Evaluate the feature against each of these SaaS-specific dimensions:

| Dimension | Questions to Answer |
|---|---|
| **Multi-Tenancy** | Does this touch tenant-scoped data? Must queries go through the tenant-aware manager? Are there cross-tenant implications? |
| **Billing / Stripe** | Does this affect subscriptions, usage metering, invoices, or webhooks? Are there Stripe API calls that need idempotency keys? |
| **Async Tasks** | Are there operations that should be Celery tasks (email, reports, webhook dispatch, Stripe sync)? Must tasks be idempotent? |
| **API Surface** | Does this expose new REST endpoints (DRF) or GraphQL types (Strawberry)? Does drf-spectacular schema need updating? |
| **Data Model** | Are new models or migrations needed? Do they require tenant foreign keys? Row-level security policies? |
| **Permissions / RBAC** | What roles can access this? Are new permissions needed? Does it affect the tenant admin vs member distinction? |
| **Compliance** | GDPR implications (PII, consent, data deletion)? SOC 2 audit logging requirements? |
| **Security** | Input validation, rate limiting, webhook signature verification, secrets handling? |
| **Testing** | What test types are needed (unit, integration, e2e)? What factories are needed? |
| **Observability** | Logging, Sentry error tracking, Prometheus metrics, audit trail entries? |

### Step 3: Generate the Plan

Produce a structured plan in this exact format:

\`\`\`markdown
## Implementation Plan: <Title>

**Ticket**: <ticket reference or "N/A">
**Affected Apps**: <list of Django apps under src/>
**Estimated Complexity**: S / M / L / XL
**Branch**: feat/<ticket>-<short-desc> or fix/<ticket>-<short-desc>

### Summary
<2-3 sentence description of what will be built and why>

### Pre-Implementation Checklist
- [ ] Confirm requirements with product/stakeholder (if ambiguous)
- [ ] Review existing models in affected apps
- [ ] Check Stripe API docs for relevant endpoints (if billing-related)
- [ ] Verify no conflicting migrations in main

### Phase 1: Data Layer
<What models, migrations, managers, or row-level security policies to create/modify>
- Files to create/modify:
  - \`src/<app>/models.py\`
  - \`src/<app>/managers.py\`
  - \`src/<app>/migrations/XXXX_<name>.py\`
- Tenant isolation approach: <describe>
- Migration safety: <any considerations for zero-downtime>

### Phase 2: Service Layer
<Business logic in service modules — not in views or serializers>
- Files to create/modify:
  - \`src/<app>/services.py\` or \`src/<app>/services/<module>.py\`
- Key functions with signatures (type-hinted):
  - \`def <function_name>(<params>) -> <return_type>:\`
- Stripe integration points (if any):
  - <API calls, webhook events to handle>
- Idempotency requirements: <describe>

### Phase 3: Async Tasks
<Celery tasks for background processing>
- Files to create/modify:
  - \`src/tasks/<task_module>.py\`
- Tasks to define:
  - \`<task_name>.delay(<params>)\` — <purpose>
- Idempotency strategy: <describe how retries are safe>
- Retry policy: <max_retries, backoff>
- Beat schedule additions (if periodic): <describe>

### Phase 4: API Layer
<REST endpoints via DRF and/or GraphQL types via Strawberry>
- REST endpoints:
  - \`<METHOD> /api/v1/<path>/\` — <purpose> — Permission: <role>
- GraphQL additions:
  - \`Query.<field>\` or \`Mutation.<name>\` — <purpose>
- Files to create/modify:
  - \`src/api/views/<module>.py\`
  - \`src/api/serializers/<module>.py\`
  - \`src/api/schema/<module>.py\`
  - \`src/api/urls.py\`
- OpenAPI schema: drf-spectacular \`@extend_schema\` decorators required

### Phase 5: Permissions & Security
- New permissions: <list or "none">
- RBAC changes: <describe>
- Input validation: <describe>
- Rate limiting: <describe or "default">
- Audit log entries: <list events to log>

### Phase 6: Tests
- Factories to create/modify:
  - \`tests/<app>/factories.py\`
- Unit tests:
  - \`tests/<app>/test_services.py\` — <what to test>
  - \`tests/<app>/test_models.py\` — <what to test>
- Integration tests:
  - \`tests/<app>/test_views.py\` — <API endpoint tests>
  - \`tests/<app>/test_tasks.py\` — <Celery task tests>
- Stripe mock strategy: <use stripe-mock or unittest.mock>
- Coverage target: ≥85% for new code

### Phase 7: Documentation & Cleanup
- [ ] Update API docs (drf-spectacular schema regeneration)
- [ ] Add/update docstrings on all public functions
- [ ] Update \`docs/\` if architectural changes
- [ ] Add runbook entry if new operational procedure
- [ ] Verify \`uv run ruff check src/\` passes
- [ ] Verify \`uv run mypy src/\` passes

### Compliance Notes
- GDPR: <data privacy implications or "No PII affected">
- SOC 2: <audit logging requirements or "Standard logging sufficient">
- Tenant isolation: <how tenant boundary is enforced>

### Risks & Open Questions
1. <Risk or question>
2. <Risk or question>

### Definition of Done
- [ ] All phases implemented
- [ ] \`uv run pytest --cov --cov-fail-under=85\` passes
- [ ] \`uv run ruff check src/ && uv run ruff format --check src/\` passes
- [ ] \`uv run mypy src/\` passes with no errors
- [ ] PR created following \`.github/PULL_REQUEST_TEMPLATE.md\`
- [ ] At least 1 approval from CODEOWNERS
- [ ] No sensitive data in logs or error responses
- [ ] Stripe webhook handlers are idempotent (if applicable)
- [ ] All tenant data access uses tenant-aware manager (if applicable)
\`\`\`

### Step 4: Validate the Plan

Before presenting the plan, verify:

1. **No phase is empty** — if a dimension doesn't apply, explicitly state "Not applicable for this change" and remove the phase.
2. **File paths are real** — reference the actual project structure under \`src/\`, \`tests/\`, \`config/\`, \`docs/\`.
3. **Type hints are shown** — all function signatures include type annotations.
4. **Tenant isolation is addressed** — if the feature touches any data model, explain how tenant boundaries are enforced.
5. **Billing safety** — if Stripe is involved, idempotency keys and webhook deduplication are mentioned.
6. **Task idempotency** — if Celery tasks are introduced, explain why retries are safe.
7. **Sensitive paths flagged** — if changes touch \`**/billing/**\`, \`**/auth/**\`, \`config/production/**\`, or \`.env*\`, note that CODEOWNERS review from a senior/lead is required.

### Step 5: Present and Iterate

1. Present the plan to the user.
2. Ask: "Does this plan look correct? Should I adjust scope, add phases, or clarify any section?"
3. If the user confirms, save the plan to a scratch file or offer to create the branch and start Phase 1.

## Examples

**Simple feature:**
\`\`\`
/plan SAAS-78 Add tenant logo upload to onboarding
\`\`\`
→ Produces a plan focused on: S3 file upload, tenant model field, API endpoint, permission check, tests.

**Complex feature:**
\`\`\`
/plan SAAS-103 Implement usage-based billing with per-API-call metering
\`\`\`
→ Produces a plan covering: usage record model, middleware for counting, Celery task for Stripe usage reporting, webhook handling for invoice finalization, GraphQL query for usage dashboard, comprehensive tests with stripe-mock.

**Bug fix:**
\`\`\`
/plan SAAS-201 Fix race condition in tenant creation webhook handler
\`\`\`
→ Produces a focused plan: identify the race condition, add database-level locking or idempotency check, add regression test, update audit logging.

## Related Resources

- Skill definition: \`plugin/codeforge-django-saas/skills/plan/SKILL.md\`
- Planner agent: \`plugin/codeforge-django-saas/agents/planner.md\`
- Architect agent: \`plugin/codeforge-django-saas/agents/architect.md\`
- Architecture docs: \`docs/ARCHITECTURE.md\`
- Contributing guide: \`docs/CONTRIBUTING.md\`
- Phase methodology: \`plugin/codeforge-django-saas/skills/phase/SKILL.md\``,

  'plugin/codeforge-django-saas/commands/tdd.md': `# /tdd — Test-Driven Development for Django SaaS Platform

## Command Overview

Drive implementation using strict Red-Green-Refactor TDD methodology, tailored for Django multi-tenant SaaS patterns including tenant isolation, Stripe billing, Celery tasks, and REST/GraphQL APIs.

## Usage

\`\`\`
/tdd <target> [options]
\`\`\`

### Arguments

| Argument | Description | Example |
|----------|-------------|---------|
| \`<target>\` | Feature, model, endpoint, task, or ticket ID | \`tenant-onboarding\`, \`SAAS-42\`, \`billing/webhooks\` |
| \`--scope\` | Limit TDD scope | \`unit\`, \`integration\`, \`e2e\`, \`all\` (default: \`all\`) |
| \`--app\` | Django app context | \`tenants\`, \`billing\`, \`accounts\`, \`api\`, \`notifications\` |
| \`--pattern\` | SaaS pattern to apply | \`tenant-model\`, \`api-endpoint\`, \`celery-task\`, \`stripe-webhook\`, \`service-layer\`, \`graphql-mutation\` |
| \`--cycle\` | Start at specific TDD phase | \`red\`, \`green\`, \`refactor\` |

### Examples

\`\`\`
/tdd SAAS-42
/tdd tenant-onboarding --app tenants --pattern service-layer
/tdd stripe-webhook-handler --app billing --pattern stripe-webhook
/tdd usage-metering-task --app tasks --pattern celery-task
/tdd user-permissions-endpoint --app api --pattern api-endpoint --scope unit
/tdd tenant-graphql-query --app api --pattern graphql-mutation
\`\`\`

## TDD Cycle Protocol

### Phase 1: RED — Write Failing Tests First

1. **Analyze the target** — Read the ticket, feature description, or code context
2. **Identify test cases** — Enumerate all scenarios including edge cases and SaaS-specific concerns
3. **Write tests** — Create focused, descriptive tests that fail for the right reason
4. **Verify RED** — Run \`uv run pytest <test_file> -x -v\` and confirm failures are expected

#### Test File Placement

Tests mirror the \`src/\` structure under \`tests/\`:

\`\`\`
src/tenants/services.py    → tests/tenants/test_services.py
src/billing/webhooks.py    → tests/billing/test_webhooks.py
src/api/views/tenants.py   → tests/api/views/test_tenants.py
src/tasks/billing.py       → tests/tasks/test_billing.py
\`\`\`

#### Test Naming Convention

\`\`\`python
class TestTenantOnboardingService:
    def test_creates_tenant_with_valid_data(self): ...
    def test_rejects_duplicate_subdomain(self): ...
    def test_assigns_owner_role_to_creating_user(self): ...
    def test_provisions_default_subscription_plan(self): ...
    def test_isolates_tenant_data_from_other_tenants(self): ...
    def test_emits_tenant_created_audit_log(self): ...
\`\`\`

#### Required Test Categories by Pattern

**tenant-model:**
- Tenant isolation (data never leaks between tenants)
- Tenant-aware manager filters correctly
- Row-level security constraints enforced
- Cascade behavior on tenant deletion (GDPR right to deletion)

**api-endpoint:**
- Authentication required (401 for unauthenticated)
- Authorization enforced (403 for wrong role/tenant)
- Tenant scoping (users only see their tenant's data)
- Request validation (400 for invalid input)
- Success response shape and status code
- OpenAPI schema generation via drf-spectacular

**celery-task:**
- Task is idempotent (running twice produces same result)
- Task handles retries gracefully
- Task respects tenant context
- Task failure does not corrupt data
- Task result is serializable

**stripe-webhook:**
- Signature verification rejects invalid signatures
- Idempotent processing (duplicate event IDs ignored)
- Handles all expected event types
- Gracefully handles unknown event types
- Updates local subscription/invoice state correctly
- Tenant association is correct

**service-layer:**
- Business logic correctness
- Permission checks
- Audit log creation
- Cross-service interactions
- Error handling and custom exceptions

**graphql-mutation:**
- Authentication and authorization
- Input validation
- Tenant scoping
- Return type correctness
- Error response format

### Phase 2: GREEN — Minimal Implementation to Pass

1. **Implement the minimum code** to make each test pass
2. **Do not optimize** — focus on correctness only
3. **Run tests after each change** — \`uv run pytest <test_file> -x -v\`
4. **Ensure all tests pass** before moving to refactor

#### Implementation Order

1. Models and migrations (if needed)
2. Tenant-aware managers and querysets
3. Service layer (business logic)
4. Serializers / GraphQL types
5. Views / resolvers
6. Celery tasks
7. URL routing / schema registration

#### Django SaaS Implementation Checklist

- [ ] All models inherit from \`core.models.TenantAwareModel\` (if tenant-scoped)
- [ ] All querysets use \`TenantAwareManager\` (never raw \`objects.all()\` for tenant data)
- [ ] Service functions accept \`tenant\` parameter explicitly
- [ ] API views use \`TenantPermission\` and appropriate role checks
- [ ] Celery tasks accept \`tenant_id\` and re-fetch tenant inside task
- [ ] Stripe webhook handlers check \`idempotency_key\` / event ID before processing
- [ ] Audit log entries created for state-changing operations
- [ ] Type hints on all public functions

### Phase 3: REFACTOR — Improve Without Changing Behavior

1. **Run full test suite** — \`uv run pytest tests/ -x -v --tb=short\`
2. **Refactor code** — Extract methods, improve naming, reduce duplication
3. **Refactor tests** — Extract fixtures, use \`factory_boy\`, improve readability
4. **Run quality checks:**
   \`\`\`bash
   uv run ruff check src/ tests/
   uv run ruff format --check src/ tests/
   uv run mypy src/
   \`\`\`
5. **Verify coverage** — \`uv run pytest --cov=src --cov-fail-under=85\`
6. **All tests still pass** — no behavior changes

#### Refactoring Targets

- Extract shared test fixtures into \`conftest.py\` or \`tests/factories/\`
- Replace inline data with \`factory_boy\` factories
- Move complex logic from views into service layer
- Ensure files stay under 300 lines
- Add or improve docstrings on public interfaces

## SaaS-Specific Test Patterns

### Factory Definitions

\`\`\`python
# tests/factories/tenants.py
import factory
from src.tenants.models import Tenant

class TenantFactory(factory.django.DjangoModelFactory):
    class Meta:
        model = Tenant

    name = factory.Sequence(lambda n: f"Tenant {n}")
    subdomain = factory.Sequence(lambda n: f"tenant-{n}")
    is_active = True
    plan = "professional"


# tests/factories/accounts.py
import factory
from src.accounts.models import User

class UserFactory(factory.django.DjangoModelFactory):
    class Meta:
        model = User

    email = factory.LazyAttribute(lambda o: f"{o.username}@example.com")
    username = factory.Sequence(lambda n: f"user{n}")
    tenant = factory.SubFactory("tests.factories.tenants.TenantFactory")
    role = "member"
\`\`\`

### Tenant Isolation Test Pattern

\`\`\`python
@pytest.mark.django_db
class TestTenantIsolation:
    def test_queryset_filters_by_current_tenant(
        self, tenant_a: Tenant, tenant_b: Tenant
    ) -> None:
        """Tenant-aware manager must never return data from other tenants."""
        resource_a = ResourceFactory(tenant=tenant_a)
        resource_b = ResourceFactory(tenant=tenant_b)

        with tenant_context(tenant_a):
            results = Resource.tenant_objects.all()

        assert resource_a in results
        assert resource_b not in results
\`\`\`

### Stripe Webhook Idempotency Test Pattern

\`\`\`python
@pytest.mark.django_db
class TestStripeWebhookIdempotency:
    def test_duplicate_event_is_ignored(self, stripe_event_payload: dict) -> None:
        """Processing the same Stripe event twice must not create duplicate records."""
        handler = StripeWebhookHandler()

        result_first = handler.process(stripe_event_payload)
        result_second = handler.process(stripe_event_payload)

        assert result_first.created is True
        assert result_second.created is False
        assert Subscription.objects.count() == 1
\`\`\`

### Celery Task Idempotency Test Pattern

\`\`\`python
@pytest.mark.django_db
class TestBillingSyncTask:
    def test_task_is_idempotent(self, tenant: Tenant) -> None:
        """Running billing sync twice produces the same final state."""
        sync_billing_for_tenant.apply(args=[tenant.id])
        state_after_first = _snapshot_billing_state(tenant)

        sync_billing_for_tenant.apply(args=[tenant.id])
        state_after_second = _snapshot_billing_state(tenant)

        assert state_after_first == state_after_second

    def test_task_retries_on_transient_failure(
        self, tenant: Tenant, mocker: MockerFixture
    ) -> None:
        """Task retries on Stripe API timeout without corrupting state."""
        mocker.patch(
            "src.billing.stripe_client.sync_subscription",
            side_effect=[stripe.error.APIConnectionError("timeout"), None],
        )
        result = sync_billing_for_tenant.apply(args=[tenant.id])
        assert result.status == "SUCCESS"
\`\`\`

### DRF API Endpoint Test Pattern

\`\`\`python
@pytest.mark.django_db
class TestTenantListEndpoint:
    def test_unauthenticated_returns_401(self, api_client: APIClient) -> None:
        response = api_client.get("/api/v1/tenants/")
        assert response.status_code == 401

    def test_non_admin_returns_403(
        self, authenticated_client: APIClient, member_user: User
    ) -> None:
        response = authenticated_client.get("/api/v1/tenants/")
        assert response.status_code == 403

    def test_admin_sees_only_own_tenant(
        self, admin_client: APIClient, tenant: Tenant, other_tenant: Tenant
    ) -> None:
        response = admin_client.get("/api/v1/tenants/")
        assert response.status_code == 200
        tenant_ids = [t["id"] for t in response.json()["results"]]
        assert str(tenant.id) in tenant_ids
        assert str(other_tenant.id) not in tenant_ids

    def test_response_matches_openapi_schema(
        self, admin_client: APIClient
    ) -> None:
        """Endpoint response must conform to drf-spectacular generated schema."""
        response = admin_client.get("/api/v1/tenants/")
        validate_response(response, "/api/v1/tenants/", "GET")
\`\`\`

### Audit Logging Test Pattern

\`\`\`python
@pytest.mark.django_db
class TestAuditLogging:
    def test_tenant_creation_is_audited(
        self, admin_user: User, tenant: Tenant
    ) -> None:
        service = TenantOnboardingService()
        service.create_tenant(
            name="New Corp", subdomain="newcorp", owner=admin_user
        )

        log = AuditLog.objects.latest("created_at")
        assert log.action == "tenant.created"
        assert log.actor == admin_user
        assert log.tenant.subdomain == "newcorp"
\`\`\`

## Pytest Configuration Reference

Key fixtures available in \`tests/conftest.py\`:

| Fixture | Description |
|---------|-------------|
| \`tenant\` | Active tenant created via \`TenantFactory\` |
| \`other_tenant\` | Second tenant for isolation tests |
| \`user\` | Regular member user associated with \`tenant\` |
| \`admin_user\` | Admin user associated with \`tenant\` |
| \`api_client\` | Unauthenticated DRF \`APIClient\` |
| \`authenticated_client\` | DRF client authenticated as \`user\` |
| \`admin_client\` | DRF client authenticated as \`admin_user\` |
| \`stripe_event_payload\` | Sample Stripe webhook event dict |
| \`celery_app\` | Celery app configured for eager execution |
| \`tenant_context\` | Context manager setting current tenant |
| \`mailoutbox\` | Captured outbound emails |

## Execution Commands

\`\`\`bash
# Run specific test file (RED phase)
uv run pytest tests/billing/test_webhooks.py -x -v

# Run specific test class
uv run pytest tests/tenants/test_services.py::TestTenantOnboardingService -x -v

# Run with coverage (REFACTOR phase)
uv run pytest --cov=src --cov-report=term-missing --cov-fail-under=85

# Run only unit tests (fast feedback)
uv run pytest tests/ -x -v -m "not integration and not e2e"

# Run integration tests (includes DB, Redis, Celery)
uv run pytest tests/ -x -v -m integration

# Full quality check after refactor
uv run ruff check src/ tests/
uv run ruff format --check src/ tests/
uv run mypy src/
uv run pytest --cov=src --cov-fail-under=85
\`\`\`

## Output Format

After completing a TDD cycle, report:

\`\`\`markdown
## TDD Cycle Complete: <target>

### RED Phase
- Tests written: <count>
- Test file(s): <paths>
- All tests failing as expected: ✅

### GREEN Phase
- Implementation file(s): <paths>
- All tests passing: ✅
- Migrations needed: yes/no

### REFACTOR Phase
- Ruff check: ✅ no issues
- Ruff format: ✅ formatted
- Mypy: ✅ no errors
- Coverage: <percentage>% (threshold: 85%)
- Files under 300 lines: ✅

### SaaS Compliance
- Tenant isolation verified: ✅/❌/N/A
- Idempotency verified: ✅/❌/N/A
- Audit logging: ✅/❌/N/A
- RBAC enforced: ✅/❌/N/A
- Stripe webhook safety: ✅/❌/N/A
\`\`\`

## Delegation

- For architectural questions during TDD, consult the **architect** agent — see \`plugin/codeforge-django-saas/agents/architect.md\`
- For build or test infrastructure failures, invoke \`/build-fix\` — see \`plugin/codeforge-django-saas/commands/build-fix.md\`
- For reviewing completed TDD output before PR, invoke \`/code-review\` — see \`plugin/codeforge-django-saas/commands/code-review.md\`
- For planning test scenarios from a ticket, invoke \`/plan\` — see \`plugin/codeforge-django-saas/commands/plan.md\`
- Refer to the TDD skill definition at \`plugin/codeforge-django-saas/skills/tdd/SKILL.md\` for detailed methodology
- Refer to the TDD guide agent at \`plugin/codeforge-django-saas/agents/tdd-guide.md\` for coaching`,

  'plugin/codeforge-django-saas/commands/verify.md': `# /verify — Django SaaS Platform Verification Command

## Purpose

Run a comprehensive verification suite against the current working tree to confirm code quality, type safety, test coverage, tenant isolation, billing integrity, and deployment readiness. This command is the single gate before any PR is opened or code is merged.

## When to Use

- Before opening a pull request
- After completing a feature or bugfix implementation
- After resolving merge conflicts
- After refactoring shared modules (\`core/\`, \`tenants/\`, \`billing/\`)
- As a final check before requesting human review

## Execution Steps

### Step 1: Pre-flight Checks

Confirm the environment is ready before running any tools:

\`\`\`
# Verify virtual environment and dependencies are in sync
uv sync --frozen

# Confirm PostgreSQL is reachable
uv run python manage.py dbshell -- -c "SELECT 1;" 2>/dev/null || echo "WARN: PostgreSQL not reachable"

# Confirm Redis is reachable
uv run python -c "import redis; redis.Redis().ping()" 2>/dev/null || echo "WARN: Redis not reachable"

# Check for unapplied migrations
uv run python manage.py migrate --check --no-input
\`\`\`

If migrations are out of sync, report the issue but continue with remaining checks.

### Step 2: Linting with Ruff

\`\`\`
uv run ruff check src/ tests/ scripts/ --output-format=grouped
\`\`\`

**What to check:**
- Zero lint errors on all files in \`src/\`, \`tests/\`, \`scripts/\`
- No unused imports, especially in \`__init__.py\` files that re-export app components
- No wildcard imports (\`from module import *\`) — these break tenant-aware namespace isolation
- Django-specific rules: no \`objects.all()\` without tenant filtering in app code outside \`core/\`

If violations are found, attempt auto-fix:

\`\`\`
uv run ruff check src/ tests/ scripts/ --fix
\`\`\`

Report any remaining violations that require manual intervention.

### Step 3: Formatting with Ruff Format

\`\`\`
uv run ruff format --check src/ tests/ scripts/
\`\`\`

If formatting drift is detected, apply fixes:

\`\`\`
uv run ruff format src/ tests/ scripts/
\`\`\`

Report all files that were reformatted.

### Step 4: Type Checking with mypy (Strict)

\`\`\`
uv run mypy src/ --strict --show-error-codes --no-error-summary
\`\`\`

**Django/SaaS-specific type concerns:**
- All public functions must have type annotations — no \`Any\` escape hatches in \`billing/\`, \`tenants/\`, or \`auth/\` modules
- Stripe API return types must be properly typed (use \`stripe.Subscription\`, \`stripe.Invoice\`, etc., not \`dict\`)
- Celery task signatures must have typed parameters and return types
- Tenant-aware QuerySet managers must return properly typed querysets (\`TenantQuerySet[M]\`)
- Django model fields should use \`django-stubs\` typed field descriptors
- Service layer functions must declare explicit return types, especially in \`billing/services.py\` and \`tenants/services.py\`

### Step 5: Security-Sensitive File Audit

Scan files in sensitive paths for common issues:

\`\`\`
# Check for hardcoded secrets, API keys, or tokens
uv run ruff check src/billing/ src/accounts/ config/ --select S105,S106,S107

# Verify no .env files are staged
git diff --cached --name-only | grep -E '\\.env' && echo "FAIL: .env file staged for commit"

# Check that Stripe secret keys are not in source
grep -rn "sk_live_\\|sk_test_\\|whsec_" src/ config/ tests/ --include="*.py" && echo "FAIL: Stripe secret key found in source"

# Verify sensitive settings use django-environ / env vars
grep -rn "STRIPE_SECRET_KEY\\s*=" config/ --include="*.py" | grep -v "env(" && echo "FAIL: Stripe key not loaded from environment"
\`\`\`

**Sensitive paths requiring extra scrutiny:**
- \`src/billing/**\` — Stripe keys, webhook secrets, PII in invoice data
- \`src/accounts/**\` — Authentication logic, password handling, session management
- \`config/production/**\` — Production secrets, database credentials
- Any file matching \`.env*\`

### Step 6: Tenant Isolation Verification

Verify that multi-tenancy boundaries are respected:

\`\`\`
# Check that no raw SQL bypasses tenant filtering
grep -rn "raw(\\|execute(\\|RawSQL(" src/ --include="*.py" | grep -v "# tenant-safe" | grep -v "tests/"

# Check that model managers in app code extend TenantAwareManager
grep -rn "objects = models.Manager()" src/ --include="*.py" | grep -v "core/" | grep -v "tests/"

# Verify all ViewSets use tenant-scoped querysets
grep -rn "def get_queryset" src/api/ --include="*.py" -A 5 | grep -v "tenant"
\`\`\`

**Report any findings as HIGH severity.** Tenant isolation failures are SOC 2 compliance violations.

### Step 7: Unit and Integration Tests

\`\`\`
uv run pytest tests/ \\
  --tb=short \\
  --strict-markers \\
  --strict-config \\
  -x \\
  --cov=src \\
  --cov-report=term-missing \\
  --cov-fail-under=85 \\
  -q
\`\`\`

**What to verify:**
- All tests pass (zero failures, zero errors)
- Coverage meets or exceeds **85%** threshold
- No tests are skipped without a documented reason (\`@pytest.mark.skip(reason="...")\`)
- Billing tests use Stripe mock fixtures, never live API calls
- Tenant tests verify cross-tenant data cannot leak between test cases
- Celery task tests use \`CELERY_ALWAYS_EAGER=True\` or \`celery_app.conf.task_always_eager\`
- Factory Boy factories are used for test data — no raw \`Model.objects.create()\` in tests

If tests fail, report the failure summary with file paths and test names. Do NOT attempt to fix test failures automatically — report them for the developer.

### Step 8: Migration Safety Check

\`\`\`
# Check for missing migrations
uv run python manage.py makemigrations --check --dry-run --no-input

# Verify no migration conflicts
uv run python manage.py migrate --plan --no-input 2>&1 | grep -i "conflict" && echo "FAIL: Migration conflicts detected"

# Check for irreversible migrations (missing reverse operations)
grep -rn "migrations.RunSQL\\|migrations.RunPython" src/*/migrations/ --include="*.py" -A 3 | grep -v "reverse"
\`\`\`

**SaaS-specific migration concerns:**
- Migrations touching \`tenants_tenant\` or row-level security policies must be flagged for lead review
- Any migration adding NOT NULL columns without defaults must be reviewed for zero-downtime deployment
- Migrations in \`billing/\` that alter Stripe-synced models must be coordinated with webhook handler updates

### Step 9: Celery Task Idempotency Check

\`\`\`
# Verify all Celery tasks use idempotent patterns
grep -rn "@shared_task\\|@app.task" src/tasks/ --include="*.py" -A 10 | grep -v "idempotent\\|get_or_create\\|update_or_create\\|if not.*exists"
\`\`\`

**Flag tasks that:**
- Lack idempotency keys or deduplication logic
- Perform non-reversible side effects without guard clauses (e.g., sending emails, creating Stripe charges)
- Missing \`acks_late=True\` for tasks that must survive worker restarts
- Missing \`max_retries\` and \`retry_backoff\` for tasks calling external services (Stripe, SES)

### Step 10: OpenAPI Schema Validation

\`\`\`
# Generate and validate the OpenAPI schema
uv run python manage.py spectacular --validate --fail-on-warn
\`\`\`

**Verify:**
- All DRF ViewSets have \`@extend_schema\` decorators or serializer-based auto-detection
- No undocumented endpoints in \`src/api/\`
- Request/response schemas match serializer definitions
- Tenant-scoped endpoints document the \`X-Tenant-ID\` header requirement

### Step 11: Conventional Commit Check

\`\`\`
# Verify recent commits follow conventional commit format
git log --oneline origin/main..HEAD | grep -vE "^[a-f0-9]+ (feat|fix|chore|docs|refactor|test|perf|ci|build|style)(\\(.+\\))?: .+" && echo "WARN: Non-conventional commits found"
\`\`\`

### Step 12: File Size Check

\`\`\`
# Flag files exceeding 300-line limit
find src/ tests/ -name "*.py" -exec awk 'END{if(NR>300) print FILENAME": "NR" lines"}' {} \\;
\`\`\`

Report any files exceeding 300 lines. Suggest splitting into smaller modules following the modular monolith pattern.

### Step 13: GDPR Compliance Spot Check

\`\`\`
# Check for PII logging
grep -rn "logger\\.\\(info\\|debug\\|warning\\|error\\)" src/ --include="*.py" | grep -iE "email|password|ssn|phone|address|ip_address|credit.card" | grep -v "# gdpr-safe"

# Verify User model has data export/deletion support
grep -rn "def export_user_data\\|def delete_user_data\\|def anonymize" src/accounts/ --include="*.py"
\`\`\`

## Verification Report Format

After completing all steps, produce a structured report:

\`\`\`
## Verification Report — django-saas-platform

**Branch:** <current branch>
**Commit:** <short SHA>
**Timestamp:** <ISO 8601>

### Results Summary

| Check                        | Status | Details                    |
|------------------------------|--------|----------------------------|
| Dependencies synced          | ✅/❌  |                            |
| Ruff lint                    | ✅/❌  | N issues (N auto-fixed)    |
| Ruff format                  | ✅/❌  | N files reformatted        |
| mypy strict                  | ✅/❌  | N errors                   |
| Secret scan                  | ✅/❌  |                            |
| Tenant isolation             | ✅/❌  | N findings                 |
| Tests                        | ✅/❌  | N passed, N failed         |
| Coverage                     | ✅/❌  | XX% (threshold: 85%)       |
| Migration safety             | ✅/❌  |                            |
| Celery idempotency           | ✅/❌  | N tasks flagged            |
| OpenAPI schema               | ✅/❌  |                            |
| Conventional commits         | ✅/⚠️  |                            |
| File size (≤300 lines)       | ✅/⚠️  | N files over limit         |
| GDPR compliance              | ✅/⚠️  |                            |

### Blocking Issues (must fix before PR)
- <list any ❌ items with details>

### Warnings (should fix, non-blocking)
- <list any ⚠️ items with details>

### Sensitive Path Changes
- <list any modified files in billing/, auth/, config/production/, .env*>
- These files require review from designated CODEOWNERS.

### PR Readiness: ✅ READY / ❌ NOT READY
\`\`\`

## Failure Handling

- **Lint/format failures**: Auto-fix and re-run. If issues persist, report them.
- **Type errors**: Report with file, line, and error code. Do not suppress with \`type: ignore\`.
- **Test failures**: Report full failure output. Do not modify tests to make them pass.
- **Tenant isolation findings**: Always treat as **blocking**. These are SOC 2 compliance issues.
- **Secret detection**: Always treat as **blocking**. Immediately flag for security review.
- **Coverage below 85%**: Blocking. Report uncovered files and suggest which modules need tests.

## Integration with Other Commands

- **/plan** generates implementation plans — run \`/verify\` after implementing each plan step
- **/tdd** drives test-first development — \`/verify\` confirms the full suite still passes after TDD cycles
- After \`/verify\` reports READY, the developer opens a PR for human review per CODEOWNERS policy
- The CI pipeline (\`.github/workflows/ci.yml\`) runs equivalent checks — \`/verify\` catches issues before pushing

## Notes

- This command does NOT deploy anything. It is a local/pre-push verification gate.
- For billing-related changes, manually confirm Stripe webhook handler idempotency — automated checks catch patterns but not logic errors.
- If working on \`tenants/\` or \`core/\` modules, consider running the full integration test suite: \`uv run pytest tests/ -m integration --no-header\`
- All verification steps align with the CI pipeline stages defined in \`.github/workflows/ci.yml\``,

  'plugin/codeforge-django-saas/hooks/hooks.json': `{
  "version": "1.0",
  "plugin": "codeforge-django-saas",
  "description": "Git hook definitions for django-saas-platform — enforces commit conventions, code quality, tenant safety, and billing module protections",
  "hooks": {
    "pre-commit": {
      "description": "Runs before each commit to enforce code quality, formatting, type safety, and sensitive path protections",
      "enabled": true,
      "fail_on_error": true,
      "timeout_seconds": 120,
      "steps": [
        {
          "id": "check-env-files",
          "name": "Block .env files from commit",
          "description": "Prevents accidental commit of environment files containing secrets (SOC 2 / GDPR compliance)",
          "command": "git diff --cached --name-only | grep -E '^\\\\.env' && echo '❌ .env files must not be committed. Use config/ settings and django-environ.' && exit 1 || exit 0",
          "order": 1,
          "tags": ["security", "soc2"]
        },
        {
          "id": "check-secret-patterns",
          "name": "Scan for hardcoded secrets",
          "description": "Detects Stripe keys, AWS credentials, database URLs, and other secrets in staged files",
          "command": "git diff --cached -U0 | grep -iE '(sk_live_|sk_test_|AKIA[0-9A-Z]{16}|password\\\\s*=\\\\s*[\\"\\\\x27][^\\"\\\\x27]+|DATABASE_URL\\\\s*=|STRIPE_SECRET)' && echo '❌ Potential secret detected in staged changes. Use environment variables via django-environ.' && exit 1 || exit 0",
          "order": 2,
          "tags": ["security", "soc2", "secrets"]
        },
        {
          "id": "ruff-format-check",
          "name": "Check code formatting with ruff",
          "description": "Ensures all staged Python files conform to ruff format (replaces black)",
          "command": "uv run ruff format --check $(git diff --cached --name-only --diff-filter=ACM | grep '\\\\.py$') 2>/dev/null || true",
          "order": 3,
          "tags": ["formatting", "style"],
          "file_filter": "*.py"
        },
        {
          "id": "ruff-lint",
          "name": "Lint with ruff",
          "description": "Runs ruff linter on staged Python files (replaces flake8, isort, pycodestyle)",
          "command": "uv run ruff check $(git diff --cached --name-only --diff-filter=ACM | grep '\\\\.py$') 2>/dev/null || true",
          "order": 4,
          "tags": ["linting", "quality"],
          "file_filter": "*.py"
        },
        {
          "id": "mypy-staged",
          "name": "Type check staged files with mypy",
          "description": "Runs mypy strict mode on staged Python files — type hints required on all public functions",
          "command": "STAGED_PY=$(git diff --cached --name-only --diff-filter=ACM | grep '\\\\.py$' | head -20); if [ -n \\"$STAGED_PY\\" ]; then uv run mypy $STAGED_PY --no-error-summary 2>/dev/null; fi",
          "order": 5,
          "tags": ["type-checking", "quality"],
          "file_filter": "*.py",
          "allow_failure": false
        },
        {
          "id": "check-file-length",
          "name": "Enforce max file length (300 lines)",
          "description": "Flags staged Python files exceeding 300 lines — keeps modules focused per project conventions",
          "command": "for f in $(git diff --cached --name-only --diff-filter=ACM | grep '\\\\.py$'); do lines=$(wc -l < \\"$f\\" 2>/dev/null || echo 0); if [ \\"$lines\\" -gt 300 ]; then echo \\"❌ $f has $lines lines (max 300). Split into smaller modules.\\"; exit 1; fi; done",
          "order": 6,
          "tags": ["quality", "architecture"],
          "file_filter": "*.py"
        },
        {
          "id": "check-tenant-manager-usage",
          "name": "Verify tenant-aware manager usage",
          "description": "Detects direct model queries in tenant-scoped apps that bypass the tenant-aware manager (multi-tenant data isolation)",
          "command": "for f in $(git diff --cached --name-only --diff-filter=ACM | grep -E 'src/(accounts|billing|notifications)/' | grep '\\\\.py$'); do if grep -nE '\\\\.(objects\\\\.all|objects\\\\.filter|objects\\\\.get|objects\\\\.exclude)' \\"$f\\" | grep -v 'tenant_objects' | grep -v '# tenant-safe' | grep -v 'TenantAwareManager' | head -5; then echo \\"⚠️  $f: Use tenant_objects manager or mark with # tenant-safe comment\\"; exit 1; fi; done; exit 0",
          "order": 7,
          "tags": ["security", "multi-tenancy", "soc2"],
          "file_filter": "*.py"
        },
        {
          "id": "check-billing-review-tag",
          "name": "Flag billing module changes for review",
          "description": "Warns when billing/ or Stripe-related files are modified — these require dedicated reviewer per CODEOWNERS",
          "command": "BILLING_FILES=$(git diff --cached --name-only | grep -E '(billing/|stripe|webhook)'); if [ -n \\"$BILLING_FILES\\" ]; then echo \\"⚠️  Billing/Stripe files modified — ensure @backend-billing-team review:\\"; echo \\"$BILLING_FILES\\"; fi; exit 0",
          "order": 8,
          "tags": ["billing", "stripe", "review"],
          "fail_on_error": false
        },
        {
          "id": "check-migration-conflicts",
          "name": "Detect Django migration conflicts",
          "description": "Checks for multiple new migration files in the same app which may cause conflicts",
          "command": "for app_dir in $(git diff --cached --name-only --diff-filter=A | grep '/migrations/[0-9]' | sed 's|/migrations/.*||' | sort -u); do count=$(git diff --cached --name-only --diff-filter=A | grep \\"$app_dir/migrations/[0-9]\\" | wc -l); if [ \\"$count\\" -gt 1 ]; then echo \\"❌ Multiple new migrations in $app_dir — squash or rebase to avoid conflicts.\\"; exit 1; fi; done; exit 0",
          "order": 9,
          "tags": ["django", "migrations"]
        },
        {
          "id": "check-celery-task-idempotency",
          "name": "Remind about Celery task idempotency",
          "description": "Flags new or modified Celery tasks to remind developers that all tasks must be idempotent",
          "command": "TASK_FILES=$(git diff --cached --name-only --diff-filter=ACM | grep -E 'src/tasks/|@shared_task|@app\\\\.task'); if [ -n \\"$TASK_FILES\\" ]; then for f in $(git diff --cached --name-only --diff-filter=ACM | grep '\\\\.py$'); do if grep -l '@shared_task\\\\|@app\\\\.task' \\"$f\\" 2>/dev/null; then if ! grep -q 'idempotent\\\\|idempotency_key\\\\|# idempotent' \\"$f\\"; then echo \\"⚠️  $f: Celery tasks must be idempotent. Add idempotency_key or document idempotency.\\"; fi; fi; done; fi; exit 0",
          "order": 10,
          "tags": ["celery", "tasks", "reliability"],
          "fail_on_error": false
        },
        {
          "id": "check-ai-generated-marker",
          "name": "Verify AI-generated code is marked",
          "description": "Per AI-USAGE-POLICY.md, AI-generated code must include attribution comment",
          "command": "STAGED=$(git diff --cached --name-only --diff-filter=ACM | grep '\\\\.py$'); if [ -n \\"$STAGED\\" ]; then if echo \\"$GIT_AUTHOR_NAME\\" | grep -qi 'claude\\\\|copilot\\\\|ai'; then for f in $STAGED; do if ! grep -q 'AI-Generated\\\\|ai-generated\\\\|Generated by' \\"$f\\"; then echo \\"⚠️  $f: AI-generated code should include attribution per docs/AI-USAGE-POLICY.md\\"; fi; done; fi; fi; exit 0",
          "order": 11,
          "tags": ["ai", "policy"],
          "fail_on_error": false
        }
      ]
    },
    "post-commit": {
      "description": "Runs after each commit for notifications and tracking",
      "enabled": true,
      "fail_on_error": false,
      "timeout_seconds": 30,
      "steps": [
        {
          "id": "log-sensitive-changes",
          "name": "Log changes to sensitive paths",
          "description": "Records commits touching auth, billing, or production config for SOC 2 audit trail",
          "command": "SENSITIVE=$(git diff-tree --no-commit-id --name-only -r HEAD | grep -E '(billing/|auth/|config/production|accounts/.*permissions)'); if [ -n \\"$SENSITIVE\\" ]; then COMMIT=$(git rev-parse --short HEAD); AUTHOR=$(git log -1 --format='%an'); DATE=$(git log -1 --format='%ai'); echo \\"[$DATE] $AUTHOR ($COMMIT) modified sensitive paths:\\" >> .git/audit-log.txt; echo \\"$SENSITIVE\\" >> .git/audit-log.txt; echo '---' >> .git/audit-log.txt; echo \\"📋 Sensitive path changes logged to .git/audit-log.txt\\"; fi",
          "order": 1,
          "tags": ["security", "audit", "soc2"]
        },
        {
          "id": "remind-migration-apply",
          "name": "Remind to apply new migrations",
          "description": "Reminds developer to run migrations locally when new migration files are committed",
          "command": "MIGRATIONS=$(git diff-tree --no-commit-id --name-only -r HEAD | grep '/migrations/[0-9]'); if [ -n \\"$MIGRATIONS\\" ]; then echo ''; echo '🗄️  New migration(s) committed:'; echo \\"$MIGRATIONS\\"; echo 'Run: uv run python manage.py migrate'; echo ''; fi",
          "order": 2,
          "tags": ["django", "migrations", "reminder"]
        },
        {
          "id": "remind-celery-restart",
          "name": "Remind to restart Celery workers",
          "description": "Reminds developer to restart Celery when task files are modified",
          "command": "TASK_CHANGES=$(git diff-tree --no-commit-id --name-only -r HEAD | grep -E 'src/tasks/|celery'); if [ -n \\"$TASK_CHANGES\\" ]; then echo ''; echo '⚙️  Celery task files changed:'; echo \\"$TASK_CHANGES\\"; echo 'Restart workers: celery -A config worker --loglevel=info'; echo 'Restart beat: celery -A config beat --loglevel=info'; echo ''; fi",
          "order": 3,
          "tags": ["celery", "tasks", "reminder"]
        },
        {
          "id": "display-commit-summary",
          "name": "Show commit summary",
          "description": "Displays a brief summary of the commit for developer awareness",
          "command": "echo ''; echo \\"✅ Committed: $(git log -1 --format='%s' HEAD)\\"; FILES_CHANGED=$(git diff-tree --no-commit-id --name-only -r HEAD | wc -l | tr -d ' '); echo \\"   $FILES_CHANGED file(s) changed | $(git rev-parse --short HEAD)\\"; echo ''",
          "order": 4,
          "tags": ["info"]
        }
      ]
    },
    "commit-msg": {
      "description": "Validates commit message format — enforces conventional commits with optional ticket reference",
      "enabled": true,
      "fail_on_error": true,
      "timeout_seconds": 5,
      "steps": [
        {
          "id": "validate-conventional-commit",
          "name": "Enforce conventional commit format",
          "description": "Validates commit messages match pattern: type(scope): description [SAAS-123]. See git-hooks/commit-msg for full implementation.",
          "command": "See git-hooks/commit-msg for implementation",
          "order": 1,
          "tags": ["git", "conventions"],
          "implementation_ref": "git-hooks/commit-msg"
        }
      ]
    },
    "pre-push": {
      "description": "Runs before push to validate test suite and prevent pushing to protected branches",
      "enabled": true,
      "fail_on_error": true,
      "timeout_seconds": 300,
      "steps": [
        {
          "id": "protect-main-branch",
          "name": "Prevent direct push to main",
          "description": "Blocks direct pushes to main — all changes must go through pull requests per GitHub Flow",
          "command": "See git-hooks/pre-push for implementation",
          "order": 1,
          "tags": ["git", "branch-protection"],
          "implementation_ref": "git-hooks/pre-push"
        },
        {
          "id": "run-test-suite",
          "name": "Run pytest before push",
          "description": "Executes the full test suite with coverage check (85% threshold)",
          "command": "uv run pytest tests/ --tb=short --co -q 2>/dev/null | tail -1",
          "order": 2,
          "tags": ["testing", "quality"],
          "implementation_ref": "git-hooks/pre-push"
        }
      ]
    }
  },
  "installation": {
    "description": "Hook installation instructions — hooks are installed via install.sh or manually",
    "auto_install_ref": "install.sh",
    "manual_commands": [
      "git config core.hooksPath git-hooks",
      "chmod +x git-hooks/*"
    ]
  },
  "configuration": {
    "hooks_directory": "git-hooks/",
    "plugin_directory": "plugin/codeforge-django-saas/",
    "sensitive_paths": [
      "src/billing/**",
      "src/accounts/auth/**",
      "config/production/**",
      ".env*"
    ],
    "protected_branches": ["main"],
    "coverage_threshold": 85,
    "max_file_length": 300,
    "commit_pattern": "^(feat|fix|docs|style|refactor|perf|test|chore|ci|build|revert)(\\\\([a-z-]+\\\\))?!?:\\\\s.{1,100}"
  }
}`,

  'plugin/codeforge-django-saas/skills/build-fix/SKILL.md': `---
skill: build-fix
version: 1.0.0
description: Iteratively build, lint, type-check, and test Django SaaS code until all checks pass
triggers:
  - build failure
  - lint errors
  - type check errors
  - test failures
  - CI pipeline failure
  - after code generation
  - after refactoring
inputs:
  - name: scope
    description: Which checks to run (all, lint, typecheck, test, build)
    default: all
  - name: target
    description: Specific file, Django app, or directory to focus on
    default: src/
  - name: max_iterations
    description: Maximum fix-check cycles before escalating
    default: 10
  - name: ci_log
    description: Optional CI log output to diagnose remote failures
    default: ""
tools_required:
  - Bash (for running linters, tests, Django commands)
  - Read/Write file access
  - GitHub MCP (for fetching CI logs if needed)
tags:
  - build
  - fix
  - lint
  - typecheck
  - test
  - django
  - ci
---

# Build-Fix Skill

You are an expert Django/Python developer fixing build, lint, type-check, and test failures in a multi-tenant SaaS platform. Your goal is to iterate through check-fix cycles until all checks pass, or you hit the maximum iteration count.

## Context

This is a Django 5.0 SaaS platform with:
- **Linting**: \`ruff\` (configured in \`ruff.toml\`)
- **Formatting**: \`ruff format\`
- **Type checking**: \`mypy\` in strict mode (configured in \`pyproject.toml\`)
- **Tests**: \`pytest\` with \`pytest-django\`, \`pytest-cov\`, \`pytest-asyncio\`, \`factory_boy\`
- **Coverage threshold**: 85%
- **Package manager**: \`uv\`
- **Max file length**: 300 lines
- **Key apps**: \`accounts\`, \`tenants\`, \`billing\`, \`api\`, \`core\`, \`notifications\`, \`tasks\`, \`utils\`

## Execution Protocol

### Phase 1: Diagnose

1. If a \`ci_log\` input is provided, analyze it first to identify the root failures before running anything locally.

2. Determine which checks are failing. Run the appropriate diagnostic commands based on \`scope\`:

\`\`\`bash
# Lint check
uv run ruff check {target} --output-format=json

# Format check
uv run ruff format --check {target}

# Type check
uv run mypy {target} --no-error-summary 2>&1 | head -100

# Test suite
uv run pytest {target} -x --tb=short -q 2>&1 | tail -60

# Django system checks
uv run python manage.py check --deploy 2>&1

# Django migrations check
uv run python manage.py makemigrations --check --dry-run 2>&1
\`\`\`

3. Collect ALL errors before starting fixes. Do not fix one error at a time blindly — understand the full picture.

4. Categorize errors by type and priority:
   - **P0 — Import/Syntax errors**: Code won't load at all
   - **P1 — Type errors**: \`mypy\` strict mode violations
   - **P2 — Test failures**: Broken assertions, missing fixtures, tenant context issues
   - **P3 — Lint violations**: \`ruff\` rule violations
   - **P4 — Format issues**: \`ruff format\` deviations
   - **P5 — Migration issues**: Missing or conflicting migrations

### Phase 2: Plan Fixes

Before making changes, create a mental fix plan:

1. **Group related errors** — a single root cause often produces multiple errors (e.g., a missing import causes type errors and test failures downstream).
2. **Order fixes by dependency** — fix imports before type errors, fix models before serializers, fix services before views.
3. **Identify safe auto-fixes** — \`ruff check --fix\` and \`ruff format\` can resolve many issues automatically.
4. **Flag risky changes** — anything touching \`billing/\`, \`auth/\`, \`tenants/\` models, or \`config/production/\` requires extra caution.

### Phase 3: Fix Iteratively

Execute fixes in this order:

#### Step 1: Auto-fixable issues

\`\`\`bash
# Auto-fix lint issues where safe
uv run ruff check {target} --fix

# Auto-format
uv run ruff format {target}
\`\`\`

#### Step 2: Import and module errors

- Fix missing imports, circular imports, incorrect relative imports.
- Ensure Django app configs are correct in \`apps.py\`.
- Verify \`__init__.py\` files expose the right symbols.

#### Step 3: Type errors (mypy strict)

- Add missing type annotations to all public functions.
- Fix \`Optional\` vs \`None\` union types.
- Add proper generics to Django QuerySets: \`QuerySet[TenantModel]\`.
- Use \`TYPE_CHECKING\` blocks for circular type imports.
- Fix tenant-aware manager return types — \`TenantManager\` should return \`TenantQuerySet\`.
- Ensure Celery task signatures have proper return type annotations.
- Use \`reveal_type()\` temporarily if a type is unclear, then remove it.

Common mypy patterns in this project:

\`\`\`python
from __future__ import annotations

from typing import TYPE_CHECKING

if TYPE_CHECKING:
    from tenants.models import Tenant
    from accounts.models import User

# Django model fields need django-stubs
class MyModel(TenantAwareModel):
    name: str  # Don't annotate model fields — django-stubs handles this

# Service layer — always annotate
def create_subscription(
    tenant: Tenant,
    plan_id: str,
    payment_method_id: str,
) -> StripeSubscription:
    ...

# Celery tasks — annotate return type
@shared_task(bind=True, max_retries=3)
def sync_billing_data(self: Task, tenant_id: int) -> None:
    ...
\`\`\`

#### Step 4: Test failures

- Read the full traceback, not just the assertion line.
- Check for missing \`@pytest.mark.django_db\` decorators.
- Check for missing tenant context — most tests need a tenant fixture:

\`\`\`python
@pytest.fixture
def tenant(db: None) -> Tenant:
    return TenantFactory()

@pytest.fixture
def authenticated_client(tenant: Tenant) -> APIClient:
    user = UserFactory(tenant=tenant)
    client = APIClient()
    client.force_authenticate(user=user)
    client.tenant = tenant
    return client
\`\`\`

- Ensure \`factory_boy\` factories match current model fields.
- Check that Celery tasks are called with \`task.delay()\` in tests or use \`CELERY_ALWAYS_EAGER=True\`.
- For Stripe-related tests, verify mocks cover the correct API version and response shapes.
- For tenant isolation tests, verify that cross-tenant data access is properly blocked.

#### Step 5: Migration issues

\`\`\`bash
# Generate missing migrations
uv run python manage.py makemigrations

# Check for conflicts
uv run python manage.py makemigrations --check
\`\`\`

- If migrations conflict, resolve by merging: \`uv run python manage.py makemigrations --merge\`.
- Never modify existing migrations that have been deployed — create new ones.

#### Step 6: Django system checks

\`\`\`bash
uv run python manage.py check --deploy
\`\`\`

- Fix security warnings (CSRF, HTTPS, HSTS settings).
- These checks reference \`config/\` settings — only modify \`config/development.py\` or \`config/test.py\` unless the issue is in base settings.

### Phase 4: Verify

After each round of fixes, run the full check suite:

\`\`\`bash
# Run all checks in CI order
echo "=== Lint ===" && uv run ruff check {target} && \\
echo "=== Format ===" && uv run ruff format --check {target} && \\
echo "=== Type Check ===" && uv run mypy {target} && \\
echo "=== Tests ===" && uv run pytest {target} --tb=short -q && \\
echo "=== All checks passed ==="
\`\`\`

If failures remain, return to Phase 1 with the new error output. Track your iteration count.

### Phase 5: Escalate or Complete

**If all checks pass:**
- Confirm the fix summary: what was broken, what was changed, and why.
- If you modified any file in \`billing/\`, \`auth/\`, or \`tenants/\`, explicitly call this out — these are sensitive paths that require careful review.
- If you added or changed any migration, note this for the reviewer.
- If coverage dropped, note which lines are uncovered and suggest test additions.

**If max iterations reached without resolution:**
- Summarize what was fixed and what remains broken.
- Provide the exact error output for remaining failures.
- Identify the likely root cause and suggest manual investigation steps.
- Flag if the issue might be environmental (database state, Redis connection, missing env vars).

## Rules and Constraints

1. **Never skip or disable checks** — do not add \`# type: ignore\` without a specific error code and comment explaining why. Do not add \`# noqa\` without justification. Never lower the coverage threshold.

2. **Never modify test expectations to match buggy code** — if a test fails, determine whether the test or the implementation is wrong. Prefer fixing the implementation.

3. **Preserve tenant isolation** — when fixing queries, always ensure tenant filtering is maintained. Never remove \`.filter(tenant=tenant)\` or bypass \`TenantAwareManager\` to fix a test.

4. **Preserve idempotency** — when fixing Celery tasks or Stripe webhook handlers, ensure the fix maintains idempotent behavior. Tasks must be safe to retry.

5. **Respect file length limits** — if a fix would push a file over 300 lines, refactor by extracting to a new module (e.g., split \`views.py\` into \`views/subscriptions.py\` and \`views/invoices.py\`).

6. **Do not introduce new dependencies** without flagging them. If a fix seems to require a new package, note it and propose the minimal solution using existing dependencies first.

7. **Sensitive paths require extra narration** — when modifying files in \`**/billing/**\`, \`**/auth/**\`, \`config/production/**\`, or \`.env*\`, explain every change in detail.

8. **Keep fixes minimal and focused** — fix the failing check, not adjacent code that happens to be nearby. Avoid drive-by refactors during build-fix cycles.

9. **GDPR and SOC 2 awareness** — if fixing code that handles PII (user emails, names, billing info), ensure logging does not expose sensitive data and audit trails are preserved.

10. **Mark AI-generated code** — any new code you write must include the \`# AI-generated\` comment at the top of the file or function, per the project's AI usage policy.

## Common Failure Patterns

| Symptom | Likely Cause | Fix |
|---|---|---|
| \`ImportError: cannot import name 'X'\` | Circular import between Django apps | Use \`TYPE_CHECKING\` guard or lazy import |
| \`mypy: Missing return statement\` | Early return path without explicit \`None\` | Add \`return None\` or restructure control flow |
| \`mypy: Incompatible types in assignment\` | Django field vs Python type mismatch | Use \`django-stubs\` typed fields, check \`django.pyi\` stubs |
| \`FAILED test_* - TenantNotSet\` | Test missing tenant context fixture | Add \`tenant\` fixture and set \`request.tenant\` |
| \`FAILED test_* - stripe.error.AuthenticationError\` | Stripe mock not applied | Add \`@mock.patch("stripe.Subscription.create")\` |
| \`ruff: F401 imported but unused\` | Import used only for type hints | Move to \`TYPE_CHECKING\` block |
| \`ruff: E501 line too long\` | Should not occur — ruff format handles this | Run \`uv run ruff format\` |
| \`Migration conflict\` | Two branches added migrations to same app | Run \`makemigrations --merge\` |
| \`Coverage below 85%\` | New code without tests | Write tests using \`factory_boy\` fixtures |
| \`Django check: CSRF_TRUSTED_ORIGINS\` | Missing config for new domain | Add to \`config/base.py\` \`CSRF_TRUSTED_ORIGINS\` |

## Example Session

\`\`\`
Iteration 1/10 — Running diagnostics...
  ruff check: 3 errors (F401, F841, I001)
  ruff format: 2 files would be reformatted
  mypy: 5 errors (missing return type, incompatible assignment)
  pytest: 2 failures (test_create_subscription, test_tenant_isolation)

Fixing auto-fixable issues...
  → ruff check --fix resolved F401, I001
  → ruff format fixed 2 files
  → F841 (unused variable) requires manual fix in src/billing/services.py:42

Fixing type errors...
  → Added return type to create_subscription() in src/billing/services.py
  → Fixed QuerySet generic in src/tenants/managers.py
  → 3 remaining mypy errors resolved

Fixing test failures...
  → test_create_subscription: Stripe mock was missing \`latest_invoice\` field — updated mock fixture
  → test_tenant_isolation: Factory was not setting tenant — fixed TenantFactory

Iteration 2/10 — Verifying...
  ruff check: ✅ passed
  ruff format: ✅ passed
  mypy: ✅ passed
  pytest: ✅ 247 passed, 0 failed, coverage 87%

All checks passed. Summary:
  - Fixed 3 lint issues (1 manual, 2 auto-fixed)
  - Formatted 2 files
  - Added type annotations to 2 functions in billing/services.py (⚠️ sensitive path)
  - Updated Stripe mock fixture in tests/billing/test_subscriptions.py
  - Fixed TenantFactory in tests/factories.py
\`\`\``,

  'plugin/codeforge-django-saas/skills/code-review/SKILL.md': `---
skill: code-review
version: 1.0.0
description: Perform thorough code reviews on Django SaaS pull requests with focus on security, multi-tenancy, billing correctness, and Django best practices
triggers:
  - review this PR
  - code review
  - review my changes
  - check this code
  - review for merge
inputs:
  - name: pr_number
    description: GitHub PR number to review (optional — will detect from current branch)
    required: false
  - name: focus_area
    description: Specific focus area (security, performance, tenancy, billing, general)
    required: false
    default: general
  - name: severity_threshold
    description: Minimum severity to report (info, warning, error, critical)
    required: false
    default: warning
tools:
  - github
  - filesystem
  - terminal
tags:
  - review
  - quality
  - security
  - django
  - saas
---

# Code Review Skill — Django SaaS Platform

You are an expert code reviewer for a multi-tenant Django SaaS platform. You review pull requests with deep knowledge of Django 5.0, DRF, Strawberry GraphQL, Celery, Stripe billing, PostgreSQL row-level security, and SOC 2 / GDPR compliance requirements.

## Review Philosophy

Reviews should be constructive, specific, and actionable. Every comment must include a severity level and, for non-trivial issues, a suggested fix. Prioritize issues that could cause data leaks between tenants, billing errors, or security vulnerabilities. Acknowledge good patterns when you see them.

## Step 1: Gather Context

Before reviewing code, understand what the PR is about.

### 1a. Identify the PR

If a PR number was provided, fetch it. Otherwise, detect from the current branch:

\`\`\`
git branch --show-current
\`\`\`

Use the GitHub MCP tool to fetch the PR details:
- Title, description, and linked issues
- Files changed (diff)
- PR author and any existing review comments
- CI status

### 1b. Classify the Change

Determine the change type and risk level:

| Change Type | Risk | Extra Scrutiny |
|---|---|---|
| \`src/billing/\` | **Critical** | Stripe integration, subscription state, webhook idempotency, financial accuracy |
| \`src/accounts/\` or \`src/core/auth*\` | **Critical** | Authentication, authorization, session handling, password management |
| \`src/tenants/\` | **Critical** | Tenant isolation, row-level security, cross-tenant data access |
| \`config/production/\` or \`.env*\` | **Critical** | Secrets exposure, configuration correctness |
| \`src/api/\` | **High** | Input validation, serializer correctness, permission classes, rate limiting |
| \`src/tasks/\` | **High** | Idempotency, retry behavior, failure handling, dead letter queues |
| \`src/notifications/\` | **Medium** | PII in logs/emails, webhook payload security |
| \`tests/\` | **Medium** | Test quality, coverage, fixture correctness |
| \`docs/\`, \`scripts/\` | **Low** | Accuracy, completeness |
| Migrations | **High** | Data integrity, reversibility, zero-downtime compatibility |

### 1c. Check PR Hygiene

Verify before diving into code:

- [ ] PR title follows conventional commit format (\`feat:\`, \`fix:\`, \`chore:\`, \`docs:\`)
- [ ] PR description explains the **what** and **why**
- [ ] Linked to a GitHub Issue (e.g., \`Closes #42\` or \`SAAS-42\`)
- [ ] Branch name follows \`type/ticket-desc\` pattern
- [ ] No unrelated changes bundled in
- [ ] PR is a reasonable size (flag if >500 lines changed, suggest splitting if >800)

## Step 2: Automated Checks Verification

Confirm CI pipeline results before manual review:

\`\`\`
# Check if local linting passes on changed files
git diff --name-only origin/main...HEAD -- '*.py' | xargs uv run ruff check
git diff --name-only origin/main...HEAD -- '*.py' | xargs uv run ruff format --check
\`\`\`

\`\`\`
# Type checking
uv run mypy src/ --no-error-summary 2>&1 | head -50
\`\`\`

\`\`\`
# Run tests related to changed files
uv run pytest tests/ -x --tb=short -q 2>&1 | tail -30
\`\`\`

If any automated checks fail, report them first — do not proceed with a full manual review until the author fixes lint/type/test failures.

## Step 3: Multi-Tenancy Review (ALWAYS CHECK)

This is the most critical review dimension. Every data access path must be tenant-scoped.

### 3a. Tenant Isolation Checklist

For every queryset, ORM call, or raw SQL in the diff:

- [ ] **Uses tenant-aware manager**: All model queries go through \`TenantAwareManager\` or explicitly filter by \`tenant_id\`
- [ ] **No \`.objects.all()\` on tenant models**: Must use \`.for_tenant(tenant)\` or equivalent
- [ ] **No raw SQL without tenant filter**: Any \`raw()\`, \`extra()\`, or \`RawSQL\` must include \`WHERE tenant_id = %s\`
- [ ] **Middleware sets tenant context**: Views that access tenant data must run after \`TenantMiddleware\`
- [ ] **Serializer doesn't leak cross-tenant data**: Nested serializers and related fields are tenant-scoped
- [ ] **Celery tasks receive tenant_id**: Background tasks must explicitly receive and set tenant context
- [ ] **Admin views are tenant-filtered**: Any custom admin views filter by tenant

### 3b. Dangerous Patterns to Flag

Flag these as **CRITICAL**:

\`\`\`python
# DANGEROUS: Unscoped query on tenant model
User.objects.filter(email=email)  # Missing tenant scope

# DANGEROUS: Celery task without tenant context
@shared_task
def process_report(report_id):
    report = Report.objects.get(id=report_id)  # No tenant verification

# DANGEROUS: Serializer exposes tenant_id choices
class ProjectSerializer(serializers.ModelSerializer):
    tenant = serializers.PrimaryKeyRelatedField(queryset=Tenant.objects.all())  # Leaks tenant IDs

# DANGEROUS: GraphQL resolver without tenant filtering
@strawberry.type
class Query:
    @strawberry.field
    def projects(self, info) -> list[ProjectType]:
        return Project.objects.all()  # Cross-tenant data leak
\`\`\`

## Step 4: Security Review

### 4a. Authentication & Authorization

- [ ] Views have explicit \`permission_classes\` (no relying on defaults for sensitive endpoints)
- [ ] GraphQL resolvers check permissions (Strawberry doesn't auto-apply DRF permissions)
- [ ] No hardcoded secrets, tokens, or API keys
- [ ] Sensitive fields excluded from serializer output (\`password\`, \`stripe_customer_id\`, internal IDs)
- [ ] Rate limiting applied to authentication endpoints
- [ ] RBAC roles checked correctly (tenant admin vs member vs viewer)

### 4b. Input Validation

- [ ] All user input validated through serializers or Pydantic models — never trust \`request.data\` directly
- [ ] File uploads validated (type, size, content)
- [ ] SQL injection prevention: no string formatting in queries
- [ ] XSS prevention: template output escaped, API responses don't reflect unsanitized input
- [ ] SSRF prevention: no user-controlled URLs used in server-side requests without allowlisting

### 4c. Data Privacy (GDPR / SOC 2)

- [ ] PII not logged (check \`logger.info/debug/error\` calls for email, name, IP, payment info)
- [ ] Audit log entries created for data access/modification on sensitive models
- [ ] Data deletion cascades correctly (right to deletion support)
- [ ] Consent tracked where required
- [ ] No PII in Celery task arguments (use IDs, look up in task)
- [ ] S3 uploads use appropriate bucket policies and encryption

## Step 5: Billing & Stripe Review

Only applies when \`src/billing/\` or Stripe-related code is changed.

### 5a. Stripe Integration

- [ ] Webhook handlers verify signature (\`stripe.Webhook.construct_event\`)
- [ ] Webhook handlers are idempotent (check for existing processed event ID)
- [ ] Subscription state transitions are valid (don't skip states)
- [ ] Usage metering records are created with idempotency keys
- [ ] Stripe API calls use the tenant's \`stripe_customer_id\`, not a global one
- [ ] Error handling for Stripe API failures (network errors, card declines, rate limits)
- [ ] No Stripe secret key in client-facing code or logs
- [ ] Monetary amounts use \`Decimal\`, never \`float\`

### 5b. Billing State Consistency

- [ ] Local subscription state stays in sync with Stripe (webhook is source of truth)
- [ ] Grace periods handled for failed payments
- [ ] Downgrade/upgrade proration calculated correctly
- [ ] Trial expiration handled
- [ ] Cancellation doesn't delete data immediately (soft delete, retention period)

## Step 6: Django & Python Quality

### 6a. Django Best Practices

- [ ] Models have \`__str__\` methods
- [ ] Models use \`Meta.ordering\` only when necessary (performance impact)
- [ ] \`select_related\` / \`prefetch_related\` used to avoid N+1 queries
- [ ] Database indexes defined for frequently queried fields
- [ ] Migrations are reversible (have \`RunPython\` reverse functions)
- [ ] Migrations are safe for zero-downtime deployment (no \`ALTER TABLE\` locks on large tables)
- [ ] Signals used sparingly — prefer explicit service layer calls
- [ ] Settings accessed via \`django.conf.settings\`, not direct import of settings module
- [ ] \`get_object_or_404\` or explicit error handling (no bare \`.get()\` in views)

### 6b. Python Quality

- [ ] Type hints on all public functions (required by project standard)
- [ ] Functions under 50 lines, files under 300 lines
- [ ] No mutable default arguments
- [ ] Context managers used for resource cleanup
- [ ] Exceptions are specific (no bare \`except:\` or \`except Exception:\` without re-raise)
- [ ] f-strings preferred over \`.format()\` or \`%\` formatting
- [ ] Constants in SCREAMING_SNAKE_CASE, defined at module level

### 6c. Celery Tasks

- [ ] Tasks are idempotent (safe to retry)
- [ ] Tasks have \`max_retries\`, \`retry_backoff\`, and \`retry_jitter\` configured
- [ ] Tasks have reasonable \`time_limit\` and \`soft_time_limit\`
- [ ] Tasks use \`bind=True\` when they need \`self.retry()\`
- [ ] Tasks log start, completion, and failure with correlation IDs
- [ ] Heavy tasks use \`acks_late=True\` for at-least-once delivery
- [ ] Tasks don't pass large objects — pass IDs and fetch from DB

## Step 7: API Review

### 7a. REST API (DRF)

- [ ] Endpoints documented with \`drf-spectacular\` decorators (\`@extend_schema\`)
- [ ] Pagination applied to list endpoints
- [ ] Filtering uses \`django-filter\`, not manual query param parsing
- [ ] HTTP status codes are correct (201 for creation, 204 for deletion, 409 for conflicts)
- [ ] Error responses follow consistent format
- [ ] Versioning considered for breaking changes

### 7b. GraphQL (Strawberry)

- [ ] Query complexity / depth limits configured
- [ ] Resolvers are efficient (use dataloaders for N+1 prevention)
- [ ] Mutations validate input before executing
- [ ] Permissions checked in resolvers (not just at schema level)
- [ ] Sensitive fields excluded from schema introspection in production

## Step 8: Test Quality

- [ ] New code has corresponding tests
- [ ] Tests use \`factory_boy\` factories, not raw \`Model.objects.create()\`
- [ ] Tests are isolated (no shared mutable state between tests)
- [ ] Stripe interactions mocked (no real API calls in unit tests)
- [ ] Integration tests use \`pytest.mark.django_db\` with \`transaction=True\` where needed
- [ ] Edge cases covered: empty inputs, boundary values, permission denied, tenant mismatch
- [ ] Celery tasks tested with \`CELERY_ALWAYS_EAGER=True\` or explicit \`.apply()\` calls
- [ ] Coverage for the changed files meets 85% threshold

\`\`\`
# Check coverage for changed files
uv run pytest tests/ --cov=src --cov-report=term-missing -q 2>&1 | tail -20
\`\`\`

## Step 9: Compose Review

Structure your review as follows:

### Review Summary Format

\`\`\`markdown
## Code Review: PR #<number> — <title>

**Reviewer**: Claude (AI-assisted review)
**Risk Level**: Critical / High / Medium / Low
**Recommendation**: Approve / Approve with Comments / Request Changes / Block

### Summary
<1-2 sentence summary of what this PR does and overall assessment>

### Critical Issues (must fix before merge)
- 🔴 **[CRITICAL]** <file>:<line> — <description>
  **Why**: <impact explanation>
  **Fix**: <suggested code or approach>

### Warnings (should fix)
- 🟡 **[WARNING]** <file>:<line> — <description>
  **Why**: <impact explanation>
  **Suggestion**: <recommended change>

### Suggestions (nice to have)
- 🔵 **[SUGGESTION]** <file>:<line> — <description>

### Positive Observations
- ✅ <thing done well>

### Checklist Results
- [ ] Tenant isolation verified
- [ ] Security review passed
- [ ] Billing correctness verified (if applicable)
- [ ] Tests adequate
- [ ] CI passing
- [ ] Documentation updated (if applicable)
\`\`\`

### Severity Definitions

| Severity | Meaning | Action |
|---|---|---|
| 🔴 CRITICAL | Data leak, security vulnerability, billing error, tenant isolation breach | **Block merge** |
| 🟡 WARNING | Bug risk, missing validation, performance issue, missing tests | **Request changes** |
| 🔵 SUGGESTION | Style improvement, refactoring opportunity, documentation gap | **Approve with comments** |
| ✅ POSITIVE | Good pattern, well-tested, clean implementation | **Acknowledge** |

## Step 10: Submit Review

If the GitHub MCP tool is available, post the review directly on the PR. Otherwise, output the review in the format above for the developer to read.

When posting via GitHub MCP:
- Use \`REQUEST_CHANGES\` for any critical or warning issues
- Use \`COMMENT\` for suggestion-only reviews
- Use \`APPROVE\` only when all checklist items pass
- Add inline comments on specific lines for critical and warning issues
- Add the summary as the top-level review body

## Focus Area Overrides

When a specific \`focus_area\` is provided, prioritize that dimension but still do a baseline check on all others:

- **security**: Deep dive on Steps 4 (Security) and 3 (Tenancy). Check OWASP Top 10 patterns.
- **performance**: Focus on N+1 queries, missing indexes, unoptimized Celery tasks, cache usage, large payload serialization.
- **tenancy**: Exhaustive Step 3. Trace every data access path to verify tenant scoping.
- **billing**: Deep dive on Step 5. Verify Stripe webhook flows, subscription state machines, monetary precision.
- **general**: Balanced review across all steps.

## Common Patterns to Watch For

### Anti-patterns (flag these)

\`\`\`python
# Anti-pattern: Service layer in view
class ProjectViewSet(viewsets.ModelViewSet):
    def create(self, request):
        # 50 lines of business logic here...  # Move to service layer
        
# Anti-pattern: Tenant context lost in Celery
@shared_task
def send_report(user_id):
    user = User.objects.get(id=user_id)  # No tenant verification
    
# Anti-pattern: Mutable queryset default
def get_projects(filters={}):  # Mutable default argument
    
# Anti-pattern: Bare exception in webhook handler
try:
    stripe.Webhook.construct_event(payload, sig, secret)
except Exception:  # Too broad — masks real errors
    pass
\`\`\`

### Good patterns (acknowledge these)

\`\`\`python
# Good: Explicit tenant scoping in service layer
class ProjectService:
    def __init__(self, tenant: Tenant) -> None:
        self.tenant = tenant
    
    def create_project(self, data: ProjectCreateDTO) -> Project:
        return Project.objects.create(tenant=self.tenant, **data.dict())

# Good: Idempotent webhook handler
@require_POST
def stripe_webhook(request: HttpRequest) -> HttpResponse:
    event = verify_stripe_signature(request)
    if StripeEvent.objects.filter(stripe_id=event.id).exists():
        return HttpResponse(status=200)  # Already processed
    
# Good: Celery task with proper configuration
@shared_task(bind=True, max_retries=3, retry_backoff=True, acks_late=True)
def sync_subscription(self, tenant_id: int, subscription_id: str) -> None:
    
# Good: Factory-based test
class TestProjectCreation:
    def test_create_project_for_tenant(self, tenant_factory, user_factory):
        tenant = tenant_factory()
        user = user_factory(tenant=tenant)
\`\`\``,

  'plugin/codeforge-django-saas/skills/phase/SKILL.md': `---
skill: phase
version: "1.0"
description: >
  Guides Claude through structured development workflow phases for the Django SaaS Platform.
  Each phase has clear entry criteria, activities, and exit criteria to ensure consistent,
  high-quality delivery across the team.
triggers:
  - "start phase"
  - "run phase"
  - "development workflow"
  - "next phase"
  - "phase:"
inputs:
  phase_name:
    type: string
    required: true
    description: "Phase to execute: discover, design, implement, test, review, deploy"
    enum: [discover, design, implement, test, review, deploy]
  ticket_id:
    type: string
    required: false
    description: "GitHub Issue ID (e.g., SAAS-42)"
  context:
    type: string
    required: false
    description: "Additional context about the work item"
tools:
  - mcp: github
  - mcp: slack
  - command: uv run pytest
  - command: uv run ruff check src/
  - command: uv run ruff format --check src/
  - command: uv run mypy src/
  - command: uv run python manage.py makemigrations --dry-run --check
  - command: uv run python manage.py migrate --plan
  - command: uv run drf-spectacular --validate
references:
  - docs/ARCHITECTURE.md
  - docs/CONTRIBUTING.md
  - docs/AI-USAGE-POLICY.md
  - docs/ONBOARDING.md
  - playbook/README.md
  - pyproject.toml
  - ruff.toml
---

# Skill: phase — Django SaaS Development Workflow

You are guiding a developer through a structured development phase for the **django-saas-platform** project. Follow the phase instructions precisely. Each phase builds on the previous one and produces specific artifacts.

## Phase Overview

The development workflow consists of six phases:

\`\`\`
discover → design → implement → test → review → deploy
\`\`\`

Always identify which phase is requested and execute only that phase. If no phase is specified, determine the appropriate phase from the current state of the work.

---

## Phase 1: DISCOVER

**Purpose**: Understand the problem, gather requirements, assess impact on multi-tenant architecture.

### Entry Criteria
- A GitHub Issue exists or a clear problem statement is provided
- The developer has access to relevant Django app code

### Activities

1. **Fetch the ticket** (if \`ticket_id\` provided):
   - Use GitHub MCP to read the issue details, labels, and linked issues
   - Identify acceptance criteria and any SaaS-specific requirements

2. **Analyze the problem domain**:
   - Determine which Django apps are affected (\`accounts\`, \`tenants\`, \`billing\`, \`api\`, \`core\`, \`notifications\`, \`tasks\`, \`utils\`)
   - Check if the change touches sensitive paths: \`**/billing/**\`, \`**/auth/**\`, \`config/production/**\`
   - Identify tenant isolation implications — does this change affect row-level security or tenant-aware querysets?
   - Check for Stripe billing impact — subscription lifecycle, webhook handling, usage metering
   - Assess GDPR/SOC 2 compliance implications

3. **Map dependencies**:
   - List affected models, serializers, views, Celery tasks, and GraphQL types
   - Identify cross-app dependencies and service layer calls
   - Check for existing Django signals that might be triggered
   - Review Celery task chains that could be affected

4. **Assess risk**:
   - Data migration required? (PostgreSQL schema changes, RLS policy updates)
   - Breaking API changes? (DRF serializers, GraphQL schema)
   - Billing flow changes? (Stripe webhook handlers, subscription state machine)
   - Multi-tenant data leak risk?

### Exit Criteria
- Problem is clearly understood and documented
- Affected Django apps and files are identified
- Risk assessment is complete
- A brief discovery summary is produced

### Output Format
\`\`\`markdown
## Discovery Summary — [ticket_id]

### Problem Statement
[Clear description of what needs to be done]

### Affected Apps
- [ ] accounts — [reason]
- [ ] tenants — [reason]
- [ ] billing — [reason]
- [ ] api — [reason]
- [ ] core — [reason]
- [ ] notifications — [reason]
- [ ] tasks — [reason]

### Tenant Isolation Impact
[How this affects multi-tenant data access, RLS policies, tenant-aware managers]

### Billing Impact
[Stripe subscription/webhook/metering changes, if any]

### Compliance Notes
[GDPR or SOC 2 considerations]

### Risk Assessment
- Data migration: [yes/no — details]
- Breaking API changes: [yes/no — details]
- Billing flow changes: [yes/no — details]
- Tenant data leak risk: [low/medium/high — mitigation]

### Key Files to Modify
- \`src/[app]/models.py\` — [reason]
- \`src/[app]/services.py\` — [reason]
- \`src/[app]/serializers.py\` — [reason]
- \`tests/[app]/test_[feature].py\` — [reason]
\`\`\`

---

## Phase 2: DESIGN

**Purpose**: Define the technical approach, API contracts, data models, and task definitions before writing code.

### Entry Criteria
- Discovery phase is complete
- Problem domain and affected apps are understood

### Activities

1. **Design the data model changes**:
   - Define new or modified Django models with field types and constraints
   - Ensure all tenant-scoped models inherit from \`core.models.TenantAwareModel\`
   - Plan PostgreSQL migrations — consider RLS policy updates
   - Design indexes for common query patterns (tenant_id + status, etc.)

2. **Design the service layer**:
   - Define service functions with type signatures (Python 3.12+ type hints)
   - Prefer explicit service calls over Django signals
   - Ensure all tenant data access goes through \`TenantAwareManager\`
   - Plan for idempotency in any state-changing operations

3. **Design the API contract**:
   - DRF: Define serializer fields, viewset actions, URL patterns (kebab-case)
   - GraphQL: Define Strawberry types, queries, mutations
   - Ensure all endpoints will have drf-spectacular OpenAPI schema
   - Plan pagination, filtering, and permission classes

4. **Design Celery tasks** (if needed):
   - Define task signatures with explicit parameters (no complex objects)
   - Ensure idempotency — tasks must be safe to retry
   - Plan retry policies, rate limits, and dead letter handling
   - Consider task chains and chord patterns for complex workflows

5. **Design Stripe integration** (if billing is affected):
   - Map subscription state transitions
   - Define webhook event handlers with idempotency keys
   - Plan usage metering record format
   - Consider Stripe test mode fixtures

6. **Plan the file structure**:
   - Ensure each file stays under 300 lines
   - Split large features across service, selector, and task modules
   - Follow the modular monolith pattern — keep app boundaries clean

### Exit Criteria
- Technical design is documented
- API contracts are defined with type signatures
- Data model changes are specified
- Celery task contracts are defined (if applicable)
- File-level implementation plan exists

### Output Format
\`\`\`markdown
## Technical Design — [ticket_id]

### Data Model Changes
[Model definitions with fields, constraints, indexes]

### Service Layer
[Function signatures with type hints and docstrings]

### API Contract
[Endpoint definitions: method, URL, request/response schema]

### Celery Tasks
[Task signatures, retry policy, idempotency strategy]

### Stripe Integration
[Webhook handlers, subscription state changes, metering]

### Migration Plan
[SQL migration steps, RLS policy updates, data backfill]

### Implementation Order
1. [file] — [what to implement]
2. [file] — [what to implement]
...
\`\`\`

---

## Phase 3: IMPLEMENT

**Purpose**: Write production code following the technical design, project conventions, and quality standards.

### Entry Criteria
- Technical design is complete and reviewed
- Branch is created following naming convention: \`type/TICKET-desc\`

### Activities

1. **Create the branch**:
   \`\`\`
   git checkout -b feat/SAAS-{ticket_id}-{description}
   \`\`\`

2. **Implement in order** (from the design phase):
   - Models first → migrations → services → serializers/types → views → tasks → tests
   - Follow conventional commits: \`feat:\`, \`fix:\`, \`chore:\`, \`docs:\`

3. **Coding standards** (enforced):
   - Type hints on ALL public functions (mypy strict mode)
   - snake_case for files and functions, PascalCase for classes, SCREAMING_SNAKE_CASE for constants
   - kebab-case for URL patterns
   - Max 300 lines per file — split into modules if needed
   - Use \`from __future__ import annotations\` in all files

4. **Multi-tenancy rules**:
   - All tenant-scoped models MUST use \`TenantAwareManager\` as default manager
   - Never use \`.objects.all()\` on tenant models — always filter by tenant
   - Verify RLS policies cover new tables
   - Test with multiple tenants to confirm isolation

5. **Billing rules** (if touching \`src/billing/\`):
   - All Stripe API calls must be wrapped in try/except with proper error handling
   - Webhook handlers must check idempotency (store processed event IDs)
   - Never store raw credit card data — use Stripe tokens/payment methods
   - Log all billing state transitions to audit log

6. **Celery task rules** (if touching \`src/tasks/\`):
   - Tasks must be idempotent — safe to run multiple times with same args
   - Use \`bind=True\` for tasks that need \`self.retry()\`
   - Set \`max_retries\`, \`default_retry_delay\`, and \`acks_late=True\`
   - Pass only serializable primitive arguments (IDs, not objects)

7. **AI code marking** (per AI-USAGE-POLICY.md):
   - Add \`# AI-GENERATED\` comment to AI-generated functions
   - Include \`AI-Assisted: yes\` in commit trailers

8. **Validate continuously**:
   \`\`\`bash
   uv run ruff check src/
   uv run ruff format --check src/
   uv run mypy src/
   uv run python manage.py makemigrations --dry-run --check
   \`\`\`

### Exit Criteria
- All code follows project conventions
- Linting passes (\`ruff check\`)
- Formatting passes (\`ruff format --check\`)
- Type checking passes (\`mypy src/\`)
- Migrations are valid
- No hardcoded secrets or tenant data leaks

---

## Phase 4: TEST

**Purpose**: Write and run comprehensive tests to validate correctness, tenant isolation, and billing integrity.

### Entry Criteria
- Implementation is complete
- Code passes linting, formatting, and type checks

### Activities

1. **Write unit tests** (pytest + factory_boy):
   - Use \`factory_boy\` for all test fixtures — no raw \`Model.objects.create()\`
   - Test service layer functions in isolation
   - Mock external services (Stripe, SES, Redis) with \`unittest.mock\` or \`pytest-mock\`
   - Test tenant isolation: verify Tenant A cannot access Tenant B data
   - Test permission classes: verify RBAC enforcement

2. **Write integration tests**:
   - Test DRF viewsets with \`APIClient\` — full request/response cycle
   - Test GraphQL queries/mutations with Strawberry test client
   - Test Celery tasks with \`CELERY_ALWAYS_EAGER=True\`
   - Test Stripe webhook handlers with fixture payloads from Stripe CLI

3. **Write billing-specific tests** (if applicable):
   - Test subscription creation, upgrade, downgrade, cancellation
   - Test webhook idempotency — send same event twice, verify single processing
   - Test usage metering aggregation
   - Test invoice generation and payment failure handling

4. **Test multi-tenancy**:
   - Create fixtures for at least 2 tenants
   - Verify queryset filtering returns only current tenant's data
   - Test tenant middleware sets correct tenant context
   - Verify RLS policies at the database level (if using raw SQL tests)

5. **Run the full test suite**:
   \`\`\`bash
   uv run pytest tests/ -v --cov=src --cov-report=term-missing --cov-fail-under=85
   \`\`\`

6. **Validate API schema**:
   \`\`\`bash
   uv run python manage.py spectacular --validate --fail-on-warn
   \`\`\`

### Exit Criteria
- All tests pass
- Coverage ≥ 85% on changed code
- Tenant isolation is verified
- Billing flows are tested (if applicable)
- API schema validates without warnings
- No flaky tests

### Output Format
\`\`\`
Test Results:
- Total: [N] tests
- Passed: [N]
- Failed: [N]
- Coverage: [N]%
- Tenant isolation: ✅ verified
- Billing tests: ✅ passed (or N/A)
- API schema: ✅ valid
\`\`\`

---

## Phase 5: REVIEW

**Purpose**: Prepare the PR, run final checks, and ensure the change is ready for human review.

### Entry Criteria
- All tests pass with ≥ 85% coverage
- Code passes all linting and type checks

### Activities

1. **Run the complete CI check locally**:
   \`\`\`bash
   uv run ruff check src/ tests/
   uv run ruff format --check src/ tests/
   uv run mypy src/
   uv run pytest tests/ -v --cov=src --cov-fail-under=85
   uv run python manage.py makemigrations --dry-run --check
   \`\`\`

2. **Self-review checklist**:
   - [ ] No files exceed 300 lines
   - [ ] All public functions have type hints
   - [ ] All API endpoints have OpenAPI schema decorators
   - [ ] Tenant-aware managers used for all tenant-scoped queries
   - [ ] Celery tasks are idempotent with retry policies
   - [ ] Stripe webhook handlers verify signatures and check idempotency
   - [ ] No hardcoded secrets, API keys, or tenant identifiers
   - [ ] GDPR: personal data handling follows consent and deletion policies
   - [ ] SOC 2: audit logging for sensitive operations
   - [ ] AI-generated code is marked with \`# AI-GENERATED\`
   - [ ] Conventional commits used throughout
   - [ ] Django signals avoided (explicit service calls preferred)
   - [ ] Database migrations are reversible

3. **Create the Pull Request**:
   - Use the PR template from \`.github/PULL_REQUEST_TEMPLATE.md\`
   - Link the GitHub Issue
   - Fill in all sections: description, changes, testing, tenant impact, billing impact
   - Add appropriate labels and request reviewers per CODEOWNERS
   - Mark sensitive path changes for security review

4. **Notify the team** (if Slack MCP available):
   - Post PR link to the appropriate channel
   - Tag reviewers if the change is urgent or touches billing/auth

### Exit Criteria
- PR is created with complete description
- All CI checks pass
- Reviewers are assigned
- CODEOWNERS rules are satisfied for sensitive paths

---

## Phase 6: DEPLOY

**Purpose**: Guide the deployment process from staging validation to production release.

### Entry Criteria
- PR is approved with at least 1 approval
- All CI checks pass
- No unresolved review comments

### Activities

1. **Merge to main**:
   - Squash merge preferred for clean history
   - Ensure commit message follows conventional commits format
   - Verify the merge doesn't conflict with recent main changes

2. **Staging deployment** (auto-deployed):
   - Monitor GitHub Actions \`deploy-staging.yml\` workflow
   - Verify database migrations run successfully
   - Check Celery workers pick up new task definitions
   - Validate Stripe webhook endpoints in test mode

3. **Staging validation**:
   \`\`\`
   - [ ] API endpoints respond correctly (DRF + GraphQL)
   - [ ] Tenant isolation verified in staging environment
   - [ ] Billing flows work in Stripe test mode
   - [ ] Celery tasks execute and complete
   - [ ] No errors in Sentry
   - [ ] Prometheus metrics look normal
   - [ ] E2E tests pass against staging
   \`\`\`

4. **Production deployment**:
   - Trigger \`deploy-production.yml\` workflow (manual approval required)
   - Monitor deployment progress in AWS ECS
   - Verify RDS migrations complete without downtime
   - Check ElastiCache (Redis) connectivity for Celery and caching
   - Validate Stripe live mode webhook delivery

5. **Post-deployment verification**:
   - [ ] Health check endpoints return 200
   - [ ] Key API endpoints respond within SLA
   - [ ] Sentry error rate is stable
   - [ ] Grafana dashboards show normal metrics
   - [ ] Stripe webhooks are being received and processed
   - [ ] Celery beat scheduler is running periodic tasks

6. **Rollback plan** (if issues detected):
   - Revert the merge commit on main
   - Trigger redeployment to roll back ECS tasks
   - Run reverse migration if database changes were made
   - Notify team via Slack with incident details

### Exit Criteria
- Production deployment is successful
- All post-deployment checks pass
- GitHub Issue is closed
- Any follow-up tasks are created as new issues

---

## Phase Selection Logic

When the developer doesn't specify a phase, determine the correct phase:

| Current State | Recommended Phase |
|---|---|
| New ticket, no analysis done | **discover** |
| Problem understood, no design | **design** |
| Design complete, no code written | **implement** |
| Code written, tests incomplete | **test** |
| Tests passing, no PR created | **review** |
| PR approved, not deployed | **deploy** |

## Cross-Skill Integration

- After **discover**, suggest running \`plan\` skill for detailed task breakdown
- During **implement**, suggest \`tdd\` skill for test-first development
- Before **review**, suggest \`verify\` skill for automated quality checks
- If CI fails, suggest \`build-fix\` skill to diagnose and resolve
- During **review**, suggest \`code-review\` skill for automated review

## Sensitive Path Handling

When any phase touches these paths, add extra scrutiny:

- \`**/billing/**\` → Verify Stripe integration, idempotency, PCI compliance
- \`**/auth/**\` → Verify authentication flows, token handling, session security
- \`config/production/**\` → Verify no secrets committed, environment variable usage
- \`.env*\` → NEVER commit, verify \`.gitignore\` coverage
- \`**/tenants/**\` → Verify RLS policies, tenant isolation, data leak prevention`,

  'plugin/codeforge-django-saas/skills/plan/SKILL.md': `---
skill: plan
version: "1.0"
description: >
  Plan implementation for a Django SaaS feature by analyzing requirements,
  identifying affected apps and modules, mapping tenant isolation concerns,
  and producing a structured implementation plan with tasks and test strategy.
triggers:
  - plan
  - design
  - architect
  - breakdown
inputs:
  - name: ticket
    description: GitHub Issue number or URL for the feature/bug
    required: true
  - name: scope
    description: "Scope hint: small | medium | large | epic"
    required: false
    default: medium
outputs:
  - implementation_plan.md written to the working directory
  - GitHub Issue updated with plan summary (if MCP available)
tags:
  - planning
  - architecture
  - django
  - saas
---

# Skill: plan

Create a structured implementation plan for a Django SaaS platform feature or bug fix. The plan accounts for multi-tenancy, billing implications, API surface changes, async task requirements, and test coverage.

## When to Use

- Before starting any \`medium\` or \`large\` feature
- When a ticket touches multiple Django apps (e.g., billing + tenants + notifications)
- When changes affect tenant data isolation or Stripe integration
- When introducing new Celery tasks or modifying webhook handlers
- During sprint planning to break epics into implementable chunks

## Workflow

### Step 1: Gather Context

Fetch the ticket details and understand the requirement:

\`\`\`
Use the GitHub MCP server to read the issue specified by the ticket input.
If no MCP is available, ask the developer to paste the ticket description.
\`\`\`

Identify:
- **What** the feature or fix does (user-facing behavior)
- **Why** it's needed (business context, customer request, compliance)
- **Who** is affected (tenants, admins, billing, end-users)
- **Constraints** (GDPR, SOC 2, backward compatibility, migration safety)

### Step 2: Analyze Affected Django Apps

Map the change to the project's modular monolith structure. For each affected app, note what changes:

| App | What Changes |
|-----|-------------|
| \`src/accounts/\` | User model fields, authentication flows, RBAC permissions |
| \`src/tenants/\` | Tenant model, middleware, row-level security policies |
| \`src/billing/\` | Stripe subscription logic, usage metering, webhook handlers |
| \`src/api/\` | DRF serializers/viewsets, Strawberry GraphQL types/resolvers |
| \`src/core/\` | Base models, tenant-aware managers, shared middleware |
| \`src/notifications/\` | Email templates, in-app notifications, webhook dispatch |
| \`src/tasks/\` | Celery task definitions, beat schedule entries |
| \`src/utils/\` | Shared utilities, decorators, logging helpers |
| \`config/\` | Django settings, URL routing, environment variables |
| \`templates/\` | Admin templates, email templates |

### Step 3: Evaluate Cross-Cutting Concerns

For every plan, explicitly address each of these:

**Multi-Tenancy Isolation**
- Does this feature read or write tenant-scoped data?
- Are all QuerySets going through the tenant-aware manager (\`TenantManager\`)?
- Do new database tables need row-level security policies in PostgreSQL?
- Could a bug here leak data between tenants?

**Billing & Subscription Impact**
- Does this feature depend on a subscription tier or feature flag?
- Are there usage-based metering events to track?
- Do Stripe webhook handlers need updating?
- Is the change backward-compatible with existing subscriptions?

**API Surface**
- Are new DRF endpoints needed? Update \`drf-spectacular\` schema annotations.
- Are new GraphQL types/mutations needed in Strawberry?
- Do existing API contracts change (breaking vs. non-breaking)?
- Is API versioning required?

**Async Processing**
- Are new Celery tasks needed? They MUST be idempotent.
- Do existing tasks need modification?
- Are there new beat schedule entries for periodic tasks?
- What happens if a task fails or is retried?

**Data Privacy & Compliance**
- Does this touch personal data (GDPR: consent, right to deletion, data residency)?
- Are there audit log entries to add?
- Does this affect SOC 2 controls (access logging, change management)?

**Security**
- Are there new permission checks needed (RBAC)?
- Does this touch sensitive paths (\`billing/\`, \`auth/\`, \`config/production/\`)?
- Are there new inputs to validate or sanitize?

### Step 4: Produce the Implementation Plan

Write a structured plan as \`implementation_plan.md\` with the following sections:

\`\`\`markdown
# Implementation Plan: [Feature Title]

**Ticket**: [GitHub Issue link]
**Scope**: [small | medium | large]
**Estimated Effort**: [story points or time range]
**Author**: [developer or "Claude (AI-assisted)"]
**Date**: [ISO date]

## Summary

[2-3 sentence description of what will be built and why]

## Affected Apps

- [ ] \`src/app_name/\` — brief description of changes

## Database Changes

- [ ] New models or model field additions (list them)
- [ ] Migration strategy (additive-only preferred, data migration if needed)
- [ ] Row-level security policy updates for new tables
- [ ] Index additions for query performance

## API Changes

- [ ] New/modified DRF endpoints with HTTP methods and paths
- [ ] New/modified GraphQL types, queries, or mutations
- [ ] OpenAPI schema updates via drf-spectacular
- [ ] Breaking changes (if any) and deprecation plan

## Billing Changes

- [ ] Stripe objects affected (subscriptions, prices, usage records)
- [ ] Webhook events to handle (list event types)
- [ ] Idempotency keys and deduplication strategy
- [ ] Feature flag or tier gating

## Async Tasks

- [ ] New Celery tasks (with idempotency strategy)
- [ ] Beat schedule changes
- [ ] Retry policy and dead-letter handling
- [ ] Task monitoring and alerting

## Implementation Tasks

Break into ordered, reviewable chunks. Each task should be a single PR:

### Task 1: [Title]
- **Branch**: \`feat/SAAS-XX-description\`
- **Apps**: \`src/app1/\`, \`src/app2/\`
- **Changes**: Bullet list of specific file changes
- **Tests**: What test cases to add
- **Reviewer Notes**: What to pay attention to in review

### Task 2: [Title]
...

## Test Strategy

- **Unit Tests**: List key test cases per app (use factory_boy fixtures)
- **Integration Tests**: API endpoint tests, Celery task tests with mocked Stripe
- **Tenant Isolation Tests**: Verify data cannot leak between tenants
- **Billing Tests**: Mock Stripe API calls, test webhook idempotency
- **Coverage Target**: 85% minimum for new code

## Security & Compliance Checklist

- [ ] Tenant data isolation verified (no cross-tenant data access)
- [ ] RBAC permissions enforced on new endpoints
- [ ] Audit log entries added for state changes
- [ ] GDPR: personal data handling documented
- [ ] SOC 2: access controls and logging in place
- [ ] Input validation on all new API fields
- [ ] Stripe webhook signature verification maintained

## Rollback Plan

- [ ] Database migrations are reversible (or rollback SQL provided)
- [ ] Feature flag to disable without deploy
- [ ] Stripe changes are backward-compatible

## Open Questions

- [ ] List any unresolved decisions or questions for the team
\`\`\`

### Step 5: Update the Ticket

If the GitHub MCP server is available:

1. Post the plan summary as a comment on the GitHub Issue
2. Add labels based on affected apps (e.g., \`billing\`, \`tenants\`, \`api\`)
3. Add the \`planned\` label to indicate planning is complete
4. If the scope is \`large\` or \`epic\`, create sub-issues for each implementation task

### Step 6: Validate the Plan

Before finalizing, run these checks:

- [ ] Every new model uses the tenant-aware base model from \`src/core/\`
- [ ] Every new API endpoint has permission classes and schema decorators
- [ ] Every Celery task has \`acks_late=True\`, \`max_retries\`, and idempotency logic
- [ ] Every Stripe webhook handler checks for duplicate event processing
- [ ] Test cases cover the happy path, error cases, and tenant isolation
- [ ] File changes respect the 300-line max file length convention
- [ ] No Django signals introduced where a service layer call would suffice
- [ ] Branch names follow \`type/SAAS-XX-description\` convention
- [ ] Commits will follow conventional commit format

## Scope Guidelines

| Scope | Typical Shape | Tasks | PRs |
|-------|--------------|-------|-----|
| \`small\` | Single app, no migrations, no billing | 1-2 | 1 |
| \`medium\` | 2-3 apps, additive migration, API changes | 3-5 | 2-3 |
| \`large\` | 3+ apps, billing changes, new Celery tasks | 5-8 | 3-5 |
| \`epic\` | Cross-cutting, schema changes, Stripe product changes | 8+ | 5+ |

## Example Usage

\`\`\`
> /plan ticket:42 scope:medium

Fetching GitHub Issue #42...
Analyzing: "Add usage-based metering for API calls per tenant"

Affected apps: src/billing/, src/tenants/, src/api/, src/tasks/
Cross-cutting: tenant isolation, Stripe usage records, Celery periodic task

Writing implementation_plan.md...
Updating GitHub Issue #42 with plan summary...
Done. Review the plan and adjust before starting implementation.
\`\`\`

## Related Skills

- **\`code\`** — Use after planning to implement individual tasks from the plan
- **\`test\`** — Use to generate test cases from the test strategy section
- **\`review\`** — Use to review PRs against the plan's security and compliance checklist

## References

- Project architecture: \`docs/ARCHITECTURE.md\`
- Contributing guide: \`docs/CONTRIBUTING.md\`
- AI usage policy: \`docs/AI-USAGE-POLICY.md\`
- Testing standards: \`.claude/rules/python/testing.md\``,

  'plugin/codeforge-django-saas/skills/tdd/SKILL.md': `---
skill: tdd
name: Test-Driven Development for Django SaaS
description: >
  Red-Green-Refactor workflow for the django-saas-platform. Write failing tests first,
  implement the minimum code to pass, then refactor. Covers Django models, DRF serializers,
  API views, Celery tasks, Stripe webhook handlers, and tenant-isolated queries.
version: 1.0.0
tags:
  - testing
  - tdd
  - django
  - saas
  - pytest
triggers:
  - implement a feature
  - fix a bug
  - add an endpoint
  - create a model
  - write a celery task
  - handle a webhook
tools_required:
  - pytest
  - factory_boy
  - pytest-django
  - pytest-cov
  - pytest-asyncio
  - mypy
  - ruff
context_files:
  - pyproject.toml
  - ruff.toml
  - config/settings/base.py
  - src/core/models.py
  - src/core/managers.py
  - tests/conftest.py
  - .claude/rules/python/testing.md
---

# TDD Skill — Django SaaS Platform

## Philosophy

Every production code change starts with a failing test. This is non-negotiable for billing logic, tenant isolation, authentication, and webhook handlers. The cost of a bug in multi-tenant SaaS (data leakage, billing errors) far exceeds the cost of writing tests first.

## Workflow: Red → Green → Refactor

### Step 1: RED — Write a Failing Test

Before writing any implementation code, create a test that describes the desired behavior.

**Determine the test location:**
- Source file: \`src/<app>/<module>.py\` → Test file: \`tests/<app>/test_<module>.py\`
- Example: \`src/billing/services.py\` → \`tests/billing/test_services.py\`

**Choose the right test type:**

| What you're building | Test type | Fixtures | Key assertions |
|---|---|---|---|
| Model / Manager | Unit | \`factory_boy\` factories | Field values, constraints, tenant filtering |
| Service layer function | Unit | Factories + mocks for external calls | Return values, side effects, exceptions |
| DRF Serializer | Unit | Raw dicts + model instances | Validation errors, serialized output |
| DRF ViewSet / APIView | Integration | \`APIClient\` + factories | Status codes, response body, permissions |
| Strawberry GraphQL | Integration | \`strawberry.test.client\` + factories | Query results, mutation effects |
| Celery task | Unit | Factories + \`@override_settings\` | Idempotency, retry behavior, side effects |
| Stripe webhook handler | Integration | Stripe event fixtures + mocks | Idempotency key check, state transitions |
| Middleware / Permissions | Unit | \`RequestFactory\` + factories | Allow/deny, tenant context set |

**Write the test following these conventions:**

\`\`\`python
# tests/billing/test_services.py
import pytest
from unittest.mock import patch, MagicMock
from django.test import override_settings

from tests.factories.billing import SubscriptionFactory, TenantFactory


class TestCreateSubscription:
    """Tests for billing.services.create_subscription."""

    def test_creates_stripe_subscription_for_tenant(
        self, db, tenant_context
    ) -> None:
        """A new subscription is created in Stripe and persisted locally."""
        tenant = TenantFactory()
        # Arrange: set up preconditions
        # Act: call the function under test
        # Assert: verify the outcome
        # This test MUST fail because create_subscription doesn't exist yet
        from src.billing.services import create_subscription

        result = create_subscription(
            tenant=tenant,
            price_id="price_test_monthly",
        )

        assert result.stripe_subscription_id is not None
        assert result.tenant_id == tenant.id
        assert result.status == "active"

    def test_raises_on_duplicate_active_subscription(
        self, db, tenant_context
    ) -> None:
        """Cannot create a second active subscription for the same tenant."""
        tenant = TenantFactory()
        SubscriptionFactory(tenant=tenant, status="active")

        from src.billing.services import create_subscription

        with pytest.raises(ValueError, match="already has an active"):
            create_subscription(
                tenant=tenant,
                price_id="price_test_monthly",
            )
\`\`\`

**Test naming rules:**
- Class: \`Test<FunctionOrFeatureName>\` in PascalCase
- Method: \`test_<expected_behavior>\` or \`test_<scenario>_<expected_outcome>\` in snake_case
- Every test method MUST have a docstring explaining the business rule

**Run the test — confirm it fails:**

\`\`\`bash
uv run pytest tests/billing/test_services.py::TestCreateSubscription -x -v
\`\`\`

You MUST see a failure (ImportError, AttributeError, or AssertionError). If the test passes, you either wrote a trivial test or the feature already exists — reassess.

### Step 2: GREEN — Write Minimum Implementation

Write the smallest amount of code that makes the failing test pass. Do not add extra logic, optimizations, or edge case handling that isn't covered by a test.

**Implementation rules:**
1. Create the module/function/class referenced in the test
2. Add type hints to all public functions (mypy strict mode)
3. Use the tenant-aware manager for all querysets (\`objects.for_tenant(tenant)\`)
4. External API calls (Stripe, email) must be behind service functions, never in models or views
5. Keep the file under 300 lines — split into smaller modules if needed

\`\`\`python
# src/billing/services.py
"""Billing service layer — orchestrates Stripe operations and local persistence."""

from __future__ import annotations

import stripe
from django.db import transaction

from src.billing.models import Subscription
from src.tenants.models import Tenant


def create_subscription(
    *,
    tenant: Tenant,
    price_id: str,
) -> Subscription:
    """Create a Stripe subscription for a tenant.

    Args:
        tenant: The tenant to subscribe.
        price_id: The Stripe price ID for the plan.

    Returns:
        The persisted Subscription instance.

    Raises:
        ValueError: If the tenant already has an active subscription.
    """
    if Subscription.objects.for_tenant(tenant).filter(status="active").exists():
        raise ValueError(f"Tenant {tenant.slug} already has an active subscription")

    stripe_sub = stripe.Subscription.create(
        customer=tenant.stripe_customer_id,
        items=[{"price": price_id}],
        metadata={"tenant_id": str(tenant.id)},
    )

    with transaction.atomic():
        return Subscription.objects.create(
            tenant=tenant,
            stripe_subscription_id=stripe_sub.id,
            stripe_price_id=price_id,
            status=stripe_sub.status,
        )
\`\`\`

**Run the test — confirm it passes:**

\`\`\`bash
uv run pytest tests/billing/test_services.py::TestCreateSubscription -x -v
\`\`\`

**Run the full quality gate before moving on:**

\`\`\`bash
uv run ruff check src/billing/services.py
uv run ruff format --check src/billing/services.py
uv run mypy src/billing/services.py
\`\`\`

### Step 3: REFACTOR — Improve Without Changing Behavior

With passing tests as your safety net, improve the code:

- Extract constants (plan names, status strings) into enums or module-level constants
- Reduce duplication between similar service functions
- Improve error messages and logging
- Add \`__all__\` exports to modules
- Ensure docstrings are complete

**After every refactor, re-run the tests:**

\`\`\`bash
uv run pytest tests/billing/ -x -v --tb=short
\`\`\`

If any test fails after refactoring, you changed behavior — revert and try again.

## Tenant Isolation Testing Pattern

Every test that touches the database MUST verify tenant isolation. Use the \`tenant_context\` fixture to set the current tenant, then assert that queries never leak data across tenants.

\`\`\`python
# tests/conftest.py provides these fixtures:

@pytest.fixture
def tenant_context(db):
    """Provides a tenant and sets it as the current tenant in middleware context."""
    from src.tenants.models import Tenant
    from src.tenants.context import set_current_tenant
    tenant = TenantFactory()
    set_current_tenant(tenant)
    yield tenant
    set_current_tenant(None)

@pytest.fixture
def other_tenant(db):
    """A second tenant for cross-tenant isolation tests."""
    return TenantFactory()
\`\`\`

\`\`\`python
class TestSubscriptionQueryset:
    def test_for_tenant_excludes_other_tenants(
        self, db, tenant_context, other_tenant
    ) -> None:
        """Tenant-scoped queries must never return another tenant's data."""
        SubscriptionFactory(tenant=tenant_context)
        SubscriptionFactory(tenant=other_tenant)

        results = Subscription.objects.for_tenant(tenant_context).all()

        assert results.count() == 1
        assert all(s.tenant_id == tenant_context.id for s in results)
\`\`\`

## Celery Task Testing Pattern

Celery tasks must be tested synchronously with \`CELERY_ALWAYS_EAGER=True\` and must verify idempotency.

\`\`\`python
from django.test import override_settings


@override_settings(CELERY_TASK_ALWAYS_EAGER=True)
class TestSyncSubscriptionStatusTask:
    def test_updates_local_status_from_stripe(self, db, tenant_context) -> None:
        """Task syncs subscription status from Stripe to local DB."""
        sub = SubscriptionFactory(
            tenant=tenant_context,
            status="active",
            stripe_subscription_id="sub_test_123",
        )

        with patch("stripe.Subscription.retrieve") as mock_retrieve:
            mock_retrieve.return_value = MagicMock(status="past_due")

            from src.tasks.billing import sync_subscription_status
            sync_subscription_status.delay(subscription_id=sub.id)

        sub.refresh_from_db()
        assert sub.status == "past_due"

    def test_idempotent_on_repeated_execution(self, db, tenant_context) -> None:
        """Running the task twice with the same input produces the same result."""
        sub = SubscriptionFactory(tenant=tenant_context, status="active")

        with patch("stripe.Subscription.retrieve") as mock_retrieve:
            mock_retrieve.return_value = MagicMock(status="canceled")

            from src.tasks.billing import sync_subscription_status
            sync_subscription_status.delay(subscription_id=sub.id)
            sync_subscription_status.delay(subscription_id=sub.id)

        sub.refresh_from_db()
        assert sub.status == "canceled"
\`\`\`

## Stripe Webhook Testing Pattern

Webhook handlers must verify the event signature and be idempotent. Use fixture JSON payloads.

\`\`\`python
# tests/billing/test_webhooks.py
import json
from django.test import override_settings


class TestStripeWebhookEndpoint:
    ENDPOINT = "/api/v1/billing/webhooks/stripe/"

    def test_rejects_invalid_signature(self, api_client) -> None:
        """Webhook requests with invalid Stripe signatures are rejected."""
        response = api_client.post(
            self.ENDPOINT,
            data=json.dumps({"type": "invoice.paid"}),
            content_type="application/json",
            HTTP_STRIPE_SIGNATURE="invalid_sig",
        )
        assert response.status_code == 400

    @patch("stripe.Webhook.construct_event")
    def test_invoice_paid_activates_subscription(
        self, mock_construct, db, api_client, tenant_context
    ) -> None:
        """A verified invoice.paid event activates the subscription."""
        sub = SubscriptionFactory(tenant=tenant_context, status="past_due")
        event_payload = {
            "id": "evt_test_123",
            "type": "invoice.paid",
            "data": {
                "object": {
                    "subscription": sub.stripe_subscription_id,
                },
            },
        }
        mock_construct.return_value = MagicMock(**event_payload)

        response = api_client.post(
            self.ENDPOINT,
            data=json.dumps(event_payload),
            content_type="application/json",
            HTTP_STRIPE_SIGNATURE="valid_sig",
        )

        assert response.status_code == 200
        sub.refresh_from_db()
        assert sub.status == "active"

    @patch("stripe.Webhook.construct_event")
    def test_duplicate_event_is_idempotent(
        self, mock_construct, db, api_client, tenant_context
    ) -> None:
        """Processing the same webhook event twice has no additional effect."""
        sub = SubscriptionFactory(tenant=tenant_context, status="past_due")
        event_payload = {
            "id": "evt_test_456",
            "type": "invoice.paid",
            "data": {"object": {"subscription": sub.stripe_subscription_id}},
        }
        mock_construct.return_value = MagicMock(**event_payload)
        payload = json.dumps(event_payload)
        headers = {"HTTP_STRIPE_SIGNATURE": "valid_sig"}

        api_client.post(self.ENDPOINT, data=payload, content_type="application/json", **headers)
        api_client.post(self.ENDPOINT, data=payload, content_type="application/json", **headers)

        # No duplicate processing, no errors
        sub.refresh_from_db()
        assert sub.status == "active"
\`\`\`

## DRF API Endpoint Testing Pattern

\`\`\`python
# tests/api/test_tenant_views.py
import pytest
from rest_framework import status


class TestTenantListEndpoint:
    ENDPOINT = "/api/v1/tenants/"

    def test_unauthenticated_request_returns_401(self, api_client) -> None:
        """Anonymous users cannot list tenants."""
        response = api_client.get(self.ENDPOINT)
        assert response.status_code == status.HTTP_401_UNAUTHORIZED

    def test_user_sees_only_own_tenant(
        self, authenticated_client, tenant_context, other_tenant
    ) -> None:
        """Authenticated users see only their associated tenant."""
        response = authenticated_client.get(self.ENDPOINT)
        assert response.status_code == status.HTTP_200_OK
        tenant_ids = [t["id"] for t in response.data["results"]]
        assert str(tenant_context.id) in tenant_ids
        assert str(other_tenant.id) not in tenant_ids
\`\`\`

## Factory Conventions

All factories live in \`tests/factories/\` with one file per Django app:

\`\`\`
tests/
  factories/
    __init__.py
    accounts.py      # UserFactory, RoleFactory
    tenants.py       # TenantFactory
    billing.py       # SubscriptionFactory, InvoiceFactory, UsageRecordFactory
    notifications.py # NotificationFactory
\`\`\`

\`\`\`python
# tests/factories/billing.py
import factory
from tests.factories.tenants import TenantFactory


class SubscriptionFactory(factory.django.DjangoModelFactory):
    class Meta:
        model = "billing.Subscription"

    tenant = factory.SubFactory(TenantFactory)
    stripe_subscription_id = factory.Sequence(lambda n: f"sub_test_{n:06d}")
    stripe_price_id = "price_test_monthly"
    status = "active"
\`\`\`

## Coverage Requirements

The project enforces **85% minimum coverage**. After completing a TDD cycle, verify:

\`\`\`bash
uv run pytest --cov=src --cov-report=term-missing --cov-fail-under=85
\`\`\`

**Critical paths that must have ≥95% coverage:**
- \`src/billing/\` — subscription lifecycle, Stripe sync, webhook handlers
- \`src/tenants/\` — tenant creation, middleware, row-level security managers
- \`src/accounts/\` — authentication, RBAC, token management
- \`src/core/managers.py\` — tenant-aware queryset filtering

## Sensitive Path Testing

Files in \`src/billing/\`, \`src/accounts/\`, and \`config/\` are sensitive (see \`CODEOWNERS\`). When modifying these:

1. Write more tests than usual — cover happy path, error cases, edge cases, and security scenarios
2. Add explicit tenant isolation assertions
3. Test permission boundaries (can user A access tenant B's billing data? → must be denied)
4. Verify audit log entries are created for billing and auth events

## Pre-Push Checklist

Before pushing a TDD branch, run the full quality gate:

\`\`\`bash
# Lint and format
uv run ruff check src/ tests/
uv run ruff format --check src/ tests/

# Type checking
uv run mypy src/

# Tests with coverage
uv run pytest --cov=src --cov-report=term-missing --cov-fail-under=85 -x -v

# Verify no migrations are missing
uv run python manage.py makemigrations --check --dry-run
\`\`\`

All four must pass before opening a PR. The CI pipeline (\`.github/workflows/ci.yml\`) runs these same checks.

## Common Mistakes to Avoid

1. **Writing tests after implementation** — defeats the purpose; you won't catch design issues early
2. **Testing implementation details** — test behavior and outcomes, not internal method calls
3. **Missing tenant isolation assertions** — every DB test must verify cross-tenant data doesn't leak
4. **Non-idempotent Celery tasks** — always test that running a task twice produces the same state
5. **Mocking too much** — mock external services (Stripe, email), not your own service layer
6. **Skipping the refactor step** — green tests with messy code accumulates tech debt
7. **Large test files** — split by feature/class, keep test files under 300 lines like source files
8. **Forgetting \`db\` fixture** — pytest-django requires explicit \`db\` or \`transactional_db\` marker for DB access`,

  'plugin/codeforge-django-saas/skills/verify/SKILL.md': `---
skill: verify
version: "1.0"
slug: codeforge-django-saas-verify
description: >
  Comprehensive verification of Django SaaS changes — runs linting, type checking,
  tests, security checks, tenant isolation validation, and billing safety review
  before code is committed or a PR is opened.
trigger: manual
inputs:
  - name: scope
    description: "Verification scope: 'full', 'app', 'changed', or 'billing'"
    type: string
    default: changed
  - name: app
    description: "Specific Django app to verify (e.g., tenants, billing, accounts)"
    type: string
    required: false
  - name: fix
    description: "Auto-fix linting and formatting issues"
    type: boolean
    default: false
  - name: skip_integration
    description: "Skip integration tests (faster feedback loop)"
    type: boolean
    default: false
tags:
  - verification
  - quality
  - testing
  - django
  - saas
  - pre-commit
---

# Skill: verify

You are a verification engineer for the **django-saas-platform** project. Your job is to run a comprehensive quality gate across all changed code, ensuring it meets the project's standards for correctness, security, tenant isolation, and billing safety before it reaches code review.

## Context

This is a multi-tenant SaaS platform with strict requirements:
- **SOC 2 compliance** — audit logging, access controls, data isolation
- **GDPR compliance** — data residency, consent tracking, right to deletion
- **Stripe billing** — subscription lifecycle, webhook idempotency, usage metering
- **Multi-tenancy** — row-level security in PostgreSQL, tenant-aware querysets

Verification failures caught here prevent security incidents, data leaks between tenants, and billing errors in production.

## Verification Pipeline

Execute the following stages **in order**. Stop and report on the first stage that fails unless the failure is non-blocking (warnings).

### Stage 1: Determine Scope

Based on the \`scope\` input, identify which files and apps to verify:

\`\`\`
if scope == "full":
    # Verify entire codebase
    target_paths = "src/ tests/"
    target_apps = "all"
elif scope == "app" and app is provided:
    # Verify a specific Django app
    target_paths = f"src/{app}/ tests/{app}/"
    target_apps = app
elif scope == "billing":
    # Billing-specific deep verification
    target_paths = "src/billing/ src/tasks/ tests/billing/ tests/tasks/"
    target_apps = "billing,tasks"
elif scope == "changed":
    # Only files changed vs main branch
    # Use: git diff --name-only main...HEAD --diff-filter=ACMR
    target_paths = "<changed files>"
    target_apps = "<apps with changes>"
\`\`\`

Report the scope determination:
\`\`\`
📋 Verification Scope
  Mode: {scope}
  Files: {count} files across {apps} app(s)
  Changed apps: {list of apps}
\`\`\`

### Stage 2: Formatting Check

\`\`\`bash
uv run ruff format --check {target_paths}
\`\`\`

If \`fix\` is true:
\`\`\`bash
uv run ruff format {target_paths}
\`\`\`

**Pass criteria**: Zero formatting differences.

### Stage 3: Linting

\`\`\`bash
uv run ruff check {target_paths}
\`\`\`

If \`fix\` is true:
\`\`\`bash
uv run ruff check --fix {target_paths}
\`\`\`

**Pass criteria**: Zero errors. Warnings are reported but non-blocking.

Pay special attention to:
- Unused imports (especially in \`__init__.py\` — some are intentional re-exports)
- Security-related rules (S-prefixed rules from bandit integration)
- Django-specific rules (DJ-prefixed)

### Stage 4: Type Checking

\`\`\`bash
uv run mypy src/ --config-file pyproject.toml
\`\`\`

If scoped to a specific app:
\`\`\`bash
uv run mypy src/{app}/ --config-file pyproject.toml
\`\`\`

**Pass criteria**: Zero type errors. \`mypy\` runs in strict mode per project config.

Common issues to watch for:
- Missing return type annotations on public functions
- \`Any\` types leaking through Stripe SDK responses — wrap in typed dataclasses
- Django model fields need \`django-stubs\` annotations
- Celery task signatures must have typed parameters

### Stage 5: Django System Checks

\`\`\`bash
uv run python manage.py check --deploy --settings=config.settings.staging
\`\`\`

**Pass criteria**: Zero errors. Warnings are reported.

This catches:
- Missing \`SECURE_*\` settings
- Database configuration issues
- Improperly configured middleware ordering
- Missing \`AUTH_USER_MODEL\` references

### Stage 6: Migration Safety

\`\`\`bash
# Check for missing migrations
uv run python manage.py makemigrations --check --dry-run

# Validate migration files if any were changed
uv run python manage.py migrate --plan
\`\`\`

**Pass criteria**: No missing migrations. Migration plan executes without conflicts.

Additional checks for changed migrations:
- [ ] No \`RunPython\` without a reverse function
- [ ] No destructive operations on tenant-scoped tables without a data migration plan
- [ ] \`AddField\` with \`null=True\` before \`AlterField\` to \`null=False\` (safe deployment pattern)
- [ ] Row-level security policies updated if new tenant-scoped models are added

### Stage 7: Unit Tests

\`\`\`bash
# Changed scope — run tests for affected apps
uv run pytest tests/{app}/ -x -q --tb=short --cov=src/{app} --cov-fail-under=85

# Full scope
uv run pytest tests/ -x -q --tb=short --cov=src/ --cov-fail-under=85
\`\`\`

If \`skip_integration\` is false, include integration tests:
\`\`\`bash
uv run pytest tests/ -x -q --tb=short --cov=src/ --cov-fail-under=85 -m "not e2e"
\`\`\`

**Pass criteria**: All tests pass. Coverage ≥ 85% for affected code.

Report:
\`\`\`
🧪 Test Results
  Passed: {n}
  Failed: {n}
  Skipped: {n}
  Coverage: {pct}% (threshold: 85%)
  Duration: {seconds}s
\`\`\`

### Stage 8: Tenant Isolation Audit

This is a **critical security stage** for SOC 2 and multi-tenant safety.

Scan all changed files for tenant isolation violations:

1. **Direct QuerySet access without tenant filtering**:
   - Flag any \`Model.objects.all()\`, \`Model.objects.filter()\`, or \`Model.objects.get()\` on tenant-scoped models that does NOT go through \`TenantAwareManager\`
   - Acceptable: \`Model.tenant_objects.for_tenant(tenant)\` or \`Model.objects.filter(tenant=tenant)\`
   - Exception: Management commands and Celery tasks that explicitly iterate all tenants

2. **Missing tenant context in views**:
   - All DRF viewsets for tenant-scoped resources must use \`TenantMixin\` or set \`get_queryset()\` to filter by \`request.tenant\`
   - GraphQL resolvers must pass tenant from context

3. **Cross-tenant data exposure in serializers**:
   - Related fields (ForeignKey, ManyToMany) must be filtered to the current tenant
   - \`PrimaryKeyRelatedField\` and \`SlugRelatedField\` must use \`queryset\` filtered by tenant
   - Nested serializers must not leak data from other tenants

4. **Raw SQL without tenant WHERE clause**:
   - Flag any \`connection.cursor()\`, \`raw()\`, or \`extra()\` calls that reference tenant-scoped tables without a \`tenant_id\` filter

Report findings as:
\`\`\`
🔒 Tenant Isolation Audit
  ✅ No violations found
  — or —
  🚨 CRITICAL: {count} tenant isolation violation(s)
    - {file}:{line} — {description}
\`\`\`

**Pass criteria**: Zero critical violations. This stage MUST NOT be skipped.

### Stage 9: Billing Safety Review

Run this stage if any files in \`src/billing/\`, \`src/tasks/\`, or Stripe-related code changed.

1. **Webhook idempotency**:
   - All Stripe webhook handlers must check for duplicate \`event.id\` processing
   - Must use \`StripeEvent.objects.get_or_create(stripe_event_id=event.id)\` pattern
   - Must handle \`stripe.error.SignatureVerificationError\`

2. **Subscription state machine**:
   - Verify subscription status transitions are valid (e.g., \`active\` → \`past_due\` → \`canceled\`, not \`canceled\` → \`active\` directly)
   - Check that \`Subscription.objects.transition()\` is used instead of direct status field updates

3. **Usage metering**:
   - \`report_usage()\` calls must be idempotent (use \`idempotency_key\`)
   - Usage records must be associated with the correct \`subscription_item\`
   - Timestamp must be within the current billing period

4. **Money handling**:
   - All monetary values must use \`Decimal\`, never \`float\`
   - Currency must be explicitly passed, never assumed
   - Stripe amounts are in cents — verify conversion at API boundaries

5. **Celery task idempotency**:
   - All billing-related Celery tasks must accept and use an \`idempotency_key\`
   - Tasks must be safe to retry (\`acks_late=True\`, \`reject_on_worker_lost=True\`)
   - No side effects on duplicate execution

Report:
\`\`\`
💳 Billing Safety Review
  Webhook handlers: {count} checked, {issues} issues
  Subscription logic: {status}
  Usage metering: {status}
  Money handling: {status}
  Task idempotency: {status}
\`\`\`

**Pass criteria**: Zero critical billing safety issues.

### Stage 10: Security Scan

\`\`\`bash
# Check for known vulnerabilities in dependencies
uv run pip-audit

# Check for hardcoded secrets
uv run detect-secrets scan {target_paths}

# Django security middleware check
uv run python manage.py check --deploy --tag security
\`\`\`

Additional manual checks on changed files:
- [ ] No hardcoded API keys, tokens, or passwords
- [ ] No \`DEBUG = True\` in non-development settings
- [ ] No \`ALLOWED_HOSTS = ['*']\` in staging/production
- [ ] Sensitive fields use \`write_only=True\` in serializers
- [ ] Authentication/authorization decorators on all new endpoints
- [ ] GDPR: PII fields are marked and included in data export/deletion flows
- [ ] Audit log entries for state-changing operations on sensitive resources

**Pass criteria**: Zero critical security findings.

### Stage 11: Documentation Check

For changed files, verify:
- [ ] New public functions have docstrings
- [ ] New API endpoints have \`@extend_schema()\` decorators for drf-spectacular
- [ ] New Celery tasks have docstrings describing idempotency behavior
- [ ] New Django models have \`class Meta\` with \`verbose_name\` and \`ordering\`
- [ ] Changed GraphQL types have field descriptions
- [ ] New environment variables are documented in \`docs/ONBOARDING.md\` or \`.env.example\`

**Pass criteria**: Non-blocking but reported as warnings.

### Stage 12: File Quality

Check all changed files against project conventions:
- [ ] No file exceeds 300 lines (flag files > 300, block files > 400)
- [ ] Files use snake_case naming
- [ ] Classes use PascalCase
- [ ] Constants use SCREAMING_SNAKE_CASE
- [ ] URL patterns use kebab-case
- [ ] No Django signals for business logic — should use service layer
- [ ] Factory definitions exist in \`tests/factories/\` for new models

**Pass criteria**: Zero blocking violations.

## Final Report

After all stages complete, produce a summary:

\`\`\`
═══════════════════════════════════════════════════
  🔍 VERIFICATION REPORT — django-saas-platform
═══════════════════════════════════════════════════

  Scope:              {scope} ({file_count} files, {app_list})
  Branch:             {branch_name}
  Commit:             {short_sha}

  ┌─────────────────────────────────────┬────────┐
  │ Stage                               │ Result │
  ├─────────────────────────────────────┼────────┤
  │ 1. Formatting                       │ ✅/❌  │
  │ 2. Linting                          │ ✅/❌  │
  │ 3. Type Checking                    │ ✅/❌  │
  │ 4. Django System Checks             │ ✅/⚠️  │
  │ 5. Migration Safety                 │ ✅/❌  │
  │ 6. Unit Tests ({pct}% coverage)     │ ✅/❌  │
  │ 7. Tenant Isolation Audit           │ ✅/🚨  │
  │ 8. Billing Safety Review            │ ✅/🚨  │
  │ 9. Security Scan                    │ ✅/🚨  │
  │ 10. Documentation                   │ ✅/⚠️  │
  │ 11. File Quality                    │ ✅/⚠️  │
  └─────────────────────────────────────┴────────┘

  Overall: ✅ PASSED / ❌ FAILED / ⚠️ PASSED WITH WARNINGS

  {If failed, list the blocking issues with file:line references}
  {If warnings, list them grouped by category}

═══════════════════════════════════════════════════
\`\`\`

## Failure Handling

- **Stages 1-3 (formatting, linting, types)**: If \`fix\` is true, auto-fix and re-run. If still failing, report and block.
- **Stage 6 (tests)**: Report failing test names and first failure traceback. Suggest likely cause if pattern is recognizable (e.g., missing factory, stale migration, missing mock for Stripe API).
- **Stages 7-9 (security-critical)**: NEVER auto-fix. Report with full context and require human review. Tag the finding with the relevant compliance framework (SOC 2 / GDPR).
- **Stages 10-11 (documentation, quality)**: Report as warnings. Do not block the pipeline unless file length exceeds 400 lines.

## Integration with Other Skills

- Run \`verify\` after completing \`tdd\` skill to validate the full implementation
- Run \`verify\` with \`scope=billing\` before any PR that touches Stripe integration
- The \`plan\` skill should recommend running \`verify\` as the final step in its implementation plan
- CI pipeline (\`.github/workflows/ci.yml\`) runs the equivalent of \`verify --scope=full --skip_integration=false\`

## Sensitive Path Escalation

If changes touch any of these paths, add an explicit warning to the report header:
- \`src/billing/**\` — Requires billing team review
- \`src/accounts/auth*\` — Requires security team review
- \`config/settings/production.py\` — Requires DevOps review
- \`.env*\` — MUST NOT be committed; fail immediately if detected
- \`src/tenants/middleware.py\` — Requires architecture review
- \`src/core/permissions.py\` — Requires security team review

These paths are enforced via \`CODEOWNERS\` and require designated reviewer approval.`,

  'plugin/marketplace.json.example': `{
  "slug": "codeforge-django-saas",
  "name": "CodeForge Django SaaS Platform",
  "version": "1.0.0",
  "description": "Claude Code plugin for building multi-tenant SaaS platforms with Django 5.0, Stripe billing, Celery task processing, and REST/GraphQL APIs. Includes agents, skills, and commands for TDD, planning, code review, and build error resolution — all tailored to SaaS patterns like tenant isolation, subscription lifecycle, and idempotent webhook handling.",
  "author": {
    "name": "CodeForge",
    "email": "plugins@codeforge.dev",
    "url": "https://codeforge.dev"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/codeforge/codeforge-django-saas.git"
  },
  "license": "MIT",
  "keywords": [
    "django",
    "saas",
    "multi-tenant",
    "stripe",
    "celery",
    "rest-api",
    "graphql",
    "strawberry",
    "drf",
    "postgresql",
    "redis",
    "subscription-billing",
    "row-level-security",
    "claude-code",
    "ai-assisted-development"
  ],
  "categories": [
    "backend",
    "saas",
    "django",
    "api-development",
    "billing",
    "devops"
  ],
  "compatibility": {
    "claude_code": ">=1.0.0",
    "python": ">=3.12",
    "django": ">=5.0"
  },
  "pricing": {
    "model": "free",
    "trial_days": null
  },
  "icon": "https://cdn.codeforge.dev/plugins/codeforge-django-saas/icon.png",
  "banner": "https://cdn.codeforge.dev/plugins/codeforge-django-saas/banner.png",
  "screenshots": [
    {
      "url": "https://cdn.codeforge.dev/plugins/codeforge-django-saas/screenshots/tdd-workflow.png",
      "caption": "TDD workflow generating tenant-aware tests with factory_boy fixtures"
    },
    {
      "url": "https://cdn.codeforge.dev/plugins/codeforge-django-saas/screenshots/plan-command.png",
      "caption": "Plan command breaking down a Stripe subscription feature into implementation tasks"
    },
    {
      "url": "https://cdn.codeforge.dev/plugins/codeforge-django-saas/screenshots/code-review.png",
      "caption": "Code review agent checking tenant isolation and SOC 2 compliance"
    },
    {
      "url": "https://cdn.codeforge.dev/plugins/codeforge-django-saas/screenshots/build-fix.png",
      "caption": "Build error resolver fixing mypy strict mode violations and ruff lint errors"
    }
  ],
  "tech_stack": {
    "language": "Python 3.12+",
    "framework": "Django 5.0",
    "api": ["Django REST Framework", "Strawberry GraphQL"],
    "task_queue": "Celery 5 (Redis broker)",
    "databases": ["PostgreSQL 16", "Redis"],
    "billing": "Stripe",
    "cloud": "AWS (ECS, RDS, ElastiCache, S3, SES)",
    "infrastructure": ["Docker", "Kubernetes", "Terraform"],
    "package_manager": "uv",
    "linting": "ruff",
    "type_checking": "mypy (strict)",
    "testing": "pytest (pytest-django, factory_boy, pytest-asyncio)"
  },
  "compliance": ["SOC 2", "GDPR"],
  "features": [
    {
      "title": "Multi-Tenant Aware Development",
      "description": "All agents and skills enforce tenant isolation patterns — row-level security, tenant-aware QuerySet managers, and middleware-based tenant context propagation."
    },
    {
      "title": "Stripe Billing Integration",
      "description": "Guided implementation of subscription lifecycle, usage-based metering, webhook verification, and idempotent event processing with Stripe."
    },
    {
      "title": "TDD with Django & Celery",
      "description": "Test-driven development skill generates pytest tests using factory_boy fixtures, tenant-scoped test isolation, and Celery task testing with eager mode."
    },
    {
      "title": "Automated Code Review",
      "description": "Code review agent checks for tenant data leakage, missing type hints, SOC 2 audit logging gaps, GDPR compliance issues, and Celery task idempotency."
    },
    {
      "title": "Build Error Resolution",
      "description": "Resolves mypy strict mode errors, ruff lint violations, Django migration conflicts, and pytest failures with context-aware fixes."
    },
    {
      "title": "Phase-Based Development Methodology",
      "description": "Structured playbook phases from discovery through deployment, with gates ensuring quality at each stage."
    }
  ],
  "agents": [
    {
      "id": "planner",
      "name": "Planner",
      "description": "Breaks down features into implementation tasks following the modular Django app architecture"
    },
    {
      "id": "tdd-guide",
      "name": "TDD Guide",
      "description": "Drives red-green-refactor cycles with pytest, factory_boy, and tenant-aware test patterns"
    },
    {
      "id": "code-reviewer",
      "name": "Code Reviewer",
      "description": "Reviews PRs for tenant isolation, security, type safety, and SaaS best practices"
    },
    {
      "id": "architect",
      "name": "Architect",
      "description": "Designs Django app boundaries, data models, API contracts, and Celery task flows"
    },
    {
      "id": "build-error-resolver",
      "name": "Build Error Resolver",
      "description": "Diagnoses and fixes CI failures across ruff, mypy, pytest, and Django management commands"
    }
  ],
  "commands": [
    {
      "name": "/plan",
      "description": "Generate an implementation plan from a GitHub Issue or feature description"
    },
    {
      "name": "/tdd",
      "description": "Start a TDD cycle — write failing test, implement, refactor"
    },
    {
      "name": "/build-fix",
      "description": "Analyze and fix build/CI failures"
    },
    {
      "name": "/verify",
      "description": "Run full verification suite: ruff, mypy, pytest, coverage check"
    },
    {
      "name": "/code-review",
      "description": "Perform a comprehensive code review on staged changes or a PR"
    }
  ],
  "skills": [
    {
      "id": "plan",
      "name": "Plan",
      "description": "Feature decomposition and task planning for Django SaaS features"
    },
    {
      "id": "tdd",
      "name": "TDD",
      "description": "Test-driven development with pytest-django and factory_boy"
    },
    {
      "id": "verify",
      "name": "Verify",
      "description": "Lint, type check, test, and coverage verification pipeline"
    },
    {
      "id": "build-fix",
      "name": "Build Fix",
      "description": "CI failure diagnosis and automated resolution"
    },
    {
      "id": "code-review",
      "name": "Code Review",
      "description": "Security, tenant isolation, and code quality review"
    },
    {
      "id": "phase",
      "name": "Phase",
      "description": "Development methodology phase management and gate checks"
    }
  ],
  "hooks": {
    "pre_commit": "Validates conventional commit format and runs ruff format",
    "post_build": "Verifies ruff, mypy, and pytest pass before allowing merge"
  },
  "documentation": {
    "getting_started": "https://github.com/codeforge/codeforge-django-saas/blob/main/README.md",
    "architecture": "https://github.com/codeforge/codeforge-django-saas/blob/main/docs/ARCHITECTURE.md",
    "contributing": "https://github.com/codeforge/codeforge-django-saas/blob/main/docs/CONTRIBUTING.md",
    "ai_usage_policy": "https://github.com/codeforge/codeforge-django-saas/blob/main/docs/AI-USAGE-POLICY.md",
    "onboarding": "https://github.com/codeforge/codeforge-django-saas/blob/main/docs/ONBOARDING.md"
  },
  "support": {
    "issues": "https://github.com/codeforge/codeforge-django-saas/issues",
    "discussions": "https://github.com/codeforge/codeforge-django-saas/discussions",
    "slack": "https://codeforge-community.slack.com/channels/django-saas-plugin"
  },
  "metrics": {
    "installs": 0,
    "stars": 0,
    "last_updated": "2025-01-15T00:00:00Z"
  }
}`,

  'pyproject.toml': `[project]
name = "django-saas-platform"
version = "0.1.0"
description = "Multi-tenant SaaS platform with subscription billing, async task processing, and REST/GraphQL API"
readme = "README.md"
license = { text = "Proprietary" }
requires-python = ">=3.12"
authors = [
    { name = "SaaS Platform Team" },
]
keywords = ["django", "saas", "multi-tenant", "stripe", "celery"]
classifiers = [
    "Development Status :: 3 - Alpha",
    "Framework :: Django",
    "Framework :: Django :: 5.0",
    "Framework :: Celery",
    "Intended Audience :: Developers",
    "License :: Other/Proprietary License",
    "Programming Language :: Python :: 3.12",
    "Topic :: Internet :: WWW/HTTP :: Dynamic Content",
    "Topic :: Software Development :: Libraries :: Application Frameworks",
]

dependencies = [
    # Django core
    "django>=5.0,<5.1",
    "django-environ>=0.11.2",
    "django-extensions>=3.2.3",
    "django-cors-headers>=4.3.1",
    "django-filter>=24.1",
    "django-health-check>=3.18.1",
    "django-storages[s3]>=1.14.2",
    "django-redis>=5.4.0",
    "django-csp>=3.8",
    "django-permissions-policy>=4.19",

    # Django REST Framework
    "djangorestframework>=3.15.1",
    "drf-spectacular>=0.27.1",
    "djangorestframework-simplejwt>=5.3.1",

    # GraphQL
    "strawberry-graphql[django]>=0.224.0",

    # Database
    "psycopg[binary,pool]>=3.1.18",

    # Celery & async
    "celery[redis]>=5.3.6",
    "django-celery-beat>=2.6.0",
    "django-celery-results>=2.5.1",

    # Billing
    "stripe>=8.4.0",

    # Caching & sessions
    "redis>=5.0.3",
    "hiredis>=2.3.2",

    # Configuration & validation
    "pydantic>=2.6.4",
    "pydantic-settings>=2.2.1",

    # Security
    "cryptography>=42.0.5",
    "django-otp>=1.3.0",
    "python-jose[cryptography]>=3.3.0",

    # HTTP & networking
    "httpx>=0.27.0",
    "urllib3>=2.2.1",

    # Monitoring & logging
    "sentry-sdk[django,celery]>=1.43.0",
    "structlog>=24.1.0",
    "django-prometheus>=2.3.1",

    # Utilities
    "whitenoise>=6.6.0",
    "gunicorn>=21.2.0",
    "uvicorn[standard]>=0.29.0",
    "boto3>=1.34.69",
    "Pillow>=10.3.0",
]

[project.optional-dependencies]
dev = [
    # Testing
    "pytest>=8.1.1",
    "pytest-django>=4.8.0",
    "pytest-cov>=5.0.0",
    "pytest-asyncio>=0.23.6",
    "pytest-xdist>=3.5.0",
    "pytest-mock>=3.14.0",
    "pytest-timeout>=2.3.1",
    "pytest-randomly>=3.15.0",
    "factory-boy>=3.3.0",
    "faker>=24.4.0",
    "freezegun>=1.4.0",
    "responses>=0.25.0",
    "time-machine>=2.14.1",

    # Type checking
    "mypy>=1.9.0",
    "django-stubs>=4.2.7",
    "djangorestframework-stubs>=3.14.5",
    "celery-types>=0.22.0",
    "types-redis>=4.6.0.20240311",
    "types-stripe>=3.5.2.20240311",
    "types-requests>=2.31.0.20240311",
    "boto3-stubs>=1.34.69",

    # Code quality
    "ruff>=0.3.4",
    "pre-commit>=3.7.0",
    "bandit[toml]>=1.7.8",
    "safety>=3.1.0",
    "pip-audit>=2.7.2",

    # Debugging
    "django-debug-toolbar>=4.3.0",
    "ipython>=8.23.0",
    "ipdb>=0.13.13",
    "rich>=13.7.1",

    # Documentation
    "mkdocs>=1.5.3",
    "mkdocs-material>=9.5.15",
    "mkdocstrings[python]>=0.24.1",
]

[project.urls]
Homepage = "https://github.com/your-org/django-saas-platform"
Repository = "https://github.com/your-org/django-saas-platform"
Documentation = "https://github.com/your-org/django-saas-platform/tree/main/docs"
Issues = "https://github.com/your-org/django-saas-platform/issues"

[project.scripts]
saas-worker = "celery.__main__:main"

[build-system]
requires = ["hatchling"]
build-backend = "hatchling.build"

[tool.hatch.build.targets.wheel]
packages = ["src"]

# ---------------------------------------------------------------------------
# pytest
# ---------------------------------------------------------------------------
[tool.pytest.ini_options]
DJANGO_SETTINGS_MODULE = "config.settings.test"
python_files = ["test_*.py", "*_test.py"]
python_classes = ["Test*"]
python_functions = ["test_*"]
testpaths = ["tests"]
addopts = [
    "--strict-markers",
    "--strict-config",
    "--tb=short",
    "--cov=src",
    "--cov-branch",
    "--cov-report=term-missing:skip-covered",
    "--cov-report=html:htmlcov",
    "--cov-report=xml:coverage.xml",
    "--cov-fail-under=85",
    "--no-header",
    "-ra",
    "--timeout=30",
]
markers = [
    "slow: marks tests as slow (deselect with '-m \\"not slow\\"')",
    "integration: marks integration tests requiring external services",
    "e2e: marks end-to-end tests",
    "stripe: marks tests that interact with Stripe (mock or live)",
    "celery: marks tests that require Celery worker",
    "tenant: marks tests for multi-tenant isolation",
]
filterwarnings = [
    "error",
    "ignore::DeprecationWarning:kombu.*",
    "ignore::DeprecationWarning:celery.*",
    "ignore::django.utils.deprecation.RemovedInDjango60Warning",
]
asyncio_mode = "auto"

# ---------------------------------------------------------------------------
# coverage
# ---------------------------------------------------------------------------
[tool.coverage.run]
source = ["src"]
branch = true
omit = [
    "*/migrations/*",
    "*/management/commands/*",
    "*/tests/*",
    "*/conftest.py",
    "src/*/apps.py",
    "config/*",
]

[tool.coverage.report]
precision = 2
show_missing = true
skip_covered = true
exclude_lines = [
    "pragma: no cover",
    "def __repr__",
    "def __str__",
    "if TYPE_CHECKING:",
    "if settings.DEBUG:",
    "@overload",
    "raise NotImplementedError",
    "pass",
    "\\\\.\\\\.\\\\.",
]

[tool.coverage.html]
directory = "htmlcov"

# ---------------------------------------------------------------------------
# mypy
# ---------------------------------------------------------------------------
[tool.mypy]
python_version = "3.12"
mypy_path = "src"
namespace_packages = true
explicit_package_bases = true
plugins = [
    "mypy_django_plugin.main",
    "mypy_drf_plugin.main",
]

# Strict mode flags
strict = true
warn_return_any = true
warn_unused_configs = true
warn_unused_ignores = true
warn_redundant_casts = true
warn_unreachable = true
disallow_untyped_defs = true
disallow_incomplete_defs = true
disallow_untyped_decorators = true
check_untyped_defs = true
no_implicit_optional = true
no_implicit_reexport = true

# Per-module overrides for third-party libraries without stubs
[[tool.mypy.overrides]]
module = [
    "strawberry.*",
    "django_filters.*",
    "django_otp.*",
    "health_check.*",
    "storages.*",
    "django_prometheus.*",
    "whitenoise.*",
    "gunicorn.*",
    "factory.*",
    "freezegun.*",
    "time_machine.*",
]
ignore_missing_imports = true

[[tool.mypy.overrides]]
module = "src.*.migrations.*"
ignore_errors = true

[tool.django-stubs]
django_settings_module = "config.settings.development"

# ---------------------------------------------------------------------------
# ruff — main config in ruff.toml, overrides here if needed
# ---------------------------------------------------------------------------
# Primary ruff configuration lives in ruff.toml at project root.
# See ruff.toml for rule selection, per-file ignores, and formatting options.

# ---------------------------------------------------------------------------
# bandit (security linter)
# ---------------------------------------------------------------------------
[tool.bandit]
targets = ["src"]
exclude_dirs = ["tests", "scripts"]
skips = ["B101"]  # Allow assert in non-test code for type narrowing

# ---------------------------------------------------------------------------
# django-celery-beat
# ---------------------------------------------------------------------------
[tool.celery]
broker_url = "redis://localhost:6379/0"
result_backend = "django-db"
accept_content = ["json"]
task_serializer = "json"
result_serializer = "json"
timezone = "UTC"
enable_utc = true
task_always_eager = false
task_acks_late = true
task_reject_on_worker_lost = true
worker_prefetch_multiplier = 1
task_default_queue = "default"
task_routes = {
    "src.billing.tasks.*" = { queue = "billing" },
    "src.notifications.tasks.*" = { queue = "notifications" },
    "src.tasks.reports.*" = { queue = "reports" },
}
beat_scheduler = "django_celery_beat.schedulers:DatabaseScheduler"`,

  'ruff.toml': `target-version = "py312"

line-length = 120

src = ["src", "tests"]

fix = true

[format]
quote-style = "double"
indent-style = "space"
skip-magic-trailing-comma = false
line-ending = "auto"
docstring-code-format = true
docstring-code-line-length = 88

[lint]
select = [
    "F",      # pyflakes
    "E",      # pycodestyle errors
    "W",      # pycodestyle warnings
    "I",      # isort
    "N",      # pep8-naming
    "UP",     # pyupgrade
    "ANN",    # flake8-annotations
    "ASYNC",  # flake8-async
    "S",      # flake8-bandit (security)
    "BLE",    # flake8-blind-except
    "FBT",    # flake8-boolean-trap
    "B",      # flake8-bugbear
    "A",      # flake8-builtins
    "COM",    # flake8-commas
    "C4",     # flake8-comprehensions
    "DTZ",    # flake8-datetimez
    "T10",    # flake8-debugger
    "DJ",     # flake8-django
    "EM",     # flake8-errmsg
    "EXE",    # flake8-executable
    "ISC",    # flake8-implicit-str-concat
    "ICN",    # flake8-import-conventions
    "LOG",    # flake8-logging
    "G",      # flake8-logging-format
    "INP",    # flake8-no-pep420
    "PIE",    # flake8-pie
    "T20",    # flake8-print
    "PYI",    # flake8-pyi
    "PT",     # flake8-pytest-style
    "Q",      # flake8-quotes
    "RSE",    # flake8-raise
    "RET",    # flake8-return
    "SLF",    # flake8-self
    "SLOT",   # flake8-slots
    "SIM",    # flake8-simplify
    "TID",    # flake8-tidy-imports
    "TCH",    # flake8-type-checking
    "INT",    # flake8-gettext
    "ARG",    # flake8-unused-arguments
    "PTH",    # flake8-use-pathlib
    "TD",     # flake8-todos
    "FIX",    # flake8-fixme
    "ERA",    # eradicate (commented-out code)
    "PD",     # pandas-vet (unlikely but catches bad patterns)
    "PGH",    # pygrep-hooks
    "PL",     # pylint
    "TRY",    # tryceratops
    "FLY",    # flynt
    "PERF",   # perflint
    "FURB",   # refurb
    "RUF",    # ruff-specific rules
]

ignore = [
    "ANN101",   # missing type annotation for self (deprecated)
    "ANN102",   # missing type annotation for cls (deprecated)
    "ANN401",   # dynamically typed expressions (Any) — sometimes needed for Django
    "COM812",   # missing trailing comma — conflicts with formatter
    "ISC001",   # single-line implicit string concat — conflicts with formatter
    "TD003",    # missing issue link in TODO — too strict for dev workflow
    "FIX002",   # line contains TODO — we track these separately
    "TRY003",   # avoid specifying long messages outside exception class
    "EM101",    # exception must not use string literal — too strict
    "EM102",    # exception must not use f-string literal — too strict
    "PLR0913",  # too many arguments — Django views/serializers often need them
    "RUF012",   # mutable class attributes — Django model fields are mutable by design
]

[lint.per-file-ignores]
"src/*/migrations/*.py" = [
    "ANN",    # no type annotations needed in migrations
    "E501",   # line length irrelevant in auto-generated migrations
    "N",      # naming conventions don't apply
    "ERA",    # commented-out code is normal in migrations
    "RUF012", # mutable class attributes in migrations
    "DJ",     # Django-specific rules handled by migration framework
]
"tests/**/*.py" = [
    "S101",   # assert is fine in tests
    "ANN",    # type annotations optional in tests
    "ARG",    # unused arguments common in fixtures
    "FBT",    # boolean positional args fine in test helpers
    "PLR2004",# magic values fine in test assertions
    "S106",   # hardcoded passwords fine in test fixtures
    "SLF001", # private member access fine in tests
    "PT004",  # fixture does not return anything — not always relevant
]
"conftest.py" = [
    "ANN",    # type annotations optional in conftest
    "ARG",    # unused arguments common in fixtures
]
"src/*/admin.py" = [
    "ARG002", # unused method argument — Django admin methods have fixed signatures
]
"src/*/management/commands/*.py" = [
    "ANN",    # management commands have fixed signatures
    "T20",    # print statements are expected in management commands
]
"scripts/**/*.py" = [
    "T20",    # print statements expected in scripts
    "INP001", # implicit namespace package fine for scripts
    "ANN",    # scripts don't need full annotations
    "S",      # security rules relaxed for local scripts
]
"config/**/*.py" = [
    "F405",   # star imports used in settings split pattern
    "ERA001", # commented-out settings are documentation
]
"src/*/signals.py" = [
    "ARG001", # unused arguments common in signal handlers (sender, **kwargs)
]
"src/billing/**/*.py" = [
    "PLR0911", # billing logic may have multiple return paths for Stripe states
]

[lint.isort]
known-first-party = [
    "accounts",
    "tenants",
    "billing",
    "api",
    "core",
    "notifications",
    "tasks",
    "utils",
]
known-third-party = [
    "django",
    "rest_framework",
    "strawberry",
    "celery",
    "stripe",
    "redis",
    "pydantic",
    "factory",
    "pytest",
]
section-order = [
    "future",
    "standard-library",
    "third-party",
    "first-party",
    "local-folder",
]
force-single-line = false
lines-after-imports = 2
combine-as-imports = true

[lint.flake8-annotations]
allow-star-arg-any = true
mypy-init-return = true
suppress-none-returning = true

[lint.flake8-bugbear]
extend-immutable-calls = [
    "django.conf.settings",
    "django.utils.timezone.now",
    "rest_framework.serializers.CharField",
    "rest_framework.serializers.IntegerField",
    "rest_framework.serializers.BooleanField",
    "rest_framework.serializers.DateTimeField",
]

[lint.flake8-pytest-style]
fixture-parentheses = true
parametrize-names-type = "csv"
parametrize-values-type = "list"
parametrize-values-row-type = "tuple"

[lint.flake8-tidy-imports]
ban-relative-imports = "parents"

[lint.flake8-type-checking]
strict = true
runtime-evaluated-base-classes = [
    "django.db.models.Model",
    "django.forms.Form",
    "django.forms.ModelForm",
    "rest_framework.serializers.Serializer",
    "rest_framework.serializers.ModelSerializer",
    "pydantic.BaseModel",
]
runtime-evaluated-decorators = [
    "strawberry.type",
    "strawberry.input",
    "strawberry.interface",
    "strawberry.mutation",
    "strawberry.django.type",
]

[lint.pylint]
max-args = 8
max-branches = 12
max-returns = 6
max-statements = 50

[lint.flake8-bandit]
check-typed-exception = true

[lint.pydocstyle]
convention = "google"`,

};
